import { jsx as h, jsxs as C, Fragment as Ve } from "react/jsx-runtime";
import * as v from "react";
import E, { forwardRef as bs, createElement as _i, useLayoutEffect as d$, useState as pr, isValidElement as Et, Children as ta, PureComponent as St, useRef as Ic, useImperativeHandle as p$, useCallback as h$, useEffect as ko, useMemo as h_, cloneElement as Je, useContext as nn, createContext as pa, Component as m_ } from "react";
import * as xs from "react-dom";
import v_ from "react-dom";
function G0(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function He(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((a) => {
      const o = G0(a, t);
      return !r && typeof o == "function" && (r = !0), o;
    });
    if (r)
      return () => {
        for (let a = 0; a < n.length; a++) {
          const o = n[a];
          typeof o == "function" ? o() : G0(e[a], null);
        }
      };
  };
}
function me(...e) {
  return v.useCallback(He(...e), e);
}
var m$ = Symbol.for("react.lazy"), Dc = v[" use ".trim().toString()];
function v$(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function y_(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === m$ && "_payload" in e && v$(e._payload);
}
// @__NO_SIDE_EFFECTS__
function g_(e) {
  const t = /* @__PURE__ */ g$(e), r = v.forwardRef((n, a) => {
    let { children: o, ...i } = n;
    y_(o) && typeof Dc == "function" && (o = Dc(o._payload));
    const s = v.Children.toArray(o), c = s.find(x$);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
var y$ = /* @__PURE__ */ g_("Slot");
// @__NO_SIDE_EFFECTS__
function g$(e) {
  const t = v.forwardRef((r, n) => {
    let { children: a, ...o } = r;
    if (y_(a) && typeof Dc == "function" && (a = Dc(a._payload)), v.isValidElement(a)) {
      const i = S$(a), s = w$(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var b$ = Symbol("radix.slottable");
function x$(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === b$;
}
function w$(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function S$(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function b_(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (r = b_(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function ue() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++) (e = arguments[r]) && (t = b_(e)) && (n && (n += " "), n += t);
  return n;
}
const Y0 = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, X0 = ue, Ye = (e, t) => (r) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return X0(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: a, defaultVariants: o } = t, i = Object.keys(a).map((l) => {
    const u = r == null ? void 0 : r[l], f = o == null ? void 0 : o[l];
    if (u === null) return null;
    const d = Y0(u) || Y0(f);
    return a[l][d];
  }), s = r && Object.entries(r).reduce((l, u) => {
    let [f, d] = u;
    return d === void 0 || (l[f] = d), l;
  }, {}), c = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((l, u) => {
    let { class: f, className: d, ...p } = u;
    return Object.entries(p).every((g) => {
      let [m, y] = g;
      return Array.isArray(y) ? y.includes({
        ...o,
        ...s
      }[m]) : {
        ...o,
        ...s
      }[m] === y;
    }) ? [
      ...l,
      f,
      d
    ] : l;
  }, []);
  return X0(e, i, c, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O$ = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), x_ = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim();
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var P$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A$ = bs(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: a = "",
    children: o,
    iconNode: i,
    ...s
  }, c) => _i(
    "svg",
    {
      ref: c,
      ...P$,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: x_("lucide", a),
      ...s
    },
    [
      ...i.map(([l, u]) => _i(l, u)),
      ...Array.isArray(o) ? o : [o]
    ]
  )
);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ie = (e, t) => {
  const r = bs(
    ({ className: n, ...a }, o) => _i(A$, {
      ref: o,
      iconNode: t,
      className: x_(`lucide-${O$(e)}`, n),
      ...a
    })
  );
  return r.displayName = `${e}`, r;
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _$ = ie("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E$ = ie("ArrowRight", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w_ = ie("ArrowUpDown", [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C$ = ie("ArrowUp", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lu = ie("Bell", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k$ = ie("Calendar", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N$ = ie("ChartColumn", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ha = ie("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yr = ie("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zy = ie("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uu = ie("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S_ = ie("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ws = ie("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T$ = ie("CircleCheckBig", [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M$ = ie("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R$ = ie("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z0 = ie("Clock", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $$ = ie("Copy", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I$ = ie("Download", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const D$ = ie("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const j$ = ie("ExternalLink", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L$ = ie("EyeOff", [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jy = ie("Eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const B$ = ie("FileX", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F$ = ie("Filter", [
  ["polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z$ = ie("Hash", [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const O_ = ie("Heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q$ = ie("Inbox", [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const av = ie("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W$ = ie("LayoutDashboard", [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H$ = ie("Lightbulb", [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qy = ie("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V$ = ie("Mail", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U$ = ie("Maximize2", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P_ = ie("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A_ = ie("MessageCircle", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K$ = ie("MessageSquareOff", [
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fu = ie("MessageSquare", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G$ = ie("Minimize2", [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const __ = ie("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y$ = ie("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X$ = ie("OctagonAlert", [
  ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  [
    "path",
    {
      d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
      key: "1fd625"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z$ = ie("Palette", [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ov = ie("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J$ = ie("Receipt", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17.5v-11", key: "1jc1ny" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ha = ie("RefreshCw", [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q$ = ie("Repeat2", [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eI = ie("SearchX", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ei = ie("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E_ = ie("Settings", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tI = ie("Share2", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rI = ie("Smartphone", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kf = ie("Sparkles", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const J0 = ie("SquareCheckBig", [
  ["path", { d: "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5", key: "1uzm8b" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nf = ie("Square", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nI = ie("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aI = ie("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eg = ie("TrendingDown", [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ss = ie("TrendingUp", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Os = ie("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oI = ie("Users", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const An = ie("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), tg = "-", iI = (e) => {
  const t = cI(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (i) => {
      const s = i.split(tg);
      return s[0] === "" && s.length !== 1 && s.shift(), C_(s, t) || sI(i);
    },
    getConflictingClassGroupIds: (i, s) => {
      const c = r[i] || [];
      return s && n[i] ? [...c, ...n[i]] : c;
    }
  };
}, C_ = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), a = n ? C_(e.slice(1), n) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const o = e.join(tg);
  return (i = t.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : i.classGroupId;
}, Q0 = /^\[(.+)\]$/, sI = (e) => {
  if (Q0.test(e)) {
    const t = Q0.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, cI = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return uI(Object.entries(e.classGroups), r).forEach(([o, i]) => {
    iv(i, n, o, t);
  }), n;
}, iv = (e, t, r, n) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const o = a === "" ? t : eb(t, a);
      o.classGroupId = r;
      return;
    }
    if (typeof a == "function") {
      if (lI(a)) {
        iv(a(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: r
      });
      return;
    }
    Object.entries(a).forEach(([o, i]) => {
      iv(i, eb(t, o), r, n);
    });
  });
}, eb = (e, t) => {
  let r = e;
  return t.split(tg).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, lI = (e) => e.isThemeGetter, uI = (e, t) => t ? e.map(([r, n]) => {
  const a = n.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([i, s]) => [t + i, s])) : o);
  return [r, a];
}) : e, fI = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const a = (o, i) => {
    r.set(o, i), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let i = r.get(o);
      if (i !== void 0)
        return i;
      if ((i = n.get(o)) !== void 0)
        return a(o, i), i;
    },
    set(o, i) {
      r.has(o) ? r.set(o, i) : a(o, i);
    }
  };
}, k_ = "!", dI = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, a = t[0], o = t.length, i = (s) => {
    const c = [];
    let l = 0, u = 0, f;
    for (let y = 0; y < s.length; y++) {
      let b = s[y];
      if (l === 0) {
        if (b === a && (n || s.slice(y, y + o) === t)) {
          c.push(s.slice(u, y)), u = y + o;
          continue;
        }
        if (b === "/") {
          f = y;
          continue;
        }
      }
      b === "[" ? l++ : b === "]" && l--;
    }
    const d = c.length === 0 ? s : s.substring(u), p = d.startsWith(k_), g = p ? d.substring(1) : d, m = f && f > u ? f - u : void 0;
    return {
      modifiers: c,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
  return r ? (s) => r({
    className: s,
    parseClassName: i
  }) : i;
}, pI = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}, hI = (e) => ({
  cache: fI(e.cacheSize),
  parseClassName: dI(e),
  ...iI(e)
}), mI = /\s+/, vI = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: a
  } = t, o = [], i = e.trim().split(mI);
  let s = "";
  for (let c = i.length - 1; c >= 0; c -= 1) {
    const l = i[c], {
      modifiers: u,
      hasImportantModifier: f,
      baseClassName: d,
      maybePostfixModifierPosition: p
    } = r(l);
    let g = !!p, m = n(g ? d.substring(0, p) : d);
    if (!m) {
      if (!g) {
        s = l + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (m = n(d), !m) {
        s = l + (s.length > 0 ? " " + s : s);
        continue;
      }
      g = !1;
    }
    const y = pI(u).join(":"), b = f ? y + k_ : y, w = b + m;
    if (o.includes(w))
      continue;
    o.push(w);
    const S = a(m, g);
    for (let P = 0; P < S.length; ++P) {
      const x = S[P];
      o.push(b + x);
    }
    s = l + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function yI() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = N_(t)) && (n && (n += " "), n += r);
  return n;
}
const N_ = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = N_(e[n])) && (r && (r += " "), r += t);
  return r;
};
function gI(e, ...t) {
  let r, n, a, o = i;
  function i(c) {
    const l = t.reduce((u, f) => f(u), e());
    return r = hI(l), n = r.cache.get, a = r.cache.set, o = s, s(c);
  }
  function s(c) {
    const l = n(c);
    if (l)
      return l;
    const u = vI(c, r);
    return a(c, u), u;
  }
  return function() {
    return o(yI.apply(null, arguments));
  };
}
const De = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, T_ = /^\[(?:([a-z-]+):)?(.+)\]$/i, bI = /^\d+\/\d+$/, xI = /* @__PURE__ */ new Set(["px", "full", "screen"]), wI = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, SI = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, OI = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, PI = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, AI = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Fr = (e) => La(e) || xI.has(e) || bI.test(e), dn = (e) => No(e, "length", RI), La = (e) => !!e && !Number.isNaN(Number(e)), Tf = (e) => No(e, "number", La), Qo = (e) => !!e && Number.isInteger(Number(e)), _I = (e) => e.endsWith("%") && La(e.slice(0, -1)), he = (e) => T_.test(e), pn = (e) => wI.test(e), EI = /* @__PURE__ */ new Set(["length", "size", "percentage"]), CI = (e) => No(e, EI, M_), kI = (e) => No(e, "position", M_), NI = /* @__PURE__ */ new Set(["image", "url"]), TI = (e) => No(e, NI, II), MI = (e) => No(e, "", $I), ei = () => !0, No = (e, t, r) => {
  const n = T_.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}, RI = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  SI.test(e) && !OI.test(e)
), M_ = () => !1, $I = (e) => PI.test(e), II = (e) => AI.test(e), DI = () => {
  const e = De("colors"), t = De("spacing"), r = De("blur"), n = De("brightness"), a = De("borderColor"), o = De("borderRadius"), i = De("borderSpacing"), s = De("borderWidth"), c = De("contrast"), l = De("grayscale"), u = De("hueRotate"), f = De("invert"), d = De("gap"), p = De("gradientColorStops"), g = De("gradientColorStopPositions"), m = De("inset"), y = De("margin"), b = De("opacity"), w = De("padding"), S = De("saturate"), P = De("scale"), x = De("sepia"), O = De("skew"), A = De("space"), _ = De("translate"), N = () => ["auto", "contain", "none"], M = () => ["auto", "hidden", "clip", "visible", "scroll"], T = () => ["auto", he, t], k = () => [he, t], $ = () => ["", Fr, dn], R = () => ["auto", La, he], L = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], j = () => ["solid", "dashed", "dotted", "double", "none"], z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], q = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], I = () => ["", "0", he], B = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], W = () => [La, he];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [ei],
      spacing: [Fr, dn],
      blur: ["none", "", pn, he],
      brightness: W(),
      borderColor: [e],
      borderRadius: ["none", "", "full", pn, he],
      borderSpacing: k(),
      borderWidth: $(),
      contrast: W(),
      grayscale: I(),
      hueRotate: W(),
      invert: I(),
      gap: k(),
      gradientColorStops: [e],
      gradientColorStopPositions: [_I, dn],
      inset: T(),
      margin: T(),
      opacity: W(),
      padding: k(),
      saturate: W(),
      scale: W(),
      sepia: I(),
      skew: W(),
      space: k(),
      translate: k()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", he]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [pn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": B()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": B()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...L(), he]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: M()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": M()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": M()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: N()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": N()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": N()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Qo, he]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: T()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", he]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: I()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: I()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Qo, he]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [ei]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Qo, he]
        }, he]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": R()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": R()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [ei]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Qo, he]
        }, he]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": R()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": R()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", he]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", he]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...q()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...q(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...q(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [A]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [A]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", he, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [he, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [he, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [pn]
        }, pn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [he, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [he, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [he, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [he, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", pn, dn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Tf]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ei]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", he]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", La, Tf]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Fr, he]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", he]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", he]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...j(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Fr, dn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Fr, he]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", he]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", he]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...L(), kI]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", CI]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, TI]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...j(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: j()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...j()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Fr, he]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Fr, dn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: $()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Fr, dn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", pn, MI]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [ei]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", pn, he]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", he]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: W()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", he]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: W()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", he]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [P]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [P]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [P]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Qo, he]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [_]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [_]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [O]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [O]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", he]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", he]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", he]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Fr, dn, Tf]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, jI = /* @__PURE__ */ gI(DI);
function F(...e) {
  return jI(ue(e));
}
function Ci(e) {
  return e >= 1e9 ? (e / 1e9).toFixed(1).replace(/\.0$/, "") + "B" : e >= 1e6 ? (e / 1e6).toFixed(1).replace(/\.0$/, "") + "M" : e >= 1e3 ? (e / 1e3).toFixed(1).replace(/\.0$/, "") + "K" : e.toString();
}
function LI(e, t = !0) {
  const r = Math.abs(e).toFixed(1) + "%";
  return t ? e > 0 ? "+" + r : e < 0 ? "-" + r : r : r;
}
function BI(e) {
  return e.split(" ").map((t) => t[0]).join("").toUpperCase().slice(0, 2);
}
function cce(e) {
  switch (e) {
    case 1:
      return "Positive";
    case 0:
      return "Neutral";
    case -1:
      return "Negative";
  }
}
function R_(e) {
  return e < 25 ? "low" : e < 50 ? "medium" : e < 75 ? "high" : "critical";
}
function $_(e) {
  switch (e) {
    case "low":
      return "Low Risk";
    case "medium":
      return "Medium Risk";
    case "high":
      return "High Risk";
    case "critical":
      return "Critical";
  }
}
const FI = Ye(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary: "bg-primary-700 text-white hover:bg-primary-800 active:bg-primary-900 shadow-sm",
        secondary: "bg-secondary-500 text-stone-900 hover:bg-secondary-600 active:bg-secondary-700 shadow-sm",
        outline: "border border-stone-300 bg-transparent text-stone-900 hover:bg-stone-100 active:bg-stone-200 dark:border-stone-700 dark:text-stone-100 dark:hover:bg-stone-800",
        ghost: "text-stone-900 hover:bg-stone-100 active:bg-stone-200 dark:text-stone-100 dark:hover:bg-stone-800",
        destructive: "bg-red-500 text-white hover:bg-red-600 active:bg-red-700 shadow-sm",
        link: "text-primary-700 underline-offset-4 hover:underline dark:text-primary-400"
      },
      size: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4 text-sm",
        lg: "h-12 px-6 text-base",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "md"
    }
  }
), Te = v.forwardRef(
  ({
    className: e,
    variant: t,
    size: r,
    asChild: n = !1,
    isLoading: a = !1,
    leftIcon: o,
    rightIcon: i,
    disabled: s,
    children: c,
    ...l
  }, u) => /* @__PURE__ */ h(
    n ? y$ : "button",
    {
      className: F(FI({ variant: t, size: r, className: e })),
      ref: u,
      disabled: s || a,
      ...l,
      children: a ? /* @__PURE__ */ C(Ve, { children: [
        /* @__PURE__ */ h(Qy, { className: "animate-spin" }),
        /* @__PURE__ */ h("span", { children: c })
      ] }) : /* @__PURE__ */ C(Ve, { children: [
        o,
        c,
        i
      ] })
    }
  )
);
Te.displayName = "Button";
const zI = Ye(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "bg-stone-100 text-stone-900 dark:bg-stone-800 dark:text-stone-100",
        primary: "bg-primary-100 text-primary-800 dark:bg-primary-900 dark:text-primary-200",
        secondary: "bg-secondary-100 text-secondary-800 dark:bg-secondary-900 dark:text-secondary-200",
        success: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
        warning: "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200",
        error: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
        info: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
        outline: "border border-stone-300 text-stone-900 dark:border-stone-700 dark:text-stone-100",
        // Sentiment variants
        positive: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
        neutral: "bg-stone-100 text-stone-700 dark:bg-stone-800 dark:text-stone-300",
        negative: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
        // Emotion variants
        joy: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
        sadness: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
        anger: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
        fear: "bg-violet-100 text-violet-800 dark:bg-violet-900 dark:text-violet-200",
        surprise: "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
        // Platform variants
        twitter: "bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-200",
        instagram: "bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200",
        facebook: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
        tiktok: "bg-stone-900 text-white dark:bg-stone-100 dark:text-stone-900",
        google_news: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
      },
      size: {
        sm: "px-2 py-0.5 text-[10px]",
        md: "px-2.5 py-0.5 text-xs",
        lg: "px-3 py-1 text-sm"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "md"
    }
  }
), Qt = v.forwardRef(
  ({ className: e, variant: t, size: r, dot: n, children: a, ...o }, i) => /* @__PURE__ */ C(
    "span",
    {
      ref: i,
      className: F(zI({ variant: t, size: r }), e),
      ...o,
      children: [
        n && /* @__PURE__ */ h("span", { className: "mr-1.5 h-1.5 w-1.5 rounded-full bg-current" }),
        a
      ]
    }
  )
);
Qt.displayName = "Badge";
const I_ = v.forwardRef(
  ({ sentiment: e, children: t, ...r }, n) => /* @__PURE__ */ h(Qt, { ref: n, variant: e === 1 ? "positive" : e === -1 ? "negative" : "neutral", ...r, children: t || (e === 1 ? "Positivo" : e === -1 ? "Negativo" : "Neutral") })
);
I_.displayName = "SentimentBadge";
const qI = {
  joy: "Alegría",
  sadness: "Tristeza",
  anger: "Enojo",
  fear: "Miedo",
  surprise: "Sorpresa",
  disgust: "Disgusto",
  others: "Otros",
  admiracion: "Admiración",
  aprobacion: "Aprobación",
  desaprobacion: "Desaprobación",
  entusiasmo: "Entusiasmo",
  decepcion: "Decepción",
  deseo: "Deseo",
  diversion: "Diversión",
  expectativa: "Expectativa",
  gratitud: "Gratitud",
  desconfianza: "Desconfianza"
}, WI = /* @__PURE__ */ new Set(["joy", "sadness", "anger", "fear", "surprise"]), D_ = v.forwardRef(
  ({ emotion: e, children: t, ...r }, n) => {
    const a = String(e), o = WI.has(a) ? a : "default", i = qI[a] || a.charAt(0).toUpperCase() + a.slice(1);
    return /* @__PURE__ */ h(Qt, { ref: n, variant: o, ...r, children: t || i });
  }
);
D_.displayName = "EmotionBadge";
const j_ = v.forwardRef(
  ({ children: e, ...t }, r) => /* @__PURE__ */ h(Qt, { ref: r, variant: "warning", ...t, children: e || "Sarcasmo" })
);
j_.displayName = "SarcasmBadge";
const L_ = v.forwardRef(
  ({ hate: e, children: t, ...r }, n) => /* @__PURE__ */ h(Qt, { ref: n, variant: "error", ...r, children: t || "Odio" })
);
L_.displayName = "HateBadge";
const HI = Ye(
  "flex w-full rounded-md border bg-white dark:bg-stone-900 text-stone-900 dark:text-stone-100 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-stone-400 dark:placeholder:text-stone-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "border-stone-300 focus-visible:ring-primary-500 dark:border-stone-700",
        error: "border-red-500 focus-visible:ring-red-500 dark:border-red-500"
      },
      inputSize: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4 text-sm",
        lg: "h-12 px-4 text-base"
      }
    },
    defaultVariants: {
      variant: "default",
      inputSize: "md"
    }
  }
), jc = v.forwardRef(
  ({
    className: e,
    type: t = "text",
    variant: r,
    inputSize: n,
    leftElement: a,
    rightElement: o,
    error: i,
    helperText: s,
    clearable: c,
    onClear: l,
    value: u,
    ...f
  }, d) => {
    const [p, g] = v.useState(!1), m = t === "password", y = m && p ? "text" : t, b = u !== void 0 && u !== "";
    return /* @__PURE__ */ C("div", { className: "w-full space-y-1.5", children: [
      /* @__PURE__ */ C("div", { className: "relative", children: [
        a && /* @__PURE__ */ h("div", { className: "absolute left-3 top-1/2 -translate-y-1/2 text-stone-400 dark:text-stone-500", children: a }),
        /* @__PURE__ */ h(
          "input",
          {
            type: y,
            className: F(
              HI({ variant: i ? "error" : r, inputSize: n }),
              a && "pl-10",
              (o || m || c && b) && "pr-10",
              e
            ),
            ref: d,
            value: u,
            ...f
          }
        ),
        (o || m || c && b) && /* @__PURE__ */ C("div", { className: "absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1", children: [
          c && b && /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              onClick: l,
              className: "text-stone-400 hover:text-stone-600 dark:hover:text-stone-300",
              tabIndex: -1,
              children: /* @__PURE__ */ h(An, { className: "h-4 w-4" })
            }
          ),
          m && /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              onClick: () => g(!p),
              className: "text-stone-400 hover:text-stone-600 dark:hover:text-stone-300",
              tabIndex: -1,
              children: p ? /* @__PURE__ */ h(L$, { className: "h-4 w-4" }) : /* @__PURE__ */ h(Jy, { className: "h-4 w-4" })
            }
          ),
          o
        ] })
      ] }),
      (i || s) && /* @__PURE__ */ h(
        "p",
        {
          className: F(
            "text-xs",
            i ? "text-red-500" : "text-stone-500 dark:text-stone-400"
          ),
          children: i || s
        }
      )
    ] });
  }
);
jc.displayName = "Input";
const B_ = v.forwardRef(
  ({ "aria-label": e, "aria-labelledby": t, placeholder: r, ...n }, a) => /* @__PURE__ */ h(
    jc,
    {
      ref: a,
      type: "search",
      leftElement: /* @__PURE__ */ h(Ei, { className: "h-4 w-4" }),
      placeholder: r,
      "aria-label": e ?? (t ? void 0 : r || "Buscar"),
      "aria-labelledby": t,
      ...n
    }
  )
);
B_.displayName = "SearchInput";
function VI(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i);
    s.displayName = o + "Context";
    const c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, UI(a, ...t)];
}
function UI(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function et(e) {
  const t = v.useRef(e);
  return v.useEffect(() => {
    t.current = e;
  }), v.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
var Ge = globalThis != null && globalThis.document ? v.useLayoutEffect : () => {
}, KI = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ps = KI.reduce((e, t) => {
  const r = /* @__PURE__ */ g_(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Zs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _e(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Js = { exports: {} }, Mf = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tb;
function GI() {
  if (tb) return Mf;
  tb = 1;
  var e = E;
  function t(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, a = e.useEffect, o = e.useLayoutEffect, i = e.useDebugValue;
  function s(f, d) {
    var p = d(), g = n({ inst: { value: p, getSnapshot: d } }), m = g[0].inst, y = g[1];
    return o(
      function() {
        m.value = p, m.getSnapshot = d, c(m) && y({ inst: m });
      },
      [f, p, d]
    ), a(
      function() {
        return c(m) && y({ inst: m }), f(function() {
          c(m) && y({ inst: m });
        });
      },
      [f]
    ), i(p), p;
  }
  function c(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var p = d();
      return !r(f, p);
    } catch {
      return !0;
    }
  }
  function l(f, d) {
    return d();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : s;
  return Mf.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, Mf;
}
var Rf = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rb;
function YI() {
  return rb || (rb = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(p, g) {
      return p === g && (p !== 0 || 1 / p === 1 / g) || p !== p && g !== g;
    }
    function t(p, g) {
      u || a.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var m = g();
      if (!f) {
        var y = g();
        o(m, y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      y = i({
        inst: { value: m, getSnapshot: g }
      });
      var b = y[0].inst, w = y[1];
      return c(
        function() {
          b.value = m, b.getSnapshot = g, r(b) && w({ inst: b });
        },
        [p, m, g]
      ), s(
        function() {
          return r(b) && w({ inst: b }), p(function() {
            r(b) && w({ inst: b });
          });
        },
        [p]
      ), l(m), m;
    }
    function r(p) {
      var g = p.getSnapshot;
      p = p.value;
      try {
        var m = g();
        return !o(p, m);
      } catch {
        return !0;
      }
    }
    function n(p, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var a = E, o = typeof Object.is == "function" ? Object.is : e, i = a.useState, s = a.useEffect, c = a.useLayoutEffect, l = a.useDebugValue, u = !1, f = !1, d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : t;
    Rf.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : d, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Rf;
}
var nb;
function XI() {
  return nb || (nb = 1, process.env.NODE_ENV === "production" ? Js.exports = GI() : Js.exports = YI()), Js.exports;
}
var ZI = XI();
function JI() {
  return ZI.useSyncExternalStore(
    QI,
    () => !0,
    () => !1
  );
}
function QI() {
  return () => {
  };
}
var rg = "Avatar", [eD] = VI(rg), [tD, F_] = eD(rg), z_ = v.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, ...n } = e, [a, o] = v.useState("idle");
    return /* @__PURE__ */ h(
      tD,
      {
        scope: r,
        imageLoadingStatus: a,
        onImageLoadingStatusChange: o,
        children: /* @__PURE__ */ h(Ps.span, { ...n, ref: t })
      }
    );
  }
);
z_.displayName = rg;
var q_ = "AvatarImage", W_ = v.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, src: n, onLoadingStatusChange: a = () => {
    }, ...o } = e, i = F_(q_, r), s = rD(n, o), c = et((l) => {
      a(l), i.onImageLoadingStatusChange(l);
    });
    return Ge(() => {
      s !== "idle" && c(s);
    }, [s, c]), s === "loaded" ? /* @__PURE__ */ h(Ps.img, { ...o, ref: t, src: n }) : null;
  }
);
W_.displayName = q_;
var H_ = "AvatarFallback", V_ = v.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, delayMs: n, ...a } = e, o = F_(H_, r), [i, s] = v.useState(n === void 0);
    return v.useEffect(() => {
      if (n !== void 0) {
        const c = window.setTimeout(() => s(!0), n);
        return () => window.clearTimeout(c);
      }
    }, [n]), i && o.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ h(Ps.span, { ...a, ref: t }) : null;
  }
);
V_.displayName = H_;
function ab(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function rD(e, { referrerPolicy: t, crossOrigin: r }) {
  const n = JI(), a = v.useRef(null), o = n ? (a.current || (a.current = new window.Image()), a.current) : null, [i, s] = v.useState(
    () => ab(o, e)
  );
  return Ge(() => {
    s(ab(o, e));
  }, [o, e]), Ge(() => {
    const c = (f) => () => {
      s(f);
    };
    if (!o) return;
    const l = c("loaded"), u = c("error");
    return o.addEventListener("load", l), o.addEventListener("error", u), t && (o.referrerPolicy = t), typeof r == "string" && (o.crossOrigin = r), () => {
      o.removeEventListener("load", l), o.removeEventListener("error", u);
    };
  }, [o, r, t]), i;
}
var nD = z_, aD = W_, oD = V_;
const U_ = Ye(
  "relative flex shrink-0 overflow-hidden rounded-full",
  {
    variants: {
      size: {
        xs: "h-6 w-6 text-[10px]",
        sm: "h-8 w-8 text-xs",
        md: "h-10 w-10 text-sm",
        lg: "h-12 w-12 text-base",
        xl: "h-16 w-16 text-lg"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), iD = {
  twitter: "bg-sky-500",
  instagram: "bg-pink-500",
  facebook: "bg-blue-600",
  tiktok: "bg-stone-900 dark:bg-stone-100",
  google_news: "bg-blue-500"
}, sD = {
  twitter: "X",
  instagram: "IG",
  facebook: "FB",
  tiktok: "TT",
  google_news: "GN"
}, ng = v.forwardRef(({ className: e, size: t, src: r, alt: n, name: a, platform: o, verified: i, ...s }, c) => {
  const l = a ? BI(a) : "?";
  return /* @__PURE__ */ C("div", { className: "relative inline-flex", children: [
    /* @__PURE__ */ C(
      nD,
      {
        ref: c,
        className: F(U_({ size: t }), e),
        ...s,
        children: [
          /* @__PURE__ */ h(
            aD,
            {
              src: r,
              alt: n || a,
              referrerPolicy: "no-referrer",
              className: "aspect-square h-full w-full object-cover"
            }
          ),
          /* @__PURE__ */ h(
            oD,
            {
              className: "flex h-full w-full items-center justify-center bg-stone-200 font-medium text-stone-700 dark:bg-stone-700 dark:text-stone-200",
              children: l
            }
          )
        ]
      }
    ),
    o && /* @__PURE__ */ h(
      "span",
      {
        className: F(
          "absolute -bottom-0.5 -right-0.5 flex items-center justify-center rounded-full text-[8px] font-bold text-white",
          iD[o],
          t === "xs" && "h-3 w-3",
          t === "sm" && "h-3.5 w-3.5",
          t === "md" && "h-4 w-4",
          t === "lg" && "h-5 w-5",
          t === "xl" && "h-6 w-6 text-[10px]",
          o === "tiktok" && "dark:text-stone-900"
        ),
        title: o,
        children: sD[o]
      }
    ),
    i && /* @__PURE__ */ h(
      "span",
      {
        className: F(
          "absolute -top-0.5 -right-0.5 flex items-center justify-center rounded-full bg-blue-500 text-white",
          t === "xs" && "h-3 w-3 text-[8px]",
          t === "sm" && "h-3.5 w-3.5 text-[8px]",
          t === "md" && "h-4 w-4 text-[10px]",
          t === "lg" && "h-5 w-5 text-xs",
          t === "xl" && "h-6 w-6 text-sm"
        ),
        title: "Verified",
        children: "✓"
      }
    )
  ] });
});
ng.displayName = "Avatar";
const cD = v.forwardRef(
  ({ className: e, max: t = 4, size: r = "md", children: n, ...a }, o) => {
    const i = v.Children.toArray(n), s = i.slice(0, t), c = i.length - t;
    return /* @__PURE__ */ C(
      "div",
      {
        ref: o,
        className: F("flex -space-x-2", e),
        ...a,
        children: [
          s.map((l, u) => /* @__PURE__ */ h(
            "div",
            {
              className: "ring-2 ring-white dark:ring-stone-900 rounded-full",
              children: v.isValidElement(l) ? v.cloneElement(l, { size: r }) : l
            },
            u
          )),
          c > 0 && /* @__PURE__ */ C(
            "div",
            {
              className: F(
                U_({ size: r }),
                "ring-2 ring-white dark:ring-stone-900 flex items-center justify-center bg-stone-200 font-medium text-stone-700 dark:bg-stone-700 dark:text-stone-200"
              ),
              children: [
                "+",
                c
              ]
            }
          )
        ]
      }
    );
  }
);
cD.displayName = "AvatarGroup";
const lD = Ye(
  "inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "bg-stone-100 text-stone-700 hover:bg-stone-200 dark:bg-stone-800 dark:text-stone-300 dark:hover:bg-stone-700",
        primary: "bg-primary-100 text-primary-800 hover:bg-primary-200 dark:bg-primary-900 dark:text-primary-200 dark:hover:bg-primary-800",
        secondary: "bg-secondary-100 text-secondary-800 hover:bg-secondary-200 dark:bg-secondary-900 dark:text-secondary-200 dark:hover:bg-secondary-800",
        outline: "border border-stone-300 text-stone-700 hover:bg-stone-100 dark:border-stone-700 dark:text-stone-300 dark:hover:bg-stone-800",
        // Platform variants
        twitter: "bg-sky-100 text-sky-800 hover:bg-sky-200 dark:bg-sky-900 dark:text-sky-200",
        instagram: "bg-pink-100 text-pink-800 hover:bg-pink-200 dark:bg-pink-900 dark:text-pink-200",
        facebook: "bg-blue-100 text-blue-800 hover:bg-blue-200 dark:bg-blue-900 dark:text-blue-200",
        tiktok: "bg-stone-800 text-white hover:bg-stone-700 dark:bg-stone-200 dark:text-stone-900",
        google_news: "bg-blue-100 text-blue-800 hover:bg-blue-200 dark:bg-blue-900 dark:text-blue-200"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), K_ = v.forwardRef(
  ({
    className: e,
    variant: t,
    isHashtag: r,
    removable: n,
    onRemove: a,
    platform: o,
    children: i,
    ...s
  }, c) => /* @__PURE__ */ C(
    "span",
    {
      ref: c,
      className: F(lD({ variant: o || t }), e),
      ...s,
      children: [
        r && /* @__PURE__ */ h(z$, { className: "h-3 w-3" }),
        i,
        n && /* @__PURE__ */ C(
          "button",
          {
            type: "button",
            onClick: (u) => {
              u.stopPropagation(), a == null || a();
            },
            className: "ml-0.5 rounded-sm opacity-70 hover:opacity-100 focus:outline-none focus:ring-1 focus:ring-primary-500",
            children: [
              /* @__PURE__ */ h(An, { className: "h-3 w-3" }),
              /* @__PURE__ */ h("span", { className: "sr-only", children: "Remove" })
            ]
          }
        )
      ]
    }
  )
);
K_.displayName = "Tag";
const uD = v.forwardRef(
  ({ className: e, max: t, children: r, ...n }, a) => {
    const o = v.Children.toArray(r), i = t ? o.slice(0, t) : o, s = t ? o.length - t : 0;
    return /* @__PURE__ */ C(
      "div",
      {
        ref: a,
        className: F("flex flex-wrap gap-1.5", e),
        ...n,
        children: [
          i,
          s > 0 && /* @__PURE__ */ C(K_, { variant: "outline", children: [
            "+",
            s,
            " more"
          ] })
        ]
      }
    );
  }
);
uD.displayName = "TagGroup";
const fD = Ye("animate-spin text-primary-600", {
  variants: {
    size: {
      sm: "h-4 w-4",
      md: "h-6 w-6",
      lg: "h-8 w-8",
      xl: "h-12 w-12"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), ag = v.forwardRef(
  ({ className: e, size: t, label: r = "Loading...", ...n }, a) => /* @__PURE__ */ h(
    Qy,
    {
      ref: a,
      className: F(fD({ size: t }), e),
      "aria-label": r,
      role: "status",
      ...n
    }
  )
);
ag.displayName = "Spinner";
const dD = v.forwardRef(
  ({ show: e = !0, message: t = "Loading...", size: r = "lg" }, n) => e ? /* @__PURE__ */ h(
    "div",
    {
      ref: n,
      className: "fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm",
      children: /* @__PURE__ */ C("div", { className: "flex flex-col items-center gap-3", children: [
        /* @__PURE__ */ h(ag, { size: r }),
        t && /* @__PURE__ */ h("p", { className: "text-sm font-medium text-stone-600 dark:text-stone-400", children: t })
      ] })
    }
  ) : null
);
dD.displayName = "LoadingOverlay";
const pD = v.forwardRef(
  ({ className: e, message: t = "Loading...", size: r = "sm", ...n }, a) => /* @__PURE__ */ C(
    "div",
    {
      ref: a,
      className: F("flex items-center gap-2", e),
      ...n,
      children: [
        /* @__PURE__ */ h(ag, { size: r }),
        t && /* @__PURE__ */ h("span", { className: "text-sm text-stone-600 dark:text-stone-400", children: t })
      ]
    }
  )
);
pD.displayName = "InlineLoading";
const G_ = v.forwardRef(
  ({ className: e, width: t = "w-full", height: r = "h-4", ...n }, a) => /* @__PURE__ */ h(
    "div",
    {
      ref: a,
      className: F(
        "animate-pulse rounded-md bg-stone-200 dark:bg-stone-700",
        t,
        r,
        e
      ),
      ...n
    }
  )
);
G_.displayName = "Skeleton";
const hD = [
  {
    name: "uyari-tech",
    label: "Uyari Tech",
    description: "Technical precision, analytical depth, modernity - cyan IA + teal hierarchy + slate anchor",
    colors: {
      primary: "#2BC4CE",
      // Cyan medio (CTA solido)
      secondary: "#43868A",
      // Teal oscuro (brand profundo)
      accent: "#6BD6DB"
      // Teal claro (highlights)
    }
  },
  {
    name: "ocean-blue",
    label: "Ocean Blue",
    description: "Trust, technology, clarity",
    colors: {
      primary: "#2563EB",
      secondary: "#0D9488",
      accent: "#06B6D4"
    }
  },
  {
    name: "midnight",
    label: "Midnight Professional",
    description: "Elegance, seriousness, enterprise",
    colors: {
      primary: "#1E3A5F",
      secondary: "#475569",
      accent: "#0EA5E9"
    }
  },
  {
    name: "tech-violet",
    label: "Tech Violet",
    description: "Innovation, modernity, AI",
    colors: {
      primary: "#7C3AED",
      secondary: "#6366F1",
      accent: "#EC4899"
    }
  },
  {
    name: "fresh-green",
    label: "Fresh Green",
    description: "Growth, health, positivity",
    colors: {
      primary: "#059669",
      secondary: "#0D9488",
      accent: "#84CC16"
    }
  }
];
function mD(e) {
  document.documentElement.setAttribute("data-theme", e);
}
function vD() {
  return document.documentElement.getAttribute("data-theme") || "uyari-tech";
}
function lce(e) {
  e ? document.documentElement.classList.add("dark") : document.documentElement.classList.remove("dark");
}
function uce() {
  return document.documentElement.classList.contains("dark");
}
const yD = {
  sm: { swatch: "h-6 w-6", text: "text-xs" },
  md: { swatch: "h-8 w-8", text: "text-sm" },
  lg: { swatch: "h-10 w-10", text: "text-base" }
}, gD = v.forwardRef(
  ({
    className: e,
    value: t,
    onChange: r,
    showLabels: n = !0,
    size: a = "md",
    ...o
  }, i) => {
    const [s, c] = v.useState(
      t || (typeof window < "u" ? vD() : "uyari-tech")
    ), l = yD[a];
    v.useEffect(() => {
      t && c(t);
    }, [t]);
    const u = (f) => {
      c(f), mD(f), r == null || r(f);
    };
    return /* @__PURE__ */ C("div", { ref: i, className: F("space-y-3", e), ...o, children: [
      /* @__PURE__ */ C("div", { className: "flex items-center gap-2 text-sm font-medium text-stone-700 dark:text-stone-300", children: [
        /* @__PURE__ */ h(Z$, { className: "h-4 w-4" }),
        /* @__PURE__ */ h("span", { children: "Theme" })
      ] }),
      /* @__PURE__ */ h("div", { className: "grid grid-cols-5 gap-2", children: hD.map((f) => {
        const d = s === f.name;
        return /* @__PURE__ */ C(
          "button",
          {
            onClick: () => u(f.name),
            title: f.label,
            className: F(
              "group relative flex flex-col items-center gap-1 rounded-lg p-2 transition-all",
              d ? "bg-stone-100 dark:bg-stone-800" : "hover:bg-stone-50 dark:hover:bg-stone-900"
            ),
            children: [
              /* @__PURE__ */ C(
                "div",
                {
                  className: F(
                    "relative flex items-center justify-center rounded-full transition-transform group-hover:scale-110",
                    l.swatch
                  ),
                  style: { backgroundColor: f.colors.primary },
                  children: [
                    d && /* @__PURE__ */ h(ha, { className: "h-4 w-4 text-white" }),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 border-white dark:border-stone-800",
                        style: { backgroundColor: f.colors.secondary }
                      }
                    )
                  ]
                }
              ),
              n && /* @__PURE__ */ h(
                "span",
                {
                  className: F(
                    "text-center text-stone-600 dark:text-stone-400",
                    l.text,
                    d && "font-medium text-stone-900 dark:text-stone-100"
                  ),
                  children: f.label.split(" ")[0]
                }
              )
            ]
          },
          f.name
        );
      }) })
    ] });
  }
);
gD.displayName = "ThemeSwitcher";
var bD = "Label", Y_ = v.forwardRef((e, t) => /* @__PURE__ */ h(
  Ps.label,
  {
    ...e,
    ref: t,
    onMouseDown: (r) => {
      var a;
      r.target.closest("button, input, select, textarea") || ((a = e.onMouseDown) == null || a.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
Y_.displayName = bD;
var xD = Y_;
const wD = Ye(
  "font-medium text-stone-700 dark:text-stone-300",
  {
    variants: {
      size: {
        sm: "text-xs",
        md: "text-sm",
        lg: "text-base"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), X_ = v.forwardRef(({ className: e, size: t, required: r, children: n, ...a }, o) => /* @__PURE__ */ C(
  xD,
  {
    ref: o,
    className: F(wD({ size: t, className: e })),
    ...a,
    children: [
      n,
      r && /* @__PURE__ */ h("span", { className: "ml-0.5 text-red-500", children: "*" })
    ]
  }
));
X_.displayName = "Label";
function SD(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, OD(a, ...t)];
}
function OD(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function re(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), r === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
var PD = v[" useInsertionEffect ".trim().toString()] || Ge;
function mr({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  },
  caller: n
}) {
  const [a, o, i] = AD({
    defaultProp: t,
    onChange: r
  }), s = e !== void 0, c = s ? e : a;
  {
    const u = v.useRef(e !== void 0);
    v.useEffect(() => {
      const f = u.current;
      f !== s && console.warn(
        `${n} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, n]);
  }
  const l = v.useCallback(
    (u) => {
      var f;
      if (s) {
        const d = _D(u) ? u(e) : u;
        d !== e && ((f = i.current) == null || f.call(i, d));
      } else
        o(u);
    },
    [s, e, o, i]
  );
  return [c, l];
}
function AD({
  defaultProp: e,
  onChange: t
}) {
  const [r, n] = v.useState(e), a = v.useRef(r), o = v.useRef(t);
  return PD(() => {
    o.current = t;
  }, [t]), v.useEffect(() => {
    var i;
    a.current !== r && ((i = o.current) == null || i.call(o, r), a.current = r);
  }, [r, a]), [r, n, o];
}
function _D(e) {
  return typeof e == "function";
}
function og(e) {
  const t = v.useRef({ value: e, previous: e });
  return v.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function ig(e) {
  const [t, r] = v.useState(void 0);
  return Ge(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const o = a[0];
        let i, s;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, s = l.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        r({ width: i, height: s });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
function ED(e, t) {
  return v.useReducer((r, n) => t[r][n] ?? r, e);
}
var ot = (e) => {
  const { present: t, children: r } = e, n = CD(t), a = typeof r == "function" ? r({ present: n.isPresent }) : v.Children.only(r), o = me(n.ref, kD(a));
  return typeof r == "function" || n.isPresent ? v.cloneElement(a, { ref: o }) : null;
};
ot.displayName = "Presence";
function CD(e) {
  const [t, r] = v.useState(), n = v.useRef(null), a = v.useRef(e), o = v.useRef("none"), i = e ? "mounted" : "unmounted", [s, c] = ED(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return v.useEffect(() => {
    const l = Qs(n.current);
    o.current = s === "mounted" ? l : "none";
  }, [s]), Ge(() => {
    const l = n.current, u = a.current;
    if (u !== e) {
      const d = o.current, p = Qs(l);
      e ? c("MOUNT") : p === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && d !== p ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, c]), Ge(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, f = (p) => {
        const m = Qs(n.current).includes(CSS.escape(p.animationName));
        if (p.target === t && m && (c("ANIMATION_END"), !a.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, d = (p) => {
        p.target === t && (o.current = Qs(n.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: v.useCallback((l) => {
      n.current = l ? getComputedStyle(l) : null, r(l);
    }, [])
  };
}
function Qs(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function kD(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
// @__NO_SIDE_EFFECTS__
function ND(e) {
  const t = /* @__PURE__ */ TD(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(RD);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function TD(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = ID(a), s = $D(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var MD = Symbol("radix.slottable");
function RD(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === MD;
}
function $D(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function ID(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var DD = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], sg = DD.reduce((e, t) => {
  const r = /* @__PURE__ */ ND(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), du = "Checkbox", [jD] = SD(du), [LD, cg] = jD(du);
function BD(e) {
  const {
    __scopeCheckbox: t,
    checked: r,
    children: n,
    defaultChecked: a,
    disabled: o,
    form: i,
    name: s,
    onCheckedChange: c,
    required: l,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [d, p] = mr({
    prop: r,
    defaultProp: a ?? !1,
    onChange: c,
    caller: du
  }), [g, m] = v.useState(null), [y, b] = v.useState(null), w = v.useRef(!1), S = g ? !!i || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), P = {
    checked: d,
    disabled: o,
    setChecked: p,
    control: g,
    setControl: m,
    name: s,
    form: i,
    value: u,
    hasConsumerStoppedPropagationRef: w,
    required: l,
    defaultChecked: Sn(a) ? !1 : a,
    isFormControl: S,
    bubbleInput: y,
    setBubbleInput: b
  };
  return /* @__PURE__ */ h(
    LD,
    {
      scope: t,
      ...P,
      children: FD(f) ? f(P) : n
    }
  );
}
var Z_ = "CheckboxTrigger", J_ = v.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: r, ...n }, a) => {
    const {
      control: o,
      value: i,
      disabled: s,
      checked: c,
      required: l,
      setControl: u,
      setChecked: f,
      hasConsumerStoppedPropagationRef: d,
      isFormControl: p,
      bubbleInput: g
    } = cg(Z_, e), m = me(a, u), y = v.useRef(c);
    return v.useEffect(() => {
      const b = o == null ? void 0 : o.form;
      if (b) {
        const w = () => f(y.current);
        return b.addEventListener("reset", w), () => b.removeEventListener("reset", w);
      }
    }, [o, f]), /* @__PURE__ */ h(
      sg.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": Sn(c) ? "mixed" : c,
        "aria-required": l,
        "data-state": rE(c),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: i,
        ...n,
        ref: m,
        onKeyDown: re(t, (b) => {
          b.key === "Enter" && b.preventDefault();
        }),
        onClick: re(r, (b) => {
          f((w) => Sn(w) ? !0 : !w), g && p && (d.current = b.isPropagationStopped(), d.current || b.stopPropagation());
        })
      }
    );
  }
);
J_.displayName = Z_;
var lg = v.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: r,
      name: n,
      checked: a,
      defaultChecked: o,
      required: i,
      disabled: s,
      value: c,
      onCheckedChange: l,
      form: u,
      ...f
    } = e;
    return /* @__PURE__ */ h(
      BD,
      {
        __scopeCheckbox: r,
        checked: a,
        defaultChecked: o,
        disabled: s,
        required: i,
        onCheckedChange: l,
        name: n,
        form: u,
        value: c,
        internal_do_not_use_render: ({ isFormControl: d }) => /* @__PURE__ */ C(Ve, { children: [
          /* @__PURE__ */ h(
            J_,
            {
              ...f,
              ref: t,
              __scopeCheckbox: r
            }
          ),
          d && /* @__PURE__ */ h(
            tE,
            {
              __scopeCheckbox: r
            }
          )
        ] })
      }
    );
  }
);
lg.displayName = du;
var Q_ = "CheckboxIndicator", ug = v.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: r, forceMount: n, ...a } = e, o = cg(Q_, r);
    return /* @__PURE__ */ h(
      ot,
      {
        present: n || Sn(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ h(
          sg.span,
          {
            "data-state": rE(o.checked),
            "data-disabled": o.disabled ? "" : void 0,
            ...a,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
ug.displayName = Q_;
var eE = "CheckboxBubbleInput", tE = v.forwardRef(
  ({ __scopeCheckbox: e, ...t }, r) => {
    const {
      control: n,
      hasConsumerStoppedPropagationRef: a,
      checked: o,
      defaultChecked: i,
      required: s,
      disabled: c,
      name: l,
      value: u,
      form: f,
      bubbleInput: d,
      setBubbleInput: p
    } = cg(eE, e), g = me(r, p), m = og(o), y = ig(n);
    v.useEffect(() => {
      const w = d;
      if (!w) return;
      const S = window.HTMLInputElement.prototype, x = Object.getOwnPropertyDescriptor(
        S,
        "checked"
      ).set, O = !a.current;
      if (m !== o && x) {
        const A = new Event("click", { bubbles: O });
        w.indeterminate = Sn(o), x.call(w, Sn(o) ? !1 : o), w.dispatchEvent(A);
      }
    }, [d, m, o, a]);
    const b = v.useRef(Sn(o) ? !1 : o);
    return /* @__PURE__ */ h(
      sg.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? b.current,
        required: s,
        disabled: c,
        name: l,
        value: u,
        form: f,
        ...t,
        tabIndex: -1,
        ref: g,
        style: {
          ...t.style,
          ...y,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
tE.displayName = eE;
function FD(e) {
  return typeof e == "function";
}
function Sn(e) {
  return e === "indeterminate";
}
function rE(e) {
  return Sn(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const zD = Ye(
  "peer shrink-0 border border-stone-300 dark:border-stone-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary-700 data-[state=checked]:border-primary-700 data-[state=checked]:text-white dark:data-[state=checked]:bg-primary-600",
  {
    variants: {
      size: {
        sm: "h-4 w-4 rounded",
        md: "h-5 w-5 rounded-md",
        lg: "h-6 w-6 rounded-md"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), qD = {
  sm: "h-3 w-3",
  md: "h-3.5 w-3.5",
  lg: "h-4 w-4"
}, WD = v.forwardRef(({ className: e, size: t, label: r, ...n }, a) => {
  const o = t ?? "md", i = /* @__PURE__ */ h(
    lg,
    {
      ref: a,
      className: F(zD({ size: t, className: e })),
      ...n,
      children: /* @__PURE__ */ h(ug, { className: "flex items-center justify-center", children: /* @__PURE__ */ h(ha, { className: qD[o] }) })
    }
  );
  return r ? /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
    i,
    /* @__PURE__ */ h(
      "label",
      {
        className: "text-sm font-medium text-stone-700 dark:text-stone-300 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        onClick: () => {
        },
        children: r
      }
    )
  ] }) : i;
});
WD.displayName = "Checkbox";
function HD(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, VD(a, ...t)];
}
function VD(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function UD(e) {
  const t = /* @__PURE__ */ KD(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(YD);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function KD(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = ZD(a), s = XD(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var GD = Symbol("radix.slottable");
function YD(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === GD;
}
function XD(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function ZD(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var JD = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], nE = JD.reduce((e, t) => {
  const r = /* @__PURE__ */ UD(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), pu = "Switch", [QD] = HD(pu), [ej, tj] = QD(pu), aE = v.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: r,
      name: n,
      checked: a,
      defaultChecked: o,
      required: i,
      disabled: s,
      value: c = "on",
      onCheckedChange: l,
      form: u,
      ...f
    } = e, [d, p] = v.useState(null), g = me(t, (S) => p(S)), m = v.useRef(!1), y = d ? u || !!d.closest("form") : !0, [b, w] = mr({
      prop: a,
      defaultProp: o ?? !1,
      onChange: l,
      caller: pu
    });
    return /* @__PURE__ */ C(ej, { scope: r, checked: b, disabled: s, children: [
      /* @__PURE__ */ h(
        nE.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": i,
          "data-state": cE(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...f,
          ref: g,
          onClick: re(e.onClick, (S) => {
            w((P) => !P), y && (m.current = S.isPropagationStopped(), m.current || S.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ h(
        sE,
        {
          control: d,
          bubbles: !m.current,
          name: n,
          value: c,
          checked: b,
          required: i,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
aE.displayName = pu;
var oE = "SwitchThumb", iE = v.forwardRef(
  (e, t) => {
    const { __scopeSwitch: r, ...n } = e, a = tj(oE, r);
    return /* @__PURE__ */ h(
      nE.span,
      {
        "data-state": cE(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
iE.displayName = oE;
var rj = "SwitchBubbleInput", sE = v.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: r,
    bubbles: n = !0,
    ...a
  }, o) => {
    const i = v.useRef(null), s = me(i, o), c = og(r), l = ig(t);
    return v.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const f = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (c !== r && p) {
        const g = new Event("click", { bubbles: n });
        p.call(u, r), u.dispatchEvent(g);
      }
    }, [c, r, n]), /* @__PURE__ */ h(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: r,
        ...a,
        tabIndex: -1,
        ref: s,
        style: {
          ...a.style,
          ...l,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
sE.displayName = rj;
function cE(e) {
  return e ? "checked" : "unchecked";
}
var nj = aE, aj = iE;
const oj = Ye(
  "inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors data-[state=checked]:bg-primary-600 dark:data-[state=checked]:bg-primary-500 bg-stone-200 dark:bg-stone-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      size: {
        sm: "h-4 w-7",
        md: "h-5 w-9",
        lg: "h-6 w-11"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), ij = Ye(
  "block rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0",
  {
    variants: {
      size: {
        sm: "h-3 w-3 data-[state=checked]:translate-x-3",
        md: "h-4 w-4 data-[state=checked]:translate-x-4",
        lg: "h-5 w-5 data-[state=checked]:translate-x-5"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), sj = v.forwardRef(({ className: e, size: t, label: r, ...n }, a) => {
  const o = /* @__PURE__ */ h(
    nj,
    {
      className: F(oj({ size: t, className: r ? void 0 : e })),
      ref: a,
      ...n,
      children: /* @__PURE__ */ h(aj, { className: F(ij({ size: t })) })
    }
  );
  return r ? /* @__PURE__ */ C("div", { className: F("flex items-center gap-2", e), children: [
    o,
    /* @__PURE__ */ h("span", { className: "text-sm text-stone-700 dark:text-stone-300", children: r })
  ] }) : o;
});
sj.displayName = "Switch";
const cj = Ye(
  "flex w-full rounded-md border bg-transparent transition-colors placeholder:text-stone-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-vertical dark:placeholder:text-stone-400",
  {
    variants: {
      variant: {
        default: "border-stone-300 focus-visible:ring-primary-500 dark:border-stone-700",
        error: "border-red-500 focus-visible:ring-red-500 dark:border-red-500"
      },
      textareaSize: {
        sm: "min-h-[60px] px-3 py-1.5 text-xs",
        md: "min-h-[80px] px-4 py-2 text-sm",
        lg: "min-h-[120px] px-4 py-3 text-base"
      }
    },
    defaultVariants: {
      variant: "default",
      textareaSize: "md"
    }
  }
), lj = v.forwardRef(
  ({
    className: e,
    variant: t,
    textareaSize: r,
    error: n,
    helperText: a,
    ...o
  }, i) => /* @__PURE__ */ C("div", { className: "w-full space-y-1.5", children: [
    /* @__PURE__ */ h(
      "textarea",
      {
        className: F(
          cj({ variant: n ? "error" : t, textareaSize: r }),
          e
        ),
        ref: i,
        ...o
      }
    ),
    (n || a) && /* @__PURE__ */ h(
      "p",
      {
        className: F(
          "text-xs",
          n ? "text-red-500" : "text-stone-500 dark:text-stone-400"
        ),
        children: n || a
      }
    )
  ] })
);
lj.displayName = "Textarea";
function sv(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
function uj(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, fj(a, ...t)];
}
function fj(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function ob(e) {
  const t = /* @__PURE__ */ dj(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(hj);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function dj(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = vj(a), s = mj(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var pj = Symbol("radix.slottable");
function hj(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === pj;
}
function mj(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function vj(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function fg(e) {
  const t = e + "CollectionProvider", [r, n] = uj(t), [a, o] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: y, children: b } = m, w = E.useRef(null), S = E.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ h(a, { scope: y, itemMap: S, collectionRef: w, children: b });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", c = /* @__PURE__ */ ob(s), l = E.forwardRef(
    (m, y) => {
      const { scope: b, children: w } = m, S = o(s, b), P = me(y, S.collectionRef);
      return /* @__PURE__ */ h(c, { ref: P, children: w });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", f = "data-radix-collection-item", d = /* @__PURE__ */ ob(u), p = E.forwardRef(
    (m, y) => {
      const { scope: b, children: w, ...S } = m, P = E.useRef(null), x = me(y, P), O = o(u, b);
      return E.useEffect(() => (O.itemMap.set(P, { ref: P, ...S }), () => void O.itemMap.delete(P))), /* @__PURE__ */ h(d, { [f]: "", ref: x, children: w });
    }
  );
  p.displayName = u;
  function g(m) {
    const y = o(e + "CollectionConsumer", m);
    return E.useCallback(() => {
      const w = y.collectionRef.current;
      if (!w) return [];
      const S = Array.from(w.querySelectorAll(`[${f}]`));
      return Array.from(y.itemMap.values()).sort(
        (O, A) => S.indexOf(O.ref.current) - S.indexOf(A.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: p },
    g,
    n
  ];
}
function yj(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, gj(a, ...t)];
}
function gj(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var bj = v.createContext(void 0);
function As(e) {
  const t = v.useContext(bj);
  return e || t || "ltr";
}
// @__NO_SIDE_EFFECTS__
function xj(e) {
  const t = /* @__PURE__ */ wj(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(Oj);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function wj(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = Aj(a), s = Pj(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Sj = Symbol("radix.slottable");
function Oj(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Sj;
}
function Pj(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Aj(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var _j = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], lE = _j.reduce((e, t) => {
  const r = /* @__PURE__ */ xj(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Ej(e, t) {
  e && xs.flushSync(() => e.dispatchEvent(t));
}
function Cj(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = et(e);
  v.useEffect(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var kj = "DismissableLayer", cv = "dismissableLayer.update", Nj = "dismissableLayer.pointerDownOutside", Tj = "dismissableLayer.focusOutside", ib, uE = v.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), To = v.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: a,
      onFocusOutside: o,
      onInteractOutside: i,
      onDismiss: s,
      ...c
    } = e, l = v.useContext(uE), [u, f] = v.useState(null), d = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = v.useState({}), g = me(t, (A) => f(A)), m = Array.from(l.layers), [y] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(y), w = u ? m.indexOf(u) : -1, S = l.layersWithOutsidePointerEventsDisabled.size > 0, P = w >= b, x = $j((A) => {
      const _ = A.target, N = [...l.branches].some((M) => M.contains(_));
      !P || N || (a == null || a(A), i == null || i(A), A.defaultPrevented || s == null || s());
    }, d), O = Ij((A) => {
      const _ = A.target;
      [...l.branches].some((M) => M.contains(_)) || (o == null || o(A), i == null || i(A), A.defaultPrevented || s == null || s());
    }, d);
    return Cj((A) => {
      w === l.layers.size - 1 && (n == null || n(A), !A.defaultPrevented && s && (A.preventDefault(), s()));
    }, d), v.useEffect(() => {
      if (u)
        return r && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (ib = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), sb(), () => {
          r && l.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = ib);
        };
    }, [u, d, r, l]), v.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), sb());
    }, [u, l]), v.useEffect(() => {
      const A = () => p({});
      return document.addEventListener(cv, A), () => document.removeEventListener(cv, A);
    }, []), /* @__PURE__ */ h(
      lE.div,
      {
        ...c,
        ref: g,
        style: {
          pointerEvents: S ? P ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: re(e.onFocusCapture, O.onFocusCapture),
        onBlurCapture: re(e.onBlurCapture, O.onBlurCapture),
        onPointerDownCapture: re(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
To.displayName = kj;
var Mj = "DismissableLayerBranch", Rj = v.forwardRef((e, t) => {
  const r = v.useContext(uE), n = v.useRef(null), a = me(t, n);
  return v.useEffect(() => {
    const o = n.current;
    if (o)
      return r.branches.add(o), () => {
        r.branches.delete(o);
      };
  }, [r.branches]), /* @__PURE__ */ h(lE.div, { ...e, ref: a });
});
Rj.displayName = Mj;
function $j(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = et(e), n = v.useRef(!1), a = v.useRef(() => {
  });
  return v.useEffect(() => {
    const o = (s) => {
      if (s.target && !n.current) {
        let c = function() {
          fE(
            Nj,
            r,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = c, t.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", o), t.removeEventListener("click", a.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function Ij(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = et(e), n = v.useRef(!1);
  return v.useEffect(() => {
    const a = (o) => {
      o.target && !n.current && fE(Tj, r, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function sb() {
  const e = new CustomEvent(cv);
  document.dispatchEvent(e);
}
function fE(e, t, r, { discrete: n }) {
  const a = r.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && a.addEventListener(e, t, { once: !0 }), n ? Ej(a, o) : a.dispatchEvent(o);
}
var $f = 0;
function hu() {
  v.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? cb()), document.body.insertAdjacentElement("beforeend", e[1] ?? cb()), $f++, () => {
      $f === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), $f--;
    };
  }, []);
}
function cb() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
// @__NO_SIDE_EFFECTS__
function Dj(e) {
  const t = /* @__PURE__ */ jj(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(Bj);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function jj(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = zj(a), s = Fj(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Lj = Symbol("radix.slottable");
function Bj(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Lj;
}
function Fj(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function zj(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var qj = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Wj = qj.reduce((e, t) => {
  const r = /* @__PURE__ */ Dj(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), If = "focusScope.autoFocusOnMount", Df = "focusScope.autoFocusOnUnmount", lb = { bubbles: !1, cancelable: !0 }, Hj = "FocusScope", _s = v.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: o,
    ...i
  } = e, [s, c] = v.useState(null), l = et(a), u = et(o), f = v.useRef(null), d = me(t, (m) => c(m)), p = v.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  v.useEffect(() => {
    if (n) {
      let m = function(S) {
        if (p.paused || !s) return;
        const P = S.target;
        s.contains(P) ? f.current = P : mn(f.current, { select: !0 });
      }, y = function(S) {
        if (p.paused || !s) return;
        const P = S.relatedTarget;
        P !== null && (s.contains(P) || mn(f.current, { select: !0 }));
      }, b = function(S) {
        if (document.activeElement === document.body)
          for (const x of S)
            x.removedNodes.length > 0 && mn(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", y);
      const w = new MutationObserver(b);
      return s && w.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", y), w.disconnect();
      };
    }
  }, [n, s, p.paused]), v.useEffect(() => {
    if (s) {
      fb.add(p);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const b = new CustomEvent(If, lb);
        s.addEventListener(If, l), s.dispatchEvent(b), b.defaultPrevented || (Vj(Xj(dE(s)), { select: !0 }), document.activeElement === m && mn(s));
      }
      return () => {
        s.removeEventListener(If, l), setTimeout(() => {
          const b = new CustomEvent(Df, lb);
          s.addEventListener(Df, u), s.dispatchEvent(b), b.defaultPrevented || mn(m ?? document.body, { select: !0 }), s.removeEventListener(Df, u), fb.remove(p);
        }, 0);
      };
    }
  }, [s, l, u, p]);
  const g = v.useCallback(
    (m) => {
      if (!r && !n || p.paused) return;
      const y = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, b = document.activeElement;
      if (y && b) {
        const w = m.currentTarget, [S, P] = Uj(w);
        S && P ? !m.shiftKey && b === P ? (m.preventDefault(), r && mn(S, { select: !0 })) : m.shiftKey && b === S && (m.preventDefault(), r && mn(P, { select: !0 })) : b === w && m.preventDefault();
      }
    },
    [r, n, p.paused]
  );
  return /* @__PURE__ */ h(Wj.div, { tabIndex: -1, ...i, ref: d, onKeyDown: g });
});
_s.displayName = Hj;
function Vj(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (mn(n, { select: t }), document.activeElement !== r) return;
}
function Uj(e) {
  const t = dE(e), r = ub(t, e), n = ub(t.reverse(), e);
  return [r, n];
}
function dE(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function ub(e, t) {
  for (const r of e)
    if (!Kj(r, { upTo: t })) return r;
}
function Kj(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Gj(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function mn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Gj(e) && t && e.select();
  }
}
var fb = Yj();
function Yj() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = db(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = db(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function db(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Xj(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Zj = v[" useId ".trim().toString()] || (() => {
}), Jj = 0;
function Ct(e) {
  const [t, r] = v.useState(Zj());
  return Ge(() => {
    r((n) => n ?? String(Jj++));
  }, [e]), t ? `radix-${t}` : "";
}
const Qj = ["top", "right", "bottom", "left"], _n = Math.min, jt = Math.max, Lc = Math.round, ec = Math.floor, kr = (e) => ({
  x: e,
  y: e
}), e5 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, t5 = {
  start: "end",
  end: "start"
};
function lv(e, t, r) {
  return jt(e, _n(t, r));
}
function Xr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Zr(e) {
  return e.split("-")[0];
}
function Mo(e) {
  return e.split("-")[1];
}
function dg(e) {
  return e === "x" ? "y" : "x";
}
function pg(e) {
  return e === "y" ? "height" : "width";
}
const r5 = /* @__PURE__ */ new Set(["top", "bottom"]);
function _r(e) {
  return r5.has(Zr(e)) ? "y" : "x";
}
function hg(e) {
  return dg(_r(e));
}
function n5(e, t, r) {
  r === void 0 && (r = !1);
  const n = Mo(e), a = hg(e), o = pg(a);
  let i = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (i = Bc(i)), [i, Bc(i)];
}
function a5(e) {
  const t = Bc(e);
  return [uv(e), t, uv(t)];
}
function uv(e) {
  return e.replace(/start|end/g, (t) => t5[t]);
}
const pb = ["left", "right"], hb = ["right", "left"], o5 = ["top", "bottom"], i5 = ["bottom", "top"];
function s5(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? hb : pb : t ? pb : hb;
    case "left":
    case "right":
      return t ? o5 : i5;
    default:
      return [];
  }
}
function c5(e, t, r, n) {
  const a = Mo(e);
  let o = s5(Zr(e), r === "start", n);
  return a && (o = o.map((i) => i + "-" + a), t && (o = o.concat(o.map(uv)))), o;
}
function Bc(e) {
  return e.replace(/left|right|bottom|top/g, (t) => e5[t]);
}
function l5(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function pE(e) {
  return typeof e != "number" ? l5(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Fc(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: a
  } = e;
  return {
    width: n,
    height: a,
    top: r,
    left: t,
    right: t + n,
    bottom: r + a,
    x: t,
    y: r
  };
}
function mb(e, t, r) {
  let {
    reference: n,
    floating: a
  } = e;
  const o = _r(t), i = hg(t), s = pg(i), c = Zr(t), l = o === "y", u = n.x + n.width / 2 - a.width / 2, f = n.y + n.height / 2 - a.height / 2, d = n[s] / 2 - a[s] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: u,
        y: n.y - a.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      p = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: n.x - a.width,
        y: f
      };
      break;
    default:
      p = {
        x: n.x,
        y: n.y
      };
  }
  switch (Mo(t)) {
    case "start":
      p[i] -= d * (r && l ? -1 : 1);
      break;
    case "end":
      p[i] += d * (r && l ? -1 : 1);
      break;
  }
  return p;
}
const u5 = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: o = [],
    platform: i
  } = r, s = o.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: u,
    y: f
  } = mb(l, n, c), d = n, p = {}, g = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: y,
      fn: b
    } = s[m], {
      x: w,
      y: S,
      data: P,
      reset: x
    } = await b({
      x: u,
      y: f,
      initialPlacement: n,
      placement: d,
      strategy: a,
      middlewareData: p,
      rects: l,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = w ?? u, f = S ?? f, p = {
      ...p,
      [y]: {
        ...p[y],
        ...P
      }
    }, x && g <= 50 && (g++, typeof x == "object" && (x.placement && (d = x.placement), x.rects && (l = x.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : x.rects), {
      x: u,
      y: f
    } = mb(l, d, c)), m = -1);
  }
  return {
    x: u,
    y: f,
    placement: d,
    strategy: a,
    middlewareData: p
  };
};
async function ki(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: a,
    platform: o,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: d = !1,
    padding: p = 0
  } = Xr(t, e), g = pE(p), y = s[d ? f === "floating" ? "reference" : "floating" : f], b = Fc(await o.getClippingRect({
    element: (r = await (o.isElement == null ? void 0 : o.isElement(y))) == null || r ? y : y.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), w = f === "floating" ? {
    x: n,
    y: a,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), P = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Fc(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: S,
    strategy: c
  }) : w);
  return {
    top: (b.top - x.top + g.top) / P.y,
    bottom: (x.bottom - b.bottom + g.bottom) / P.y,
    left: (b.left - x.left + g.left) / P.x,
    right: (x.right - b.right + g.right) / P.x
  };
}
const f5 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: o,
      platform: i,
      elements: s,
      middlewareData: c
    } = t, {
      element: l,
      padding: u = 0
    } = Xr(e, t) || {};
    if (l == null)
      return {};
    const f = pE(u), d = {
      x: r,
      y: n
    }, p = hg(a), g = pg(p), m = await i.getDimensions(l), y = p === "y", b = y ? "top" : "left", w = y ? "bottom" : "right", S = y ? "clientHeight" : "clientWidth", P = o.reference[g] + o.reference[p] - d[p] - o.floating[g], x = d[p] - o.reference[p], O = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l));
    let A = O ? O[S] : 0;
    (!A || !await (i.isElement == null ? void 0 : i.isElement(O))) && (A = s.floating[S] || o.floating[g]);
    const _ = P / 2 - x / 2, N = A / 2 - m[g] / 2 - 1, M = _n(f[b], N), T = _n(f[w], N), k = M, $ = A - m[g] - T, R = A / 2 - m[g] / 2 + _, L = lv(k, R, $), j = !c.arrow && Mo(a) != null && R !== L && o.reference[g] / 2 - (R < k ? M : T) - m[g] / 2 < 0, z = j ? R < k ? R - k : R - $ : 0;
    return {
      [p]: d[p] + z,
      data: {
        [p]: L,
        centerOffset: R - L - z,
        ...j && {
          alignmentOffset: z
        }
      },
      reset: j
    };
  }
}), d5 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: a,
        middlewareData: o,
        rects: i,
        initialPlacement: s,
        platform: c,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: d,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: m = !0,
        ...y
      } = Xr(e, t);
      if ((r = o.arrow) != null && r.alignmentOffset)
        return {};
      const b = Zr(a), w = _r(s), S = Zr(s) === s, P = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), x = d || (S || !m ? [Bc(s)] : a5(s)), O = g !== "none";
      !d && O && x.push(...c5(s, m, g, P));
      const A = [s, ...x], _ = await ki(t, y), N = [];
      let M = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (u && N.push(_[b]), f) {
        const R = n5(a, i, P);
        N.push(_[R[0]], _[R[1]]);
      }
      if (M = [...M, {
        placement: a,
        overflows: N
      }], !N.every((R) => R <= 0)) {
        var T, k;
        const R = (((T = o.flip) == null ? void 0 : T.index) || 0) + 1, L = A[R];
        if (L && (!(f === "alignment" ? w !== _r(L) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        M.every((q) => _r(q.placement) === w ? q.overflows[0] > 0 : !0)))
          return {
            data: {
              index: R,
              overflows: M
            },
            reset: {
              placement: L
            }
          };
        let j = (k = M.filter((z) => z.overflows[0] <= 0).sort((z, q) => z.overflows[1] - q.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!j)
          switch (p) {
            case "bestFit": {
              var $;
              const z = ($ = M.filter((q) => {
                if (O) {
                  const I = _r(q.placement);
                  return I === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  I === "y";
                }
                return !0;
              }).map((q) => [q.placement, q.overflows.filter((I) => I > 0).reduce((I, B) => I + B, 0)]).sort((q, I) => q[1] - I[1])[0]) == null ? void 0 : $[0];
              z && (j = z);
              break;
            }
            case "initialPlacement":
              j = s;
              break;
          }
        if (a !== j)
          return {
            reset: {
              placement: j
            }
          };
      }
      return {};
    }
  };
};
function vb(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function yb(e) {
  return Qj.some((t) => e[t] >= 0);
}
const p5 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...a
      } = Xr(e, t);
      switch (n) {
        case "referenceHidden": {
          const o = await ki(t, {
            ...a,
            elementContext: "reference"
          }), i = vb(o, r.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: yb(i)
            }
          };
        }
        case "escaped": {
          const o = await ki(t, {
            ...a,
            altBoundary: !0
          }), i = vb(o, r.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: yb(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, hE = /* @__PURE__ */ new Set(["left", "top"]);
async function h5(e, t) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = e, o = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), i = Zr(r), s = Mo(r), c = _r(r) === "y", l = hE.has(i) ? -1 : 1, u = o && c ? -1 : 1, f = Xr(t, e);
  let {
    mainAxis: d,
    crossAxis: p,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof g == "number" && (p = s === "end" ? g * -1 : g), c ? {
    x: p * u,
    y: d * l
  } : {
    x: d * l,
    y: p * u
  };
}
const m5 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: a,
        y: o,
        placement: i,
        middlewareData: s
      } = t, c = await h5(t, e);
      return i === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: a + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, v5 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: a
      } = t, {
        mainAxis: o = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: b,
              y: w
            } = y;
            return {
              x: b,
              y: w
            };
          }
        },
        ...c
      } = Xr(e, t), l = {
        x: r,
        y: n
      }, u = await ki(t, c), f = _r(Zr(a)), d = dg(f);
      let p = l[d], g = l[f];
      if (o) {
        const y = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", w = p + u[y], S = p - u[b];
        p = lv(w, p, S);
      }
      if (i) {
        const y = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", w = g + u[y], S = g - u[b];
        g = lv(w, g, S);
      }
      const m = s.fn({
        ...t,
        [d]: p,
        [f]: g
      });
      return {
        ...m,
        data: {
          x: m.x - r,
          y: m.y - n,
          enabled: {
            [d]: o,
            [f]: i
          }
        }
      };
    }
  };
}, y5 = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: a,
        rects: o,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = Xr(e, t), u = {
        x: r,
        y: n
      }, f = _r(a), d = dg(f);
      let p = u[d], g = u[f];
      const m = Xr(s, t), y = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (c) {
        const S = d === "y" ? "height" : "width", P = o.reference[d] - o.floating[S] + y.mainAxis, x = o.reference[d] + o.reference[S] - y.mainAxis;
        p < P ? p = P : p > x && (p = x);
      }
      if (l) {
        var b, w;
        const S = d === "y" ? "width" : "height", P = hE.has(Zr(a)), x = o.reference[f] - o.floating[S] + (P && ((b = i.offset) == null ? void 0 : b[f]) || 0) + (P ? 0 : y.crossAxis), O = o.reference[f] + o.reference[S] + (P ? 0 : ((w = i.offset) == null ? void 0 : w[f]) || 0) - (P ? y.crossAxis : 0);
        g < x ? g = x : g > O && (g = O);
      }
      return {
        [d]: p,
        [f]: g
      };
    }
  };
}, g5 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: a,
        rects: o,
        platform: i,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...l
      } = Xr(e, t), u = await ki(t, l), f = Zr(a), d = Mo(a), p = _r(a) === "y", {
        width: g,
        height: m
      } = o.floating;
      let y, b;
      f === "top" || f === "bottom" ? (y = f, b = d === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = f, y = d === "end" ? "top" : "bottom");
      const w = m - u.top - u.bottom, S = g - u.left - u.right, P = _n(m - u[y], w), x = _n(g - u[b], S), O = !t.middlewareData.shift;
      let A = P, _ = x;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (_ = S), (n = t.middlewareData.shift) != null && n.enabled.y && (A = w), O && !d) {
        const M = jt(u.left, 0), T = jt(u.right, 0), k = jt(u.top, 0), $ = jt(u.bottom, 0);
        p ? _ = g - 2 * (M !== 0 || T !== 0 ? M + T : jt(u.left, u.right)) : A = m - 2 * (k !== 0 || $ !== 0 ? k + $ : jt(u.top, u.bottom));
      }
      await c({
        ...t,
        availableWidth: _,
        availableHeight: A
      });
      const N = await i.getDimensions(s.floating);
      return g !== N.width || m !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function mu() {
  return typeof window < "u";
}
function Ro(e) {
  return mE(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Bt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ir(e) {
  var t;
  return (t = (mE(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function mE(e) {
  return mu() ? e instanceof Node || e instanceof Bt(e).Node : !1;
}
function vr(e) {
  return mu() ? e instanceof Element || e instanceof Bt(e).Element : !1;
}
function Mr(e) {
  return mu() ? e instanceof HTMLElement || e instanceof Bt(e).HTMLElement : !1;
}
function gb(e) {
  return !mu() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Bt(e).ShadowRoot;
}
const b5 = /* @__PURE__ */ new Set(["inline", "contents"]);
function Es(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: a
  } = yr(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !b5.has(a);
}
const x5 = /* @__PURE__ */ new Set(["table", "td", "th"]);
function w5(e) {
  return x5.has(Ro(e));
}
const S5 = [":popover-open", ":modal"];
function vu(e) {
  return S5.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const O5 = ["transform", "translate", "scale", "rotate", "perspective"], P5 = ["transform", "translate", "scale", "rotate", "perspective", "filter"], A5 = ["paint", "layout", "strict", "content"];
function mg(e) {
  const t = vg(), r = vr(e) ? yr(e) : e;
  return O5.some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || P5.some((n) => (r.willChange || "").includes(n)) || A5.some((n) => (r.contain || "").includes(n));
}
function _5(e) {
  let t = En(e);
  for (; Mr(t) && !Va(t); ) {
    if (mg(t))
      return t;
    if (vu(t))
      return null;
    t = En(t);
  }
  return null;
}
function vg() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const E5 = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Va(e) {
  return E5.has(Ro(e));
}
function yr(e) {
  return Bt(e).getComputedStyle(e);
}
function yu(e) {
  return vr(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function En(e) {
  if (Ro(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    gb(e) && e.host || // Fallback.
    Ir(e)
  );
  return gb(t) ? t.host : t;
}
function vE(e) {
  const t = En(e);
  return Va(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Mr(t) && Es(t) ? t : vE(t);
}
function Ni(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const a = vE(e), o = a === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Bt(a);
  if (o) {
    const s = fv(i);
    return t.concat(i, i.visualViewport || [], Es(a) ? a : [], s && r ? Ni(s) : []);
  }
  return t.concat(a, Ni(a, [], r));
}
function fv(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function yE(e) {
  const t = yr(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const a = Mr(e), o = a ? e.offsetWidth : r, i = a ? e.offsetHeight : n, s = Lc(r) !== o || Lc(n) !== i;
  return s && (r = o, n = i), {
    width: r,
    height: n,
    $: s
  };
}
function yg(e) {
  return vr(e) ? e : e.contextElement;
}
function Ba(e) {
  const t = yg(e);
  if (!Mr(t))
    return kr(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: a,
    $: o
  } = yE(t);
  let i = (o ? Lc(r.width) : r.width) / n, s = (o ? Lc(r.height) : r.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const C5 = /* @__PURE__ */ kr(0);
function gE(e) {
  const t = Bt(e);
  return !vg() || !t.visualViewport ? C5 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function k5(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== Bt(e) ? !1 : t;
}
function oa(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), o = yg(e);
  let i = kr(1);
  t && (n ? vr(n) && (i = Ba(n)) : i = Ba(e));
  const s = k5(o, r, n) ? gE(o) : kr(0);
  let c = (a.left + s.x) / i.x, l = (a.top + s.y) / i.y, u = a.width / i.x, f = a.height / i.y;
  if (o) {
    const d = Bt(o), p = n && vr(n) ? Bt(n) : n;
    let g = d, m = fv(g);
    for (; m && n && p !== g; ) {
      const y = Ba(m), b = m.getBoundingClientRect(), w = yr(m), S = b.left + (m.clientLeft + parseFloat(w.paddingLeft)) * y.x, P = b.top + (m.clientTop + parseFloat(w.paddingTop)) * y.y;
      c *= y.x, l *= y.y, u *= y.x, f *= y.y, c += S, l += P, g = Bt(m), m = fv(g);
    }
  }
  return Fc({
    width: u,
    height: f,
    x: c,
    y: l
  });
}
function gu(e, t) {
  const r = yu(e).scrollLeft;
  return t ? t.left + r : oa(Ir(e)).left + r;
}
function bE(e, t) {
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - gu(e, r), a = r.top + t.scrollTop;
  return {
    x: n,
    y: a
  };
}
function N5(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: a
  } = e;
  const o = a === "fixed", i = Ir(n), s = t ? vu(t.floating) : !1;
  if (n === i || s && o)
    return r;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = kr(1);
  const u = kr(0), f = Mr(n);
  if ((f || !f && !o) && ((Ro(n) !== "body" || Es(i)) && (c = yu(n)), Mr(n))) {
    const p = oa(n);
    l = Ba(n), u.x = p.x + n.clientLeft, u.y = p.y + n.clientTop;
  }
  const d = i && !f && !o ? bE(i, c) : kr(0);
  return {
    width: r.width * l.x,
    height: r.height * l.y,
    x: r.x * l.x - c.scrollLeft * l.x + u.x + d.x,
    y: r.y * l.y - c.scrollTop * l.y + u.y + d.y
  };
}
function T5(e) {
  return Array.from(e.getClientRects());
}
function M5(e) {
  const t = Ir(e), r = yu(e), n = e.ownerDocument.body, a = jt(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), o = jt(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -r.scrollLeft + gu(e);
  const s = -r.scrollTop;
  return yr(n).direction === "rtl" && (i += jt(t.clientWidth, n.clientWidth) - a), {
    width: a,
    height: o,
    x: i,
    y: s
  };
}
const bb = 25;
function R5(e, t) {
  const r = Bt(e), n = Ir(e), a = r.visualViewport;
  let o = n.clientWidth, i = n.clientHeight, s = 0, c = 0;
  if (a) {
    o = a.width, i = a.height;
    const u = vg();
    (!u || u && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  const l = gu(n);
  if (l <= 0) {
    const u = n.ownerDocument, f = u.body, d = getComputedStyle(f), p = u.compatMode === "CSS1Compat" && parseFloat(d.marginLeft) + parseFloat(d.marginRight) || 0, g = Math.abs(n.clientWidth - f.clientWidth - p);
    g <= bb && (o -= g);
  } else l <= bb && (o += l);
  return {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
const $5 = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function I5(e, t) {
  const r = oa(e, !0, t === "fixed"), n = r.top + e.clientTop, a = r.left + e.clientLeft, o = Mr(e) ? Ba(e) : kr(1), i = e.clientWidth * o.x, s = e.clientHeight * o.y, c = a * o.x, l = n * o.y;
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function xb(e, t, r) {
  let n;
  if (t === "viewport")
    n = R5(e, r);
  else if (t === "document")
    n = M5(Ir(e));
  else if (vr(t))
    n = I5(t, r);
  else {
    const a = gE(e);
    n = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return Fc(n);
}
function xE(e, t) {
  const r = En(e);
  return r === t || !vr(r) || Va(r) ? !1 : yr(r).position === "fixed" || xE(r, t);
}
function D5(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = Ni(e, [], !1).filter((s) => vr(s) && Ro(s) !== "body"), a = null;
  const o = yr(e).position === "fixed";
  let i = o ? En(e) : e;
  for (; vr(i) && !Va(i); ) {
    const s = yr(i), c = mg(i);
    !c && s.position === "fixed" && (a = null), (o ? !c && !a : !c && s.position === "static" && !!a && $5.has(a.position) || Es(i) && !c && xE(e, i)) ? n = n.filter((u) => u !== i) : a = s, i = En(i);
  }
  return t.set(e, n), n;
}
function j5(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = e;
  const i = [...r === "clippingAncestors" ? vu(t) ? [] : D5(t, this._c) : [].concat(r), n], s = i[0], c = i.reduce((l, u) => {
    const f = xb(t, u, a);
    return l.top = jt(f.top, l.top), l.right = _n(f.right, l.right), l.bottom = _n(f.bottom, l.bottom), l.left = jt(f.left, l.left), l;
  }, xb(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function L5(e) {
  const {
    width: t,
    height: r
  } = yE(e);
  return {
    width: t,
    height: r
  };
}
function B5(e, t, r) {
  const n = Mr(t), a = Ir(t), o = r === "fixed", i = oa(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = kr(0);
  function l() {
    c.x = gu(a);
  }
  if (n || !n && !o)
    if ((Ro(t) !== "body" || Es(a)) && (s = yu(t)), n) {
      const p = oa(t, !0, o, t);
      c.x = p.x + t.clientLeft, c.y = p.y + t.clientTop;
    } else a && l();
  o && !n && a && l();
  const u = a && !n && !o ? bE(a, s) : kr(0), f = i.left + s.scrollLeft - c.x - u.x, d = i.top + s.scrollTop - c.y - u.y;
  return {
    x: f,
    y: d,
    width: i.width,
    height: i.height
  };
}
function jf(e) {
  return yr(e).position === "static";
}
function wb(e, t) {
  if (!Mr(e) || yr(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return Ir(e) === r && (r = r.ownerDocument.body), r;
}
function wE(e, t) {
  const r = Bt(e);
  if (vu(e))
    return r;
  if (!Mr(e)) {
    let a = En(e);
    for (; a && !Va(a); ) {
      if (vr(a) && !jf(a))
        return a;
      a = En(a);
    }
    return r;
  }
  let n = wb(e, t);
  for (; n && w5(n) && jf(n); )
    n = wb(n, t);
  return n && Va(n) && jf(n) && !mg(n) ? r : n || _5(e) || r;
}
const F5 = async function(e) {
  const t = this.getOffsetParent || wE, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: B5(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function z5(e) {
  return yr(e).direction === "rtl";
}
const q5 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: N5,
  getDocumentElement: Ir,
  getClippingRect: j5,
  getOffsetParent: wE,
  getElementRects: F5,
  getClientRects: T5,
  getDimensions: L5,
  getScale: Ba,
  isElement: vr,
  isRTL: z5
};
function SE(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function W5(e, t) {
  let r = null, n;
  const a = Ir(e);
  function o() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), o();
    const l = e.getBoundingClientRect(), {
      left: u,
      top: f,
      width: d,
      height: p
    } = l;
    if (s || t(), !d || !p)
      return;
    const g = ec(f), m = ec(a.clientWidth - (u + d)), y = ec(a.clientHeight - (f + p)), b = ec(u), S = {
      rootMargin: -g + "px " + -m + "px " + -y + "px " + -b + "px",
      threshold: jt(0, _n(1, c)) || 1
    };
    let P = !0;
    function x(O) {
      const A = O[0].intersectionRatio;
      if (A !== c) {
        if (!P)
          return i();
        A ? i(!1, A) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      A === 1 && !SE(l, e.getBoundingClientRect()) && i(), P = !1;
    }
    try {
      r = new IntersectionObserver(x, {
        ...S,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(x, S);
    }
    r.observe(e);
  }
  return i(!0), o;
}
function H5(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, l = yg(e), u = a || o ? [...l ? Ni(l) : [], ...Ni(t)] : [];
  u.forEach((b) => {
    a && b.addEventListener("scroll", r, {
      passive: !0
    }), o && b.addEventListener("resize", r);
  });
  const f = l && s ? W5(l, r) : null;
  let d = -1, p = null;
  i && (p = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === l && p && (p.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var S;
      (S = p) == null || S.observe(t);
    })), r();
  }), l && !c && p.observe(l), p.observe(t));
  let g, m = c ? oa(e) : null;
  c && y();
  function y() {
    const b = oa(e);
    m && !SE(m, b) && r(), m = b, g = requestAnimationFrame(y);
  }
  return r(), () => {
    var b;
    u.forEach((w) => {
      a && w.removeEventListener("scroll", r), o && w.removeEventListener("resize", r);
    }), f == null || f(), (b = p) == null || b.disconnect(), p = null, c && cancelAnimationFrame(g);
  };
}
const V5 = m5, U5 = v5, K5 = d5, G5 = g5, Y5 = p5, Sb = f5, X5 = y5, Z5 = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: q5,
    ...r
  }, o = {
    ...a.platform,
    _c: n
  };
  return u5(e, t, {
    ...a,
    platform: o
  });
};
var J5 = typeof document < "u", Q5 = function() {
}, Ac = J5 ? d$ : Q5;
function zc(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!zc(e[n], t[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const o = a[n];
      if (!(o === "_owner" && e.$$typeof) && !zc(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function OE(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ob(e, t) {
  const r = OE(e);
  return Math.round(t * r) / r;
}
function Lf(e) {
  const t = v.useRef(e);
  return Ac(() => {
    t.current = e;
  }), t;
}
function e4(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: o,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, f] = v.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [d, p] = v.useState(n);
  zc(d, n) || p(n);
  const [g, m] = v.useState(null), [y, b] = v.useState(null), w = v.useCallback((q) => {
    q !== O.current && (O.current = q, m(q));
  }, []), S = v.useCallback((q) => {
    q !== A.current && (A.current = q, b(q));
  }, []), P = o || g, x = i || y, O = v.useRef(null), A = v.useRef(null), _ = v.useRef(u), N = c != null, M = Lf(c), T = Lf(a), k = Lf(l), $ = v.useCallback(() => {
    if (!O.current || !A.current)
      return;
    const q = {
      placement: t,
      strategy: r,
      middleware: d
    };
    T.current && (q.platform = T.current), Z5(O.current, A.current, q).then((I) => {
      const B = {
        ...I,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      R.current && !zc(_.current, B) && (_.current = B, xs.flushSync(() => {
        f(B);
      }));
    });
  }, [d, t, r, T, k]);
  Ac(() => {
    l === !1 && _.current.isPositioned && (_.current.isPositioned = !1, f((q) => ({
      ...q,
      isPositioned: !1
    })));
  }, [l]);
  const R = v.useRef(!1);
  Ac(() => (R.current = !0, () => {
    R.current = !1;
  }), []), Ac(() => {
    if (P && (O.current = P), x && (A.current = x), P && x) {
      if (M.current)
        return M.current(P, x, $);
      $();
    }
  }, [P, x, $, M, N]);
  const L = v.useMemo(() => ({
    reference: O,
    floating: A,
    setReference: w,
    setFloating: S
  }), [w, S]), j = v.useMemo(() => ({
    reference: P,
    floating: x
  }), [P, x]), z = v.useMemo(() => {
    const q = {
      position: r,
      left: 0,
      top: 0
    };
    if (!j.floating)
      return q;
    const I = Ob(j.floating, u.x), B = Ob(j.floating, u.y);
    return s ? {
      ...q,
      transform: "translate(" + I + "px, " + B + "px)",
      ...OE(j.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: I,
      top: B
    };
  }, [r, s, j.floating, u.x, u.y]);
  return v.useMemo(() => ({
    ...u,
    update: $,
    refs: L,
    elements: j,
    floatingStyles: z
  }), [u, $, L, j, z]);
}
const t4 = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: a
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? Sb({
        element: n.current,
        padding: a
      }).fn(r) : {} : n ? Sb({
        element: n,
        padding: a
      }).fn(r) : {};
    }
  };
}, r4 = (e, t) => ({
  ...V5(e),
  options: [e, t]
}), n4 = (e, t) => ({
  ...U5(e),
  options: [e, t]
}), a4 = (e, t) => ({
  ...X5(e),
  options: [e, t]
}), o4 = (e, t) => ({
  ...K5(e),
  options: [e, t]
}), i4 = (e, t) => ({
  ...G5(e),
  options: [e, t]
}), s4 = (e, t) => ({
  ...Y5(e),
  options: [e, t]
}), c4 = (e, t) => ({
  ...t4(e),
  options: [e, t]
});
// @__NO_SIDE_EFFECTS__
function l4(e) {
  const t = /* @__PURE__ */ u4(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(d4);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function u4(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = h4(a), s = p4(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var f4 = Symbol("radix.slottable");
function d4(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === f4;
}
function p4(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function h4(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var m4 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], v4 = m4.reduce((e, t) => {
  const r = /* @__PURE__ */ l4(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), y4 = "Arrow", PE = v.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: a = 5, ...o } = e;
  return /* @__PURE__ */ h(
    v4.svg,
    {
      ...o,
      ref: t,
      width: n,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ h("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
PE.displayName = y4;
var g4 = PE;
function b4(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, x4(a, ...t)];
}
function x4(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function w4(e) {
  const t = /* @__PURE__ */ S4(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(P4);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function S4(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = _4(a), s = A4(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var O4 = Symbol("radix.slottable");
function P4(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === O4;
}
function A4(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function _4(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var E4 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], AE = E4.reduce((e, t) => {
  const r = /* @__PURE__ */ w4(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), gg = "Popper", [_E, kn] = b4(gg), [C4, EE] = _E(gg), CE = (e) => {
  const { __scopePopper: t, children: r } = e, [n, a] = v.useState(null);
  return /* @__PURE__ */ h(C4, { scope: t, anchor: n, onAnchorChange: a, children: r });
};
CE.displayName = gg;
var kE = "PopperAnchor", NE = v.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...a } = e, o = EE(kE, r), i = v.useRef(null), s = me(t, i), c = v.useRef(null);
    return v.useEffect(() => {
      const l = c.current;
      c.current = (n == null ? void 0 : n.current) || i.current, l !== c.current && o.onAnchorChange(c.current);
    }), n ? null : /* @__PURE__ */ h(AE.div, { ...a, ref: s });
  }
);
NE.displayName = kE;
var bg = "PopperContent", [k4, N4] = _E(bg), TE = v.forwardRef(
  (e, t) => {
    var G, te, V, Y, Q, D;
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: a = 0,
      align: o = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: d = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: g,
      ...m
    } = e, y = EE(bg, r), [b, w] = v.useState(null), S = me(t, (le) => w(le)), [P, x] = v.useState(null), O = ig(P), A = (O == null ? void 0 : O.width) ?? 0, _ = (O == null ? void 0 : O.height) ?? 0, N = n + (o !== "center" ? "-" + o : ""), M = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, T = Array.isArray(l) ? l : [l], k = T.length > 0, $ = {
      padding: M,
      boundary: T.filter(M4),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: k
    }, { refs: R, floatingStyles: L, placement: j, isPositioned: z, middlewareData: q } = e4({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...le) => H5(...le, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        r4({ mainAxis: a + _, alignmentAxis: i }),
        c && n4({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? a4() : void 0,
          ...$
        }),
        c && o4({ ...$ }),
        i4({
          ...$,
          apply: ({ elements: le, rects: Z, availableWidth: ve, availableHeight: ye }) => {
            const { width: Ie, height: Ot } = Z.reference, Tt = le.floating.style;
            Tt.setProperty("--radix-popper-available-width", `${ve}px`), Tt.setProperty("--radix-popper-available-height", `${ye}px`), Tt.setProperty("--radix-popper-anchor-width", `${Ie}px`), Tt.setProperty("--radix-popper-anchor-height", `${Ot}px`);
          }
        }),
        P && c4({ element: P, padding: s }),
        R4({ arrowWidth: A, arrowHeight: _ }),
        d && s4({ strategy: "referenceHidden", ...$ })
      ]
    }), [I, B] = $E(j), W = et(g);
    Ge(() => {
      z && (W == null || W());
    }, [z, W]);
    const H = (G = q.arrow) == null ? void 0 : G.x, U = (te = q.arrow) == null ? void 0 : te.y, X = ((V = q.arrow) == null ? void 0 : V.centerOffset) !== 0, [ee, ne] = v.useState();
    return Ge(() => {
      b && ne(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ h(
      "div",
      {
        ref: R.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...L,
          transform: z ? L.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ee,
          "--radix-popper-transform-origin": [
            (Y = q.transformOrigin) == null ? void 0 : Y.x,
            (Q = q.transformOrigin) == null ? void 0 : Q.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((D = q.hide) == null ? void 0 : D.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ h(
          k4,
          {
            scope: r,
            placedSide: I,
            onArrowChange: x,
            arrowX: H,
            arrowY: U,
            shouldHideArrow: X,
            children: /* @__PURE__ */ h(
              AE.div,
              {
                "data-side": I,
                "data-align": B,
                ...m,
                ref: S,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: z ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
TE.displayName = bg;
var ME = "PopperArrow", T4 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, RE = v.forwardRef(function(t, r) {
  const { __scopePopper: n, ...a } = t, o = N4(ME, n), i = T4[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ h(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ h(
          g4,
          {
            ...a,
            ref: r,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
RE.displayName = ME;
function M4(e) {
  return e !== null;
}
var R4 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, b, w;
    const { placement: r, rects: n, middlewareData: a } = t, i = ((y = a.arrow) == null ? void 0 : y.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, c = i ? 0 : e.arrowHeight, [l, u] = $E(r), f = { start: "0%", center: "50%", end: "100%" }[u], d = (((b = a.arrow) == null ? void 0 : b.x) ?? 0) + s / 2, p = (((w = a.arrow) == null ? void 0 : w.y) ?? 0) + c / 2;
    let g = "", m = "";
    return l === "bottom" ? (g = i ? f : `${d}px`, m = `${-c}px`) : l === "top" ? (g = i ? f : `${d}px`, m = `${n.floating.height + c}px`) : l === "right" ? (g = `${-c}px`, m = i ? f : `${p}px`) : l === "left" && (g = `${n.floating.width + c}px`, m = i ? f : `${p}px`), { data: { x: g, y: m } };
  }
});
function $E(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var Cs = CE, ks = NE, bu = TE, xu = RE;
// @__NO_SIDE_EFFECTS__
function $4(e) {
  const t = /* @__PURE__ */ I4(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(j4);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function I4(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = B4(a), s = L4(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var D4 = Symbol("radix.slottable");
function j4(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === D4;
}
function L4(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function B4(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var F4 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], z4 = F4.reduce((e, t) => {
  const r = /* @__PURE__ */ $4(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), q4 = "Portal", $o = v.forwardRef((e, t) => {
  var s;
  const { container: r, ...n } = e, [a, o] = v.useState(!1);
  Ge(() => o(!0), []);
  const i = r || a && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? v_.createPortal(/* @__PURE__ */ h(z4.div, { ...n, ref: t }), i) : null;
});
$o.displayName = q4;
// @__NO_SIDE_EFFECTS__
function IE(e) {
  const t = /* @__PURE__ */ W4(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(V4);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function W4(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = K4(a), s = U4(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var H4 = Symbol("radix.slottable");
function V4(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === H4;
}
function U4(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function K4(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var G4 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], zt = G4.reduce((e, t) => {
  const r = /* @__PURE__ */ IE(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
// @__NO_SIDE_EFFECTS__
function Y4(e) {
  const t = /* @__PURE__ */ X4(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(J4);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function X4(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = eL(a), s = Q4(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Z4 = Symbol("radix.slottable");
function J4(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Z4;
}
function Q4(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function eL(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var tL = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], rL = tL.reduce((e, t) => {
  const r = /* @__PURE__ */ Y4(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), DE = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), nL = "VisuallyHidden", jE = v.forwardRef(
  (e, t) => /* @__PURE__ */ h(
    rL.span,
    {
      ...e,
      ref: t,
      style: { ...DE, ...e.style }
    }
  )
);
jE.displayName = nL;
var aL = jE, oL = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Sa = /* @__PURE__ */ new WeakMap(), tc = /* @__PURE__ */ new WeakMap(), rc = {}, Bf = 0, LE = function(e) {
  return e && (e.host || LE(e.parentNode));
}, iL = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = LE(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, sL = function(e, t, r, n) {
  var a = iL(t, Array.isArray(e) ? e : [e]);
  rc[r] || (rc[r] = /* @__PURE__ */ new WeakMap());
  var o = rc[r], i = [], s = /* @__PURE__ */ new Set(), c = new Set(a), l = function(f) {
    !f || s.has(f) || (s.add(f), l(f.parentNode));
  };
  a.forEach(l);
  var u = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(d) {
      if (s.has(d))
        u(d);
      else
        try {
          var p = d.getAttribute(n), g = p !== null && p !== "false", m = (Sa.get(d) || 0) + 1, y = (o.get(d) || 0) + 1;
          Sa.set(d, m), o.set(d, y), i.push(d), m === 1 && g && tc.set(d, !0), y === 1 && d.setAttribute(r, "true"), g || d.setAttribute(n, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", d, b);
        }
    });
  };
  return u(t), s.clear(), Bf++, function() {
    i.forEach(function(f) {
      var d = Sa.get(f) - 1, p = o.get(f) - 1;
      Sa.set(f, d), o.set(f, p), d || (tc.has(f) || f.removeAttribute(n), tc.delete(f)), p || f.removeAttribute(r);
    }), Bf--, Bf || (Sa = /* @__PURE__ */ new WeakMap(), Sa = /* @__PURE__ */ new WeakMap(), tc = /* @__PURE__ */ new WeakMap(), rc = {});
  };
}, wu = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = oL(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live], script"))), sL(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, Or = function() {
  return Or = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, Or.apply(this, arguments);
};
function BE(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function cL(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, o; n < a; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var _c = "right-scroll-bar-position", Ec = "width-before-scroll-bar", lL = "with-scroll-bars-hidden", uL = "--removed-body-scroll-bar-size";
function Ff(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function fL(e, t) {
  var r = pr(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var dL = typeof window < "u" ? v.useLayoutEffect : v.useEffect, Pb = /* @__PURE__ */ new WeakMap();
function pL(e, t) {
  var r = fL(null, function(n) {
    return e.forEach(function(a) {
      return Ff(a, n);
    });
  });
  return dL(function() {
    var n = Pb.get(r);
    if (n) {
      var a = new Set(n), o = new Set(e), i = r.current;
      a.forEach(function(s) {
        o.has(s) || Ff(s, null);
      }), o.forEach(function(s) {
        a.has(s) || Ff(s, i);
      });
    }
    Pb.set(r, e);
  }, [e]), r;
}
function hL(e) {
  return e;
}
function mL(e, t) {
  t === void 0 && (t = hL);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(o) {
      var i = t(o, n);
      return r.push(i), function() {
        r = r.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (n = !0; r.length; ) {
        var i = r;
        r = [], i.forEach(o);
      }
      r = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(o) {
      n = !0;
      var i = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(o), i = r;
      }
      var c = function() {
        var u = i;
        i = [], u.forEach(o);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), r = {
        push: function(u) {
          i.push(u), l();
        },
        filter: function(u) {
          return i = i.filter(u), r;
        }
      };
    }
  };
  return a;
}
function vL(e) {
  e === void 0 && (e = {});
  var t = mL(null);
  return t.options = Or({ async: !0, ssr: !1 }, e), t;
}
var FE = function(e) {
  var t = e.sideCar, r = BE(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return v.createElement(n, Or({}, r));
};
FE.isSideCarExport = !0;
function yL(e, t) {
  return e.useMedium(t), FE;
}
var zE = vL(), zf = function() {
}, Su = v.forwardRef(function(e, t) {
  var r = v.useRef(null), n = v.useState({
    onScrollCapture: zf,
    onWheelCapture: zf,
    onTouchMoveCapture: zf
  }), a = n[0], o = n[1], i = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, f = e.shards, d = e.sideCar, p = e.noRelative, g = e.noIsolation, m = e.inert, y = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, S = e.gapMode, P = BE(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = d, O = pL([r, t]), A = Or(Or({}, P), a);
  return v.createElement(
    v.Fragment,
    null,
    u && v.createElement(x, { sideCar: zE, removeScrollBar: l, shards: f, noRelative: p, noIsolation: g, inert: m, setCallbacks: o, allowPinchZoom: !!y, lockRef: r, gapMode: S }),
    i ? v.cloneElement(v.Children.only(s), Or(Or({}, A), { ref: O })) : v.createElement(w, Or({}, A, { className: c, ref: O }), s)
  );
});
Su.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Su.classNames = {
  fullWidth: Ec,
  zeroRight: _c
};
var gL = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function bL() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = gL();
  return t && e.setAttribute("nonce", t), e;
}
function xL(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function wL(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var SL = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = bL()) && (xL(t, r), wL(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, OL = function() {
  var e = SL();
  return function(t, r) {
    v.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, qE = function() {
  var e = OL(), t = function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  };
  return t;
}, PL = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, qf = function(e) {
  return parseInt(e || "", 10) || 0;
}, AL = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [qf(r), qf(n), qf(a)];
}, _L = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return PL;
  var t = AL(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, EL = qE(), Fa = "data-scroll-locked", CL = function(e, t, r, n) {
  var a = e.left, o = e.top, i = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(lL, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body[`).concat(Fa, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(_c, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(Ec, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(_c, " .").concat(_c, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Ec, " .").concat(Ec, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(Fa, `] {
    `).concat(uL, ": ").concat(s, `px;
  }
`);
}, Ab = function() {
  var e = parseInt(document.body.getAttribute(Fa) || "0", 10);
  return isFinite(e) ? e : 0;
}, kL = function() {
  v.useEffect(function() {
    return document.body.setAttribute(Fa, (Ab() + 1).toString()), function() {
      var e = Ab() - 1;
      e <= 0 ? document.body.removeAttribute(Fa) : document.body.setAttribute(Fa, e.toString());
    };
  }, []);
}, NL = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n;
  kL();
  var o = v.useMemo(function() {
    return _L(a);
  }, [a]);
  return v.createElement(EL, { styles: CL(o, !t, a, r ? "" : "!important") });
}, dv = !1;
if (typeof window < "u")
  try {
    var nc = Object.defineProperty({}, "passive", {
      get: function() {
        return dv = !0, !0;
      }
    });
    window.addEventListener("test", nc, nc), window.removeEventListener("test", nc, nc);
  } catch {
    dv = !1;
  }
var Oa = dv ? { passive: !1 } : !1, TL = function(e) {
  return e.tagName === "TEXTAREA";
}, WE = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !TL(e) && r[t] === "visible")
  );
}, ML = function(e) {
  return WE(e, "overflowY");
}, RL = function(e) {
  return WE(e, "overflowX");
}, _b = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = HE(e, n);
    if (a) {
      var o = VE(e, n), i = o[1], s = o[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, $L = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, IL = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, HE = function(e, t) {
  return e === "v" ? ML(t) : RL(t);
}, VE = function(e, t) {
  return e === "v" ? $L(t) : IL(t);
}, DL = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, jL = function(e, t, r, n, a) {
  var o = DL(e, window.getComputedStyle(t).direction), i = o * n, s = r.target, c = t.contains(s), l = !1, u = i > 0, f = 0, d = 0;
  do {
    if (!s)
      break;
    var p = VE(e, s), g = p[0], m = p[1], y = p[2], b = m - y - o * g;
    (g || b) && HE(e, s) && (f += b, d += g);
    var w = s.parentNode;
    s = w && w.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? w.host : w;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(d) < 1) && (l = !0), l;
}, ac = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Eb = function(e) {
  return [e.deltaX, e.deltaY];
}, Cb = function(e) {
  return e && "current" in e ? e.current : e;
}, LL = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, BL = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, FL = 0, Pa = [];
function zL(e) {
  var t = v.useRef([]), r = v.useRef([0, 0]), n = v.useRef(), a = v.useState(FL++)[0], o = v.useState(qE)[0], i = v.useRef(e);
  v.useEffect(function() {
    i.current = e;
  }, [e]), v.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var m = cL([e.lockRef.current], (e.shards || []).map(Cb), !0).filter(Boolean);
      return m.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), m.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = v.useCallback(function(m, y) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var b = ac(m), w = r.current, S = "deltaX" in m ? m.deltaX : w[0] - b[0], P = "deltaY" in m ? m.deltaY : w[1] - b[1], x, O = m.target, A = Math.abs(S) > Math.abs(P) ? "h" : "v";
    if ("touches" in m && A === "h" && O.type === "range")
      return !1;
    var _ = window.getSelection(), N = _ && _.anchorNode, M = N ? N === O || N.contains(O) : !1;
    if (M)
      return !1;
    var T = _b(A, O);
    if (!T)
      return !0;
    if (T ? x = A : (x = A === "v" ? "h" : "v", T = _b(A, O)), !T)
      return !1;
    if (!n.current && "changedTouches" in m && (S || P) && (n.current = x), !x)
      return !0;
    var k = n.current || x;
    return jL(k, y, m, k === "h" ? S : P);
  }, []), c = v.useCallback(function(m) {
    var y = m;
    if (!(!Pa.length || Pa[Pa.length - 1] !== o)) {
      var b = "deltaY" in y ? Eb(y) : ac(y), w = t.current.filter(function(x) {
        return x.name === y.type && (x.target === y.target || y.target === x.shadowParent) && LL(x.delta, b);
      })[0];
      if (w && w.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!w) {
        var S = (i.current.shards || []).map(Cb).filter(Boolean).filter(function(x) {
          return x.contains(y.target);
        }), P = S.length > 0 ? s(y, S[0]) : !i.current.noIsolation;
        P && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = v.useCallback(function(m, y, b, w) {
    var S = { name: m, delta: y, target: b, should: w, shadowParent: qL(b) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== S;
      });
    }, 1);
  }, []), u = v.useCallback(function(m) {
    r.current = ac(m), n.current = void 0;
  }, []), f = v.useCallback(function(m) {
    l(m.type, Eb(m), m.target, s(m, e.lockRef.current));
  }, []), d = v.useCallback(function(m) {
    l(m.type, ac(m), m.target, s(m, e.lockRef.current));
  }, []);
  v.useEffect(function() {
    return Pa.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", c, Oa), document.addEventListener("touchmove", c, Oa), document.addEventListener("touchstart", u, Oa), function() {
      Pa = Pa.filter(function(m) {
        return m !== o;
      }), document.removeEventListener("wheel", c, Oa), document.removeEventListener("touchmove", c, Oa), document.removeEventListener("touchstart", u, Oa);
    };
  }, []);
  var p = e.removeScrollBar, g = e.inert;
  return v.createElement(
    v.Fragment,
    null,
    g ? v.createElement(o, { styles: BL(a) }) : null,
    p ? v.createElement(NL, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function qL(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const WL = yL(zE, zL);
var Ns = v.forwardRef(function(e, t) {
  return v.createElement(Su, Or({}, e, { ref: t, sideCar: WL }));
});
Ns.classNames = Su.classNames;
var HL = [" ", "Enter", "ArrowUp", "ArrowDown"], VL = [" ", "Enter"], ia = "Select", [Ou, Pu, UL] = fg(ia), [Io] = yj(ia, [
  UL,
  kn
]), Au = kn(), [KL, Nn] = Io(ia), [GL, YL] = Io(ia), UE = (e) => {
  const {
    __scopeSelect: t,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: o,
    value: i,
    defaultValue: s,
    onValueChange: c,
    dir: l,
    name: u,
    autoComplete: f,
    disabled: d,
    required: p,
    form: g
  } = e, m = Au(t), [y, b] = v.useState(null), [w, S] = v.useState(null), [P, x] = v.useState(!1), O = As(l), [A, _] = mr({
    prop: n,
    defaultProp: a ?? !1,
    onChange: o,
    caller: ia
  }), [N, M] = mr({
    prop: i,
    defaultProp: s,
    onChange: c,
    caller: ia
  }), T = v.useRef(null), k = y ? g || !!y.closest("form") : !0, [$, R] = v.useState(/* @__PURE__ */ new Set()), L = Array.from($).map((j) => j.props.value).join(";");
  return /* @__PURE__ */ h(Cs, { ...m, children: /* @__PURE__ */ C(
    KL,
    {
      required: p,
      scope: t,
      trigger: y,
      onTriggerChange: b,
      valueNode: w,
      onValueNodeChange: S,
      valueNodeHasChildren: P,
      onValueNodeHasChildrenChange: x,
      contentId: Ct(),
      value: N,
      onValueChange: M,
      open: A,
      onOpenChange: _,
      dir: O,
      triggerPointerDownPosRef: T,
      disabled: d,
      children: [
        /* @__PURE__ */ h(Ou.Provider, { scope: t, children: /* @__PURE__ */ h(
          GL,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: v.useCallback((j) => {
              R((z) => new Set(z).add(j));
            }, []),
            onNativeOptionRemove: v.useCallback((j) => {
              R((z) => {
                const q = new Set(z);
                return q.delete(j), q;
              });
            }, []),
            children: r
          }
        ) }),
        k ? /* @__PURE__ */ C(
          y2,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: u,
            autoComplete: f,
            value: N,
            onChange: (j) => M(j.target.value),
            disabled: d,
            form: g,
            children: [
              N === void 0 ? /* @__PURE__ */ h("option", { value: "" }) : null,
              Array.from($)
            ]
          },
          L
        ) : null
      ]
    }
  ) });
};
UE.displayName = ia;
var KE = "SelectTrigger", GE = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, disabled: n = !1, ...a } = e, o = Au(r), i = Nn(KE, r), s = i.disabled || n, c = me(t, i.onTriggerChange), l = Pu(r), u = v.useRef("touch"), [f, d, p] = b2((m) => {
      const y = l().filter((S) => !S.disabled), b = y.find((S) => S.value === i.value), w = x2(y, m, b);
      w !== void 0 && i.onValueChange(w.value);
    }), g = (m) => {
      s || (i.onOpenChange(!0), p()), m && (i.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ h(ks, { asChild: !0, ...o, children: /* @__PURE__ */ h(
      zt.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": g2(i.value) ? "" : void 0,
        ...a,
        ref: c,
        onClick: re(a.onClick, (m) => {
          m.currentTarget.focus(), u.current !== "mouse" && g(m);
        }),
        onPointerDown: re(a.onPointerDown, (m) => {
          u.current = m.pointerType;
          const y = m.target;
          y.hasPointerCapture(m.pointerId) && y.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (g(m), m.preventDefault());
        }),
        onKeyDown: re(a.onKeyDown, (m) => {
          const y = f.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && d(m.key), !(y && m.key === " ") && HL.includes(m.key) && (g(), m.preventDefault());
        })
      }
    ) });
  }
);
GE.displayName = KE;
var YE = "SelectValue", XE = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: a, children: o, placeholder: i = "", ...s } = e, c = Nn(YE, r), { onValueNodeHasChildrenChange: l } = c, u = o !== void 0, f = me(t, c.onValueNodeChange);
    return Ge(() => {
      l(u);
    }, [l, u]), /* @__PURE__ */ h(
      zt.span,
      {
        ...s,
        ref: f,
        style: { pointerEvents: "none" },
        children: g2(c.value) ? /* @__PURE__ */ h(Ve, { children: i }) : o
      }
    );
  }
);
XE.displayName = YE;
var XL = "SelectIcon", ZE = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, children: n, ...a } = e;
    return /* @__PURE__ */ h(zt.span, { "aria-hidden": !0, ...a, ref: t, children: n || "▼" });
  }
);
ZE.displayName = XL;
var ZL = "SelectPortal", JE = (e) => /* @__PURE__ */ h($o, { asChild: !0, ...e });
JE.displayName = ZL;
var sa = "SelectContent", QE = v.forwardRef(
  (e, t) => {
    const r = Nn(sa, e.__scopeSelect), [n, a] = v.useState();
    if (Ge(() => {
      a(new DocumentFragment());
    }, []), !r.open) {
      const o = n;
      return o ? xs.createPortal(
        /* @__PURE__ */ h(e2, { scope: e.__scopeSelect, children: /* @__PURE__ */ h(Ou.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ h("div", { children: e.children }) }) }),
        o
      ) : null;
    }
    return /* @__PURE__ */ h(t2, { ...e, ref: t });
  }
);
QE.displayName = sa;
var lr = 10, [e2, Tn] = Io(sa), JL = "SelectContentImpl", QL = /* @__PURE__ */ IE("SelectContent.RemoveScroll"), t2 = v.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      position: n = "item-aligned",
      onCloseAutoFocus: a,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: c,
      align: l,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: d,
      collisionPadding: p,
      sticky: g,
      hideWhenDetached: m,
      avoidCollisions: y,
      //
      ...b
    } = e, w = Nn(sa, r), [S, P] = v.useState(null), [x, O] = v.useState(null), A = me(t, (G) => P(G)), [_, N] = v.useState(null), [M, T] = v.useState(
      null
    ), k = Pu(r), [$, R] = v.useState(!1), L = v.useRef(!1);
    v.useEffect(() => {
      if (S) return wu(S);
    }, [S]), hu();
    const j = v.useCallback(
      (G) => {
        const [te, ...V] = k().map((D) => D.ref.current), [Y] = V.slice(-1), Q = document.activeElement;
        for (const D of G)
          if (D === Q || (D == null || D.scrollIntoView({ block: "nearest" }), D === te && x && (x.scrollTop = 0), D === Y && x && (x.scrollTop = x.scrollHeight), D == null || D.focus(), document.activeElement !== Q)) return;
      },
      [k, x]
    ), z = v.useCallback(
      () => j([_, S]),
      [j, _, S]
    );
    v.useEffect(() => {
      $ && z();
    }, [$, z]);
    const { onOpenChange: q, triggerPointerDownPosRef: I } = w;
    v.useEffect(() => {
      if (S) {
        let G = { x: 0, y: 0 };
        const te = (Y) => {
          var Q, D;
          G = {
            x: Math.abs(Math.round(Y.pageX) - (((Q = I.current) == null ? void 0 : Q.x) ?? 0)),
            y: Math.abs(Math.round(Y.pageY) - (((D = I.current) == null ? void 0 : D.y) ?? 0))
          };
        }, V = (Y) => {
          G.x <= 10 && G.y <= 10 ? Y.preventDefault() : S.contains(Y.target) || q(!1), document.removeEventListener("pointermove", te), I.current = null;
        };
        return I.current !== null && (document.addEventListener("pointermove", te), document.addEventListener("pointerup", V, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", te), document.removeEventListener("pointerup", V, { capture: !0 });
        };
      }
    }, [S, q, I]), v.useEffect(() => {
      const G = () => q(!1);
      return window.addEventListener("blur", G), window.addEventListener("resize", G), () => {
        window.removeEventListener("blur", G), window.removeEventListener("resize", G);
      };
    }, [q]);
    const [B, W] = b2((G) => {
      const te = k().filter((Q) => !Q.disabled), V = te.find((Q) => Q.ref.current === document.activeElement), Y = x2(te, G, V);
      Y && setTimeout(() => Y.ref.current.focus());
    }), H = v.useCallback(
      (G, te, V) => {
        const Y = !L.current && !V;
        (w.value !== void 0 && w.value === te || Y) && (N(G), Y && (L.current = !0));
      },
      [w.value]
    ), U = v.useCallback(() => S == null ? void 0 : S.focus(), [S]), X = v.useCallback(
      (G, te, V) => {
        const Y = !L.current && !V;
        (w.value !== void 0 && w.value === te || Y) && T(G);
      },
      [w.value]
    ), ee = n === "popper" ? pv : r2, ne = ee === pv ? {
      side: s,
      sideOffset: c,
      align: l,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: d,
      collisionPadding: p,
      sticky: g,
      hideWhenDetached: m,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ h(
      e2,
      {
        scope: r,
        content: S,
        viewport: x,
        onViewportChange: O,
        itemRefCallback: H,
        selectedItem: _,
        onItemLeave: U,
        itemTextRefCallback: X,
        focusSelectedItem: z,
        selectedItemText: M,
        position: n,
        isPositioned: $,
        searchRef: B,
        children: /* @__PURE__ */ h(Ns, { as: QL, allowPinchZoom: !0, children: /* @__PURE__ */ h(
          _s,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (G) => {
              G.preventDefault();
            },
            onUnmountAutoFocus: re(a, (G) => {
              var te;
              (te = w.trigger) == null || te.focus({ preventScroll: !0 }), G.preventDefault();
            }),
            children: /* @__PURE__ */ h(
              To,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: o,
                onPointerDownOutside: i,
                onFocusOutside: (G) => G.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ h(
                  ee,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (G) => G.preventDefault(),
                    ...b,
                    ...ne,
                    onPlaced: () => R(!0),
                    ref: A,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: re(b.onKeyDown, (G) => {
                      const te = G.ctrlKey || G.altKey || G.metaKey;
                      if (G.key === "Tab" && G.preventDefault(), !te && G.key.length === 1 && W(G.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(G.key)) {
                        let Y = k().filter((Q) => !Q.disabled).map((Q) => Q.ref.current);
                        if (["ArrowUp", "End"].includes(G.key) && (Y = Y.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(G.key)) {
                          const Q = G.target, D = Y.indexOf(Q);
                          Y = Y.slice(D + 1);
                        }
                        setTimeout(() => j(Y)), G.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
t2.displayName = JL;
var e3 = "SelectItemAlignedPosition", r2 = v.forwardRef((e, t) => {
  const { __scopeSelect: r, onPlaced: n, ...a } = e, o = Nn(sa, r), i = Tn(sa, r), [s, c] = v.useState(null), [l, u] = v.useState(null), f = me(t, (A) => u(A)), d = Pu(r), p = v.useRef(!1), g = v.useRef(!0), { viewport: m, selectedItem: y, selectedItemText: b, focusSelectedItem: w } = i, S = v.useCallback(() => {
    if (o.trigger && o.valueNode && s && l && m && y && b) {
      const A = o.trigger.getBoundingClientRect(), _ = l.getBoundingClientRect(), N = o.valueNode.getBoundingClientRect(), M = b.getBoundingClientRect();
      if (o.dir !== "rtl") {
        const Q = M.left - _.left, D = N.left - Q, le = A.left - D, Z = A.width + le, ve = Math.max(Z, _.width), ye = window.innerWidth - lr, Ie = sv(D, [
          lr,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(lr, ye - ve)
        ]);
        s.style.minWidth = Z + "px", s.style.left = Ie + "px";
      } else {
        const Q = _.right - M.right, D = window.innerWidth - N.right - Q, le = window.innerWidth - A.right - D, Z = A.width + le, ve = Math.max(Z, _.width), ye = window.innerWidth - lr, Ie = sv(D, [
          lr,
          Math.max(lr, ye - ve)
        ]);
        s.style.minWidth = Z + "px", s.style.right = Ie + "px";
      }
      const T = d(), k = window.innerHeight - lr * 2, $ = m.scrollHeight, R = window.getComputedStyle(l), L = parseInt(R.borderTopWidth, 10), j = parseInt(R.paddingTop, 10), z = parseInt(R.borderBottomWidth, 10), q = parseInt(R.paddingBottom, 10), I = L + j + $ + q + z, B = Math.min(y.offsetHeight * 5, I), W = window.getComputedStyle(m), H = parseInt(W.paddingTop, 10), U = parseInt(W.paddingBottom, 10), X = A.top + A.height / 2 - lr, ee = k - X, ne = y.offsetHeight / 2, G = y.offsetTop + ne, te = L + j + G, V = I - te;
      if (te <= X) {
        const Q = T.length > 0 && y === T[T.length - 1].ref.current;
        s.style.bottom = "0px";
        const D = l.clientHeight - m.offsetTop - m.offsetHeight, le = Math.max(
          ee,
          ne + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Q ? U : 0) + D + z
        ), Z = te + le;
        s.style.height = Z + "px";
      } else {
        const Q = T.length > 0 && y === T[0].ref.current;
        s.style.top = "0px";
        const le = Math.max(
          X,
          L + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Q ? H : 0) + ne
        ) + V;
        s.style.height = le + "px", m.scrollTop = te - X + m.offsetTop;
      }
      s.style.margin = `${lr}px 0`, s.style.minHeight = B + "px", s.style.maxHeight = k + "px", n == null || n(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    d,
    o.trigger,
    o.valueNode,
    s,
    l,
    m,
    y,
    b,
    o.dir,
    n
  ]);
  Ge(() => S(), [S]);
  const [P, x] = v.useState();
  Ge(() => {
    l && x(window.getComputedStyle(l).zIndex);
  }, [l]);
  const O = v.useCallback(
    (A) => {
      A && g.current === !0 && (S(), w == null || w(), g.current = !1);
    },
    [S, w]
  );
  return /* @__PURE__ */ h(
    r3,
    {
      scope: r,
      contentWrapper: s,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: O,
      children: /* @__PURE__ */ h(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: P
          },
          children: /* @__PURE__ */ h(
            zt.div,
            {
              ...a,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...a.style
              }
            }
          )
        }
      )
    }
  );
});
r2.displayName = e3;
var t3 = "SelectPopperPosition", pv = v.forwardRef((e, t) => {
  const {
    __scopeSelect: r,
    align: n = "start",
    collisionPadding: a = lr,
    ...o
  } = e, i = Au(r);
  return /* @__PURE__ */ h(
    bu,
    {
      ...i,
      ...o,
      ref: t,
      align: n,
      collisionPadding: a,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...o.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
pv.displayName = t3;
var [r3, xg] = Io(sa, {}), hv = "SelectViewport", n2 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, nonce: n, ...a } = e, o = Tn(hv, r), i = xg(hv, r), s = me(t, o.onViewportChange), c = v.useRef(0);
    return /* @__PURE__ */ C(Ve, { children: [
      /* @__PURE__ */ h(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ h(Ou.Slot, { scope: r, children: /* @__PURE__ */ h(
        zt.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...a,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...a.style
          },
          onScroll: re(a.onScroll, (l) => {
            const u = l.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: d } = i;
            if (d != null && d.current && f) {
              const p = Math.abs(c.current - u.scrollTop);
              if (p > 0) {
                const g = window.innerHeight - lr * 2, m = parseFloat(f.style.minHeight), y = parseFloat(f.style.height), b = Math.max(m, y);
                if (b < g) {
                  const w = b + p, S = Math.min(g, w), P = w - S;
                  f.style.height = S + "px", f.style.bottom === "0px" && (u.scrollTop = P > 0 ? P : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
n2.displayName = hv;
var a2 = "SelectGroup", [n3, a3] = Io(a2), o2 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, a = Ct();
    return /* @__PURE__ */ h(n3, { scope: r, id: a, children: /* @__PURE__ */ h(zt.div, { role: "group", "aria-labelledby": a, ...n, ref: t }) });
  }
);
o2.displayName = a2;
var i2 = "SelectLabel", s2 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, a = a3(i2, r);
    return /* @__PURE__ */ h(zt.div, { id: a.id, ...n, ref: t });
  }
);
s2.displayName = i2;
var qc = "SelectItem", [o3, c2] = Io(qc), l2 = v.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      value: n,
      disabled: a = !1,
      textValue: o,
      ...i
    } = e, s = Nn(qc, r), c = Tn(qc, r), l = s.value === n, [u, f] = v.useState(o ?? ""), [d, p] = v.useState(!1), g = me(
      t,
      (w) => {
        var S;
        return (S = c.itemRefCallback) == null ? void 0 : S.call(c, w, n, a);
      }
    ), m = Ct(), y = v.useRef("touch"), b = () => {
      a || (s.onValueChange(n), s.onOpenChange(!1));
    };
    if (n === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ h(
      o3,
      {
        scope: r,
        value: n,
        disabled: a,
        textId: m,
        isSelected: l,
        onItemTextChange: v.useCallback((w) => {
          f((S) => S || ((w == null ? void 0 : w.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ h(
          Ou.ItemSlot,
          {
            scope: r,
            value: n,
            disabled: a,
            textValue: u,
            children: /* @__PURE__ */ h(
              zt.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": d ? "" : void 0,
                "aria-selected": l && d,
                "data-state": l ? "checked" : "unchecked",
                "aria-disabled": a || void 0,
                "data-disabled": a ? "" : void 0,
                tabIndex: a ? void 0 : -1,
                ...i,
                ref: g,
                onFocus: re(i.onFocus, () => p(!0)),
                onBlur: re(i.onBlur, () => p(!1)),
                onClick: re(i.onClick, () => {
                  y.current !== "mouse" && b();
                }),
                onPointerUp: re(i.onPointerUp, () => {
                  y.current === "mouse" && b();
                }),
                onPointerDown: re(i.onPointerDown, (w) => {
                  y.current = w.pointerType;
                }),
                onPointerMove: re(i.onPointerMove, (w) => {
                  var S;
                  y.current = w.pointerType, a ? (S = c.onItemLeave) == null || S.call(c) : y.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: re(i.onPointerLeave, (w) => {
                  var S;
                  w.currentTarget === document.activeElement && ((S = c.onItemLeave) == null || S.call(c));
                }),
                onKeyDown: re(i.onKeyDown, (w) => {
                  var P;
                  ((P = c.searchRef) == null ? void 0 : P.current) !== "" && w.key === " " || (VL.includes(w.key) && b(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
l2.displayName = qc;
var ui = "SelectItemText", u2 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: a, ...o } = e, i = Nn(ui, r), s = Tn(ui, r), c = c2(ui, r), l = YL(ui, r), [u, f] = v.useState(null), d = me(
      t,
      (b) => f(b),
      c.onItemTextChange,
      (b) => {
        var w;
        return (w = s.itemTextRefCallback) == null ? void 0 : w.call(s, b, c.value, c.disabled);
      }
    ), p = u == null ? void 0 : u.textContent, g = v.useMemo(
      () => /* @__PURE__ */ h("option", { value: c.value, disabled: c.disabled, children: p }, c.value),
      [c.disabled, c.value, p]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: y } = l;
    return Ge(() => (m(g), () => y(g)), [m, y, g]), /* @__PURE__ */ C(Ve, { children: [
      /* @__PURE__ */ h(zt.span, { id: c.textId, ...o, ref: d }),
      c.isSelected && i.valueNode && !i.valueNodeHasChildren ? xs.createPortal(o.children, i.valueNode) : null
    ] });
  }
);
u2.displayName = ui;
var f2 = "SelectItemIndicator", d2 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return c2(f2, r).isSelected ? /* @__PURE__ */ h(zt.span, { "aria-hidden": !0, ...n, ref: t }) : null;
  }
);
d2.displayName = f2;
var mv = "SelectScrollUpButton", p2 = v.forwardRef((e, t) => {
  const r = Tn(mv, e.__scopeSelect), n = xg(mv, e.__scopeSelect), [a, o] = v.useState(!1), i = me(t, n.onScrollButtonChange);
  return Ge(() => {
    if (r.viewport && r.isPositioned) {
      let s = function() {
        const l = c.scrollTop > 0;
        o(l);
      };
      const c = r.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [r.viewport, r.isPositioned]), a ? /* @__PURE__ */ h(
    m2,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = r;
        s && c && (s.scrollTop = s.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
p2.displayName = mv;
var vv = "SelectScrollDownButton", h2 = v.forwardRef((e, t) => {
  const r = Tn(vv, e.__scopeSelect), n = xg(vv, e.__scopeSelect), [a, o] = v.useState(!1), i = me(t, n.onScrollButtonChange);
  return Ge(() => {
    if (r.viewport && r.isPositioned) {
      let s = function() {
        const l = c.scrollHeight - c.clientHeight, u = Math.ceil(c.scrollTop) < l;
        o(u);
      };
      const c = r.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [r.viewport, r.isPositioned]), a ? /* @__PURE__ */ h(
    m2,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = r;
        s && c && (s.scrollTop = s.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
h2.displayName = vv;
var m2 = v.forwardRef((e, t) => {
  const { __scopeSelect: r, onAutoScroll: n, ...a } = e, o = Tn("SelectScrollButton", r), i = v.useRef(null), s = Pu(r), c = v.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return v.useEffect(() => () => c(), [c]), Ge(() => {
    var u;
    const l = s().find((f) => f.ref.current === document.activeElement);
    (u = l == null ? void 0 : l.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ h(
    zt.div,
    {
      "aria-hidden": !0,
      ...a,
      ref: t,
      style: { flexShrink: 0, ...a.style },
      onPointerDown: re(a.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerMove: re(a.onPointerMove, () => {
        var l;
        (l = o.onItemLeave) == null || l.call(o), i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerLeave: re(a.onPointerLeave, () => {
        c();
      })
    }
  );
}), i3 = "SelectSeparator", v2 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return /* @__PURE__ */ h(zt.div, { "aria-hidden": !0, ...n, ref: t });
  }
);
v2.displayName = i3;
var yv = "SelectArrow", s3 = v.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, a = Au(r), o = Nn(yv, r), i = Tn(yv, r);
    return o.open && i.position === "popper" ? /* @__PURE__ */ h(xu, { ...a, ...n, ref: t }) : null;
  }
);
s3.displayName = yv;
var c3 = "SelectBubbleInput", y2 = v.forwardRef(
  ({ __scopeSelect: e, value: t, ...r }, n) => {
    const a = v.useRef(null), o = me(n, a), i = og(t);
    return v.useEffect(() => {
      const s = a.current;
      if (!s) return;
      const c = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (i !== t && u) {
        const f = new Event("change", { bubbles: !0 });
        u.call(s, t), s.dispatchEvent(f);
      }
    }, [i, t]), /* @__PURE__ */ h(
      zt.select,
      {
        ...r,
        style: { ...DE, ...r.style },
        ref: o,
        defaultValue: t
      }
    );
  }
);
y2.displayName = c3;
function g2(e) {
  return e === "" || e === void 0;
}
function b2(e) {
  const t = et(e), r = v.useRef(""), n = v.useRef(0), a = v.useCallback(
    (i) => {
      const s = r.current + i;
      t(s), (function c(l) {
        r.current = l, window.clearTimeout(n.current), l !== "" && (n.current = window.setTimeout(() => c(""), 1e3));
      })(s);
    },
    [t]
  ), o = v.useCallback(() => {
    r.current = "", window.clearTimeout(n.current);
  }, []);
  return v.useEffect(() => () => window.clearTimeout(n.current), []), [r, a, o];
}
function x2(e, t, r) {
  const a = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, o = r ? e.indexOf(r) : -1;
  let i = l3(e, Math.max(o, 0));
  a.length === 1 && (i = i.filter((l) => l !== r));
  const c = i.find(
    (l) => l.textValue.toLowerCase().startsWith(a.toLowerCase())
  );
  return c !== r ? c : void 0;
}
function l3(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var u3 = UE, f3 = GE, d3 = XE, p3 = ZE, h3 = JE, m3 = QE, v3 = n2, y3 = o2, g3 = s2, b3 = l2, x3 = u2, w3 = d2, S3 = p2, O3 = h2, P3 = v2;
const fce = u3, dce = y3, pce = d3, A3 = Ye(
  "flex w-full items-center justify-between rounded-md border border-stone-300 bg-transparent text-stone-900 placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-stone-700 dark:text-stone-100 [&>span]:line-clamp-1",
  {
    variants: {
      size: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4 text-sm",
        lg: "h-12 px-4 text-base"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), _3 = v.forwardRef(({ className: e, children: t, size: r, ...n }, a) => /* @__PURE__ */ C(
  f3,
  {
    ref: a,
    className: F(A3({ size: r, className: e })),
    ...n,
    children: [
      t,
      /* @__PURE__ */ h(p3, { asChild: !0, children: /* @__PURE__ */ h(Yr, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
_3.displayName = "SelectTrigger";
const w2 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  S3,
  {
    ref: r,
    className: F(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ h(S_, { className: "h-4 w-4" })
  }
));
w2.displayName = "SelectScrollUpButton";
const S2 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  O3,
  {
    ref: r,
    className: F(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ h(Yr, { className: "h-4 w-4" })
  }
));
S2.displayName = "SelectScrollDownButton";
const E3 = v.forwardRef(({ className: e, children: t, position: r = "popper", ...n }, a) => /* @__PURE__ */ h(h3, { children: /* @__PURE__ */ C(
  m3,
  {
    ref: a,
    className: F(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border border-stone-200 bg-white text-stone-900 shadow-md dark:border-stone-700 dark:bg-stone-900 dark:text-stone-100",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      r === "popper" && "w-full min-w-[var(--radix-select-trigger-width)]",
      e
    ),
    position: r,
    ...n,
    children: [
      /* @__PURE__ */ h(w2, {}),
      /* @__PURE__ */ h(
        v3,
        {
          className: F(
            "p-1",
            r === "popper" && "h-[var(--radix-select-content-available-height)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ h(S2, {})
    ]
  }
) }));
E3.displayName = "SelectContent";
const C3 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  g3,
  {
    ref: r,
    className: F(
      "py-1.5 pl-8 pr-2 text-sm font-semibold text-stone-900 dark:text-stone-100",
      e
    ),
    ...t
  }
));
C3.displayName = "SelectLabel";
const k3 = v.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ C(
  b3,
  {
    ref: n,
    className: F(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm text-stone-900 outline-none focus:bg-stone-100 focus:text-stone-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:text-stone-100 dark:focus:bg-stone-800 dark:focus:text-stone-100",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ h("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ h(w3, { children: /* @__PURE__ */ h(ha, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ h(x3, { children: t })
    ]
  }
));
k3.displayName = "SelectItem";
const N3 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  P3,
  {
    ref: r,
    className: F("-mx-1 my-1 h-px bg-stone-200 dark:bg-stone-700", e),
    ...t
  }
));
N3.displayName = "SelectSeparator";
function T3(e, t) {
  const r = v.createContext(t), n = (o) => {
    const { children: i, ...s } = o, c = v.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ h(r.Provider, { value: c, children: i });
  };
  n.displayName = e + "Provider";
  function a(o) {
    const i = v.useContext(r);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [n, a];
}
function M3(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, R3(a, ...t)];
}
function R3(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function O2(e) {
  const t = /* @__PURE__ */ $3(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(D3);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function $3(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = L3(a), s = j3(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var I3 = Symbol("radix.slottable");
function D3(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === I3;
}
function j3(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function L3(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var B3 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ts = B3.reduce((e, t) => {
  const r = /* @__PURE__ */ O2(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), _u = "Dialog", [P2] = M3(_u), [F3, br] = P2(_u), A2 = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: o,
    modal: i = !0
  } = e, s = v.useRef(null), c = v.useRef(null), [l, u] = mr({
    prop: n,
    defaultProp: a ?? !1,
    onChange: o,
    caller: _u
  });
  return /* @__PURE__ */ h(
    F3,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: Ct(),
      titleId: Ct(),
      descriptionId: Ct(),
      open: l,
      onOpenChange: u,
      onOpenToggle: v.useCallback(() => u((f) => !f), [u]),
      modal: i,
      children: r
    }
  );
};
A2.displayName = _u;
var _2 = "DialogTrigger", E2 = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = br(_2, r), o = me(t, a.triggerRef);
    return /* @__PURE__ */ h(
      Ts.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": Og(a.open),
        ...n,
        ref: o,
        onClick: re(e.onClick, a.onOpenToggle)
      }
    );
  }
);
E2.displayName = _2;
var wg = "DialogPortal", [z3, C2] = P2(wg, {
  forceMount: void 0
}), k2 = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: a } = e, o = br(wg, t);
  return /* @__PURE__ */ h(z3, { scope: t, forceMount: r, children: v.Children.map(n, (i) => /* @__PURE__ */ h(ot, { present: r || o.open, children: /* @__PURE__ */ h($o, { asChild: !0, container: a, children: i }) })) });
};
k2.displayName = wg;
var Wc = "DialogOverlay", N2 = v.forwardRef(
  (e, t) => {
    const r = C2(Wc, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, o = br(Wc, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ h(ot, { present: n || o.open, children: /* @__PURE__ */ h(W3, { ...a, ref: t }) }) : null;
  }
);
N2.displayName = Wc;
var q3 = /* @__PURE__ */ O2("DialogOverlay.RemoveScroll"), W3 = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = br(Wc, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ h(Ns, { as: q3, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ h(
        Ts.div,
        {
          "data-state": Og(a.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), ca = "DialogContent", T2 = v.forwardRef(
  (e, t) => {
    const r = C2(ca, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, o = br(ca, e.__scopeDialog);
    return /* @__PURE__ */ h(ot, { present: n || o.open, children: o.modal ? /* @__PURE__ */ h(H3, { ...a, ref: t }) : /* @__PURE__ */ h(V3, { ...a, ref: t }) });
  }
);
T2.displayName = ca;
var H3 = v.forwardRef(
  (e, t) => {
    const r = br(ca, e.__scopeDialog), n = v.useRef(null), a = me(t, r.contentRef, n);
    return v.useEffect(() => {
      const o = n.current;
      if (o) return wu(o);
    }, []), /* @__PURE__ */ h(
      M2,
      {
        ...e,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: re(e.onCloseAutoFocus, (o) => {
          var i;
          o.preventDefault(), (i = r.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: re(e.onPointerDownOutside, (o) => {
          const i = o.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: re(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), V3 = v.forwardRef(
  (e, t) => {
    const r = br(ca, e.__scopeDialog), n = v.useRef(!1), a = v.useRef(!1);
    return /* @__PURE__ */ h(
      M2,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, o), o.defaultPrevented || (n.current || (s = r.triggerRef.current) == null || s.focus(), o.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (o) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (n.current = !0, o.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const i = o.target;
          ((l = r.triggerRef.current) == null ? void 0 : l.contains(i)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && a.current && o.preventDefault();
        }
      }
    );
  }
), M2 = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: o, ...i } = e, s = br(ca, r), c = v.useRef(null), l = me(t, c);
    return hu(), /* @__PURE__ */ C(Ve, { children: [
      /* @__PURE__ */ h(
        _s,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: a,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ h(
            To,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Og(s.open),
              ...i,
              ref: l,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ C(Ve, { children: [
        /* @__PURE__ */ h(U3, { titleId: s.titleId }),
        /* @__PURE__ */ h(G3, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Sg = "DialogTitle", R2 = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = br(Sg, r);
    return /* @__PURE__ */ h(Ts.h2, { id: a.titleId, ...n, ref: t });
  }
);
R2.displayName = Sg;
var $2 = "DialogDescription", I2 = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = br($2, r);
    return /* @__PURE__ */ h(Ts.p, { id: a.descriptionId, ...n, ref: t });
  }
);
I2.displayName = $2;
var D2 = "DialogClose", j2 = v.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, a = br(D2, r);
    return /* @__PURE__ */ h(
      Ts.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: re(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
j2.displayName = D2;
function Og(e) {
  return e ? "open" : "closed";
}
var L2 = "DialogTitleWarning", [hce, B2] = T3(L2, {
  contentName: ca,
  titleName: Sg,
  docsSlug: "dialog"
}), U3 = ({ titleId: e }) => {
  const t = B2(L2), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return v.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, K3 = "DialogDescriptionWarning", G3 = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${B2(K3).contentName}}.`;
  return v.useEffect(() => {
    var o;
    const a = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && a && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, F2 = A2, z2 = E2, q2 = k2, Eu = N2, Cu = T2, ku = R2, Nu = I2, Tu = j2;
const Y3 = F2, mce = z2, X3 = q2, vce = Tu, W2 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  Eu,
  {
    ref: r,
    className: F(
      "fixed inset-0 z-50 bg-black/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
W2.displayName = Eu.displayName;
const H2 = v.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ C(X3, { children: [
  /* @__PURE__ */ h(W2, {}),
  /* @__PURE__ */ C(
    Cu,
    {
      ref: n,
      className: F(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-stone-200 bg-white p-6 shadow-lg duration-200 sm:rounded-lg dark:border-stone-700 dark:bg-stone-900 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
        e
      ),
      ...r,
      children: [
        t,
        /* @__PURE__ */ C(Tu, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-stone-100 dark:ring-offset-stone-900 dark:data-[state=open]:bg-stone-800", children: [
          /* @__PURE__ */ h(An, { className: "h-4 w-4 text-stone-900 dark:text-stone-100" }),
          /* @__PURE__ */ h("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
H2.displayName = Cu.displayName;
const V2 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ h(
  "div",
  {
    className: F(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
V2.displayName = "DialogHeader";
const U2 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ h(
  "div",
  {
    className: F(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
U2.displayName = "DialogFooter";
const K2 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  ku,
  {
    ref: r,
    className: F(
      "text-lg font-semibold leading-none tracking-tight text-stone-900 dark:text-stone-100",
      e
    ),
    ...t
  }
));
K2.displayName = ku.displayName;
const G2 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  Nu,
  {
    ref: r,
    className: F(
      "text-sm text-stone-500 dark:text-stone-400",
      e
    ),
    ...t
  }
));
G2.displayName = Nu.displayName;
function Z3(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, J3(a, ...t)];
}
function J3(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function Q3(e) {
  const t = /* @__PURE__ */ e6(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(r6);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function e6(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = a6(a), s = n6(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Y2 = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function t6(e) {
  const t = ({ children: r }) => /* @__PURE__ */ h(Ve, { children: r });
  return t.displayName = `${e}.Slottable`, t.__radixId = Y2, t;
}
function r6(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Y2;
}
function n6(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function a6(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var o6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], i6 = o6.reduce((e, t) => {
  const r = /* @__PURE__ */ Q3(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), [Mu] = Z3("Tooltip", [
  kn
]), Ru = kn(), X2 = "TooltipProvider", s6 = 700, gv = "tooltip.open", [c6, Pg] = Mu(X2), Z2 = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: r = s6,
    skipDelayDuration: n = 300,
    disableHoverableContent: a = !1,
    children: o
  } = e, i = v.useRef(!0), s = v.useRef(!1), c = v.useRef(0);
  return v.useEffect(() => {
    const l = c.current;
    return () => window.clearTimeout(l);
  }, []), /* @__PURE__ */ h(
    c6,
    {
      scope: t,
      isOpenDelayedRef: i,
      delayDuration: r,
      onOpen: v.useCallback(() => {
        window.clearTimeout(c.current), i.current = !1;
      }, []),
      onClose: v.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => i.current = !0,
          n
        );
      }, [n]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: v.useCallback((l) => {
        s.current = l;
      }, []),
      disableHoverableContent: a,
      children: o
    }
  );
};
Z2.displayName = X2;
var Ti = "Tooltip", [l6, Ms] = Mu(Ti), J2 = (e) => {
  const {
    __scopeTooltip: t,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: o,
    disableHoverableContent: i,
    delayDuration: s
  } = e, c = Pg(Ti, e.__scopeTooltip), l = Ru(t), [u, f] = v.useState(null), d = Ct(), p = v.useRef(0), g = i ?? c.disableHoverableContent, m = s ?? c.delayDuration, y = v.useRef(!1), [b, w] = mr({
    prop: n,
    defaultProp: a ?? !1,
    onChange: (A) => {
      A ? (c.onOpen(), document.dispatchEvent(new CustomEvent(gv))) : c.onClose(), o == null || o(A);
    },
    caller: Ti
  }), S = v.useMemo(() => b ? y.current ? "delayed-open" : "instant-open" : "closed", [b]), P = v.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, y.current = !1, w(!0);
  }, [w]), x = v.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, w(!1);
  }, [w]), O = v.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      y.current = !0, w(!0), p.current = 0;
    }, m);
  }, [m, w]);
  return v.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ h(Cs, { ...l, children: /* @__PURE__ */ h(
    l6,
    {
      scope: t,
      contentId: d,
      open: b,
      stateAttribute: S,
      trigger: u,
      onTriggerChange: f,
      onTriggerEnter: v.useCallback(() => {
        c.isOpenDelayedRef.current ? O() : P();
      }, [c.isOpenDelayedRef, O, P]),
      onTriggerLeave: v.useCallback(() => {
        g ? x() : (window.clearTimeout(p.current), p.current = 0);
      }, [x, g]),
      onOpen: P,
      onClose: x,
      disableHoverableContent: g,
      children: r
    }
  ) });
};
J2.displayName = Ti;
var bv = "TooltipTrigger", Q2 = v.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, a = Ms(bv, r), o = Pg(bv, r), i = Ru(r), s = v.useRef(null), c = me(t, s, a.onTriggerChange), l = v.useRef(!1), u = v.useRef(!1), f = v.useCallback(() => l.current = !1, []);
    return v.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ h(ks, { asChild: !0, ...i, children: /* @__PURE__ */ h(
      i6.button,
      {
        "aria-describedby": a.open ? a.contentId : void 0,
        "data-state": a.stateAttribute,
        ...n,
        ref: c,
        onPointerMove: re(e.onPointerMove, (d) => {
          d.pointerType !== "touch" && !u.current && !o.isPointerInTransitRef.current && (a.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: re(e.onPointerLeave, () => {
          a.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: re(e.onPointerDown, () => {
          a.open && a.onClose(), l.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: re(e.onFocus, () => {
          l.current || a.onOpen();
        }),
        onBlur: re(e.onBlur, a.onClose),
        onClick: re(e.onClick, a.onClose)
      }
    ) });
  }
);
Q2.displayName = bv;
var Ag = "TooltipPortal", [u6, f6] = Mu(Ag, {
  forceMount: void 0
}), eC = (e) => {
  const { __scopeTooltip: t, forceMount: r, children: n, container: a } = e, o = Ms(Ag, t);
  return /* @__PURE__ */ h(u6, { scope: t, forceMount: r, children: /* @__PURE__ */ h(ot, { present: r || o.open, children: /* @__PURE__ */ h($o, { asChild: !0, container: a, children: n }) }) });
};
eC.displayName = Ag;
var Ua = "TooltipContent", tC = v.forwardRef(
  (e, t) => {
    const r = f6(Ua, e.__scopeTooltip), { forceMount: n = r.forceMount, side: a = "top", ...o } = e, i = Ms(Ua, e.__scopeTooltip);
    return /* @__PURE__ */ h(ot, { present: n || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ h(rC, { side: a, ...o, ref: t }) : /* @__PURE__ */ h(d6, { side: a, ...o, ref: t }) });
  }
), d6 = v.forwardRef((e, t) => {
  const r = Ms(Ua, e.__scopeTooltip), n = Pg(Ua, e.__scopeTooltip), a = v.useRef(null), o = me(t, a), [i, s] = v.useState(null), { trigger: c, onClose: l } = r, u = a.current, { onPointerInTransitChange: f } = n, d = v.useCallback(() => {
    s(null), f(!1);
  }, [f]), p = v.useCallback(
    (g, m) => {
      const y = g.currentTarget, b = { x: g.clientX, y: g.clientY }, w = y6(b, y.getBoundingClientRect()), S = g6(b, w), P = b6(m.getBoundingClientRect()), x = w6([...S, ...P]);
      s(x), f(!0);
    },
    [f]
  );
  return v.useEffect(() => () => d(), [d]), v.useEffect(() => {
    if (c && u) {
      const g = (y) => p(y, u), m = (y) => p(y, c);
      return c.addEventListener("pointerleave", g), u.addEventListener("pointerleave", m), () => {
        c.removeEventListener("pointerleave", g), u.removeEventListener("pointerleave", m);
      };
    }
  }, [c, u, p, d]), v.useEffect(() => {
    if (i) {
      const g = (m) => {
        const y = m.target, b = { x: m.clientX, y: m.clientY }, w = (c == null ? void 0 : c.contains(y)) || (u == null ? void 0 : u.contains(y)), S = !x6(b, i);
        w ? d() : S && (d(), l());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [c, u, i, l, d]), /* @__PURE__ */ h(rC, { ...e, ref: o });
}), [p6, h6] = Mu(Ti, { isInside: !1 }), m6 = /* @__PURE__ */ t6("TooltipContent"), rC = v.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: r,
      children: n,
      "aria-label": a,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      ...s
    } = e, c = Ms(Ua, r), l = Ru(r), { onClose: u } = c;
    return v.useEffect(() => (document.addEventListener(gv, u), () => document.removeEventListener(gv, u)), [u]), v.useEffect(() => {
      if (c.trigger) {
        const f = (d) => {
          const p = d.target;
          p != null && p.contains(c.trigger) && u();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [c.trigger, u]), /* @__PURE__ */ h(
      To,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: i,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ C(
          bu,
          {
            "data-state": c.stateAttribute,
            ...l,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ h(m6, { children: n }),
              /* @__PURE__ */ h(p6, { scope: r, isInside: !0, children: /* @__PURE__ */ h(aL, { id: c.contentId, role: "tooltip", children: a || n }) })
            ]
          }
        )
      }
    );
  }
);
tC.displayName = Ua;
var nC = "TooltipArrow", v6 = v.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, a = Ru(r);
    return h6(
      nC,
      r
    ).isInside ? null : /* @__PURE__ */ h(xu, { ...a, ...n, ref: t });
  }
);
v6.displayName = nC;
function y6(e, t) {
  const r = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), a = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
  switch (Math.min(r, n, a, o)) {
    case o:
      return "left";
    case a:
      return "right";
    case r:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function g6(e, t, r = 5) {
  const n = [];
  switch (t) {
    case "top":
      n.push(
        { x: e.x - r, y: e.y + r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "bottom":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x + r, y: e.y - r }
      );
      break;
    case "left":
      n.push(
        { x: e.x + r, y: e.y - r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "right":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x - r, y: e.y + r }
      );
      break;
  }
  return n;
}
function b6(e) {
  const { top: t, right: r, bottom: n, left: a } = e;
  return [
    { x: a, y: t },
    { x: r, y: t },
    { x: r, y: n },
    { x: a, y: n }
  ];
}
function x6(e, t) {
  const { x: r, y: n } = e;
  let a = !1;
  for (let o = 0, i = t.length - 1; o < t.length; i = o++) {
    const s = t[o], c = t[i], l = s.x, u = s.y, f = c.x, d = c.y;
    u > n != d > n && r < (f - l) * (n - u) / (d - u) + l && (a = !a);
  }
  return a;
}
function w6(e) {
  const t = e.slice();
  return t.sort((r, n) => r.x < n.x ? -1 : r.x > n.x ? 1 : r.y < n.y ? -1 : r.y > n.y ? 1 : 0), S6(t);
}
function S6(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    for (; t.length >= 2; ) {
      const o = t[t.length - 1], i = t[t.length - 2];
      if ((o.x - i.x) * (a.y - i.y) >= (o.y - i.y) * (a.x - i.x)) t.pop();
      else break;
    }
    t.push(a);
  }
  t.pop();
  const r = [];
  for (let n = e.length - 1; n >= 0; n--) {
    const a = e[n];
    for (; r.length >= 2; ) {
      const o = r[r.length - 1], i = r[r.length - 2];
      if ((o.x - i.x) * (a.y - i.y) >= (o.y - i.y) * (a.x - i.x)) r.pop();
      else break;
    }
    r.push(a);
  }
  return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
}
var O6 = Z2, P6 = J2, A6 = Q2, _6 = eC, aC = tC;
const oC = O6, Hc = P6, Vc = A6, Mi = v.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ h(_6, { children: /* @__PURE__ */ h(
  aC,
  {
    ref: n,
    sideOffset: t,
    className: F(
      "z-50 overflow-hidden rounded-md border border-stone-200 bg-white px-3 py-1.5 text-sm text-stone-900 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-stone-700 dark:bg-stone-900 dark:text-stone-100",
      e
    ),
    ...r
  }
) }));
Mi.displayName = aC.displayName;
function E6(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, C6(a, ...t)];
}
function C6(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function iC(e) {
  const t = /* @__PURE__ */ k6(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(T6);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function k6(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = R6(a), s = M6(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var N6 = Symbol("radix.slottable");
function T6(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === N6;
}
function M6(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function R6(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var $6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], sC = $6.reduce((e, t) => {
  const r = /* @__PURE__ */ iC(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), $u = "Popover", [cC] = E6($u, [
  kn
]), Rs = kn(), [I6, Mn] = cC($u), lC = (e) => {
  const {
    __scopePopover: t,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: o,
    modal: i = !1
  } = e, s = Rs(t), c = v.useRef(null), [l, u] = v.useState(!1), [f, d] = mr({
    prop: n,
    defaultProp: a ?? !1,
    onChange: o,
    caller: $u
  });
  return /* @__PURE__ */ h(Cs, { ...s, children: /* @__PURE__ */ h(
    I6,
    {
      scope: t,
      contentId: Ct(),
      triggerRef: c,
      open: f,
      onOpenChange: d,
      onOpenToggle: v.useCallback(() => d((p) => !p), [d]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: v.useCallback(() => u(!0), []),
      onCustomAnchorRemove: v.useCallback(() => u(!1), []),
      modal: i,
      children: r
    }
  ) });
};
lC.displayName = $u;
var uC = "PopoverAnchor", fC = v.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, a = Mn(uC, r), o = Rs(r), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = a;
    return v.useEffect(() => (i(), () => s()), [i, s]), /* @__PURE__ */ h(ks, { ...o, ...n, ref: t });
  }
);
fC.displayName = uC;
var dC = "PopoverTrigger", pC = v.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, a = Mn(dC, r), o = Rs(r), i = me(t, a.triggerRef), s = /* @__PURE__ */ h(
      sC.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": gC(a.open),
        ...n,
        ref: i,
        onClick: re(e.onClick, a.onOpenToggle)
      }
    );
    return a.hasCustomAnchor ? s : /* @__PURE__ */ h(ks, { asChild: !0, ...o, children: s });
  }
);
pC.displayName = dC;
var _g = "PopoverPortal", [D6, j6] = cC(_g, {
  forceMount: void 0
}), hC = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: a } = e, o = Mn(_g, t);
  return /* @__PURE__ */ h(D6, { scope: t, forceMount: r, children: /* @__PURE__ */ h(ot, { present: r || o.open, children: /* @__PURE__ */ h($o, { asChild: !0, container: a, children: n }) }) });
};
hC.displayName = _g;
var Ka = "PopoverContent", mC = v.forwardRef(
  (e, t) => {
    const r = j6(Ka, e.__scopePopover), { forceMount: n = r.forceMount, ...a } = e, o = Mn(Ka, e.__scopePopover);
    return /* @__PURE__ */ h(ot, { present: n || o.open, children: o.modal ? /* @__PURE__ */ h(B6, { ...a, ref: t }) : /* @__PURE__ */ h(F6, { ...a, ref: t }) });
  }
);
mC.displayName = Ka;
var L6 = /* @__PURE__ */ iC("PopoverContent.RemoveScroll"), B6 = v.forwardRef(
  (e, t) => {
    const r = Mn(Ka, e.__scopePopover), n = v.useRef(null), a = me(t, n), o = v.useRef(!1);
    return v.useEffect(() => {
      const i = n.current;
      if (i) return wu(i);
    }, []), /* @__PURE__ */ h(Ns, { as: L6, allowPinchZoom: !0, children: /* @__PURE__ */ h(
      vC,
      {
        ...e,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: re(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), o.current || (s = r.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: re(
          e.onPointerDownOutside,
          (i) => {
            const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
            o.current = l;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: re(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), F6 = v.forwardRef(
  (e, t) => {
    const r = Mn(Ka, e.__scopePopover), n = v.useRef(!1), a = v.useRef(!1);
    return /* @__PURE__ */ h(
      vC,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, o), o.defaultPrevented || (n.current || (s = r.triggerRef.current) == null || s.focus(), o.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (o) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (n.current = !0, o.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const i = o.target;
          ((l = r.triggerRef.current) == null ? void 0 : l.contains(i)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && a.current && o.preventDefault();
        }
      }
    );
  }
), vC = v.forwardRef(
  (e, t) => {
    const {
      __scopePopover: r,
      trapFocus: n,
      onOpenAutoFocus: a,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onInteractOutside: u,
      ...f
    } = e, d = Mn(Ka, r), p = Rs(r);
    return hu(), /* @__PURE__ */ h(
      _s,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: a,
        onUnmountAutoFocus: o,
        children: /* @__PURE__ */ h(
          To,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: u,
            onEscapeKeyDown: s,
            onPointerDownOutside: c,
            onFocusOutside: l,
            onDismiss: () => d.onOpenChange(!1),
            children: /* @__PURE__ */ h(
              bu,
              {
                "data-state": gC(d.open),
                role: "dialog",
                id: d.contentId,
                ...p,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), yC = "PopoverClose", z6 = v.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, a = Mn(yC, r);
    return /* @__PURE__ */ h(
      sC.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: re(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
z6.displayName = yC;
var q6 = "PopoverArrow", W6 = v.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, a = Rs(r);
    return /* @__PURE__ */ h(xu, { ...a, ...n, ref: t });
  }
);
W6.displayName = q6;
function gC(e) {
  return e ? "open" : "closed";
}
var H6 = lC, V6 = fC, U6 = pC, K6 = hC, bC = mC;
const yce = H6, gce = U6, bce = V6, G6 = v.forwardRef(({ className: e, align: t = "center", sideOffset: r = 4, ...n }, a) => /* @__PURE__ */ h(K6, { children: /* @__PURE__ */ h(
  bC,
  {
    ref: a,
    align: t,
    sideOffset: r,
    className: F(
      "z-50 w-72 rounded-md border border-stone-200 bg-white p-4 text-stone-900 shadow-md outline-none dark:border-stone-700 dark:bg-stone-900 dark:text-stone-100 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
G6.displayName = bC.displayName;
var Y6 = (e) => {
  switch (e) {
    case "success":
      return J6;
    case "info":
      return e8;
    case "warning":
      return Q6;
    case "error":
      return t8;
    default:
      return null;
  }
}, X6 = Array(12).fill(0), Z6 = ({ visible: e, className: t }) => E.createElement("div", { className: ["sonner-loading-wrapper", t].filter(Boolean).join(" "), "data-visible": e }, E.createElement("div", { className: "sonner-spinner" }, X6.map((r, n) => E.createElement("div", { className: "sonner-loading-bar", key: `spinner-bar-${n}` })))), J6 = E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, E.createElement("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z", clipRule: "evenodd" })), Q6 = E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", height: "20", width: "20" }, E.createElement("path", { fillRule: "evenodd", d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z", clipRule: "evenodd" })), e8 = E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, E.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z", clipRule: "evenodd" })), t8 = E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, E.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" })), r8 = E.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, E.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), E.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })), n8 = () => {
  let [e, t] = E.useState(document.hidden);
  return E.useEffect(() => {
    let r = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", r), () => window.removeEventListener("visibilitychange", r);
  }, []), e;
}, xv = 1, a8 = class {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      let t = this.subscribers.indexOf(e);
      this.subscribers.splice(t, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((t) => t(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    }, this.create = (e) => {
      var t;
      let { message: r, ...n } = e, a = typeof (e == null ? void 0 : e.id) == "number" || ((t = e.id) == null ? void 0 : t.length) > 0 ? e.id : xv++, o = this.toasts.find((s) => s.id === a), i = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), o ? this.toasts = this.toasts.map((s) => s.id === a ? (this.publish({ ...s, ...e, id: a, title: r }), { ...s, ...e, id: a, dismissible: i, title: r }) : s) : this.addToast({ title: r, ...n, dismissible: i, id: a }), a;
    }, this.dismiss = (e) => (this.dismissedToasts.add(e), e || this.toasts.forEach((t) => {
      this.subscribers.forEach((r) => r({ id: t.id, dismiss: !0 }));
    }), this.subscribers.forEach((t) => t({ id: e, dismiss: !0 })), e), this.message = (e, t) => this.create({ ...t, message: e }), this.error = (e, t) => this.create({ ...t, message: e, type: "error" }), this.success = (e, t) => this.create({ ...t, type: "success", message: e }), this.info = (e, t) => this.create({ ...t, type: "info", message: e }), this.warning = (e, t) => this.create({ ...t, type: "warning", message: e }), this.loading = (e, t) => this.create({ ...t, type: "loading", message: e }), this.promise = (e, t) => {
      if (!t) return;
      let r;
      t.loading !== void 0 && (r = this.create({ ...t, promise: e, type: "loading", message: t.loading, description: typeof t.description != "function" ? t.description : void 0 }));
      let n = e instanceof Promise ? e : e(), a = r !== void 0, o, i = n.then(async (c) => {
        if (o = ["resolve", c], E.isValidElement(c)) a = !1, this.create({ id: r, type: "default", message: c });
        else if (i8(c) && !c.ok) {
          a = !1;
          let l = typeof t.error == "function" ? await t.error(`HTTP error! status: ${c.status}`) : t.error, u = typeof t.description == "function" ? await t.description(`HTTP error! status: ${c.status}`) : t.description;
          this.create({ id: r, type: "error", message: l, description: u });
        } else if (t.success !== void 0) {
          a = !1;
          let l = typeof t.success == "function" ? await t.success(c) : t.success, u = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: r, type: "success", message: l, description: u });
        }
      }).catch(async (c) => {
        if (o = ["reject", c], t.error !== void 0) {
          a = !1;
          let l = typeof t.error == "function" ? await t.error(c) : t.error, u = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: r, type: "error", message: l, description: u });
        }
      }).finally(() => {
        var c;
        a && (this.dismiss(r), r = void 0), (c = t.finally) == null || c.call(t);
      }), s = () => new Promise((c, l) => i.then(() => o[0] === "reject" ? l(o[1]) : c(o[1])).catch(l));
      return typeof r != "string" && typeof r != "number" ? { unwrap: s } : Object.assign(r, { unwrap: s });
    }, this.custom = (e, t) => {
      let r = (t == null ? void 0 : t.id) || xv++;
      return this.create({ jsx: e(r), id: r, ...t }), r;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}, Pt = new a8(), o8 = (e, t) => {
  let r = (t == null ? void 0 : t.id) || xv++;
  return Pt.addToast({ title: e, ...t, id: r }), r;
}, i8 = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", s8 = o8, c8 = () => Pt.toasts, l8 = () => Pt.getActiveToasts(), xce = Object.assign(s8, { success: Pt.success, info: Pt.info, warning: Pt.warning, error: Pt.error, custom: Pt.custom, message: Pt.message, promise: Pt.promise, dismiss: Pt.dismiss, loading: Pt.loading }, { getHistory: c8, getToasts: l8 });
function u8(e, { insertAt: t } = {}) {
  if (typeof document > "u") return;
  let r = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t === "top" && r.firstChild ? r.insertBefore(n, r.firstChild) : r.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
u8(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}:where([data-sonner-toaster][data-lifted="true"]){transform:translateY(-10px)}@media (hover: none) and (pointer: coarse){:where([data-sonner-toaster][data-lifted="true"]){transform:none}}:where([data-sonner-toaster][data-x-position="right"]){right:var(--offset-right)}:where([data-sonner-toaster][data-x-position="left"]){left:var(--offset-left)}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:var(--offset-top)}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:var(--offset-bottom)}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]{background:var(--gray1)}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:-50%;right:-50%;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function oc(e) {
  return e.label !== void 0;
}
var f8 = 3, d8 = "32px", p8 = "16px", kb = 4e3, h8 = 356, m8 = 14, v8 = 20, y8 = 200;
function sr(...e) {
  return e.filter(Boolean).join(" ");
}
function g8(e) {
  let [t, r] = e.split("-"), n = [];
  return t && n.push(t), r && n.push(r), n;
}
var b8 = (e) => {
  var t, r, n, a, o, i, s, c, l, u, f;
  let { invert: d, toast: p, unstyled: g, interacting: m, setHeights: y, visibleToasts: b, heights: w, index: S, toasts: P, expanded: x, removeToast: O, defaultRichColors: A, closeButton: _, style: N, cancelButtonStyle: M, actionButtonStyle: T, className: k = "", descriptionClassName: $ = "", duration: R, position: L, gap: j, loadingIcon: z, expandByDefault: q, classNames: I, icons: B, closeButtonAriaLabel: W = "Close toast", pauseWhenPageIsHidden: H } = e, [U, X] = E.useState(null), [ee, ne] = E.useState(null), [G, te] = E.useState(!1), [V, Y] = E.useState(!1), [Q, D] = E.useState(!1), [le, Z] = E.useState(!1), [ve, ye] = E.useState(!1), [Ie, Ot] = E.useState(0), [Tt, Fn] = E.useState(0), Mt = E.useRef(p.duration || R || kb), Wt = E.useRef(null), nr = E.useRef(null), Zo = S === 0, Jo = S + 1 <= b, mt = p.type, Br = p.dismissible !== !1, o$ = p.className || "", i$ = p.descriptionClassName || "", Xs = E.useMemo(() => w.findIndex((pe) => pe.toastId === p.id) || 0, [w, p.id]), s$ = E.useMemo(() => {
    var pe;
    return (pe = p.closeButton) != null ? pe : _;
  }, [p.closeButton, _]), H0 = E.useMemo(() => p.duration || R || kb, [p.duration, R]), Ef = E.useRef(0), xa = E.useRef(0), V0 = E.useRef(0), wa = E.useRef(null), [c$, l$] = L.split("-"), U0 = E.useMemo(() => w.reduce((pe, Ce, Le) => Le >= Xs ? pe : pe + Ce.height, 0), [w, Xs]), K0 = n8(), u$ = p.invert || d, Cf = mt === "loading";
  xa.current = E.useMemo(() => Xs * j + U0, [Xs, U0]), E.useEffect(() => {
    Mt.current = H0;
  }, [H0]), E.useEffect(() => {
    te(!0);
  }, []), E.useEffect(() => {
    let pe = nr.current;
    if (pe) {
      let Ce = pe.getBoundingClientRect().height;
      return Fn(Ce), y((Le) => [{ toastId: p.id, height: Ce, position: p.position }, ...Le]), () => y((Le) => Le.filter((ar) => ar.toastId !== p.id));
    }
  }, [y, p.id]), E.useLayoutEffect(() => {
    if (!G) return;
    let pe = nr.current, Ce = pe.style.height;
    pe.style.height = "auto";
    let Le = pe.getBoundingClientRect().height;
    pe.style.height = Ce, Fn(Le), y((ar) => ar.find((or) => or.toastId === p.id) ? ar.map((or) => or.toastId === p.id ? { ...or, height: Le } : or) : [{ toastId: p.id, height: Le, position: p.position }, ...ar]);
  }, [G, p.title, p.description, y, p.id]);
  let ln = E.useCallback(() => {
    Y(!0), Ot(xa.current), y((pe) => pe.filter((Ce) => Ce.toastId !== p.id)), setTimeout(() => {
      O(p);
    }, y8);
  }, [p, O, y, xa]);
  E.useEffect(() => {
    if (p.promise && mt === "loading" || p.duration === 1 / 0 || p.type === "loading") return;
    let pe;
    return x || m || H && K0 ? (() => {
      if (V0.current < Ef.current) {
        let Ce = (/* @__PURE__ */ new Date()).getTime() - Ef.current;
        Mt.current = Mt.current - Ce;
      }
      V0.current = (/* @__PURE__ */ new Date()).getTime();
    })() : Mt.current !== 1 / 0 && (Ef.current = (/* @__PURE__ */ new Date()).getTime(), pe = setTimeout(() => {
      var Ce;
      (Ce = p.onAutoClose) == null || Ce.call(p, p), ln();
    }, Mt.current)), () => clearTimeout(pe);
  }, [x, m, p, mt, H, K0, ln]), E.useEffect(() => {
    p.delete && ln();
  }, [ln, p.delete]);
  function f$() {
    var pe, Ce, Le;
    return B != null && B.loading ? E.createElement("div", { className: sr(I == null ? void 0 : I.loader, (pe = p == null ? void 0 : p.classNames) == null ? void 0 : pe.loader, "sonner-loader"), "data-visible": mt === "loading" }, B.loading) : z ? E.createElement("div", { className: sr(I == null ? void 0 : I.loader, (Ce = p == null ? void 0 : p.classNames) == null ? void 0 : Ce.loader, "sonner-loader"), "data-visible": mt === "loading" }, z) : E.createElement(Z6, { className: sr(I == null ? void 0 : I.loader, (Le = p == null ? void 0 : p.classNames) == null ? void 0 : Le.loader), visible: mt === "loading" });
  }
  return E.createElement("li", { tabIndex: 0, ref: nr, className: sr(k, o$, I == null ? void 0 : I.toast, (t = p == null ? void 0 : p.classNames) == null ? void 0 : t.toast, I == null ? void 0 : I.default, I == null ? void 0 : I[mt], (r = p == null ? void 0 : p.classNames) == null ? void 0 : r[mt]), "data-sonner-toast": "", "data-rich-colors": (n = p.richColors) != null ? n : A, "data-styled": !(p.jsx || p.unstyled || g), "data-mounted": G, "data-promise": !!p.promise, "data-swiped": ve, "data-removed": V, "data-visible": Jo, "data-y-position": c$, "data-x-position": l$, "data-index": S, "data-front": Zo, "data-swiping": Q, "data-dismissible": Br, "data-type": mt, "data-invert": u$, "data-swipe-out": le, "data-swipe-direction": ee, "data-expanded": !!(x || q && G), style: { "--index": S, "--toasts-before": S, "--z-index": P.length - S, "--offset": `${V ? Ie : xa.current}px`, "--initial-height": q ? "auto" : `${Tt}px`, ...N, ...p.style }, onDragEnd: () => {
    D(!1), X(null), wa.current = null;
  }, onPointerDown: (pe) => {
    Cf || !Br || (Wt.current = /* @__PURE__ */ new Date(), Ot(xa.current), pe.target.setPointerCapture(pe.pointerId), pe.target.tagName !== "BUTTON" && (D(!0), wa.current = { x: pe.clientX, y: pe.clientY }));
  }, onPointerUp: () => {
    var pe, Ce, Le, ar;
    if (le || !Br) return;
    wa.current = null;
    let or = Number(((pe = nr.current) == null ? void 0 : pe.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), un = Number(((Ce = nr.current) == null ? void 0 : Ce.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), zn = (/* @__PURE__ */ new Date()).getTime() - ((Le = Wt.current) == null ? void 0 : Le.getTime()), ir = U === "x" ? or : un, fn = Math.abs(ir) / zn;
    if (Math.abs(ir) >= v8 || fn > 0.11) {
      Ot(xa.current), (ar = p.onDismiss) == null || ar.call(p, p), ne(U === "x" ? or > 0 ? "right" : "left" : un > 0 ? "down" : "up"), ln(), Z(!0), ye(!1);
      return;
    }
    D(!1), X(null);
  }, onPointerMove: (pe) => {
    var Ce, Le, ar, or;
    if (!wa.current || !Br || ((Ce = window.getSelection()) == null ? void 0 : Ce.toString().length) > 0) return;
    let un = pe.clientY - wa.current.y, zn = pe.clientX - wa.current.x, ir = (Le = e.swipeDirections) != null ? Le : g8(L);
    !U && (Math.abs(zn) > 1 || Math.abs(un) > 1) && X(Math.abs(zn) > Math.abs(un) ? "x" : "y");
    let fn = { x: 0, y: 0 };
    U === "y" ? (ir.includes("top") || ir.includes("bottom")) && (ir.includes("top") && un < 0 || ir.includes("bottom") && un > 0) && (fn.y = un) : U === "x" && (ir.includes("left") || ir.includes("right")) && (ir.includes("left") && zn < 0 || ir.includes("right") && zn > 0) && (fn.x = zn), (Math.abs(fn.x) > 0 || Math.abs(fn.y) > 0) && ye(!0), (ar = nr.current) == null || ar.style.setProperty("--swipe-amount-x", `${fn.x}px`), (or = nr.current) == null || or.style.setProperty("--swipe-amount-y", `${fn.y}px`);
  } }, s$ && !p.jsx ? E.createElement("button", { "aria-label": W, "data-disabled": Cf, "data-close-button": !0, onClick: Cf || !Br ? () => {
  } : () => {
    var pe;
    ln(), (pe = p.onDismiss) == null || pe.call(p, p);
  }, className: sr(I == null ? void 0 : I.closeButton, (a = p == null ? void 0 : p.classNames) == null ? void 0 : a.closeButton) }, (o = B == null ? void 0 : B.close) != null ? o : r8) : null, p.jsx || Et(p.title) ? p.jsx ? p.jsx : typeof p.title == "function" ? p.title() : p.title : E.createElement(E.Fragment, null, mt || p.icon || p.promise ? E.createElement("div", { "data-icon": "", className: sr(I == null ? void 0 : I.icon, (i = p == null ? void 0 : p.classNames) == null ? void 0 : i.icon) }, p.promise || p.type === "loading" && !p.icon ? p.icon || f$() : null, p.type !== "loading" ? p.icon || (B == null ? void 0 : B[mt]) || Y6(mt) : null) : null, E.createElement("div", { "data-content": "", className: sr(I == null ? void 0 : I.content, (s = p == null ? void 0 : p.classNames) == null ? void 0 : s.content) }, E.createElement("div", { "data-title": "", className: sr(I == null ? void 0 : I.title, (c = p == null ? void 0 : p.classNames) == null ? void 0 : c.title) }, typeof p.title == "function" ? p.title() : p.title), p.description ? E.createElement("div", { "data-description": "", className: sr($, i$, I == null ? void 0 : I.description, (l = p == null ? void 0 : p.classNames) == null ? void 0 : l.description) }, typeof p.description == "function" ? p.description() : p.description) : null), Et(p.cancel) ? p.cancel : p.cancel && oc(p.cancel) ? E.createElement("button", { "data-button": !0, "data-cancel": !0, style: p.cancelButtonStyle || M, onClick: (pe) => {
    var Ce, Le;
    oc(p.cancel) && Br && ((Le = (Ce = p.cancel).onClick) == null || Le.call(Ce, pe), ln());
  }, className: sr(I == null ? void 0 : I.cancelButton, (u = p == null ? void 0 : p.classNames) == null ? void 0 : u.cancelButton) }, p.cancel.label) : null, Et(p.action) ? p.action : p.action && oc(p.action) ? E.createElement("button", { "data-button": !0, "data-action": !0, style: p.actionButtonStyle || T, onClick: (pe) => {
    var Ce, Le;
    oc(p.action) && ((Le = (Ce = p.action).onClick) == null || Le.call(Ce, pe), !pe.defaultPrevented && ln());
  }, className: sr(I == null ? void 0 : I.actionButton, (f = p == null ? void 0 : p.classNames) == null ? void 0 : f.actionButton) }, p.action.label) : null));
};
function Nb() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  let e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function x8(e, t) {
  let r = {};
  return [e, t].forEach((n, a) => {
    let o = a === 1, i = o ? "--mobile-offset" : "--offset", s = o ? p8 : d8;
    function c(l) {
      ["top", "right", "bottom", "left"].forEach((u) => {
        r[`${i}-${u}`] = typeof l == "number" ? `${l}px` : l;
      });
    }
    typeof n == "number" || typeof n == "string" ? c(n) : typeof n == "object" ? ["top", "right", "bottom", "left"].forEach((l) => {
      n[l] === void 0 ? r[`${i}-${l}`] = s : r[`${i}-${l}`] = typeof n[l] == "number" ? `${n[l]}px` : n[l];
    }) : c(s);
  }), r;
}
var w8 = bs(function(e, t) {
  let { invert: r, position: n = "bottom-right", hotkey: a = ["altKey", "KeyT"], expand: o, closeButton: i, className: s, offset: c, mobileOffset: l, theme: u = "light", richColors: f, duration: d, style: p, visibleToasts: g = f8, toastOptions: m, dir: y = Nb(), gap: b = m8, loadingIcon: w, icons: S, containerAriaLabel: P = "Notifications", pauseWhenPageIsHidden: x } = e, [O, A] = E.useState([]), _ = E.useMemo(() => Array.from(new Set([n].concat(O.filter((H) => H.position).map((H) => H.position)))), [O, n]), [N, M] = E.useState([]), [T, k] = E.useState(!1), [$, R] = E.useState(!1), [L, j] = E.useState(u !== "system" ? u : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), z = E.useRef(null), q = a.join("+").replace(/Key/g, "").replace(/Digit/g, ""), I = E.useRef(null), B = E.useRef(!1), W = E.useCallback((H) => {
    A((U) => {
      var X;
      return (X = U.find((ee) => ee.id === H.id)) != null && X.delete || Pt.dismiss(H.id), U.filter(({ id: ee }) => ee !== H.id);
    });
  }, []);
  return E.useEffect(() => Pt.subscribe((H) => {
    if (H.dismiss) {
      A((U) => U.map((X) => X.id === H.id ? { ...X, delete: !0 } : X));
      return;
    }
    setTimeout(() => {
      v_.flushSync(() => {
        A((U) => {
          let X = U.findIndex((ee) => ee.id === H.id);
          return X !== -1 ? [...U.slice(0, X), { ...U[X], ...H }, ...U.slice(X + 1)] : [H, ...U];
        });
      });
    });
  }), []), E.useEffect(() => {
    if (u !== "system") {
      j(u);
      return;
    }
    if (u === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? j("dark") : j("light")), typeof window > "u") return;
    let H = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      H.addEventListener("change", ({ matches: U }) => {
        j(U ? "dark" : "light");
      });
    } catch {
      H.addListener(({ matches: X }) => {
        try {
          j(X ? "dark" : "light");
        } catch (ee) {
          console.error(ee);
        }
      });
    }
  }, [u]), E.useEffect(() => {
    O.length <= 1 && k(!1);
  }, [O]), E.useEffect(() => {
    let H = (U) => {
      var X, ee;
      a.every((ne) => U[ne] || U.code === ne) && (k(!0), (X = z.current) == null || X.focus()), U.code === "Escape" && (document.activeElement === z.current || (ee = z.current) != null && ee.contains(document.activeElement)) && k(!1);
    };
    return document.addEventListener("keydown", H), () => document.removeEventListener("keydown", H);
  }, [a]), E.useEffect(() => {
    if (z.current) return () => {
      I.current && (I.current.focus({ preventScroll: !0 }), I.current = null, B.current = !1);
    };
  }, [z.current]), E.createElement("section", { ref: t, "aria-label": `${P} ${q}`, tabIndex: -1, "aria-live": "polite", "aria-relevant": "additions text", "aria-atomic": "false", suppressHydrationWarning: !0 }, _.map((H, U) => {
    var X;
    let [ee, ne] = H.split("-");
    return O.length ? E.createElement("ol", { key: H, dir: y === "auto" ? Nb() : y, tabIndex: -1, ref: z, className: s, "data-sonner-toaster": !0, "data-theme": L, "data-y-position": ee, "data-lifted": T && O.length > 1 && !o, "data-x-position": ne, style: { "--front-toast-height": `${((X = N[0]) == null ? void 0 : X.height) || 0}px`, "--width": `${h8}px`, "--gap": `${b}px`, ...p, ...x8(c, l) }, onBlur: (G) => {
      B.current && !G.currentTarget.contains(G.relatedTarget) && (B.current = !1, I.current && (I.current.focus({ preventScroll: !0 }), I.current = null));
    }, onFocus: (G) => {
      G.target instanceof HTMLElement && G.target.dataset.dismissible === "false" || B.current || (B.current = !0, I.current = G.relatedTarget);
    }, onMouseEnter: () => k(!0), onMouseMove: () => k(!0), onMouseLeave: () => {
      $ || k(!1);
    }, onDragEnd: () => k(!1), onPointerDown: (G) => {
      G.target instanceof HTMLElement && G.target.dataset.dismissible === "false" || R(!0);
    }, onPointerUp: () => R(!1) }, O.filter((G) => !G.position && U === 0 || G.position === H).map((G, te) => {
      var V, Y;
      return E.createElement(b8, { key: G.id, icons: S, index: te, toast: G, defaultRichColors: f, duration: (V = m == null ? void 0 : m.duration) != null ? V : d, className: m == null ? void 0 : m.className, descriptionClassName: m == null ? void 0 : m.descriptionClassName, invert: r, visibleToasts: g, closeButton: (Y = m == null ? void 0 : m.closeButton) != null ? Y : i, interacting: $, position: H, style: m == null ? void 0 : m.style, unstyled: m == null ? void 0 : m.unstyled, classNames: m == null ? void 0 : m.classNames, cancelButtonStyle: m == null ? void 0 : m.cancelButtonStyle, actionButtonStyle: m == null ? void 0 : m.actionButtonStyle, removeToast: W, toasts: O.filter((Q) => Q.position == G.position), heights: N.filter((Q) => Q.position == G.position), setHeights: M, expandByDefault: o, gap: b, loadingIcon: w, expanded: T, pauseWhenPageIsHidden: x, swipeDirections: e.swipeDirections });
    })) : null;
  }));
});
const S8 = ({ ...e }) => /* @__PURE__ */ h(
  w8,
  {
    className: "toaster group",
    toastOptions: {
      classNames: {
        toast: "group toast group-[.toaster]:bg-white group-[.toaster]:text-stone-900 group-[.toaster]:border-stone-200 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-stone-900 dark:group-[.toaster]:text-stone-100 dark:group-[.toaster]:border-stone-700",
        description: "group-[.toast]:text-stone-500 dark:group-[.toast]:text-stone-400",
        actionButton: "group-[.toast]:bg-primary-700 group-[.toast]:text-white",
        cancelButton: "group-[.toast]:bg-stone-100 group-[.toast]:text-stone-500 dark:group-[.toast]:bg-stone-800 dark:group-[.toast]:text-stone-400",
        success: "group-[.toaster]:border-green-200 dark:group-[.toaster]:border-green-800",
        error: "group-[.toaster]:border-red-200 dark:group-[.toaster]:border-red-800"
      }
    },
    ...e
  }
);
S8.displayName = "Toaster";
const O8 = Ye(
  "rounded-lg text-stone-900 dark:text-stone-100",
  {
    variants: {
      variant: {
        default: "border border-stone-200 bg-white dark:border-stone-800 dark:bg-stone-900",
        outline: "border-2 border-stone-200 bg-transparent dark:border-stone-700",
        elevated: "bg-white shadow-lg dark:bg-stone-900"
      },
      padding: {
        none: "p-0",
        sm: "p-4",
        md: "p-6",
        lg: "p-8"
      }
    },
    defaultVariants: {
      variant: "default",
      padding: "md"
    }
  }
), P8 = v.forwardRef(
  ({ className: e, variant: t, padding: r, ...n }, a) => /* @__PURE__ */ h(
    "div",
    {
      ref: a,
      className: F(O8({ variant: t, padding: r }), e),
      ...n
    }
  )
);
P8.displayName = "Card";
const A8 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "div",
  {
    ref: r,
    className: F("flex flex-col space-y-1.5 pb-4", e),
    ...t
  }
));
A8.displayName = "CardHeader";
const _8 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "h3",
  {
    ref: r,
    className: F(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
_8.displayName = "CardTitle";
const E8 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "p",
  {
    ref: r,
    className: F("text-sm text-stone-500 dark:text-stone-400", e),
    ...t
  }
));
E8.displayName = "CardDescription";
const C8 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h("div", { ref: r, className: F(e), ...t }));
C8.displayName = "CardContent";
const k8 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "div",
  {
    ref: r,
    className: F("flex items-center pt-4", e),
    ...t
  }
));
k8.displayName = "CardFooter";
var N8 = "Separator", Tb = "horizontal", T8 = ["horizontal", "vertical"], xC = v.forwardRef((e, t) => {
  const { decorative: r, orientation: n = Tb, ...a } = e, o = M8(n) ? n : Tb, s = r ? { role: "none" } : { "aria-orientation": o === "vertical" ? o : void 0, role: "separator" };
  return /* @__PURE__ */ h(
    Ps.div,
    {
      "data-orientation": o,
      ...s,
      ...a,
      ref: t
    }
  );
});
xC.displayName = N8;
function M8(e) {
  return T8.includes(e);
}
var R8 = xC;
const $8 = v.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: r = !0, ...n }, a) => /* @__PURE__ */ h(
    R8,
    {
      ref: a,
      decorative: r,
      orientation: t,
      className: F(
        "shrink-0 bg-stone-200 dark:bg-stone-700",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...n
    }
  )
);
$8.displayName = "Separator";
const wC = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ h(
  "table",
  {
    ref: r,
    className: F("w-full caption-bottom text-sm", e),
    ...t
  }
) }));
wC.displayName = "Table";
const SC = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h("thead", { ref: r, className: F("[&_tr]:border-b", e), ...t }));
SC.displayName = "TableHeader";
const OC = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "tbody",
  {
    ref: r,
    className: F("[&_tr:last-child]:border-0", e),
    ...t
  }
));
OC.displayName = "TableBody";
const I8 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "tfoot",
  {
    ref: r,
    className: F(
      "border-t bg-stone-100/50 font-medium dark:bg-stone-800/50 [&>tr]:last:border-b-0",
      e
    ),
    ...t
  }
));
I8.displayName = "TableFooter";
const fi = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "tr",
  {
    ref: r,
    className: F(
      "border-b border-stone-200 transition-colors hover:bg-stone-100/50 data-[state=selected]:bg-stone-100 dark:border-stone-700 dark:hover:bg-stone-800/50 dark:data-[state=selected]:bg-stone-800",
      e
    ),
    ...t
  }
));
fi.displayName = "TableRow";
const PC = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "th",
  {
    ref: r,
    className: F(
      "h-12 px-4 text-left align-middle font-medium text-stone-500 dark:text-stone-400 [&:has([role=checkbox])]:pr-0",
      e
    ),
    ...t
  }
));
PC.displayName = "TableHead";
const Cc = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "td",
  {
    ref: r,
    className: F(
      "p-4 align-middle text-stone-900 dark:text-stone-100 [&:has([role=checkbox])]:pr-0",
      e
    ),
    ...t
  }
));
Cc.displayName = "TableCell";
const D8 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "caption",
  {
    ref: r,
    className: F(
      "mt-4 text-sm text-stone-500 dark:text-stone-400",
      e
    ),
    ...t
  }
));
D8.displayName = "TableCaption";
function j8(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, L8(a, ...t)];
}
function L8(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function B8(e) {
  const t = /* @__PURE__ */ F8(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(q8);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function F8(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = H8(a), s = W8(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var z8 = Symbol("radix.slottable");
function q8(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === z8;
}
function W8(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function H8(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var V8 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], U8 = V8.reduce((e, t) => {
  const r = /* @__PURE__ */ B8(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function K8(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, G8(a, ...t)];
}
function G8(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function AC(e) {
  const t = /* @__PURE__ */ Y8(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(Z8);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function Y8(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = Q8(a), s = J8(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var X8 = Symbol("radix.slottable");
function Z8(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === X8;
}
function J8(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Q8(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var eB = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], $s = eB.reduce((e, t) => {
  const r = /* @__PURE__ */ AC(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function tB(e, t) {
  e && xs.flushSync(() => e.dispatchEvent(t));
}
function rB(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, nB(a, ...t)];
}
function nB(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function aB(e) {
  const t = /* @__PURE__ */ oB(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(sB);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function oB(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = lB(a), s = cB(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var iB = Symbol("radix.slottable");
function sB(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === iB;
}
function cB(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function lB(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var uB = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], _C = uB.reduce((e, t) => {
  const r = /* @__PURE__ */ aB(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Wf = "rovingFocusGroup.onEntryFocus", fB = { bubbles: !1, cancelable: !0 }, Is = "RovingFocusGroup", [wv, EC, dB] = fg(Is), [pB, Iu] = rB(
  Is,
  [dB]
), [hB, mB] = pB(Is), CC = v.forwardRef(
  (e, t) => /* @__PURE__ */ h(wv.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ h(wv.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ h(vB, { ...e, ref: t }) }) })
);
CC.displayName = Is;
var vB = v.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: n,
    loop: a = !1,
    dir: o,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: l,
    preventScrollOnEntryFocus: u = !1,
    ...f
  } = e, d = v.useRef(null), p = me(t, d), g = As(o), [m, y] = mr({
    prop: i,
    defaultProp: s ?? null,
    onChange: c,
    caller: Is
  }), [b, w] = v.useState(!1), S = et(l), P = EC(r), x = v.useRef(!1), [O, A] = v.useState(0);
  return v.useEffect(() => {
    const _ = d.current;
    if (_)
      return _.addEventListener(Wf, S), () => _.removeEventListener(Wf, S);
  }, [S]), /* @__PURE__ */ h(
    hB,
    {
      scope: r,
      orientation: n,
      dir: g,
      loop: a,
      currentTabStopId: m,
      onItemFocus: v.useCallback(
        (_) => y(_),
        [y]
      ),
      onItemShiftTab: v.useCallback(() => w(!0), []),
      onFocusableItemAdd: v.useCallback(
        () => A((_) => _ + 1),
        []
      ),
      onFocusableItemRemove: v.useCallback(
        () => A((_) => _ - 1),
        []
      ),
      children: /* @__PURE__ */ h(
        _C.div,
        {
          tabIndex: b || O === 0 ? -1 : 0,
          "data-orientation": n,
          ...f,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: re(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: re(e.onFocus, (_) => {
            const N = !x.current;
            if (_.target === _.currentTarget && N && !b) {
              const M = new CustomEvent(Wf, fB);
              if (_.currentTarget.dispatchEvent(M), !M.defaultPrevented) {
                const T = P().filter((j) => j.focusable), k = T.find((j) => j.active), $ = T.find((j) => j.id === m), L = [k, $, ...T].filter(
                  Boolean
                ).map((j) => j.ref.current);
                TC(L, u);
              }
            }
            x.current = !1;
          }),
          onBlur: re(e.onBlur, () => w(!1))
        }
      )
    }
  );
}), kC = "RovingFocusGroupItem", NC = v.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: n = !0,
      active: a = !1,
      tabStopId: o,
      children: i,
      ...s
    } = e, c = Ct(), l = o || c, u = mB(kC, r), f = u.currentTabStopId === l, d = EC(r), { onFocusableItemAdd: p, onFocusableItemRemove: g, currentTabStopId: m } = u;
    return v.useEffect(() => {
      if (n)
        return p(), () => g();
    }, [n, p, g]), /* @__PURE__ */ h(
      wv.ItemSlot,
      {
        scope: r,
        id: l,
        focusable: n,
        active: a,
        children: /* @__PURE__ */ h(
          _C.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: re(e.onMouseDown, (y) => {
              n ? u.onItemFocus(l) : y.preventDefault();
            }),
            onFocus: re(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: re(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const b = bB(y, u.orientation, u.dir);
              if (b !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let S = d().filter((P) => P.focusable).map((P) => P.ref.current);
                if (b === "last") S.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && S.reverse();
                  const P = S.indexOf(y.currentTarget);
                  S = u.loop ? xB(S, P + 1) : S.slice(P + 1);
                }
                setTimeout(() => TC(S));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: f, hasTabStop: m != null }) : i
          }
        )
      }
    );
  }
);
NC.displayName = kC;
var yB = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function gB(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function bB(e, t, r) {
  const n = gB(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return yB[n];
}
function TC(e, t = !1) {
  const r = document.activeElement;
  for (const n of e)
    if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function xB(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var MC = CC, RC = NC, Sv = ["Enter", " "], wB = ["ArrowDown", "PageUp", "Home"], $C = ["ArrowUp", "PageDown", "End"], SB = [...wB, ...$C], OB = {
  ltr: [...Sv, "ArrowRight"],
  rtl: [...Sv, "ArrowLeft"]
}, PB = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Ds = "Menu", [Ri, AB, _B] = fg(Ds), [ma, IC] = K8(Ds, [
  _B,
  kn,
  Iu
]), js = kn(), DC = Iu(), [jC, Rn] = ma(Ds), [EB, Ls] = ma(Ds), LC = (e) => {
  const { __scopeMenu: t, open: r = !1, children: n, dir: a, onOpenChange: o, modal: i = !0 } = e, s = js(t), [c, l] = v.useState(null), u = v.useRef(!1), f = et(o), d = As(a);
  return v.useEffect(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => u.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ h(Cs, { ...s, children: /* @__PURE__ */ h(
    jC,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: c,
      onContentChange: l,
      children: /* @__PURE__ */ h(
        EB,
        {
          scope: t,
          onClose: v.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: u,
          dir: d,
          modal: i,
          children: n
        }
      )
    }
  ) });
};
LC.displayName = Ds;
var CB = "MenuAnchor", Eg = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, a = js(r);
    return /* @__PURE__ */ h(ks, { ...a, ...n, ref: t });
  }
);
Eg.displayName = CB;
var Cg = "MenuPortal", [kB, BC] = ma(Cg, {
  forceMount: void 0
}), FC = (e) => {
  const { __scopeMenu: t, forceMount: r, children: n, container: a } = e, o = Rn(Cg, t);
  return /* @__PURE__ */ h(kB, { scope: t, forceMount: r, children: /* @__PURE__ */ h(ot, { present: r || o.open, children: /* @__PURE__ */ h($o, { asChild: !0, container: a, children: n }) }) });
};
FC.displayName = Cg;
var Xt = "MenuContent", [NB, kg] = ma(Xt), zC = v.forwardRef(
  (e, t) => {
    const r = BC(Xt, e.__scopeMenu), { forceMount: n = r.forceMount, ...a } = e, o = Rn(Xt, e.__scopeMenu), i = Ls(Xt, e.__scopeMenu);
    return /* @__PURE__ */ h(Ri.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ h(ot, { present: n || o.open, children: /* @__PURE__ */ h(Ri.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ h(TB, { ...a, ref: t }) : /* @__PURE__ */ h(MB, { ...a, ref: t }) }) }) });
  }
), TB = v.forwardRef(
  (e, t) => {
    const r = Rn(Xt, e.__scopeMenu), n = v.useRef(null), a = me(t, n);
    return v.useEffect(() => {
      const o = n.current;
      if (o) return wu(o);
    }, []), /* @__PURE__ */ h(
      Ng,
      {
        ...e,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        disableOutsideScroll: !0,
        onFocusOutside: re(
          e.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => r.onOpenChange(!1)
      }
    );
  }
), MB = v.forwardRef((e, t) => {
  const r = Rn(Xt, e.__scopeMenu);
  return /* @__PURE__ */ h(
    Ng,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => r.onOpenChange(!1)
    }
  );
}), RB = /* @__PURE__ */ AC("MenuContent.ScrollLock"), Ng = v.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: r,
      loop: n = !1,
      trapFocus: a,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: c,
      onEscapeKeyDown: l,
      onPointerDownOutside: u,
      onFocusOutside: f,
      onInteractOutside: d,
      onDismiss: p,
      disableOutsideScroll: g,
      ...m
    } = e, y = Rn(Xt, r), b = Ls(Xt, r), w = js(r), S = DC(r), P = AB(r), [x, O] = v.useState(null), A = v.useRef(null), _ = me(t, A, y.onContentChange), N = v.useRef(0), M = v.useRef(""), T = v.useRef(0), k = v.useRef(null), $ = v.useRef("right"), R = v.useRef(0), L = g ? Ns : v.Fragment, j = g ? { as: RB, allowPinchZoom: !0 } : void 0, z = (I) => {
      var G, te;
      const B = M.current + I, W = P().filter((V) => !V.disabled), H = document.activeElement, U = (G = W.find((V) => V.ref.current === H)) == null ? void 0 : G.textValue, X = W.map((V) => V.textValue), ee = VB(X, B, U), ne = (te = W.find((V) => V.textValue === ee)) == null ? void 0 : te.ref.current;
      (function V(Y) {
        M.current = Y, window.clearTimeout(N.current), Y !== "" && (N.current = window.setTimeout(() => V(""), 1e3));
      })(B), ne && setTimeout(() => ne.focus());
    };
    v.useEffect(() => () => window.clearTimeout(N.current), []), hu();
    const q = v.useCallback((I) => {
      var W, H;
      return $.current === ((W = k.current) == null ? void 0 : W.side) && KB(I, (H = k.current) == null ? void 0 : H.area);
    }, []);
    return /* @__PURE__ */ h(
      NB,
      {
        scope: r,
        searchRef: M,
        onItemEnter: v.useCallback(
          (I) => {
            q(I) && I.preventDefault();
          },
          [q]
        ),
        onItemLeave: v.useCallback(
          (I) => {
            var B;
            q(I) || ((B = A.current) == null || B.focus(), O(null));
          },
          [q]
        ),
        onTriggerLeave: v.useCallback(
          (I) => {
            q(I) && I.preventDefault();
          },
          [q]
        ),
        pointerGraceTimerRef: T,
        onPointerGraceIntentChange: v.useCallback((I) => {
          k.current = I;
        }, []),
        children: /* @__PURE__ */ h(L, { ...j, children: /* @__PURE__ */ h(
          _s,
          {
            asChild: !0,
            trapped: a,
            onMountAutoFocus: re(o, (I) => {
              var B;
              I.preventDefault(), (B = A.current) == null || B.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ h(
              To,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: l,
                onPointerDownOutside: u,
                onFocusOutside: f,
                onInteractOutside: d,
                onDismiss: p,
                children: /* @__PURE__ */ h(
                  MC,
                  {
                    asChild: !0,
                    ...S,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: n,
                    currentTabStopId: x,
                    onCurrentTabStopIdChange: O,
                    onEntryFocus: re(c, (I) => {
                      b.isUsingKeyboardRef.current || I.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ h(
                      bu,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": ak(y.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...w,
                        ...m,
                        ref: _,
                        style: { outline: "none", ...m.style },
                        onKeyDown: re(m.onKeyDown, (I) => {
                          const W = I.target.closest("[data-radix-menu-content]") === I.currentTarget, H = I.ctrlKey || I.altKey || I.metaKey, U = I.key.length === 1;
                          W && (I.key === "Tab" && I.preventDefault(), !H && U && z(I.key));
                          const X = A.current;
                          if (I.target !== X || !SB.includes(I.key)) return;
                          I.preventDefault();
                          const ne = P().filter((G) => !G.disabled).map((G) => G.ref.current);
                          $C.includes(I.key) && ne.reverse(), WB(ne);
                        }),
                        onBlur: re(e.onBlur, (I) => {
                          I.currentTarget.contains(I.target) || (window.clearTimeout(N.current), M.current = "");
                        }),
                        onPointerMove: re(
                          e.onPointerMove,
                          $i((I) => {
                            const B = I.target, W = R.current !== I.clientX;
                            if (I.currentTarget.contains(B) && W) {
                              const H = I.clientX > R.current ? "right" : "left";
                              $.current = H, R.current = I.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
zC.displayName = Xt;
var $B = "MenuGroup", Tg = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ h($s.div, { role: "group", ...n, ref: t });
  }
);
Tg.displayName = $B;
var IB = "MenuLabel", qC = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ h($s.div, { ...n, ref: t });
  }
);
qC.displayName = IB;
var Uc = "MenuItem", Mb = "menu.itemSelect", Du = v.forwardRef(
  (e, t) => {
    const { disabled: r = !1, onSelect: n, ...a } = e, o = v.useRef(null), i = Ls(Uc, e.__scopeMenu), s = kg(Uc, e.__scopeMenu), c = me(t, o), l = v.useRef(!1), u = () => {
      const f = o.current;
      if (!r && f) {
        const d = new CustomEvent(Mb, { bubbles: !0, cancelable: !0 });
        f.addEventListener(Mb, (p) => n == null ? void 0 : n(p), { once: !0 }), tB(f, d), d.defaultPrevented ? l.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ h(
      WC,
      {
        ...a,
        ref: c,
        disabled: r,
        onClick: re(e.onClick, u),
        onPointerDown: (f) => {
          var d;
          (d = e.onPointerDown) == null || d.call(e, f), l.current = !0;
        },
        onPointerUp: re(e.onPointerUp, (f) => {
          var d;
          l.current || (d = f.currentTarget) == null || d.click();
        }),
        onKeyDown: re(e.onKeyDown, (f) => {
          const d = s.searchRef.current !== "";
          r || d && f.key === " " || Sv.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
Du.displayName = Uc;
var WC = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, disabled: n = !1, textValue: a, ...o } = e, i = kg(Uc, r), s = DC(r), c = v.useRef(null), l = me(t, c), [u, f] = v.useState(!1), [d, p] = v.useState("");
    return v.useEffect(() => {
      const g = c.current;
      g && p((g.textContent ?? "").trim());
    }, [o.children]), /* @__PURE__ */ h(
      Ri.ItemSlot,
      {
        scope: r,
        disabled: n,
        textValue: a ?? d,
        children: /* @__PURE__ */ h(RC, { asChild: !0, ...s, focusable: !n, children: /* @__PURE__ */ h(
          $s.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": n || void 0,
            "data-disabled": n ? "" : void 0,
            ...o,
            ref: l,
            onPointerMove: re(
              e.onPointerMove,
              $i((g) => {
                n ? i.onItemLeave(g) : (i.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: re(
              e.onPointerLeave,
              $i((g) => i.onItemLeave(g))
            ),
            onFocus: re(e.onFocus, () => f(!0)),
            onBlur: re(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), DB = "MenuCheckboxItem", HC = v.forwardRef(
  (e, t) => {
    const { checked: r = !1, onCheckedChange: n, ...a } = e;
    return /* @__PURE__ */ h(YC, { scope: e.__scopeMenu, checked: r, children: /* @__PURE__ */ h(
      Du,
      {
        role: "menuitemcheckbox",
        "aria-checked": Kc(r) ? "mixed" : r,
        ...a,
        ref: t,
        "data-state": $g(r),
        onSelect: re(
          a.onSelect,
          () => n == null ? void 0 : n(Kc(r) ? !0 : !r),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
HC.displayName = DB;
var VC = "MenuRadioGroup", [jB, LB] = ma(
  VC,
  { value: void 0, onValueChange: () => {
  } }
), UC = v.forwardRef(
  (e, t) => {
    const { value: r, onValueChange: n, ...a } = e, o = et(n);
    return /* @__PURE__ */ h(jB, { scope: e.__scopeMenu, value: r, onValueChange: o, children: /* @__PURE__ */ h(Tg, { ...a, ref: t }) });
  }
);
UC.displayName = VC;
var KC = "MenuRadioItem", GC = v.forwardRef(
  (e, t) => {
    const { value: r, ...n } = e, a = LB(KC, e.__scopeMenu), o = r === a.value;
    return /* @__PURE__ */ h(YC, { scope: e.__scopeMenu, checked: o, children: /* @__PURE__ */ h(
      Du,
      {
        role: "menuitemradio",
        "aria-checked": o,
        ...n,
        ref: t,
        "data-state": $g(o),
        onSelect: re(
          n.onSelect,
          () => {
            var i;
            return (i = a.onValueChange) == null ? void 0 : i.call(a, r);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
GC.displayName = KC;
var Mg = "MenuItemIndicator", [YC, BB] = ma(
  Mg,
  { checked: !1 }
), XC = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, forceMount: n, ...a } = e, o = BB(Mg, r);
    return /* @__PURE__ */ h(
      ot,
      {
        present: n || Kc(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ h(
          $s.span,
          {
            ...a,
            ref: t,
            "data-state": $g(o.checked)
          }
        )
      }
    );
  }
);
XC.displayName = Mg;
var FB = "MenuSeparator", ZC = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ h(
      $s.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...n,
        ref: t
      }
    );
  }
);
ZC.displayName = FB;
var zB = "MenuArrow", JC = v.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, a = js(r);
    return /* @__PURE__ */ h(xu, { ...a, ...n, ref: t });
  }
);
JC.displayName = zB;
var Rg = "MenuSub", [qB, QC] = ma(Rg), ek = (e) => {
  const { __scopeMenu: t, children: r, open: n = !1, onOpenChange: a } = e, o = Rn(Rg, t), i = js(t), [s, c] = v.useState(null), [l, u] = v.useState(null), f = et(a);
  return v.useEffect(() => (o.open === !1 && f(!1), () => f(!1)), [o.open, f]), /* @__PURE__ */ h(Cs, { ...i, children: /* @__PURE__ */ h(
    jC,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ h(
        qB,
        {
          scope: t,
          contentId: Ct(),
          triggerId: Ct(),
          trigger: s,
          onTriggerChange: c,
          children: r
        }
      )
    }
  ) });
};
ek.displayName = Rg;
var di = "MenuSubTrigger", tk = v.forwardRef(
  (e, t) => {
    const r = Rn(di, e.__scopeMenu), n = Ls(di, e.__scopeMenu), a = QC(di, e.__scopeMenu), o = kg(di, e.__scopeMenu), i = v.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = o, l = { __scopeMenu: e.__scopeMenu }, u = v.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return v.useEffect(() => u, [u]), v.useEffect(() => {
      const f = s.current;
      return () => {
        window.clearTimeout(f), c(null);
      };
    }, [s, c]), /* @__PURE__ */ h(Eg, { asChild: !0, ...l, children: /* @__PURE__ */ h(
      WC,
      {
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": r.open,
        "aria-controls": a.contentId,
        "data-state": ak(r.open),
        ...e,
        ref: He(t, a.onTriggerChange),
        onClick: (f) => {
          var d;
          (d = e.onClick) == null || d.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), r.open || r.onOpenChange(!0));
        },
        onPointerMove: re(
          e.onPointerMove,
          $i((f) => {
            o.onItemEnter(f), !f.defaultPrevented && !e.disabled && !r.open && !i.current && (o.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              r.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: re(
          e.onPointerLeave,
          $i((f) => {
            var p, g;
            u();
            const d = (p = r.content) == null ? void 0 : p.getBoundingClientRect();
            if (d) {
              const m = (g = r.content) == null ? void 0 : g.dataset.side, y = m === "right", b = y ? -5 : 5, w = d[y ? "left" : "right"], S = d[y ? "right" : "left"];
              o.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + b, y: f.clientY },
                  { x: w, y: d.top },
                  { x: S, y: d.top },
                  { x: S, y: d.bottom },
                  { x: w, y: d.bottom }
                ],
                side: m
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => o.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (o.onTriggerLeave(f), f.defaultPrevented) return;
              o.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: re(e.onKeyDown, (f) => {
          var p;
          const d = o.searchRef.current !== "";
          e.disabled || d && f.key === " " || OB[n.dir].includes(f.key) && (r.onOpenChange(!0), (p = r.content) == null || p.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
tk.displayName = di;
var rk = "MenuSubContent", nk = v.forwardRef(
  (e, t) => {
    const r = BC(Xt, e.__scopeMenu), { forceMount: n = r.forceMount, ...a } = e, o = Rn(Xt, e.__scopeMenu), i = Ls(Xt, e.__scopeMenu), s = QC(rk, e.__scopeMenu), c = v.useRef(null), l = me(t, c);
    return /* @__PURE__ */ h(Ri.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ h(ot, { present: n || o.open, children: /* @__PURE__ */ h(Ri.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ h(
      Ng,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...a,
        ref: l,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var f;
          i.isUsingKeyboardRef.current && ((f = c.current) == null || f.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: re(e.onFocusOutside, (u) => {
          u.target !== s.trigger && o.onOpenChange(!1);
        }),
        onEscapeKeyDown: re(e.onEscapeKeyDown, (u) => {
          i.onClose(), u.preventDefault();
        }),
        onKeyDown: re(e.onKeyDown, (u) => {
          var p;
          const f = u.currentTarget.contains(u.target), d = PB[i.dir].includes(u.key);
          f && d && (o.onOpenChange(!1), (p = s.trigger) == null || p.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
nk.displayName = rk;
function ak(e) {
  return e ? "open" : "closed";
}
function Kc(e) {
  return e === "indeterminate";
}
function $g(e) {
  return Kc(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function WB(e) {
  const t = document.activeElement;
  for (const r of e)
    if (r === t || (r.focus(), document.activeElement !== t)) return;
}
function HB(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
function VB(e, t, r) {
  const a = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, o = r ? e.indexOf(r) : -1;
  let i = HB(e, Math.max(o, 0));
  a.length === 1 && (i = i.filter((l) => l !== r));
  const c = i.find(
    (l) => l.toLowerCase().startsWith(a.toLowerCase())
  );
  return c !== r ? c : void 0;
}
function UB(e, t) {
  const { x: r, y: n } = e;
  let a = !1;
  for (let o = 0, i = t.length - 1; o < t.length; i = o++) {
    const s = t[o], c = t[i], l = s.x, u = s.y, f = c.x, d = c.y;
    u > n != d > n && r < (f - l) * (n - u) / (d - u) + l && (a = !a);
  }
  return a;
}
function KB(e, t) {
  if (!t) return !1;
  const r = { x: e.clientX, y: e.clientY };
  return UB(r, t);
}
function $i(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var GB = LC, YB = Eg, XB = FC, ZB = zC, JB = Tg, QB = qC, eF = Du, tF = HC, rF = UC, nF = GC, aF = XC, oF = ZC, iF = JC, sF = ek, cF = tk, lF = nk, ju = "DropdownMenu", [uF] = j8(
  ju,
  [IC]
), ht = IC(), [fF, ok] = uF(ju), ik = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: r,
    dir: n,
    open: a,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, c = ht(t), l = v.useRef(null), [u, f] = mr({
    prop: a,
    defaultProp: o ?? !1,
    onChange: i,
    caller: ju
  });
  return /* @__PURE__ */ h(
    fF,
    {
      scope: t,
      triggerId: Ct(),
      triggerRef: l,
      contentId: Ct(),
      open: u,
      onOpenChange: f,
      onOpenToggle: v.useCallback(() => f((d) => !d), [f]),
      modal: s,
      children: /* @__PURE__ */ h(GB, { ...c, open: u, onOpenChange: f, dir: n, modal: s, children: r })
    }
  );
};
ik.displayName = ju;
var sk = "DropdownMenuTrigger", ck = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, disabled: n = !1, ...a } = e, o = ok(sk, r), i = ht(r);
    return /* @__PURE__ */ h(YB, { asChild: !0, ...i, children: /* @__PURE__ */ h(
      U8.button,
      {
        type: "button",
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": o.open,
        "aria-controls": o.open ? o.contentId : void 0,
        "data-state": o.open ? "open" : "closed",
        "data-disabled": n ? "" : void 0,
        disabled: n,
        ...a,
        ref: He(t, o.triggerRef),
        onPointerDown: re(e.onPointerDown, (s) => {
          !n && s.button === 0 && s.ctrlKey === !1 && (o.onOpenToggle(), o.open || s.preventDefault());
        }),
        onKeyDown: re(e.onKeyDown, (s) => {
          n || (["Enter", " "].includes(s.key) && o.onOpenToggle(), s.key === "ArrowDown" && o.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
ck.displayName = sk;
var dF = "DropdownMenuPortal", lk = (e) => {
  const { __scopeDropdownMenu: t, ...r } = e, n = ht(t);
  return /* @__PURE__ */ h(XB, { ...n, ...r });
};
lk.displayName = dF;
var uk = "DropdownMenuContent", fk = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, a = ok(uk, r), o = ht(r), i = v.useRef(!1);
    return /* @__PURE__ */ h(
      ZB,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...o,
        ...n,
        ref: t,
        onCloseAutoFocus: re(e.onCloseAutoFocus, (s) => {
          var c;
          i.current || (c = a.triggerRef.current) == null || c.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: re(e.onInteractOutside, (s) => {
          const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || l;
          (!a.modal || u) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
fk.displayName = uk;
var pF = "DropdownMenuGroup", dk = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
    return /* @__PURE__ */ h(JB, { ...a, ...n, ref: t });
  }
);
dk.displayName = pF;
var hF = "DropdownMenuLabel", pk = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
    return /* @__PURE__ */ h(QB, { ...a, ...n, ref: t });
  }
);
pk.displayName = hF;
var mF = "DropdownMenuItem", hk = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
    return /* @__PURE__ */ h(eF, { ...a, ...n, ref: t });
  }
);
hk.displayName = mF;
var vF = "DropdownMenuCheckboxItem", mk = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
  return /* @__PURE__ */ h(tF, { ...a, ...n, ref: t });
});
mk.displayName = vF;
var yF = "DropdownMenuRadioGroup", vk = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
  return /* @__PURE__ */ h(rF, { ...a, ...n, ref: t });
});
vk.displayName = yF;
var gF = "DropdownMenuRadioItem", yk = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
  return /* @__PURE__ */ h(nF, { ...a, ...n, ref: t });
});
yk.displayName = gF;
var bF = "DropdownMenuItemIndicator", gk = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
  return /* @__PURE__ */ h(aF, { ...a, ...n, ref: t });
});
gk.displayName = bF;
var xF = "DropdownMenuSeparator", bk = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
  return /* @__PURE__ */ h(oF, { ...a, ...n, ref: t });
});
bk.displayName = xF;
var wF = "DropdownMenuArrow", SF = v.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
    return /* @__PURE__ */ h(iF, { ...a, ...n, ref: t });
  }
);
SF.displayName = wF;
var OF = (e) => {
  const { __scopeDropdownMenu: t, children: r, open: n, onOpenChange: a, defaultOpen: o } = e, i = ht(t), [s, c] = mr({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ h(sF, { ...i, open: s, onOpenChange: c, children: r });
}, PF = "DropdownMenuSubTrigger", xk = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
  return /* @__PURE__ */ h(cF, { ...a, ...n, ref: t });
});
xk.displayName = PF;
var AF = "DropdownMenuSubContent", wk = v.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, a = ht(r);
  return /* @__PURE__ */ h(
    lF,
    {
      ...a,
      ...n,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
wk.displayName = AF;
var _F = ik, EF = ck, Sk = lk, Ok = fk, CF = dk, Pk = pk, Ak = hk, _k = mk, kF = vk, Ek = yk, Ck = gk, kk = bk, NF = OF, Nk = xk, Tk = wk;
const wce = _F, Sce = EF, Oce = CF, Pce = Sk, Ace = NF, _ce = kF, TF = v.forwardRef(({ className: e, inset: t, children: r, ...n }, a) => /* @__PURE__ */ C(
  Nk,
  {
    ref: a,
    className: F(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-stone-100 data-[state=open]:bg-stone-100 dark:focus:bg-stone-800 dark:data-[state=open]:bg-stone-800",
      t && "pl-8",
      e
    ),
    ...n,
    children: [
      r,
      /* @__PURE__ */ h(uu, { className: "ml-auto h-4 w-4" })
    ]
  }
));
TF.displayName = Nk.displayName;
const MF = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  Tk,
  {
    ref: r,
    className: F(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border border-stone-200 bg-white p-1 text-stone-900 shadow-lg dark:border-stone-700 dark:bg-stone-900 dark:text-stone-100",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
MF.displayName = Tk.displayName;
const RF = v.forwardRef(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ h(Sk, { children: /* @__PURE__ */ h(
  Ok,
  {
    ref: n,
    sideOffset: t,
    className: F(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border border-stone-200 bg-white p-1 text-stone-900 shadow-md dark:border-stone-700 dark:bg-stone-900 dark:text-stone-100",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
) }));
RF.displayName = Ok.displayName;
const $F = v.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ h(
  Ak,
  {
    ref: n,
    className: F(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-stone-100 focus:text-stone-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-stone-800 dark:focus:text-stone-100",
      t && "pl-8",
      e
    ),
    ...r
  }
));
$F.displayName = Ak.displayName;
const IF = v.forwardRef(({ className: e, children: t, checked: r, ...n }, a) => /* @__PURE__ */ C(
  _k,
  {
    ref: a,
    className: F(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-stone-100 focus:text-stone-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-stone-800 dark:focus:text-stone-100",
      e
    ),
    checked: r,
    ...n,
    children: [
      /* @__PURE__ */ h("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ h(Ck, { children: /* @__PURE__ */ h(ha, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
IF.displayName = _k.displayName;
const DF = v.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ C(
  Ek,
  {
    ref: n,
    className: F(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-stone-100 focus:text-stone-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-stone-800 dark:focus:text-stone-100",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ h("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ h(Ck, { children: /* @__PURE__ */ h(R$, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
DF.displayName = Ek.displayName;
const jF = v.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ h(
  Pk,
  {
    ref: n,
    className: F(
      "px-2 py-1.5 text-sm font-semibold text-stone-900 dark:text-stone-100",
      t && "pl-8",
      e
    ),
    ...r
  }
));
jF.displayName = Pk.displayName;
const LF = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  kk,
  {
    ref: r,
    className: F("-mx-1 my-1 h-px bg-stone-200 dark:bg-stone-700", e),
    ...t
  }
));
LF.displayName = kk.displayName;
const BF = ({
  className: e,
  ...t
}) => /* @__PURE__ */ h(
  "span",
  {
    className: F(
      "ml-auto text-xs tracking-widest text-stone-500 dark:text-stone-400",
      e
    ),
    ...t
  }
);
BF.displayName = "DropdownMenuShortcut";
function FF(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, zF(a, ...t)];
}
function zF(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
// @__NO_SIDE_EFFECTS__
function qF(e) {
  const t = /* @__PURE__ */ WF(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(VF);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function WF(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = KF(a), s = UF(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var HF = Symbol("radix.slottable");
function VF(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === HF;
}
function UF(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function KF(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var GF = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Lu = GF.reduce((e, t) => {
  const r = /* @__PURE__ */ qF(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Bu = "Tabs", [YF] = FF(Bu, [
  Iu
]), Mk = Iu(), [XF, Ig] = YF(Bu), Rk = v.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: r,
      value: n,
      onValueChange: a,
      defaultValue: o,
      orientation: i = "horizontal",
      dir: s,
      activationMode: c = "automatic",
      ...l
    } = e, u = As(s), [f, d] = mr({
      prop: n,
      onChange: a,
      defaultProp: o ?? "",
      caller: Bu
    });
    return /* @__PURE__ */ h(
      XF,
      {
        scope: r,
        baseId: Ct(),
        value: f,
        onValueChange: d,
        orientation: i,
        dir: u,
        activationMode: c,
        children: /* @__PURE__ */ h(
          Lu.div,
          {
            dir: u,
            "data-orientation": i,
            ...l,
            ref: t
          }
        )
      }
    );
  }
);
Rk.displayName = Bu;
var $k = "TabsList", Ik = v.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, loop: n = !0, ...a } = e, o = Ig($k, r), i = Mk(r);
    return /* @__PURE__ */ h(
      MC,
      {
        asChild: !0,
        ...i,
        orientation: o.orientation,
        dir: o.dir,
        loop: n,
        children: /* @__PURE__ */ h(
          Lu.div,
          {
            role: "tablist",
            "aria-orientation": o.orientation,
            ...a,
            ref: t
          }
        )
      }
    );
  }
);
Ik.displayName = $k;
var Dk = "TabsTrigger", jk = v.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, disabled: a = !1, ...o } = e, i = Ig(Dk, r), s = Mk(r), c = Fk(i.baseId, n), l = zk(i.baseId, n), u = n === i.value;
    return /* @__PURE__ */ h(
      RC,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ h(
          Lu.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": l,
            "data-state": u ? "active" : "inactive",
            "data-disabled": a ? "" : void 0,
            disabled: a,
            id: c,
            ...o,
            ref: t,
            onMouseDown: re(e.onMouseDown, (f) => {
              !a && f.button === 0 && f.ctrlKey === !1 ? i.onValueChange(n) : f.preventDefault();
            }),
            onKeyDown: re(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && i.onValueChange(n);
            }),
            onFocus: re(e.onFocus, () => {
              const f = i.activationMode !== "manual";
              !u && !a && f && i.onValueChange(n);
            })
          }
        )
      }
    );
  }
);
jk.displayName = Dk;
var Lk = "TabsContent", Bk = v.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, forceMount: a, children: o, ...i } = e, s = Ig(Lk, r), c = Fk(s.baseId, n), l = zk(s.baseId, n), u = n === s.value, f = v.useRef(u);
    return v.useEffect(() => {
      const d = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(d);
    }, []), /* @__PURE__ */ h(ot, { present: a || u, children: ({ present: d }) => /* @__PURE__ */ h(
      Lu.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !d,
        id: l,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: d && o
      }
    ) });
  }
);
Bk.displayName = Lk;
function Fk(e, t) {
  return `${e}-trigger-${t}`;
}
function zk(e, t) {
  return `${e}-content-${t}`;
}
var ZF = Rk, JF = Ik, QF = jk, e9 = Bk;
const Ece = ZF, t9 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  JF,
  {
    ref: r,
    className: F(
      "inline-flex h-10 items-center justify-center rounded-md bg-stone-100 p-1 text-stone-500 dark:bg-stone-800 dark:text-stone-400",
      e
    ),
    ...t
  }
));
t9.displayName = "TabsList";
const r9 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  QF,
  {
    ref: r,
    className: F(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      "data-[state=active]:bg-white data-[state=active]:text-stone-900 data-[state=active]:shadow-sm",
      "dark:ring-offset-stone-950 dark:data-[state=active]:bg-stone-900 dark:data-[state=active]:text-stone-100",
      e
    ),
    ...t
  }
));
r9.displayName = "TabsTrigger";
const n9 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  e9,
  {
    ref: r,
    className: F(
      "mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:ring-offset-stone-950",
      e
    ),
    ...t
  }
));
n9.displayName = "TabsContent";
function a9(e, t, r) {
  if (t <= r)
    return Array.from({ length: t }, (s, c) => c + 1);
  const n = [];
  n.push(1);
  const a = Math.floor((r - 3) / 2);
  let o = Math.max(2, e - a), i = Math.min(t - 1, e + a);
  e <= a + 2 && (i = Math.min(t - 1, r - 2)), e >= t - a - 1 && (o = Math.max(2, t - r + 3)), o > 2 && n.push("ellipsis");
  for (let s = o; s <= i; s++)
    n.push(s);
  return i < t - 1 && n.push("ellipsis"), t > 1 && n.push(t), n;
}
const Dg = v.forwardRef(
  ({
    className: e,
    currentPage: t,
    totalPages: r,
    onPageChange: n,
    showPageNumbers: a = !0,
    maxPageButtons: o = 5,
    ...i
  }, s) => {
    const c = a9(t, r, o);
    return /* @__PURE__ */ h(
      "nav",
      {
        ref: s,
        "aria-label": "pagination",
        className: F("mx-auto flex w-full justify-center", e),
        ...i,
        children: /* @__PURE__ */ C("ul", { className: "flex flex-row items-center gap-1", children: [
          /* @__PURE__ */ h("li", { children: /* @__PURE__ */ C(
            Te,
            {
              variant: "outline",
              size: "sm",
              disabled: t === 1,
              onClick: () => n(t - 1),
              "aria-label": "Go to previous page",
              children: [
                /* @__PURE__ */ h(Zy, { className: "h-4 w-4" }),
                /* @__PURE__ */ h("span", { className: "hidden sm:inline", children: "Previous" })
              ]
            }
          ) }),
          a && c.map(
            (l, u) => l === "ellipsis" ? /* @__PURE__ */ h("li", { children: /* @__PURE__ */ h(
              "span",
              {
                className: "flex h-8 w-8 items-center justify-center",
                "aria-hidden": "true",
                children: /* @__PURE__ */ h(D$, { className: "h-4 w-4 text-stone-400" })
              }
            ) }, `ellipsis-${u}`) : /* @__PURE__ */ h("li", { children: /* @__PURE__ */ h(
              Te,
              {
                variant: l === t ? "primary" : "outline",
                size: "sm",
                onClick: () => n(l),
                "aria-label": `Go to page ${l}`,
                "aria-current": l === t ? "page" : void 0,
                children: l
              }
            ) }, l)
          ),
          /* @__PURE__ */ h("li", { children: /* @__PURE__ */ C(
            Te,
            {
              variant: "outline",
              size: "sm",
              disabled: t === r,
              onClick: () => n(t + 1),
              "aria-label": "Go to next page",
              children: [
                /* @__PURE__ */ h("span", { className: "hidden sm:inline", children: "Next" }),
                /* @__PURE__ */ h(uu, { className: "h-4 w-4" })
              ]
            }
          ) })
        ] })
      }
    );
  }
);
Dg.displayName = "Pagination";
function Cce({
  open: e,
  onOpenChange: t,
  title: r,
  description: n,
  confirmLabel: a = "Confirm",
  cancelLabel: o = "Cancel",
  variant: i = "destructive",
  onConfirm: s,
  isLoading: c,
  icon: l
}) {
  const [u, f] = pr(!1), d = c || u, p = async () => {
    f(!0);
    try {
      await s(), t(!1);
    } finally {
      f(!1);
    }
  }, g = i === "destructive" ? /* @__PURE__ */ h(Os, { className: "h-5 w-5 text-red-500" }) : /* @__PURE__ */ h(av, { className: "h-5 w-5 text-primary-600" });
  return /* @__PURE__ */ h(Y3, { open: e, onOpenChange: t, children: /* @__PURE__ */ C(H2, { className: "sm:max-w-[425px]", children: [
    /* @__PURE__ */ h(V2, { children: /* @__PURE__ */ C("div", { className: "flex items-start gap-3", children: [
      /* @__PURE__ */ h(
        "div",
        {
          className: F(
            "flex h-10 w-10 shrink-0 items-center justify-center rounded-full",
            i === "destructive" ? "bg-red-100 dark:bg-red-900/30" : "bg-primary-100 dark:bg-primary-900/30"
          ),
          children: l || g
        }
      ),
      /* @__PURE__ */ C("div", { className: "space-y-1.5", children: [
        /* @__PURE__ */ h(K2, { children: r }),
        /* @__PURE__ */ h(G2, { children: n })
      ] })
    ] }) }),
    /* @__PURE__ */ C(U2, { children: [
      /* @__PURE__ */ h(
        Te,
        {
          variant: "outline",
          onClick: () => t(!1),
          disabled: d,
          children: o
        }
      ),
      /* @__PURE__ */ h(
        Te,
        {
          variant: i === "destructive" ? "destructive" : "primary",
          onClick: p,
          isLoading: d,
          children: a
        }
      )
    ] })
  ] }) });
}
const o9 = Ye("h-full rounded-full transition-all duration-500 ease-out", {
  variants: {
    variant: {
      default: "bg-primary-600",
      primary: "bg-primary-600",
      success: "bg-green-500",
      warning: "bg-yellow-500",
      danger: "bg-red-500",
      info: "bg-blue-500"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), qk = Ye("w-full overflow-hidden rounded-full bg-stone-200 dark:bg-stone-700", {
  variants: {
    size: {
      sm: "h-1.5",
      md: "h-2.5",
      lg: "h-4"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), i9 = v.forwardRef(
  ({
    className: e,
    value: t,
    max: r = 100,
    size: n = "md",
    variant: a = "default",
    label: o,
    showPercentage: i = !1,
    animated: s = !0,
    striped: c = !1,
    autoVariant: l = !1,
    ...u
  }, f) => {
    const d = Math.min(Math.max(t / r * 100, 0), 100);
    let p = a;
    return l && (d >= 90 ? p = "danger" : d >= 70 ? p = "warning" : p = "success"), /* @__PURE__ */ C("div", { ref: f, className: F("w-full", e), ...u, children: [
      (o || i) && /* @__PURE__ */ C("div", { className: "mb-1 flex items-center justify-between", children: [
        o && /* @__PURE__ */ h("span", { className: "text-sm font-medium text-stone-700 dark:text-stone-300", children: o }),
        i && /* @__PURE__ */ C("span", { className: "text-sm font-medium text-stone-500 dark:text-stone-400", children: [
          Math.round(d),
          "%"
        ] })
      ] }),
      /* @__PURE__ */ h("div", { className: F(qk({ size: n })), children: /* @__PURE__ */ h(
        "div",
        {
          className: F(
            o9({ variant: p }),
            c && "bg-[length:1rem_1rem] bg-[linear-gradient(45deg,rgba(255,255,255,.15)_25%,transparent_25%,transparent_50%,rgba(255,255,255,.15)_50%,rgba(255,255,255,.15)_75%,transparent_75%,transparent)]",
            s && c && "animate-[progress-stripes_1s_linear_infinite]",
            !s && "transition-none"
          ),
          style: { width: `${d}%` },
          role: "progressbar",
          "aria-valuenow": t,
          "aria-valuemin": 0,
          "aria-valuemax": r,
          "aria-label": o
        }
      ) })
    ] });
  }
);
i9.displayName = "ProgressBar";
const s9 = v.forwardRef(
  ({ className: e, segments: t, size: r = "md", showLegend: n = !1, total: a, ...o }, i) => {
    const s = a || t.reduce((c, l) => c + l.value, 0);
    return /* @__PURE__ */ C("div", { ref: i, className: F("w-full", e), ...o, children: [
      /* @__PURE__ */ h("div", { className: F(qk({ size: r }), "flex"), children: t.map((c, l) => {
        const u = s > 0 ? c.value / s * 100 : 0;
        return /* @__PURE__ */ h(
          "div",
          {
            className: F(
              "h-full transition-all duration-500",
              l === 0 && "rounded-l-full",
              l === t.length - 1 && "rounded-r-full"
            ),
            style: { width: `${u}%`, backgroundColor: c.color }
          },
          l
        );
      }) }),
      n && /* @__PURE__ */ h("div", { className: "mt-2 flex flex-wrap gap-3", children: t.map((c, l) => /* @__PURE__ */ C("div", { className: "flex items-center gap-1.5", children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "h-2.5 w-2.5 rounded-full",
            style: { backgroundColor: c.color }
          }
        ),
        /* @__PURE__ */ C("span", { className: "text-xs text-stone-600 dark:text-stone-400", children: [
          c.label || `Segment ${l + 1}`,
          ": ",
          c.value
        ] })
      ] }, l)) })
    ] });
  }
);
s9.displayName = "SegmentedProgress";
const c9 = Ye(
  "flex flex-col items-center justify-center text-center",
  {
    variants: {
      size: {
        sm: "py-6 px-4 gap-2",
        md: "py-10 px-6 gap-3",
        lg: "py-16 px-8 gap-4"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), l9 = {
  sm: "h-8 w-8",
  md: "h-12 w-12",
  lg: "h-16 w-16"
}, u9 = {
  "no-data": B$,
  "no-results": eI,
  error: ws,
  "no-mentions": K$,
  "no-transactions": J$,
  "empty-inbox": q$
}, Wk = v.forwardRef(
  ({
    className: e,
    size: t = "md",
    illustration: r = "no-data",
    icon: n,
    title: a,
    description: o,
    action: i,
    secondaryAction: s,
    bordered: c = !1,
    ...l
  }, u) => {
    const f = u9[r], d = t || "md";
    return /* @__PURE__ */ C(
      "div",
      {
        ref: u,
        className: F(
          c9({ size: t }),
          c && "rounded-lg border-2 border-dashed border-stone-300 dark:border-stone-600",
          e
        ),
        ...l,
        children: [
          /* @__PURE__ */ h("div", { className: "text-stone-400 dark:text-stone-500", children: n || /* @__PURE__ */ h(f, { className: l9[d] }) }),
          /* @__PURE__ */ C("div", { className: "space-y-1", children: [
            /* @__PURE__ */ h(
              "h3",
              {
                className: F(
                  "font-semibold text-stone-900 dark:text-stone-100",
                  d === "sm" && "text-sm",
                  d === "md" && "text-base",
                  d === "lg" && "text-lg"
                ),
                children: a
              }
            ),
            o && /* @__PURE__ */ h(
              "p",
              {
                className: F(
                  "text-stone-500 dark:text-stone-400",
                  d === "sm" && "text-xs",
                  d === "md" && "text-sm",
                  d === "lg" && "text-base"
                ),
                children: o
              }
            )
          ] }),
          (i || s) && /* @__PURE__ */ C("div", { className: "flex items-center gap-2 pt-2", children: [
            i && /* @__PURE__ */ h(
              Te,
              {
                variant: i.variant || "primary",
                size: d === "lg" ? "md" : "sm",
                onClick: i.onClick,
                children: i.label
              }
            ),
            s && /* @__PURE__ */ h(
              Te,
              {
                variant: "ghost",
                size: d === "lg" ? "md" : "sm",
                onClick: s.onClick,
                children: s.label
              }
            )
          ] })
        ]
      }
    );
  }
);
Wk.displayName = "EmptyState";
const kce = F2, Nce = z2, Tce = Tu, f9 = q2, Hk = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  Eu,
  {
    ref: r,
    className: F(
      "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Hk.displayName = Eu.displayName;
const d9 = Ye(
  "fixed z-50 gap-4 bg-white p-6 shadow-lg transition ease-in-out dark:bg-stone-900 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b border-stone-200 dark:border-stone-700 data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t border-stone-200 dark:border-stone-700 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r border-stone-200 dark:border-stone-700 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l border-stone-200 dark:border-stone-700 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), p9 = v.forwardRef(({ side: e = "right", className: t, children: r, ...n }, a) => /* @__PURE__ */ C(f9, { children: [
  /* @__PURE__ */ h(Hk, {}),
  /* @__PURE__ */ C(
    Cu,
    {
      ref: a,
      className: F(d9({ side: e }), t),
      ...n,
      children: [
        r,
        /* @__PURE__ */ C(Tu, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-stone-100 dark:ring-offset-stone-900 dark:data-[state=open]:bg-stone-800", children: [
          /* @__PURE__ */ h(An, { className: "h-4 w-4" }),
          /* @__PURE__ */ h("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
p9.displayName = Cu.displayName;
const h9 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ h(
  "div",
  {
    className: F(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
h9.displayName = "SheetHeader";
const m9 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ h(
  "div",
  {
    className: F(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
m9.displayName = "SheetFooter";
const v9 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  ku,
  {
    ref: r,
    className: F(
      "text-lg font-semibold text-stone-900 dark:text-stone-100",
      e
    ),
    ...t
  }
));
v9.displayName = ku.displayName;
const y9 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  Nu,
  {
    ref: r,
    className: F("text-sm text-stone-500 dark:text-stone-400", e),
    ...t
  }
));
y9.displayName = Nu.displayName;
// @__NO_SIDE_EFFECTS__
function g9(e) {
  const t = /* @__PURE__ */ b9(e), r = v.forwardRef((n, a) => {
    const { children: o, ...i } = n, s = v.Children.toArray(o), c = s.find(w9);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? v.Children.count(l) > 1 ? v.Children.only(null) : v.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ h(t, { ...i, ref: a, children: v.isValidElement(l) ? v.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ h(t, { ...i, ref: a, children: o });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function b9(e) {
  const t = v.forwardRef((r, n) => {
    const { children: a, ...o } = r;
    if (v.isValidElement(a)) {
      const i = O9(a), s = S9(o, a.props);
      return a.type !== v.Fragment && (s.ref = n ? He(n, i) : i), v.cloneElement(a, s);
    }
    return v.Children.count(a) > 1 ? v.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var x9 = Symbol("radix.slottable");
function w9(e) {
  return v.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === x9;
}
function S9(e, t) {
  const r = { ...t };
  for (const n in t) {
    const a = e[n], o = t[n];
    /^on[A-Z]/.test(n) ? a && o ? r[n] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...o } : n === "className" && (r[n] = [a, o].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function O9(e) {
  var n, a;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var P9 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Bs = P9.reduce((e, t) => {
  const r = /* @__PURE__ */ g9(`Primitive.${t}`), n = v.forwardRef((a, o) => {
    const { asChild: i, ...s } = a, c = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(c, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function A9(e, t = []) {
  let r = [];
  function n(o, i) {
    const s = v.createContext(i), c = r.length;
    r = [...r, i];
    const l = (f) => {
      var b;
      const { scope: d, children: p, ...g } = f, m = ((b = d == null ? void 0 : d[e]) == null ? void 0 : b[c]) || s, y = v.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ h(m.Provider, { value: y, children: p });
    };
    l.displayName = o + "Provider";
    function u(f, d) {
      var m;
      const p = ((m = d == null ? void 0 : d[e]) == null ? void 0 : m[c]) || s, g = v.useContext(p);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [l, u];
  }
  const a = () => {
    const o = r.map((i) => v.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return v.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = e, [n, _9(a, ...t)];
}
function _9(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const i = n.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(o)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return v.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function E9(e, t) {
  return v.useReducer((r, n) => t[r][n] ?? r, e);
}
var jg = "ScrollArea", [Vk] = A9(jg), [C9, tr] = Vk(jg), Uk = v.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: r,
      type: n = "hover",
      dir: a,
      scrollHideDelay: o = 600,
      ...i
    } = e, [s, c] = v.useState(null), [l, u] = v.useState(null), [f, d] = v.useState(null), [p, g] = v.useState(null), [m, y] = v.useState(null), [b, w] = v.useState(0), [S, P] = v.useState(0), [x, O] = v.useState(!1), [A, _] = v.useState(!1), N = me(t, (T) => c(T)), M = As(a);
    return /* @__PURE__ */ h(
      C9,
      {
        scope: r,
        type: n,
        dir: M,
        scrollHideDelay: o,
        scrollArea: s,
        viewport: l,
        onViewportChange: u,
        content: f,
        onContentChange: d,
        scrollbarX: p,
        onScrollbarXChange: g,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: O,
        scrollbarY: m,
        onScrollbarYChange: y,
        scrollbarYEnabled: A,
        onScrollbarYEnabledChange: _,
        onCornerWidthChange: w,
        onCornerHeightChange: P,
        children: /* @__PURE__ */ h(
          Bs.div,
          {
            dir: M,
            ...i,
            ref: N,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": S + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Uk.displayName = jg;
var Kk = "ScrollAreaViewport", Gk = v.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, children: n, nonce: a, ...o } = e, i = tr(Kk, r), s = v.useRef(null), c = me(t, s, i.onViewportChange);
    return /* @__PURE__ */ C(Ve, { children: [
      /* @__PURE__ */ h(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: a
        }
      ),
      /* @__PURE__ */ h(
        Bs.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...o,
          ref: c,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ h("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: n })
        }
      )
    ] });
  }
);
Gk.displayName = Kk;
var Dr = "ScrollAreaScrollbar", Lg = v.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, a = tr(Dr, e.__scopeScrollArea), { onScrollbarXEnabledChange: o, onScrollbarYEnabledChange: i } = a, s = e.orientation === "horizontal";
    return v.useEffect(() => (s ? o(!0) : i(!0), () => {
      s ? o(!1) : i(!1);
    }), [s, o, i]), a.type === "hover" ? /* @__PURE__ */ h(k9, { ...n, ref: t, forceMount: r }) : a.type === "scroll" ? /* @__PURE__ */ h(N9, { ...n, ref: t, forceMount: r }) : a.type === "auto" ? /* @__PURE__ */ h(Yk, { ...n, ref: t, forceMount: r }) : a.type === "always" ? /* @__PURE__ */ h(Bg, { ...n, ref: t }) : null;
  }
);
Lg.displayName = Dr;
var k9 = v.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, a = tr(Dr, e.__scopeScrollArea), [o, i] = v.useState(!1);
  return v.useEffect(() => {
    const s = a.scrollArea;
    let c = 0;
    if (s) {
      const l = () => {
        window.clearTimeout(c), i(!0);
      }, u = () => {
        c = window.setTimeout(() => i(!1), a.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", l), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(c), s.removeEventListener("pointerenter", l), s.removeEventListener("pointerleave", u);
      };
    }
  }, [a.scrollArea, a.scrollHideDelay]), /* @__PURE__ */ h(ot, { present: r || o, children: /* @__PURE__ */ h(
    Yk,
    {
      "data-state": o ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), N9 = v.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, a = tr(Dr, e.__scopeScrollArea), o = e.orientation === "horizontal", i = zu(() => c("SCROLL_END"), 100), [s, c] = E9("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return v.useEffect(() => {
    if (s === "idle") {
      const l = window.setTimeout(() => c("HIDE"), a.scrollHideDelay);
      return () => window.clearTimeout(l);
    }
  }, [s, a.scrollHideDelay, c]), v.useEffect(() => {
    const l = a.viewport, u = o ? "scrollLeft" : "scrollTop";
    if (l) {
      let f = l[u];
      const d = () => {
        const p = l[u];
        f !== p && (c("SCROLL"), i()), f = p;
      };
      return l.addEventListener("scroll", d), () => l.removeEventListener("scroll", d);
    }
  }, [a.viewport, o, c, i]), /* @__PURE__ */ h(ot, { present: r || s !== "hidden", children: /* @__PURE__ */ h(
    Bg,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...n,
      ref: t,
      onPointerEnter: re(e.onPointerEnter, () => c("POINTER_ENTER")),
      onPointerLeave: re(e.onPointerLeave, () => c("POINTER_LEAVE"))
    }
  ) });
}), Yk = v.forwardRef((e, t) => {
  const r = tr(Dr, e.__scopeScrollArea), { forceMount: n, ...a } = e, [o, i] = v.useState(!1), s = e.orientation === "horizontal", c = zu(() => {
    if (r.viewport) {
      const l = r.viewport.offsetWidth < r.viewport.scrollWidth, u = r.viewport.offsetHeight < r.viewport.scrollHeight;
      i(s ? l : u);
    }
  }, 10);
  return Ga(r.viewport, c), Ga(r.content, c), /* @__PURE__ */ h(ot, { present: n || o, children: /* @__PURE__ */ h(
    Bg,
    {
      "data-state": o ? "visible" : "hidden",
      ...a,
      ref: t
    }
  ) });
}), Bg = v.forwardRef((e, t) => {
  const { orientation: r = "vertical", ...n } = e, a = tr(Dr, e.__scopeScrollArea), o = v.useRef(null), i = v.useRef(0), [s, c] = v.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), l = eN(s.viewport, s.content), u = {
    ...n,
    sizes: s,
    onSizesChange: c,
    hasThumb: l > 0 && l < 1,
    onThumbChange: (d) => o.current = d,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (d) => i.current = d
  };
  function f(d, p) {
    return D9(d, i.current, s, p);
  }
  return r === "horizontal" ? /* @__PURE__ */ h(
    T9,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (a.viewport && o.current) {
          const d = a.viewport.scrollLeft, p = Rb(d, s, a.dir);
          o.current.style.transform = `translate3d(${p}px, 0, 0)`;
        }
      },
      onWheelScroll: (d) => {
        a.viewport && (a.viewport.scrollLeft = d);
      },
      onDragScroll: (d) => {
        a.viewport && (a.viewport.scrollLeft = f(d, a.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ h(
    M9,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (a.viewport && o.current) {
          const d = a.viewport.scrollTop, p = Rb(d, s);
          o.current.style.transform = `translate3d(0, ${p}px, 0)`;
        }
      },
      onWheelScroll: (d) => {
        a.viewport && (a.viewport.scrollTop = d);
      },
      onDragScroll: (d) => {
        a.viewport && (a.viewport.scrollTop = f(d));
      }
    }
  ) : null;
}), T9 = v.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...a } = e, o = tr(Dr, e.__scopeScrollArea), [i, s] = v.useState(), c = v.useRef(null), l = me(t, c, o.onScrollbarXChange);
  return v.useEffect(() => {
    c.current && s(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ h(
    Zk,
    {
      "data-orientation": "horizontal",
      ...a,
      ref: l,
      sizes: r,
      style: {
        bottom: 0,
        left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Fu(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, f) => {
        if (o.viewport) {
          const d = o.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(d), rN(d, f) && u.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && i && n({
          content: o.viewport.scrollWidth,
          viewport: o.viewport.offsetWidth,
          scrollbar: {
            size: c.current.clientWidth,
            paddingStart: Yc(i.paddingLeft),
            paddingEnd: Yc(i.paddingRight)
          }
        });
      }
    }
  );
}), M9 = v.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...a } = e, o = tr(Dr, e.__scopeScrollArea), [i, s] = v.useState(), c = v.useRef(null), l = me(t, c, o.onScrollbarYChange);
  return v.useEffect(() => {
    c.current && s(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ h(
    Zk,
    {
      "data-orientation": "vertical",
      ...a,
      ref: l,
      sizes: r,
      style: {
        top: 0,
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Fu(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, f) => {
        if (o.viewport) {
          const d = o.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(d), rN(d, f) && u.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && i && n({
          content: o.viewport.scrollHeight,
          viewport: o.viewport.offsetHeight,
          scrollbar: {
            size: c.current.clientHeight,
            paddingStart: Yc(i.paddingTop),
            paddingEnd: Yc(i.paddingBottom)
          }
        });
      }
    }
  );
}), [R9, Xk] = Vk(Dr), Zk = v.forwardRef((e, t) => {
  const {
    __scopeScrollArea: r,
    sizes: n,
    hasThumb: a,
    onThumbChange: o,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: c,
    onDragScroll: l,
    onWheelScroll: u,
    onResize: f,
    ...d
  } = e, p = tr(Dr, r), [g, m] = v.useState(null), y = me(t, (N) => m(N)), b = v.useRef(null), w = v.useRef(""), S = p.viewport, P = n.content - n.viewport, x = et(u), O = et(c), A = zu(f, 10);
  function _(N) {
    if (b.current) {
      const M = N.clientX - b.current.left, T = N.clientY - b.current.top;
      l({ x: M, y: T });
    }
  }
  return v.useEffect(() => {
    const N = (M) => {
      const T = M.target;
      (g == null ? void 0 : g.contains(T)) && x(M, P);
    };
    return document.addEventListener("wheel", N, { passive: !1 }), () => document.removeEventListener("wheel", N, { passive: !1 });
  }, [S, g, P, x]), v.useEffect(O, [n, O]), Ga(g, A), Ga(p.content, A), /* @__PURE__ */ h(
    R9,
    {
      scope: r,
      scrollbar: g,
      hasThumb: a,
      onThumbChange: et(o),
      onThumbPointerUp: et(i),
      onThumbPositionChange: O,
      onThumbPointerDown: et(s),
      children: /* @__PURE__ */ h(
        Bs.div,
        {
          ...d,
          ref: y,
          style: { position: "absolute", ...d.style },
          onPointerDown: re(e.onPointerDown, (N) => {
            N.button === 0 && (N.target.setPointerCapture(N.pointerId), b.current = g.getBoundingClientRect(), w.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", p.viewport && (p.viewport.style.scrollBehavior = "auto"), _(N));
          }),
          onPointerMove: re(e.onPointerMove, _),
          onPointerUp: re(e.onPointerUp, (N) => {
            const M = N.target;
            M.hasPointerCapture(N.pointerId) && M.releasePointerCapture(N.pointerId), document.body.style.webkitUserSelect = w.current, p.viewport && (p.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), Gc = "ScrollAreaThumb", Jk = v.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, a = Xk(Gc, e.__scopeScrollArea);
    return /* @__PURE__ */ h(ot, { present: r || a.hasThumb, children: /* @__PURE__ */ h($9, { ref: t, ...n }) });
  }
), $9 = v.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, style: n, ...a } = e, o = tr(Gc, r), i = Xk(Gc, r), { onThumbPositionChange: s } = i, c = me(
      t,
      (f) => i.onThumbChange(f)
    ), l = v.useRef(void 0), u = zu(() => {
      l.current && (l.current(), l.current = void 0);
    }, 100);
    return v.useEffect(() => {
      const f = o.viewport;
      if (f) {
        const d = () => {
          if (u(), !l.current) {
            const p = j9(f, s);
            l.current = p, s();
          }
        };
        return s(), f.addEventListener("scroll", d), () => f.removeEventListener("scroll", d);
      }
    }, [o.viewport, u, s]), /* @__PURE__ */ h(
      Bs.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...a,
        ref: c,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...n
        },
        onPointerDownCapture: re(e.onPointerDownCapture, (f) => {
          const p = f.target.getBoundingClientRect(), g = f.clientX - p.left, m = f.clientY - p.top;
          i.onThumbPointerDown({ x: g, y: m });
        }),
        onPointerUp: re(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
Jk.displayName = Gc;
var Fg = "ScrollAreaCorner", Qk = v.forwardRef(
  (e, t) => {
    const r = tr(Fg, e.__scopeScrollArea), n = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && n ? /* @__PURE__ */ h(I9, { ...e, ref: t }) : null;
  }
);
Qk.displayName = Fg;
var I9 = v.forwardRef((e, t) => {
  const { __scopeScrollArea: r, ...n } = e, a = tr(Fg, r), [o, i] = v.useState(0), [s, c] = v.useState(0), l = !!(o && s);
  return Ga(a.scrollbarX, () => {
    var f;
    const u = ((f = a.scrollbarX) == null ? void 0 : f.offsetHeight) || 0;
    a.onCornerHeightChange(u), c(u);
  }), Ga(a.scrollbarY, () => {
    var f;
    const u = ((f = a.scrollbarY) == null ? void 0 : f.offsetWidth) || 0;
    a.onCornerWidthChange(u), i(u);
  }), l ? /* @__PURE__ */ h(
    Bs.div,
    {
      ...n,
      ref: t,
      style: {
        width: o,
        height: s,
        position: "absolute",
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Yc(e) {
  return e ? parseInt(e, 10) : 0;
}
function eN(e, t) {
  const r = e / t;
  return isNaN(r) ? 0 : r;
}
function Fu(e) {
  const t = eN(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, n = (e.scrollbar.size - r) * t;
  return Math.max(n, 18);
}
function D9(e, t, r, n = "ltr") {
  const a = Fu(r), o = a / 2, i = t || o, s = a - i, c = r.scrollbar.paddingStart + i, l = r.scrollbar.size - r.scrollbar.paddingEnd - s, u = r.content - r.viewport, f = n === "ltr" ? [0, u] : [u * -1, 0];
  return tN([c, l], f)(e);
}
function Rb(e, t, r = "ltr") {
  const n = Fu(t), a = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, o = t.scrollbar.size - a, i = t.content - t.viewport, s = o - n, c = r === "ltr" ? [0, i] : [i * -1, 0], l = sv(e, c);
  return tN([0, i], [0, s])(l);
}
function tN(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function rN(e, t) {
  return e > 0 && e < t;
}
var j9 = (e, t = () => {
}) => {
  let r = { left: e.scrollLeft, top: e.scrollTop }, n = 0;
  return (function a() {
    const o = { left: e.scrollLeft, top: e.scrollTop }, i = r.left !== o.left, s = r.top !== o.top;
    (i || s) && t(), r = o, n = window.requestAnimationFrame(a);
  })(), () => window.cancelAnimationFrame(n);
};
function zu(e, t) {
  const r = et(e), n = v.useRef(0);
  return v.useEffect(() => () => window.clearTimeout(n.current), []), v.useCallback(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(r, t);
  }, [r, t]);
}
function Ga(e, t) {
  const r = et(t);
  Ge(() => {
    let n = 0;
    if (e) {
      const a = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(r);
      });
      return a.observe(e), () => {
        window.cancelAnimationFrame(n), a.unobserve(e);
      };
    }
  }, [e, r]);
}
var nN = Uk, L9 = Gk, B9 = Qk;
const F9 = v.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ C(
  nN,
  {
    ref: n,
    className: F("relative overflow-hidden", e),
    ...r,
    children: [
      /* @__PURE__ */ h(L9, { className: "h-full w-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ h(aN, {}),
      /* @__PURE__ */ h(B9, {})
    ]
  }
));
F9.displayName = nN.displayName;
const aN = v.forwardRef(({ className: e, orientation: t = "vertical", ...r }, n) => /* @__PURE__ */ h(
  Lg,
  {
    ref: n,
    orientation: t,
    className: F(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...r,
    children: /* @__PURE__ */ h(Jk, { className: "relative flex-1 rounded-full bg-stone-300 dark:bg-stone-600" })
  }
));
aN.displayName = Lg.displayName;
const z9 = v.forwardRef(
  ({
    className: e,
    label: t,
    htmlFor: r,
    required: n = !1,
    error: a,
    helperText: o,
    description: i,
    children: s,
    ...c
  }, l) => /* @__PURE__ */ C("div", { ref: l, className: F("space-y-2", e), ...c, children: [
    t && /* @__PURE__ */ C("div", { className: "space-y-0.5", children: [
      /* @__PURE__ */ h(X_, { htmlFor: r, required: n, children: t }),
      i && /* @__PURE__ */ h("p", { className: "text-xs text-stone-500 dark:text-stone-400", children: i })
    ] }),
    s,
    a && /* @__PURE__ */ h("p", { className: "text-sm text-red-500 dark:text-red-400", children: a }),
    !a && o && /* @__PURE__ */ h("p", { className: "text-sm text-stone-500 dark:text-stone-400", children: o })
  ] })
);
z9.displayName = "FormField";
const q9 = Ye(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4",
  {
    variants: {
      variant: {
        default: "border-stone-200 bg-white text-stone-900 dark:border-stone-700 dark:bg-stone-900 dark:text-stone-100 [&>svg]:text-stone-500",
        destructive: "border-red-200 bg-red-50 text-red-900 dark:border-red-800 dark:bg-red-950 dark:text-red-100 [&>svg]:text-red-500",
        success: "border-green-200 bg-green-50 text-green-900 dark:border-green-800 dark:bg-green-950 dark:text-green-100 [&>svg]:text-green-500",
        warning: "border-yellow-200 bg-yellow-50 text-yellow-900 dark:border-yellow-800 dark:bg-yellow-950 dark:text-yellow-100 [&>svg]:text-yellow-600",
        info: "border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-100 [&>svg]:text-blue-500"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), W9 = {
  default: av,
  destructive: ws,
  success: M$,
  warning: Os,
  info: av
}, H9 = v.forwardRef(
  ({ className: e, variant: t = "default", showIcon: r = !1, children: n, ...a }, o) => {
    const i = W9[t || "default"];
    return /* @__PURE__ */ C(
      "div",
      {
        ref: o,
        role: "alert",
        className: F(q9({ variant: t }), e),
        ...a,
        children: [
          r && /* @__PURE__ */ h(i, { className: "h-4 w-4" }),
          n
        ]
      }
    );
  }
);
H9.displayName = "Alert";
const V9 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "h5",
  {
    ref: r,
    className: F("mb-1 font-medium leading-none tracking-tight", e),
    ...t
  }
));
V9.displayName = "AlertTitle";
const U9 = v.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ h(
  "div",
  {
    ref: r,
    className: F("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
U9.displayName = "AlertDescription";
const $b = Ye(
  "rounded-xl border bg-card p-4 transition-shadow hover:shadow-md",
  {
    variants: {
      variant: {
        default: "border-stone-200 dark:border-stone-800",
        primary: "border-primary-200 bg-primary-50 dark:border-primary-800 dark:bg-primary-950",
        success: "border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-950",
        warning: "border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950",
        danger: "border-red-200 bg-red-50 dark:border-red-800 dark:bg-red-950"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), oN = v.forwardRef(
  ({
    className: e,
    variant: t,
    title: r,
    value: n,
    change: a,
    trend: o,
    icon: i,
    description: s,
    isLoading: c,
    formatValue: l = !0,
    sparklineData: u,
    ...f
  }, d) => {
    const p = l && typeof n == "number" ? Ci(n) : n, g = o === "up" ? /* @__PURE__ */ h(Ss, { className: "h-4 w-4" }) : o === "down" ? /* @__PURE__ */ h(eg, { className: "h-4 w-4" }) : /* @__PURE__ */ h(__, { className: "h-4 w-4" }), m = o === "up" ? "text-green-600 dark:text-green-400" : o === "down" ? "text-red-600 dark:text-red-400" : "text-stone-500";
    return c ? /* @__PURE__ */ C(
      "div",
      {
        ref: d,
        className: F($b({ variant: t }), e),
        ...f,
        children: [
          /* @__PURE__ */ C("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ h("div", { className: "h-4 w-24 animate-pulse rounded bg-stone-200 dark:bg-stone-700" }),
            /* @__PURE__ */ h(Ha, { className: "h-4 w-4 animate-spin text-stone-400" })
          ] }),
          /* @__PURE__ */ h("div", { className: "mt-3 h-8 w-20 animate-pulse rounded bg-stone-200 dark:bg-stone-700" }),
          /* @__PURE__ */ h("div", { className: "mt-2 h-3 w-16 animate-pulse rounded bg-stone-200 dark:bg-stone-700" })
        ]
      }
    ) : /* @__PURE__ */ C(
      "div",
      {
        ref: d,
        className: F($b({ variant: t }), e),
        ...f,
        children: [
          /* @__PURE__ */ C("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ h("span", { className: "text-sm font-medium text-stone-600 dark:text-stone-400", children: r }),
            i && /* @__PURE__ */ h("span", { className: "text-stone-400 dark:text-stone-300", children: i })
          ] }),
          /* @__PURE__ */ C("div", { className: "mt-2 flex items-end justify-between", children: [
            /* @__PURE__ */ C("div", { children: [
              /* @__PURE__ */ h("p", { className: "text-data text-stone-900 dark:text-stone-100", children: p }),
              a !== void 0 && /* @__PURE__ */ C("div", { className: F("mt-1 flex items-center gap-1 text-sm", m), children: [
                g,
                /* @__PURE__ */ h("span", { children: LI(a) })
              ] })
            ] }),
            u && u.length > 0 && /* @__PURE__ */ h(K9, { data: u, trend: o })
          ] }),
          s && /* @__PURE__ */ h("p", { className: "mt-2 text-xs text-stone-500 dark:text-stone-400", children: s })
        ]
      }
    );
  }
);
oN.displayName = "StatCard";
function K9({ data: e, trend: t }) {
  const r = Math.max(...e), n = Math.min(...e), a = r - n || 1, o = e.map((s, c) => {
    const l = c / (e.length - 1) * 60, u = 24 - (s - n) / a * 20;
    return `${l},${u}`;
  }).join(" ");
  return /* @__PURE__ */ h("svg", { width: "60", height: "24", className: "overflow-visible", children: /* @__PURE__ */ h(
    "polyline",
    {
      fill: "none",
      stroke: t === "up" ? "#22C55E" : t === "down" ? "#EF4444" : "#78716C",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      points: o
    }
  ) });
}
const G9 = v.forwardRef(
  ({
    className: e,
    data: t,
    variant: r = "bar",
    showPercentages: n = !0,
    showCounts: a = !1,
    total: o,
    ...i
  }, s) => {
    const c = o || t.positive + t.neutral + t.negative, l = c > 0 ? t.positive / c * 100 : 0, u = c > 0 ? t.neutral / c * 100 : 0, f = c > 0 ? t.negative / c * 100 : 0;
    return r === "bar" ? /* @__PURE__ */ C("div", { ref: s, className: F("space-y-2", e), ...i, children: [
      /* @__PURE__ */ C("div", { className: "flex h-2 w-full overflow-hidden rounded-full bg-stone-200 dark:bg-stone-700", children: [
        /* @__PURE__ */ h(
          "div",
          {
            className: "bg-green-500 transition-all duration-300",
            style: { width: `${l}%` }
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: "bg-stone-400 transition-all duration-300",
            style: { width: `${u}%` }
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: "bg-red-500 transition-all duration-300",
            style: { width: `${f}%` }
          }
        )
      ] }),
      n && /* @__PURE__ */ C("div", { className: "flex justify-between text-xs", children: [
        /* @__PURE__ */ C("span", { className: "text-green-600 dark:text-green-400", children: [
          l.toFixed(1),
          "% Positive"
        ] }),
        /* @__PURE__ */ C("span", { className: "text-stone-500 dark:text-stone-400", children: [
          u.toFixed(1),
          "% Neutral"
        ] }),
        /* @__PURE__ */ C("span", { className: "text-red-600 dark:text-red-400", children: [
          f.toFixed(1),
          "% Negative"
        ] })
      ] })
    ] }) : /* @__PURE__ */ C("div", { ref: s, className: F("space-y-3", e), ...i, children: [
      /* @__PURE__ */ h(
        Hf,
        {
          label: "Positive",
          value: t.positive,
          percentage: l,
          color: "green",
          showCount: a,
          showPercentage: n
        }
      ),
      /* @__PURE__ */ h(
        Hf,
        {
          label: "Neutral",
          value: t.neutral,
          percentage: u,
          color: "stone",
          showCount: a,
          showPercentage: n
        }
      ),
      /* @__PURE__ */ h(
        Hf,
        {
          label: "Negative",
          value: t.negative,
          percentage: f,
          color: "red",
          showCount: a,
          showPercentage: n
        }
      )
    ] });
  }
);
G9.displayName = "SentimentIndicator";
function Hf({
  label: e,
  value: t,
  percentage: r,
  color: n,
  showCount: a,
  showPercentage: o
}) {
  const i = {
    green: "bg-green-500",
    stone: "bg-stone-400",
    red: "bg-red-500"
  };
  return /* @__PURE__ */ C("div", { className: "space-y-1", children: [
    /* @__PURE__ */ C("div", { className: "flex items-center justify-between text-sm", children: [
      /* @__PURE__ */ h("span", { className: {
        green: "text-green-600 dark:text-green-400",
        stone: "text-stone-600 dark:text-stone-400",
        red: "text-red-600 dark:text-red-400"
      }[n], children: e }),
      /* @__PURE__ */ C("span", { className: "text-stone-600 dark:text-stone-400", children: [
        o && `${r.toFixed(1)}%`,
        a && o && " • ",
        a && t.toLocaleString()
      ] })
    ] }),
    /* @__PURE__ */ h("div", { className: "h-2 w-full overflow-hidden rounded-full bg-stone-200 dark:bg-stone-700", children: /* @__PURE__ */ h(
      "div",
      {
        className: F("h-full transition-all duration-300", i[n]),
        style: { width: `${r}%` }
      }
    ) })
  ] });
}
const Ib = Ye(
  "rounded-lg border p-4 transition-all",
  {
    variants: {
      level: {
        low: "border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-950",
        medium: "border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950",
        high: "border-orange-200 bg-orange-50 dark:border-orange-800 dark:bg-orange-950",
        critical: "border-red-200 bg-red-50 dark:border-red-800 dark:bg-red-950"
      }
    },
    defaultVariants: {
      level: "low"
    }
  }
), ic = {
  low: "text-green-600 dark:text-green-400",
  medium: "text-amber-600 dark:text-amber-400",
  high: "text-orange-600 dark:text-orange-400",
  critical: "text-red-600 dark:text-red-400"
}, Db = {
  low: "bg-green-500",
  medium: "bg-amber-500",
  high: "bg-orange-500",
  critical: "bg-red-500"
}, Ov = v.forwardRef(
  ({
    className: e,
    percentage: t,
    level: r,
    title: n,
    description: a,
    compact: o = !1,
    ...i
  }, s) => {
    const c = r || R_(t), l = $_(c), u = c === "low" ? T$ : c === "medium" ? ws : c === "high" ? Os : X$;
    return o ? /* @__PURE__ */ C(
      "div",
      {
        ref: s,
        className: F(
          "flex items-center gap-3 rounded-lg border px-3 py-2",
          Ib({ level: c }),
          e
        ),
        ...i,
        children: [
          /* @__PURE__ */ h(u, { className: F("h-5 w-5 shrink-0", ic[c]) }),
          /* @__PURE__ */ C("div", { className: "flex-1", children: [
            /* @__PURE__ */ C("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ h("span", { className: "text-sm font-medium text-stone-900 dark:text-stone-100", children: l }),
              /* @__PURE__ */ C("span", { className: F("text-sm font-semibold", ic[c]), children: [
                t.toFixed(0),
                "%"
              ] })
            ] }),
            /* @__PURE__ */ h("div", { className: "mt-1 h-1.5 w-full overflow-hidden rounded-full bg-stone-200 dark:bg-stone-700", children: /* @__PURE__ */ h(
              "div",
              {
                className: F("h-full transition-all duration-500", Db[c]),
                style: { width: `${t}%` }
              }
            ) })
          ] })
        ]
      }
    ) : /* @__PURE__ */ h(
      "div",
      {
        ref: s,
        className: F(Ib({ level: c }), e),
        ...i,
        children: /* @__PURE__ */ C("div", { className: "flex items-start gap-3", children: [
          /* @__PURE__ */ h(u, { className: F("h-6 w-6 shrink-0", ic[c]) }),
          /* @__PURE__ */ C("div", { className: "flex-1", children: [
            /* @__PURE__ */ C("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ h("h4", { className: "text-sm font-semibold text-stone-900 dark:text-stone-100", children: n || `Crisis Level: ${l}` }),
              /* @__PURE__ */ C("span", { className: F("text-lg font-bold", ic[c]), children: [
                t.toFixed(0),
                "%"
              ] })
            ] }),
            /* @__PURE__ */ h("div", { className: "mt-2 h-2 w-full overflow-hidden rounded-full bg-stone-200 dark:bg-stone-700", children: /* @__PURE__ */ h(
              "div",
              {
                className: F("h-full transition-all duration-500", Db[c]),
                style: { width: `${t}%` }
              }
            ) }),
            /* @__PURE__ */ C("div", { className: "mt-2 flex justify-between text-xs text-stone-500 dark:text-stone-400", children: [
              /* @__PURE__ */ h("span", { children: "Low" }),
              /* @__PURE__ */ h("span", { children: "Medium" }),
              /* @__PURE__ */ h("span", { children: "High" }),
              /* @__PURE__ */ h("span", { children: "Critical" })
            ] }),
            a && /* @__PURE__ */ h("p", { className: "mt-3 text-sm text-stone-600 dark:text-stone-400", children: a })
          ] })
        ] })
      }
    );
  }
);
Ov.displayName = "CrisisAlert";
const iN = 6048e5, Y9 = 864e5, sc = 43200, jb = 1440, Lb = Symbol.for("constructDateFrom");
function Rr(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Lb in e ? e[Lb](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ze(e, t) {
  return Rr(t || e, e);
}
function X9(e, t, r) {
  const n = ze(e, r == null ? void 0 : r.in);
  return isNaN(t) ? Rr(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
let Z9 = {};
function Fs() {
  return Z9;
}
function Ii(e, t) {
  var s, c, l, u;
  const r = Fs(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((u = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = ze(e, t == null ? void 0 : t.in), o = a.getDay(), i = (o < n ? 7 : 0) + o - n;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function Xc(e, t) {
  return Ii(e, { ...t, weekStartsOn: 1 });
}
function sN(e, t) {
  const r = ze(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = Rr(r, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const o = Xc(a), i = Rr(r, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const s = Xc(i);
  return r.getTime() >= o.getTime() ? n + 1 : r.getTime() >= s.getTime() ? n : n - 1;
}
function Zc(e) {
  const t = ze(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function qu(e, ...t) {
  const r = Rr.bind(
    null,
    e || t.find((n) => typeof n == "object")
  );
  return t.map(r);
}
function vi(e, t) {
  const r = ze(e, t == null ? void 0 : t.in);
  return r.setHours(0, 0, 0, 0), r;
}
function J9(e, t, r) {
  const [n, a] = qu(
    r == null ? void 0 : r.in,
    e,
    t
  ), o = vi(n), i = vi(a), s = +o - Zc(o), c = +i - Zc(i);
  return Math.round((s - c) / Y9);
}
function Q9(e, t) {
  const r = sN(e, t), n = Rr(e, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), Xc(n);
}
function kc(e, t) {
  const r = +ze(e) - +ze(t);
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function e7(e) {
  return Rr(e, Date.now());
}
function t7(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function r7(e) {
  return !(!t7(e) && typeof e != "number" || isNaN(+ze(e)));
}
function n7(e, t, r) {
  const [n, a] = qu(
    r == null ? void 0 : r.in,
    e,
    t
  ), o = n.getFullYear() - a.getFullYear(), i = n.getMonth() - a.getMonth();
  return o * 12 + i;
}
function a7(e) {
  return (t) => {
    const n = (e ? Math[e] : Math.trunc)(t);
    return n === 0 ? 0 : n;
  };
}
function o7(e, t) {
  return +ze(e) - +ze(t);
}
function Nc(e, t) {
  const r = ze(e, t == null ? void 0 : t.in);
  return r.setHours(23, 59, 59, 999), r;
}
function i7(e, t) {
  const r = ze(e, t == null ? void 0 : t.in), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function s7(e, t) {
  const r = ze(e, t == null ? void 0 : t.in);
  return +Nc(r, t) == +i7(r, t);
}
function c7(e, t, r) {
  const [n, a, o] = qu(
    r == null ? void 0 : r.in,
    e,
    e,
    t
  ), i = kc(a, o), s = Math.abs(
    n7(a, o)
  );
  if (s < 1) return 0;
  a.getMonth() === 1 && a.getDate() > 27 && a.setDate(30), a.setMonth(a.getMonth() - i * s);
  let c = kc(a, o) === -i;
  s7(n) && s === 1 && kc(n, o) === 1 && (c = !1);
  const l = i * (s - +c);
  return l === 0 ? 0 : l;
}
function l7(e, t, r) {
  const n = o7(e, t) / 1e3;
  return a7(r == null ? void 0 : r.roundingMethod)(n);
}
function u7(e, t) {
  const r = ze(e, t == null ? void 0 : t.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
const f7 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, d7 = (e, t, r) => {
  let n;
  const a = f7[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function za(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const p7 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, h7 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, m7 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, v7 = {
  date: za({
    formats: p7,
    defaultWidth: "full"
  }),
  time: za({
    formats: h7,
    defaultWidth: "full"
  }),
  dateTime: za({
    formats: m7,
    defaultWidth: "full"
  })
}, y7 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, g7 = (e, t, r, n) => y7[e];
function Pr(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[o];
  };
}
const b7 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, x7 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, w7 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, S7 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, O7 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, P7 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, A7 = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, _7 = {
  ordinalNumber: A7,
  era: Pr({
    values: b7,
    defaultWidth: "wide"
  }),
  quarter: Pr({
    values: x7,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Pr({
    values: w7,
    defaultWidth: "wide"
  }),
  day: Pr({
    values: S7,
    defaultWidth: "wide"
  }),
  dayPeriod: Pr({
    values: O7,
    defaultWidth: "wide",
    formattingValues: P7,
    defaultFormattingWidth: "wide"
  })
};
function Ar(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = t.match(a);
    if (!o)
      return null;
    const i = o[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? C7(s, (f) => f.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      E7(s, (f) => f.test(i))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(l)
    ) : l;
    const u = t.slice(i.length);
    return { value: l, rest: u };
  };
}
function E7(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function C7(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function cN(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const a = n[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = r.valueCallback ? r.valueCallback(i) : i;
    const s = t.slice(a.length);
    return { value: i, rest: s };
  };
}
const k7 = /^(\d+)(th|st|nd|rd)?/i, N7 = /\d+/i, T7 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, M7 = {
  any: [/^b/i, /^(a|c)/i]
}, R7 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, $7 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, I7 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, D7 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, j7 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, L7 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, B7 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, F7 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, z7 = {
  ordinalNumber: cN({
    matchPattern: k7,
    parsePattern: N7,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ar({
    matchPatterns: T7,
    defaultMatchWidth: "wide",
    parsePatterns: M7,
    defaultParseWidth: "any"
  }),
  quarter: Ar({
    matchPatterns: R7,
    defaultMatchWidth: "wide",
    parsePatterns: $7,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ar({
    matchPatterns: I7,
    defaultMatchWidth: "wide",
    parsePatterns: D7,
    defaultParseWidth: "any"
  }),
  day: Ar({
    matchPatterns: j7,
    defaultMatchWidth: "wide",
    parsePatterns: L7,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ar({
    matchPatterns: B7,
    defaultMatchWidth: "any",
    parsePatterns: F7,
    defaultParseWidth: "any"
  })
}, lN = {
  code: "en-US",
  formatDistance: d7,
  formatLong: v7,
  formatRelative: g7,
  localize: _7,
  match: z7,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function q7(e, t) {
  const r = ze(e, t == null ? void 0 : t.in);
  return J9(r, u7(r)) + 1;
}
function W7(e, t) {
  const r = ze(e, t == null ? void 0 : t.in), n = +Xc(r) - +Q9(r);
  return Math.round(n / iN) + 1;
}
function uN(e, t) {
  var u, f, d, p;
  const r = ze(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = Fs(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (d = a.locale) == null ? void 0 : d.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, i = Rr((t == null ? void 0 : t.in) || e, 0);
  i.setFullYear(n + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = Ii(i, t), c = Rr((t == null ? void 0 : t.in) || e, 0);
  c.setFullYear(n, 0, o), c.setHours(0, 0, 0, 0);
  const l = Ii(c, t);
  return +r >= +s ? n + 1 : +r >= +l ? n : n - 1;
}
function H7(e, t) {
  var s, c, l, u;
  const r = Fs(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((u = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = uN(e, t), o = Rr((t == null ? void 0 : t.in) || e, 0);
  return o.setFullYear(a, 0, n), o.setHours(0, 0, 0, 0), Ii(o, t);
}
function V7(e, t) {
  const r = ze(e, t == null ? void 0 : t.in), n = +Ii(r, t) - +H7(r, t);
  return Math.round(n / iN) + 1;
}
function Ee(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const hn = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return Ee(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : Ee(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Ee(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Ee(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Ee(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Ee(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Ee(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return Ee(a, t.length);
  }
}, Aa = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Bb = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return hn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = uN(e, n), o = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const i = o % 100;
      return Ee(i, 2);
    }
    return t === "Yo" ? r.ordinalNumber(o, { unit: "year" }) : Ee(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = sN(e);
    return Ee(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return Ee(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return Ee(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return Ee(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return hn.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return Ee(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = V7(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : Ee(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = W7(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : Ee(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : hn.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = q7(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : Ee(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), o = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return Ee(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(o, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), o = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return Ee(o, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return Ee(a, t.length);
      // 2nd
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = Aa.noon : n === 0 ? a = Aa.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = Aa.evening : n >= 12 ? a = Aa.afternoon : n >= 4 ? a = Aa.morning : a = Aa.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return hn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : hn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : Ee(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : Ee(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : hn.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : hn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return hn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return zb(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Vn(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Vn(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return zb(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Vn(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Vn(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Fb(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Vn(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Fb(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Vn(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(+e / 1e3);
    return Ee(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return Ee(+e, t.length);
  }
};
function Fb(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), o = n % 60;
  return o === 0 ? r + String(a) : r + String(a) + t + Ee(o, 2);
}
function zb(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ee(Math.abs(e) / 60, 2) : Vn(e, t);
}
function Vn(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Ee(Math.trunc(n / 60), 2), o = Ee(n % 60, 2);
  return r + a + t + o;
}
const qb = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, fN = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, U7 = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return qb(e, t);
  let o;
  switch (n) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", qb(n, t)).replace("{{time}}", fN(a, t));
}, K7 = {
  p: fN,
  P: U7
}, G7 = /^D+$/, Y7 = /^Y+$/, X7 = ["D", "DD", "YY", "YYYY"];
function Z7(e) {
  return G7.test(e);
}
function J7(e) {
  return Y7.test(e);
}
function Q7(e, t, r) {
  const n = ez(e, t, r);
  if (console.warn(n), X7.includes(e)) throw new RangeError(n);
}
function ez(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const tz = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, rz = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, nz = /^'([^]*?)'?$/, az = /''/g, oz = /[a-zA-Z]/;
function Dt(e, t, r) {
  var u, f, d, p;
  const n = Fs(), a = n.locale ?? lN, o = n.firstWeekContainsDate ?? ((f = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = n.weekStartsOn ?? ((p = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : p.weekStartsOn) ?? 0, s = ze(e, r == null ? void 0 : r.in);
  if (!r7(s))
    throw new RangeError("Invalid time value");
  let c = t.match(rz).map((g) => {
    const m = g[0];
    if (m === "p" || m === "P") {
      const y = K7[m];
      return y(g, a.formatLong);
    }
    return g;
  }).join("").match(tz).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const m = g[0];
    if (m === "'")
      return { isToken: !1, value: iz(g) };
    if (Bb[m])
      return { isToken: !0, value: g };
    if (m.match(oz))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + m + "`"
      );
    return { isToken: !1, value: g };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  const l = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return c.map((g) => {
    if (!g.isToken) return g.value;
    const m = g.value;
    (J7(m) || Z7(m)) && Q7(m, t, String(e));
    const y = Bb[m[0]];
    return y(s, m, a.localize, l);
  }).join("");
}
function iz(e) {
  const t = e.match(nz);
  return t ? t[1].replace(az, "'") : e;
}
function sz(e, t, r) {
  const n = Fs(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? lN, o = 2520, i = kc(e, t);
  if (isNaN(i)) throw new RangeError("Invalid time value");
  const s = Object.assign({}, r, {
    addSuffix: r == null ? void 0 : r.addSuffix,
    comparison: i
  }), [c, l] = qu(
    r == null ? void 0 : r.in,
    ...i > 0 ? [t, e] : [e, t]
  ), u = l7(l, c), f = (Zc(l) - Zc(c)) / 1e3, d = Math.round((u - f) / 60);
  let p;
  if (d < 2)
    return r != null && r.includeSeconds ? u < 5 ? a.formatDistance("lessThanXSeconds", 5, s) : u < 10 ? a.formatDistance("lessThanXSeconds", 10, s) : u < 20 ? a.formatDistance("lessThanXSeconds", 20, s) : u < 40 ? a.formatDistance("halfAMinute", 0, s) : u < 60 ? a.formatDistance("lessThanXMinutes", 1, s) : a.formatDistance("xMinutes", 1, s) : d === 0 ? a.formatDistance("lessThanXMinutes", 1, s) : a.formatDistance("xMinutes", d, s);
  if (d < 45)
    return a.formatDistance("xMinutes", d, s);
  if (d < 90)
    return a.formatDistance("aboutXHours", 1, s);
  if (d < jb) {
    const g = Math.round(d / 60);
    return a.formatDistance("aboutXHours", g, s);
  } else {
    if (d < o)
      return a.formatDistance("xDays", 1, s);
    if (d < sc) {
      const g = Math.round(d / jb);
      return a.formatDistance("xDays", g, s);
    } else if (d < sc * 2)
      return p = Math.round(d / sc), a.formatDistance("aboutXMonths", p, s);
  }
  if (p = c7(l, c), p < 12) {
    const g = Math.round(d / sc);
    return a.formatDistance("xMonths", g, s);
  } else {
    const g = p % 12, m = Math.trunc(p / 12);
    return g < 3 ? a.formatDistance("aboutXYears", m, s) : g < 9 ? a.formatDistance("overXYears", m, s) : a.formatDistance("almostXYears", m + 1, s);
  }
}
function cz(e, t) {
  return sz(e, e7(e), t);
}
function Wb(e, t) {
  return +ze(e) > +ze(t);
}
function Vf(e, t) {
  return +ze(e) < +ze(t);
}
function lz(e, t, r) {
  return X9(e, -t, r);
}
const uz = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, fz = (e, t, r) => {
  let n;
  const a = uz[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + n : "hace " + n : n;
}, dz = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, pz = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, hz = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, mz = {
  date: za({
    formats: dz,
    defaultWidth: "full"
  }),
  time: za({
    formats: pz,
    defaultWidth: "full"
  }),
  dateTime: za({
    formats: hz,
    defaultWidth: "full"
  })
}, vz = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, yz = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, gz = (e, t, r, n) => t.getHours() !== 1 ? yz[e] : vz[e], bz = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, xz = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, wz = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, Sz = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, Oz = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, Pz = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, Az = (e, t) => Number(e) + "º", _z = {
  ordinalNumber: Az,
  era: Pr({
    values: bz,
    defaultWidth: "wide"
  }),
  quarter: Pr({
    values: xz,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: Pr({
    values: wz,
    defaultWidth: "wide"
  }),
  day: Pr({
    values: Sz,
    defaultWidth: "wide"
  }),
  dayPeriod: Pr({
    values: Oz,
    defaultWidth: "wide",
    formattingValues: Pz,
    defaultFormattingWidth: "wide"
  })
}, Ez = /^(\d+)(º)?/i, Cz = /\d+/i, kz = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, Nz = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, Tz = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Mz = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Rz = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, $z = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, Iz = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, Dz = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, jz = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, Lz = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, Bz = {
  ordinalNumber: cN({
    matchPattern: Ez,
    parsePattern: Cz,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Ar({
    matchPatterns: kz,
    defaultMatchWidth: "wide",
    parsePatterns: Nz,
    defaultParseWidth: "any"
  }),
  quarter: Ar({
    matchPatterns: Tz,
    defaultMatchWidth: "wide",
    parsePatterns: Mz,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ar({
    matchPatterns: Rz,
    defaultMatchWidth: "wide",
    parsePatterns: $z,
    defaultParseWidth: "any"
  }),
  day: Ar({
    matchPatterns: Iz,
    defaultMatchWidth: "wide",
    parsePatterns: Dz,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ar({
    matchPatterns: jz,
    defaultMatchWidth: "any",
    parsePatterns: Lz,
    defaultParseWidth: "any"
  })
}, Fz = {
  code: "es",
  formatDistance: fz,
  formatLong: mz,
  formatRelative: gz,
  localize: _z,
  match: Bz,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, zz = {
  twitter: "X",
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  google_news: "Google News"
}, dN = v.forwardRef(
  ({
    className: e,
    content: t,
    authorName: r,
    authorUsername: n,
    authorAvatar: a,
    isVerified: o,
    platform: i,
    sentiment: s,
    emotion: c,
    isSarcasm: l,
    hate: u,
    createdAt: f,
    postUrl: d,
    likes: p,
    replies: g,
    shares: m,
    views: y,
    mediaUrls: b,
    selected: w,
    onCardClick: S,
    onExternalClick: P,
    ...x
  }, O) => {
    const A = cz(new Date(f), { addSuffix: !0, locale: Fz }), [_, N] = v.useState(!1), [M, T] = v.useState(!1), k = v.useRef(null);
    return v.useLayoutEffect(() => {
      const $ = k.current;
      $ && !_ && T($.scrollHeight > $.clientHeight + 1);
    }, [t, _]), /* @__PURE__ */ C(
      "div",
      {
        ref: O,
        className: F(
          "group rounded-lg border bg-card p-4 transition-all hover:shadow-md",
          w ? "border-primary-500 ring-2 ring-primary-500/20" : "border-stone-200 dark:border-stone-800",
          S && "cursor-pointer",
          e
        ),
        onClick: S,
        ...x,
        children: [
          /* @__PURE__ */ C("div", { className: "flex items-start justify-between gap-3", children: [
            /* @__PURE__ */ C("div", { className: "flex min-w-0 flex-1 items-start gap-3", children: [
              /* @__PURE__ */ h(
                ng,
                {
                  src: a,
                  name: r,
                  platform: i,
                  verified: o,
                  size: "md"
                }
              ),
              /* @__PURE__ */ C("div", { className: "min-w-0", children: [
                /* @__PURE__ */ h("div", { className: "flex items-center gap-1.5", children: /* @__PURE__ */ h("span", { className: "truncate font-medium text-stone-900 dark:text-stone-100", children: r }) }),
                /* @__PURE__ */ C("div", { className: "flex items-center gap-2 text-sm text-stone-500 dark:text-stone-400", children: [
                  /* @__PURE__ */ C("span", { className: "truncate", children: [
                    "@",
                    n
                  ] }),
                  /* @__PURE__ */ h("span", { children: "·" }),
                  /* @__PURE__ */ h("span", { className: "whitespace-nowrap", children: A })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ C("div", { className: "flex shrink-0 items-center gap-2", children: [
              /* @__PURE__ */ h(Qt, { variant: i, className: "whitespace-nowrap text-[10px]", children: zz[i] }),
              d && /* @__PURE__ */ h(
                "button",
                {
                  onClick: ($) => {
                    $.stopPropagation(), P == null || P(), window.open(d, "_blank");
                  },
                  className: "rounded p-1 text-stone-400 opacity-0 transition-opacity hover:bg-stone-100 hover:text-stone-600 group-hover:opacity-100 dark:hover:bg-stone-800",
                  children: /* @__PURE__ */ h(j$, { className: "h-4 w-4" })
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ h(
            "p",
            {
              ref: k,
              className: F(
                "mt-3 text-sm text-stone-700 dark:text-stone-300",
                !_ && "line-clamp-4"
              ),
              children: t
            }
          ),
          M && /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              onClick: ($) => {
                $.stopPropagation(), N((R) => !R);
              },
              className: "mt-1 text-xs font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 rounded",
              children: _ ? "Ver menos" : "Ver más"
            }
          ),
          b && b.length > 0 && /* @__PURE__ */ h("div", { className: "mt-3 flex gap-2 overflow-hidden rounded-lg", children: b.slice(0, 4).map(($, R) => /* @__PURE__ */ C(
            "div",
            {
              className: "relative aspect-square flex-1 overflow-hidden rounded bg-stone-100 dark:bg-stone-800",
              children: [
                /* @__PURE__ */ h(
                  "img",
                  {
                    src: $,
                    alt: "",
                    className: "h-full w-full object-cover",
                    loading: "lazy"
                  }
                ),
                R === 3 && b.length > 4 && /* @__PURE__ */ C("div", { className: "absolute inset-0 flex items-center justify-center bg-black/50 text-white", children: [
                  "+",
                  b.length - 4
                ] })
              ]
            },
            R
          )) }),
          (() => {
            const $ = !!(u && (u.hateful || u.targeted || u.aggressive));
            return s !== void 0 || c || l || $ ? /* @__PURE__ */ C("div", { className: "mt-3 flex flex-wrap items-center gap-2", children: [
              s !== void 0 && /* @__PURE__ */ h(I_, { sentiment: s }),
              c && c !== "others" && /* @__PURE__ */ h(D_, { emotion: c }),
              l && /* @__PURE__ */ h(j_, {}),
              $ && /* @__PURE__ */ h(L_, { hate: u })
            ] }) : null;
          })(),
          /* @__PURE__ */ C("div", { className: "mt-3 flex items-center gap-4 text-sm text-stone-500 dark:text-stone-400", children: [
            p !== void 0 && /* @__PURE__ */ h(cc, { icon: O_, value: p, label: "likes" }),
            g !== void 0 && /* @__PURE__ */ h(cc, { icon: A_, value: g, label: "replies" }),
            m !== void 0 && /* @__PURE__ */ h(cc, { icon: Q$, value: m, label: "shares" }),
            y !== void 0 && /* @__PURE__ */ h(cc, { icon: Jy, value: y, label: "views" })
          ] })
        ]
      }
    );
  }
);
dN.displayName = "MentionCard";
function cc({ icon: e, value: t, label: r }) {
  return /* @__PURE__ */ C("div", { className: "flex items-center gap-1", title: `${t.toLocaleString()} ${r}`, children: [
    /* @__PURE__ */ h(e, { className: "h-4 w-4" }),
    /* @__PURE__ */ h("span", { children: Ci(t) })
  ] });
}
const qz = {
  twitter: /* @__PURE__ */ h("svg", { viewBox: "0 0 24 24", className: "h-4 w-4", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" }) }),
  instagram: /* @__PURE__ */ h("svg", { viewBox: "0 0 24 24", className: "h-4 w-4", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" }) }),
  facebook: /* @__PURE__ */ h("svg", { viewBox: "0 0 24 24", className: "h-4 w-4", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" }) }),
  tiktok: /* @__PURE__ */ h("svg", { viewBox: "0 0 24 24", className: "h-4 w-4", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" }) }),
  google_news: /* @__PURE__ */ h("svg", { viewBox: "0 0 24 24", className: "h-4 w-4", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm-1 4v4H7v2h4v4h2v-4h4v-2h-4V6h-2z" }) })
}, Wz = {
  twitter: "X (Twitter)",
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  google_news: "Google News"
}, Hz = {
  twitter: "text-stone-900 dark:text-stone-100",
  instagram: "text-pink-600 dark:text-pink-400",
  facebook: "text-blue-600 dark:text-blue-400",
  tiktok: "text-stone-900 dark:text-stone-100",
  google_news: "text-blue-500 dark:text-blue-400"
}, Vz = v.forwardRef(
  ({
    className: e,
    selected: t,
    onChange: r,
    counts: n,
    platforms: a = ["twitter", "instagram", "facebook", "tiktok", "google_news"],
    direction: o = "vertical",
    ...i
  }, s) => {
    const c = (d) => {
      t.includes(d) ? r(t.filter((p) => p !== d)) : r([...t, d]);
    }, l = () => r([...a]), u = () => r([]), f = a.every((d) => t.includes(d));
    return /* @__PURE__ */ C(
      "div",
      {
        ref: s,
        className: F("space-y-2", e),
        ...i,
        children: [
          /* @__PURE__ */ C("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ h("span", { className: "text-sm font-medium text-stone-900 dark:text-stone-100", children: "Platforms" }),
            /* @__PURE__ */ h(
              "button",
              {
                type: "button",
                onClick: f ? u : l,
                className: "text-xs text-primary-600 hover:text-primary-700 dark:text-primary-400",
                children: f ? "Clear all" : "Select all"
              }
            )
          ] }),
          /* @__PURE__ */ h(
            "div",
            {
              className: F(
                "gap-2",
                o === "horizontal" ? "flex flex-wrap" : "flex flex-col"
              ),
              children: a.map((d) => /* @__PURE__ */ h(
                Uz,
                {
                  platform: d,
                  checked: t.includes(d),
                  onChange: () => c(d),
                  count: n == null ? void 0 : n[d]
                },
                d
              ))
            }
          )
        ]
      }
    );
  }
);
Vz.displayName = "PlatformFilter";
function Uz({ platform: e, checked: t, onChange: r, count: n }) {
  return /* @__PURE__ */ C("label", { className: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 transition-colors hover:bg-stone-100 dark:hover:bg-stone-800", children: [
    /* @__PURE__ */ h(
      lg,
      {
        checked: t,
        onCheckedChange: r,
        className: F(
          "flex h-4 w-4 shrink-0 items-center justify-center rounded border transition-colors",
          t ? "border-primary-600 bg-primary-600 text-white" : "border-stone-300 dark:border-stone-700"
        ),
        children: /* @__PURE__ */ h(ug, { children: /* @__PURE__ */ h(ha, { className: "h-3 w-3" }) })
      }
    ),
    /* @__PURE__ */ h("span", { className: F("shrink-0", Hz[e]), children: qz[e] }),
    /* @__PURE__ */ h("span", { className: "flex-1 text-sm text-stone-700 dark:text-stone-300", children: Wz[e] }),
    n !== void 0 && /* @__PURE__ */ h("span", { className: "text-xs text-stone-500", children: Ci(n) })
  ] });
}
const Kz = v.forwardRef(
  ({
    className: e,
    value: t = "",
    placeholder: r = "Search mentions, keywords, users...",
    suggestions: n = [],
    activeFilters: a = [],
    showHistory: o = !0,
    showFilters: i = !0,
    isLoading: s = !1,
    onChange: c,
    onSearch: l,
    onSuggestionClick: u,
    onFilterAdd: f,
    onFilterRemove: d,
    onFiltersClick: p,
    ...g
  }, m) => {
    const [y, b] = v.useState(!1), [w, S] = v.useState(t), P = v.useRef(null), x = v.useRef(null);
    v.useEffect(() => {
      S(t);
    }, [t]), v.useEffect(() => {
      const k = ($) => {
        x.current && !x.current.contains($.target) && b(!1);
      };
      return document.addEventListener("mousedown", k), () => document.removeEventListener("mousedown", k);
    }, []);
    const O = (k) => {
      const $ = k.target.value;
      S($), c == null || c($), $.length > 0 && b(!0);
    }, A = (k) => {
      k.key === "Enter" ? (l == null || l(w), b(!1)) : k.key === "Escape" && b(!1);
    }, _ = () => {
      var k;
      S(""), c == null || c(""), (k = P.current) == null || k.focus();
    }, N = (k) => {
      S(k.text), c == null || c(k.text), u == null || u(k), b(!1);
    }, M = n.filter((k) => k.type === "history"), T = n.filter((k) => k.type === "trending");
    return /* @__PURE__ */ C("div", { ref: x, className: F("relative w-full", e), ...g, children: [
      /* @__PURE__ */ C("div", { ref: m, className: "relative flex items-center gap-2", children: [
        /* @__PURE__ */ C("div", { className: "relative flex-1", children: [
          /* @__PURE__ */ h(Ei, { className: "absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-stone-400" }),
          /* @__PURE__ */ h(
            "input",
            {
              ref: P,
              type: "text",
              value: w,
              onChange: O,
              onKeyDown: A,
              onFocus: () => o && n.length > 0 && b(!0),
              placeholder: r,
              className: F(
                "h-10 w-full rounded-lg border border-stone-200 bg-white pl-10 pr-10 text-sm transition-colors",
                "placeholder:text-stone-400 dark:placeholder:text-stone-400",
                "focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20",
                "dark:border-stone-700 dark:bg-stone-900 dark:text-stone-100",
                s && "pr-16"
              )
            }
          ),
          s && /* @__PURE__ */ h("div", { className: "absolute right-10 top-1/2 -translate-y-1/2", children: /* @__PURE__ */ h("div", { className: "h-4 w-4 animate-spin rounded-full border-2 border-primary-500 border-t-transparent" }) }),
          w && /* @__PURE__ */ h(
            "button",
            {
              onClick: _,
              className: "absolute right-3 top-1/2 -translate-y-1/2 rounded p-0.5 text-stone-400 hover:bg-stone-100 hover:text-stone-600 dark:hover:bg-stone-800",
              children: /* @__PURE__ */ h(An, { className: "h-4 w-4" })
            }
          )
        ] }),
        i && /* @__PURE__ */ C(
          "button",
          {
            onClick: p,
            className: F(
              "flex h-10 items-center gap-2 rounded-lg border border-stone-200 bg-white px-3 text-sm font-medium transition-colors",
              "hover:bg-stone-50 dark:border-stone-700 dark:bg-stone-900 dark:hover:bg-stone-800",
              a.length > 0 && "border-primary-500 text-primary-600 dark:text-primary-400"
            ),
            children: [
              /* @__PURE__ */ h(F$, { className: "h-4 w-4" }),
              /* @__PURE__ */ h("span", { className: "hidden sm:inline", children: "Filters" }),
              a.length > 0 && /* @__PURE__ */ h(Qt, { variant: "default", className: "ml-1 h-5 min-w-[1.25rem] px-1.5", children: a.length }),
              /* @__PURE__ */ h(Yr, { className: "h-4 w-4" })
            ]
          }
        )
      ] }),
      a.length > 0 && /* @__PURE__ */ h("div", { className: "mt-2 flex flex-wrap gap-2", children: a.map((k, $) => /* @__PURE__ */ C(
        Qt,
        {
          variant: "outline",
          className: "flex items-center gap-1 pr-1",
          children: [
            /* @__PURE__ */ C("span", { className: "text-xs text-stone-500 dark:text-stone-400", children: [
              k.type,
              ":"
            ] }),
            k.label,
            /* @__PURE__ */ h(
              "button",
              {
                onClick: () => d == null ? void 0 : d(k),
                className: "ml-1 rounded-full p-0.5 hover:bg-stone-200 dark:hover:bg-stone-700",
                children: /* @__PURE__ */ h(An, { className: "h-3 w-3" })
              }
            )
          ]
        },
        `${k.type}-${k.value}-${$}`
      )) }),
      y && n.length > 0 && /* @__PURE__ */ C("div", { className: "absolute left-0 right-0 top-full z-50 mt-1 overflow-hidden rounded-lg border border-stone-200 bg-white shadow-lg dark:border-stone-700 dark:bg-stone-900", children: [
        M.length > 0 && /* @__PURE__ */ C("div", { className: "border-b border-stone-100 p-2 dark:border-stone-800", children: [
          /* @__PURE__ */ C("div", { className: "mb-1 flex items-center gap-1 px-2 text-xs font-medium text-stone-500 dark:text-stone-400", children: [
            /* @__PURE__ */ h(Z0, { className: "h-3 w-3" }),
            "Recent searches"
          ] }),
          M.slice(0, 5).map((k) => /* @__PURE__ */ C(
            "button",
            {
              onClick: () => N(k),
              className: "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm hover:bg-stone-100 dark:hover:bg-stone-800",
              children: [
                /* @__PURE__ */ h(Z0, { className: "h-4 w-4 text-stone-400" }),
                k.text
              ]
            },
            k.id
          ))
        ] }),
        T.length > 0 && /* @__PURE__ */ C("div", { className: "p-2", children: [
          /* @__PURE__ */ h("div", { className: "mb-1 px-2 text-xs font-medium text-stone-500 dark:text-stone-400", children: "Trending" }),
          T.slice(0, 5).map((k) => /* @__PURE__ */ C(
            "button",
            {
              onClick: () => N(k),
              className: "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm hover:bg-stone-100 dark:hover:bg-stone-800",
              children: [
                /* @__PURE__ */ h(Ei, { className: "h-4 w-4 text-stone-400" }),
                k.text
              ]
            },
            k.id
          ))
        ] })
      ] })
    ] });
  }
);
Kz.displayName = "SearchBar";
const Gz = [
  { label: "Last 7 days", days: 7 },
  { label: "Last 15 days", days: 15 },
  { label: "Last 30 days", days: 30 },
  { label: "Last 90 days", days: 90 }
], Yz = {
  sm: "h-8 text-xs px-2",
  md: "h-10 text-sm px-3",
  lg: "h-12 text-base px-4"
}, Jc = v.forwardRef(
  ({
    className: e,
    value: t,
    placeholder: r = "Select date range",
    presets: n = Gz,
    minDate: a,
    maxDate: o = /* @__PURE__ */ new Date(),
    onChange: i,
    disabled: s = !1,
    size: c = "md",
    ...l
  }, u) => {
    const [f, d] = v.useState(!1), [p, g] = v.useState((t == null ? void 0 : t.from) || /* @__PURE__ */ new Date()), [m, y] = v.useState(!0), [b, w] = v.useState({}), S = v.useRef(null);
    v.useEffect(() => {
      const k = ($) => {
        S.current && !S.current.contains($.target) && d(!1);
      };
      return document.addEventListener("mousedown", k), () => document.removeEventListener("mousedown", k);
    }, []);
    const P = (k) => {
      const $ = Nc(/* @__PURE__ */ new Date()), R = vi(lz($, k.days - 1));
      i == null || i({ from: R, to: $ }), d(!1);
    }, x = (k) => {
      if (m)
        w({ from: k }), y(!1);
      else {
        const $ = b.from;
        Vf(k, $) ? w({ from: k }) : (i == null || i({ from: vi($), to: Nc(k) }), w({}), y(!0), d(!1));
      }
    }, O = (k) => !!(a && Vf(k, vi(a)) || o && Wb(k, Nc(o))), A = (k) => t ? !Vf(k, t.from) && !Wb(k, t.to) : !1, _ = (k) => t ? Dt(k, "yyyy-MM-dd") === Dt(t.from, "yyyy-MM-dd") : !1, N = (k) => t ? Dt(k, "yyyy-MM-dd") === Dt(t.to, "yyyy-MM-dd") : !1, M = () => {
      const k = p.getFullYear(), $ = p.getMonth(), R = new Date(k, $, 1), j = new Date(k, $ + 1, 0).getDate(), z = R.getDay(), q = [];
      for (let I = 0; I < z; I++)
        q.push(null);
      for (let I = 1; I <= j; I++)
        q.push(new Date(k, $, I));
      return /* @__PURE__ */ C("div", { className: "p-3", children: [
        /* @__PURE__ */ C("div", { className: "mb-3 flex items-center justify-between", children: [
          /* @__PURE__ */ h(
            "button",
            {
              onClick: () => g(new Date(k, $ - 1, 1)),
              className: "rounded p-1 hover:bg-stone-100 dark:hover:bg-stone-800",
              children: /* @__PURE__ */ h(Zy, { className: "h-4 w-4" })
            }
          ),
          /* @__PURE__ */ h("span", { className: "text-sm font-medium", children: Dt(p, "MMMM yyyy") }),
          /* @__PURE__ */ h(
            "button",
            {
              onClick: () => g(new Date(k, $ + 1, 1)),
              className: "rounded p-1 hover:bg-stone-100 dark:hover:bg-stone-800",
              children: /* @__PURE__ */ h(uu, { className: "h-4 w-4" })
            }
          )
        ] }),
        /* @__PURE__ */ h("div", { className: "mb-1 grid grid-cols-7 gap-1", children: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((I) => /* @__PURE__ */ h(
          "div",
          {
            className: "flex h-8 w-8 items-center justify-center text-xs font-medium text-stone-500",
            children: I
          },
          I
        )) }),
        /* @__PURE__ */ h("div", { className: "grid grid-cols-7 gap-1", children: q.map((I, B) => {
          if (!I)
            return /* @__PURE__ */ h("div", { className: "h-8 w-8" }, `empty-${B}`);
          const W = O(I), H = A(I), U = _(I), X = N(I), ee = Dt(I, "yyyy-MM-dd") === Dt(/* @__PURE__ */ new Date(), "yyyy-MM-dd");
          return /* @__PURE__ */ h(
            "button",
            {
              onClick: () => !W && x(I),
              disabled: W,
              className: F(
                "flex h-8 w-8 items-center justify-center rounded text-sm transition-colors",
                W && "cursor-not-allowed opacity-30",
                !W && !H && "hover:bg-stone-100 dark:hover:bg-stone-800",
                H && !U && !X && "bg-primary-100 dark:bg-primary-900/30",
                (U || X) && "bg-primary-500 text-white",
                ee && !U && !X && "ring-1 ring-primary-500"
              ),
              children: I.getDate()
            },
            I.toISOString()
          );
        }) })
      ] });
    }, T = t ? `${Dt(t.from, "MMM d, yyyy")} - ${Dt(t.to, "MMM d, yyyy")}` : r;
    return /* @__PURE__ */ C("div", { ref: S, className: F("relative", e), ...l, children: [
      /* @__PURE__ */ C(
        "button",
        {
          ref: u,
          onClick: () => !s && d(!f),
          disabled: s,
          className: F(
            "flex w-full items-center justify-between rounded-lg border border-stone-200 bg-white transition-colors",
            "hover:bg-stone-50 dark:border-stone-700 dark:bg-stone-900 dark:hover:bg-stone-800",
            "focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20",
            s && "cursor-not-allowed opacity-50",
            Yz[c]
          ),
          children: [
            /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ h(k$, { className: "h-4 w-4 text-stone-400" }),
              /* @__PURE__ */ h("span", { className: F(!t && "text-stone-400"), children: T })
            ] }),
            /* @__PURE__ */ h(Yr, { className: F("h-4 w-4 text-stone-400 transition-transform", f && "rotate-180") })
          ]
        }
      ),
      f && /* @__PURE__ */ C("div", { className: "absolute left-0 top-full z-50 mt-1 flex overflow-hidden rounded-lg border border-stone-200 bg-white shadow-lg dark:border-stone-700 dark:bg-stone-900", children: [
        /* @__PURE__ */ C("div", { className: "border-r border-stone-200 p-2 dark:border-stone-700", children: [
          /* @__PURE__ */ h("div", { className: "mb-2 px-2 text-xs font-medium text-stone-500", children: "Quick Select" }),
          /* @__PURE__ */ h("div", { className: "space-y-1", children: n.map((k) => /* @__PURE__ */ h(
            "button",
            {
              onClick: () => P(k),
              className: "block w-full whitespace-nowrap rounded-md px-3 py-1.5 text-left text-sm hover:bg-stone-100 dark:hover:bg-stone-800",
              children: k.label
            },
            k.label
          )) })
        ] }),
        M()
      ] })
    ] });
  }
);
Jc.displayName = "DateRangePicker";
function Xz({
  className: e,
  columns: t,
  data: r,
  isLoading: n = !1,
  keyExtractor: a,
  pagination: o,
  emptyMessage: i = "No hay datos disponibles",
  emptyState: s,
  skeletonRows: c = 5,
  sort: l,
  onSort: u,
  striped: f = !1,
  compact: d = !1,
  onRowClick: p,
  rowClassName: g,
  toolbar: m,
  ...y
}, b) {
  const w = (x) => {
    if (!x.sortable || !u) return;
    const O = (l == null ? void 0 : l.key) === x.key && l.direction === "asc" ? "desc" : "asc";
    u(x.key, O);
  }, S = (x) => x.sortable ? (l == null ? void 0 : l.key) === x.key ? l.direction === "asc" ? /* @__PURE__ */ h(C$, { className: "ml-1 inline h-3.5 w-3.5" }) : /* @__PURE__ */ h(_$, { className: "ml-1 inline h-3.5 w-3.5" }) : /* @__PURE__ */ h(w_, { className: "ml-1 inline h-3.5 w-3.5 opacity-40" }) : null, P = (x) => x === "center" ? "text-center" : x === "right" ? "text-right" : "text-left";
  return /* @__PURE__ */ C("div", { ref: b, className: F("space-y-4", e), ...y, children: [
    m && /* @__PURE__ */ h("div", { className: "flex flex-wrap items-center gap-3", children: m }),
    /* @__PURE__ */ h("div", { className: "rounded-md border border-stone-200 dark:border-stone-700", children: /* @__PURE__ */ C(wC, { children: [
      /* @__PURE__ */ h(SC, { children: /* @__PURE__ */ h(fi, { children: t.map((x) => /* @__PURE__ */ C(
        PC,
        {
          className: F(
            x.className,
            P(x.align),
            x.sortable && "cursor-pointer select-none hover:bg-stone-50 dark:hover:bg-stone-800",
            d && "px-3 py-2"
          ),
          onClick: () => w(x),
          children: [
            x.header,
            S(x)
          ]
        },
        x.key
      )) }) }),
      /* @__PURE__ */ h(OC, { children: n ? Array.from({ length: c }).map((x, O) => /* @__PURE__ */ h(fi, { children: t.map((A) => /* @__PURE__ */ h(
        Cc,
        {
          className: F(A.className, d && "px-3 py-2"),
          children: /* @__PURE__ */ h(G_, { className: "h-4 w-full" })
        },
        A.key
      )) }, `skeleton-${O}`)) : r.length === 0 ? /* @__PURE__ */ h(fi, { children: /* @__PURE__ */ h(Cc, { colSpan: t.length, className: "p-0", children: /* @__PURE__ */ h(
        Wk,
        {
          title: (s == null ? void 0 : s.title) || i,
          description: s == null ? void 0 : s.description,
          illustration: (s == null ? void 0 : s.illustration) || "no-data",
          action: s == null ? void 0 : s.action,
          size: "sm",
          bordered: !1
        }
      ) }) }) : r.map((x) => /* @__PURE__ */ h(
        fi,
        {
          className: F(
            f && "even:bg-stone-50 dark:even:bg-stone-800/50",
            p && "cursor-pointer hover:bg-stone-50 dark:hover:bg-stone-800",
            g == null ? void 0 : g(x)
          ),
          onClick: () => p == null ? void 0 : p(x),
          children: t.map((O) => /* @__PURE__ */ h(
            Cc,
            {
              className: F(
                O.className,
                P(O.align),
                d && "px-3 py-2"
              ),
              children: O.cell(x)
            },
            O.key
          ))
        },
        a(x)
      )) })
    ] }) }),
    o && o.pages > 1 && /* @__PURE__ */ h(
      Dg,
      {
        currentPage: o.page,
        totalPages: o.pages,
        onPageChange: o.onPageChange
      }
    )
  ] });
}
const Mce = v.forwardRef(Xz);
function Rce({
  label: e,
  options: t,
  value: r,
  onChange: n,
  multiple: a = !1,
  clearable: o = !1,
  collapseAfter: i,
  className: s
}) {
  const [c, l] = v.useState(!1), u = i && !c ? t.slice(i) : [], f = i && !c ? [...t.slice(0, i), ...u.filter((p) => r.includes(p.value))] : t, d = (p) => {
    if (!a) {
      n([p]);
      return;
    }
    n(r.includes(p) ? r.filter((g) => g !== p) : [...r, p]);
  };
  return /* @__PURE__ */ C("div", { className: s, children: [
    /* @__PURE__ */ C("div", { className: "mb-1.5 flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ h("p", { className: "text-xs font-medium uppercase tracking-wide text-stone-500 dark:text-stone-400", children: e }),
      o && r.length > 0 && /* @__PURE__ */ h(
        "button",
        {
          type: "button",
          onClick: () => n([]),
          className: "text-xs text-stone-500 underline underline-offset-2 hover:text-stone-800 dark:text-stone-400 dark:hover:text-stone-100",
          children: "Limpiar"
        }
      )
    ] }),
    /* @__PURE__ */ h(
      "div",
      {
        role: a ? "group" : "radiogroup",
        "aria-label": e,
        className: F(
          "flex flex-wrap gap-1"
        ),
        children: f.map((p) => {
          const g = r.includes(p.value);
          return /* @__PURE__ */ C(
            "button",
            {
              type: "button",
              role: a ? void 0 : "radio",
              "aria-pressed": a ? g : void 0,
              "aria-checked": a ? void 0 : g,
              onClick: () => d(p.value),
              className: F(
                // Card 123: look Power BI del mockup — tile cuadrado, negro al
                // seleccionar, blanco con borde gris al reposo.
                "inline-flex items-center gap-1.5 rounded-sm border px-3 py-2 text-sm transition-colors",
                g ? "border-[#252423] bg-[#252423] text-white" : "border-stone-300 bg-white text-stone-700 hover:border-stone-500 dark:border-stone-600 dark:bg-stone-900 dark:text-stone-200"
              ),
              children: [
                /* @__PURE__ */ h("span", { className: "truncate", children: p.label }),
                p.hint && /* @__PURE__ */ h(
                  "span",
                  {
                    className: F(
                      "text-xs tabular-nums",
                      g ? "text-white/80" : "text-stone-400 dark:text-stone-500"
                    ),
                    children: p.hint
                  }
                )
              ]
            },
            p.value
          );
        })
      }
    ),
    i && t.length > f.length && /* @__PURE__ */ C(
      "button",
      {
        type: "button",
        onClick: () => l(!0),
        className: "mt-1 text-xs text-stone-500 underline underline-offset-2 hover:text-stone-800 dark:text-stone-400 dark:hover:text-stone-100",
        children: [
          "Ver las ",
          t.length,
          " opciones"
        ]
      }
    ),
    i && c && /* @__PURE__ */ h(
      "button",
      {
        type: "button",
        onClick: () => l(!1),
        className: "mt-1 text-xs text-stone-500 underline underline-offset-2 hover:text-stone-800 dark:text-stone-400 dark:hover:text-stone-100",
        children: "Ver menos"
      }
    )
  ] });
}
const Ma = 1440 * 60 * 1e3, _a = (e) => Math.floor(e.getTime() / Ma), Ea = (e) => {
  const t = e.getUTCFullYear(), r = String(e.getUTCMonth() + 1).padStart(2, "0"), n = String(e.getUTCDate()).padStart(2, "0");
  return `${t}-${r}-${n}`;
};
function $ce({
  label: e = "Fecha",
  min: t,
  max: r,
  start: n,
  end: a,
  onChange: o,
  className: i
}) {
  const s = _a(t), c = _a(r), l = n ? Math.min(Math.max(_a(n), s), c) : s, u = a ? Math.min(Math.max(_a(a), s), c) : c, f = Math.max(c - s, 1), d = (m, y) => {
    const b = Math.min(m, y), w = Math.max(m, y);
    o(
      b <= s ? null : new Date(b * Ma),
      w >= c ? null : new Date(w * Ma + Ma - 1)
    );
  }, p = (l - s) / f * 100, g = (u - s) / f * 100;
  return /* @__PURE__ */ C("div", { className: F("min-w-[230px]", i), children: [
    /* @__PURE__ */ h("p", { className: "mb-1.5 text-xs font-medium uppercase tracking-wide text-stone-500 dark:text-stone-400", children: e }),
    /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ h(
        "input",
        {
          type: "date",
          "aria-label": "Fecha desde",
          value: Ea(new Date(l * Ma)),
          min: Ea(t),
          max: Ea(r),
          onChange: (m) => {
            m.target.value && d(_a(/* @__PURE__ */ new Date(`${m.target.value}T12:00:00Z`)), u);
          },
          className: "w-full rounded-sm border border-stone-300 bg-white px-2 py-1.5 text-sm text-stone-800 dark:border-stone-600 dark:bg-stone-900 dark:text-stone-100"
        }
      ),
      /* @__PURE__ */ h(
        "input",
        {
          type: "date",
          "aria-label": "Fecha hasta",
          value: Ea(new Date(u * Ma)),
          min: Ea(t),
          max: Ea(r),
          onChange: (m) => {
            m.target.value && d(l, _a(/* @__PURE__ */ new Date(`${m.target.value}T12:00:00Z`)));
          },
          className: "w-full rounded-sm border border-stone-300 bg-white px-2 py-1.5 text-sm text-stone-800 dark:border-stone-600 dark:bg-stone-900 dark:text-stone-100"
        }
      )
    ] }),
    /* @__PURE__ */ C("div", { className: "relative mt-3 h-5", children: [
      /* @__PURE__ */ h("div", { className: "absolute top-1/2 h-1 w-full -translate-y-1/2 rounded-full bg-stone-300 dark:bg-stone-600" }),
      /* @__PURE__ */ h(
        "div",
        {
          className: "absolute top-1/2 h-1 -translate-y-1/2 rounded-full bg-stone-700 dark:bg-stone-300",
          style: { left: `${p}%`, width: `${Math.max(g - p, 0)}%` }
        }
      ),
      /* @__PURE__ */ h(
        "input",
        {
          type: "range",
          "aria-label": "Inicio del rango",
          min: s,
          max: c,
          value: l,
          onChange: (m) => d(Number(m.target.value), u),
          className: "dual-range pointer-events-none absolute top-0 h-5 w-full appearance-none bg-transparent"
        }
      ),
      /* @__PURE__ */ h(
        "input",
        {
          type: "range",
          "aria-label": "Fin del rango",
          min: s,
          max: c,
          value: u,
          onChange: (m) => d(l, Number(m.target.value)),
          className: "dual-range pointer-events-none absolute top-0 h-5 w-full appearance-none bg-transparent"
        }
      ),
      /* @__PURE__ */ h("style", { children: `
          .dual-range::-webkit-slider-thumb {
            pointer-events: auto;
            appearance: none;
            height: 16px;
            width: 16px;
            border-radius: 9999px;
            background: #fff;
            border: 2px solid #605E5C;
            cursor: pointer;
          }
          .dual-range::-moz-range-thumb {
            pointer-events: auto;
            height: 16px;
            width: 16px;
            border-radius: 9999px;
            background: #fff;
            border: 2px solid #605E5C;
            cursor: pointer;
          }
        ` })
    ] })
  ] });
}
const Zz = [
  { id: "dashboard", label: "Dashboard", icon: /* @__PURE__ */ h(W$, { className: "h-5 w-5" }) },
  { id: "mentions", label: "Mentions", icon: /* @__PURE__ */ h(fu, { className: "h-5 w-5" }) },
  { id: "analytics", label: "Analytics", icon: /* @__PURE__ */ h(N$, { className: "h-5 w-5" }) },
  { id: "alerts", label: "Alerts", icon: /* @__PURE__ */ h(lu, { className: "h-5 w-5" }) },
  { id: "settings", label: "Settings", icon: /* @__PURE__ */ h(E_, { className: "h-5 w-5" }) }
], pN = v.forwardRef(
  ({
    className: e,
    navItems: t = Zz,
    savedQueries: r = [],
    activeItem: n,
    collapsed: a = !1,
    onCollapsedChange: o,
    theme: i = "light",
    onThemeChange: s,
    onNavItemClick: c,
    onQueryClick: l,
    onNewQueryClick: u,
    planInfo: f,
    logo: d,
    ...p
  }, g) => /* @__PURE__ */ C(
    "aside",
    {
      ref: g,
      className: F(
        "flex h-full flex-col border-r border-stone-200 bg-white transition-all duration-300 dark:border-stone-800 dark:bg-stone-950",
        a ? "w-16" : "w-64",
        e
      ),
      ...p,
      children: [
        /* @__PURE__ */ C("div", { className: "flex h-16 items-center justify-between border-b border-stone-200 px-4 dark:border-stone-800", children: [
          !a && /* @__PURE__ */ h("div", { className: "flex items-center gap-2", children: d || /* @__PURE__ */ h("span", { className: "text-xl font-bold text-primary-700 dark:text-primary-400", children: "Uyari" }) }),
          /* @__PURE__ */ h(
            "button",
            {
              onClick: () => o == null ? void 0 : o(!a),
              "aria-label": a ? "Expandir menú" : "Colapsar menú",
              title: a ? "Expandir menú" : "Colapsar menú",
              className: "rounded-md p-1.5 text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800",
              children: a ? /* @__PURE__ */ h(uu, { className: "h-5 w-5" }) : /* @__PURE__ */ h(Zy, { className: "h-5 w-5" })
            }
          )
        ] }),
        /* @__PURE__ */ C("nav", { className: "flex-1 space-y-1 overflow-y-auto p-2", children: [
          t.map((m) => /* @__PURE__ */ C(
            "button",
            {
              onClick: () => c == null ? void 0 : c(m),
              "aria-label": m.label,
              title: a ? m.label : void 0,
              "aria-current": m.active || n === m.id ? "page" : void 0,
              className: F(
                "flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                m.active || n === m.id ? "bg-primary-100 text-primary-700 dark:bg-primary-900 dark:text-primary-300" : "text-stone-600 hover:bg-stone-100 dark:text-stone-400 dark:hover:bg-stone-800"
              ),
              children: [
                m.icon,
                !a && /* @__PURE__ */ C(Ve, { children: [
                  /* @__PURE__ */ h("span", { className: "flex-1 text-left", children: m.label }),
                  m.badge !== void 0 && m.badge > 0 && /* @__PURE__ */ h("span", { className: "rounded-full bg-red-500 px-2 py-0.5 text-xs text-white", children: m.badge > 99 ? "99+" : m.badge })
                ] })
              ]
            },
            m.id
          )),
          !a && r.length > 0 && /* @__PURE__ */ C("div", { className: "mt-6", children: [
            /* @__PURE__ */ C("div", { className: "flex items-center justify-between px-3 py-2", children: [
              /* @__PURE__ */ h("span", { className: "text-xs font-semibold uppercase tracking-wider text-stone-500", children: "Saved Queries" }),
              /* @__PURE__ */ h(
                "button",
                {
                  onClick: u,
                  "aria-label": "Nueva consulta guardada",
                  title: "Nueva consulta guardada",
                  className: "rounded p-1 text-stone-400 hover:bg-stone-100 hover:text-stone-600 dark:hover:bg-stone-800",
                  children: /* @__PURE__ */ h(ov, { className: "h-4 w-4" })
                }
              )
            ] }),
            /* @__PURE__ */ h("div", { className: "space-y-1", children: r.map((m) => /* @__PURE__ */ C(
              "button",
              {
                onClick: () => l == null ? void 0 : l(m),
                className: "flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-stone-600 hover:bg-stone-100 dark:text-stone-400 dark:hover:bg-stone-800",
                children: [
                  /* @__PURE__ */ h(Ei, { className: "h-4 w-4" }),
                  /* @__PURE__ */ h("span", { className: "truncate", children: m.name })
                ]
              },
              m.id
            )) })
          ] })
        ] }),
        /* @__PURE__ */ C("div", { className: "border-t border-stone-200 p-2 dark:border-stone-800", children: [
          !a && f && /* @__PURE__ */ C("div", { className: "mb-2 rounded-md bg-stone-100 p-3 dark:bg-stone-800", children: [
            /* @__PURE__ */ C("div", { className: "flex items-center justify-between text-xs", children: [
              /* @__PURE__ */ h("span", { className: "font-medium text-stone-700 dark:text-stone-300", children: f.name }),
              /* @__PURE__ */ C("span", { className: "text-stone-500", children: [
                f.creditsUsed,
                "/",
                f.creditsTotal
              ] })
            ] }),
            /* @__PURE__ */ h("div", { className: "mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-stone-200 dark:bg-stone-700", children: /* @__PURE__ */ h(
              "div",
              {
                className: "h-full bg-primary-500 transition-all",
                style: {
                  width: `${f.creditsUsed / f.creditsTotal * 100}%`
                }
              }
            ) })
          ] }),
          /* @__PURE__ */ C(
            "button",
            {
              onClick: () => s == null ? void 0 : s(i === "light" ? "dark" : "light"),
              "aria-label": i === "light" ? "Activar modo oscuro" : "Activar modo claro",
              title: a ? i === "light" ? "Activar modo oscuro" : "Activar modo claro" : void 0,
              className: F(
                "flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm text-stone-600 hover:bg-stone-100 dark:text-stone-400 dark:hover:bg-stone-800",
                a && "justify-center"
              ),
              children: [
                i === "light" ? /* @__PURE__ */ h(Y$, { className: "h-5 w-5" }) : /* @__PURE__ */ h(nI, { className: "h-5 w-5" }),
                !a && /* @__PURE__ */ h("span", { children: i === "light" ? "Dark Mode" : "Light Mode" })
              ]
            }
          )
        ] })
      ]
    }
  )
);
pN.displayName = "Sidebar";
const hN = v.forwardRef(
  ({
    className: e,
    breadcrumbs: t,
    user: r,
    notifications: n = [],
    currentQuery: a,
    showSearch: o = !0,
    showNotifications: i = !0,
    searchValue: s = "",
    searchPlaceholder: c = "Search mentions...",
    rightContent: l,
    onSearchChange: u,
    onSearchSubmit: f,
    onNotificationsClick: d,
    onUserMenuClick: p,
    onMobileMenuClick: g,
    ...m
  }, y) => {
    const [b, w] = v.useState(s), S = n.filter((O) => !O.read).length, P = (O) => {
      w(O.target.value), u == null || u(O.target.value);
    }, x = (O) => {
      O.preventDefault(), f == null || f(b);
    };
    return /* @__PURE__ */ C(
      "header",
      {
        ref: y,
        className: F(
          "flex h-16 items-center justify-between border-b border-stone-200 bg-white px-4 dark:border-stone-800 dark:bg-stone-950 lg:px-6",
          e
        ),
        ...m,
        children: [
          /* @__PURE__ */ C("div", { className: "flex items-center gap-4", children: [
            /* @__PURE__ */ h(
              "button",
              {
                onClick: g,
                className: "rounded-md p-2 text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800 lg:hidden",
                children: /* @__PURE__ */ h(P_, { className: "h-5 w-5" })
              }
            ),
            t && t.length > 0 && /* @__PURE__ */ h("nav", { className: "hidden items-center gap-2 text-sm md:flex", children: t.map((O, A) => /* @__PURE__ */ C(v.Fragment, { children: [
              A > 0 && /* @__PURE__ */ h("span", { className: "text-stone-400", children: "/" }),
              O.href || O.onClick ? /* @__PURE__ */ h(
                "button",
                {
                  onClick: O.onClick,
                  className: "text-stone-500 hover:text-stone-900 dark:text-stone-400 dark:hover:text-stone-100",
                  children: O.label
                }
              ) : /* @__PURE__ */ h("span", { className: "font-medium text-stone-900 dark:text-stone-100", children: O.label })
            ] }, A)) }),
            a && !t && /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ h("span", { className: "font-semibold text-stone-900 dark:text-stone-100", children: a }),
              /* @__PURE__ */ h(Yr, { className: "h-4 w-4 text-stone-400" })
            ] })
          ] }),
          o && /* @__PURE__ */ h("form", { onSubmit: x, className: "hidden w-full max-w-md px-4 md:block", children: /* @__PURE__ */ h(
            B_,
            {
              value: b,
              onChange: P,
              placeholder: c,
              inputSize: "sm",
              clearable: !0,
              onClear: () => {
                w(""), u == null || u("");
              }
            }
          ) }),
          /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
            o && /* @__PURE__ */ h("button", { className: "rounded-md p-2 text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800 md:hidden", children: /* @__PURE__ */ h(Ei, { className: "h-5 w-5" }) }),
            l,
            i && /* @__PURE__ */ C(
              "button",
              {
                onClick: d,
                className: "relative rounded-md p-2 text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800",
                children: [
                  /* @__PURE__ */ h(lu, { className: "h-5 w-5" }),
                  S > 0 && /* @__PURE__ */ h("span", { className: "absolute -right-0.5 -top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-medium text-white", children: S > 9 ? "9+" : S })
                ]
              }
            ),
            r && /* @__PURE__ */ C(
              "button",
              {
                onClick: p,
                className: "flex items-center gap-2 rounded-md p-1.5 hover:bg-stone-100 dark:hover:bg-stone-800",
                children: [
                  /* @__PURE__ */ h(
                    ng,
                    {
                      src: r.avatar,
                      name: r.name,
                      size: "sm"
                    }
                  ),
                  /* @__PURE__ */ C("div", { className: "hidden text-left lg:block", children: [
                    /* @__PURE__ */ h("p", { className: "text-sm font-medium text-stone-900 dark:text-stone-100", children: r.name }),
                    /* @__PURE__ */ h("p", { className: "text-xs text-stone-500", children: r.email })
                  ] }),
                  /* @__PURE__ */ h(Yr, { className: "hidden h-4 w-4 text-stone-400 lg:block" })
                ]
              }
            )
          ] })
        ]
      }
    );
  }
);
hN.displayName = "Header";
const Jz = [
  {
    id: "mentions",
    title: "Total Mentions",
    value: 12847,
    change: 12.5,
    trend: "up",
    icon: /* @__PURE__ */ h(fu, { className: "h-5 w-5" }),
    sparklineData: [65, 72, 68, 80, 75, 90, 85, 95]
  },
  {
    id: "sentiment",
    title: "Sentiment Score",
    value: "72%",
    change: 5.2,
    trend: "up",
    icon: /* @__PURE__ */ h(O_, { className: "h-5 w-5" }),
    description: "Positive sentiment"
  },
  {
    id: "reach",
    title: "Total Reach",
    value: 245e4,
    change: -3.1,
    trend: "down",
    icon: /* @__PURE__ */ h(Jy, { className: "h-5 w-5" }),
    sparklineData: [90, 85, 88, 82, 78, 80, 75, 72]
  },
  {
    id: "engagement",
    title: "Engagement Rate",
    value: "4.8%",
    change: 0.8,
    trend: "up",
    icon: /* @__PURE__ */ h(Ss, { className: "h-5 w-5" })
  },
  {
    id: "authors",
    title: "Unique Authors",
    value: 3421,
    change: 8.3,
    trend: "up",
    icon: /* @__PURE__ */ h(oI, { className: "h-5 w-5" })
  },
  {
    id: "alerts",
    title: "Active Alerts",
    value: 3,
    icon: /* @__PURE__ */ h(Os, { className: "h-5 w-5" }),
    description: "2 high priority"
  }
], Qz = {
  2: "grid-cols-1 md:grid-cols-2",
  3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
}, eq = v.forwardRef(
  ({
    className: e,
    stats: t = Jz,
    crisisLevel: r = 15,
    crisisDescription: n,
    dateRange: a,
    isLoading: o = !1,
    isRefreshing: i = !1,
    onDateRangeChange: s,
    onRefresh: c,
    onCrisisClick: l,
    showCrisisAlert: u = !0,
    columns: f = 4,
    ...d
  }, p) => /* @__PURE__ */ C("div", { ref: p, className: F("space-y-4", e), ...d, children: [
    /* @__PURE__ */ C("div", { className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between", children: [
      /* @__PURE__ */ C("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ h("h2", { className: "text-lg font-semibold text-stone-900 dark:text-stone-100", children: "Overview" }),
        i && /* @__PURE__ */ h(Ha, { className: "h-4 w-4 animate-spin text-stone-400" })
      ] }),
      /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ h(
          Jc,
          {
            value: a,
            onChange: s,
            size: "sm"
          }
        ),
        /* @__PURE__ */ C(
          Te,
          {
            variant: "outline",
            size: "sm",
            onClick: c,
            disabled: i,
            children: [
              /* @__PURE__ */ h(Ha, { className: F("h-4 w-4", i && "animate-spin") }),
              /* @__PURE__ */ h("span", { className: "ml-2 hidden sm:inline", children: "Refresh" })
            ]
          }
        )
      ] })
    ] }),
    u && r >= 50 && /* @__PURE__ */ h(
      "div",
      {
        onClick: l,
        className: F(
          "cursor-pointer transition-transform hover:scale-[1.01]",
          l && "cursor-pointer"
        ),
        children: /* @__PURE__ */ h(
          Ov,
          {
            percentage: r,
            description: n
          }
        )
      }
    ),
    /* @__PURE__ */ C("div", { className: F("grid gap-4", Qz[f]), children: [
      u && r < 50 && /* @__PURE__ */ h(
        "div",
        {
          onClick: l,
          className: F(l && "cursor-pointer"),
          children: /* @__PURE__ */ h(
            Ov,
            {
              percentage: r,
              description: n,
              compact: !0
            }
          )
        }
      ),
      t.map((g) => /* @__PURE__ */ h(
        oN,
        {
          title: g.title,
          value: g.value,
          change: g.change,
          trend: g.trend,
          icon: g.icon,
          description: g.description,
          sparklineData: g.sparklineData,
          isLoading: o
        },
        g.id
      ))
    ] })
  ] })
);
eq.displayName = "DashboardSummary";
const Hb = [
  { value: "recent", label: "Most Recent" },
  { value: "engagement", label: "Most Engagement" },
  { value: "sentiment_negative", label: "Most Negative" },
  { value: "sentiment_positive", label: "Most Positive" }
], tq = v.forwardRef(
  ({
    className: e,
    mentions: t,
    selectedIds: r = [],
    sortBy: n = "recent",
    isLoading: a = !1,
    isLoadingMore: o = !1,
    hasMore: i = !1,
    currentPage: s = 1,
    totalPages: c = 1,
    totalCount: l,
    usePagination: u = !1,
    onMentionClick: f,
    onViewOriginal: d,
    onSelectionChange: p,
    onSortChange: g,
    onLoadMore: m,
    onPageChange: y,
    selectable: b = !1,
    bulkActions: w,
    ...S
  }, P) => {
    var $;
    const [x, O] = v.useState(!1), A = v.useRef(null), _ = v.useRef(null);
    v.useEffect(() => {
      const R = (L) => {
        A.current && !A.current.contains(L.target) && O(!1);
      };
      return document.addEventListener("mousedown", R), () => document.removeEventListener("mousedown", R);
    }, []), v.useEffect(() => {
      if (u || !i || o) return;
      const R = new IntersectionObserver(
        (L) => {
          L[0].isIntersecting && i && !o && (m == null || m());
        },
        { threshold: 0.1 }
      );
      return _.current && R.observe(_.current), () => R.disconnect();
    }, [i, o, u, m]);
    const N = () => {
      r.length === t.length ? p == null || p([]) : p == null || p(t.map((R) => R.id));
    }, M = (R) => {
      r.includes(R) ? p == null || p(r.filter((L) => L !== R)) : p == null || p([...r, R]);
    }, T = t.length > 0 && r.length === t.length, k = r.length > 0 && r.length < t.length;
    return a ? /* @__PURE__ */ h("div", { ref: P, className: F("space-y-4", e), ...S, children: Array.from({ length: 5 }).map((R, L) => /* @__PURE__ */ h(
      "div",
      {
        className: "animate-pulse rounded-lg border border-stone-200 bg-white p-4 dark:border-stone-800 dark:bg-stone-900",
        children: /* @__PURE__ */ C("div", { className: "flex items-start gap-3", children: [
          /* @__PURE__ */ h("div", { className: "h-10 w-10 rounded-full bg-stone-200 dark:bg-stone-700" }),
          /* @__PURE__ */ C("div", { className: "flex-1 space-y-2", children: [
            /* @__PURE__ */ h("div", { className: "h-4 w-32 rounded bg-stone-200 dark:bg-stone-700" }),
            /* @__PURE__ */ h("div", { className: "h-3 w-full rounded bg-stone-200 dark:bg-stone-700" }),
            /* @__PURE__ */ h("div", { className: "h-3 w-3/4 rounded bg-stone-200 dark:bg-stone-700" })
          ] })
        ] })
      },
      L
    )) }) : t.length === 0 ? /* @__PURE__ */ h(
      "div",
      {
        ref: P,
        className: F(
          "flex h-48 items-center justify-center rounded-lg border border-dashed border-stone-300 dark:border-stone-700",
          e
        ),
        ...S,
        children: /* @__PURE__ */ C("div", { className: "text-center", children: [
          /* @__PURE__ */ h("p", { className: "text-sm font-medium text-stone-600 dark:text-stone-400", children: "No mentions found" }),
          /* @__PURE__ */ h("p", { className: "mt-1 text-xs text-stone-500", children: "Try adjusting your filters or search query" })
        ] })
      }
    ) : /* @__PURE__ */ C("div", { ref: P, className: F("space-y-4", e), ...S, children: [
      /* @__PURE__ */ C("div", { className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between", children: [
        /* @__PURE__ */ C("div", { className: "flex items-center gap-3", children: [
          b && /* @__PURE__ */ C(
            "button",
            {
              onClick: N,
              className: "flex items-center gap-2 text-sm text-stone-600 hover:text-stone-900 dark:text-stone-400 dark:hover:text-stone-100",
              children: [
                T ? /* @__PURE__ */ h(J0, { className: "h-4 w-4 text-primary-500" }) : k ? /* @__PURE__ */ C("div", { className: "relative", children: [
                  /* @__PURE__ */ h(Nf, { className: "h-4 w-4" }),
                  /* @__PURE__ */ h("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ h("div", { className: "h-2 w-2 bg-primary-500" }) })
                ] }) : /* @__PURE__ */ h(Nf, { className: "h-4 w-4" }),
                "Select all"
              ]
            }
          ),
          l !== void 0 && /* @__PURE__ */ C("span", { className: "text-sm text-stone-500", children: [
            l.toLocaleString(),
            " mentions"
          ] }),
          r.length > 0 && /* @__PURE__ */ C(Qt, { variant: "default", children: [
            r.length,
            " selected"
          ] })
        ] }),
        /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
          r.length > 0 && w,
          /* @__PURE__ */ C("div", { className: "relative", ref: A, children: [
            /* @__PURE__ */ C(
              Te,
              {
                variant: "outline",
                size: "sm",
                onClick: () => O(!x),
                children: [
                  /* @__PURE__ */ h(w_, { className: "h-4 w-4" }),
                  /* @__PURE__ */ h("span", { className: "ml-2", children: ($ = Hb.find((R) => R.value === n)) == null ? void 0 : $.label }),
                  /* @__PURE__ */ h(Yr, { className: "ml-2 h-4 w-4" })
                ]
              }
            ),
            x && /* @__PURE__ */ h("div", { className: "absolute right-0 top-full z-50 mt-1 w-48 overflow-hidden rounded-lg border border-stone-200 bg-white shadow-lg dark:border-stone-700 dark:bg-stone-900", children: Hb.map((R) => /* @__PURE__ */ C(
              "button",
              {
                onClick: () => {
                  g == null || g(R.value), O(!1);
                },
                className: F(
                  "flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-stone-100 dark:hover:bg-stone-800",
                  n === R.value && "bg-stone-50 dark:bg-stone-800"
                ),
                children: [
                  R.label,
                  n === R.value && /* @__PURE__ */ h(ha, { className: "h-4 w-4 text-primary-500" })
                ]
              },
              R.value
            )) })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ h("div", { className: "space-y-3", children: t.map((R) => /* @__PURE__ */ C("div", { className: "flex items-start gap-3", children: [
        b && /* @__PURE__ */ h(
          "button",
          {
            onClick: () => M(R.id),
            className: "mt-4 flex-shrink-0",
            children: r.includes(R.id) ? /* @__PURE__ */ h(J0, { className: "h-5 w-5 text-primary-500" }) : /* @__PURE__ */ h(Nf, { className: "h-5 w-5 text-stone-400 hover:text-stone-600" })
          }
        ),
        /* @__PURE__ */ h("div", { className: "flex-1", children: /* @__PURE__ */ h(
          dN,
          {
            content: R.text || R.content || "",
            authorName: R.authorName,
            authorUsername: R.authorUsername,
            authorAvatar: R.authorAvatar,
            isVerified: R.authorIsVerified,
            platform: R.source,
            sentiment: R.sentiment,
            emotion: R.emotion,
            createdAt: R.createdAt,
            postUrl: R.postUrl,
            likes: R.likes,
            replies: R.replies,
            shares: R.shares,
            views: R.views,
            mediaUrls: R.mediaUrls,
            onCardClick: () => f == null ? void 0 : f(R),
            onExternalClick: () => d == null ? void 0 : d(R)
          }
        ) })
      ] }, R.id)) }),
      u ? /* @__PURE__ */ h(
        Dg,
        {
          currentPage: s,
          totalPages: c,
          onPageChange: (R) => y == null ? void 0 : y(R),
          className: "pt-4"
        }
      ) : /* @__PURE__ */ C(Ve, { children: [
        /* @__PURE__ */ h("div", { ref: _, className: "h-1" }),
        o && /* @__PURE__ */ h("div", { className: "flex justify-center py-4", children: /* @__PURE__ */ h(Qy, { className: "h-6 w-6 animate-spin text-primary-500" }) }),
        i && !o && /* @__PURE__ */ h("div", { className: "flex justify-center pt-4", children: /* @__PURE__ */ h(Te, { variant: "outline", onClick: m, children: "Load more" }) })
      ] })
    ] });
  }
);
tq.displayName = "MentionsList";
const rq = {
  trend: Ss,
  alert: ws,
  recommendation: H$,
  summary: fu
}, nq = {
  trend: "text-blue-500",
  alert: "text-amber-500",
  recommendation: "text-violet-500",
  summary: "text-stone-500"
}, aq = {
  high: "negative",
  medium: "neutral",
  low: "default"
}, oq = v.forwardRef(
  ({
    className: e,
    summary: t,
    insights: r = [],
    generatedAt: n,
    isLoading: a = !1,
    error: o,
    defaultExpanded: i = !0,
    showCopy: s = !0,
    onRegenerate: c,
    onInsightClick: l,
    ...u
  }, f) => {
    const [d, p] = v.useState(i), [g, m] = v.useState(!1), y = async () => {
      const b = [
        t,
        "",
        "Key Insights:",
        ...r.map((w) => `- ${w.title}: ${w.description}`)
      ].join(`
`);
      await navigator.clipboard.writeText(b), m(!0), setTimeout(() => m(!1), 2e3);
    };
    return o ? /* @__PURE__ */ h(
      "div",
      {
        ref: f,
        className: F(
          "rounded-xl border border-red-200 bg-red-50 p-4 dark:border-red-900 dark:bg-red-950",
          e
        ),
        ...u,
        children: /* @__PURE__ */ C("div", { className: "flex items-start gap-3", children: [
          /* @__PURE__ */ h(ws, { className: "h-5 w-5 flex-shrink-0 text-red-500" }),
          /* @__PURE__ */ C("div", { className: "flex-1", children: [
            /* @__PURE__ */ h("p", { className: "font-medium text-red-800 dark:text-red-200", children: "Failed to generate insights" }),
            /* @__PURE__ */ h("p", { className: "mt-1 text-sm text-red-600 dark:text-red-400", children: o })
          ] }),
          /* @__PURE__ */ C(Te, { variant: "outline", size: "sm", onClick: c, children: [
            /* @__PURE__ */ h(Ha, { className: "h-4 w-4" }),
            "Retry"
          ] })
        ] })
      }
    ) : a ? /* @__PURE__ */ h(
      "div",
      {
        ref: f,
        className: F(
          "rounded-xl border border-stone-200 bg-gradient-to-r from-violet-50 to-blue-50 p-4 dark:border-stone-800 dark:from-violet-950/30 dark:to-blue-950/30",
          e
        ),
        ...u,
        children: /* @__PURE__ */ C("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ C("div", { className: "relative", children: [
            /* @__PURE__ */ h(kf, { className: "h-5 w-5 text-violet-500" }),
            /* @__PURE__ */ h("div", { className: "absolute inset-0 animate-ping", children: /* @__PURE__ */ h(kf, { className: "h-5 w-5 text-violet-500 opacity-50" }) })
          ] }),
          /* @__PURE__ */ C("div", { className: "flex-1", children: [
            /* @__PURE__ */ h("p", { className: "font-medium text-stone-700 dark:text-stone-300", children: "Analyzing your data..." }),
            /* @__PURE__ */ h("p", { className: "text-sm text-stone-500", children: "AI is processing mentions and generating insights" })
          ] }),
          /* @__PURE__ */ C("div", { className: "flex gap-1", children: [
            /* @__PURE__ */ h("div", { className: "h-2 w-2 animate-bounce rounded-full bg-violet-500 [animation-delay:-0.3s]" }),
            /* @__PURE__ */ h("div", { className: "h-2 w-2 animate-bounce rounded-full bg-violet-500 [animation-delay:-0.15s]" }),
            /* @__PURE__ */ h("div", { className: "h-2 w-2 animate-bounce rounded-full bg-violet-500" })
          ] })
        ] })
      }
    ) : /* @__PURE__ */ C(
      "div",
      {
        ref: f,
        className: F(
          "overflow-hidden rounded-xl border border-stone-200 bg-gradient-to-r from-violet-50/50 to-blue-50/50 dark:border-stone-800 dark:from-violet-950/20 dark:to-blue-950/20",
          e
        ),
        ...u,
        children: [
          /* @__PURE__ */ C(
            "button",
            {
              onClick: () => p(!d),
              className: "flex w-full items-center justify-between p-4 text-left",
              children: [
                /* @__PURE__ */ C("div", { className: "flex items-center gap-3", children: [
                  /* @__PURE__ */ h("div", { className: "flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-violet-500 to-blue-500", children: /* @__PURE__ */ h(kf, { className: "h-4 w-4 text-white" }) }),
                  /* @__PURE__ */ C("div", { children: [
                    /* @__PURE__ */ h("h3", { className: "font-semibold text-stone-900 dark:text-stone-100", children: "AI Insights" }),
                    n && /* @__PURE__ */ C("p", { className: "text-xs text-stone-500", children: [
                      "Updated ",
                      n.toLocaleTimeString()
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
                  r.filter((b) => b.importance === "high").length > 0 && /* @__PURE__ */ C(Qt, { variant: "negative", className: "text-xs", children: [
                    r.filter((b) => b.importance === "high").length,
                    " priority"
                  ] }),
                  d ? /* @__PURE__ */ h(S_, { className: "h-5 w-5 text-stone-400" }) : /* @__PURE__ */ h(Yr, { className: "h-5 w-5 text-stone-400" })
                ] })
              ]
            }
          ),
          d && /* @__PURE__ */ C("div", { className: "border-t border-stone-200 p-4 dark:border-stone-800", children: [
            t && /* @__PURE__ */ h("div", { className: "mb-4 rounded-lg bg-white/60 p-3 dark:bg-stone-900/60", children: /* @__PURE__ */ h("p", { className: "text-sm leading-relaxed text-stone-700 dark:text-stone-300", children: t }) }),
            r.length > 0 && /* @__PURE__ */ C("div", { className: "space-y-2", children: [
              /* @__PURE__ */ h("h4", { className: "text-xs font-semibold uppercase tracking-wider text-stone-500", children: "Key Insights" }),
              /* @__PURE__ */ h("div", { className: "space-y-2", children: r.map((b) => {
                const w = rq[b.type];
                return /* @__PURE__ */ C(
                  "button",
                  {
                    onClick: () => l == null ? void 0 : l(b),
                    className: F(
                      "flex w-full items-start gap-3 rounded-lg bg-white/80 p-3 text-left transition-colors hover:bg-white dark:bg-stone-900/80 dark:hover:bg-stone-900",
                      !l && "cursor-default"
                    ),
                    children: [
                      /* @__PURE__ */ h(w, { className: F("mt-0.5 h-4 w-4 flex-shrink-0", nq[b.type]) }),
                      /* @__PURE__ */ C("div", { className: "flex-1 min-w-0", children: [
                        /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
                          /* @__PURE__ */ h("span", { className: "font-medium text-stone-900 dark:text-stone-100", children: b.title }),
                          b.trend && /* @__PURE__ */ C("span", { className: F(
                            "inline-flex items-center",
                            b.trend === "up" && "text-green-500",
                            b.trend === "down" && "text-red-500",
                            b.trend === "neutral" && "text-stone-400"
                          ), children: [
                            b.trend === "up" && /* @__PURE__ */ h(Ss, { className: "h-3 w-3" }),
                            b.trend === "down" && /* @__PURE__ */ h(eg, { className: "h-3 w-3" }),
                            b.trend === "neutral" && /* @__PURE__ */ h(__, { className: "h-3 w-3" })
                          ] }),
                          /* @__PURE__ */ h(Qt, { variant: aq[b.importance], className: "text-[10px] px-1.5 py-0", children: b.importance })
                        ] }),
                        /* @__PURE__ */ h("p", { className: "mt-0.5 text-sm text-stone-600 dark:text-stone-400", children: b.description })
                      ] })
                    ]
                  },
                  b.id
                );
              }) })
            ] }),
            /* @__PURE__ */ C("div", { className: "mt-4 flex items-center justify-between border-t border-stone-200 pt-4 dark:border-stone-800", children: [
              /* @__PURE__ */ C(Te, { variant: "ghost", size: "sm", onClick: c, children: [
                /* @__PURE__ */ h(Ha, { className: "h-4 w-4" }),
                "Regenerate"
              ] }),
              s && /* @__PURE__ */ h(Te, { variant: "ghost", size: "sm", onClick: y, children: g ? /* @__PURE__ */ C(Ve, { children: [
                /* @__PURE__ */ h(ha, { className: "h-4 w-4" }),
                "Copied!"
              ] }) : /* @__PURE__ */ C(Ve, { children: [
                /* @__PURE__ */ h($$, { className: "h-4 w-4" }),
                "Copy"
              ] }) })
            ] })
          ] })
        ]
      }
    );
  }
);
oq.displayName = "AIInsightPanel";
const Vb = {
  crisis: {
    label: "Crisis Level",
    icon: Os,
    description: "Alert when crisis index exceeds threshold",
    unit: "%",
    min: 0,
    max: 100
  },
  sentiment: {
    label: "Sentiment Drop",
    icon: eg,
    description: "Alert when negative sentiment increases",
    unit: "%",
    min: 0,
    max: 100
  },
  volume: {
    label: "Volume Spike",
    icon: Ss,
    description: "Alert when mention volume increases significantly",
    unit: "%",
    min: 0,
    max: 500
  },
  keyword: {
    label: "Keyword Mention",
    icon: A_,
    description: "Alert when specific keywords are mentioned",
    unit: "",
    min: 0,
    max: 0
  }
}, Ub = {
  email: { label: "Email", icon: V$ },
  sms: { label: "SMS", icon: rI },
  whatsapp: { label: "WhatsApp", icon: fu },
  push: { label: "Push", icon: lu }
}, iq = [
  { value: "realtime", label: "Real-time" },
  { value: "hourly", label: "Hourly digest" },
  { value: "daily", label: "Daily digest" },
  { value: "weekly", label: "Weekly digest" }
], sq = {
  name: "New Alert",
  type: "crisis",
  enabled: !0,
  threshold: 50,
  channels: ["email"],
  frequency: "realtime"
}, cq = v.forwardRef(
  ({
    className: e,
    rules: t = [],
    isLoading: r = !1,
    isSaving: n = !1,
    onRulesChange: a,
    onSave: o,
    maxRules: i = 10,
    ...s
  }, c) => {
    const [l, u] = v.useState(t), [f, d] = v.useState(null);
    v.useEffect(() => {
      u(t);
    }, [t]);
    const p = () => {
      if (l.length >= i) return;
      const b = {
        ...sq,
        id: `rule-${Date.now()}`
      }, w = [...l, b];
      u(w), d(b.id), a == null || a(w);
    }, g = (b) => {
      const w = l.filter((S) => S.id !== b);
      u(w), a == null || a(w);
    }, m = (b, w) => {
      const S = l.map(
        (P) => P.id === b ? { ...P, ...w } : P
      );
      u(S), a == null || a(S);
    }, y = (b, w) => {
      const S = l.find((x) => x.id === b);
      if (!S) return;
      const P = S.channels.includes(w) ? S.channels.filter((x) => x !== w) : [...S.channels, w];
      m(b, { channels: P });
    };
    return r ? /* @__PURE__ */ h("div", { ref: c, className: F("space-y-4", e), ...s, children: Array.from({ length: 3 }).map((b, w) => /* @__PURE__ */ h(
      "div",
      {
        className: "animate-pulse rounded-lg border border-stone-200 bg-white p-4 dark:border-stone-800 dark:bg-stone-900",
        children: /* @__PURE__ */ C("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ h("div", { className: "h-8 w-8 rounded bg-stone-200 dark:bg-stone-700" }),
          /* @__PURE__ */ C("div", { className: "flex-1 space-y-2", children: [
            /* @__PURE__ */ h("div", { className: "h-4 w-32 rounded bg-stone-200 dark:bg-stone-700" }),
            /* @__PURE__ */ h("div", { className: "h-3 w-48 rounded bg-stone-200 dark:bg-stone-700" })
          ] })
        ] })
      },
      w
    )) }) : /* @__PURE__ */ C("div", { ref: c, className: F("space-y-4", e), ...s, children: [
      /* @__PURE__ */ C("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ C("div", { children: [
          /* @__PURE__ */ h("h3", { className: "text-lg font-semibold text-stone-900 dark:text-stone-100", children: "Alert Configuration" }),
          /* @__PURE__ */ h("p", { className: "text-sm text-stone-500", children: "Configure when and how you want to be notified" })
        ] }),
        /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ C("span", { className: "text-sm text-stone-500", children: [
            l.length,
            "/",
            i,
            " rules"
          ] }),
          /* @__PURE__ */ C(
            Te,
            {
              variant: "outline",
              size: "sm",
              onClick: p,
              disabled: l.length >= i,
              children: [
                /* @__PURE__ */ h(ov, { className: "h-4 w-4" }),
                "Add Rule"
              ]
            }
          )
        ] })
      ] }),
      l.length === 0 ? /* @__PURE__ */ h("div", { className: "flex h-48 items-center justify-center rounded-lg border border-dashed border-stone-300 dark:border-stone-700", children: /* @__PURE__ */ C("div", { className: "text-center", children: [
        /* @__PURE__ */ h(lu, { className: "mx-auto h-8 w-8 text-stone-400" }),
        /* @__PURE__ */ h("p", { className: "mt-2 font-medium text-stone-600 dark:text-stone-400", children: "No alert rules configured" }),
        /* @__PURE__ */ h("p", { className: "mt-1 text-sm text-stone-500", children: "Add a rule to start receiving notifications" }),
        /* @__PURE__ */ C(
          Te,
          {
            variant: "outline",
            size: "sm",
            className: "mt-4",
            onClick: p,
            children: [
              /* @__PURE__ */ h(ov, { className: "h-4 w-4" }),
              "Add First Rule"
            ]
          }
        )
      ] }) }) : /* @__PURE__ */ h("div", { className: "space-y-3", children: l.map((b) => {
        const w = Vb[b.type], S = w.icon, P = f === b.id;
        return /* @__PURE__ */ C(
          "div",
          {
            className: "overflow-hidden rounded-lg border border-stone-200 bg-white dark:border-stone-800 dark:bg-stone-900",
            children: [
              /* @__PURE__ */ C(
                "button",
                {
                  onClick: () => d(P ? null : b.id),
                  className: "flex w-full items-center justify-between p-4 text-left",
                  children: [
                    /* @__PURE__ */ C("div", { className: "flex items-center gap-3", children: [
                      /* @__PURE__ */ h(
                        "div",
                        {
                          className: F(
                            "flex h-8 w-8 items-center justify-center rounded-lg",
                            b.enabled ? "bg-primary-100 text-primary-600 dark:bg-primary-900 dark:text-primary-400" : "bg-stone-100 text-stone-400 dark:bg-stone-800"
                          ),
                          children: /* @__PURE__ */ h(S, { className: "h-4 w-4" })
                        }
                      ),
                      /* @__PURE__ */ C("div", { children: [
                        /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
                          /* @__PURE__ */ h("span", { className: "font-medium text-stone-900 dark:text-stone-100", children: b.name }),
                          !b.enabled && /* @__PURE__ */ h(Qt, { variant: "outline", className: "text-xs", children: "Disabled" })
                        ] }),
                        /* @__PURE__ */ C("p", { className: "text-sm text-stone-500", children: [
                          w.label,
                          b.type !== "keyword" && ` > ${b.threshold}${w.unit}`
                        ] })
                      ] })
                    ] }),
                    /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ h("div", { className: "flex gap-1", children: b.channels.map((x) => {
                        const O = Ub[x].icon;
                        return /* @__PURE__ */ h(
                          "div",
                          {
                            className: "flex h-6 w-6 items-center justify-center rounded bg-stone-100 dark:bg-stone-800",
                            children: /* @__PURE__ */ h(O, { className: "h-3 w-3 text-stone-500" })
                          },
                          x
                        );
                      }) }),
                      /* @__PURE__ */ h(
                        Yr,
                        {
                          className: F(
                            "h-5 w-5 text-stone-400 transition-transform",
                            P && "rotate-180"
                          )
                        }
                      )
                    ] })
                  ]
                }
              ),
              P && /* @__PURE__ */ C("div", { className: "border-t border-stone-200 p-4 dark:border-stone-800", children: [
                /* @__PURE__ */ C("div", { className: "grid gap-4 md:grid-cols-2", children: [
                  /* @__PURE__ */ C("div", { children: [
                    /* @__PURE__ */ h("label", { className: "mb-1.5 block text-sm font-medium text-stone-700 dark:text-stone-300", children: "Alert Name" }),
                    /* @__PURE__ */ h(
                      jc,
                      {
                        value: b.name,
                        onChange: (x) => m(b.id, { name: x.target.value }),
                        placeholder: "Enter alert name"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ C("div", { children: [
                    /* @__PURE__ */ h("label", { className: "mb-1.5 block text-sm font-medium text-stone-700 dark:text-stone-300", children: "Alert Type" }),
                    /* @__PURE__ */ h(
                      "select",
                      {
                        value: b.type,
                        onChange: (x) => m(b.id, { type: x.target.value }),
                        className: "h-10 w-full rounded-lg border border-stone-200 bg-white px-3 text-sm dark:border-stone-700 dark:bg-stone-900",
                        children: Object.entries(Vb).map(([x, O]) => /* @__PURE__ */ h("option", { value: x, children: O.label }, x))
                      }
                    )
                  ] }),
                  b.type !== "keyword" && /* @__PURE__ */ C("div", { children: [
                    /* @__PURE__ */ C("label", { className: "mb-1.5 block text-sm font-medium text-stone-700 dark:text-stone-300", children: [
                      "Threshold (",
                      w.unit,
                      ")"
                    ] }),
                    /* @__PURE__ */ h(
                      jc,
                      {
                        type: "number",
                        value: b.threshold,
                        onChange: (x) => m(b.id, { threshold: parseInt(x.target.value) || 0 }),
                        min: w.min,
                        max: w.max
                      }
                    )
                  ] }),
                  /* @__PURE__ */ C("div", { children: [
                    /* @__PURE__ */ h("label", { className: "mb-1.5 block text-sm font-medium text-stone-700 dark:text-stone-300", children: "Frequency" }),
                    /* @__PURE__ */ h(
                      "select",
                      {
                        value: b.frequency,
                        onChange: (x) => m(b.id, { frequency: x.target.value }),
                        className: "h-10 w-full rounded-lg border border-stone-200 bg-white px-3 text-sm dark:border-stone-700 dark:bg-stone-900",
                        children: iq.map((x) => /* @__PURE__ */ h("option", { value: x.value, children: x.label }, x.value))
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ C("div", { className: "mt-4", children: [
                  /* @__PURE__ */ h("label", { className: "mb-2 block text-sm font-medium text-stone-700 dark:text-stone-300", children: "Notification Channels" }),
                  /* @__PURE__ */ h("div", { className: "flex flex-wrap gap-2", children: Object.entries(Ub).map(
                    ([x, O]) => {
                      const A = b.channels.includes(x), _ = O.icon;
                      return /* @__PURE__ */ C(
                        "button",
                        {
                          onClick: () => y(b.id, x),
                          className: F(
                            "flex items-center gap-2 rounded-lg border px-3 py-2 text-sm transition-colors",
                            A ? "border-primary-500 bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-400" : "border-stone-200 hover:bg-stone-50 dark:border-stone-700 dark:hover:bg-stone-800"
                          ),
                          children: [
                            /* @__PURE__ */ h(_, { className: "h-4 w-4" }),
                            O.label
                          ]
                        },
                        x
                      );
                    }
                  ) })
                ] }),
                /* @__PURE__ */ C("div", { className: "mt-4 flex items-center justify-between border-t border-stone-200 pt-4 dark:border-stone-800", children: [
                  /* @__PURE__ */ C("label", { className: "flex cursor-pointer items-center gap-2", children: [
                    /* @__PURE__ */ h(
                      "input",
                      {
                        type: "checkbox",
                        checked: b.enabled,
                        onChange: (x) => m(b.id, { enabled: x.target.checked }),
                        className: "h-4 w-4 rounded border-stone-300"
                      }
                    ),
                    /* @__PURE__ */ h("span", { className: "text-sm text-stone-600 dark:text-stone-400", children: "Enable this rule" })
                  ] }),
                  /* @__PURE__ */ C(
                    Te,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: () => g(b.id),
                      className: "text-red-500 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-900/30",
                      children: [
                        /* @__PURE__ */ h(aI, { className: "h-4 w-4" }),
                        "Delete"
                      ]
                    }
                  )
                ] })
              ] })
            ]
          },
          b.id
        );
      }) }),
      l.length > 0 && o && /* @__PURE__ */ h("div", { className: "flex justify-end pt-4", children: /* @__PURE__ */ h(Te, { onClick: () => o(l), disabled: n, children: n ? "Saving..." : "Save Configuration" }) })
    ] });
  }
);
cq.displayName = "AlertConfiguration";
var Uf, Kb;
function Nt() {
  if (Kb) return Uf;
  Kb = 1;
  var e = Array.isArray;
  return Uf = e, Uf;
}
var Kf, Gb;
function mN() {
  if (Gb) return Kf;
  Gb = 1;
  var e = typeof Zs == "object" && Zs && Zs.Object === Object && Zs;
  return Kf = e, Kf;
}
var Gf, Yb;
function jr() {
  if (Yb) return Gf;
  Yb = 1;
  var e = mN(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return Gf = r, Gf;
}
var Yf, Xb;
function zs() {
  if (Xb) return Yf;
  Xb = 1;
  var e = jr(), t = e.Symbol;
  return Yf = t, Yf;
}
var Xf, Zb;
function lq() {
  if (Zb) return Xf;
  Zb = 1;
  var e = zs(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function o(i) {
    var s = r.call(i, a), c = i[a];
    try {
      i[a] = void 0;
      var l = !0;
    } catch {
    }
    var u = n.call(i);
    return l && (s ? i[a] = c : delete i[a]), u;
  }
  return Xf = o, Xf;
}
var Zf, Jb;
function uq() {
  if (Jb) return Zf;
  Jb = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Zf = r, Zf;
}
var Jf, Qb;
function an() {
  if (Qb) return Jf;
  Qb = 1;
  var e = zs(), t = lq(), r = uq(), n = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function i(s) {
    return s == null ? s === void 0 ? a : n : o && o in Object(s) ? t(s) : r(s);
  }
  return Jf = i, Jf;
}
var Qf, ex;
function on() {
  if (ex) return Qf;
  ex = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Qf = e, Qf;
}
var ed, tx;
function Do() {
  if (tx) return ed;
  tx = 1;
  var e = an(), t = on(), r = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || t(a) && e(a) == r;
  }
  return ed = n, ed;
}
var td, rx;
function zg() {
  if (rx) return td;
  rx = 1;
  var e = Nt(), t = Do(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(o, i) {
    if (e(o))
      return !1;
    var s = typeof o;
    return s == "number" || s == "symbol" || s == "boolean" || o == null || t(o) ? !0 : n.test(o) || !r.test(o) || i != null && o in Object(i);
  }
  return td = a, td;
}
var rd, nx;
function $n() {
  if (nx) return rd;
  nx = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return rd = e, rd;
}
var nd, ax;
function qg() {
  if (ax) return nd;
  ax = 1;
  var e = an(), t = $n(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function i(s) {
    if (!t(s))
      return !1;
    var c = e(s);
    return c == n || c == a || c == r || c == o;
  }
  return nd = i, nd;
}
var ad, ox;
function fq() {
  if (ox) return ad;
  ox = 1;
  var e = jr(), t = e["__core-js_shared__"];
  return ad = t, ad;
}
var od, ix;
function dq() {
  if (ix) return od;
  ix = 1;
  var e = fq(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return od = r, od;
}
var id, sx;
function vN() {
  if (sx) return id;
  sx = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return id = r, id;
}
var sd, cx;
function pq() {
  if (cx) return sd;
  cx = 1;
  var e = qg(), t = dq(), r = $n(), n = vN(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, i = Function.prototype, s = Object.prototype, c = i.toString, l = s.hasOwnProperty, u = RegExp(
    "^" + c.call(l).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(d) {
    if (!r(d) || t(d))
      return !1;
    var p = e(d) ? u : o;
    return p.test(n(d));
  }
  return sd = f, sd;
}
var cd, lx;
function hq() {
  if (lx) return cd;
  lx = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return cd = e, cd;
}
var ld, ux;
function va() {
  if (ux) return ld;
  ux = 1;
  var e = pq(), t = hq();
  function r(n, a) {
    var o = t(n, a);
    return e(o) ? o : void 0;
  }
  return ld = r, ld;
}
var ud, fx;
function Wu() {
  if (fx) return ud;
  fx = 1;
  var e = va(), t = e(Object, "create");
  return ud = t, ud;
}
var fd, dx;
function mq() {
  if (dx) return fd;
  dx = 1;
  var e = Wu();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return fd = t, fd;
}
var dd, px;
function vq() {
  if (px) return dd;
  px = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return dd = e, dd;
}
var pd, hx;
function yq() {
  if (hx) return pd;
  hx = 1;
  var e = Wu(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(o) {
    var i = this.__data__;
    if (e) {
      var s = i[o];
      return s === t ? void 0 : s;
    }
    return n.call(i, o) ? i[o] : void 0;
  }
  return pd = a, pd;
}
var hd, mx;
function gq() {
  if (mx) return hd;
  mx = 1;
  var e = Wu(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return hd = n, hd;
}
var md, vx;
function bq() {
  if (vx) return md;
  vx = 1;
  var e = Wu(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var o = this.__data__;
    return this.size += this.has(n) ? 0 : 1, o[n] = e && a === void 0 ? t : a, this;
  }
  return md = r, md;
}
var vd, yx;
function xq() {
  if (yx) return vd;
  yx = 1;
  var e = mq(), t = vq(), r = yq(), n = gq(), a = bq();
  function o(i) {
    var s = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++s < c; ) {
      var l = i[s];
      this.set(l[0], l[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = n, o.prototype.set = a, vd = o, vd;
}
var yd, gx;
function wq() {
  if (gx) return yd;
  gx = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return yd = e, yd;
}
var gd, bx;
function Wg() {
  if (bx) return gd;
  bx = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return gd = e, gd;
}
var bd, xx;
function Hu() {
  if (xx) return bd;
  xx = 1;
  var e = Wg();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return bd = t, bd;
}
var xd, wx;
function Sq() {
  if (wx) return xd;
  wx = 1;
  var e = Hu(), t = Array.prototype, r = t.splice;
  function n(a) {
    var o = this.__data__, i = e(o, a);
    if (i < 0)
      return !1;
    var s = o.length - 1;
    return i == s ? o.pop() : r.call(o, i, 1), --this.size, !0;
  }
  return xd = n, xd;
}
var wd, Sx;
function Oq() {
  if (Sx) return wd;
  Sx = 1;
  var e = Hu();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return wd = t, wd;
}
var Sd, Ox;
function Pq() {
  if (Ox) return Sd;
  Ox = 1;
  var e = Hu();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Sd = t, Sd;
}
var Od, Px;
function Aq() {
  if (Px) return Od;
  Px = 1;
  var e = Hu();
  function t(r, n) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, n])) : a[o][1] = n, this;
  }
  return Od = t, Od;
}
var Pd, Ax;
function Vu() {
  if (Ax) return Pd;
  Ax = 1;
  var e = wq(), t = Sq(), r = Oq(), n = Pq(), a = Aq();
  function o(i) {
    var s = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++s < c; ) {
      var l = i[s];
      this.set(l[0], l[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = n, o.prototype.set = a, Pd = o, Pd;
}
var Ad, _x;
function Hg() {
  if (_x) return Ad;
  _x = 1;
  var e = va(), t = jr(), r = e(t, "Map");
  return Ad = r, Ad;
}
var _d, Ex;
function _q() {
  if (Ex) return _d;
  Ex = 1;
  var e = xq(), t = Vu(), r = Hg();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return _d = n, _d;
}
var Ed, Cx;
function Eq() {
  if (Cx) return Ed;
  Cx = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Ed = e, Ed;
}
var Cd, kx;
function Uu() {
  if (kx) return Cd;
  kx = 1;
  var e = Eq();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return Cd = t, Cd;
}
var kd, Nx;
function Cq() {
  if (Nx) return kd;
  Nx = 1;
  var e = Uu();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return kd = t, kd;
}
var Nd, Tx;
function kq() {
  if (Tx) return Nd;
  Tx = 1;
  var e = Uu();
  function t(r) {
    return e(this, r).get(r);
  }
  return Nd = t, Nd;
}
var Td, Mx;
function Nq() {
  if (Mx) return Td;
  Mx = 1;
  var e = Uu();
  function t(r) {
    return e(this, r).has(r);
  }
  return Td = t, Td;
}
var Md, Rx;
function Tq() {
  if (Rx) return Md;
  Rx = 1;
  var e = Uu();
  function t(r, n) {
    var a = e(this, r), o = a.size;
    return a.set(r, n), this.size += a.size == o ? 0 : 1, this;
  }
  return Md = t, Md;
}
var Rd, $x;
function Vg() {
  if ($x) return Rd;
  $x = 1;
  var e = _q(), t = Cq(), r = kq(), n = Nq(), a = Tq();
  function o(i) {
    var s = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++s < c; ) {
      var l = i[s];
      this.set(l[0], l[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = n, o.prototype.set = a, Rd = o, Rd;
}
var $d, Ix;
function yN() {
  if (Ix) return $d;
  Ix = 1;
  var e = Vg(), t = "Expected a function";
  function r(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(t);
    var o = function() {
      var i = arguments, s = a ? a.apply(this, i) : i[0], c = o.cache;
      if (c.has(s))
        return c.get(s);
      var l = n.apply(this, i);
      return o.cache = c.set(s, l) || c, l;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, $d = r, $d;
}
var Id, Dx;
function Mq() {
  if (Dx) return Id;
  Dx = 1;
  var e = yN(), t = 500;
  function r(n) {
    var a = e(n, function(i) {
      return o.size === t && o.clear(), i;
    }), o = a.cache;
    return a;
  }
  return Id = r, Id;
}
var Dd, jx;
function Rq() {
  if (jx) return Dd;
  jx = 1;
  var e = Mq(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(t, function(i, s, c, l) {
      o.push(c ? l.replace(r, "$1") : s || i);
    }), o;
  });
  return Dd = n, Dd;
}
var jd, Lx;
function Ug() {
  if (Lx) return jd;
  Lx = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, o = Array(a); ++n < a; )
      o[n] = r(t[n], n, t);
    return o;
  }
  return jd = e, jd;
}
var Ld, Bx;
function $q() {
  if (Bx) return Ld;
  Bx = 1;
  var e = zs(), t = Ug(), r = Nt(), n = Do(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function i(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return t(s, i) + "";
    if (n(s))
      return o ? o.call(s) : "";
    var c = s + "";
    return c == "0" && 1 / s == -1 / 0 ? "-0" : c;
  }
  return Ld = i, Ld;
}
var Bd, Fx;
function gN() {
  if (Fx) return Bd;
  Fx = 1;
  var e = $q();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return Bd = t, Bd;
}
var Fd, zx;
function bN() {
  if (zx) return Fd;
  zx = 1;
  var e = Nt(), t = zg(), r = Rq(), n = gN();
  function a(o, i) {
    return e(o) ? o : t(o, i) ? [o] : r(n(o));
  }
  return Fd = a, Fd;
}
var zd, qx;
function Ku() {
  if (qx) return zd;
  qx = 1;
  var e = Do();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return zd = t, zd;
}
var qd, Wx;
function Kg() {
  if (Wx) return qd;
  Wx = 1;
  var e = bN(), t = Ku();
  function r(n, a) {
    a = e(a, n);
    for (var o = 0, i = a.length; n != null && o < i; )
      n = n[t(a[o++])];
    return o && o == i ? n : void 0;
  }
  return qd = r, qd;
}
var Wd, Hx;
function xN() {
  if (Hx) return Wd;
  Hx = 1;
  var e = Kg();
  function t(r, n, a) {
    var o = r == null ? void 0 : e(r, n);
    return o === void 0 ? a : o;
  }
  return Wd = t, Wd;
}
var Iq = xN();
const lt = /* @__PURE__ */ _e(Iq);
var Hd, Vx;
function Dq() {
  if (Vx) return Hd;
  Vx = 1;
  function e(t) {
    return t == null;
  }
  return Hd = e, Hd;
}
var jq = Dq();
const ce = /* @__PURE__ */ _e(jq);
var Vd, Ux;
function Lq() {
  if (Ux) return Vd;
  Ux = 1;
  var e = an(), t = Nt(), r = on(), n = "[object String]";
  function a(o) {
    return typeof o == "string" || !t(o) && r(o) && e(o) == n;
  }
  return Vd = a, Vd;
}
var Bq = Lq();
const la = /* @__PURE__ */ _e(Bq);
var Fq = qg();
const se = /* @__PURE__ */ _e(Fq);
var zq = $n();
const jo = /* @__PURE__ */ _e(zq);
var lc = { exports: {} }, we = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kx;
function qq() {
  if (Kx) return we;
  Kx = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function m(y) {
    if (typeof y == "object" && y !== null) {
      var b = y.$$typeof;
      switch (b) {
        case e:
          switch (y = y.type, y) {
            case r:
            case a:
            case n:
            case l:
            case u:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case i:
                case c:
                case d:
                case f:
                case o:
                  return y;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return we.ContextConsumer = i, we.ContextProvider = o, we.Element = e, we.ForwardRef = c, we.Fragment = r, we.Lazy = d, we.Memo = f, we.Portal = t, we.Profiler = a, we.StrictMode = n, we.Suspense = l, we.SuspenseList = u, we.isAsyncMode = function() {
    return !1;
  }, we.isConcurrentMode = function() {
    return !1;
  }, we.isContextConsumer = function(y) {
    return m(y) === i;
  }, we.isContextProvider = function(y) {
    return m(y) === o;
  }, we.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, we.isForwardRef = function(y) {
    return m(y) === c;
  }, we.isFragment = function(y) {
    return m(y) === r;
  }, we.isLazy = function(y) {
    return m(y) === d;
  }, we.isMemo = function(y) {
    return m(y) === f;
  }, we.isPortal = function(y) {
    return m(y) === t;
  }, we.isProfiler = function(y) {
    return m(y) === a;
  }, we.isStrictMode = function(y) {
    return m(y) === n;
  }, we.isSuspense = function(y) {
    return m(y) === l;
  }, we.isSuspenseList = function(y) {
    return m(y) === u;
  }, we.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === a || y === n || y === l || y === u || y === p || typeof y == "object" && y !== null && (y.$$typeof === d || y.$$typeof === f || y.$$typeof === o || y.$$typeof === i || y.$$typeof === c || y.$$typeof === g || y.getModuleId !== void 0);
  }, we.typeOf = m, we;
}
var Se = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gx;
function Wq() {
  return Gx || (Gx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g = !1, m = !1, y = !1, b = !1, w = !1, S;
    S = Symbol.for("react.module.reference");
    function P(Z) {
      return !!(typeof Z == "string" || typeof Z == "function" || Z === r || Z === a || w || Z === n || Z === l || Z === u || b || Z === p || g || m || y || typeof Z == "object" && Z !== null && (Z.$$typeof === d || Z.$$typeof === f || Z.$$typeof === o || Z.$$typeof === i || Z.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Z.$$typeof === S || Z.getModuleId !== void 0));
    }
    function x(Z) {
      if (typeof Z == "object" && Z !== null) {
        var ve = Z.$$typeof;
        switch (ve) {
          case e:
            var ye = Z.type;
            switch (ye) {
              case r:
              case a:
              case n:
              case l:
              case u:
                return ye;
              default:
                var Ie = ye && ye.$$typeof;
                switch (Ie) {
                  case s:
                  case i:
                  case c:
                  case d:
                  case f:
                  case o:
                    return Ie;
                  default:
                    return ve;
                }
            }
          case t:
            return ve;
        }
      }
    }
    var O = i, A = o, _ = e, N = c, M = r, T = d, k = f, $ = t, R = a, L = n, j = l, z = u, q = !1, I = !1;
    function B(Z) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function W(Z) {
      return I || (I = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function H(Z) {
      return x(Z) === i;
    }
    function U(Z) {
      return x(Z) === o;
    }
    function X(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === e;
    }
    function ee(Z) {
      return x(Z) === c;
    }
    function ne(Z) {
      return x(Z) === r;
    }
    function G(Z) {
      return x(Z) === d;
    }
    function te(Z) {
      return x(Z) === f;
    }
    function V(Z) {
      return x(Z) === t;
    }
    function Y(Z) {
      return x(Z) === a;
    }
    function Q(Z) {
      return x(Z) === n;
    }
    function D(Z) {
      return x(Z) === l;
    }
    function le(Z) {
      return x(Z) === u;
    }
    Se.ContextConsumer = O, Se.ContextProvider = A, Se.Element = _, Se.ForwardRef = N, Se.Fragment = M, Se.Lazy = T, Se.Memo = k, Se.Portal = $, Se.Profiler = R, Se.StrictMode = L, Se.Suspense = j, Se.SuspenseList = z, Se.isAsyncMode = B, Se.isConcurrentMode = W, Se.isContextConsumer = H, Se.isContextProvider = U, Se.isElement = X, Se.isForwardRef = ee, Se.isFragment = ne, Se.isLazy = G, Se.isMemo = te, Se.isPortal = V, Se.isProfiler = Y, Se.isStrictMode = Q, Se.isSuspense = D, Se.isSuspenseList = le, Se.isValidElementType = P, Se.typeOf = x;
  })()), Se;
}
var Yx;
function Hq() {
  return Yx || (Yx = 1, process.env.NODE_ENV === "production" ? lc.exports = qq() : lc.exports = Wq()), lc.exports;
}
var Vq = Hq(), Ud, Xx;
function wN() {
  if (Xx) return Ud;
  Xx = 1;
  var e = an(), t = on(), r = "[object Number]";
  function n(a) {
    return typeof a == "number" || t(a) && e(a) == r;
  }
  return Ud = n, Ud;
}
var Kd, Zx;
function Uq() {
  if (Zx) return Kd;
  Zx = 1;
  var e = wN();
  function t(r) {
    return e(r) && r != +r;
  }
  return Kd = t, Kd;
}
var Kq = Uq();
const Lo = /* @__PURE__ */ _e(Kq);
var Gq = wN();
const Yq = /* @__PURE__ */ _e(Gq);
var yt = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, Xn = function(t) {
  return la(t) && t.indexOf("%") === t.length - 1;
}, J = function(t) {
  return Yq(t) && !Lo(t);
}, Xq = function(t) {
  return ce(t);
}, tt = function(t) {
  return J(t) || la(t);
}, Zq = 0, In = function(t) {
  var r = ++Zq;
  return "".concat(t || "").concat(r);
}, gt = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!J(t) && !la(t))
    return n;
  var o;
  if (Xn(t)) {
    var i = t.indexOf("%");
    o = r * parseFloat(t.slice(0, i)) / 100;
  } else
    o = +t;
  return Lo(o) && (o = n), a && o > r && (o = r), o;
}, gn = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, Jq = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, a = 0; a < r; a++)
    if (!n[t[a]])
      n[t[a]] = !0;
    else
      return !0;
  return !1;
}, Ne = function(t, r) {
  return J(t) && J(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function Qc(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : lt(n, t)) === r;
  });
}
var Qq = function(t) {
  if (!t || !t.length)
    return null;
  for (var r = t.length, n = 0, a = 0, o = 0, i = 0, s = 1 / 0, c = -1 / 0, l = 0, u = 0, f = 0; f < r; f++)
    l = t[f].cx || 0, u = t[f].cy || 0, n += l, a += u, o += l * u, i += l * l, s = Math.min(s, l), c = Math.max(c, l);
  var d = r * i !== n * n ? (r * o - n * a) / (r * i - n * n) : 0;
  return {
    xmin: s,
    xmax: c,
    a: d,
    b: (a - d * n) / r
  };
}, eW = function(t, r) {
  return J(t) && J(r) ? t - r : la(t) && la(r) ? t.localeCompare(r) : t instanceof Date && r instanceof Date ? t.getTime() - r.getTime() : String(t).localeCompare(String(r));
};
function ra(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function Pv(e) {
  "@babel/helpers - typeof";
  return Pv = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pv(e);
}
var tW = ["viewBox", "children"], rW = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], Jx = ["points", "pathLength"], Gd = {
  svg: tW,
  polygon: Jx,
  polyline: Jx
}, Gg = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], el = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ Et(t) && (n = t.props), !jo(n))
    return null;
  var a = {};
  return Object.keys(n).forEach(function(o) {
    Gg.includes(o) && (a[o] = r || function(i) {
      return n[o](n, i);
    });
  }), a;
}, nW = function(t, r, n) {
  return function(a) {
    return t(r, n, a), null;
  };
}, Cn = function(t, r, n) {
  if (!jo(t) || Pv(t) !== "object")
    return null;
  var a = null;
  return Object.keys(t).forEach(function(o) {
    var i = t[o];
    Gg.includes(o) && typeof i == "function" && (a || (a = {}), a[o] = nW(i, r, n));
  }), a;
}, aW = ["children"], oW = ["children"];
function Qx(e, t) {
  if (e == null) return {};
  var r = iW(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function iW(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Av(e) {
  "@babel/helpers - typeof";
  return Av = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Av(e);
}
var ew = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Kr = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, tw = null, Yd = null, Gu = function e(t) {
  if (t === tw && Array.isArray(Yd))
    return Yd;
  var r = [];
  return ta.forEach(t, function(n) {
    ce(n) || (Vq.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), Yd = r, tw = t, r;
};
function xt(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(a) {
    return Kr(a);
  }) : n = [Kr(t)], Gu(e).forEach(function(a) {
    var o = lt(a, "type.displayName") || lt(a, "type.name");
    n.indexOf(o) !== -1 && r.push(a);
  }), r;
}
function ct(e, t) {
  var r = xt(e, t);
  return r && r[0];
}
var _v = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, a = r.height;
  return !(!J(n) || n <= 0 || !J(a) || a <= 0);
}, sW = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], SN = function(t) {
  return t && t.type && la(t.type) && sW.indexOf(t.type) >= 0;
}, ON = function(t) {
  return t && Av(t) === "object" && "clipDot" in t;
}, cW = function(t, r, n, a) {
  var o, i = (o = Gd == null ? void 0 : Gd[a]) !== null && o !== void 0 ? o : [];
  return r.startsWith("data-") || !se(t) && (a && i.includes(r) || rW.includes(r)) || n && Gg.includes(r);
}, lW = function(t) {
  var r = [];
  return Gu(t).forEach(function(n) {
    SN(n) && r.push(n);
  }), r;
}, ae = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var a = t;
  if (/* @__PURE__ */ Et(t) && (a = t.props), !jo(a))
    return null;
  var o = {};
  return Object.keys(a).forEach(function(i) {
    var s;
    cW((s = a) === null || s === void 0 ? void 0 : s[i], i, r, n) && (o[i] = a[i]);
  }), o;
}, Ev = function e(t, r) {
  if (t === r)
    return !0;
  var n = ta.count(t);
  if (n !== ta.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return rw(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var a = 0; a < n; a++) {
    var o = t[a], i = r[a];
    if (Array.isArray(o) || Array.isArray(i)) {
      if (!e(o, i))
        return !1;
    } else if (!rw(o, i))
      return !1;
  }
  return !0;
}, rw = function(t, r) {
  if (ce(t) && ce(r))
    return !0;
  if (!ce(t) && !ce(r)) {
    var n = t.props || {}, a = n.children, o = Qx(n, aW), i = r.props || {}, s = i.children, c = Qx(i, oW);
    return a && s ? ra(o, c) && Ev(a, s) : !a && !s ? ra(o, c) : !1;
  }
  return !1;
}, nw = function(t, r) {
  var n = [], a = {};
  return Gu(t).forEach(function(o, i) {
    if (SN(o))
      n.push(o);
    else if (o) {
      var s = Kr(o.type), c = r[s] || {}, l = c.handler, u = c.once;
      if (l && (!u || !a[s])) {
        var f = l(o, s, i);
        n.push(f), a[s] = !0;
      }
    }
  }), n;
}, uW = function(t) {
  var r = t && t.type;
  return r && ew[r] ? ew[r] : null;
}, fW = function(t, r) {
  return Gu(r).indexOf(t);
}, dW = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function Cv() {
  return Cv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cv.apply(this, arguments);
}
function pW(e, t) {
  if (e == null) return {};
  var r = hW(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function hW(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function tl(e) {
  var t = e.children, r = e.width, n = e.height, a = e.viewBox, o = e.className, i = e.style, s = e.title, c = e.desc, l = pW(e, dW), u = a || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, f = ue("recharts-surface", o);
  return /* @__PURE__ */ E.createElement("svg", Cv({}, ae(l, !0, "svg"), {
    className: f,
    width: r,
    height: n,
    style: i,
    viewBox: "".concat(u.x, " ").concat(u.y, " ").concat(u.width, " ").concat(u.height)
  }), /* @__PURE__ */ E.createElement("title", null, s), /* @__PURE__ */ E.createElement("desc", null, c), t);
}
var mW = ["children", "className"];
function kv() {
  return kv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, kv.apply(this, arguments);
}
function vW(e, t) {
  if (e == null) return {};
  var r = yW(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function yW(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var de = /* @__PURE__ */ E.forwardRef(function(e, t) {
  var r = e.children, n = e.className, a = vW(e, mW), o = ue("recharts-layer", n);
  return /* @__PURE__ */ E.createElement("g", kv({
    className: o
  }, ae(a, !0), {
    ref: t
  }), r);
}), gW = process.env.NODE_ENV !== "production", hr = function(t, r) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    a[o - 2] = arguments[o];
  if (gW && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var i = 0;
      console.warn(r.replace(/%s/g, function() {
        return a[i++];
      }));
    }
}, Xd, aw;
function bW() {
  if (aw) return Xd;
  aw = 1;
  function e(t, r, n) {
    var a = -1, o = t.length;
    r < 0 && (r = -r > o ? 0 : o + r), n = n > o ? o : n, n < 0 && (n += o), o = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var i = Array(o); ++a < o; )
      i[a] = t[a + r];
    return i;
  }
  return Xd = e, Xd;
}
var Zd, ow;
function xW() {
  if (ow) return Zd;
  ow = 1;
  var e = bW();
  function t(r, n, a) {
    var o = r.length;
    return a = a === void 0 ? o : a, !n && a >= o ? r : e(r, n, a);
  }
  return Zd = t, Zd;
}
var Jd, iw;
function PN() {
  if (iw) return Jd;
  iw = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, o = "\\ufe0e\\ufe0f", i = "\\u200d", s = RegExp("[" + i + e + a + o + "]");
  function c(l) {
    return s.test(l);
  }
  return Jd = c, Jd;
}
var Qd, sw;
function wW() {
  if (sw) return Qd;
  sw = 1;
  function e(t) {
    return t.split("");
  }
  return Qd = e, Qd;
}
var ep, cw;
function SW() {
  if (cw) return ep;
  cw = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = t + r + n, o = "\\ufe0e\\ufe0f", i = "[" + e + "]", s = "[" + a + "]", c = "\\ud83c[\\udffb-\\udfff]", l = "(?:" + s + "|" + c + ")", u = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", d = "[\\ud800-\\udbff][\\udc00-\\udfff]", p = "\\u200d", g = l + "?", m = "[" + o + "]?", y = "(?:" + p + "(?:" + [u, f, d].join("|") + ")" + m + g + ")*", b = m + g + y, w = "(?:" + [u + s + "?", s, f, d, i].join("|") + ")", S = RegExp(c + "(?=" + c + ")|" + w + b, "g");
  function P(x) {
    return x.match(S) || [];
  }
  return ep = P, ep;
}
var tp, lw;
function OW() {
  if (lw) return tp;
  lw = 1;
  var e = wW(), t = PN(), r = SW();
  function n(a) {
    return t(a) ? r(a) : e(a);
  }
  return tp = n, tp;
}
var rp, uw;
function PW() {
  if (uw) return rp;
  uw = 1;
  var e = xW(), t = PN(), r = OW(), n = gN();
  function a(o) {
    return function(i) {
      i = n(i);
      var s = t(i) ? r(i) : void 0, c = s ? s[0] : i.charAt(0), l = s ? e(s, 1).join("") : i.slice(1);
      return c[o]() + l;
    };
  }
  return rp = a, rp;
}
var np, fw;
function AW() {
  if (fw) return np;
  fw = 1;
  var e = PW(), t = e("toUpperCase");
  return np = t, np;
}
var _W = AW();
const Yu = /* @__PURE__ */ _e(_W);
function $e(e) {
  return function() {
    return e;
  };
}
const AN = Math.cos, rl = Math.sin, xr = Math.sqrt, nl = Math.PI, Xu = 2 * nl, Nv = Math.PI, Tv = 2 * Nv, Un = 1e-6, EW = Tv - Un;
function _N(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function CW(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return _N;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let a = 1, o = n.length; a < o; ++a)
      this._ += Math.round(arguments[a] * r) / r + n[a];
  };
}
class kW {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? _N : CW(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, a) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +a}`;
  }
  bezierCurveTo(t, r, n, a, o, i) {
    this._append`C${+t},${+r},${+n},${+a},${this._x1 = +o},${this._y1 = +i}`;
  }
  arcTo(t, r, n, a, o) {
    if (t = +t, r = +r, n = +n, a = +a, o = +o, o < 0) throw new Error(`negative radius: ${o}`);
    let i = this._x1, s = this._y1, c = n - t, l = a - r, u = i - t, f = s - r, d = u * u + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (d > Un) if (!(Math.abs(f * c - l * u) > Un) || !o)
      this._append`L${this._x1 = t},${this._y1 = r}`;
    else {
      let p = n - i, g = a - s, m = c * c + l * l, y = p * p + g * g, b = Math.sqrt(m), w = Math.sqrt(d), S = o * Math.tan((Nv - Math.acos((m + d - y) / (2 * b * w))) / 2), P = S / w, x = S / b;
      Math.abs(P - 1) > Un && this._append`L${t + P * u},${r + P * f}`, this._append`A${o},${o},0,0,${+(f * p > u * g)},${this._x1 = t + x * c},${this._y1 = r + x * l}`;
    }
  }
  arc(t, r, n, a, o, i) {
    if (t = +t, r = +r, n = +n, i = !!i, n < 0) throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(a), c = n * Math.sin(a), l = t + s, u = r + c, f = 1 ^ i, d = i ? a - o : o - a;
    this._x1 === null ? this._append`M${l},${u}` : (Math.abs(this._x1 - l) > Un || Math.abs(this._y1 - u) > Un) && this._append`L${l},${u}`, n && (d < 0 && (d = d % Tv + Tv), d > EW ? this._append`A${n},${n},0,1,${f},${t - s},${r - c}A${n},${n},0,1,${f},${this._x1 = l},${this._y1 = u}` : d > Un && this._append`A${n},${n},0,${+(d >= Nv)},${f},${this._x1 = t + n * Math.cos(o)},${this._y1 = r + n * Math.sin(o)}`);
  }
  rect(t, r, n, a) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+a}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function Yg(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length) return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new kW(t);
}
function Xg(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function EN(e) {
  this._context = e;
}
EN.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function Zu(e) {
  return new EN(e);
}
function CN(e) {
  return e[0];
}
function kN(e) {
  return e[1];
}
function NN(e, t) {
  var r = $e(!0), n = null, a = Zu, o = null, i = Yg(s);
  e = typeof e == "function" ? e : e === void 0 ? CN : $e(e), t = typeof t == "function" ? t : t === void 0 ? kN : $e(t);
  function s(c) {
    var l, u = (c = Xg(c)).length, f, d = !1, p;
    for (n == null && (o = a(p = i())), l = 0; l <= u; ++l)
      !(l < u && r(f = c[l], l, c)) === d && ((d = !d) ? o.lineStart() : o.lineEnd()), d && o.point(+e(f, l, c), +t(f, l, c));
    if (p) return o = null, p + "" || null;
  }
  return s.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : $e(+c), s) : e;
  }, s.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : $e(+c), s) : t;
  }, s.defined = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : $e(!!c), s) : r;
  }, s.curve = function(c) {
    return arguments.length ? (a = c, n != null && (o = a(n)), s) : a;
  }, s.context = function(c) {
    return arguments.length ? (c == null ? n = o = null : o = a(n = c), s) : n;
  }, s;
}
function uc(e, t, r) {
  var n = null, a = $e(!0), o = null, i = Zu, s = null, c = Yg(l);
  e = typeof e == "function" ? e : e === void 0 ? CN : $e(+e), t = typeof t == "function" ? t : $e(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? kN : $e(+r);
  function l(f) {
    var d, p, g, m = (f = Xg(f)).length, y, b = !1, w, S = new Array(m), P = new Array(m);
    for (o == null && (s = i(w = c())), d = 0; d <= m; ++d) {
      if (!(d < m && a(y = f[d], d, f)) === b)
        if (b = !b)
          p = d, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), g = d - 1; g >= p; --g)
            s.point(S[g], P[g]);
          s.lineEnd(), s.areaEnd();
        }
      b && (S[d] = +e(y, d, f), P[d] = +t(y, d, f), s.point(n ? +n(y, d, f) : S[d], r ? +r(y, d, f) : P[d]));
    }
    if (w) return s = null, w + "" || null;
  }
  function u() {
    return NN().defined(a).curve(i).context(o);
  }
  return l.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : $e(+f), n = null, l) : e;
  }, l.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : $e(+f), l) : e;
  }, l.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : $e(+f), l) : n;
  }, l.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : $e(+f), r = null, l) : t;
  }, l.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : $e(+f), l) : t;
  }, l.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : $e(+f), l) : r;
  }, l.lineX0 = l.lineY0 = function() {
    return u().x(e).y(t);
  }, l.lineY1 = function() {
    return u().x(e).y(r);
  }, l.lineX1 = function() {
    return u().x(n).y(t);
  }, l.defined = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : $e(!!f), l) : a;
  }, l.curve = function(f) {
    return arguments.length ? (i = f, o != null && (s = i(o)), l) : i;
  }, l.context = function(f) {
    return arguments.length ? (f == null ? o = s = null : s = i(o = f), l) : o;
  }, l;
}
class TN {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function NW(e) {
  return new TN(e, !0);
}
function TW(e) {
  return new TN(e, !1);
}
const Zg = {
  draw(e, t) {
    const r = xr(t / nl);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, Xu);
  }
}, MW = {
  draw(e, t) {
    const r = xr(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, MN = xr(1 / 3), RW = MN * 2, $W = {
  draw(e, t) {
    const r = xr(t / RW), n = r * MN;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, IW = {
  draw(e, t) {
    const r = xr(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, DW = 0.8908130915292852, RN = rl(nl / 10) / rl(7 * nl / 10), jW = rl(Xu / 10) * RN, LW = -AN(Xu / 10) * RN, BW = {
  draw(e, t) {
    const r = xr(t * DW), n = jW * r, a = LW * r;
    e.moveTo(0, -r), e.lineTo(n, a);
    for (let o = 1; o < 5; ++o) {
      const i = Xu * o / 5, s = AN(i), c = rl(i);
      e.lineTo(c * r, -s * r), e.lineTo(s * n - c * a, c * n + s * a);
    }
    e.closePath();
  }
}, ap = xr(3), FW = {
  draw(e, t) {
    const r = -xr(t / (ap * 3));
    e.moveTo(0, r * 2), e.lineTo(-ap * r, -r), e.lineTo(ap * r, -r), e.closePath();
  }
}, Ht = -0.5, Vt = xr(3) / 2, Mv = 1 / xr(12), zW = (Mv / 2 + 1) * 3, qW = {
  draw(e, t) {
    const r = xr(t / zW), n = r / 2, a = r * Mv, o = n, i = r * Mv + r, s = -o, c = i;
    e.moveTo(n, a), e.lineTo(o, i), e.lineTo(s, c), e.lineTo(Ht * n - Vt * a, Vt * n + Ht * a), e.lineTo(Ht * o - Vt * i, Vt * o + Ht * i), e.lineTo(Ht * s - Vt * c, Vt * s + Ht * c), e.lineTo(Ht * n + Vt * a, Ht * a - Vt * n), e.lineTo(Ht * o + Vt * i, Ht * i - Vt * o), e.lineTo(Ht * s + Vt * c, Ht * c - Vt * s), e.closePath();
  }
};
function WW(e, t) {
  let r = null, n = Yg(a);
  e = typeof e == "function" ? e : $e(e || Zg), t = typeof t == "function" ? t : $e(t === void 0 ? 64 : +t);
  function a() {
    let o;
    if (r || (r = o = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), o) return r = null, o + "" || null;
  }
  return a.type = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : $e(o), a) : e;
  }, a.size = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : $e(+o), a) : t;
  }, a.context = function(o) {
    return arguments.length ? (r = o ?? null, a) : r;
  }, a;
}
function al() {
}
function ol(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function $N(e) {
  this._context = e;
}
$N.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        ol(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        ol(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function HW(e) {
  return new $N(e);
}
function IN(e) {
  this._context = e;
}
IN.prototype = {
  areaStart: al,
  areaEnd: al,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        ol(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function VW(e) {
  return new IN(e);
}
function DN(e) {
  this._context = e;
}
DN.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        ol(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function UW(e) {
  return new DN(e);
}
function jN(e) {
  this._context = e;
}
jN.prototype = {
  areaStart: al,
  areaEnd: al,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function KW(e) {
  return new jN(e);
}
function dw(e) {
  return e < 0 ? -1 : 1;
}
function pw(e, t, r) {
  var n = e._x1 - e._x0, a = t - e._x1, o = (e._y1 - e._y0) / (n || a < 0 && -0), i = (r - e._y1) / (a || n < 0 && -0), s = (o * a + i * n) / (n + a);
  return (dw(o) + dw(i)) * Math.min(Math.abs(o), Math.abs(i), 0.5 * Math.abs(s)) || 0;
}
function hw(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function op(e, t, r) {
  var n = e._x0, a = e._y0, o = e._x1, i = e._y1, s = (o - n) / 3;
  e._context.bezierCurveTo(n + s, a + s * t, o - s, i - s * r, o, i);
}
function il(e) {
  this._context = e;
}
il.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        op(this, this._t0, hw(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, op(this, hw(this, r = pw(this, e, t)), r);
          break;
        default:
          op(this, this._t0, r = pw(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function LN(e) {
  this._context = new BN(e);
}
(LN.prototype = Object.create(il.prototype)).point = function(e, t) {
  il.prototype.point.call(this, t, e);
};
function BN(e) {
  this._context = e;
}
BN.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, a, o) {
    this._context.bezierCurveTo(t, e, n, r, o, a);
  }
};
function GW(e) {
  return new il(e);
}
function YW(e) {
  return new LN(e);
}
function FN(e) {
  this._context = e;
}
FN.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = mw(e), a = mw(t), o = 0, i = 1; i < r; ++o, ++i)
          this._context.bezierCurveTo(n[0][o], a[0][o], n[1][o], a[1][o], e[i], t[i]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function mw(e) {
  var t, r = e.length - 1, n, a = new Array(r), o = new Array(r), i = new Array(r);
  for (a[0] = 0, o[0] = 2, i[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) a[t] = 1, o[t] = 4, i[t] = 4 * e[t] + 2 * e[t + 1];
  for (a[r - 1] = 2, o[r - 1] = 7, i[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = a[t] / o[t - 1], o[t] -= n, i[t] -= n * i[t - 1];
  for (a[r - 1] = i[r - 1] / o[r - 1], t = r - 2; t >= 0; --t) a[t] = (i[t] - a[t + 1]) / o[t];
  for (o[r - 1] = (e[r] + a[r - 1]) / 2, t = 0; t < r - 1; ++t) o[t] = 2 * e[t + 1] - a[t + 1];
  return [a, o];
}
function XW(e) {
  return new FN(e);
}
function Ju(e, t) {
  this._context = e, this._t = t;
}
Ju.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function ZW(e) {
  return new Ju(e, 0.5);
}
function JW(e) {
  return new Ju(e, 0);
}
function QW(e) {
  return new Ju(e, 1);
}
function Ya(e, t) {
  if ((i = e.length) > 1)
    for (var r = 1, n, a, o = e[t[0]], i, s = o.length; r < i; ++r)
      for (a = o, o = e[t[r]], n = 0; n < s; ++n)
        o[n][1] += o[n][0] = isNaN(a[n][1]) ? a[n][0] : a[n][1];
}
function Rv(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
  return r;
}
function eH(e, t) {
  return e[t];
}
function tH(e) {
  const t = [];
  return t.key = e, t;
}
function rH() {
  var e = $e([]), t = Rv, r = Ya, n = eH;
  function a(o) {
    var i = Array.from(e.apply(this, arguments), tH), s, c = i.length, l = -1, u;
    for (const f of o)
      for (s = 0, ++l; s < c; ++s)
        (i[s][l] = [0, +n(f, i[s].key, l, o)]).data = f;
    for (s = 0, u = Xg(t(i)); s < c; ++s)
      i[u[s]].index = s;
    return r(i, u), i;
  }
  return a.keys = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : $e(Array.from(o)), a) : e;
  }, a.value = function(o) {
    return arguments.length ? (n = typeof o == "function" ? o : $e(+o), a) : n;
  }, a.order = function(o) {
    return arguments.length ? (t = o == null ? Rv : typeof o == "function" ? o : $e(Array.from(o)), a) : t;
  }, a.offset = function(o) {
    return arguments.length ? (r = o ?? Ya, a) : r;
  }, a;
}
function nH(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, a = 0, o = e[0].length, i; a < o; ++a) {
      for (i = r = 0; r < n; ++r) i += e[r][a][1] || 0;
      if (i) for (r = 0; r < n; ++r) e[r][a][1] /= i;
    }
    Ya(e, t);
  }
}
function aH(e, t) {
  if ((a = e.length) > 0) {
    for (var r = 0, n = e[t[0]], a, o = n.length; r < o; ++r) {
      for (var i = 0, s = 0; i < a; ++i) s += e[i][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    Ya(e, t);
  }
}
function oH(e, t) {
  if (!(!((i = e.length) > 0) || !((o = (a = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, a, o, i; n < o; ++n) {
      for (var s = 0, c = 0, l = 0; s < i; ++s) {
        for (var u = e[t[s]], f = u[n][1] || 0, d = u[n - 1][1] || 0, p = (f - d) / 2, g = 0; g < s; ++g) {
          var m = e[t[g]], y = m[n][1] || 0, b = m[n - 1][1] || 0;
          p += y - b;
        }
        c += f, l += p * f;
      }
      a[n - 1][1] += a[n - 1][0] = r, c && (r -= l / c);
    }
    a[n - 1][1] += a[n - 1][0] = r, Ya(e, t);
  }
}
function Di(e) {
  "@babel/helpers - typeof";
  return Di = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Di(e);
}
var iH = ["type", "size", "sizeType"];
function $v() {
  return $v = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $v.apply(this, arguments);
}
function vw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vw(Object(r), !0).forEach(function(n) {
      sH(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function sH(e, t, r) {
  return t = cH(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function cH(e) {
  var t = lH(e, "string");
  return Di(t) == "symbol" ? t : t + "";
}
function lH(e, t) {
  if (Di(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Di(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function uH(e, t) {
  if (e == null) return {};
  var r = fH(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function fH(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var zN = {
  symbolCircle: Zg,
  symbolCross: MW,
  symbolDiamond: $W,
  symbolSquare: IW,
  symbolStar: BW,
  symbolTriangle: FW,
  symbolWye: qW
}, dH = Math.PI / 180, pH = function(t) {
  var r = "symbol".concat(Yu(t));
  return zN[r] || Zg;
}, hH = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var a = 18 * dH;
      return 1.25 * t * t * (Math.tan(a) - Math.tan(a * 2) * Math.pow(Math.tan(a), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, mH = function(t, r) {
  zN["symbol".concat(Yu(t))] = r;
}, Qu = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, a = t.size, o = a === void 0 ? 64 : a, i = t.sizeType, s = i === void 0 ? "area" : i, c = uH(t, iH), l = yw(yw({}, c), {}, {
    type: n,
    size: o,
    sizeType: s
  }), u = function() {
    var y = pH(n), b = WW().type(y).size(hH(o, s, n));
    return b();
  }, f = l.className, d = l.cx, p = l.cy, g = ae(l, !0);
  return d === +d && p === +p && o === +o ? /* @__PURE__ */ E.createElement("path", $v({}, g, {
    className: ue("recharts-symbols", f),
    transform: "translate(".concat(d, ", ").concat(p, ")"),
    d: u()
  })) : null;
};
Qu.registerSymbol = mH;
function Xa(e) {
  "@babel/helpers - typeof";
  return Xa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xa(e);
}
function Iv() {
  return Iv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Iv.apply(this, arguments);
}
function gw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vH(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gw(Object(r), !0).forEach(function(n) {
      ji(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gw(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yH(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gH(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WN(n.key), n);
  }
}
function bH(e, t, r) {
  return t && gH(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xH(e, t, r) {
  return t = sl(t), wH(e, qN() ? Reflect.construct(t, r || [], sl(e).constructor) : t.apply(e, r));
}
function wH(e, t) {
  if (t && (Xa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return SH(e);
}
function SH(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function qN() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (qN = function() {
    return !!e;
  })();
}
function sl(e) {
  return sl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, sl(e);
}
function OH(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Dv(e, t);
}
function Dv(e, t) {
  return Dv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Dv(e, t);
}
function ji(e, t, r) {
  return t = WN(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WN(e) {
  var t = PH(e, "string");
  return Xa(t) == "symbol" ? t : t + "";
}
function PH(e, t) {
  if (Xa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Xa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ut = 32, Jg = /* @__PURE__ */ (function(e) {
  function t() {
    return yH(this, t), xH(this, t, arguments);
  }
  return OH(t, e), bH(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var a = this.props.inactiveColor, o = Ut / 2, i = Ut / 6, s = Ut / 3, c = n.inactive ? a : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ E.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: o,
            x2: Ut,
            y2: o,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ E.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: c,
            d: "M0,".concat(o, "h").concat(s, `
            A`).concat(i, ",").concat(i, ",0,1,1,").concat(2 * s, ",").concat(o, `
            H`).concat(Ut, "M").concat(2 * s, ",").concat(o, `
            A`).concat(i, ",").concat(i, ",0,1,1,").concat(s, ",").concat(o),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ E.createElement("path", {
            stroke: "none",
            fill: c,
            d: "M0,".concat(Ut / 8, "h").concat(Ut, "v").concat(Ut * 3 / 4, "h").concat(-Ut, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ E.isValidElement(n.legendIcon)) {
          var l = vH({}, n);
          return delete l.legendIcon, /* @__PURE__ */ E.cloneElement(n.legendIcon, l);
        }
        return /* @__PURE__ */ E.createElement(Qu, {
          fill: c,
          cx: o,
          cy: o,
          size: Ut,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, a = this.props, o = a.payload, i = a.iconSize, s = a.layout, c = a.formatter, l = a.inactiveColor, u = {
        x: 0,
        y: 0,
        width: Ut,
        height: Ut
      }, f = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, d = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return o.map(function(p, g) {
        var m = p.formatter || c, y = ue(ji(ji({
          "recharts-legend-item": !0
        }, "legend-item-".concat(g), !0), "inactive", p.inactive));
        if (p.type === "none")
          return null;
        var b = se(p.value) ? null : p.value;
        hr(
          !se(p.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var w = p.inactive ? l : p.color;
        return /* @__PURE__ */ E.createElement("li", Iv({
          className: y,
          style: f,
          key: "legend-item-".concat(g)
        }, Cn(n.props, p, g)), /* @__PURE__ */ E.createElement(tl, {
          width: i,
          height: i,
          viewBox: u,
          style: d
        }, n.renderIcon(p)), /* @__PURE__ */ E.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: w
          }
        }, m ? m(b, p, g) : b));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.payload, o = n.layout, i = n.align;
      if (!a || !a.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: o === "horizontal" ? i : "left"
      };
      return /* @__PURE__ */ E.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
})(St);
ji(Jg, "displayName", "Legend");
ji(Jg, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var ip, bw;
function AH() {
  if (bw) return ip;
  bw = 1;
  var e = Vu();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return ip = t, ip;
}
var sp, xw;
function _H() {
  if (xw) return sp;
  xw = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return sp = e, sp;
}
var cp, ww;
function EH() {
  if (ww) return cp;
  ww = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return cp = e, cp;
}
var lp, Sw;
function CH() {
  if (Sw) return lp;
  Sw = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return lp = e, lp;
}
var up, Ow;
function kH() {
  if (Ow) return up;
  Ow = 1;
  var e = Vu(), t = Hg(), r = Vg(), n = 200;
  function a(o, i) {
    var s = this.__data__;
    if (s instanceof e) {
      var c = s.__data__;
      if (!t || c.length < n - 1)
        return c.push([o, i]), this.size = ++s.size, this;
      s = this.__data__ = new r(c);
    }
    return s.set(o, i), this.size = s.size, this;
  }
  return up = a, up;
}
var fp, Pw;
function HN() {
  if (Pw) return fp;
  Pw = 1;
  var e = Vu(), t = AH(), r = _H(), n = EH(), a = CH(), o = kH();
  function i(s) {
    var c = this.__data__ = new e(s);
    this.size = c.size;
  }
  return i.prototype.clear = t, i.prototype.delete = r, i.prototype.get = n, i.prototype.has = a, i.prototype.set = o, fp = i, fp;
}
var dp, Aw;
function NH() {
  if (Aw) return dp;
  Aw = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return dp = t, dp;
}
var pp, _w;
function TH() {
  if (_w) return pp;
  _w = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return pp = e, pp;
}
var hp, Ew;
function VN() {
  if (Ew) return hp;
  Ew = 1;
  var e = Vg(), t = NH(), r = TH();
  function n(a) {
    var o = -1, i = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++o < i; )
      this.add(a[o]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, hp = n, hp;
}
var mp, Cw;
function UN() {
  if (Cw) return mp;
  Cw = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return mp = e, mp;
}
var vp, kw;
function KN() {
  if (kw) return vp;
  kw = 1;
  function e(t, r) {
    return t.has(r);
  }
  return vp = e, vp;
}
var yp, Nw;
function GN() {
  if (Nw) return yp;
  Nw = 1;
  var e = VN(), t = UN(), r = KN(), n = 1, a = 2;
  function o(i, s, c, l, u, f) {
    var d = c & n, p = i.length, g = s.length;
    if (p != g && !(d && g > p))
      return !1;
    var m = f.get(i), y = f.get(s);
    if (m && y)
      return m == s && y == i;
    var b = -1, w = !0, S = c & a ? new e() : void 0;
    for (f.set(i, s), f.set(s, i); ++b < p; ) {
      var P = i[b], x = s[b];
      if (l)
        var O = d ? l(x, P, b, s, i, f) : l(P, x, b, i, s, f);
      if (O !== void 0) {
        if (O)
          continue;
        w = !1;
        break;
      }
      if (S) {
        if (!t(s, function(A, _) {
          if (!r(S, _) && (P === A || u(P, A, c, l, f)))
            return S.push(_);
        })) {
          w = !1;
          break;
        }
      } else if (!(P === x || u(P, x, c, l, f))) {
        w = !1;
        break;
      }
    }
    return f.delete(i), f.delete(s), w;
  }
  return yp = o, yp;
}
var gp, Tw;
function MH() {
  if (Tw) return gp;
  Tw = 1;
  var e = jr(), t = e.Uint8Array;
  return gp = t, gp;
}
var bp, Mw;
function RH() {
  if (Mw) return bp;
  Mw = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, o) {
      n[++r] = [o, a];
    }), n;
  }
  return bp = e, bp;
}
var xp, Rw;
function Qg() {
  if (Rw) return xp;
  Rw = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return xp = e, xp;
}
var wp, $w;
function $H() {
  if ($w) return wp;
  $w = 1;
  var e = zs(), t = MH(), r = Wg(), n = GN(), a = RH(), o = Qg(), i = 1, s = 2, c = "[object Boolean]", l = "[object Date]", u = "[object Error]", f = "[object Map]", d = "[object Number]", p = "[object RegExp]", g = "[object Set]", m = "[object String]", y = "[object Symbol]", b = "[object ArrayBuffer]", w = "[object DataView]", S = e ? e.prototype : void 0, P = S ? S.valueOf : void 0;
  function x(O, A, _, N, M, T, k) {
    switch (_) {
      case w:
        if (O.byteLength != A.byteLength || O.byteOffset != A.byteOffset)
          return !1;
        O = O.buffer, A = A.buffer;
      case b:
        return !(O.byteLength != A.byteLength || !T(new t(O), new t(A)));
      case c:
      case l:
      case d:
        return r(+O, +A);
      case u:
        return O.name == A.name && O.message == A.message;
      case p:
      case m:
        return O == A + "";
      case f:
        var $ = a;
      case g:
        var R = N & i;
        if ($ || ($ = o), O.size != A.size && !R)
          return !1;
        var L = k.get(O);
        if (L)
          return L == A;
        N |= s, k.set(O, A);
        var j = n($(O), $(A), N, M, T, k);
        return k.delete(O), j;
      case y:
        if (P)
          return P.call(O) == P.call(A);
    }
    return !1;
  }
  return wp = x, wp;
}
var Sp, Iw;
function YN() {
  if (Iw) return Sp;
  Iw = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, o = t.length; ++n < a; )
      t[o + n] = r[n];
    return t;
  }
  return Sp = e, Sp;
}
var Op, Dw;
function IH() {
  if (Dw) return Op;
  Dw = 1;
  var e = YN(), t = Nt();
  function r(n, a, o) {
    var i = a(n);
    return t(n) ? i : e(i, o(n));
  }
  return Op = r, Op;
}
var Pp, jw;
function DH() {
  if (jw) return Pp;
  jw = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, o = 0, i = []; ++n < a; ) {
      var s = t[n];
      r(s, n, t) && (i[o++] = s);
    }
    return i;
  }
  return Pp = e, Pp;
}
var Ap, Lw;
function jH() {
  if (Lw) return Ap;
  Lw = 1;
  function e() {
    return [];
  }
  return Ap = e, Ap;
}
var _p, Bw;
function LH() {
  if (Bw) return _p;
  Bw = 1;
  var e = DH(), t = jH(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(i) {
    return i == null ? [] : (i = Object(i), e(a(i), function(s) {
      return n.call(i, s);
    }));
  } : t;
  return _p = o, _p;
}
var Ep, Fw;
function BH() {
  if (Fw) return Ep;
  Fw = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return Ep = e, Ep;
}
var Cp, zw;
function FH() {
  if (zw) return Cp;
  zw = 1;
  var e = an(), t = on(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Cp = n, Cp;
}
var kp, qw;
function e0() {
  if (qw) return kp;
  qw = 1;
  var e = FH(), t = on(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(i) {
    return t(i) && n.call(i, "callee") && !a.call(i, "callee");
  };
  return kp = o, kp;
}
var pi = { exports: {} }, Np, Ww;
function zH() {
  if (Ww) return Np;
  Ww = 1;
  function e() {
    return !1;
  }
  return Np = e, Np;
}
pi.exports;
var Hw;
function XN() {
  return Hw || (Hw = 1, (function(e, t) {
    var r = jr(), n = zH(), a = t && !t.nodeType && t, o = a && !0 && e && !e.nodeType && e, i = o && o.exports === a, s = i ? r.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || n;
    e.exports = l;
  })(pi, pi.exports)), pi.exports;
}
var Tp, Vw;
function t0() {
  if (Vw) return Tp;
  Vw = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var o = typeof n;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return Tp = r, Tp;
}
var Mp, Uw;
function r0() {
  if (Uw) return Mp;
  Uw = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Mp = t, Mp;
}
var Rp, Kw;
function qH() {
  if (Kw) return Rp;
  Kw = 1;
  var e = an(), t = r0(), r = on(), n = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", i = "[object Date]", s = "[object Error]", c = "[object Function]", l = "[object Map]", u = "[object Number]", f = "[object Object]", d = "[object RegExp]", p = "[object Set]", g = "[object String]", m = "[object WeakMap]", y = "[object ArrayBuffer]", b = "[object DataView]", w = "[object Float32Array]", S = "[object Float64Array]", P = "[object Int8Array]", x = "[object Int16Array]", O = "[object Int32Array]", A = "[object Uint8Array]", _ = "[object Uint8ClampedArray]", N = "[object Uint16Array]", M = "[object Uint32Array]", T = {};
  T[w] = T[S] = T[P] = T[x] = T[O] = T[A] = T[_] = T[N] = T[M] = !0, T[n] = T[a] = T[y] = T[o] = T[b] = T[i] = T[s] = T[c] = T[l] = T[u] = T[f] = T[d] = T[p] = T[g] = T[m] = !1;
  function k($) {
    return r($) && t($.length) && !!T[e($)];
  }
  return Rp = k, Rp;
}
var $p, Gw;
function ZN() {
  if (Gw) return $p;
  Gw = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return $p = e, $p;
}
var hi = { exports: {} };
hi.exports;
var Yw;
function WH() {
  return Yw || (Yw = 1, (function(e, t) {
    var r = mN(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, o = a && a.exports === n, i = o && r.process, s = (function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || i && i.binding && i.binding("util");
      } catch {
      }
    })();
    e.exports = s;
  })(hi, hi.exports)), hi.exports;
}
var Ip, Xw;
function JN() {
  if (Xw) return Ip;
  Xw = 1;
  var e = qH(), t = ZN(), r = WH(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return Ip = a, Ip;
}
var Dp, Zw;
function HH() {
  if (Zw) return Dp;
  Zw = 1;
  var e = BH(), t = e0(), r = Nt(), n = XN(), a = t0(), o = JN(), i = Object.prototype, s = i.hasOwnProperty;
  function c(l, u) {
    var f = r(l), d = !f && t(l), p = !f && !d && n(l), g = !f && !d && !p && o(l), m = f || d || p || g, y = m ? e(l.length, String) : [], b = y.length;
    for (var w in l)
      (u || s.call(l, w)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
      (w == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      p && (w == "offset" || w == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (w == "buffer" || w == "byteLength" || w == "byteOffset") || // Skip index properties.
      a(w, b))) && y.push(w);
    return y;
  }
  return Dp = c, Dp;
}
var jp, Jw;
function VH() {
  if (Jw) return jp;
  Jw = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return jp = t, jp;
}
var Lp, Qw;
function QN() {
  if (Qw) return Lp;
  Qw = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return Lp = e, Lp;
}
var Bp, e1;
function UH() {
  if (e1) return Bp;
  e1 = 1;
  var e = QN(), t = e(Object.keys, Object);
  return Bp = t, Bp;
}
var Fp, t1;
function KH() {
  if (t1) return Fp;
  t1 = 1;
  var e = VH(), t = UH(), r = Object.prototype, n = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return t(o);
    var i = [];
    for (var s in Object(o))
      n.call(o, s) && s != "constructor" && i.push(s);
    return i;
  }
  return Fp = a, Fp;
}
var zp, r1;
function qs() {
  if (r1) return zp;
  r1 = 1;
  var e = qg(), t = r0();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return zp = r, zp;
}
var qp, n1;
function ef() {
  if (n1) return qp;
  n1 = 1;
  var e = HH(), t = KH(), r = qs();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return qp = n, qp;
}
var Wp, a1;
function GH() {
  if (a1) return Wp;
  a1 = 1;
  var e = IH(), t = LH(), r = ef();
  function n(a) {
    return e(a, r, t);
  }
  return Wp = n, Wp;
}
var Hp, o1;
function YH() {
  if (o1) return Hp;
  o1 = 1;
  var e = GH(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(o, i, s, c, l, u) {
    var f = s & t, d = e(o), p = d.length, g = e(i), m = g.length;
    if (p != m && !f)
      return !1;
    for (var y = p; y--; ) {
      var b = d[y];
      if (!(f ? b in i : n.call(i, b)))
        return !1;
    }
    var w = u.get(o), S = u.get(i);
    if (w && S)
      return w == i && S == o;
    var P = !0;
    u.set(o, i), u.set(i, o);
    for (var x = f; ++y < p; ) {
      b = d[y];
      var O = o[b], A = i[b];
      if (c)
        var _ = f ? c(A, O, b, i, o, u) : c(O, A, b, o, i, u);
      if (!(_ === void 0 ? O === A || l(O, A, s, c, u) : _)) {
        P = !1;
        break;
      }
      x || (x = b == "constructor");
    }
    if (P && !x) {
      var N = o.constructor, M = i.constructor;
      N != M && "constructor" in o && "constructor" in i && !(typeof N == "function" && N instanceof N && typeof M == "function" && M instanceof M) && (P = !1);
    }
    return u.delete(o), u.delete(i), P;
  }
  return Hp = a, Hp;
}
var Vp, i1;
function XH() {
  if (i1) return Vp;
  i1 = 1;
  var e = va(), t = jr(), r = e(t, "DataView");
  return Vp = r, Vp;
}
var Up, s1;
function ZH() {
  if (s1) return Up;
  s1 = 1;
  var e = va(), t = jr(), r = e(t, "Promise");
  return Up = r, Up;
}
var Kp, c1;
function eT() {
  if (c1) return Kp;
  c1 = 1;
  var e = va(), t = jr(), r = e(t, "Set");
  return Kp = r, Kp;
}
var Gp, l1;
function JH() {
  if (l1) return Gp;
  l1 = 1;
  var e = va(), t = jr(), r = e(t, "WeakMap");
  return Gp = r, Gp;
}
var Yp, u1;
function QH() {
  if (u1) return Yp;
  u1 = 1;
  var e = XH(), t = Hg(), r = ZH(), n = eT(), a = JH(), o = an(), i = vN(), s = "[object Map]", c = "[object Object]", l = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", d = "[object DataView]", p = i(e), g = i(t), m = i(r), y = i(n), b = i(a), w = o;
  return (e && w(new e(new ArrayBuffer(1))) != d || t && w(new t()) != s || r && w(r.resolve()) != l || n && w(new n()) != u || a && w(new a()) != f) && (w = function(S) {
    var P = o(S), x = P == c ? S.constructor : void 0, O = x ? i(x) : "";
    if (O)
      switch (O) {
        case p:
          return d;
        case g:
          return s;
        case m:
          return l;
        case y:
          return u;
        case b:
          return f;
      }
    return P;
  }), Yp = w, Yp;
}
var Xp, f1;
function eV() {
  if (f1) return Xp;
  f1 = 1;
  var e = HN(), t = GN(), r = $H(), n = YH(), a = QH(), o = Nt(), i = XN(), s = JN(), c = 1, l = "[object Arguments]", u = "[object Array]", f = "[object Object]", d = Object.prototype, p = d.hasOwnProperty;
  function g(m, y, b, w, S, P) {
    var x = o(m), O = o(y), A = x ? u : a(m), _ = O ? u : a(y);
    A = A == l ? f : A, _ = _ == l ? f : _;
    var N = A == f, M = _ == f, T = A == _;
    if (T && i(m)) {
      if (!i(y))
        return !1;
      x = !0, N = !1;
    }
    if (T && !N)
      return P || (P = new e()), x || s(m) ? t(m, y, b, w, S, P) : r(m, y, A, b, w, S, P);
    if (!(b & c)) {
      var k = N && p.call(m, "__wrapped__"), $ = M && p.call(y, "__wrapped__");
      if (k || $) {
        var R = k ? m.value() : m, L = $ ? y.value() : y;
        return P || (P = new e()), S(R, L, b, w, P);
      }
    }
    return T ? (P || (P = new e()), n(m, y, b, w, S, P)) : !1;
  }
  return Xp = g, Xp;
}
var Zp, d1;
function n0() {
  if (d1) return Zp;
  d1 = 1;
  var e = eV(), t = on();
  function r(n, a, o, i, s) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, o, i, r, s);
  }
  return Zp = r, Zp;
}
var Jp, p1;
function tV() {
  if (p1) return Jp;
  p1 = 1;
  var e = HN(), t = n0(), r = 1, n = 2;
  function a(o, i, s, c) {
    var l = s.length, u = l, f = !c;
    if (o == null)
      return !u;
    for (o = Object(o); l--; ) {
      var d = s[l];
      if (f && d[2] ? d[1] !== o[d[0]] : !(d[0] in o))
        return !1;
    }
    for (; ++l < u; ) {
      d = s[l];
      var p = d[0], g = o[p], m = d[1];
      if (f && d[2]) {
        if (g === void 0 && !(p in o))
          return !1;
      } else {
        var y = new e();
        if (c)
          var b = c(g, m, p, o, i, y);
        if (!(b === void 0 ? t(m, g, r | n, c, y) : b))
          return !1;
      }
    }
    return !0;
  }
  return Jp = a, Jp;
}
var Qp, h1;
function tT() {
  if (h1) return Qp;
  h1 = 1;
  var e = $n();
  function t(r) {
    return r === r && !e(r);
  }
  return Qp = t, Qp;
}
var eh, m1;
function rV() {
  if (m1) return eh;
  m1 = 1;
  var e = tT(), t = ef();
  function r(n) {
    for (var a = t(n), o = a.length; o--; ) {
      var i = a[o], s = n[i];
      a[o] = [i, s, e(s)];
    }
    return a;
  }
  return eh = r, eh;
}
var th, v1;
function rT() {
  if (v1) return th;
  v1 = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return th = e, th;
}
var rh, y1;
function nV() {
  if (y1) return rh;
  y1 = 1;
  var e = tV(), t = rV(), r = rT();
  function n(a) {
    var o = t(a);
    return o.length == 1 && o[0][2] ? r(o[0][0], o[0][1]) : function(i) {
      return i === a || e(i, a, o);
    };
  }
  return rh = n, rh;
}
var nh, g1;
function aV() {
  if (g1) return nh;
  g1 = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return nh = e, nh;
}
var ah, b1;
function oV() {
  if (b1) return ah;
  b1 = 1;
  var e = bN(), t = e0(), r = Nt(), n = t0(), a = r0(), o = Ku();
  function i(s, c, l) {
    c = e(c, s);
    for (var u = -1, f = c.length, d = !1; ++u < f; ) {
      var p = o(c[u]);
      if (!(d = s != null && l(s, p)))
        break;
      s = s[p];
    }
    return d || ++u != f ? d : (f = s == null ? 0 : s.length, !!f && a(f) && n(p, f) && (r(s) || t(s)));
  }
  return ah = i, ah;
}
var oh, x1;
function iV() {
  if (x1) return oh;
  x1 = 1;
  var e = aV(), t = oV();
  function r(n, a) {
    return n != null && t(n, a, e);
  }
  return oh = r, oh;
}
var ih, w1;
function sV() {
  if (w1) return ih;
  w1 = 1;
  var e = n0(), t = xN(), r = iV(), n = zg(), a = tT(), o = rT(), i = Ku(), s = 1, c = 2;
  function l(u, f) {
    return n(u) && a(f) ? o(i(u), f) : function(d) {
      var p = t(d, u);
      return p === void 0 && p === f ? r(d, u) : e(f, p, s | c);
    };
  }
  return ih = l, ih;
}
var sh, S1;
function Bo() {
  if (S1) return sh;
  S1 = 1;
  function e(t) {
    return t;
  }
  return sh = e, sh;
}
var ch, O1;
function cV() {
  if (O1) return ch;
  O1 = 1;
  function e(t) {
    return function(r) {
      return r == null ? void 0 : r[t];
    };
  }
  return ch = e, ch;
}
var lh, P1;
function lV() {
  if (P1) return lh;
  P1 = 1;
  var e = Kg();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return lh = t, lh;
}
var uh, A1;
function uV() {
  if (A1) return uh;
  A1 = 1;
  var e = cV(), t = lV(), r = zg(), n = Ku();
  function a(o) {
    return r(o) ? e(n(o)) : t(o);
  }
  return uh = a, uh;
}
var fh, _1;
function wr() {
  if (_1) return fh;
  _1 = 1;
  var e = nV(), t = sV(), r = Bo(), n = Nt(), a = uV();
  function o(i) {
    return typeof i == "function" ? i : i == null ? r : typeof i == "object" ? n(i) ? t(i[0], i[1]) : e(i) : a(i);
  }
  return fh = o, fh;
}
var dh, E1;
function nT() {
  if (E1) return dh;
  E1 = 1;
  function e(t, r, n, a) {
    for (var o = t.length, i = n + (a ? 1 : -1); a ? i-- : ++i < o; )
      if (r(t[i], i, t))
        return i;
    return -1;
  }
  return dh = e, dh;
}
var ph, C1;
function fV() {
  if (C1) return ph;
  C1 = 1;
  function e(t) {
    return t !== t;
  }
  return ph = e, ph;
}
var hh, k1;
function dV() {
  if (k1) return hh;
  k1 = 1;
  function e(t, r, n) {
    for (var a = n - 1, o = t.length; ++a < o; )
      if (t[a] === r)
        return a;
    return -1;
  }
  return hh = e, hh;
}
var mh, N1;
function pV() {
  if (N1) return mh;
  N1 = 1;
  var e = nT(), t = fV(), r = dV();
  function n(a, o, i) {
    return o === o ? r(a, o, i) : e(a, t, i);
  }
  return mh = n, mh;
}
var vh, T1;
function hV() {
  if (T1) return vh;
  T1 = 1;
  var e = pV();
  function t(r, n) {
    var a = r == null ? 0 : r.length;
    return !!a && e(r, n, 0) > -1;
  }
  return vh = t, vh;
}
var yh, M1;
function mV() {
  if (M1) return yh;
  M1 = 1;
  function e(t, r, n) {
    for (var a = -1, o = t == null ? 0 : t.length; ++a < o; )
      if (n(r, t[a]))
        return !0;
    return !1;
  }
  return yh = e, yh;
}
var gh, R1;
function vV() {
  if (R1) return gh;
  R1 = 1;
  function e() {
  }
  return gh = e, gh;
}
var bh, $1;
function yV() {
  if ($1) return bh;
  $1 = 1;
  var e = eT(), t = vV(), r = Qg(), n = 1 / 0, a = e && 1 / r(new e([, -0]))[1] == n ? function(o) {
    return new e(o);
  } : t;
  return bh = a, bh;
}
var xh, I1;
function gV() {
  if (I1) return xh;
  I1 = 1;
  var e = VN(), t = hV(), r = mV(), n = KN(), a = yV(), o = Qg(), i = 200;
  function s(c, l, u) {
    var f = -1, d = t, p = c.length, g = !0, m = [], y = m;
    if (u)
      g = !1, d = r;
    else if (p >= i) {
      var b = l ? null : a(c);
      if (b)
        return o(b);
      g = !1, d = n, y = new e();
    } else
      y = l ? [] : m;
    e:
      for (; ++f < p; ) {
        var w = c[f], S = l ? l(w) : w;
        if (w = u || w !== 0 ? w : 0, g && S === S) {
          for (var P = y.length; P--; )
            if (y[P] === S)
              continue e;
          l && y.push(S), m.push(w);
        } else d(y, S, u) || (y !== m && y.push(S), m.push(w));
      }
    return m;
  }
  return xh = s, xh;
}
var wh, D1;
function bV() {
  if (D1) return wh;
  D1 = 1;
  var e = wr(), t = gV();
  function r(n, a) {
    return n && n.length ? t(n, e(a, 2)) : [];
  }
  return wh = r, wh;
}
var xV = bV();
const j1 = /* @__PURE__ */ _e(xV);
function aT(e, t, r) {
  return t === !0 ? j1(e, r) : se(t) ? j1(e, t) : e;
}
function Za(e) {
  "@babel/helpers - typeof";
  return Za = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Za(e);
}
var wV = ["ref"];
function L1(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? L1(Object(r), !0).forEach(function(n) {
      tf(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L1(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function SV(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function B1(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iT(n.key), n);
  }
}
function OV(e, t, r) {
  return t && B1(e.prototype, t), r && B1(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function PV(e, t, r) {
  return t = cl(t), AV(e, oT() ? Reflect.construct(t, r || [], cl(e).constructor) : t.apply(e, r));
}
function AV(e, t) {
  if (t && (Za(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _V(e);
}
function _V(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function oT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (oT = function() {
    return !!e;
  })();
}
function cl(e) {
  return cl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, cl(e);
}
function EV(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jv(e, t);
}
function jv(e, t) {
  return jv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, jv(e, t);
}
function tf(e, t, r) {
  return t = iT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function iT(e) {
  var t = CV(e, "string");
  return Za(t) == "symbol" ? t : t + "";
}
function CV(e, t) {
  if (Za(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Za(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function kV(e, t) {
  if (e == null) return {};
  var r = NV(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function NV(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function TV(e) {
  return e.value;
}
function MV(e, t) {
  if (/* @__PURE__ */ E.isValidElement(e))
    return /* @__PURE__ */ E.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ E.createElement(e, t);
  t.ref;
  var r = kV(t, wV);
  return /* @__PURE__ */ E.createElement(Jg, r);
}
var F1 = 1, Zt = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    SV(this, t);
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return r = PV(this, t, [].concat(a)), tf(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return EV(t, e), OV(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, a = this.getBBox();
      a ? (Math.abs(a.width - this.lastBoundingBox.width) > F1 || Math.abs(a.height - this.lastBoundingBox.height) > F1) && (this.lastBoundingBox.width = a.width, this.lastBoundingBox.height = a.height, n && n(a)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? zr({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var a = this.props, o = a.layout, i = a.align, s = a.verticalAlign, c = a.margin, l = a.chartWidth, u = a.chartHeight, f, d;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (i === "center" && o === "vertical") {
          var p = this.getBBoxSnapshot();
          f = {
            left: ((l || 0) - p.width) / 2
          };
        } else
          f = i === "right" ? {
            right: c && c.right || 0
          } : {
            left: c && c.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var g = this.getBBoxSnapshot();
          d = {
            top: ((u || 0) - g.height) / 2
          };
        } else
          d = s === "bottom" ? {
            bottom: c && c.bottom || 0
          } : {
            top: c && c.top || 0
          };
      return zr(zr({}, f), d);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, o = a.content, i = a.width, s = a.height, c = a.wrapperStyle, l = a.payloadUniqBy, u = a.payload, f = zr(zr({
        position: "absolute",
        width: i || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(c)), c);
      return /* @__PURE__ */ E.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(p) {
          n.wrapperNode = p;
        }
      }, MV(o, zr(zr({}, this.props), {}, {
        payload: aT(u, l, TV)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, a) {
      var o = zr(zr({}, this.defaultProps), n.props), i = o.layout;
      return i === "vertical" && J(n.props.height) ? {
        height: n.props.height
      } : i === "horizontal" ? {
        width: n.props.width || a
      } : null;
    }
  }]);
})(St);
tf(Zt, "displayName", "Legend");
tf(Zt, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Sh, z1;
function RV() {
  if (z1) return Sh;
  z1 = 1;
  var e = zs(), t = e0(), r = Nt(), n = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || t(o) || !!(n && o && o[n]);
  }
  return Sh = a, Sh;
}
var Oh, q1;
function sT() {
  if (q1) return Oh;
  q1 = 1;
  var e = YN(), t = RV();
  function r(n, a, o, i, s) {
    var c = -1, l = n.length;
    for (o || (o = t), s || (s = []); ++c < l; ) {
      var u = n[c];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, i, s) : e(s, u) : i || (s[s.length] = u);
    }
    return s;
  }
  return Oh = r, Oh;
}
var Ph, W1;
function $V() {
  if (W1) return Ph;
  W1 = 1;
  function e(t) {
    return function(r, n, a) {
      for (var o = -1, i = Object(r), s = a(r), c = s.length; c--; ) {
        var l = s[t ? c : ++o];
        if (n(i[l], l, i) === !1)
          break;
      }
      return r;
    };
  }
  return Ph = e, Ph;
}
var Ah, H1;
function IV() {
  if (H1) return Ah;
  H1 = 1;
  var e = $V(), t = e();
  return Ah = t, Ah;
}
var _h, V1;
function cT() {
  if (V1) return _h;
  V1 = 1;
  var e = IV(), t = ef();
  function r(n, a) {
    return n && e(n, a, t);
  }
  return _h = r, _h;
}
var Eh, U1;
function DV() {
  if (U1) return Eh;
  U1 = 1;
  var e = qs();
  function t(r, n) {
    return function(a, o) {
      if (a == null)
        return a;
      if (!e(a))
        return r(a, o);
      for (var i = a.length, s = n ? i : -1, c = Object(a); (n ? s-- : ++s < i) && o(c[s], s, c) !== !1; )
        ;
      return a;
    };
  }
  return Eh = t, Eh;
}
var Ch, K1;
function a0() {
  if (K1) return Ch;
  K1 = 1;
  var e = cT(), t = DV(), r = t(e);
  return Ch = r, Ch;
}
var kh, G1;
function lT() {
  if (G1) return kh;
  G1 = 1;
  var e = a0(), t = qs();
  function r(n, a) {
    var o = -1, i = t(n) ? Array(n.length) : [];
    return e(n, function(s, c, l) {
      i[++o] = a(s, c, l);
    }), i;
  }
  return kh = r, kh;
}
var Nh, Y1;
function jV() {
  if (Y1) return Nh;
  Y1 = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return Nh = e, Nh;
}
var Th, X1;
function LV() {
  if (X1) return Th;
  X1 = 1;
  var e = Do();
  function t(r, n) {
    if (r !== n) {
      var a = r !== void 0, o = r === null, i = r === r, s = e(r), c = n !== void 0, l = n === null, u = n === n, f = e(n);
      if (!l && !f && !s && r > n || s && c && u && !l && !f || o && c && u || !a && u || !i)
        return 1;
      if (!o && !s && !f && r < n || f && a && i && !o && !s || l && a && i || !c && i || !u)
        return -1;
    }
    return 0;
  }
  return Th = t, Th;
}
var Mh, Z1;
function BV() {
  if (Z1) return Mh;
  Z1 = 1;
  var e = LV();
  function t(r, n, a) {
    for (var o = -1, i = r.criteria, s = n.criteria, c = i.length, l = a.length; ++o < c; ) {
      var u = e(i[o], s[o]);
      if (u) {
        if (o >= l)
          return u;
        var f = a[o];
        return u * (f == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return Mh = t, Mh;
}
var Rh, J1;
function FV() {
  if (J1) return Rh;
  J1 = 1;
  var e = Ug(), t = Kg(), r = wr(), n = lT(), a = jV(), o = ZN(), i = BV(), s = Bo(), c = Nt();
  function l(u, f, d) {
    f.length ? f = e(f, function(m) {
      return c(m) ? function(y) {
        return t(y, m.length === 1 ? m[0] : m);
      } : m;
    }) : f = [s];
    var p = -1;
    f = e(f, o(r));
    var g = n(u, function(m, y, b) {
      var w = e(f, function(S) {
        return S(m);
      });
      return { criteria: w, index: ++p, value: m };
    });
    return a(g, function(m, y) {
      return i(m, y, d);
    });
  }
  return Rh = l, Rh;
}
var $h, Q1;
function zV() {
  if (Q1) return $h;
  Q1 = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return $h = e, $h;
}
var Ih, eS;
function qV() {
  if (eS) return Ih;
  eS = 1;
  var e = zV(), t = Math.max;
  function r(n, a, o) {
    return a = t(a === void 0 ? n.length - 1 : a, 0), function() {
      for (var i = arguments, s = -1, c = t(i.length - a, 0), l = Array(c); ++s < c; )
        l[s] = i[a + s];
      s = -1;
      for (var u = Array(a + 1); ++s < a; )
        u[s] = i[s];
      return u[a] = o(l), e(n, this, u);
    };
  }
  return Ih = r, Ih;
}
var Dh, tS;
function WV() {
  if (tS) return Dh;
  tS = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Dh = e, Dh;
}
var jh, rS;
function uT() {
  if (rS) return jh;
  rS = 1;
  var e = va(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return jh = t, jh;
}
var Lh, nS;
function HV() {
  if (nS) return Lh;
  nS = 1;
  var e = WV(), t = uT(), r = Bo(), n = t ? function(a, o) {
    return t(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Lh = n, Lh;
}
var Bh, aS;
function VV() {
  if (aS) return Bh;
  aS = 1;
  var e = 800, t = 16, r = Date.now;
  function n(a) {
    var o = 0, i = 0;
    return function() {
      var s = r(), c = t - (s - i);
      if (i = s, c > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Bh = n, Bh;
}
var Fh, oS;
function UV() {
  if (oS) return Fh;
  oS = 1;
  var e = HV(), t = VV(), r = t(e);
  return Fh = r, Fh;
}
var zh, iS;
function KV() {
  if (iS) return zh;
  iS = 1;
  var e = Bo(), t = qV(), r = UV();
  function n(a, o) {
    return r(t(a, o, e), a + "");
  }
  return zh = n, zh;
}
var qh, sS;
function rf() {
  if (sS) return qh;
  sS = 1;
  var e = Wg(), t = qs(), r = t0(), n = $n();
  function a(o, i, s) {
    if (!n(s))
      return !1;
    var c = typeof i;
    return (c == "number" ? t(s) && r(i, s.length) : c == "string" && i in s) ? e(s[i], o) : !1;
  }
  return qh = a, qh;
}
var Wh, cS;
function GV() {
  if (cS) return Wh;
  cS = 1;
  var e = sT(), t = FV(), r = KV(), n = rf(), a = r(function(o, i) {
    if (o == null)
      return [];
    var s = i.length;
    return s > 1 && n(o, i[0], i[1]) ? i = [] : s > 2 && n(i[0], i[1], i[2]) && (i = [i[0]]), t(o, e(i, 1), []);
  });
  return Wh = a, Wh;
}
var YV = GV();
const o0 = /* @__PURE__ */ _e(YV);
function Li(e) {
  "@babel/helpers - typeof";
  return Li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Li(e);
}
function Lv() {
  return Lv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lv.apply(this, arguments);
}
function XV(e, t) {
  return eU(e) || QV(e, t) || JV(e, t) || ZV();
}
function ZV() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JV(e, t) {
  if (e) {
    if (typeof e == "string") return lS(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return lS(e, t);
  }
}
function lS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function QV(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function eU(e) {
  if (Array.isArray(e)) return e;
}
function uS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Hh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? uS(Object(r), !0).forEach(function(n) {
      tU(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tU(e, t, r) {
  return t = rU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rU(e) {
  var t = nU(e, "string");
  return Li(t) == "symbol" ? t : t + "";
}
function nU(e, t) {
  if (Li(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Li(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function aU(e) {
  return Array.isArray(e) && tt(e[0]) && tt(e[1]) ? e.join(" ~ ") : e;
}
var oU = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, a = t.contentStyle, o = a === void 0 ? {} : a, i = t.itemStyle, s = i === void 0 ? {} : i, c = t.labelStyle, l = c === void 0 ? {} : c, u = t.payload, f = t.formatter, d = t.itemSorter, p = t.wrapperClassName, g = t.labelClassName, m = t.label, y = t.labelFormatter, b = t.accessibilityLayer, w = b === void 0 ? !1 : b, S = function() {
    if (u && u.length) {
      var k = {
        padding: 0,
        margin: 0
      }, $ = (d ? o0(u, d) : u).map(function(R, L) {
        if (R.type === "none")
          return null;
        var j = Hh({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: R.color || "#000"
        }, s), z = R.formatter || f || aU, q = R.value, I = R.name, B = q, W = I;
        if (z && B != null && W != null) {
          var H = z(q, I, R, L, u);
          if (Array.isArray(H)) {
            var U = XV(H, 2);
            B = U[0], W = U[1];
          } else
            B = H;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ E.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(L),
            style: j
          }, tt(W) ? /* @__PURE__ */ E.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, W) : null, tt(W) ? /* @__PURE__ */ E.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ E.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, B), /* @__PURE__ */ E.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, R.unit || ""))
        );
      });
      return /* @__PURE__ */ E.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: k
      }, $);
    }
    return null;
  }, P = Hh({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, o), x = Hh({
    margin: 0
  }, l), O = !ce(m), A = O ? m : "", _ = ue("recharts-default-tooltip", p), N = ue("recharts-tooltip-label", g);
  O && y && u !== void 0 && u !== null && (A = y(m, u));
  var M = w ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ E.createElement("div", Lv({
    className: _,
    style: P
  }, M), /* @__PURE__ */ E.createElement("p", {
    className: N,
    style: x
  }, /* @__PURE__ */ E.isValidElement(A) ? A : "".concat(A)), S());
};
function Bi(e) {
  "@babel/helpers - typeof";
  return Bi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bi(e);
}
function fc(e, t, r) {
  return t = iU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function iU(e) {
  var t = sU(e, "string");
  return Bi(t) == "symbol" ? t : t + "";
}
function sU(e, t) {
  if (Bi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Bi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ti = "recharts-tooltip-wrapper", cU = {
  visibility: "hidden"
};
function lU(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return ue(ti, fc(fc(fc(fc({}, "".concat(ti, "-right"), J(r) && t && J(t.x) && r >= t.x), "".concat(ti, "-left"), J(r) && t && J(t.x) && r < t.x), "".concat(ti, "-bottom"), J(n) && t && J(t.y) && n >= t.y), "".concat(ti, "-top"), J(n) && t && J(t.y) && n < t.y));
}
function fS(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, a = e.offsetTopLeft, o = e.position, i = e.reverseDirection, s = e.tooltipDimension, c = e.viewBox, l = e.viewBoxDimension;
  if (o && J(o[n]))
    return o[n];
  var u = r[n] - s - a, f = r[n] + a;
  if (t[n])
    return i[n] ? u : f;
  if (i[n]) {
    var d = u, p = c[n];
    return d < p ? Math.max(f, c[n]) : Math.max(u, c[n]);
  }
  var g = f + s, m = c[n] + l;
  return g > m ? Math.max(u, c[n]) : Math.max(f, c[n]);
}
function uU(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function fU(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, a = e.position, o = e.reverseDirection, i = e.tooltipBox, s = e.useTranslate3d, c = e.viewBox, l, u, f;
  return i.height > 0 && i.width > 0 && r ? (u = fS({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: a,
    reverseDirection: o,
    tooltipDimension: i.width,
    viewBox: c,
    viewBoxDimension: c.width
  }), f = fS({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: a,
    reverseDirection: o,
    tooltipDimension: i.height,
    viewBox: c,
    viewBoxDimension: c.height
  }), l = uU({
    translateX: u,
    translateY: f,
    useTranslate3d: s
  })) : l = cU, {
    cssProperties: l,
    cssClasses: lU({
      translateX: u,
      translateY: f,
      coordinate: r
    })
  };
}
function Ja(e) {
  "@babel/helpers - typeof";
  return Ja = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ja(e);
}
function dS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dS(Object(r), !0).forEach(function(n) {
      Fv(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function dU(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function pU(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dT(n.key), n);
  }
}
function hU(e, t, r) {
  return t && pU(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function mU(e, t, r) {
  return t = ll(t), vU(e, fT() ? Reflect.construct(t, r || [], ll(e).constructor) : t.apply(e, r));
}
function vU(e, t) {
  if (t && (Ja(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yU(e);
}
function yU(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fT = function() {
    return !!e;
  })();
}
function ll(e) {
  return ll = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ll(e);
}
function gU(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Bv(e, t);
}
function Bv(e, t) {
  return Bv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Bv(e, t);
}
function Fv(e, t, r) {
  return t = dT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dT(e) {
  var t = bU(e, "string");
  return Ja(t) == "symbol" ? t : t + "";
}
function bU(e, t) {
  if (Ja(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ja(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var hS = 1, xU = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    dU(this, t);
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return r = mU(this, t, [].concat(a)), Fv(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), Fv(r, "handleKeyDown", function(i) {
      if (i.key === "Escape") {
        var s, c, l, u;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (c = r.props.coordinate) === null || c === void 0 ? void 0 : c.x) !== null && s !== void 0 ? s : 0,
            y: (l = (u = r.props.coordinate) === null || u === void 0 ? void 0 : u.y) !== null && l !== void 0 ? l : 0
          }
        });
      }
    }), r;
  }
  return gU(t, e), hU(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > hS || Math.abs(n.height - this.state.lastBoundingBox.height) > hS) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, a;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((a = this.props.coordinate) === null || a === void 0 ? void 0 : a.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, o = a.active, i = a.allowEscapeViewBox, s = a.animationDuration, c = a.animationEasing, l = a.children, u = a.coordinate, f = a.hasPayload, d = a.isAnimationActive, p = a.offset, g = a.position, m = a.reverseDirection, y = a.useTranslate3d, b = a.viewBox, w = a.wrapperStyle, S = fU({
        allowEscapeViewBox: i,
        coordinate: u,
        offsetTopLeft: p,
        position: g,
        reverseDirection: m,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: y,
        viewBox: b
      }), P = S.cssClasses, x = S.cssProperties, O = pS(pS({
        transition: d && o ? "transform ".concat(s, "ms ").concat(c) : void 0
      }, x), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && o && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, w);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ E.createElement("div", {
          tabIndex: -1,
          className: P,
          style: O,
          ref: function(_) {
            n.wrapperNode = _;
          }
        }, l)
      );
    }
  }]);
})(St), wU = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Lr = {
  isSsr: wU()
};
function Qa(e) {
  "@babel/helpers - typeof";
  return Qa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qa(e);
}
function mS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mS(Object(r), !0).forEach(function(n) {
      i0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function SU(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function OU(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hT(n.key), n);
  }
}
function PU(e, t, r) {
  return t && OU(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function AU(e, t, r) {
  return t = ul(t), _U(e, pT() ? Reflect.construct(t, r || [], ul(e).constructor) : t.apply(e, r));
}
function _U(e, t) {
  if (t && (Qa(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return EU(e);
}
function EU(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pT() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (pT = function() {
    return !!e;
  })();
}
function ul(e) {
  return ul = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ul(e);
}
function CU(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && zv(e, t);
}
function zv(e, t) {
  return zv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, zv(e, t);
}
function i0(e, t, r) {
  return t = hT(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function hT(e) {
  var t = kU(e, "string");
  return Qa(t) == "symbol" ? t : t + "";
}
function kU(e, t) {
  if (Qa(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Qa(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function NU(e) {
  return e.dataKey;
}
function TU(e, t) {
  return /* @__PURE__ */ E.isValidElement(e) ? /* @__PURE__ */ E.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ E.createElement(e, t) : /* @__PURE__ */ E.createElement(oU, t);
}
var Be = /* @__PURE__ */ (function(e) {
  function t() {
    return SU(this, t), AU(this, t, arguments);
  }
  return CU(t, e), PU(t, [{
    key: "render",
    value: function() {
      var n = this, a = this.props, o = a.active, i = a.allowEscapeViewBox, s = a.animationDuration, c = a.animationEasing, l = a.content, u = a.coordinate, f = a.filterNull, d = a.isAnimationActive, p = a.offset, g = a.payload, m = a.payloadUniqBy, y = a.position, b = a.reverseDirection, w = a.useTranslate3d, S = a.viewBox, P = a.wrapperStyle, x = g ?? [];
      f && x.length && (x = aT(g.filter(function(A) {
        return A.value != null && (A.hide !== !0 || n.props.includeHidden);
      }), m, NU));
      var O = x.length > 0;
      return /* @__PURE__ */ E.createElement(xU, {
        allowEscapeViewBox: i,
        animationDuration: s,
        animationEasing: c,
        isAnimationActive: d,
        active: o,
        coordinate: u,
        hasPayload: O,
        offset: p,
        position: y,
        reverseDirection: b,
        useTranslate3d: w,
        viewBox: S,
        wrapperStyle: P
      }, TU(l, vS(vS({}, this.props), {}, {
        payload: x
      })));
    }
  }]);
})(St);
i0(Be, "displayName", "Tooltip");
i0(Be, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Lr.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var Vh, yS;
function MU() {
  if (yS) return Vh;
  yS = 1;
  var e = jr(), t = function() {
    return e.Date.now();
  };
  return Vh = t, Vh;
}
var Uh, gS;
function RU() {
  if (gS) return Uh;
  gS = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return Uh = t, Uh;
}
var Kh, bS;
function $U() {
  if (bS) return Kh;
  bS = 1;
  var e = RU(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return Kh = r, Kh;
}
var Gh, xS;
function mT() {
  if (xS) return Gh;
  xS = 1;
  var e = $U(), t = $n(), r = Do(), n = NaN, a = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, i = /^0o[0-7]+$/i, s = parseInt;
  function c(l) {
    if (typeof l == "number")
      return l;
    if (r(l))
      return n;
    if (t(l)) {
      var u = typeof l.valueOf == "function" ? l.valueOf() : l;
      l = t(u) ? u + "" : u;
    }
    if (typeof l != "string")
      return l === 0 ? l : +l;
    l = e(l);
    var f = o.test(l);
    return f || i.test(l) ? s(l.slice(2), f ? 2 : 8) : a.test(l) ? n : +l;
  }
  return Gh = c, Gh;
}
var Yh, wS;
function IU() {
  if (wS) return Yh;
  wS = 1;
  var e = $n(), t = MU(), r = mT(), n = "Expected a function", a = Math.max, o = Math.min;
  function i(s, c, l) {
    var u, f, d, p, g, m, y = 0, b = !1, w = !1, S = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    c = r(c) || 0, e(l) && (b = !!l.leading, w = "maxWait" in l, d = w ? a(r(l.maxWait) || 0, c) : d, S = "trailing" in l ? !!l.trailing : S);
    function P($) {
      var R = u, L = f;
      return u = f = void 0, y = $, p = s.apply(L, R), p;
    }
    function x($) {
      return y = $, g = setTimeout(_, c), b ? P($) : p;
    }
    function O($) {
      var R = $ - m, L = $ - y, j = c - R;
      return w ? o(j, d - L) : j;
    }
    function A($) {
      var R = $ - m, L = $ - y;
      return m === void 0 || R >= c || R < 0 || w && L >= d;
    }
    function _() {
      var $ = t();
      if (A($))
        return N($);
      g = setTimeout(_, O($));
    }
    function N($) {
      return g = void 0, S && u ? P($) : (u = f = void 0, p);
    }
    function M() {
      g !== void 0 && clearTimeout(g), y = 0, u = m = f = g = void 0;
    }
    function T() {
      return g === void 0 ? p : N(t());
    }
    function k() {
      var $ = t(), R = A($);
      if (u = arguments, f = this, m = $, R) {
        if (g === void 0)
          return x(m);
        if (w)
          return clearTimeout(g), g = setTimeout(_, c), P(m);
      }
      return g === void 0 && (g = setTimeout(_, c)), p;
    }
    return k.cancel = M, k.flush = T, k;
  }
  return Yh = i, Yh;
}
var Xh, SS;
function DU() {
  if (SS) return Xh;
  SS = 1;
  var e = IU(), t = $n(), r = "Expected a function";
  function n(a, o, i) {
    var s = !0, c = !0;
    if (typeof a != "function")
      throw new TypeError(r);
    return t(i) && (s = "leading" in i ? !!i.leading : s, c = "trailing" in i ? !!i.trailing : c), e(a, o, {
      leading: s,
      maxWait: o,
      trailing: c
    });
  }
  return Xh = n, Xh;
}
var jU = DU();
const vT = /* @__PURE__ */ _e(jU);
function Fi(e) {
  "@babel/helpers - typeof";
  return Fi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fi(e);
}
function OS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? OS(Object(r), !0).forEach(function(n) {
      LU(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : OS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function LU(e, t, r) {
  return t = BU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function BU(e) {
  var t = FU(e, "string");
  return Fi(t) == "symbol" ? t : t + "";
}
function FU(e, t) {
  if (Fi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Fi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function zU(e, t) {
  return VU(e) || HU(e, t) || WU(e, t) || qU();
}
function qU() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function WU(e, t) {
  if (e) {
    if (typeof e == "string") return PS(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return PS(e, t);
  }
}
function PS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function HU(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function VU(e) {
  if (Array.isArray(e)) return e;
}
var qt = /* @__PURE__ */ bs(function(e, t) {
  var r = e.aspect, n = e.initialDimension, a = n === void 0 ? {
    width: -1,
    height: -1
  } : n, o = e.width, i = o === void 0 ? "100%" : o, s = e.height, c = s === void 0 ? "100%" : s, l = e.minWidth, u = l === void 0 ? 0 : l, f = e.minHeight, d = e.maxHeight, p = e.children, g = e.debounce, m = g === void 0 ? 0 : g, y = e.id, b = e.className, w = e.onResize, S = e.style, P = S === void 0 ? {} : S, x = Ic(null), O = Ic();
  O.current = w, p$(t, function() {
    return Object.defineProperty(x.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), x.current;
      },
      configurable: !0
    });
  });
  var A = pr({
    containerWidth: a.width,
    containerHeight: a.height
  }), _ = zU(A, 2), N = _[0], M = _[1], T = h$(function($, R) {
    M(function(L) {
      var j = Math.round($), z = Math.round(R);
      return L.containerWidth === j && L.containerHeight === z ? L : {
        containerWidth: j,
        containerHeight: z
      };
    });
  }, []);
  ko(function() {
    var $ = function(I) {
      var B, W = I[0].contentRect, H = W.width, U = W.height;
      T(H, U), (B = O.current) === null || B === void 0 || B.call(O, H, U);
    };
    m > 0 && ($ = vT($, m, {
      trailing: !0,
      leading: !1
    }));
    var R = new ResizeObserver($), L = x.current.getBoundingClientRect(), j = L.width, z = L.height;
    return T(j, z), R.observe(x.current), function() {
      R.disconnect();
    };
  }, [T, m]);
  var k = h_(function() {
    var $ = N.containerWidth, R = N.containerHeight;
    if ($ < 0 || R < 0)
      return null;
    hr(Xn(i) || Xn(c), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, i, c), hr(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var L = Xn(i) ? $ : i, j = Xn(c) ? R : c;
    r && r > 0 && (L ? j = L / r : j && (L = j * r), d && j > d && (j = d)), hr(L > 0 || j > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, L, j, i, c, u, f, r);
    var z = !Array.isArray(p) && Kr(p.type).endsWith("Chart");
    return E.Children.map(p, function(q) {
      return /* @__PURE__ */ E.isValidElement(q) ? /* @__PURE__ */ Je(q, dc({
        width: L,
        height: j
      }, z ? {
        style: dc({
          height: "100%",
          width: "100%",
          maxHeight: j,
          maxWidth: L
        }, q.props.style)
      } : {})) : q;
    });
  }, [r, p, c, d, f, u, N, i]);
  return /* @__PURE__ */ E.createElement("div", {
    id: y ? "".concat(y) : void 0,
    className: ue("recharts-responsive-container", b),
    style: dc(dc({}, P), {}, {
      width: i,
      height: c,
      minWidth: u,
      minHeight: f,
      maxHeight: d
    }),
    ref: x
  }, k);
}), gr = function(t) {
  return null;
};
gr.displayName = "Cell";
function zi(e) {
  "@babel/helpers - typeof";
  return zi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, zi(e);
}
function AS(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? AS(Object(r), !0).forEach(function(n) {
      UU(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : AS(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function UU(e, t, r) {
  return t = KU(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function KU(e) {
  var t = GU(e, "string");
  return zi(t) == "symbol" ? t : t + "";
}
function GU(e, t) {
  if (zi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (zi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ca = {
  widthCache: {},
  cacheCount: 0
}, YU = 2e3, XU = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, _S = "recharts_measurement_span";
function ZU(e) {
  var t = qv({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var yi = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || Lr.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = ZU(r), a = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (Ca.widthCache[a])
    return Ca.widthCache[a];
  try {
    var o = document.getElementById(_S);
    o || (o = document.createElement("span"), o.setAttribute("id", _S), o.setAttribute("aria-hidden", "true"), document.body.appendChild(o));
    var i = qv(qv({}, XU), n);
    Object.assign(o.style, i), o.textContent = "".concat(t);
    var s = o.getBoundingClientRect(), c = {
      width: s.width,
      height: s.height
    };
    return Ca.widthCache[a] = c, ++Ca.cacheCount > YU && (Ca.cacheCount = 0, Ca.widthCache = {}), c;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, JU = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function qi(e) {
  "@babel/helpers - typeof";
  return qi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qi(e);
}
function fl(e, t) {
  return rK(e) || tK(e, t) || eK(e, t) || QU();
}
function QU() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eK(e, t) {
  if (e) {
    if (typeof e == "string") return ES(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ES(e, t);
  }
}
function ES(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function tK(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        c = !1;
      } else for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function rK(e) {
  if (Array.isArray(e)) return e;
}
function nK(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function CS(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, oK(n.key), n);
  }
}
function aK(e, t, r) {
  return t && CS(e.prototype, t), r && CS(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function oK(e) {
  var t = iK(e, "string");
  return qi(t) == "symbol" ? t : t + "";
}
function iK(e, t) {
  if (qi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (qi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var kS = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, NS = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, sK = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, cK = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, yT = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, lK = Object.keys(yT), Ra = "NaN";
function uK(e, t) {
  return e * yT[t];
}
var pc = /* @__PURE__ */ (function() {
  function e(t, r) {
    nK(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !sK.test(r) && (this.num = NaN, this.unit = ""), lK.includes(r) && (this.num = uK(t, r), this.unit = "px");
  }
  return aK(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, a = (n = cK.exec(r)) !== null && n !== void 0 ? n : [], o = fl(a, 3), i = o[1], s = o[2];
      return new e(parseFloat(i), s ?? "");
    }
  }]);
})();
function gT(e) {
  if (e.includes(Ra))
    return Ra;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = kS.exec(t)) !== null && r !== void 0 ? r : [], a = fl(n, 4), o = a[1], i = a[2], s = a[3], c = pc.parse(o ?? ""), l = pc.parse(s ?? ""), u = i === "*" ? c.multiply(l) : c.divide(l);
    if (u.isNaN())
      return Ra;
    t = t.replace(kS, u.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, d = (f = NS.exec(t)) !== null && f !== void 0 ? f : [], p = fl(d, 4), g = p[1], m = p[2], y = p[3], b = pc.parse(g ?? ""), w = pc.parse(y ?? ""), S = m === "+" ? b.add(w) : b.subtract(w);
    if (S.isNaN())
      return Ra;
    t = t.replace(NS, S.toString());
  }
  return t;
}
var TS = /\(([^()]*)\)/;
function fK(e) {
  for (var t = e; t.includes("("); ) {
    var r = TS.exec(t), n = fl(r, 2), a = n[1];
    t = t.replace(TS, gT(a));
  }
  return t;
}
function dK(e) {
  var t = e.replace(/\s+/g, "");
  return t = fK(t), t = gT(t), t;
}
function pK(e) {
  try {
    return dK(e);
  } catch {
    return Ra;
  }
}
function Zh(e) {
  var t = pK(e.slice(5, -1));
  return t === Ra ? "" : t;
}
var hK = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], mK = ["dx", "dy", "angle", "className", "breakAll"];
function Wv() {
  return Wv = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wv.apply(this, arguments);
}
function MS(e, t) {
  if (e == null) return {};
  var r = vK(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function vK(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function RS(e, t) {
  return xK(e) || bK(e, t) || gK(e, t) || yK();
}
function yK() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gK(e, t) {
  if (e) {
    if (typeof e == "string") return $S(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $S(e, t);
  }
}
function $S(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function bK(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        c = !1;
      } else for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function xK(e) {
  if (Array.isArray(e)) return e;
}
var bT = /[ \f\n\r\t\v\u2028\u2029]+/, xT = function(t) {
  var r = t.children, n = t.breakAll, a = t.style;
  try {
    var o = [];
    ce(r) || (n ? o = r.toString().split("") : o = r.toString().split(bT));
    var i = o.map(function(c) {
      return {
        word: c,
        width: yi(c, a).width
      };
    }), s = n ? 0 : yi(" ", a).width;
    return {
      wordsWithComputedWidth: i,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, wK = function(t, r, n, a, o) {
  var i = t.maxLines, s = t.children, c = t.style, l = t.breakAll, u = J(i), f = s, d = function() {
    var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return L.reduce(function(j, z) {
      var q = z.word, I = z.width, B = j[j.length - 1];
      if (B && (a == null || o || B.width + I + n < Number(a)))
        B.words.push(q), B.width += I + n;
      else {
        var W = {
          words: [q],
          width: I
        };
        j.push(W);
      }
      return j;
    }, []);
  }, p = d(r), g = function(L) {
    return L.reduce(function(j, z) {
      return j.width > z.width ? j : z;
    });
  };
  if (!u)
    return p;
  for (var m = "…", y = function(L) {
    var j = f.slice(0, L), z = xT({
      breakAll: l,
      style: c,
      children: j + m
    }).wordsWithComputedWidth, q = d(z), I = q.length > i || g(q).width > Number(a);
    return [I, q];
  }, b = 0, w = f.length - 1, S = 0, P; b <= w && S <= f.length - 1; ) {
    var x = Math.floor((b + w) / 2), O = x - 1, A = y(O), _ = RS(A, 2), N = _[0], M = _[1], T = y(x), k = RS(T, 1), $ = k[0];
    if (!N && !$ && (b = x + 1), N && $ && (w = x - 1), !N && $) {
      P = M;
      break;
    }
    S++;
  }
  return P || p;
}, IS = function(t) {
  var r = ce(t) ? [] : t.toString().split(bT);
  return [{
    words: r
  }];
}, SK = function(t) {
  var r = t.width, n = t.scaleToFit, a = t.children, o = t.style, i = t.breakAll, s = t.maxLines;
  if ((r || n) && !Lr.isSsr) {
    var c, l, u = xT({
      breakAll: i,
      children: a,
      style: o
    });
    if (u) {
      var f = u.wordsWithComputedWidth, d = u.spaceWidth;
      c = f, l = d;
    } else
      return IS(a);
    return wK({
      breakAll: i,
      children: a,
      maxLines: s,
      style: o
    }, c, l, r, n);
  }
  return IS(a);
}, DS = "#808080", ua = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, o = a === void 0 ? 0 : a, i = t.lineHeight, s = i === void 0 ? "1em" : i, c = t.capHeight, l = c === void 0 ? "0.71em" : c, u = t.scaleToFit, f = u === void 0 ? !1 : u, d = t.textAnchor, p = d === void 0 ? "start" : d, g = t.verticalAnchor, m = g === void 0 ? "end" : g, y = t.fill, b = y === void 0 ? DS : y, w = MS(t, hK), S = h_(function() {
    return SK({
      breakAll: w.breakAll,
      children: w.children,
      maxLines: w.maxLines,
      scaleToFit: f,
      style: w.style,
      width: w.width
    });
  }, [w.breakAll, w.children, w.maxLines, f, w.style, w.width]), P = w.dx, x = w.dy, O = w.angle, A = w.className, _ = w.breakAll, N = MS(w, mK);
  if (!tt(n) || !tt(o))
    return null;
  var M = n + (J(P) ? P : 0), T = o + (J(x) ? x : 0), k;
  switch (m) {
    case "start":
      k = Zh("calc(".concat(l, ")"));
      break;
    case "middle":
      k = Zh("calc(".concat((S.length - 1) / 2, " * -").concat(s, " + (").concat(l, " / 2))"));
      break;
    default:
      k = Zh("calc(".concat(S.length - 1, " * -").concat(s, ")"));
      break;
  }
  var $ = [];
  if (f) {
    var R = S[0].width, L = w.width;
    $.push("scale(".concat((J(L) ? L / R : 1) / R, ")"));
  }
  return O && $.push("rotate(".concat(O, ", ").concat(M, ", ").concat(T, ")")), $.length && (N.transform = $.join(" ")), /* @__PURE__ */ E.createElement("text", Wv({}, ae(N, !0), {
    x: M,
    y: T,
    className: ue("recharts-text", A),
    textAnchor: p,
    fill: b.includes("url") ? DS : b
  }), S.map(function(j, z) {
    var q = j.words.join(_ ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ E.createElement("tspan", {
        x: M,
        dy: z === 0 ? k : s,
        key: "".concat(q, "-").concat(z)
      }, q)
    );
  }));
};
function On(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function OK(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function s0(e) {
  let t, r, n;
  e.length !== 2 ? (t = On, r = (s, c) => On(e(s), c), n = (s, c) => e(s) - c) : (t = e === On || e === OK ? e : PK, r = e, n = e);
  function a(s, c, l = 0, u = s.length) {
    if (l < u) {
      if (t(c, c) !== 0) return u;
      do {
        const f = l + u >>> 1;
        r(s[f], c) < 0 ? l = f + 1 : u = f;
      } while (l < u);
    }
    return l;
  }
  function o(s, c, l = 0, u = s.length) {
    if (l < u) {
      if (t(c, c) !== 0) return u;
      do {
        const f = l + u >>> 1;
        r(s[f], c) <= 0 ? l = f + 1 : u = f;
      } while (l < u);
    }
    return l;
  }
  function i(s, c, l = 0, u = s.length) {
    const f = a(s, c, l, u - 1);
    return f > l && n(s[f - 1], c) > -n(s[f], c) ? f - 1 : f;
  }
  return { left: a, center: i, right: o };
}
function PK() {
  return 0;
}
function wT(e) {
  return e === null ? NaN : +e;
}
function* AK(e, t) {
  for (let r of e)
    r != null && (r = +r) >= r && (yield r);
}
const _K = s0(On), Ws = _K.right;
s0(wT).center;
class jS extends Map {
  constructor(t, r = kK) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, a] of t) this.set(n, a);
  }
  get(t) {
    return super.get(LS(this, t));
  }
  has(t) {
    return super.has(LS(this, t));
  }
  set(t, r) {
    return super.set(EK(this, t), r);
  }
  delete(t) {
    return super.delete(CK(this, t));
  }
}
function LS({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function EK({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function CK({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function kK(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function NK(e = On) {
  if (e === On) return ST;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function ST(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const TK = Math.sqrt(50), MK = Math.sqrt(10), RK = Math.sqrt(2);
function dl(e, t, r) {
  const n = (t - e) / Math.max(0, r), a = Math.floor(Math.log10(n)), o = n / Math.pow(10, a), i = o >= TK ? 10 : o >= MK ? 5 : o >= RK ? 2 : 1;
  let s, c, l;
  return a < 0 ? (l = Math.pow(10, -a) / i, s = Math.round(e * l), c = Math.round(t * l), s / l < e && ++s, c / l > t && --c, l = -l) : (l = Math.pow(10, a) * i, s = Math.round(e / l), c = Math.round(t / l), s * l < e && ++s, c * l > t && --c), c < s && 0.5 <= r && r < 2 ? dl(e, t, r * 2) : [s, c, l];
}
function Hv(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0)) return [];
  if (e === t) return [e];
  const n = t < e, [a, o, i] = n ? dl(t, e, r) : dl(e, t, r);
  if (!(o >= a)) return [];
  const s = o - a + 1, c = new Array(s);
  if (n)
    if (i < 0) for (let l = 0; l < s; ++l) c[l] = (o - l) / -i;
    else for (let l = 0; l < s; ++l) c[l] = (o - l) * i;
  else if (i < 0) for (let l = 0; l < s; ++l) c[l] = (a + l) / -i;
  else for (let l = 0; l < s; ++l) c[l] = (a + l) * i;
  return c;
}
function Vv(e, t, r) {
  return t = +t, e = +e, r = +r, dl(e, t, r)[2];
}
function Uv(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, a = n ? Vv(t, e, r) : Vv(e, t, r);
  return (n ? -1 : 1) * (a < 0 ? 1 / -a : a);
}
function BS(e, t) {
  let r;
  for (const n of e)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function FS(e, t) {
  let r;
  for (const n of e)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function OT(e, t, r = 0, n = 1 / 0, a) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
  for (a = a === void 0 ? ST : NK(a); n > r; ) {
    if (n - r > 600) {
      const c = n - r + 1, l = t - r + 1, u = Math.log(c), f = 0.5 * Math.exp(2 * u / 3), d = 0.5 * Math.sqrt(u * f * (c - f) / c) * (l - c / 2 < 0 ? -1 : 1), p = Math.max(r, Math.floor(t - l * f / c + d)), g = Math.min(n, Math.floor(t + (c - l) * f / c + d));
      OT(e, t, p, g, a);
    }
    const o = e[t];
    let i = r, s = n;
    for (ri(e, r, t), a(e[n], o) > 0 && ri(e, r, n); i < s; ) {
      for (ri(e, i, s), ++i, --s; a(e[i], o) < 0; ) ++i;
      for (; a(e[s], o) > 0; ) --s;
    }
    a(e[r], o) === 0 ? ri(e, r, s) : (++s, ri(e, s, n)), s <= t && (r = s + 1), t <= s && (n = s - 1);
  }
  return e;
}
function ri(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function $K(e, t, r) {
  if (e = Float64Array.from(AK(e)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return FS(e);
    if (t >= 1) return BS(e);
    var n, a = (n - 1) * t, o = Math.floor(a), i = BS(OT(e, o).subarray(0, o + 1)), s = FS(e.subarray(o + 1));
    return i + (s - i) * (a - o);
  }
}
function IK(e, t, r = wT) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return +r(e[0], 0, e);
    if (t >= 1) return +r(e[n - 1], n - 1, e);
    var n, a = (n - 1) * t, o = Math.floor(a), i = +r(e[o], o, e), s = +r(e[o + 1], o + 1, e);
    return i + (s - i) * (a - o);
  }
}
function DK(e, t, r) {
  e = +e, t = +t, r = (a = arguments.length) < 2 ? (t = e, e = 0, 1) : a < 3 ? 1 : +r;
  for (var n = -1, a = Math.max(0, Math.ceil((t - e) / r)) | 0, o = new Array(a); ++n < a; )
    o[n] = e + n * r;
  return o;
}
function rr(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function sn(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Kv = Symbol("implicit");
function c0() {
  var e = new jS(), t = [], r = [], n = Kv;
  function a(o) {
    let i = e.get(o);
    if (i === void 0) {
      if (n !== Kv) return n;
      e.set(o, i = t.push(o) - 1);
    }
    return r[i % r.length];
  }
  return a.domain = function(o) {
    if (!arguments.length) return t.slice();
    t = [], e = new jS();
    for (const i of o)
      e.has(i) || e.set(i, t.push(i) - 1);
    return a;
  }, a.range = function(o) {
    return arguments.length ? (r = Array.from(o), a) : r.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (n = o, a) : n;
  }, a.copy = function() {
    return c0(t, r).unknown(n);
  }, rr.apply(a, arguments), a;
}
function Wi() {
  var e = c0().unknown(void 0), t = e.domain, r = e.range, n = 0, a = 1, o, i, s = !1, c = 0, l = 0, u = 0.5;
  delete e.unknown;
  function f() {
    var d = t().length, p = a < n, g = p ? a : n, m = p ? n : a;
    o = (m - g) / Math.max(1, d - c + l * 2), s && (o = Math.floor(o)), g += (m - g - o * (d - c)) * u, i = o * (1 - c), s && (g = Math.round(g), i = Math.round(i));
    var y = DK(d).map(function(b) {
      return g + o * b;
    });
    return r(p ? y.reverse() : y);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), f()) : t();
  }, e.range = function(d) {
    return arguments.length ? ([n, a] = d, n = +n, a = +a, f()) : [n, a];
  }, e.rangeRound = function(d) {
    return [n, a] = d, n = +n, a = +a, s = !0, f();
  }, e.bandwidth = function() {
    return i;
  }, e.step = function() {
    return o;
  }, e.round = function(d) {
    return arguments.length ? (s = !!d, f()) : s;
  }, e.padding = function(d) {
    return arguments.length ? (c = Math.min(1, l = +d), f()) : c;
  }, e.paddingInner = function(d) {
    return arguments.length ? (c = Math.min(1, d), f()) : c;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (l = +d, f()) : l;
  }, e.align = function(d) {
    return arguments.length ? (u = Math.max(0, Math.min(1, d)), f()) : u;
  }, e.copy = function() {
    return Wi(t(), [n, a]).round(s).paddingInner(c).paddingOuter(l).align(u);
  }, rr.apply(f(), arguments);
}
function PT(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return PT(t());
  }, e;
}
function gi() {
  return PT(Wi.apply(null, arguments).paddingInner(1));
}
function l0(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function AT(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t) r[n] = t[n];
  return r;
}
function Hs() {
}
var Hi = 0.7, pl = 1 / Hi, qa = "\\s*([+-]?\\d+)\\s*", Vi = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Nr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", jK = /^#([0-9a-f]{3,8})$/, LK = new RegExp(`^rgb\\(${qa},${qa},${qa}\\)$`), BK = new RegExp(`^rgb\\(${Nr},${Nr},${Nr}\\)$`), FK = new RegExp(`^rgba\\(${qa},${qa},${qa},${Vi}\\)$`), zK = new RegExp(`^rgba\\(${Nr},${Nr},${Nr},${Vi}\\)$`), qK = new RegExp(`^hsl\\(${Vi},${Nr},${Nr}\\)$`), WK = new RegExp(`^hsla\\(${Vi},${Nr},${Nr},${Vi}\\)$`), zS = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
l0(Hs, Ui, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: qS,
  // Deprecated! Use color.formatHex.
  formatHex: qS,
  formatHex8: HK,
  formatHsl: VK,
  formatRgb: WS,
  toString: WS
});
function qS() {
  return this.rgb().formatHex();
}
function HK() {
  return this.rgb().formatHex8();
}
function VK() {
  return _T(this).formatHsl();
}
function WS() {
  return this.rgb().formatRgb();
}
function Ui(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = jK.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? HS(t) : r === 3 ? new At(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? hc(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? hc(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = LK.exec(e)) ? new At(t[1], t[2], t[3], 1) : (t = BK.exec(e)) ? new At(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = FK.exec(e)) ? hc(t[1], t[2], t[3], t[4]) : (t = zK.exec(e)) ? hc(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = qK.exec(e)) ? KS(t[1], t[2] / 100, t[3] / 100, 1) : (t = WK.exec(e)) ? KS(t[1], t[2] / 100, t[3] / 100, t[4]) : zS.hasOwnProperty(e) ? HS(zS[e]) : e === "transparent" ? new At(NaN, NaN, NaN, 0) : null;
}
function HS(e) {
  return new At(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function hc(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new At(e, t, r, n);
}
function UK(e) {
  return e instanceof Hs || (e = Ui(e)), e ? (e = e.rgb(), new At(e.r, e.g, e.b, e.opacity)) : new At();
}
function Gv(e, t, r, n) {
  return arguments.length === 1 ? UK(e) : new At(e, t, r, n ?? 1);
}
function At(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
l0(At, Gv, AT(Hs, {
  brighter(e) {
    return e = e == null ? pl : Math.pow(pl, e), new At(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Hi : Math.pow(Hi, e), new At(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new At(na(this.r), na(this.g), na(this.b), hl(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: VS,
  // Deprecated! Use color.formatHex.
  formatHex: VS,
  formatHex8: KK,
  formatRgb: US,
  toString: US
}));
function VS() {
  return `#${Zn(this.r)}${Zn(this.g)}${Zn(this.b)}`;
}
function KK() {
  return `#${Zn(this.r)}${Zn(this.g)}${Zn(this.b)}${Zn((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function US() {
  const e = hl(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${na(this.r)}, ${na(this.g)}, ${na(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function hl(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function na(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Zn(e) {
  return e = na(e), (e < 16 ? "0" : "") + e.toString(16);
}
function KS(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new dr(e, t, r, n);
}
function _T(e) {
  if (e instanceof dr) return new dr(e.h, e.s, e.l, e.opacity);
  if (e instanceof Hs || (e = Ui(e)), !e) return new dr();
  if (e instanceof dr) return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, a = Math.min(t, r, n), o = Math.max(t, r, n), i = NaN, s = o - a, c = (o + a) / 2;
  return s ? (t === o ? i = (r - n) / s + (r < n) * 6 : r === o ? i = (n - t) / s + 2 : i = (t - r) / s + 4, s /= c < 0.5 ? o + a : 2 - o - a, i *= 60) : s = c > 0 && c < 1 ? 0 : i, new dr(i, s, c, e.opacity);
}
function GK(e, t, r, n) {
  return arguments.length === 1 ? _T(e) : new dr(e, t, r, n ?? 1);
}
function dr(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
l0(dr, GK, AT(Hs, {
  brighter(e) {
    return e = e == null ? pl : Math.pow(pl, e), new dr(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Hi : Math.pow(Hi, e), new dr(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, a = 2 * r - n;
    return new At(
      Jh(e >= 240 ? e - 240 : e + 120, a, n),
      Jh(e, a, n),
      Jh(e < 120 ? e + 240 : e - 120, a, n),
      this.opacity
    );
  },
  clamp() {
    return new dr(GS(this.h), mc(this.s), mc(this.l), hl(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = hl(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${GS(this.h)}, ${mc(this.s) * 100}%, ${mc(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function GS(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function mc(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Jh(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const u0 = (e) => () => e;
function YK(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function XK(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function ZK(e) {
  return (e = +e) == 1 ? ET : function(t, r) {
    return r - t ? XK(t, r, e) : u0(isNaN(t) ? r : t);
  };
}
function ET(e, t) {
  var r = t - e;
  return r ? YK(e, r) : u0(isNaN(e) ? t : e);
}
const YS = (function e(t) {
  var r = ZK(t);
  function n(a, o) {
    var i = r((a = Gv(a)).r, (o = Gv(o)).r), s = r(a.g, o.g), c = r(a.b, o.b), l = ET(a.opacity, o.opacity);
    return function(u) {
      return a.r = i(u), a.g = s(u), a.b = c(u), a.opacity = l(u), a + "";
    };
  }
  return n.gamma = e, n;
})(1);
function JK(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), a;
  return function(o) {
    for (a = 0; a < r; ++a) n[a] = e[a] * (1 - o) + t[a] * o;
    return n;
  };
}
function QK(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function eG(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, a = new Array(n), o = new Array(r), i;
  for (i = 0; i < n; ++i) a[i] = Fo(e[i], t[i]);
  for (; i < r; ++i) o[i] = t[i];
  return function(s) {
    for (i = 0; i < n; ++i) o[i] = a[i](s);
    return o;
  };
}
function tG(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function ml(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function rG(e, t) {
  var r = {}, n = {}, a;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (a in t)
    a in e ? r[a] = Fo(e[a], t[a]) : n[a] = t[a];
  return function(o) {
    for (a in r) n[a] = r[a](o);
    return n;
  };
}
var Yv = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Qh = new RegExp(Yv.source, "g");
function nG(e) {
  return function() {
    return e;
  };
}
function aG(e) {
  return function(t) {
    return e(t) + "";
  };
}
function oG(e, t) {
  var r = Yv.lastIndex = Qh.lastIndex = 0, n, a, o, i = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (n = Yv.exec(e)) && (a = Qh.exec(t)); )
    (o = a.index) > r && (o = t.slice(r, o), s[i] ? s[i] += o : s[++i] = o), (n = n[0]) === (a = a[0]) ? s[i] ? s[i] += a : s[++i] = a : (s[++i] = null, c.push({ i, x: ml(n, a) })), r = Qh.lastIndex;
  return r < t.length && (o = t.slice(r), s[i] ? s[i] += o : s[++i] = o), s.length < 2 ? c[0] ? aG(c[0].x) : nG(t) : (t = c.length, function(l) {
    for (var u = 0, f; u < t; ++u) s[(f = c[u]).i] = f.x(l);
    return s.join("");
  });
}
function Fo(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? u0(t) : (r === "number" ? ml : r === "string" ? (n = Ui(t)) ? (t = n, YS) : oG : t instanceof Ui ? YS : t instanceof Date ? tG : QK(t) ? JK : Array.isArray(t) ? eG : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? rG : ml)(e, t);
}
function f0(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function iG(e, t) {
  t === void 0 && (t = e, e = Fo);
  for (var r = 0, n = t.length - 1, a = t[0], o = new Array(n < 0 ? 0 : n); r < n; ) o[r] = e(a, a = t[++r]);
  return function(i) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(i *= n)));
    return o[s](i - s);
  };
}
function sG(e) {
  return function() {
    return e;
  };
}
function vl(e) {
  return +e;
}
var XS = [0, 1];
function bt(e) {
  return e;
}
function Xv(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : sG(isNaN(t) ? NaN : 0.5);
}
function cG(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function lG(e, t, r) {
  var n = e[0], a = e[1], o = t[0], i = t[1];
  return a < n ? (n = Xv(a, n), o = r(i, o)) : (n = Xv(n, a), o = r(o, i)), function(s) {
    return o(n(s));
  };
}
function uG(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, a = new Array(n), o = new Array(n), i = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++i < n; )
    a[i] = Xv(e[i], e[i + 1]), o[i] = r(t[i], t[i + 1]);
  return function(s) {
    var c = Ws(e, s, 1, n) - 1;
    return o[c](a[c](s));
  };
}
function Vs(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function nf() {
  var e = XS, t = XS, r = Fo, n, a, o, i = bt, s, c, l;
  function u() {
    var d = Math.min(e.length, t.length);
    return i !== bt && (i = cG(e[0], e[d - 1])), s = d > 2 ? uG : lG, c = l = null, f;
  }
  function f(d) {
    return d == null || isNaN(d = +d) ? o : (c || (c = s(e.map(n), t, r)))(n(i(d)));
  }
  return f.invert = function(d) {
    return i(a((l || (l = s(t, e.map(n), ml)))(d)));
  }, f.domain = function(d) {
    return arguments.length ? (e = Array.from(d, vl), u()) : e.slice();
  }, f.range = function(d) {
    return arguments.length ? (t = Array.from(d), u()) : t.slice();
  }, f.rangeRound = function(d) {
    return t = Array.from(d), r = f0, u();
  }, f.clamp = function(d) {
    return arguments.length ? (i = d ? !0 : bt, u()) : i !== bt;
  }, f.interpolate = function(d) {
    return arguments.length ? (r = d, u()) : r;
  }, f.unknown = function(d) {
    return arguments.length ? (o = d, f) : o;
  }, function(d, p) {
    return n = d, a = p, u();
  };
}
function d0() {
  return nf()(bt, bt);
}
function fG(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function yl(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function eo(e) {
  return e = yl(Math.abs(e)), e ? e[1] : NaN;
}
function dG(e, t) {
  return function(r, n) {
    for (var a = r.length, o = [], i = 0, s = e[0], c = 0; a > 0 && s > 0 && (c + s + 1 > n && (s = Math.max(1, n - c)), o.push(r.substring(a -= s, a + s)), !((c += s + 1) > n)); )
      s = e[i = (i + 1) % e.length];
    return o.reverse().join(t);
  };
}
function pG(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var hG = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Ki(e) {
  if (!(t = hG.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new p0({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Ki.prototype = p0.prototype;
function p0(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
p0.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function mG(e) {
  e: for (var t = e.length, r = 1, n = -1, a; r < t; ++r)
    switch (e[r]) {
      case ".":
        n = a = r;
        break;
      case "0":
        n === 0 && (n = r), a = r;
        break;
      default:
        if (!+e[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? e.slice(0, n) + e.slice(a + 1) : e;
}
var CT;
function vG(e, t) {
  var r = yl(e, t);
  if (!r) return e + "";
  var n = r[0], a = r[1], o = a - (CT = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, i = n.length;
  return o === i ? n : o > i ? n + new Array(o - i + 1).join("0") : o > 0 ? n.slice(0, o) + "." + n.slice(o) : "0." + new Array(1 - o).join("0") + yl(e, Math.max(0, t + o - 1))[0];
}
function ZS(e, t) {
  var r = yl(e, t);
  if (!r) return e + "";
  var n = r[0], a = r[1];
  return a < 0 ? "0." + new Array(-a).join("0") + n : n.length > a + 1 ? n.slice(0, a + 1) + "." + n.slice(a + 1) : n + new Array(a - n.length + 2).join("0");
}
const JS = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: fG,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => ZS(e * 100, t),
  r: ZS,
  s: vG,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function QS(e) {
  return e;
}
var eO = Array.prototype.map, tO = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function yG(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? QS : dG(eO.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", a = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? QS : pG(eO.call(e.numerals, String)), i = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function l(f) {
    f = Ki(f);
    var d = f.fill, p = f.align, g = f.sign, m = f.symbol, y = f.zero, b = f.width, w = f.comma, S = f.precision, P = f.trim, x = f.type;
    x === "n" ? (w = !0, x = "g") : JS[x] || (S === void 0 && (S = 12), P = !0, x = "g"), (y || d === "0" && p === "=") && (y = !0, d = "0", p = "=");
    var O = m === "$" ? r : m === "#" && /[boxX]/.test(x) ? "0" + x.toLowerCase() : "", A = m === "$" ? n : /[%p]/.test(x) ? i : "", _ = JS[x], N = /[defgprs%]/.test(x);
    S = S === void 0 ? 6 : /[gprs]/.test(x) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
    function M(T) {
      var k = O, $ = A, R, L, j;
      if (x === "c")
        $ = _(T) + $, T = "";
      else {
        T = +T;
        var z = T < 0 || 1 / T < 0;
        if (T = isNaN(T) ? c : _(Math.abs(T), S), P && (T = mG(T)), z && +T == 0 && g !== "+" && (z = !1), k = (z ? g === "(" ? g : s : g === "-" || g === "(" ? "" : g) + k, $ = (x === "s" ? tO[8 + CT / 3] : "") + $ + (z && g === "(" ? ")" : ""), N) {
          for (R = -1, L = T.length; ++R < L; )
            if (j = T.charCodeAt(R), 48 > j || j > 57) {
              $ = (j === 46 ? a + T.slice(R + 1) : T.slice(R)) + $, T = T.slice(0, R);
              break;
            }
        }
      }
      w && !y && (T = t(T, 1 / 0));
      var q = k.length + T.length + $.length, I = q < b ? new Array(b - q + 1).join(d) : "";
      switch (w && y && (T = t(I + T, I.length ? b - $.length : 1 / 0), I = ""), p) {
        case "<":
          T = k + T + $ + I;
          break;
        case "=":
          T = k + I + T + $;
          break;
        case "^":
          T = I.slice(0, q = I.length >> 1) + k + T + $ + I.slice(q);
          break;
        default:
          T = I + k + T + $;
          break;
      }
      return o(T);
    }
    return M.toString = function() {
      return f + "";
    }, M;
  }
  function u(f, d) {
    var p = l((f = Ki(f), f.type = "f", f)), g = Math.max(-8, Math.min(8, Math.floor(eo(d) / 3))) * 3, m = Math.pow(10, -g), y = tO[8 + g / 3];
    return function(b) {
      return p(m * b) + y;
    };
  }
  return {
    format: l,
    formatPrefix: u
  };
}
var vc, h0, kT;
gG({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function gG(e) {
  return vc = yG(e), h0 = vc.format, kT = vc.formatPrefix, vc;
}
function bG(e) {
  return Math.max(0, -eo(Math.abs(e)));
}
function xG(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(eo(t) / 3))) * 3 - eo(Math.abs(e)));
}
function wG(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, eo(t) - eo(e)) + 1;
}
function NT(e, t, r, n) {
  var a = Uv(e, t, r), o;
  switch (n = Ki(n ?? ",f"), n.type) {
    case "s": {
      var i = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(o = xG(a, i)) && (n.precision = o), kT(n, i);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(o = wG(a, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = o - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(o = bG(a)) && (n.precision = o - (n.type === "%") * 2);
      break;
    }
  }
  return h0(n);
}
function Dn(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return Hv(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var a = t();
    return NT(a[0], a[a.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), a = 0, o = n.length - 1, i = n[a], s = n[o], c, l, u = 10;
    for (s < i && (l = i, i = s, s = l, l = a, a = o, o = l); u-- > 0; ) {
      if (l = Vv(i, s, r), l === c)
        return n[a] = i, n[o] = s, t(n);
      if (l > 0)
        i = Math.floor(i / l) * l, s = Math.ceil(s / l) * l;
      else if (l < 0)
        i = Math.ceil(i * l) / l, s = Math.floor(s * l) / l;
      else
        break;
      c = l;
    }
    return e;
  }, e;
}
function gl() {
  var e = d0();
  return e.copy = function() {
    return Vs(e, gl());
  }, rr.apply(e, arguments), Dn(e);
}
function TT(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, vl), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return TT(e).unknown(t);
  }, e = arguments.length ? Array.from(e, vl) : [0, 1], Dn(r);
}
function MT(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, a = e[r], o = e[n], i;
  return o < a && (i = r, r = n, n = i, i = a, a = o, o = i), e[r] = t.floor(a), e[n] = t.ceil(o), e;
}
function rO(e) {
  return Math.log(e);
}
function nO(e) {
  return Math.exp(e);
}
function SG(e) {
  return -Math.log(-e);
}
function OG(e) {
  return -Math.exp(-e);
}
function PG(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function AG(e) {
  return e === 10 ? PG : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function _G(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function aO(e) {
  return (t, r) => -e(-t, r);
}
function m0(e) {
  const t = e(rO, nO), r = t.domain;
  let n = 10, a, o;
  function i() {
    return a = _G(n), o = AG(n), r()[0] < 0 ? (a = aO(a), o = aO(o), e(SG, OG)) : e(rO, nO), t;
  }
  return t.base = function(s) {
    return arguments.length ? (n = +s, i()) : n;
  }, t.domain = function(s) {
    return arguments.length ? (r(s), i()) : r();
  }, t.ticks = (s) => {
    const c = r();
    let l = c[0], u = c[c.length - 1];
    const f = u < l;
    f && ([l, u] = [u, l]);
    let d = a(l), p = a(u), g, m;
    const y = s == null ? 10 : +s;
    let b = [];
    if (!(n % 1) && p - d < y) {
      if (d = Math.floor(d), p = Math.ceil(p), l > 0) {
        for (; d <= p; ++d)
          for (g = 1; g < n; ++g)
            if (m = d < 0 ? g / o(-d) : g * o(d), !(m < l)) {
              if (m > u) break;
              b.push(m);
            }
      } else for (; d <= p; ++d)
        for (g = n - 1; g >= 1; --g)
          if (m = d > 0 ? g / o(-d) : g * o(d), !(m < l)) {
            if (m > u) break;
            b.push(m);
          }
      b.length * 2 < y && (b = Hv(l, u, y));
    } else
      b = Hv(d, p, Math.min(p - d, y)).map(o);
    return f ? b.reverse() : b;
  }, t.tickFormat = (s, c) => {
    if (s == null && (s = 10), c == null && (c = n === 10 ? "s" : ","), typeof c != "function" && (!(n % 1) && (c = Ki(c)).precision == null && (c.trim = !0), c = h0(c)), s === 1 / 0) return c;
    const l = Math.max(1, n * s / t.ticks().length);
    return (u) => {
      let f = u / o(Math.round(a(u)));
      return f * n < n - 0.5 && (f *= n), f <= l ? c(u) : "";
    };
  }, t.nice = () => r(MT(r(), {
    floor: (s) => o(Math.floor(a(s))),
    ceil: (s) => o(Math.ceil(a(s)))
  })), t;
}
function RT() {
  const e = m0(nf()).domain([1, 10]);
  return e.copy = () => Vs(e, RT()).base(e.base()), rr.apply(e, arguments), e;
}
function oO(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function iO(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function v0(e) {
  var t = 1, r = e(oO(t), iO(t));
  return r.constant = function(n) {
    return arguments.length ? e(oO(t = +n), iO(t)) : t;
  }, Dn(r);
}
function $T() {
  var e = v0(nf());
  return e.copy = function() {
    return Vs(e, $T()).constant(e.constant());
  }, rr.apply(e, arguments);
}
function sO(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function EG(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function CG(e) {
  return e < 0 ? -e * e : e * e;
}
function y0(e) {
  var t = e(bt, bt), r = 1;
  function n() {
    return r === 1 ? e(bt, bt) : r === 0.5 ? e(EG, CG) : e(sO(r), sO(1 / r));
  }
  return t.exponent = function(a) {
    return arguments.length ? (r = +a, n()) : r;
  }, Dn(t);
}
function g0() {
  var e = y0(nf());
  return e.copy = function() {
    return Vs(e, g0()).exponent(e.exponent());
  }, rr.apply(e, arguments), e;
}
function kG() {
  return g0.apply(null, arguments).exponent(0.5);
}
function cO(e) {
  return Math.sign(e) * e * e;
}
function NG(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function IT() {
  var e = d0(), t = [0, 1], r = !1, n;
  function a(o) {
    var i = NG(e(o));
    return isNaN(i) ? n : r ? Math.round(i) : i;
  }
  return a.invert = function(o) {
    return e.invert(cO(o));
  }, a.domain = function(o) {
    return arguments.length ? (e.domain(o), a) : e.domain();
  }, a.range = function(o) {
    return arguments.length ? (e.range((t = Array.from(o, vl)).map(cO)), a) : t.slice();
  }, a.rangeRound = function(o) {
    return a.range(o).round(!0);
  }, a.round = function(o) {
    return arguments.length ? (r = !!o, a) : r;
  }, a.clamp = function(o) {
    return arguments.length ? (e.clamp(o), a) : e.clamp();
  }, a.unknown = function(o) {
    return arguments.length ? (n = o, a) : n;
  }, a.copy = function() {
    return IT(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, rr.apply(a, arguments), Dn(a);
}
function DT() {
  var e = [], t = [], r = [], n;
  function a() {
    var i = 0, s = Math.max(1, t.length);
    for (r = new Array(s - 1); ++i < s; ) r[i - 1] = IK(e, i / s);
    return o;
  }
  function o(i) {
    return i == null || isNaN(i = +i) ? n : t[Ws(r, i)];
  }
  return o.invertExtent = function(i) {
    var s = t.indexOf(i);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : e[0],
      s < r.length ? r[s] : e[e.length - 1]
    ];
  }, o.domain = function(i) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of i) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(On), a();
  }, o.range = function(i) {
    return arguments.length ? (t = Array.from(i), a()) : t.slice();
  }, o.unknown = function(i) {
    return arguments.length ? (n = i, o) : n;
  }, o.quantiles = function() {
    return r.slice();
  }, o.copy = function() {
    return DT().domain(e).range(t).unknown(n);
  }, rr.apply(o, arguments);
}
function jT() {
  var e = 0, t = 1, r = 1, n = [0.5], a = [0, 1], o;
  function i(c) {
    return c != null && c <= c ? a[Ws(n, c, 0, r)] : o;
  }
  function s() {
    var c = -1;
    for (n = new Array(r); ++c < r; ) n[c] = ((c + 1) * t - (c - r) * e) / (r + 1);
    return i;
  }
  return i.domain = function(c) {
    return arguments.length ? ([e, t] = c, e = +e, t = +t, s()) : [e, t];
  }, i.range = function(c) {
    return arguments.length ? (r = (a = Array.from(c)).length - 1, s()) : a.slice();
  }, i.invertExtent = function(c) {
    var l = a.indexOf(c);
    return l < 0 ? [NaN, NaN] : l < 1 ? [e, n[0]] : l >= r ? [n[r - 1], t] : [n[l - 1], n[l]];
  }, i.unknown = function(c) {
    return arguments.length && (o = c), i;
  }, i.thresholds = function() {
    return n.slice();
  }, i.copy = function() {
    return jT().domain([e, t]).range(a).unknown(o);
  }, rr.apply(Dn(i), arguments);
}
function LT() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function a(o) {
    return o != null && o <= o ? t[Ws(e, o, 0, n)] : r;
  }
  return a.domain = function(o) {
    return arguments.length ? (e = Array.from(o), n = Math.min(e.length, t.length - 1), a) : e.slice();
  }, a.range = function(o) {
    return arguments.length ? (t = Array.from(o), n = Math.min(e.length, t.length - 1), a) : t.slice();
  }, a.invertExtent = function(o) {
    var i = t.indexOf(o);
    return [e[i - 1], e[i]];
  }, a.unknown = function(o) {
    return arguments.length ? (r = o, a) : r;
  }, a.copy = function() {
    return LT().domain(e).range(t).unknown(r);
  }, rr.apply(a, arguments);
}
const em = /* @__PURE__ */ new Date(), tm = /* @__PURE__ */ new Date();
function rt(e, t, r, n) {
  function a(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return a.floor = (o) => (e(o = /* @__PURE__ */ new Date(+o)), o), a.ceil = (o) => (e(o = new Date(o - 1)), t(o, 1), e(o), o), a.round = (o) => {
    const i = a(o), s = a.ceil(o);
    return o - i < s - o ? i : s;
  }, a.offset = (o, i) => (t(o = /* @__PURE__ */ new Date(+o), i == null ? 1 : Math.floor(i)), o), a.range = (o, i, s) => {
    const c = [];
    if (o = a.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < i) || !(s > 0)) return c;
    let l;
    do
      c.push(l = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (l < o && o < i);
    return c;
  }, a.filter = (o) => rt((i) => {
    if (i >= i) for (; e(i), !o(i); ) i.setTime(i - 1);
  }, (i, s) => {
    if (i >= i)
      if (s < 0) for (; ++s <= 0; )
        for (; t(i, -1), !o(i); )
          ;
      else for (; --s >= 0; )
        for (; t(i, 1), !o(i); )
          ;
  }), r && (a.count = (o, i) => (em.setTime(+o), tm.setTime(+i), e(em), e(tm), Math.floor(r(em, tm))), a.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? a.filter(n ? (i) => n(i) % o === 0 : (i) => a.count(0, i) % o === 0) : a)), a;
}
const bl = rt(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
bl.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? rt((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : bl);
bl.range;
const Hr = 1e3, Yt = Hr * 60, Vr = Yt * 60, Jr = Vr * 24, b0 = Jr * 7, lO = Jr * 30, rm = Jr * 365, Jn = rt((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Hr);
}, (e, t) => (t - e) / Hr, (e) => e.getUTCSeconds());
Jn.range;
const x0 = rt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Hr);
}, (e, t) => {
  e.setTime(+e + t * Yt);
}, (e, t) => (t - e) / Yt, (e) => e.getMinutes());
x0.range;
const w0 = rt((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * Yt);
}, (e, t) => (t - e) / Yt, (e) => e.getUTCMinutes());
w0.range;
const S0 = rt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Hr - e.getMinutes() * Yt);
}, (e, t) => {
  e.setTime(+e + t * Vr);
}, (e, t) => (t - e) / Vr, (e) => e.getHours());
S0.range;
const O0 = rt((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Vr);
}, (e, t) => (t - e) / Vr, (e) => e.getUTCHours());
O0.range;
const Us = rt(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Yt) / Jr,
  (e) => e.getDate() - 1
);
Us.range;
const af = rt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Jr, (e) => e.getUTCDate() - 1);
af.range;
const BT = rt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Jr, (e) => Math.floor(e / Jr));
BT.range;
function ya(e) {
  return rt((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * Yt) / b0);
}
const of = ya(0), xl = ya(1), TG = ya(2), MG = ya(3), to = ya(4), RG = ya(5), $G = ya(6);
of.range;
xl.range;
TG.range;
MG.range;
to.range;
RG.range;
$G.range;
function ga(e) {
  return rt((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / b0);
}
const sf = ga(0), wl = ga(1), IG = ga(2), DG = ga(3), ro = ga(4), jG = ga(5), LG = ga(6);
sf.range;
wl.range;
IG.range;
DG.range;
ro.range;
jG.range;
LG.range;
const P0 = rt((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
P0.range;
const A0 = rt((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
A0.range;
const Qr = rt((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Qr.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : rt((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
Qr.range;
const en = rt((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
en.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : rt((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
en.range;
function FT(e, t, r, n, a, o) {
  const i = [
    [Jn, 1, Hr],
    [Jn, 5, 5 * Hr],
    [Jn, 15, 15 * Hr],
    [Jn, 30, 30 * Hr],
    [o, 1, Yt],
    [o, 5, 5 * Yt],
    [o, 15, 15 * Yt],
    [o, 30, 30 * Yt],
    [a, 1, Vr],
    [a, 3, 3 * Vr],
    [a, 6, 6 * Vr],
    [a, 12, 12 * Vr],
    [n, 1, Jr],
    [n, 2, 2 * Jr],
    [r, 1, b0],
    [t, 1, lO],
    [t, 3, 3 * lO],
    [e, 1, rm]
  ];
  function s(l, u, f) {
    const d = u < l;
    d && ([l, u] = [u, l]);
    const p = f && typeof f.range == "function" ? f : c(l, u, f), g = p ? p.range(l, +u + 1) : [];
    return d ? g.reverse() : g;
  }
  function c(l, u, f) {
    const d = Math.abs(u - l) / f, p = s0(([, , y]) => y).right(i, d);
    if (p === i.length) return e.every(Uv(l / rm, u / rm, f));
    if (p === 0) return bl.every(Math.max(Uv(l, u, f), 1));
    const [g, m] = i[d / i[p - 1][2] < i[p][2] / d ? p - 1 : p];
    return g.every(m);
  }
  return [s, c];
}
const [BG, FG] = FT(en, A0, sf, BT, O0, w0), [zG, qG] = FT(Qr, P0, of, Us, S0, x0);
function nm(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function am(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function ni(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function WG(e) {
  var t = e.dateTime, r = e.date, n = e.time, a = e.periods, o = e.days, i = e.shortDays, s = e.months, c = e.shortMonths, l = ai(a), u = oi(a), f = ai(o), d = oi(o), p = ai(i), g = oi(i), m = ai(s), y = oi(s), b = ai(c), w = oi(c), S = {
    a: z,
    A: q,
    b: I,
    B,
    c: null,
    d: mO,
    e: mO,
    f: dY,
    g: SY,
    G: PY,
    H: lY,
    I: uY,
    j: fY,
    L: zT,
    m: pY,
    M: hY,
    p: W,
    q: H,
    Q: gO,
    s: bO,
    S: mY,
    u: vY,
    U: yY,
    V: gY,
    w: bY,
    W: xY,
    x: null,
    X: null,
    y: wY,
    Y: OY,
    Z: AY,
    "%": yO
  }, P = {
    a: U,
    A: X,
    b: ee,
    B: ne,
    c: null,
    d: vO,
    e: vO,
    f: kY,
    g: BY,
    G: zY,
    H: _Y,
    I: EY,
    j: CY,
    L: WT,
    m: NY,
    M: TY,
    p: G,
    q: te,
    Q: gO,
    s: bO,
    S: MY,
    u: RY,
    U: $Y,
    V: IY,
    w: DY,
    W: jY,
    x: null,
    X: null,
    y: LY,
    Y: FY,
    Z: qY,
    "%": yO
  }, x = {
    a: M,
    A: T,
    b: k,
    B: $,
    c: R,
    d: pO,
    e: pO,
    f: oY,
    g: dO,
    G: fO,
    H: hO,
    I: hO,
    j: tY,
    L: aY,
    m: eY,
    M: rY,
    p: N,
    q: QG,
    Q: sY,
    s: cY,
    S: nY,
    u: GG,
    U: YG,
    V: XG,
    w: KG,
    W: ZG,
    x: L,
    X: j,
    y: dO,
    Y: fO,
    Z: JG,
    "%": iY
  };
  S.x = O(r, S), S.X = O(n, S), S.c = O(t, S), P.x = O(r, P), P.X = O(n, P), P.c = O(t, P);
  function O(V, Y) {
    return function(Q) {
      var D = [], le = -1, Z = 0, ve = V.length, ye, Ie, Ot;
      for (Q instanceof Date || (Q = /* @__PURE__ */ new Date(+Q)); ++le < ve; )
        V.charCodeAt(le) === 37 && (D.push(V.slice(Z, le)), (Ie = uO[ye = V.charAt(++le)]) != null ? ye = V.charAt(++le) : Ie = ye === "e" ? " " : "0", (Ot = Y[ye]) && (ye = Ot(Q, Ie)), D.push(ye), Z = le + 1);
      return D.push(V.slice(Z, le)), D.join("");
    };
  }
  function A(V, Y) {
    return function(Q) {
      var D = ni(1900, void 0, 1), le = _(D, V, Q += "", 0), Z, ve;
      if (le != Q.length) return null;
      if ("Q" in D) return new Date(D.Q);
      if ("s" in D) return new Date(D.s * 1e3 + ("L" in D ? D.L : 0));
      if (Y && !("Z" in D) && (D.Z = 0), "p" in D && (D.H = D.H % 12 + D.p * 12), D.m === void 0 && (D.m = "q" in D ? D.q : 0), "V" in D) {
        if (D.V < 1 || D.V > 53) return null;
        "w" in D || (D.w = 1), "Z" in D ? (Z = am(ni(D.y, 0, 1)), ve = Z.getUTCDay(), Z = ve > 4 || ve === 0 ? wl.ceil(Z) : wl(Z), Z = af.offset(Z, (D.V - 1) * 7), D.y = Z.getUTCFullYear(), D.m = Z.getUTCMonth(), D.d = Z.getUTCDate() + (D.w + 6) % 7) : (Z = nm(ni(D.y, 0, 1)), ve = Z.getDay(), Z = ve > 4 || ve === 0 ? xl.ceil(Z) : xl(Z), Z = Us.offset(Z, (D.V - 1) * 7), D.y = Z.getFullYear(), D.m = Z.getMonth(), D.d = Z.getDate() + (D.w + 6) % 7);
      } else ("W" in D || "U" in D) && ("w" in D || (D.w = "u" in D ? D.u % 7 : "W" in D ? 1 : 0), ve = "Z" in D ? am(ni(D.y, 0, 1)).getUTCDay() : nm(ni(D.y, 0, 1)).getDay(), D.m = 0, D.d = "W" in D ? (D.w + 6) % 7 + D.W * 7 - (ve + 5) % 7 : D.w + D.U * 7 - (ve + 6) % 7);
      return "Z" in D ? (D.H += D.Z / 100 | 0, D.M += D.Z % 100, am(D)) : nm(D);
    };
  }
  function _(V, Y, Q, D) {
    for (var le = 0, Z = Y.length, ve = Q.length, ye, Ie; le < Z; ) {
      if (D >= ve) return -1;
      if (ye = Y.charCodeAt(le++), ye === 37) {
        if (ye = Y.charAt(le++), Ie = x[ye in uO ? Y.charAt(le++) : ye], !Ie || (D = Ie(V, Q, D)) < 0) return -1;
      } else if (ye != Q.charCodeAt(D++))
        return -1;
    }
    return D;
  }
  function N(V, Y, Q) {
    var D = l.exec(Y.slice(Q));
    return D ? (V.p = u.get(D[0].toLowerCase()), Q + D[0].length) : -1;
  }
  function M(V, Y, Q) {
    var D = p.exec(Y.slice(Q));
    return D ? (V.w = g.get(D[0].toLowerCase()), Q + D[0].length) : -1;
  }
  function T(V, Y, Q) {
    var D = f.exec(Y.slice(Q));
    return D ? (V.w = d.get(D[0].toLowerCase()), Q + D[0].length) : -1;
  }
  function k(V, Y, Q) {
    var D = b.exec(Y.slice(Q));
    return D ? (V.m = w.get(D[0].toLowerCase()), Q + D[0].length) : -1;
  }
  function $(V, Y, Q) {
    var D = m.exec(Y.slice(Q));
    return D ? (V.m = y.get(D[0].toLowerCase()), Q + D[0].length) : -1;
  }
  function R(V, Y, Q) {
    return _(V, t, Y, Q);
  }
  function L(V, Y, Q) {
    return _(V, r, Y, Q);
  }
  function j(V, Y, Q) {
    return _(V, n, Y, Q);
  }
  function z(V) {
    return i[V.getDay()];
  }
  function q(V) {
    return o[V.getDay()];
  }
  function I(V) {
    return c[V.getMonth()];
  }
  function B(V) {
    return s[V.getMonth()];
  }
  function W(V) {
    return a[+(V.getHours() >= 12)];
  }
  function H(V) {
    return 1 + ~~(V.getMonth() / 3);
  }
  function U(V) {
    return i[V.getUTCDay()];
  }
  function X(V) {
    return o[V.getUTCDay()];
  }
  function ee(V) {
    return c[V.getUTCMonth()];
  }
  function ne(V) {
    return s[V.getUTCMonth()];
  }
  function G(V) {
    return a[+(V.getUTCHours() >= 12)];
  }
  function te(V) {
    return 1 + ~~(V.getUTCMonth() / 3);
  }
  return {
    format: function(V) {
      var Y = O(V += "", S);
      return Y.toString = function() {
        return V;
      }, Y;
    },
    parse: function(V) {
      var Y = A(V += "", !1);
      return Y.toString = function() {
        return V;
      }, Y;
    },
    utcFormat: function(V) {
      var Y = O(V += "", P);
      return Y.toString = function() {
        return V;
      }, Y;
    },
    utcParse: function(V) {
      var Y = A(V += "", !0);
      return Y.toString = function() {
        return V;
      }, Y;
    }
  };
}
var uO = { "-": "", _: " ", 0: "0" }, it = /^\s*\d+/, HG = /^%/, VG = /[\\^$*+?|[\]().{}]/g;
function be(e, t, r) {
  var n = e < 0 ? "-" : "", a = (n ? -e : e) + "", o = a.length;
  return n + (o < r ? new Array(r - o + 1).join(t) + a : a);
}
function UG(e) {
  return e.replace(VG, "\\$&");
}
function ai(e) {
  return new RegExp("^(?:" + e.map(UG).join("|") + ")", "i");
}
function oi(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function KG(e, t, r) {
  var n = it.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function GG(e, t, r) {
  var n = it.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function YG(e, t, r) {
  var n = it.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function XG(e, t, r) {
  var n = it.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function ZG(e, t, r) {
  var n = it.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function fO(e, t, r) {
  var n = it.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function dO(e, t, r) {
  var n = it.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function JG(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function QG(e, t, r) {
  var n = it.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function eY(e, t, r) {
  var n = it.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function pO(e, t, r) {
  var n = it.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function tY(e, t, r) {
  var n = it.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function hO(e, t, r) {
  var n = it.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function rY(e, t, r) {
  var n = it.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function nY(e, t, r) {
  var n = it.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function aY(e, t, r) {
  var n = it.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function oY(e, t, r) {
  var n = it.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function iY(e, t, r) {
  var n = HG.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function sY(e, t, r) {
  var n = it.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function cY(e, t, r) {
  var n = it.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function mO(e, t) {
  return be(e.getDate(), t, 2);
}
function lY(e, t) {
  return be(e.getHours(), t, 2);
}
function uY(e, t) {
  return be(e.getHours() % 12 || 12, t, 2);
}
function fY(e, t) {
  return be(1 + Us.count(Qr(e), e), t, 3);
}
function zT(e, t) {
  return be(e.getMilliseconds(), t, 3);
}
function dY(e, t) {
  return zT(e, t) + "000";
}
function pY(e, t) {
  return be(e.getMonth() + 1, t, 2);
}
function hY(e, t) {
  return be(e.getMinutes(), t, 2);
}
function mY(e, t) {
  return be(e.getSeconds(), t, 2);
}
function vY(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function yY(e, t) {
  return be(of.count(Qr(e) - 1, e), t, 2);
}
function qT(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? to(e) : to.ceil(e);
}
function gY(e, t) {
  return e = qT(e), be(to.count(Qr(e), e) + (Qr(e).getDay() === 4), t, 2);
}
function bY(e) {
  return e.getDay();
}
function xY(e, t) {
  return be(xl.count(Qr(e) - 1, e), t, 2);
}
function wY(e, t) {
  return be(e.getFullYear() % 100, t, 2);
}
function SY(e, t) {
  return e = qT(e), be(e.getFullYear() % 100, t, 2);
}
function OY(e, t) {
  return be(e.getFullYear() % 1e4, t, 4);
}
function PY(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? to(e) : to.ceil(e), be(e.getFullYear() % 1e4, t, 4);
}
function AY(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + be(t / 60 | 0, "0", 2) + be(t % 60, "0", 2);
}
function vO(e, t) {
  return be(e.getUTCDate(), t, 2);
}
function _Y(e, t) {
  return be(e.getUTCHours(), t, 2);
}
function EY(e, t) {
  return be(e.getUTCHours() % 12 || 12, t, 2);
}
function CY(e, t) {
  return be(1 + af.count(en(e), e), t, 3);
}
function WT(e, t) {
  return be(e.getUTCMilliseconds(), t, 3);
}
function kY(e, t) {
  return WT(e, t) + "000";
}
function NY(e, t) {
  return be(e.getUTCMonth() + 1, t, 2);
}
function TY(e, t) {
  return be(e.getUTCMinutes(), t, 2);
}
function MY(e, t) {
  return be(e.getUTCSeconds(), t, 2);
}
function RY(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function $Y(e, t) {
  return be(sf.count(en(e) - 1, e), t, 2);
}
function HT(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? ro(e) : ro.ceil(e);
}
function IY(e, t) {
  return e = HT(e), be(ro.count(en(e), e) + (en(e).getUTCDay() === 4), t, 2);
}
function DY(e) {
  return e.getUTCDay();
}
function jY(e, t) {
  return be(wl.count(en(e) - 1, e), t, 2);
}
function LY(e, t) {
  return be(e.getUTCFullYear() % 100, t, 2);
}
function BY(e, t) {
  return e = HT(e), be(e.getUTCFullYear() % 100, t, 2);
}
function FY(e, t) {
  return be(e.getUTCFullYear() % 1e4, t, 4);
}
function zY(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? ro(e) : ro.ceil(e), be(e.getUTCFullYear() % 1e4, t, 4);
}
function qY() {
  return "+0000";
}
function yO() {
  return "%";
}
function gO(e) {
  return +e;
}
function bO(e) {
  return Math.floor(+e / 1e3);
}
var ka, VT, UT;
WY({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function WY(e) {
  return ka = WG(e), VT = ka.format, ka.parse, UT = ka.utcFormat, ka.utcParse, ka;
}
function HY(e) {
  return new Date(e);
}
function VY(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function _0(e, t, r, n, a, o, i, s, c, l) {
  var u = d0(), f = u.invert, d = u.domain, p = l(".%L"), g = l(":%S"), m = l("%I:%M"), y = l("%I %p"), b = l("%a %d"), w = l("%b %d"), S = l("%B"), P = l("%Y");
  function x(O) {
    return (c(O) < O ? p : s(O) < O ? g : i(O) < O ? m : o(O) < O ? y : n(O) < O ? a(O) < O ? b : w : r(O) < O ? S : P)(O);
  }
  return u.invert = function(O) {
    return new Date(f(O));
  }, u.domain = function(O) {
    return arguments.length ? d(Array.from(O, VY)) : d().map(HY);
  }, u.ticks = function(O) {
    var A = d();
    return e(A[0], A[A.length - 1], O ?? 10);
  }, u.tickFormat = function(O, A) {
    return A == null ? x : l(A);
  }, u.nice = function(O) {
    var A = d();
    return (!O || typeof O.range != "function") && (O = t(A[0], A[A.length - 1], O ?? 10)), O ? d(MT(A, O)) : u;
  }, u.copy = function() {
    return Vs(u, _0(e, t, r, n, a, o, i, s, c, l));
  }, u;
}
function UY() {
  return rr.apply(_0(zG, qG, Qr, P0, of, Us, S0, x0, Jn, VT).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function KY() {
  return rr.apply(_0(BG, FG, en, A0, sf, af, O0, w0, Jn, UT).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function cf() {
  var e = 0, t = 1, r, n, a, o, i = bt, s = !1, c;
  function l(f) {
    return f == null || isNaN(f = +f) ? c : i(a === 0 ? 0.5 : (f = (o(f) - r) * a, s ? Math.max(0, Math.min(1, f)) : f));
  }
  l.domain = function(f) {
    return arguments.length ? ([e, t] = f, r = o(e = +e), n = o(t = +t), a = r === n ? 0 : 1 / (n - r), l) : [e, t];
  }, l.clamp = function(f) {
    return arguments.length ? (s = !!f, l) : s;
  }, l.interpolator = function(f) {
    return arguments.length ? (i = f, l) : i;
  };
  function u(f) {
    return function(d) {
      var p, g;
      return arguments.length ? ([p, g] = d, i = f(p, g), l) : [i(0), i(1)];
    };
  }
  return l.range = u(Fo), l.rangeRound = u(f0), l.unknown = function(f) {
    return arguments.length ? (c = f, l) : c;
  }, function(f) {
    return o = f, r = f(e), n = f(t), a = r === n ? 0 : 1 / (n - r), l;
  };
}
function jn(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function KT() {
  var e = Dn(cf()(bt));
  return e.copy = function() {
    return jn(e, KT());
  }, sn.apply(e, arguments);
}
function GT() {
  var e = m0(cf()).domain([1, 10]);
  return e.copy = function() {
    return jn(e, GT()).base(e.base());
  }, sn.apply(e, arguments);
}
function YT() {
  var e = v0(cf());
  return e.copy = function() {
    return jn(e, YT()).constant(e.constant());
  }, sn.apply(e, arguments);
}
function E0() {
  var e = y0(cf());
  return e.copy = function() {
    return jn(e, E0()).exponent(e.exponent());
  }, sn.apply(e, arguments);
}
function GY() {
  return E0.apply(null, arguments).exponent(0.5);
}
function XT() {
  var e = [], t = bt;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return t((Ws(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let a of n) a != null && !isNaN(a = +a) && e.push(a);
    return e.sort(On), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, a) => t(a / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (a, o) => $K(e, o / n));
  }, r.copy = function() {
    return XT(t).domain(e);
  }, sn.apply(r, arguments);
}
function lf() {
  var e = 0, t = 0.5, r = 1, n = 1, a, o, i, s, c, l = bt, u, f = !1, d;
  function p(m) {
    return isNaN(m = +m) ? d : (m = 0.5 + ((m = +u(m)) - o) * (n * m < n * o ? s : c), l(f ? Math.max(0, Math.min(1, m)) : m));
  }
  p.domain = function(m) {
    return arguments.length ? ([e, t, r] = m, a = u(e = +e), o = u(t = +t), i = u(r = +r), s = a === o ? 0 : 0.5 / (o - a), c = o === i ? 0 : 0.5 / (i - o), n = o < a ? -1 : 1, p) : [e, t, r];
  }, p.clamp = function(m) {
    return arguments.length ? (f = !!m, p) : f;
  }, p.interpolator = function(m) {
    return arguments.length ? (l = m, p) : l;
  };
  function g(m) {
    return function(y) {
      var b, w, S;
      return arguments.length ? ([b, w, S] = y, l = iG(m, [b, w, S]), p) : [l(0), l(0.5), l(1)];
    };
  }
  return p.range = g(Fo), p.rangeRound = g(f0), p.unknown = function(m) {
    return arguments.length ? (d = m, p) : d;
  }, function(m) {
    return u = m, a = m(e), o = m(t), i = m(r), s = a === o ? 0 : 0.5 / (o - a), c = o === i ? 0 : 0.5 / (i - o), n = o < a ? -1 : 1, p;
  };
}
function ZT() {
  var e = Dn(lf()(bt));
  return e.copy = function() {
    return jn(e, ZT());
  }, sn.apply(e, arguments);
}
function JT() {
  var e = m0(lf()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return jn(e, JT()).base(e.base());
  }, sn.apply(e, arguments);
}
function QT() {
  var e = v0(lf());
  return e.copy = function() {
    return jn(e, QT()).constant(e.constant());
  }, sn.apply(e, arguments);
}
function C0() {
  var e = y0(lf());
  return e.copy = function() {
    return jn(e, C0()).exponent(e.exponent());
  }, sn.apply(e, arguments);
}
function YY() {
  return C0.apply(null, arguments).exponent(0.5);
}
const xO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Wi,
  scaleDiverging: ZT,
  scaleDivergingLog: JT,
  scaleDivergingPow: C0,
  scaleDivergingSqrt: YY,
  scaleDivergingSymlog: QT,
  scaleIdentity: TT,
  scaleImplicit: Kv,
  scaleLinear: gl,
  scaleLog: RT,
  scaleOrdinal: c0,
  scalePoint: gi,
  scalePow: g0,
  scaleQuantile: DT,
  scaleQuantize: jT,
  scaleRadial: IT,
  scaleSequential: KT,
  scaleSequentialLog: GT,
  scaleSequentialPow: E0,
  scaleSequentialQuantile: XT,
  scaleSequentialSqrt: GY,
  scaleSequentialSymlog: YT,
  scaleSqrt: kG,
  scaleSymlog: $T,
  scaleThreshold: LT,
  scaleTime: UY,
  scaleUtc: KY,
  tickFormat: NT
}, Symbol.toStringTag, { value: "Module" }));
var om, wO;
function uf() {
  if (wO) return om;
  wO = 1;
  var e = Do();
  function t(r, n, a) {
    for (var o = -1, i = r.length; ++o < i; ) {
      var s = r[o], c = n(s);
      if (c != null && (l === void 0 ? c === c && !e(c) : a(c, l)))
        var l = c, u = s;
    }
    return u;
  }
  return om = t, om;
}
var im, SO;
function eM() {
  if (SO) return im;
  SO = 1;
  function e(t, r) {
    return t > r;
  }
  return im = e, im;
}
var sm, OO;
function XY() {
  if (OO) return sm;
  OO = 1;
  var e = uf(), t = eM(), r = Bo();
  function n(a) {
    return a && a.length ? e(a, r, t) : void 0;
  }
  return sm = n, sm;
}
var ZY = XY();
const bn = /* @__PURE__ */ _e(ZY);
var cm, PO;
function tM() {
  if (PO) return cm;
  PO = 1;
  function e(t, r) {
    return t < r;
  }
  return cm = e, cm;
}
var lm, AO;
function JY() {
  if (AO) return lm;
  AO = 1;
  var e = uf(), t = tM(), r = Bo();
  function n(a) {
    return a && a.length ? e(a, r, t) : void 0;
  }
  return lm = n, lm;
}
var QY = JY();
const Ks = /* @__PURE__ */ _e(QY);
var um, _O;
function eX() {
  if (_O) return um;
  _O = 1;
  var e = Ug(), t = wr(), r = lT(), n = Nt();
  function a(o, i) {
    var s = n(o) ? e : r;
    return s(o, t(i, 3));
  }
  return um = a, um;
}
var fm, EO;
function tX() {
  if (EO) return fm;
  EO = 1;
  var e = sT(), t = eX();
  function r(n, a) {
    return e(t(n, a), 1);
  }
  return fm = r, fm;
}
var rX = tX();
const nX = /* @__PURE__ */ _e(rX);
var dm, CO;
function aX() {
  if (CO) return dm;
  CO = 1;
  var e = n0();
  function t(r, n) {
    return e(r, n);
  }
  return dm = t, dm;
}
var oX = aX();
const tn = /* @__PURE__ */ _e(oX);
var zo = 1e9, iX = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, N0, Fe = !0, er = "[DecimalError] ", aa = er + "Invalid argument: ", k0 = er + "Exponent out of range: ", qo = Math.floor, Kn = Math.pow, sX = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Lt, nt = 1e7, je = 7, rM = 9007199254740991, Sl = qo(rM / je), oe = {};
oe.absoluteValue = oe.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
oe.comparedTo = oe.cmp = function(e) {
  var t, r, n, a, o = this;
  if (e = new o.constructor(e), o.s !== e.s) return o.s || -e.s;
  if (o.e !== e.e) return o.e > e.e ^ o.s < 0 ? 1 : -1;
  for (n = o.d.length, a = e.d.length, t = 0, r = n < a ? n : a; t < r; ++t)
    if (o.d[t] !== e.d[t]) return o.d[t] > e.d[t] ^ o.s < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ o.s < 0 ? 1 : -1;
};
oe.decimalPlaces = oe.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * je;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
oe.dividedBy = oe.div = function(e) {
  return Gr(this, new this.constructor(e));
};
oe.dividedToIntegerBy = oe.idiv = function(e) {
  var t = this, r = t.constructor;
  return Me(Gr(t, new r(e), 0, 1), r.precision);
};
oe.equals = oe.eq = function(e) {
  return !this.cmp(e);
};
oe.exponent = function() {
  return Ke(this);
};
oe.greaterThan = oe.gt = function(e) {
  return this.cmp(e) > 0;
};
oe.greaterThanOrEqualTo = oe.gte = function(e) {
  return this.cmp(e) >= 0;
};
oe.isInteger = oe.isint = function() {
  return this.e > this.d.length - 2;
};
oe.isNegative = oe.isneg = function() {
  return this.s < 0;
};
oe.isPositive = oe.ispos = function() {
  return this.s > 0;
};
oe.isZero = function() {
  return this.s === 0;
};
oe.lessThan = oe.lt = function(e) {
  return this.cmp(e) < 0;
};
oe.lessThanOrEqualTo = oe.lte = function(e) {
  return this.cmp(e) < 1;
};
oe.logarithm = oe.log = function(e) {
  var t, r = this, n = r.constructor, a = n.precision, o = a + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(Lt)) throw Error(er + "NaN");
  if (r.s < 1) throw Error(er + (r.s ? "NaN" : "-Infinity"));
  return r.eq(Lt) ? new n(0) : (Fe = !1, t = Gr(Gi(r, o), Gi(e, o), o), Fe = !0, Me(t, a));
};
oe.minus = oe.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? oM(t, e) : nM(t, (e.s = -e.s, e));
};
oe.modulo = oe.mod = function(e) {
  var t, r = this, n = r.constructor, a = n.precision;
  if (e = new n(e), !e.s) throw Error(er + "NaN");
  return r.s ? (Fe = !1, t = Gr(r, e, 0, 1).times(e), Fe = !0, r.minus(t)) : Me(new n(r), a);
};
oe.naturalExponential = oe.exp = function() {
  return aM(this);
};
oe.naturalLogarithm = oe.ln = function() {
  return Gi(this);
};
oe.negated = oe.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
oe.plus = oe.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? nM(t, e) : oM(t, (e.s = -e.s, e));
};
oe.precision = oe.sd = function(e) {
  var t, r, n, a = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(aa + e);
  if (t = Ke(a) + 1, n = a.d.length - 1, r = n * je + 1, n = a.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = a.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
oe.squareRoot = oe.sqrt = function() {
  var e, t, r, n, a, o, i, s = this, c = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new c(0);
    throw Error(er + "NaN");
  }
  for (e = Ke(s), Fe = !1, a = Math.sqrt(+s), a == 0 || a == 1 / 0 ? (t = Er(s.d), (t.length + e) % 2 == 0 && (t += "0"), a = Math.sqrt(t), e = qo((e + 1) / 2) - (e < 0 || e % 2), a == 1 / 0 ? t = "5e" + e : (t = a.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new c(t)) : n = new c(a.toString()), r = c.precision, a = i = r + 3; ; )
    if (o = n, n = o.plus(Gr(s, o, i + 2)).times(0.5), Er(o.d).slice(0, i) === (t = Er(n.d)).slice(0, i)) {
      if (t = t.slice(i - 3, i + 1), a == i && t == "4999") {
        if (Me(o, r + 1, 0), o.times(o).eq(s)) {
          n = o;
          break;
        }
      } else if (t != "9999")
        break;
      i += 4;
    }
  return Fe = !0, Me(n, r);
};
oe.times = oe.mul = function(e) {
  var t, r, n, a, o, i, s, c, l, u = this, f = u.constructor, d = u.d, p = (e = new f(e)).d;
  if (!u.s || !e.s) return new f(0);
  for (e.s *= u.s, r = u.e + e.e, c = d.length, l = p.length, c < l && (o = d, d = p, p = o, i = c, c = l, l = i), o = [], i = c + l, n = i; n--; ) o.push(0);
  for (n = l; --n >= 0; ) {
    for (t = 0, a = c + n; a > n; )
      s = o[a] + p[n] * d[a - n - 1] + t, o[a--] = s % nt | 0, t = s / nt | 0;
    o[a] = (o[a] + t) % nt | 0;
  }
  for (; !o[--i]; ) o.pop();
  return t ? ++r : o.shift(), e.d = o, e.e = r, Fe ? Me(e, f.precision) : e;
};
oe.toDecimalPlaces = oe.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : ($r(e, 0, zo), t === void 0 ? t = n.rounding : $r(t, 0, 8), Me(r, e + Ke(r) + 1, t));
};
oe.toExponential = function(e, t) {
  var r, n = this, a = n.constructor;
  return e === void 0 ? r = fa(n, !0) : ($r(e, 0, zo), t === void 0 ? t = a.rounding : $r(t, 0, 8), n = Me(new a(n), e + 1, t), r = fa(n, !0, e + 1)), r;
};
oe.toFixed = function(e, t) {
  var r, n, a = this, o = a.constructor;
  return e === void 0 ? fa(a) : ($r(e, 0, zo), t === void 0 ? t = o.rounding : $r(t, 0, 8), n = Me(new o(a), e + Ke(a) + 1, t), r = fa(n.abs(), !1, e + Ke(n) + 1), a.isneg() && !a.isZero() ? "-" + r : r);
};
oe.toInteger = oe.toint = function() {
  var e = this, t = e.constructor;
  return Me(new t(e), Ke(e) + 1, t.rounding);
};
oe.toNumber = function() {
  return +this;
};
oe.toPower = oe.pow = function(e) {
  var t, r, n, a, o, i, s = this, c = s.constructor, l = 12, u = +(e = new c(e));
  if (!e.s) return new c(Lt);
  if (s = new c(s), !s.s) {
    if (e.s < 1) throw Error(er + "Infinity");
    return s;
  }
  if (s.eq(Lt)) return s;
  if (n = c.precision, e.eq(Lt)) return Me(s, n);
  if (t = e.e, r = e.d.length - 1, i = t >= r, o = s.s, i) {
    if ((r = u < 0 ? -u : u) <= rM) {
      for (a = new c(Lt), t = Math.ceil(n / je + 4), Fe = !1; r % 2 && (a = a.times(s), NO(a.d, t)), r = qo(r / 2), r !== 0; )
        s = s.times(s), NO(s.d, t);
      return Fe = !0, e.s < 0 ? new c(Lt).div(a) : Me(a, n);
    }
  } else if (o < 0) throw Error(er + "NaN");
  return o = o < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, s.s = 1, Fe = !1, a = e.times(Gi(s, n + l)), Fe = !0, a = aM(a), a.s = o, a;
};
oe.toPrecision = function(e, t) {
  var r, n, a = this, o = a.constructor;
  return e === void 0 ? (r = Ke(a), n = fa(a, r <= o.toExpNeg || r >= o.toExpPos)) : ($r(e, 1, zo), t === void 0 ? t = o.rounding : $r(t, 0, 8), a = Me(new o(a), e, t), r = Ke(a), n = fa(a, e <= r || r <= o.toExpNeg, e)), n;
};
oe.toSignificantDigits = oe.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : ($r(e, 1, zo), t === void 0 ? t = n.rounding : $r(t, 0, 8)), Me(new n(r), e, t);
};
oe.toString = oe.valueOf = oe.val = oe.toJSON = oe[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Ke(e), r = e.constructor;
  return fa(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function nM(e, t) {
  var r, n, a, o, i, s, c, l, u = e.constructor, f = u.precision;
  if (!e.s || !t.s)
    return t.s || (t = new u(e)), Fe ? Me(t, f) : t;
  if (c = e.d, l = t.d, i = e.e, a = t.e, c = c.slice(), o = i - a, o) {
    for (o < 0 ? (n = c, o = -o, s = l.length) : (n = l, a = i, s = c.length), i = Math.ceil(f / je), s = i > s ? i + 1 : s + 1, o > s && (o = s, n.length = 1), n.reverse(); o--; ) n.push(0);
    n.reverse();
  }
  for (s = c.length, o = l.length, s - o < 0 && (o = s, n = l, l = c, c = n), r = 0; o; )
    r = (c[--o] = c[o] + l[o] + r) / nt | 0, c[o] %= nt;
  for (r && (c.unshift(r), ++a), s = c.length; c[--s] == 0; ) c.pop();
  return t.d = c, t.e = a, Fe ? Me(t, f) : t;
}
function $r(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(aa + e);
}
function Er(e) {
  var t, r, n, a = e.length - 1, o = "", i = e[0];
  if (a > 0) {
    for (o += i, t = 1; t < a; t++)
      n = e[t] + "", r = je - n.length, r && (o += yn(r)), o += n;
    i = e[t], n = i + "", r = je - n.length, r && (o += yn(r));
  } else if (i === 0)
    return "0";
  for (; i % 10 === 0; ) i /= 10;
  return o + i;
}
var Gr = /* @__PURE__ */ (function() {
  function e(n, a) {
    var o, i = 0, s = n.length;
    for (n = n.slice(); s--; )
      o = n[s] * a + i, n[s] = o % nt | 0, i = o / nt | 0;
    return i && n.unshift(i), n;
  }
  function t(n, a, o, i) {
    var s, c;
    if (o != i)
      c = o > i ? 1 : -1;
    else
      for (s = c = 0; s < o; s++)
        if (n[s] != a[s]) {
          c = n[s] > a[s] ? 1 : -1;
          break;
        }
    return c;
  }
  function r(n, a, o) {
    for (var i = 0; o--; )
      n[o] -= i, i = n[o] < a[o] ? 1 : 0, n[o] = i * nt + n[o] - a[o];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, a, o, i) {
    var s, c, l, u, f, d, p, g, m, y, b, w, S, P, x, O, A, _, N = n.constructor, M = n.s == a.s ? 1 : -1, T = n.d, k = a.d;
    if (!n.s) return new N(n);
    if (!a.s) throw Error(er + "Division by zero");
    for (c = n.e - a.e, A = k.length, x = T.length, p = new N(M), g = p.d = [], l = 0; k[l] == (T[l] || 0); ) ++l;
    if (k[l] > (T[l] || 0) && --c, o == null ? w = o = N.precision : i ? w = o + (Ke(n) - Ke(a)) + 1 : w = o, w < 0) return new N(0);
    if (w = w / je + 2 | 0, l = 0, A == 1)
      for (u = 0, k = k[0], w++; (l < x || u) && w--; l++)
        S = u * nt + (T[l] || 0), g[l] = S / k | 0, u = S % k | 0;
    else {
      for (u = nt / (k[0] + 1) | 0, u > 1 && (k = e(k, u), T = e(T, u), A = k.length, x = T.length), P = A, m = T.slice(0, A), y = m.length; y < A; ) m[y++] = 0;
      _ = k.slice(), _.unshift(0), O = k[0], k[1] >= nt / 2 && ++O;
      do
        u = 0, s = t(k, m, A, y), s < 0 ? (b = m[0], A != y && (b = b * nt + (m[1] || 0)), u = b / O | 0, u > 1 ? (u >= nt && (u = nt - 1), f = e(k, u), d = f.length, y = m.length, s = t(f, m, d, y), s == 1 && (u--, r(f, A < d ? _ : k, d))) : (u == 0 && (s = u = 1), f = k.slice()), d = f.length, d < y && f.unshift(0), r(m, f, y), s == -1 && (y = m.length, s = t(k, m, A, y), s < 1 && (u++, r(m, A < y ? _ : k, y))), y = m.length) : s === 0 && (u++, m = [0]), g[l++] = u, s && m[0] ? m[y++] = T[P] || 0 : (m = [T[P]], y = 1);
      while ((P++ < x || m[0] !== void 0) && w--);
    }
    return g[0] || g.shift(), p.e = c, Me(p, i ? o + Ke(p) + 1 : o);
  };
})();
function aM(e, t) {
  var r, n, a, o, i, s, c = 0, l = 0, u = e.constructor, f = u.precision;
  if (Ke(e) > 16) throw Error(k0 + Ke(e));
  if (!e.s) return new u(Lt);
  for (Fe = !1, s = f, i = new u(0.03125); e.abs().gte(0.1); )
    e = e.times(i), l += 5;
  for (n = Math.log(Kn(2, l)) / Math.LN10 * 2 + 5 | 0, s += n, r = a = o = new u(Lt), u.precision = s; ; ) {
    if (a = Me(a.times(e), s), r = r.times(++c), i = o.plus(Gr(a, r, s)), Er(i.d).slice(0, s) === Er(o.d).slice(0, s)) {
      for (; l--; ) o = Me(o.times(o), s);
      return u.precision = f, t == null ? (Fe = !0, Me(o, f)) : o;
    }
    o = i;
  }
}
function Ke(e) {
  for (var t = e.e * je, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function pm(e, t, r) {
  if (t > e.LN10.sd())
    throw Fe = !0, r && (e.precision = r), Error(er + "LN10 precision limit exceeded");
  return Me(new e(e.LN10), t);
}
function yn(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function Gi(e, t) {
  var r, n, a, o, i, s, c, l, u, f = 1, d = 10, p = e, g = p.d, m = p.constructor, y = m.precision;
  if (p.s < 1) throw Error(er + (p.s ? "NaN" : "-Infinity"));
  if (p.eq(Lt)) return new m(0);
  if (t == null ? (Fe = !1, l = y) : l = t, p.eq(10))
    return t == null && (Fe = !0), pm(m, l);
  if (l += d, m.precision = l, r = Er(g), n = r.charAt(0), o = Ke(p), Math.abs(o) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      p = p.times(e), r = Er(p.d), n = r.charAt(0), f++;
    o = Ke(p), n > 1 ? (p = new m("0." + r), o++) : p = new m(n + "." + r.slice(1));
  } else
    return c = pm(m, l + 2, y).times(o + ""), p = Gi(new m(n + "." + r.slice(1)), l - d).plus(c), m.precision = y, t == null ? (Fe = !0, Me(p, y)) : p;
  for (s = i = p = Gr(p.minus(Lt), p.plus(Lt), l), u = Me(p.times(p), l), a = 3; ; ) {
    if (i = Me(i.times(u), l), c = s.plus(Gr(i, new m(a), l)), Er(c.d).slice(0, l) === Er(s.d).slice(0, l))
      return s = s.times(2), o !== 0 && (s = s.plus(pm(m, l + 2, y).times(o + ""))), s = Gr(s, new m(f), l), m.precision = y, t == null ? (Fe = !0, Me(s, y)) : s;
    s = c, a += 2;
  }
}
function kO(e, t) {
  var r, n, a;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (a = t.length; t.charCodeAt(a - 1) === 48; ) --a;
  if (t = t.slice(n, a), t) {
    if (a -= n, r = r - n - 1, e.e = qo(r / je), e.d = [], n = (r + 1) % je, r < 0 && (n += je), n < a) {
      for (n && e.d.push(+t.slice(0, n)), a -= je; n < a; ) e.d.push(+t.slice(n, n += je));
      t = t.slice(n), n = je - t.length;
    } else
      n -= a;
    for (; n--; ) t += "0";
    if (e.d.push(+t), Fe && (e.e > Sl || e.e < -Sl)) throw Error(k0 + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function Me(e, t, r) {
  var n, a, o, i, s, c, l, u, f = e.d;
  for (i = 1, o = f[0]; o >= 10; o /= 10) i++;
  if (n = t - i, n < 0)
    n += je, a = t, l = f[u = 0];
  else {
    if (u = Math.ceil((n + 1) / je), o = f.length, u >= o) return e;
    for (l = o = f[u], i = 1; o >= 10; o /= 10) i++;
    n %= je, a = n - je + i;
  }
  if (r !== void 0 && (o = Kn(10, i - a - 1), s = l / o % 10 | 0, c = t < 0 || f[u + 1] !== void 0 || l % o, c = r < 4 ? (s || c) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || c || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? a > 0 ? l / Kn(10, i - a) : 0 : f[u - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return c ? (o = Ke(e), f.length = 1, t = t - o - 1, f[0] = Kn(10, (je - t % je) % je), e.e = qo(-t / je) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = u, o = 1, u--) : (f.length = u + 1, o = Kn(10, je - n), f[u] = a > 0 ? (l / Kn(10, i - a) % Kn(10, a) | 0) * o : 0), c)
    for (; ; )
      if (u == 0) {
        (f[0] += o) == nt && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[u] += o, f[u] != nt) break;
        f[u--] = 0, o = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (Fe && (e.e > Sl || e.e < -Sl))
    throw Error(k0 + Ke(e));
  return e;
}
function oM(e, t) {
  var r, n, a, o, i, s, c, l, u, f, d = e.constructor, p = d.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new d(e), Fe ? Me(t, p) : t;
  if (c = e.d, f = t.d, n = t.e, l = e.e, c = c.slice(), i = l - n, i) {
    for (u = i < 0, u ? (r = c, i = -i, s = f.length) : (r = f, n = l, s = c.length), a = Math.max(Math.ceil(p / je), s) + 2, i > a && (i = a, r.length = 1), r.reverse(), a = i; a--; ) r.push(0);
    r.reverse();
  } else {
    for (a = c.length, s = f.length, u = a < s, u && (s = a), a = 0; a < s; a++)
      if (c[a] != f[a]) {
        u = c[a] < f[a];
        break;
      }
    i = 0;
  }
  for (u && (r = c, c = f, f = r, t.s = -t.s), s = c.length, a = f.length - s; a > 0; --a) c[s++] = 0;
  for (a = f.length; a > i; ) {
    if (c[--a] < f[a]) {
      for (o = a; o && c[--o] === 0; ) c[o] = nt - 1;
      --c[o], c[a] += nt;
    }
    c[a] -= f[a];
  }
  for (; c[--s] === 0; ) c.pop();
  for (; c[0] === 0; c.shift()) --n;
  return c[0] ? (t.d = c, t.e = n, Fe ? Me(t, p) : t) : new d(0);
}
function fa(e, t, r) {
  var n, a = Ke(e), o = Er(e.d), i = o.length;
  return t ? (r && (n = r - i) > 0 ? o = o.charAt(0) + "." + o.slice(1) + yn(n) : i > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (a < 0 ? "e" : "e+") + a) : a < 0 ? (o = "0." + yn(-a - 1) + o, r && (n = r - i) > 0 && (o += yn(n))) : a >= i ? (o += yn(a + 1 - i), r && (n = r - a - 1) > 0 && (o = o + "." + yn(n))) : ((n = a + 1) < i && (o = o.slice(0, n) + "." + o.slice(n)), r && (n = r - i) > 0 && (a + 1 === i && (o += "."), o += yn(n))), e.s < 0 ? "-" + o : o;
}
function NO(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function iM(e) {
  var t, r, n;
  function a(o) {
    var i = this;
    if (!(i instanceof a)) return new a(o);
    if (i.constructor = a, o instanceof a) {
      i.s = o.s, i.e = o.e, i.d = (o = o.d) ? o.slice() : o;
      return;
    }
    if (typeof o == "number") {
      if (o * 0 !== 0)
        throw Error(aa + o);
      if (o > 0)
        i.s = 1;
      else if (o < 0)
        o = -o, i.s = -1;
      else {
        i.s = 0, i.e = 0, i.d = [0];
        return;
      }
      if (o === ~~o && o < 1e7) {
        i.e = 0, i.d = [o];
        return;
      }
      return kO(i, o.toString());
    } else if (typeof o != "string")
      throw Error(aa + o);
    if (o.charCodeAt(0) === 45 ? (o = o.slice(1), i.s = -1) : i.s = 1, sX.test(o)) kO(i, o);
    else throw Error(aa + o);
  }
  if (a.prototype = oe, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.clone = iM, a.config = a.set = cX, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return a.config(e), a;
}
function cX(e) {
  if (!e || typeof e != "object")
    throw Error(er + "Object expected");
  var t, r, n, a = [
    "precision",
    1,
    zo,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < a.length; t += 3)
    if ((n = e[r = a[t]]) !== void 0)
      if (qo(n) === n && n >= a[t + 1] && n <= a[t + 2]) this[r] = n;
      else throw Error(aa + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(aa + r + ": " + n);
  return this;
}
var N0 = iM(iX);
Lt = new N0(1);
const ke = N0;
function lX(e) {
  return pX(e) || dX(e) || fX(e) || uX();
}
function uX() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fX(e, t) {
  if (e) {
    if (typeof e == "string") return Zv(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Zv(e, t);
  }
}
function dX(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function pX(e) {
  if (Array.isArray(e)) return Zv(e);
}
function Zv(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var hX = function(t) {
  return t;
}, sM = {}, cM = function(t) {
  return t === sM;
}, TO = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && cM(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, mX = function e(t, r) {
  return t === 1 ? r : TO(function() {
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    var i = a.filter(function(s) {
      return s !== sM;
    }).length;
    return i >= t ? r.apply(void 0, a) : e(t - i, TO(function() {
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      var u = a.map(function(f) {
        return cM(f) ? c.shift() : f;
      });
      return r.apply(void 0, lX(u).concat(c));
    }));
  });
}, ff = function(t) {
  return mX(t.length, t);
}, Jv = function(t, r) {
  for (var n = [], a = t; a < r; ++a)
    n[a - t] = a;
  return n;
}, vX = ff(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), yX = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return hX;
  var a = r.reverse(), o = a[0], i = a.slice(1);
  return function() {
    return i.reduce(function(s, c) {
      return c(s);
    }, o.apply(void 0, arguments));
  };
}, Qv = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, lM = function(t) {
  var r = null, n = null;
  return function() {
    for (var a = arguments.length, o = new Array(a), i = 0; i < a; i++)
      o[i] = arguments[i];
    return r && o.every(function(s, c) {
      return s === r[c];
    }) || (r = o, n = t.apply(void 0, o)), n;
  };
};
function gX(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new ke(e).abs().log(10).toNumber()) + 1, t;
}
function bX(e, t, r) {
  for (var n = new ke(e), a = 0, o = []; n.lt(t) && a < 1e5; )
    o.push(n.toNumber()), n = n.add(r), a++;
  return o;
}
var xX = ff(function(e, t, r) {
  var n = +e, a = +t;
  return n + r * (a - n);
}), wX = ff(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), SX = ff(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const df = {
  rangeStep: bX,
  getDigitCount: gX,
  interpolateNumber: xX,
  uninterpolateNumber: wX,
  uninterpolateTruncation: SX
};
function ey(e) {
  return AX(e) || PX(e) || uM(e) || OX();
}
function OX() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PX(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function AX(e) {
  if (Array.isArray(e)) return ty(e);
}
function Yi(e, t) {
  return CX(e) || EX(e, t) || uM(e, t) || _X();
}
function _X() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uM(e, t) {
  if (e) {
    if (typeof e == "string") return ty(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ty(e, t);
  }
}
function ty(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function EX(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, a = !1, o = void 0;
    try {
      for (var i = e[Symbol.iterator](), s; !(n = (s = i.next()).done) && (r.push(s.value), !(t && r.length === t)); n = !0)
        ;
    } catch (c) {
      a = !0, o = c;
    } finally {
      try {
        !n && i.return != null && i.return();
      } finally {
        if (a) throw o;
      }
    }
    return r;
  }
}
function CX(e) {
  if (Array.isArray(e)) return e;
}
function fM(e) {
  var t = Yi(e, 2), r = t[0], n = t[1], a = r, o = n;
  return r > n && (a = n, o = r), [a, o];
}
function dM(e, t, r) {
  if (e.lte(0))
    return new ke(0);
  var n = df.getDigitCount(e.toNumber()), a = new ke(10).pow(n), o = e.div(a), i = n !== 1 ? 0.05 : 0.1, s = new ke(Math.ceil(o.div(i).toNumber())).add(r).mul(i), c = s.mul(a);
  return t ? c : new ke(Math.ceil(c));
}
function kX(e, t, r) {
  var n = 1, a = new ke(e);
  if (!a.isint() && r) {
    var o = Math.abs(e);
    o < 1 ? (n = new ke(10).pow(df.getDigitCount(e) - 1), a = new ke(Math.floor(a.div(n).toNumber())).mul(n)) : o > 1 && (a = new ke(Math.floor(e)));
  } else e === 0 ? a = new ke(Math.floor((t - 1) / 2)) : r || (a = new ke(Math.floor(e)));
  var i = Math.floor((t - 1) / 2), s = yX(vX(function(c) {
    return a.add(new ke(c - i).mul(n)).toNumber();
  }), Jv);
  return s(0, t);
}
function pM(e, t, r, n) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new ke(0),
      tickMin: new ke(0),
      tickMax: new ke(0)
    };
  var o = dM(new ke(t).sub(e).div(r - 1), n, a), i;
  e <= 0 && t >= 0 ? i = new ke(0) : (i = new ke(e).add(t).div(2), i = i.sub(new ke(i).mod(o)));
  var s = Math.ceil(i.sub(e).div(o).toNumber()), c = Math.ceil(new ke(t).sub(i).div(o).toNumber()), l = s + c + 1;
  return l > r ? pM(e, t, r, n, a + 1) : (l < r && (c = t > 0 ? c + (r - l) : c, s = t > 0 ? s : s + (r - l)), {
    step: o,
    tickMin: i.sub(new ke(s).mul(o)),
    tickMax: i.add(new ke(c).mul(o))
  });
}
function NX(e) {
  var t = Yi(e, 2), r = t[0], n = t[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, i = Math.max(a, 2), s = fM([r, n]), c = Yi(s, 2), l = c[0], u = c[1];
  if (l === -1 / 0 || u === 1 / 0) {
    var f = u === 1 / 0 ? [l].concat(ey(Jv(0, a - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(ey(Jv(0, a - 1).map(function() {
      return -1 / 0;
    })), [u]);
    return r > n ? Qv(f) : f;
  }
  if (l === u)
    return kX(l, a, o);
  var d = pM(l, u, i, o), p = d.step, g = d.tickMin, m = d.tickMax, y = df.rangeStep(g, m.add(new ke(0.1).mul(p)), p);
  return r > n ? Qv(y) : y;
}
function TX(e, t) {
  var r = Yi(e, 2), n = r[0], a = r[1], o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, i = fM([n, a]), s = Yi(i, 2), c = s[0], l = s[1];
  if (c === -1 / 0 || l === 1 / 0)
    return [n, a];
  if (c === l)
    return [c];
  var u = Math.max(t, 2), f = dM(new ke(l).sub(c).div(u - 1), o, 0), d = [].concat(ey(df.rangeStep(new ke(c), new ke(l).sub(new ke(0.99).mul(f)), f)), [l]);
  return n > a ? Qv(d) : d;
}
var MX = lM(NX), RX = lM(TX), $X = process.env.NODE_ENV === "production", hm = "Invariant failed";
function _t(e, t) {
  if ($X)
    throw new Error(hm);
  var r = typeof t == "function" ? t() : t, n = r ? "".concat(hm, ": ").concat(r) : hm;
  throw new Error(n);
}
var IX = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function no(e) {
  "@babel/helpers - typeof";
  return no = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, no(e);
}
function Ol() {
  return Ol = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ol.apply(this, arguments);
}
function DX(e, t) {
  return FX(e) || BX(e, t) || LX(e, t) || jX();
}
function jX() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LX(e, t) {
  if (e) {
    if (typeof e == "string") return MO(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return MO(e, t);
  }
}
function MO(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function BX(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function FX(e) {
  if (Array.isArray(e)) return e;
}
function zX(e, t) {
  if (e == null) return {};
  var r = qX(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function qX(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function WX(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function HX(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vM(n.key), n);
  }
}
function VX(e, t, r) {
  return t && HX(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function UX(e, t, r) {
  return t = Pl(t), KX(e, hM() ? Reflect.construct(t, r || [], Pl(e).constructor) : t.apply(e, r));
}
function KX(e, t) {
  if (t && (no(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return GX(e);
}
function GX(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (hM = function() {
    return !!e;
  })();
}
function Pl(e) {
  return Pl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Pl(e);
}
function YX(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ry(e, t);
}
function ry(e, t) {
  return ry = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, ry(e, t);
}
function mM(e, t, r) {
  return t = vM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vM(e) {
  var t = XX(e, "string");
  return no(t) == "symbol" ? t : t + "";
}
function XX(e, t) {
  if (no(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (no(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Wo = /* @__PURE__ */ (function(e) {
  function t() {
    return WX(this, t), UX(this, t, arguments);
  }
  return YX(t, e), VX(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.offset, o = n.layout, i = n.width, s = n.dataKey, c = n.data, l = n.dataPointFormatter, u = n.xAxis, f = n.yAxis, d = zX(n, IX), p = ae(d, !1);
      this.props.direction === "x" && u.type !== "number" && (process.env.NODE_ENV !== "production" ? _t(!1, 'ErrorBar requires Axis type property to be "number".') : _t());
      var g = c.map(function(m) {
        var y = l(m, s), b = y.x, w = y.y, S = y.value, P = y.errorVal;
        if (!P)
          return null;
        var x = [], O, A;
        if (Array.isArray(P)) {
          var _ = DX(P, 2);
          O = _[0], A = _[1];
        } else
          O = A = P;
        if (o === "vertical") {
          var N = u.scale, M = w + a, T = M + i, k = M - i, $ = N(S - O), R = N(S + A);
          x.push({
            x1: R,
            y1: T,
            x2: R,
            y2: k
          }), x.push({
            x1: $,
            y1: M,
            x2: R,
            y2: M
          }), x.push({
            x1: $,
            y1: T,
            x2: $,
            y2: k
          });
        } else if (o === "horizontal") {
          var L = f.scale, j = b + a, z = j - i, q = j + i, I = L(S - O), B = L(S + A);
          x.push({
            x1: z,
            y1: B,
            x2: q,
            y2: B
          }), x.push({
            x1: j,
            y1: I,
            x2: j,
            y2: B
          }), x.push({
            x1: z,
            y1: I,
            x2: q,
            y2: I
          });
        }
        return /* @__PURE__ */ E.createElement(de, Ol({
          className: "recharts-errorBar",
          key: "bar-".concat(x.map(function(W) {
            return "".concat(W.x1, "-").concat(W.x2, "-").concat(W.y1, "-").concat(W.y2);
          }))
        }, p), x.map(function(W) {
          return /* @__PURE__ */ E.createElement("line", Ol({}, W, {
            key: "line-".concat(W.x1, "-").concat(W.x2, "-").concat(W.y1, "-").concat(W.y2)
          }));
        }));
      });
      return /* @__PURE__ */ E.createElement(de, {
        className: "recharts-errorBars"
      }, g);
    }
  }]);
})(E.Component);
mM(Wo, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
mM(Wo, "displayName", "ErrorBar");
function Xi(e) {
  "@babel/helpers - typeof";
  return Xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xi(e);
}
function RO(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? RO(Object(r), !0).forEach(function(n) {
      ZX(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : RO(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ZX(e, t, r) {
  return t = JX(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function JX(e) {
  var t = QX(e, "string");
  return Xi(t) == "symbol" ? t : t + "";
}
function QX(e, t) {
  if (Xi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Xi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var yM = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, a = t.legendWidth, o = t.legendContent, i = ct(r, Zt);
  if (!i)
    return null;
  var s = Zt.defaultProps, c = s !== void 0 ? qn(qn({}, s), i.props) : {}, l;
  return i.props && i.props.payload ? l = i.props && i.props.payload : o === "children" ? l = (n || []).reduce(function(u, f) {
    var d = f.item, p = f.props, g = p.sectors || p.data || [];
    return u.concat(g.map(function(m) {
      return {
        type: i.props.iconType || d.props.legendType,
        value: m.name,
        color: m.fill,
        payload: m
      };
    }));
  }, []) : l = (n || []).map(function(u) {
    var f = u.item, d = f.type.defaultProps, p = d !== void 0 ? qn(qn({}, d), f.props) : {}, g = p.dataKey, m = p.name, y = p.legendType, b = p.hide;
    return {
      inactive: b,
      dataKey: g,
      type: c.iconType || y || "square",
      color: T0(f),
      value: m || g,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: p
    };
  }), qn(qn(qn({}, c), Zt.getWithHeight(i, a)), {}, {
    payload: l,
    item: i
  });
};
function Zi(e) {
  "@babel/helpers - typeof";
  return Zi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zi(e);
}
function $O(e) {
  return nZ(e) || rZ(e) || tZ(e) || eZ();
}
function eZ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tZ(e, t) {
  if (e) {
    if (typeof e == "string") return ny(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ny(e, t);
  }
}
function rZ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function nZ(e) {
  if (Array.isArray(e)) return ny(e);
}
function ny(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function IO(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function We(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? IO(Object(r), !0).forEach(function(n) {
      Wa(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : IO(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Wa(e, t, r) {
  return t = aZ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aZ(e) {
  var t = oZ(e, "string");
  return Zi(t) == "symbol" ? t : t + "";
}
function oZ(e, t) {
  if (Zi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Zi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ge(e, t, r) {
  return ce(e) || ce(t) ? r : tt(t) ? lt(e, t, r) : se(t) ? t(e) : r;
}
function bi(e, t, r, n) {
  var a = nX(e, function(s) {
    return ge(s, t);
  });
  if (r === "number") {
    var o = a.filter(function(s) {
      return J(s) || parseFloat(s);
    });
    return o.length ? [Ks(o), bn(o)] : [1 / 0, -1 / 0];
  }
  var i = n ? a.filter(function(s) {
    return !ce(s);
  }) : a;
  return i.map(function(s) {
    return tt(s) || s instanceof Date ? s : "";
  });
}
var iZ = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0, i = -1, s = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (o && o.axisType === "angleAxis" && Math.abs(Math.abs(o.range[1] - o.range[0]) - 360) <= 1e-6)
    for (var c = o.range, l = 0; l < s; l++) {
      var u = l > 0 ? a[l - 1].coordinate : a[s - 1].coordinate, f = a[l].coordinate, d = l >= s - 1 ? a[0].coordinate : a[l + 1].coordinate, p = void 0;
      if (yt(f - u) !== yt(d - f)) {
        var g = [];
        if (yt(d - f) === yt(c[1] - c[0])) {
          p = d;
          var m = f + c[1] - c[0];
          g[0] = Math.min(m, (m + u) / 2), g[1] = Math.max(m, (m + u) / 2);
        } else {
          p = u;
          var y = d + c[1] - c[0];
          g[0] = Math.min(f, (y + f) / 2), g[1] = Math.max(f, (y + f) / 2);
        }
        var b = [Math.min(f, (p + f) / 2), Math.max(f, (p + f) / 2)];
        if (t > b[0] && t <= b[1] || t >= g[0] && t <= g[1]) {
          i = a[l].index;
          break;
        }
      } else {
        var w = Math.min(u, d), S = Math.max(u, d);
        if (t > (w + f) / 2 && t <= (S + f) / 2) {
          i = a[l].index;
          break;
        }
      }
    }
  else
    for (var P = 0; P < s; P++)
      if (P === 0 && t <= (n[P].coordinate + n[P + 1].coordinate) / 2 || P > 0 && P < s - 1 && t > (n[P].coordinate + n[P - 1].coordinate) / 2 && t <= (n[P].coordinate + n[P + 1].coordinate) / 2 || P === s - 1 && t > (n[P].coordinate + n[P - 1].coordinate) / 2) {
        i = n[P].index;
        break;
      }
  return i;
}, T0 = function(t) {
  var r, n = t, a = n.type.displayName, o = (r = t.type) !== null && r !== void 0 && r.defaultProps ? We(We({}, t.type.defaultProps), t.props) : t.props, i = o.stroke, s = o.fill, c;
  switch (a) {
    case "Line":
      c = i;
      break;
    case "Area":
    case "Radar":
      c = i && i !== "none" ? i : s;
      break;
    default:
      c = s;
      break;
  }
  return c;
}, sZ = function(t) {
  var r = t.barSize, n = t.totalSize, a = t.stackGroups, o = a === void 0 ? {} : a;
  if (!o)
    return {};
  for (var i = {}, s = Object.keys(o), c = 0, l = s.length; c < l; c++)
    for (var u = o[s[c]].stackGroups, f = Object.keys(u), d = 0, p = f.length; d < p; d++) {
      var g = u[f[d]], m = g.items, y = g.cateAxisId, b = m.filter(function(A) {
        return Kr(A.type).indexOf("Bar") >= 0;
      });
      if (b && b.length) {
        var w = b[0].type.defaultProps, S = w !== void 0 ? We(We({}, w), b[0].props) : b[0].props, P = S.barSize, x = S[y];
        i[x] || (i[x] = []);
        var O = ce(P) ? r : P;
        i[x].push({
          item: b[0],
          stackList: b.slice(1),
          barSize: ce(O) ? void 0 : gt(O, n, 0)
        });
      }
    }
  return i;
}, cZ = function(t) {
  var r = t.barGap, n = t.barCategoryGap, a = t.bandSize, o = t.sizeList, i = o === void 0 ? [] : o, s = t.maxBarSize, c = i.length;
  if (c < 1) return null;
  var l = gt(r, a, 0, !0), u, f = [];
  if (i[0].barSize === +i[0].barSize) {
    var d = !1, p = a / c, g = i.reduce(function(P, x) {
      return P + x.barSize || 0;
    }, 0);
    g += (c - 1) * l, g >= a && (g -= (c - 1) * l, l = 0), g >= a && p > 0 && (d = !0, p *= 0.9, g = c * p);
    var m = (a - g) / 2 >> 0, y = {
      offset: m - l,
      size: 0
    };
    u = i.reduce(function(P, x) {
      var O = {
        item: x.item,
        position: {
          offset: y.offset + y.size + l,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: d ? p : x.barSize
        }
      }, A = [].concat($O(P), [O]);
      return y = A[A.length - 1].position, x.stackList && x.stackList.length && x.stackList.forEach(function(_) {
        A.push({
          item: _,
          position: y
        });
      }), A;
    }, f);
  } else {
    var b = gt(n, a, 0, !0);
    a - 2 * b - (c - 1) * l <= 0 && (l = 0);
    var w = (a - 2 * b - (c - 1) * l) / c;
    w > 1 && (w >>= 0);
    var S = s === +s ? Math.min(w, s) : w;
    u = i.reduce(function(P, x, O) {
      var A = [].concat($O(P), [{
        item: x.item,
        position: {
          offset: b + (w + l) * O + (w - S) / 2,
          size: S
        }
      }]);
      return x.stackList && x.stackList.length && x.stackList.forEach(function(_) {
        A.push({
          item: _,
          position: A[A.length - 1].position
        });
      }), A;
    }, f);
  }
  return u;
}, lZ = function(t, r, n, a) {
  var o = n.children, i = n.width, s = n.margin, c = i - (s.left || 0) - (s.right || 0), l = yM({
    children: o,
    legendWidth: c
  });
  if (l) {
    var u = a || {}, f = u.width, d = u.height, p = l.align, g = l.verticalAlign, m = l.layout;
    if ((m === "vertical" || m === "horizontal" && g === "middle") && p !== "center" && J(t[p]))
      return We(We({}, t), {}, Wa({}, p, t[p] + (f || 0)));
    if ((m === "horizontal" || m === "vertical" && p === "center") && g !== "middle" && J(t[g]))
      return We(We({}, t), {}, Wa({}, g, t[g] + (d || 0)));
  }
  return t;
}, uZ = function(t, r, n) {
  return ce(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, gM = function(t, r, n, a, o) {
  var i = r.props.children, s = xt(i, Wo).filter(function(l) {
    return uZ(a, o, l.props.direction);
  });
  if (s && s.length) {
    var c = s.map(function(l) {
      return l.props.dataKey;
    });
    return t.reduce(function(l, u) {
      var f = ge(u, n);
      if (ce(f)) return l;
      var d = Array.isArray(f) ? [Ks(f), bn(f)] : [f, f], p = c.reduce(function(g, m) {
        var y = ge(u, m, 0), b = d[0] - Math.abs(Array.isArray(y) ? y[0] : y), w = d[1] + Math.abs(Array.isArray(y) ? y[1] : y);
        return [Math.min(b, g[0]), Math.max(w, g[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(p[0], l[0]), Math.max(p[1], l[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, fZ = function(t, r, n, a, o) {
  var i = r.map(function(s) {
    return gM(t, s, n, o, a);
  }).filter(function(s) {
    return !ce(s);
  });
  return i && i.length ? i.reduce(function(s, c) {
    return [Math.min(s[0], c[0]), Math.max(s[1], c[1])];
  }, [1 / 0, -1 / 0]) : null;
}, bM = function(t, r, n, a, o) {
  var i = r.map(function(c) {
    var l = c.props.dataKey;
    return n === "number" && l && gM(t, c, l, a) || bi(t, l, n, o);
  });
  if (n === "number")
    return i.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(c, l) {
        return [Math.min(c[0], l[0]), Math.max(c[1], l[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return i.reduce(function(c, l) {
    for (var u = 0, f = l.length; u < f; u++)
      s[l[u]] || (s[l[u]] = !0, c.push(l[u]));
    return c;
  }, []);
}, xM = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, wM = function(t, r, n, a) {
  if (a)
    return t.map(function(c) {
      return c.coordinate;
    });
  var o, i, s = t.map(function(c) {
    return c.coordinate === r && (o = !0), c.coordinate === n && (i = !0), c.coordinate;
  });
  return o || s.push(r), i || s.push(n), s;
}, Ur = function(t, r, n) {
  if (!t) return null;
  var a = t.scale, o = t.duplicateDomain, i = t.type, s = t.range, c = t.realScaleType === "scaleBand" ? a.bandwidth() / 2 : 2, l = (r || n) && i === "category" && a.bandwidth ? a.bandwidth() / c : 0;
  if (l = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? yt(s[0] - s[1]) * 2 * l : l, r && (t.ticks || t.niceTicks)) {
    var u = (t.ticks || t.niceTicks).map(function(f) {
      var d = o ? o.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: a(d) + l,
        value: f,
        offset: l
      };
    });
    return u.filter(function(f) {
      return !Lo(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, d) {
    return {
      coordinate: a(f) + l,
      value: f,
      index: d,
      offset: l
    };
  }) : a.ticks && !n ? a.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: a(f) + l,
      value: f,
      offset: l
    };
  }) : a.domain().map(function(f, d) {
    return {
      coordinate: a(f) + l,
      value: o ? o[f] : f,
      index: d,
      offset: l
    };
  });
}, mm = /* @__PURE__ */ new WeakMap(), yc = function(t, r) {
  if (typeof r != "function")
    return t;
  mm.has(t) || mm.set(t, /* @__PURE__ */ new WeakMap());
  var n = mm.get(t);
  if (n.has(r))
    return n.get(r);
  var a = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, a), a;
}, SM = function(t, r, n) {
  var a = t.scale, o = t.type, i = t.layout, s = t.axisType;
  if (a === "auto")
    return i === "radial" && s === "radiusAxis" ? {
      scale: Wi(),
      realScaleType: "band"
    } : i === "radial" && s === "angleAxis" ? {
      scale: gl(),
      realScaleType: "linear"
    } : o === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: gi(),
      realScaleType: "point"
    } : o === "category" ? {
      scale: Wi(),
      realScaleType: "band"
    } : {
      scale: gl(),
      realScaleType: "linear"
    };
  if (la(a)) {
    var c = "scale".concat(Yu(a));
    return {
      scale: (xO[c] || gi)(),
      realScaleType: xO[c] ? c : "point"
    };
  }
  return se(a) ? {
    scale: a
  } : {
    scale: gi(),
    realScaleType: "point"
  };
}, DO = 1e-4, OM = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, a = t.range(), o = Math.min(a[0], a[1]) - DO, i = Math.max(a[0], a[1]) + DO, s = t(r[0]), c = t(r[n - 1]);
    (s < o || s > i || c < o || c > i) && t.domain([r[0], r[n - 1]]);
  }
}, dZ = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, a = t.length; n < a; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, pZ = function(t, r) {
  if (!r || r.length !== 2 || !J(r[0]) || !J(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), a = Math.max(r[0], r[1]), o = [t[0], t[1]];
  return (!J(t[0]) || t[0] < n) && (o[0] = n), (!J(t[1]) || t[1] > a) && (o[1] = a), o[0] > a && (o[0] = a), o[1] < n && (o[1] = n), o;
}, hZ = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var o = 0, i = 0, s = 0; s < r; ++s) {
        var c = Lo(t[s][n][1]) ? t[s][n][0] : t[s][n][1];
        c >= 0 ? (t[s][n][0] = o, t[s][n][1] = o + c, o = t[s][n][1]) : (t[s][n][0] = i, t[s][n][1] = i + c, i = t[s][n][1]);
      }
}, mZ = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, a = t[0].length; n < a; ++n)
      for (var o = 0, i = 0; i < r; ++i) {
        var s = Lo(t[i][n][1]) ? t[i][n][0] : t[i][n][1];
        s >= 0 ? (t[i][n][0] = o, t[i][n][1] = o + s, o = t[i][n][1]) : (t[i][n][0] = 0, t[i][n][1] = 0);
      }
}, vZ = {
  sign: hZ,
  // @ts-expect-error definitelytyped types are incorrect
  expand: nH,
  // @ts-expect-error definitelytyped types are incorrect
  none: Ya,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: aH,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: oH,
  positive: mZ
}, yZ = function(t, r, n) {
  var a = r.map(function(s) {
    return s.props.dataKey;
  }), o = vZ[n], i = rH().keys(a).value(function(s, c) {
    return +ge(s, c, 0);
  }).order(Rv).offset(o);
  return i(t);
}, gZ = function(t, r, n, a, o, i) {
  if (!t)
    return null;
  var s = i ? r.reverse() : r, c = {}, l = s.reduce(function(f, d) {
    var p, g = (p = d.type) !== null && p !== void 0 && p.defaultProps ? We(We({}, d.type.defaultProps), d.props) : d.props, m = g.stackId, y = g.hide;
    if (y)
      return f;
    var b = g[n], w = f[b] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (tt(m)) {
      var S = w.stackGroups[m] || {
        numericAxisId: n,
        cateAxisId: a,
        items: []
      };
      S.items.push(d), w.hasStack = !0, w.stackGroups[m] = S;
    } else
      w.stackGroups[In("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: a,
        items: [d]
      };
    return We(We({}, f), {}, Wa({}, b, w));
  }, c), u = {};
  return Object.keys(l).reduce(function(f, d) {
    var p = l[d];
    if (p.hasStack) {
      var g = {};
      p.stackGroups = Object.keys(p.stackGroups).reduce(function(m, y) {
        var b = p.stackGroups[y];
        return We(We({}, m), {}, Wa({}, y, {
          numericAxisId: n,
          cateAxisId: a,
          items: b.items,
          stackedData: yZ(t, b.items, o)
        }));
      }, g);
    }
    return We(We({}, f), {}, Wa({}, d, p));
  }, u);
}, PM = function(t, r) {
  var n = r.realScaleType, a = r.type, o = r.tickCount, i = r.originalDomain, s = r.allowDecimals, c = n || r.scale;
  if (c !== "auto" && c !== "linear")
    return null;
  if (o && a === "number" && i && (i[0] === "auto" || i[1] === "auto")) {
    var l = t.domain();
    if (!l.length)
      return null;
    var u = MX(l, o, s);
    return t.domain([Ks(u), bn(u)]), {
      niceTicks: u
    };
  }
  if (o && a === "number") {
    var f = t.domain(), d = RX(f, o, s);
    return {
      niceTicks: d
    };
  }
  return null;
};
function ao(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, a = e.entry, o = e.index, i = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !ce(a[t.dataKey])) {
      var s = Qc(r, "value", a[t.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[o] ? r[o].coordinate + n / 2 : null;
  }
  var c = ge(a, ce(i) ? t.dataKey : i);
  return ce(c) ? null : t.scale(c);
}
var jO = function(t) {
  var r = t.axis, n = t.ticks, a = t.offset, o = t.bandSize, i = t.entry, s = t.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + a : null;
  var c = ge(i, r.dataKey, r.domain[s]);
  return ce(c) ? null : r.scale(c) - o / 2 + a;
}, bZ = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var a = Math.min(n[0], n[1]), o = Math.max(n[0], n[1]);
    return a <= 0 && o >= 0 ? 0 : o < 0 ? o : a;
  }
  return n[0];
}, xZ = function(t, r) {
  var n, a = (n = t.type) !== null && n !== void 0 && n.defaultProps ? We(We({}, t.type.defaultProps), t.props) : t.props, o = a.stackId;
  if (tt(o)) {
    var i = r[o];
    if (i) {
      var s = i.items.indexOf(t);
      return s >= 0 ? i.stackedData[s] : null;
    }
  }
  return null;
}, wZ = function(t) {
  return t.reduce(function(r, n) {
    return [Ks(n.concat([r[0]]).filter(J)), bn(n.concat([r[1]]).filter(J))];
  }, [1 / 0, -1 / 0]);
}, AM = function(t, r, n) {
  return Object.keys(t).reduce(function(a, o) {
    var i = t[o], s = i.stackedData, c = s.reduce(function(l, u) {
      var f = wZ(u.slice(r, n + 1));
      return [Math.min(l[0], f[0]), Math.max(l[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(c[0], a[0]), Math.max(c[1], a[1])];
  }, [1 / 0, -1 / 0]).map(function(a) {
    return a === 1 / 0 || a === -1 / 0 ? 0 : a;
  });
}, LO = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, BO = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, ay = function(t, r, n) {
  if (se(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var a = [];
  if (J(t[0]))
    a[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (LO.test(t[0])) {
    var o = +LO.exec(t[0])[1];
    a[0] = r[0] - o;
  } else se(t[0]) ? a[0] = t[0](r[0]) : a[0] = r[0];
  if (J(t[1]))
    a[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (BO.test(t[1])) {
    var i = +BO.exec(t[1])[1];
    a[1] = r[1] + i;
  } else se(t[1]) ? a[1] = t[1](r[1]) : a[1] = r[1];
  return a;
}, Al = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var a = t.scale.bandwidth();
    if (!n || a > 0)
      return a;
  }
  if (t && r && r.length >= 2) {
    for (var o = o0(r, function(f) {
      return f.coordinate;
    }), i = 1 / 0, s = 1, c = o.length; s < c; s++) {
      var l = o[s], u = o[s - 1];
      i = Math.min((l.coordinate || 0) - (u.coordinate || 0), i);
    }
    return i === 1 / 0 ? 0 : i;
  }
  return n ? void 0 : 0;
}, FO = function(t, r, n) {
  return !t || !t.length || tn(t, lt(n, "type.defaultProps.domain")) ? r : t;
}, _M = function(t, r) {
  var n = t.type.defaultProps ? We(We({}, t.type.defaultProps), t.props) : t.props, a = n.dataKey, o = n.name, i = n.unit, s = n.formatter, c = n.tooltipType, l = n.chartType, u = n.hide;
  return We(We({}, ae(t, !1)), {}, {
    dataKey: a,
    unit: i,
    formatter: s,
    name: o || a,
    color: T0(t),
    value: ge(r, a),
    type: c,
    payload: r,
    chartType: l,
    hide: u
  });
};
function Ji(e) {
  "@babel/helpers - typeof";
  return Ji = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ji(e);
}
function zO(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zO(Object(r), !0).forEach(function(n) {
      EM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zO(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function EM(e, t, r) {
  return t = SZ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function SZ(e) {
  var t = OZ(e, "string");
  return Ji(t) == "symbol" ? t : t + "";
}
function OZ(e, t) {
  if (Ji(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ji(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function PZ(e, t) {
  return CZ(e) || EZ(e, t) || _Z(e, t) || AZ();
}
function AZ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _Z(e, t) {
  if (e) {
    if (typeof e == "string") return qO(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return qO(e, t);
  }
}
function qO(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function EZ(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function CZ(e) {
  if (Array.isArray(e)) return e;
}
var _l = Math.PI / 180, kZ = function(t) {
  return t * 180 / Math.PI;
}, xe = function(t, r, n, a) {
  return {
    x: t + Math.cos(-_l * a) * n,
    y: r + Math.sin(-_l * a) * n
  };
}, CM = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, kM = function(t, r, n, a, o) {
  var i = t.width, s = t.height, c = t.startAngle, l = t.endAngle, u = gt(t.cx, i, i / 2), f = gt(t.cy, s, s / 2), d = CM(i, s, n), p = gt(t.innerRadius, d, 0), g = gt(t.outerRadius, d, d * 0.8), m = Object.keys(r);
  return m.reduce(function(y, b) {
    var w = r[b], S = w.domain, P = w.reversed, x;
    if (ce(w.range))
      a === "angleAxis" ? x = [c, l] : a === "radiusAxis" && (x = [p, g]), P && (x = [x[1], x[0]]);
    else {
      x = w.range;
      var O = x, A = PZ(O, 2);
      c = A[0], l = A[1];
    }
    var _ = SM(w, o), N = _.realScaleType, M = _.scale;
    M.domain(S).range(x), OM(M);
    var T = PM(M, qr(qr({}, w), {}, {
      realScaleType: N
    })), k = qr(qr(qr({}, w), T), {}, {
      range: x,
      radius: g,
      realScaleType: N,
      scale: M,
      cx: u,
      cy: f,
      innerRadius: p,
      outerRadius: g,
      startAngle: c,
      endAngle: l
    });
    return qr(qr({}, y), {}, EM({}, b, k));
  }, {});
}, NZ = function(t, r) {
  var n = t.x, a = t.y, o = r.x, i = r.y;
  return Math.sqrt(Math.pow(n - o, 2) + Math.pow(a - i, 2));
}, TZ = function(t, r) {
  var n = t.x, a = t.y, o = r.cx, i = r.cy, s = NZ({
    x: n,
    y: a
  }, {
    x: o,
    y: i
  });
  if (s <= 0)
    return {
      radius: s
    };
  var c = (n - o) / s, l = Math.acos(c);
  return a > i && (l = 2 * Math.PI - l), {
    radius: s,
    angle: kZ(l),
    angleInRadian: l
  };
}, MZ = function(t) {
  var r = t.startAngle, n = t.endAngle, a = Math.floor(r / 360), o = Math.floor(n / 360), i = Math.min(a, o);
  return {
    startAngle: r - i * 360,
    endAngle: n - i * 360
  };
}, RZ = function(t, r) {
  var n = r.startAngle, a = r.endAngle, o = Math.floor(n / 360), i = Math.floor(a / 360), s = Math.min(o, i);
  return t + s * 360;
}, WO = function(t, r) {
  var n = t.x, a = t.y, o = TZ({
    x: n,
    y: a
  }, r), i = o.radius, s = o.angle, c = r.innerRadius, l = r.outerRadius;
  if (i < c || i > l)
    return !1;
  if (i === 0)
    return !0;
  var u = MZ(r), f = u.startAngle, d = u.endAngle, p = s, g;
  if (f <= d) {
    for (; p > d; )
      p -= 360;
    for (; p < f; )
      p += 360;
    g = p >= f && p <= d;
  } else {
    for (; p > f; )
      p -= 360;
    for (; p < d; )
      p += 360;
    g = p >= d && p <= f;
  }
  return g ? qr(qr({}, r), {}, {
    radius: i,
    angle: RZ(p, r)
  }) : null;
}, NM = function(t) {
  return !/* @__PURE__ */ Et(t) && !se(t) && typeof t != "boolean" ? t.className : "";
};
function Qi(e) {
  "@babel/helpers - typeof";
  return Qi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qi(e);
}
var $Z = ["offset"];
function IZ(e) {
  return BZ(e) || LZ(e) || jZ(e) || DZ();
}
function DZ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jZ(e, t) {
  if (e) {
    if (typeof e == "string") return oy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return oy(e, t);
  }
}
function LZ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function BZ(e) {
  if (Array.isArray(e)) return oy(e);
}
function oy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function FZ(e, t) {
  if (e == null) return {};
  var r = zZ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function zZ(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function HO(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ze(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? HO(Object(r), !0).forEach(function(n) {
      qZ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : HO(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qZ(e, t, r) {
  return t = WZ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WZ(e) {
  var t = HZ(e, "string");
  return Qi(t) == "symbol" ? t : t + "";
}
function HZ(e, t) {
  if (Qi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Qi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function es() {
  return es = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, es.apply(this, arguments);
}
var VZ = function(t) {
  var r = t.value, n = t.formatter, a = ce(t.children) ? r : t.children;
  return se(n) ? n(a) : a;
}, UZ = function(t, r) {
  var n = yt(r - t), a = Math.min(Math.abs(r - t), 360);
  return n * a;
}, KZ = function(t, r, n) {
  var a = t.position, o = t.viewBox, i = t.offset, s = t.className, c = o, l = c.cx, u = c.cy, f = c.innerRadius, d = c.outerRadius, p = c.startAngle, g = c.endAngle, m = c.clockWise, y = (f + d) / 2, b = UZ(p, g), w = b >= 0 ? 1 : -1, S, P;
  a === "insideStart" ? (S = p + w * i, P = m) : a === "insideEnd" ? (S = g - w * i, P = !m) : a === "end" && (S = g + w * i, P = m), P = b <= 0 ? P : !P;
  var x = xe(l, u, y, S), O = xe(l, u, y, S + (P ? 1 : -1) * 359), A = "M".concat(x.x, ",").concat(x.y, `
    A`).concat(y, ",").concat(y, ",0,1,").concat(P ? 0 : 1, `,
    `).concat(O.x, ",").concat(O.y), _ = ce(t.id) ? In("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ E.createElement("text", es({}, n, {
    dominantBaseline: "central",
    className: ue("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("path", {
    id: _,
    d: A
  })), /* @__PURE__ */ E.createElement("textPath", {
    xlinkHref: "#".concat(_)
  }, r));
}, GZ = function(t) {
  var r = t.viewBox, n = t.offset, a = t.position, o = r, i = o.cx, s = o.cy, c = o.innerRadius, l = o.outerRadius, u = o.startAngle, f = o.endAngle, d = (u + f) / 2;
  if (a === "outside") {
    var p = xe(i, s, l + n, d), g = p.x, m = p.y;
    return {
      x: g,
      y: m,
      textAnchor: g >= i ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (a === "center")
    return {
      x: i,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (a === "centerTop")
    return {
      x: i,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (a === "centerBottom")
    return {
      x: i,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var y = (c + l) / 2, b = xe(i, s, y, d), w = b.x, S = b.y;
  return {
    x: w,
    y: S,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, YZ = function(t) {
  var r = t.viewBox, n = t.parentViewBox, a = t.offset, o = t.position, i = r, s = i.x, c = i.y, l = i.width, u = i.height, f = u >= 0 ? 1 : -1, d = f * a, p = f > 0 ? "end" : "start", g = f > 0 ? "start" : "end", m = l >= 0 ? 1 : -1, y = m * a, b = m > 0 ? "end" : "start", w = m > 0 ? "start" : "end";
  if (o === "top") {
    var S = {
      x: s + l / 2,
      y: c - f * a,
      textAnchor: "middle",
      verticalAnchor: p
    };
    return Ze(Ze({}, S), n ? {
      height: Math.max(c - n.y, 0),
      width: l
    } : {});
  }
  if (o === "bottom") {
    var P = {
      x: s + l / 2,
      y: c + u + d,
      textAnchor: "middle",
      verticalAnchor: g
    };
    return Ze(Ze({}, P), n ? {
      height: Math.max(n.y + n.height - (c + u), 0),
      width: l
    } : {});
  }
  if (o === "left") {
    var x = {
      x: s - y,
      y: c + u / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return Ze(Ze({}, x), n ? {
      width: Math.max(x.x - n.x, 0),
      height: u
    } : {});
  }
  if (o === "right") {
    var O = {
      x: s + l + y,
      y: c + u / 2,
      textAnchor: w,
      verticalAnchor: "middle"
    };
    return Ze(Ze({}, O), n ? {
      width: Math.max(n.x + n.width - O.x, 0),
      height: u
    } : {});
  }
  var A = n ? {
    width: l,
    height: u
  } : {};
  return o === "insideLeft" ? Ze({
    x: s + y,
    y: c + u / 2,
    textAnchor: w,
    verticalAnchor: "middle"
  }, A) : o === "insideRight" ? Ze({
    x: s + l - y,
    y: c + u / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, A) : o === "insideTop" ? Ze({
    x: s + l / 2,
    y: c + d,
    textAnchor: "middle",
    verticalAnchor: g
  }, A) : o === "insideBottom" ? Ze({
    x: s + l / 2,
    y: c + u - d,
    textAnchor: "middle",
    verticalAnchor: p
  }, A) : o === "insideTopLeft" ? Ze({
    x: s + y,
    y: c + d,
    textAnchor: w,
    verticalAnchor: g
  }, A) : o === "insideTopRight" ? Ze({
    x: s + l - y,
    y: c + d,
    textAnchor: b,
    verticalAnchor: g
  }, A) : o === "insideBottomLeft" ? Ze({
    x: s + y,
    y: c + u - d,
    textAnchor: w,
    verticalAnchor: p
  }, A) : o === "insideBottomRight" ? Ze({
    x: s + l - y,
    y: c + u - d,
    textAnchor: b,
    verticalAnchor: p
  }, A) : jo(o) && (J(o.x) || Xn(o.x)) && (J(o.y) || Xn(o.y)) ? Ze({
    x: s + gt(o.x, l),
    y: c + gt(o.y, u),
    textAnchor: "end",
    verticalAnchor: "end"
  }, A) : Ze({
    x: s + l / 2,
    y: c + u / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, A);
}, XZ = function(t) {
  return "cx" in t && J(t.cx);
};
function at(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = FZ(e, $Z), a = Ze({
    offset: r
  }, n), o = a.viewBox, i = a.position, s = a.value, c = a.children, l = a.content, u = a.className, f = u === void 0 ? "" : u, d = a.textBreakAll;
  if (!o || ce(s) && ce(c) && !/* @__PURE__ */ Et(l) && !se(l))
    return null;
  if (/* @__PURE__ */ Et(l))
    return /* @__PURE__ */ Je(l, a);
  var p;
  if (se(l)) {
    if (p = /* @__PURE__ */ _i(l, a), /* @__PURE__ */ Et(p))
      return p;
  } else
    p = VZ(a);
  var g = XZ(o), m = ae(a, !0);
  if (g && (i === "insideStart" || i === "insideEnd" || i === "end"))
    return KZ(a, p, m);
  var y = g ? GZ(a) : YZ(a);
  return /* @__PURE__ */ E.createElement(ua, es({
    className: ue("recharts-label", f)
  }, m, y, {
    breakAll: d
  }), p);
}
at.displayName = "Label";
var TM = function(t) {
  var r = t.cx, n = t.cy, a = t.angle, o = t.startAngle, i = t.endAngle, s = t.r, c = t.radius, l = t.innerRadius, u = t.outerRadius, f = t.x, d = t.y, p = t.top, g = t.left, m = t.width, y = t.height, b = t.clockWise, w = t.labelViewBox;
  if (w)
    return w;
  if (J(m) && J(y)) {
    if (J(f) && J(d))
      return {
        x: f,
        y: d,
        width: m,
        height: y
      };
    if (J(p) && J(g))
      return {
        x: p,
        y: g,
        width: m,
        height: y
      };
  }
  return J(f) && J(d) ? {
    x: f,
    y: d,
    width: 0,
    height: 0
  } : J(r) && J(n) ? {
    cx: r,
    cy: n,
    startAngle: o || a || 0,
    endAngle: i || a || 0,
    innerRadius: l || 0,
    outerRadius: u || c || s || 0,
    clockWise: b
  } : t.viewBox ? t.viewBox : {};
}, ZZ = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ E.createElement(at, {
    key: "label-implicit",
    viewBox: r
  }) : tt(t) ? /* @__PURE__ */ E.createElement(at, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ Et(t) ? t.type === at ? /* @__PURE__ */ Je(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ E.createElement(at, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : se(t) ? /* @__PURE__ */ E.createElement(at, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : jo(t) ? /* @__PURE__ */ E.createElement(at, es({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, JZ = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var a = t.children, o = TM(t), i = xt(a, at).map(function(c, l) {
    return /* @__PURE__ */ Je(c, {
      viewBox: r || o,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(l)
    });
  });
  if (!n)
    return i;
  var s = ZZ(t.label, r || o);
  return [s].concat(IZ(i));
};
at.parseViewBox = TM;
at.renderCallByParent = JZ;
var vm, VO;
function QZ() {
  if (VO) return vm;
  VO = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return vm = e, vm;
}
var eJ = QZ();
const MM = /* @__PURE__ */ _e(eJ);
function ts(e) {
  "@babel/helpers - typeof";
  return ts = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ts(e);
}
var tJ = ["valueAccessor"], rJ = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function nJ(e) {
  return sJ(e) || iJ(e) || oJ(e) || aJ();
}
function aJ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oJ(e, t) {
  if (e) {
    if (typeof e == "string") return iy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return iy(e, t);
  }
}
function iJ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function sJ(e) {
  if (Array.isArray(e)) return iy(e);
}
function iy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function El() {
  return El = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, El.apply(this, arguments);
}
function UO(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function KO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? UO(Object(r), !0).forEach(function(n) {
      cJ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : UO(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function cJ(e, t, r) {
  return t = lJ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function lJ(e) {
  var t = uJ(e, "string");
  return ts(t) == "symbol" ? t : t + "";
}
function uJ(e, t) {
  if (ts(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ts(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function GO(e, t) {
  if (e == null) return {};
  var r = fJ(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function fJ(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var dJ = function(t) {
  return Array.isArray(t.value) ? MM(t.value) : t.value;
};
function Jt(e) {
  var t = e.valueAccessor, r = t === void 0 ? dJ : t, n = GO(e, tJ), a = n.data, o = n.dataKey, i = n.clockWise, s = n.id, c = n.textBreakAll, l = GO(n, rJ);
  return !a || !a.length ? null : /* @__PURE__ */ E.createElement(de, {
    className: "recharts-label-list"
  }, a.map(function(u, f) {
    var d = ce(o) ? r(u, f) : ge(u && u.payload, o), p = ce(s) ? {} : {
      id: "".concat(s, "-").concat(f)
    };
    return /* @__PURE__ */ E.createElement(at, El({}, ae(u, !0), l, p, {
      parentViewBox: u.parentViewBox,
      value: d,
      textBreakAll: c,
      viewBox: at.parseViewBox(ce(i) ? u : KO(KO({}, u), {}, {
        clockWise: i
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
Jt.displayName = "LabelList";
function pJ(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ E.createElement(Jt, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ E.isValidElement(e) || se(e) ? /* @__PURE__ */ E.createElement(Jt, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : jo(e) ? /* @__PURE__ */ E.createElement(Jt, El({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function hJ(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, a = xt(n, Jt).map(function(i, s) {
    return /* @__PURE__ */ Je(i, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return a;
  var o = pJ(e.label, t);
  return [o].concat(nJ(a));
}
Jt.renderCallByParent = hJ;
function rs(e) {
  "@babel/helpers - typeof";
  return rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rs(e);
}
function sy() {
  return sy = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sy.apply(this, arguments);
}
function YO(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function XO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YO(Object(r), !0).forEach(function(n) {
      mJ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : YO(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mJ(e, t, r) {
  return t = vJ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vJ(e) {
  var t = yJ(e, "string");
  return rs(t) == "symbol" ? t : t + "";
}
function yJ(e, t) {
  if (rs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (rs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var gJ = function(t, r) {
  var n = yt(r - t), a = Math.min(Math.abs(r - t), 359.999);
  return n * a;
}, gc = function(t) {
  var r = t.cx, n = t.cy, a = t.radius, o = t.angle, i = t.sign, s = t.isExternal, c = t.cornerRadius, l = t.cornerIsExternal, u = c * (s ? 1 : -1) + a, f = Math.asin(c / u) / _l, d = l ? o : o + i * f, p = xe(r, n, u, d), g = xe(r, n, a, d), m = l ? o - i * f : o, y = xe(r, n, u * Math.cos(f * _l), m);
  return {
    center: p,
    circleTangency: g,
    lineTangency: y,
    theta: f
  };
}, RM = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, o = t.outerRadius, i = t.startAngle, s = t.endAngle, c = gJ(i, s), l = i + c, u = xe(r, n, o, i), f = xe(r, n, o, l), d = "M ".concat(u.x, ",").concat(u.y, `
    A `).concat(o, ",").concat(o, `,0,
    `).concat(+(Math.abs(c) > 180), ",").concat(+(i > l), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (a > 0) {
    var p = xe(r, n, a, i), g = xe(r, n, a, l);
    d += "L ".concat(g.x, ",").concat(g.y, `
            A `).concat(a, ",").concat(a, `,0,
            `).concat(+(Math.abs(c) > 180), ",").concat(+(i <= l), `,
            `).concat(p.x, ",").concat(p.y, " Z");
  } else
    d += "L ".concat(r, ",").concat(n, " Z");
  return d;
}, bJ = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, o = t.outerRadius, i = t.cornerRadius, s = t.forceCornerRadius, c = t.cornerIsExternal, l = t.startAngle, u = t.endAngle, f = yt(u - l), d = gc({
    cx: r,
    cy: n,
    radius: o,
    angle: l,
    sign: f,
    cornerRadius: i,
    cornerIsExternal: c
  }), p = d.circleTangency, g = d.lineTangency, m = d.theta, y = gc({
    cx: r,
    cy: n,
    radius: o,
    angle: u,
    sign: -f,
    cornerRadius: i,
    cornerIsExternal: c
  }), b = y.circleTangency, w = y.lineTangency, S = y.theta, P = c ? Math.abs(l - u) : Math.abs(l - u) - m - S;
  if (P < 0)
    return s ? "M ".concat(g.x, ",").concat(g.y, `
        a`).concat(i, ",").concat(i, ",0,0,1,").concat(i * 2, `,0
        a`).concat(i, ",").concat(i, ",0,0,1,").concat(-i * 2, `,0
      `) : RM({
      cx: r,
      cy: n,
      innerRadius: a,
      outerRadius: o,
      startAngle: l,
      endAngle: u
    });
  var x = "M ".concat(g.x, ",").concat(g.y, `
    A`).concat(i, ",").concat(i, ",0,0,").concat(+(f < 0), ",").concat(p.x, ",").concat(p.y, `
    A`).concat(o, ",").concat(o, ",0,").concat(+(P > 180), ",").concat(+(f < 0), ",").concat(b.x, ",").concat(b.y, `
    A`).concat(i, ",").concat(i, ",0,0,").concat(+(f < 0), ",").concat(w.x, ",").concat(w.y, `
  `);
  if (a > 0) {
    var O = gc({
      cx: r,
      cy: n,
      radius: a,
      angle: l,
      sign: f,
      isExternal: !0,
      cornerRadius: i,
      cornerIsExternal: c
    }), A = O.circleTangency, _ = O.lineTangency, N = O.theta, M = gc({
      cx: r,
      cy: n,
      radius: a,
      angle: u,
      sign: -f,
      isExternal: !0,
      cornerRadius: i,
      cornerIsExternal: c
    }), T = M.circleTangency, k = M.lineTangency, $ = M.theta, R = c ? Math.abs(l - u) : Math.abs(l - u) - N - $;
    if (R < 0 && i === 0)
      return "".concat(x, "L").concat(r, ",").concat(n, "Z");
    x += "L".concat(k.x, ",").concat(k.y, `
      A`).concat(i, ",").concat(i, ",0,0,").concat(+(f < 0), ",").concat(T.x, ",").concat(T.y, `
      A`).concat(a, ",").concat(a, ",0,").concat(+(R > 180), ",").concat(+(f > 0), ",").concat(A.x, ",").concat(A.y, `
      A`).concat(i, ",").concat(i, ",0,0,").concat(+(f < 0), ",").concat(_.x, ",").concat(_.y, "Z");
  } else
    x += "L".concat(r, ",").concat(n, "Z");
  return x;
}, xJ = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, $M = function(t) {
  var r = XO(XO({}, xJ), t), n = r.cx, a = r.cy, o = r.innerRadius, i = r.outerRadius, s = r.cornerRadius, c = r.forceCornerRadius, l = r.cornerIsExternal, u = r.startAngle, f = r.endAngle, d = r.className;
  if (i < o || u === f)
    return null;
  var p = ue("recharts-sector", d), g = i - o, m = gt(s, g, 0, !0), y;
  return m > 0 && Math.abs(u - f) < 360 ? y = bJ({
    cx: n,
    cy: a,
    innerRadius: o,
    outerRadius: i,
    cornerRadius: Math.min(m, g / 2),
    forceCornerRadius: c,
    cornerIsExternal: l,
    startAngle: u,
    endAngle: f
  }) : y = RM({
    cx: n,
    cy: a,
    innerRadius: o,
    outerRadius: i,
    startAngle: u,
    endAngle: f
  }), /* @__PURE__ */ E.createElement("path", sy({}, ae(r, !0), {
    className: p,
    d: y,
    role: "img"
  }));
};
function ns(e) {
  "@babel/helpers - typeof";
  return ns = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ns(e);
}
function cy() {
  return cy = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cy.apply(this, arguments);
}
function ZO(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function JO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ZO(Object(r), !0).forEach(function(n) {
      wJ(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ZO(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wJ(e, t, r) {
  return t = SJ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function SJ(e) {
  var t = OJ(e, "string");
  return ns(t) == "symbol" ? t : t + "";
}
function OJ(e, t) {
  if (ns(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ns(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var QO = {
  curveBasisClosed: VW,
  curveBasisOpen: UW,
  curveBasis: HW,
  curveBumpX: NW,
  curveBumpY: TW,
  curveLinearClosed: KW,
  curveLinear: Zu,
  curveMonotoneX: GW,
  curveMonotoneY: YW,
  curveNatural: XW,
  curveStep: ZW,
  curveStepAfter: QW,
  curveStepBefore: JW
}, bc = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, ii = function(t) {
  return t.x;
}, si = function(t) {
  return t.y;
}, PJ = function(t, r) {
  if (se(t))
    return t;
  var n = "curve".concat(Yu(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? QO["".concat(n).concat(r === "vertical" ? "Y" : "X")] : QO[n] || Zu;
}, AJ = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, a = t.points, o = a === void 0 ? [] : a, i = t.baseLine, s = t.layout, c = t.connectNulls, l = c === void 0 ? !1 : c, u = PJ(n, s), f = l ? o.filter(function(m) {
    return bc(m);
  }) : o, d;
  if (Array.isArray(i)) {
    var p = l ? i.filter(function(m) {
      return bc(m);
    }) : i, g = f.map(function(m, y) {
      return JO(JO({}, m), {}, {
        base: p[y]
      });
    });
    return s === "vertical" ? d = uc().y(si).x1(ii).x0(function(m) {
      return m.base.x;
    }) : d = uc().x(ii).y1(si).y0(function(m) {
      return m.base.y;
    }), d.defined(bc).curve(u), d(g);
  }
  return s === "vertical" && J(i) ? d = uc().y(si).x1(ii).x0(i) : J(i) ? d = uc().x(ii).y1(si).y0(i) : d = NN().x(ii).y(si), d.defined(bc).curve(u), d(f);
}, Pn = function(t) {
  var r = t.className, n = t.points, a = t.path, o = t.pathRef;
  if ((!n || !n.length) && !a)
    return null;
  var i = n && n.length ? AJ(t) : a;
  return /* @__PURE__ */ v.createElement("path", cy({}, ae(t, !1), el(t), {
    className: ue("recharts-curve", r),
    d: i,
    ref: o
  }));
}, xc = { exports: {} }, wc = { exports: {} }, Oe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eP;
function _J() {
  if (eP) return Oe;
  eP = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function S(x) {
    if (typeof x == "object" && x !== null) {
      var O = x.$$typeof;
      switch (O) {
        case t:
          switch (x = x.type, x) {
            case c:
            case l:
            case n:
            case o:
            case a:
            case f:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case u:
                case g:
                case p:
                case i:
                  return x;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function P(x) {
    return S(x) === l;
  }
  return Oe.AsyncMode = c, Oe.ConcurrentMode = l, Oe.ContextConsumer = s, Oe.ContextProvider = i, Oe.Element = t, Oe.ForwardRef = u, Oe.Fragment = n, Oe.Lazy = g, Oe.Memo = p, Oe.Portal = r, Oe.Profiler = o, Oe.StrictMode = a, Oe.Suspense = f, Oe.isAsyncMode = function(x) {
    return P(x) || S(x) === c;
  }, Oe.isConcurrentMode = P, Oe.isContextConsumer = function(x) {
    return S(x) === s;
  }, Oe.isContextProvider = function(x) {
    return S(x) === i;
  }, Oe.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, Oe.isForwardRef = function(x) {
    return S(x) === u;
  }, Oe.isFragment = function(x) {
    return S(x) === n;
  }, Oe.isLazy = function(x) {
    return S(x) === g;
  }, Oe.isMemo = function(x) {
    return S(x) === p;
  }, Oe.isPortal = function(x) {
    return S(x) === r;
  }, Oe.isProfiler = function(x) {
    return S(x) === o;
  }, Oe.isStrictMode = function(x) {
    return S(x) === a;
  }, Oe.isSuspense = function(x) {
    return S(x) === f;
  }, Oe.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === n || x === l || x === o || x === a || x === f || x === d || typeof x == "object" && x !== null && (x.$$typeof === g || x.$$typeof === p || x.$$typeof === i || x.$$typeof === s || x.$$typeof === u || x.$$typeof === y || x.$$typeof === b || x.$$typeof === w || x.$$typeof === m);
  }, Oe.typeOf = S, Oe;
}
var Pe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tP;
function EJ() {
  return tP || (tP = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function S(D) {
      return typeof D == "string" || typeof D == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      D === n || D === l || D === o || D === a || D === f || D === d || typeof D == "object" && D !== null && (D.$$typeof === g || D.$$typeof === p || D.$$typeof === i || D.$$typeof === s || D.$$typeof === u || D.$$typeof === y || D.$$typeof === b || D.$$typeof === w || D.$$typeof === m);
    }
    function P(D) {
      if (typeof D == "object" && D !== null) {
        var le = D.$$typeof;
        switch (le) {
          case t:
            var Z = D.type;
            switch (Z) {
              case c:
              case l:
              case n:
              case o:
              case a:
              case f:
                return Z;
              default:
                var ve = Z && Z.$$typeof;
                switch (ve) {
                  case s:
                  case u:
                  case g:
                  case p:
                  case i:
                    return ve;
                  default:
                    return le;
                }
            }
          case r:
            return le;
        }
      }
    }
    var x = c, O = l, A = s, _ = i, N = t, M = u, T = n, k = g, $ = p, R = r, L = o, j = a, z = f, q = !1;
    function I(D) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(D) || P(D) === c;
    }
    function B(D) {
      return P(D) === l;
    }
    function W(D) {
      return P(D) === s;
    }
    function H(D) {
      return P(D) === i;
    }
    function U(D) {
      return typeof D == "object" && D !== null && D.$$typeof === t;
    }
    function X(D) {
      return P(D) === u;
    }
    function ee(D) {
      return P(D) === n;
    }
    function ne(D) {
      return P(D) === g;
    }
    function G(D) {
      return P(D) === p;
    }
    function te(D) {
      return P(D) === r;
    }
    function V(D) {
      return P(D) === o;
    }
    function Y(D) {
      return P(D) === a;
    }
    function Q(D) {
      return P(D) === f;
    }
    Pe.AsyncMode = x, Pe.ConcurrentMode = O, Pe.ContextConsumer = A, Pe.ContextProvider = _, Pe.Element = N, Pe.ForwardRef = M, Pe.Fragment = T, Pe.Lazy = k, Pe.Memo = $, Pe.Portal = R, Pe.Profiler = L, Pe.StrictMode = j, Pe.Suspense = z, Pe.isAsyncMode = I, Pe.isConcurrentMode = B, Pe.isContextConsumer = W, Pe.isContextProvider = H, Pe.isElement = U, Pe.isForwardRef = X, Pe.isFragment = ee, Pe.isLazy = ne, Pe.isMemo = G, Pe.isPortal = te, Pe.isProfiler = V, Pe.isStrictMode = Y, Pe.isSuspense = Q, Pe.isValidElementType = S, Pe.typeOf = P;
  })()), Pe;
}
var rP;
function IM() {
  return rP || (rP = 1, process.env.NODE_ENV === "production" ? wc.exports = _J() : wc.exports = EJ()), wc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ym, nP;
function CJ() {
  if (nP) return ym;
  nP = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ym = a() ? Object.assign : function(o, i) {
    for (var s, c = n(o), l, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var f in s)
        t.call(s, f) && (c[f] = s[f]);
      if (e) {
        l = e(s);
        for (var d = 0; d < l.length; d++)
          r.call(s, l[d]) && (c[l[d]] = s[l[d]]);
      }
    }
    return c;
  }, ym;
}
var gm, aP;
function M0() {
  if (aP) return gm;
  aP = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return gm = e, gm;
}
var bm, oP;
function DM() {
  return oP || (oP = 1, bm = Function.call.bind(Object.prototype.hasOwnProperty)), bm;
}
var xm, iP;
function kJ() {
  if (iP) return xm;
  iP = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ M0(), r = {}, n = /* @__PURE__ */ DM();
    e = function(o) {
      var i = "Warning: " + o;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function a(o, i, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (n(o, u)) {
          var f;
          try {
            if (typeof o[u] != "function") {
              var d = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[u](i, u, c, s, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, xm = a, xm;
}
var wm, sP;
function NJ() {
  if (sP) return wm;
  sP = 1;
  var e = IM(), t = CJ(), r = /* @__PURE__ */ M0(), n = /* @__PURE__ */ DM(), a = /* @__PURE__ */ kJ(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return wm = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(B) {
      var W = B && (l && B[l] || B[u]);
      if (typeof W == "function")
        return W;
    }
    var d = "<<anonymous>>", p = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: w(),
      arrayOf: S,
      element: P(),
      elementType: x(),
      instanceOf: O,
      node: M(),
      objectOf: _,
      oneOf: A,
      oneOfType: N,
      shape: k,
      exact: $
    };
    function g(B, W) {
      return B === W ? B !== 0 || 1 / B === 1 / W : B !== B && W !== W;
    }
    function m(B, W) {
      this.message = B, this.data = W && typeof W == "object" ? W : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function y(B) {
      if (process.env.NODE_ENV !== "production")
        var W = {}, H = 0;
      function U(ee, ne, G, te, V, Y, Q) {
        if (te = te || d, Y = Y || G, Q !== r) {
          if (c) {
            var D = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw D.name = "Invariant Violation", D;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var le = te + ":" + G;
            !W[le] && // Avoid spamming the console because they are often not actionable except for lib authors
            H < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + te + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), W[le] = !0, H++);
          }
        }
        return ne[G] == null ? ee ? ne[G] === null ? new m("The " + V + " `" + Y + "` is marked as required " + ("in `" + te + "`, but its value is `null`.")) : new m("The " + V + " `" + Y + "` is marked as required in " + ("`" + te + "`, but its value is `undefined`.")) : null : B(ne, G, te, V, Y);
      }
      var X = U.bind(null, !1);
      return X.isRequired = U.bind(null, !0), X;
    }
    function b(B) {
      function W(H, U, X, ee, ne, G) {
        var te = H[U], V = j(te);
        if (V !== B) {
          var Y = z(te);
          return new m(
            "Invalid " + ee + " `" + ne + "` of type " + ("`" + Y + "` supplied to `" + X + "`, expected ") + ("`" + B + "`."),
            { expectedType: B }
          );
        }
        return null;
      }
      return y(W);
    }
    function w() {
      return y(i);
    }
    function S(B) {
      function W(H, U, X, ee, ne) {
        if (typeof B != "function")
          return new m("Property `" + ne + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var G = H[U];
        if (!Array.isArray(G)) {
          var te = j(G);
          return new m("Invalid " + ee + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + X + "`, expected an array."));
        }
        for (var V = 0; V < G.length; V++) {
          var Y = B(G, V, X, ee, ne + "[" + V + "]", r);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return y(W);
    }
    function P() {
      function B(W, H, U, X, ee) {
        var ne = W[H];
        if (!s(ne)) {
          var G = j(ne);
          return new m("Invalid " + X + " `" + ee + "` of type " + ("`" + G + "` supplied to `" + U + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(B);
    }
    function x() {
      function B(W, H, U, X, ee) {
        var ne = W[H];
        if (!e.isValidElementType(ne)) {
          var G = j(ne);
          return new m("Invalid " + X + " `" + ee + "` of type " + ("`" + G + "` supplied to `" + U + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(B);
    }
    function O(B) {
      function W(H, U, X, ee, ne) {
        if (!(H[U] instanceof B)) {
          var G = B.name || d, te = I(H[U]);
          return new m("Invalid " + ee + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + X + "`, expected ") + ("instance of `" + G + "`."));
        }
        return null;
      }
      return y(W);
    }
    function A(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), i;
      function W(H, U, X, ee, ne) {
        for (var G = H[U], te = 0; te < B.length; te++)
          if (g(G, B[te]))
            return null;
        var V = JSON.stringify(B, function(Q, D) {
          var le = z(D);
          return le === "symbol" ? String(D) : D;
        });
        return new m("Invalid " + ee + " `" + ne + "` of value `" + String(G) + "` " + ("supplied to `" + X + "`, expected one of " + V + "."));
      }
      return y(W);
    }
    function _(B) {
      function W(H, U, X, ee, ne) {
        if (typeof B != "function")
          return new m("Property `" + ne + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var G = H[U], te = j(G);
        if (te !== "object")
          return new m("Invalid " + ee + " `" + ne + "` of type " + ("`" + te + "` supplied to `" + X + "`, expected an object."));
        for (var V in G)
          if (n(G, V)) {
            var Y = B(G, V, X, ee, ne + "." + V, r);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return y(W);
    }
    function N(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var W = 0; W < B.length; W++) {
        var H = B[W];
        if (typeof H != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(H) + " at index " + W + "."
          ), i;
      }
      function U(X, ee, ne, G, te) {
        for (var V = [], Y = 0; Y < B.length; Y++) {
          var Q = B[Y], D = Q(X, ee, ne, G, te, r);
          if (D == null)
            return null;
          D.data && n(D.data, "expectedType") && V.push(D.data.expectedType);
        }
        var le = V.length > 0 ? ", expected one of type [" + V.join(", ") + "]" : "";
        return new m("Invalid " + G + " `" + te + "` supplied to " + ("`" + ne + "`" + le + "."));
      }
      return y(U);
    }
    function M() {
      function B(W, H, U, X, ee) {
        return R(W[H]) ? null : new m("Invalid " + X + " `" + ee + "` supplied to " + ("`" + U + "`, expected a ReactNode."));
      }
      return y(B);
    }
    function T(B, W, H, U, X) {
      return new m(
        (B || "React class") + ": " + W + " type `" + H + "." + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function k(B) {
      function W(H, U, X, ee, ne) {
        var G = H[U], te = j(G);
        if (te !== "object")
          return new m("Invalid " + ee + " `" + ne + "` of type `" + te + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var V in B) {
          var Y = B[V];
          if (typeof Y != "function")
            return T(X, ee, ne, V, z(Y));
          var Q = Y(G, V, X, ee, ne + "." + V, r);
          if (Q)
            return Q;
        }
        return null;
      }
      return y(W);
    }
    function $(B) {
      function W(H, U, X, ee, ne) {
        var G = H[U], te = j(G);
        if (te !== "object")
          return new m("Invalid " + ee + " `" + ne + "` of type `" + te + "` " + ("supplied to `" + X + "`, expected `object`."));
        var V = t({}, H[U], B);
        for (var Y in V) {
          var Q = B[Y];
          if (n(B, Y) && typeof Q != "function")
            return T(X, ee, ne, Y, z(Q));
          if (!Q)
            return new m(
              "Invalid " + ee + " `" + ne + "` key `" + Y + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(H[U], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
            );
          var D = Q(G, Y, X, ee, ne + "." + Y, r);
          if (D)
            return D;
        }
        return null;
      }
      return y(W);
    }
    function R(B) {
      switch (typeof B) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !B;
        case "object":
          if (Array.isArray(B))
            return B.every(R);
          if (B === null || s(B))
            return !0;
          var W = f(B);
          if (W) {
            var H = W.call(B), U;
            if (W !== B.entries) {
              for (; !(U = H.next()).done; )
                if (!R(U.value))
                  return !1;
            } else
              for (; !(U = H.next()).done; ) {
                var X = U.value;
                if (X && !R(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L(B, W) {
      return B === "symbol" ? !0 : W ? W["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && W instanceof Symbol : !1;
    }
    function j(B) {
      var W = typeof B;
      return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : L(W, B) ? "symbol" : W;
    }
    function z(B) {
      if (typeof B > "u" || B === null)
        return "" + B;
      var W = j(B);
      if (W === "object") {
        if (B instanceof Date)
          return "date";
        if (B instanceof RegExp)
          return "regexp";
      }
      return W;
    }
    function q(B) {
      var W = z(B);
      switch (W) {
        case "array":
        case "object":
          return "an " + W;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + W;
        default:
          return W;
      }
    }
    function I(B) {
      return !B.constructor || !B.constructor.name ? d : B.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, wm;
}
var Sm, cP;
function TJ() {
  if (cP) return Sm;
  cP = 1;
  var e = /* @__PURE__ */ M0();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Sm = function() {
    function n(i, s, c, l, u, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Sm;
}
var lP;
function MJ() {
  if (lP) return xc.exports;
  if (lP = 1, process.env.NODE_ENV !== "production") {
    var e = IM(), t = !0;
    xc.exports = /* @__PURE__ */ NJ()(e.isElement, t);
  } else
    xc.exports = /* @__PURE__ */ TJ()();
  return xc.exports;
}
var RJ = /* @__PURE__ */ MJ();
const Ae = /* @__PURE__ */ _e(RJ), { getOwnPropertyNames: $J, getOwnPropertySymbols: IJ } = Object, { hasOwnProperty: DJ } = Object.prototype;
function Om(e, t) {
  return function(n, a, o) {
    return e(n, a, o) && t(n, a, o);
  };
}
function Sc(e) {
  return function(r, n, a) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, a);
    const { cache: o } = a, i = o.get(r), s = o.get(n);
    if (i && s)
      return i === n && s === r;
    o.set(r, n), o.set(n, r);
    const c = e(r, n, a);
    return o.delete(r), o.delete(n), c;
  };
}
function jJ(e) {
  return e != null ? e[Symbol.toStringTag] : void 0;
}
function uP(e) {
  return $J(e).concat(IJ(e));
}
const LJ = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((e, t) => DJ.call(e, t))
);
function ba(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
const BJ = "__v", FJ = "__o", zJ = "_owner", { getOwnPropertyDescriptor: fP, keys: dP } = Object;
function qJ(e, t) {
  return e.byteLength === t.byteLength && Cl(new Uint8Array(e), new Uint8Array(t));
}
function WJ(e, t, r) {
  let n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function HJ(e, t) {
  return e.byteLength === t.byteLength && Cl(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
}
function VJ(e, t) {
  return ba(e.getTime(), t.getTime());
}
function UJ(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function KJ(e, t) {
  return e === t;
}
function pP(e, t, r) {
  const n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  const a = new Array(n), o = e.entries();
  let i, s, c = 0;
  for (; (i = o.next()) && !i.done; ) {
    const l = t.entries();
    let u = !1, f = 0;
    for (; (s = l.next()) && !s.done; ) {
      if (a[f]) {
        f++;
        continue;
      }
      const d = i.value, p = s.value;
      if (r.equals(d[0], p[0], c, f, e, t, r) && r.equals(d[1], p[1], d[0], p[0], e, t, r)) {
        u = a[f] = !0;
        break;
      }
      f++;
    }
    if (!u)
      return !1;
    c++;
  }
  return !0;
}
const GJ = ba;
function YJ(e, t, r) {
  const n = dP(e);
  let a = n.length;
  if (dP(t).length !== a)
    return !1;
  for (; a-- > 0; )
    if (!jM(e, t, r, n[a]))
      return !1;
  return !0;
}
function ci(e, t, r) {
  const n = uP(e);
  let a = n.length;
  if (uP(t).length !== a)
    return !1;
  let o, i, s;
  for (; a-- > 0; )
    if (o = n[a], !jM(e, t, r, o) || (i = fP(e, o), s = fP(t, o), (i || s) && (!i || !s || i.configurable !== s.configurable || i.enumerable !== s.enumerable || i.writable !== s.writable)))
      return !1;
  return !0;
}
function XJ(e, t) {
  return ba(e.valueOf(), t.valueOf());
}
function ZJ(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function hP(e, t, r) {
  const n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  const a = new Array(n), o = e.values();
  let i, s;
  for (; (i = o.next()) && !i.done; ) {
    const c = t.values();
    let l = !1, u = 0;
    for (; (s = c.next()) && !s.done; ) {
      if (!a[u] && r.equals(i.value, s.value, i.value, s.value, e, t, r)) {
        l = a[u] = !0;
        break;
      }
      u++;
    }
    if (!l)
      return !1;
  }
  return !0;
}
function Cl(e, t) {
  let r = e.byteLength;
  if (t.byteLength !== r || e.byteOffset !== t.byteOffset)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function JJ(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function jM(e, t, r, n) {
  return (n === zJ || n === FJ || n === BJ) && (e.$$typeof || t.$$typeof) ? !0 : LJ(t, n) && r.equals(e[n], t[n], n, n, e, t, r);
}
const QJ = "[object ArrayBuffer]", eQ = "[object Arguments]", tQ = "[object Boolean]", rQ = "[object DataView]", nQ = "[object Date]", aQ = "[object Error]", oQ = "[object Map]", iQ = "[object Number]", sQ = "[object Object]", cQ = "[object RegExp]", lQ = "[object Set]", uQ = "[object String]", fQ = {
  "[object Int8Array]": !0,
  "[object Uint8Array]": !0,
  "[object Uint8ClampedArray]": !0,
  "[object Int16Array]": !0,
  "[object Uint16Array]": !0,
  "[object Int32Array]": !0,
  "[object Uint32Array]": !0,
  "[object Float16Array]": !0,
  "[object Float32Array]": !0,
  "[object Float64Array]": !0,
  "[object BigInt64Array]": !0,
  "[object BigUint64Array]": !0
}, dQ = "[object URL]", pQ = Object.prototype.toString;
function hQ({ areArrayBuffersEqual: e, areArraysEqual: t, areDataViewsEqual: r, areDatesEqual: n, areErrorsEqual: a, areFunctionsEqual: o, areMapsEqual: i, areNumbersEqual: s, areObjectsEqual: c, arePrimitiveWrappersEqual: l, areRegExpsEqual: u, areSetsEqual: f, areTypedArraysEqual: d, areUrlsEqual: p, unknownTagComparators: g }) {
  return function(y, b, w) {
    if (y === b)
      return !0;
    if (y == null || b == null)
      return !1;
    const S = typeof y;
    if (S !== typeof b)
      return !1;
    if (S !== "object")
      return S === "number" ? s(y, b, w) : S === "function" ? o(y, b, w) : !1;
    const P = y.constructor;
    if (P !== b.constructor)
      return !1;
    if (P === Object)
      return c(y, b, w);
    if (Array.isArray(y))
      return t(y, b, w);
    if (P === Date)
      return n(y, b, w);
    if (P === RegExp)
      return u(y, b, w);
    if (P === Map)
      return i(y, b, w);
    if (P === Set)
      return f(y, b, w);
    const x = pQ.call(y);
    if (x === nQ)
      return n(y, b, w);
    if (x === cQ)
      return u(y, b, w);
    if (x === oQ)
      return i(y, b, w);
    if (x === lQ)
      return f(y, b, w);
    if (x === sQ)
      return typeof y.then != "function" && typeof b.then != "function" && c(y, b, w);
    if (x === dQ)
      return p(y, b, w);
    if (x === aQ)
      return a(y, b, w);
    if (x === eQ)
      return c(y, b, w);
    if (fQ[x])
      return d(y, b, w);
    if (x === QJ)
      return e(y, b, w);
    if (x === rQ)
      return r(y, b, w);
    if (x === tQ || x === iQ || x === uQ)
      return l(y, b, w);
    if (g) {
      let O = g[x];
      if (!O) {
        const A = jJ(y);
        A && (O = g[A]);
      }
      if (O)
        return O(y, b, w);
    }
    return !1;
  };
}
function mQ({ circular: e, createCustomConfig: t, strict: r }) {
  let n = {
    areArrayBuffersEqual: qJ,
    areArraysEqual: r ? ci : WJ,
    areDataViewsEqual: HJ,
    areDatesEqual: VJ,
    areErrorsEqual: UJ,
    areFunctionsEqual: KJ,
    areMapsEqual: r ? Om(pP, ci) : pP,
    areNumbersEqual: GJ,
    areObjectsEqual: r ? ci : YJ,
    arePrimitiveWrappersEqual: XJ,
    areRegExpsEqual: ZJ,
    areSetsEqual: r ? Om(hP, ci) : hP,
    areTypedArraysEqual: r ? Om(Cl, ci) : Cl,
    areUrlsEqual: JJ,
    unknownTagComparators: void 0
  };
  if (t && (n = Object.assign({}, n, t(n))), e) {
    const a = Sc(n.areArraysEqual), o = Sc(n.areMapsEqual), i = Sc(n.areObjectsEqual), s = Sc(n.areSetsEqual);
    n = Object.assign({}, n, {
      areArraysEqual: a,
      areMapsEqual: o,
      areObjectsEqual: i,
      areSetsEqual: s
    });
  }
  return n;
}
function vQ(e) {
  return function(t, r, n, a, o, i, s) {
    return e(t, r, s);
  };
}
function yQ({ circular: e, comparator: t, createState: r, equals: n, strict: a }) {
  if (r)
    return function(s, c) {
      const { cache: l = e ? /* @__PURE__ */ new WeakMap() : void 0, meta: u } = r();
      return t(s, c, {
        cache: l,
        equals: n,
        meta: u,
        strict: a
      });
    };
  if (e)
    return function(s, c) {
      return t(s, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: n,
        meta: void 0,
        strict: a
      });
    };
  const o = {
    cache: void 0,
    equals: n,
    meta: void 0,
    strict: a
  };
  return function(s, c) {
    return t(s, c, o);
  };
}
const gQ = Ln();
Ln({ strict: !0 });
Ln({ circular: !0 });
Ln({
  circular: !0,
  strict: !0
});
Ln({
  createInternalComparator: () => ba
});
Ln({
  strict: !0,
  createInternalComparator: () => ba
});
Ln({
  circular: !0,
  createInternalComparator: () => ba
});
Ln({
  circular: !0,
  createInternalComparator: () => ba,
  strict: !0
});
function Ln(e = {}) {
  const { circular: t = !1, createInternalComparator: r, createState: n, strict: a = !1 } = e, o = mQ(e), i = hQ(o), s = r ? r(i) : vQ(i);
  return yQ({ circular: t, comparator: i, createState: n, equals: s, strict: a });
}
function bQ(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function mP(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function a(o) {
    r < 0 && (r = o), o - r > t ? (e(o), r = -1) : bQ(a);
  };
  requestAnimationFrame(n);
}
function ly(e) {
  "@babel/helpers - typeof";
  return ly = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ly(e);
}
function xQ(e) {
  return PQ(e) || OQ(e) || SQ(e) || wQ();
}
function wQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SQ(e, t) {
  if (e) {
    if (typeof e == "string") return vP(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return vP(e, t);
  }
}
function vP(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function OQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function PQ(e) {
  if (Array.isArray(e)) return e;
}
function AQ() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function a(o) {
    if (!r) {
      if (Array.isArray(o)) {
        if (!o.length)
          return;
        var i = o, s = xQ(i), c = s[0], l = s.slice(1);
        if (typeof c == "number") {
          mP(a.bind(null, l), c);
          return;
        }
        a(c), mP(a.bind(null, l));
        return;
      }
      ly(o) === "object" && (e = o, t(e)), typeof o == "function" && o();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(o) {
      r = !1, n(o);
    },
    subscribe: function(o) {
      return t = o, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function as(e) {
  "@babel/helpers - typeof";
  return as = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, as(e);
}
function yP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gP(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yP(Object(r), !0).forEach(function(n) {
      LM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function LM(e, t, r) {
  return t = _Q(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _Q(e) {
  var t = EQ(e, "string");
  return as(t) === "symbol" ? t : String(t);
}
function EQ(e, t) {
  if (as(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (as(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var CQ = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, a) {
    return n.filter(function(o) {
      return a.includes(o);
    });
  });
}, kQ = function(t) {
  return t;
}, NQ = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, xi = function(t, r) {
  return Object.keys(r).reduce(function(n, a) {
    return gP(gP({}, n), {}, LM({}, a, t(a, r[a])));
  }, {});
}, bP = function(t, r, n) {
  return t.map(function(a) {
    return "".concat(NQ(a), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, TQ = process.env.NODE_ENV !== "production", kl = function(t, r, n, a, o, i, s, c) {
  if (TQ && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var l = [n, a, o, i, s, c], u = 0;
      console.warn(r.replace(/%s/g, function() {
        return l[u++];
      }));
    }
};
function MQ(e, t) {
  return IQ(e) || $Q(e, t) || BM(e, t) || RQ();
}
function RQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $Q(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function IQ(e) {
  if (Array.isArray(e)) return e;
}
function DQ(e) {
  return BQ(e) || LQ(e) || BM(e) || jQ();
}
function jQ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BM(e, t) {
  if (e) {
    if (typeof e == "string") return uy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return uy(e, t);
  }
}
function LQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function BQ(e) {
  if (Array.isArray(e)) return uy(e);
}
function uy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Nl = 1e-4, FM = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, zM = function(t, r) {
  return t.map(function(n, a) {
    return n * Math.pow(r, a);
  }).reduce(function(n, a) {
    return n + a;
  });
}, xP = function(t, r) {
  return function(n) {
    var a = FM(t, r);
    return zM(a, n);
  };
}, FQ = function(t, r) {
  return function(n) {
    var a = FM(t, r), o = [].concat(DQ(a.map(function(i, s) {
      return i * s;
    }).slice(1)), [0]);
    return zM(o, n);
  };
}, wP = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0], o = r[1], i = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        a = 0, o = 0, i = 1, s = 1;
        break;
      case "ease":
        a = 0.25, o = 0.1, i = 0.25, s = 1;
        break;
      case "ease-in":
        a = 0.42, o = 0, i = 1, s = 1;
        break;
      case "ease-out":
        a = 0.42, o = 0, i = 0.58, s = 1;
        break;
      case "ease-in-out":
        a = 0, o = 0, i = 0.58, s = 1;
        break;
      default: {
        var c = r[0].split("(");
        if (c[0] === "cubic-bezier" && c[1].split(")")[0].split(",").length === 4) {
          var l = c[1].split(")")[0].split(",").map(function(y) {
            return parseFloat(y);
          }), u = MQ(l, 4);
          a = u[0], o = u[1], i = u[2], s = u[3];
        } else
          kl(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  kl([a, i, o, s].every(function(y) {
    return typeof y == "number" && y >= 0 && y <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var f = xP(a, i), d = xP(o, s), p = FQ(a, i), g = function(b) {
    return b > 1 ? 1 : b < 0 ? 0 : b;
  }, m = function(b) {
    for (var w = b > 1 ? 1 : b, S = w, P = 0; P < 8; ++P) {
      var x = f(S) - w, O = p(S);
      if (Math.abs(x - w) < Nl || O < Nl)
        return d(S);
      S = g(S - x / O);
    }
    return d(S);
  };
  return m.isStepper = !1, m;
}, zQ = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, a = t.damping, o = a === void 0 ? 8 : a, i = t.dt, s = i === void 0 ? 17 : i, c = function(u, f, d) {
    var p = -(u - f) * n, g = d * o, m = d + (p - g) * s / 1e3, y = d * s / 1e3 + u;
    return Math.abs(y - f) < Nl && Math.abs(m) < Nl ? [f, 0] : [y, m];
  };
  return c.isStepper = !0, c.dt = s, c;
}, qQ = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var a = r[0];
  if (typeof a == "string")
    switch (a) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return wP(a);
      case "spring":
        return zQ();
      default:
        if (a.split("(")[0] === "cubic-bezier")
          return wP(a);
        kl(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof a == "function" ? a : (kl(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function os(e) {
  "@babel/helpers - typeof";
  return os = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, os(e);
}
function SP(e) {
  return VQ(e) || HQ(e) || qM(e) || WQ();
}
function WQ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function HQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function VQ(e) {
  if (Array.isArray(e)) return dy(e);
}
function OP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function st(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? OP(Object(r), !0).forEach(function(n) {
      fy(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : OP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fy(e, t, r) {
  return t = UQ(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function UQ(e) {
  var t = KQ(e, "string");
  return os(t) === "symbol" ? t : String(t);
}
function KQ(e, t) {
  if (os(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (os(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function GQ(e, t) {
  return ZQ(e) || XQ(e, t) || qM(e, t) || YQ();
}
function YQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qM(e, t) {
  if (e) {
    if (typeof e == "string") return dy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dy(e, t);
  }
}
function dy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function XQ(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function ZQ(e) {
  if (Array.isArray(e)) return e;
}
var Tl = function(t, r, n) {
  return t + (r - t) * n;
}, py = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, JQ = function e(t, r, n) {
  var a = xi(function(o, i) {
    if (py(i)) {
      var s = t(i.from, i.to, i.velocity), c = GQ(s, 2), l = c[0], u = c[1];
      return st(st({}, i), {}, {
        from: l,
        velocity: u
      });
    }
    return i;
  }, r);
  return n < 1 ? xi(function(o, i) {
    return py(i) ? st(st({}, i), {}, {
      velocity: Tl(i.velocity, a[o].velocity, n),
      from: Tl(i.from, a[o].from, n)
    }) : i;
  }, r) : e(t, a, n - 1);
};
const QQ = (function(e, t, r, n, a) {
  var o = CQ(e, t), i = o.reduce(function(y, b) {
    return st(st({}, y), {}, fy({}, b, [e[b], t[b]]));
  }, {}), s = o.reduce(function(y, b) {
    return st(st({}, y), {}, fy({}, b, {
      from: e[b],
      velocity: 0,
      to: t[b]
    }));
  }, {}), c = -1, l, u, f = function() {
    return null;
  }, d = function() {
    return xi(function(b, w) {
      return w.from;
    }, s);
  }, p = function() {
    return !Object.values(s).filter(py).length;
  }, g = function(b) {
    l || (l = b);
    var w = b - l, S = w / r.dt;
    s = JQ(r, s, S), a(st(st(st({}, e), t), d())), l = b, p() || (c = requestAnimationFrame(f));
  }, m = function(b) {
    u || (u = b);
    var w = (b - u) / n, S = xi(function(x, O) {
      return Tl.apply(void 0, SP(O).concat([r(w)]));
    }, i);
    if (a(st(st(st({}, e), t), S)), w < 1)
      c = requestAnimationFrame(f);
    else {
      var P = xi(function(x, O) {
        return Tl.apply(void 0, SP(O).concat([r(1)]));
      }, i);
      a(st(st(st({}, e), t), P));
    }
  };
  return f = r.isStepper ? g : m, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(c);
    };
  };
});
function oo(e) {
  "@babel/helpers - typeof";
  return oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oo(e);
}
var eee = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function tee(e, t) {
  if (e == null) return {};
  var r = ree(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function ree(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Pm(e) {
  return iee(e) || oee(e) || aee(e) || nee();
}
function nee() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aee(e, t) {
  if (e) {
    if (typeof e == "string") return hy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return hy(e, t);
  }
}
function oee(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function iee(e) {
  if (Array.isArray(e)) return hy(e);
}
function hy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function PP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function cr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? PP(Object(r), !0).forEach(function(n) {
      mi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : PP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mi(e, t, r) {
  return t = WM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function see(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function cee(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WM(n.key), n);
  }
}
function lee(e, t, r) {
  return t && cee(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function WM(e) {
  var t = uee(e, "string");
  return oo(t) === "symbol" ? t : String(t);
}
function uee(e, t) {
  if (oo(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (oo(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fee(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && my(e, t);
}
function my(e, t) {
  return my = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, my(e, t);
}
function dee(e) {
  var t = pee();
  return function() {
    var n = Ml(e), a;
    if (t) {
      var o = Ml(this).constructor;
      a = Reflect.construct(n, arguments, o);
    } else
      a = n.apply(this, arguments);
    return vy(this, a);
  };
}
function vy(e, t) {
  if (t && (oo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yy(e);
}
function yy(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pee() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ml(e) {
  return Ml = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ml(e);
}
var Ft = /* @__PURE__ */ (function(e) {
  fee(r, e);
  var t = dee(r);
  function r(n, a) {
    var o;
    see(this, r), o = t.call(this, n, a);
    var i = o.props, s = i.isActive, c = i.attributeName, l = i.from, u = i.to, f = i.steps, d = i.children, p = i.duration;
    if (o.handleStyleChange = o.handleStyleChange.bind(yy(o)), o.changeStyle = o.changeStyle.bind(yy(o)), !s || p <= 0)
      return o.state = {
        style: {}
      }, typeof d == "function" && (o.state = {
        style: u
      }), vy(o);
    if (f && f.length)
      o.state = {
        style: f[0].style
      };
    else if (l) {
      if (typeof d == "function")
        return o.state = {
          style: l
        }, vy(o);
      o.state = {
        style: c ? mi({}, c, l) : l
      };
    } else
      o.state = {
        style: {}
      };
    return o;
  }
  return lee(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, o = a.isActive, i = a.canBegin;
      this.mounted = !0, !(!o || !i) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var o = this.props, i = o.isActive, s = o.canBegin, c = o.attributeName, l = o.shouldReAnimate, u = o.to, f = o.from, d = this.state.style;
      if (s) {
        if (!i) {
          var p = {
            style: c ? mi({}, c, u) : u
          };
          this.state && d && (c && d[c] !== u || !c && d !== u) && this.setState(p);
          return;
        }
        if (!(gQ(a.to, u) && a.canBegin && a.isActive)) {
          var g = !a.canBegin || !a.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var m = g || l ? f : a.to;
          if (this.state && d) {
            var y = {
              style: c ? mi({}, c, m) : m
            };
            (c && d[c] !== m || !c && d !== m) && this.setState(y);
          }
          this.runAnimation(cr(cr({}, this.props), {}, {
            from: m,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var a = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), a && a();
    }
  }, {
    key: "handleStyleChange",
    value: function(a) {
      this.changeStyle(a);
    }
  }, {
    key: "changeStyle",
    value: function(a) {
      this.mounted && this.setState({
        style: a
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(a) {
      var o = this, i = a.from, s = a.to, c = a.duration, l = a.easing, u = a.begin, f = a.onAnimationEnd, d = a.onAnimationStart, p = QQ(i, s, qQ(l), c, this.changeStyle), g = function() {
        o.stopJSAnimation = p();
      };
      this.manager.start([d, u, g, c, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(a) {
      var o = this, i = a.steps, s = a.begin, c = a.onAnimationStart, l = i[0], u = l.style, f = l.duration, d = f === void 0 ? 0 : f, p = function(m, y, b) {
        if (b === 0)
          return m;
        var w = y.duration, S = y.easing, P = S === void 0 ? "ease" : S, x = y.style, O = y.properties, A = y.onAnimationEnd, _ = b > 0 ? i[b - 1] : y, N = O || Object.keys(x);
        if (typeof P == "function" || P === "spring")
          return [].concat(Pm(m), [o.runJSAnimation.bind(o, {
            from: _.style,
            to: x,
            duration: w,
            easing: P
          }), w]);
        var M = bP(N, w, P), T = cr(cr(cr({}, _.style), x), {}, {
          transition: M
        });
        return [].concat(Pm(m), [T, w, A]).filter(kQ);
      };
      return this.manager.start([c].concat(Pm(i.reduce(p, [u, Math.max(d, s)])), [a.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(a) {
      this.manager || (this.manager = AQ());
      var o = a.begin, i = a.duration, s = a.attributeName, c = a.to, l = a.easing, u = a.onAnimationStart, f = a.onAnimationEnd, d = a.steps, p = a.children, g = this.manager;
      if (this.unSubscribe = g.subscribe(this.handleStyleChange), typeof l == "function" || typeof p == "function" || l === "spring") {
        this.runJSAnimation(a);
        return;
      }
      if (d.length > 1) {
        this.runStepAnimation(a);
        return;
      }
      var m = s ? mi({}, s, c) : c, y = bP(Object.keys(m), i, l);
      g.start([u, o, cr(cr({}, m), {}, {
        transition: y
      }), i, f]);
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, o = a.children;
      a.begin;
      var i = a.duration;
      a.attributeName, a.easing;
      var s = a.isActive;
      a.steps, a.from, a.to, a.canBegin, a.onAnimationEnd, a.shouldReAnimate, a.onAnimationReStart;
      var c = tee(a, eee), l = ta.count(o), u = this.state.style;
      if (typeof o == "function")
        return o(u);
      if (!s || l === 0 || i <= 0)
        return o;
      var f = function(p) {
        var g = p.props, m = g.style, y = m === void 0 ? {} : m, b = g.className, w = /* @__PURE__ */ Je(p, cr(cr({}, c), {}, {
          style: cr(cr({}, y), u),
          className: b
        }));
        return w;
      };
      return l === 1 ? f(ta.only(o)) : /* @__PURE__ */ E.createElement("div", null, ta.map(o, function(d) {
        return f(d);
      }));
    }
  }]), r;
})(St);
Ft.displayName = "Animate";
Ft.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Ft.propTypes = {
  from: Ae.oneOfType([Ae.object, Ae.string]),
  to: Ae.oneOfType([Ae.object, Ae.string]),
  attributeName: Ae.string,
  // animation duration
  duration: Ae.number,
  begin: Ae.number,
  easing: Ae.oneOfType([Ae.string, Ae.func]),
  steps: Ae.arrayOf(Ae.shape({
    duration: Ae.number.isRequired,
    style: Ae.object.isRequired,
    easing: Ae.oneOfType([Ae.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Ae.func]),
    // transition css properties(dash case), optional
    properties: Ae.arrayOf("string"),
    onAnimationEnd: Ae.func
  })),
  children: Ae.oneOfType([Ae.node, Ae.func]),
  isActive: Ae.bool,
  canBegin: Ae.bool,
  onAnimationEnd: Ae.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Ae.bool,
  onAnimationStart: Ae.func,
  onAnimationReStart: Ae.func
};
function is(e) {
  "@babel/helpers - typeof";
  return is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, is(e);
}
function Rl() {
  return Rl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Rl.apply(this, arguments);
}
function hee(e, t) {
  return gee(e) || yee(e, t) || vee(e, t) || mee();
}
function mee() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vee(e, t) {
  if (e) {
    if (typeof e == "string") return AP(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return AP(e, t);
  }
}
function AP(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function yee(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function gee(e) {
  if (Array.isArray(e)) return e;
}
function _P(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function EP(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _P(Object(r), !0).forEach(function(n) {
      bee(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _P(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function bee(e, t, r) {
  return t = xee(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function xee(e) {
  var t = wee(e, "string");
  return is(t) == "symbol" ? t : t + "";
}
function wee(e, t) {
  if (is(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (is(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var CP = function(t, r, n, a, o) {
  var i = Math.min(Math.abs(n) / 2, Math.abs(a) / 2), s = a >= 0 ? 1 : -1, c = n >= 0 ? 1 : -1, l = a >= 0 && n >= 0 || a < 0 && n < 0 ? 1 : 0, u;
  if (i > 0 && o instanceof Array) {
    for (var f = [0, 0, 0, 0], d = 0, p = 4; d < p; d++)
      f[d] = o[d] > i ? i : o[d];
    u = "M".concat(t, ",").concat(r + s * f[0]), f[0] > 0 && (u += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(l, ",").concat(t + c * f[0], ",").concat(r)), u += "L ".concat(t + n - c * f[1], ",").concat(r), f[1] > 0 && (u += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(l, `,
        `).concat(t + n, ",").concat(r + s * f[1])), u += "L ".concat(t + n, ",").concat(r + a - s * f[2]), f[2] > 0 && (u += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(l, `,
        `).concat(t + n - c * f[2], ",").concat(r + a)), u += "L ".concat(t + c * f[3], ",").concat(r + a), f[3] > 0 && (u += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(l, `,
        `).concat(t, ",").concat(r + a - s * f[3])), u += "Z";
  } else if (i > 0 && o === +o && o > 0) {
    var g = Math.min(i, o);
    u = "M ".concat(t, ",").concat(r + s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(l, ",").concat(t + c * g, ",").concat(r, `
            L `).concat(t + n - c * g, ",").concat(r, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(l, ",").concat(t + n, ",").concat(r + s * g, `
            L `).concat(t + n, ",").concat(r + a - s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(l, ",").concat(t + n - c * g, ",").concat(r + a, `
            L `).concat(t + c * g, ",").concat(r + a, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(l, ",").concat(t, ",").concat(r + a - s * g, " Z");
  } else
    u = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(a, " h ").concat(-n, " Z");
  return u;
}, See = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, a = t.y, o = r.x, i = r.y, s = r.width, c = r.height;
  if (Math.abs(s) > 0 && Math.abs(c) > 0) {
    var l = Math.min(o, o + s), u = Math.max(o, o + s), f = Math.min(i, i + c), d = Math.max(i, i + c);
    return n >= l && n <= u && a >= f && a <= d;
  }
  return !1;
}, Oee = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Gs = function(t) {
  var r = EP(EP({}, Oee), t), n = Ic(), a = pr(-1), o = hee(a, 2), i = o[0], s = o[1];
  ko(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var P = n.current.getTotalLength();
        P && s(P);
      } catch {
      }
  }, []);
  var c = r.x, l = r.y, u = r.width, f = r.height, d = r.radius, p = r.className, g = r.animationEasing, m = r.animationDuration, y = r.animationBegin, b = r.isAnimationActive, w = r.isUpdateAnimationActive;
  if (c !== +c || l !== +l || u !== +u || f !== +f || u === 0 || f === 0)
    return null;
  var S = ue("recharts-rectangle", p);
  return w ? /* @__PURE__ */ E.createElement(Ft, {
    canBegin: i > 0,
    from: {
      width: u,
      height: f,
      x: c,
      y: l
    },
    to: {
      width: u,
      height: f,
      x: c,
      y: l
    },
    duration: m,
    animationEasing: g,
    isActive: w
  }, function(P) {
    var x = P.width, O = P.height, A = P.x, _ = P.y;
    return /* @__PURE__ */ E.createElement(Ft, {
      canBegin: i > 0,
      from: "0px ".concat(i === -1 ? 1 : i, "px"),
      to: "".concat(i, "px 0px"),
      attributeName: "strokeDasharray",
      begin: y,
      duration: m,
      isActive: b,
      easing: g
    }, /* @__PURE__ */ E.createElement("path", Rl({}, ae(r, !0), {
      className: S,
      d: CP(A, _, x, O, d),
      ref: n
    })));
  }) : /* @__PURE__ */ E.createElement("path", Rl({}, ae(r, !0), {
    className: S,
    d: CP(c, l, u, f, d)
  }));
}, Pee = ["points", "className", "baseLinePoints", "connectNulls"];
function $a() {
  return $a = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $a.apply(this, arguments);
}
function Aee(e, t) {
  if (e == null) return {};
  var r = _ee(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function _ee(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function kP(e) {
  return Nee(e) || kee(e) || Cee(e) || Eee();
}
function Eee() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Cee(e, t) {
  if (e) {
    if (typeof e == "string") return gy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return gy(e, t);
  }
}
function kee(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Nee(e) {
  if (Array.isArray(e)) return gy(e);
}
function gy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var NP = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, Tee = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    NP(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), NP(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, wi = function(t, r) {
  var n = Tee(t);
  r && (n = [n.reduce(function(o, i) {
    return [].concat(kP(o), kP(i));
  }, [])]);
  var a = n.map(function(o) {
    return o.reduce(function(i, s, c) {
      return "".concat(i).concat(c === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(a, "Z") : a;
}, Mee = function(t, r, n) {
  var a = wi(t, n);
  return "".concat(a.slice(-1) === "Z" ? a.slice(0, -1) : a, "L").concat(wi(r.reverse(), n).slice(1));
}, HM = function(t) {
  var r = t.points, n = t.className, a = t.baseLinePoints, o = t.connectNulls, i = Aee(t, Pee);
  if (!r || !r.length)
    return null;
  var s = ue("recharts-polygon", n);
  if (a && a.length) {
    var c = i.stroke && i.stroke !== "none", l = Mee(r, a, o);
    return /* @__PURE__ */ E.createElement("g", {
      className: s
    }, /* @__PURE__ */ E.createElement("path", $a({}, ae(i, !0), {
      fill: l.slice(-1) === "Z" ? i.fill : "none",
      stroke: "none",
      d: l
    })), c ? /* @__PURE__ */ E.createElement("path", $a({}, ae(i, !0), {
      fill: "none",
      d: wi(r, o)
    })) : null, c ? /* @__PURE__ */ E.createElement("path", $a({}, ae(i, !0), {
      fill: "none",
      d: wi(a, o)
    })) : null);
  }
  var u = wi(r, o);
  return /* @__PURE__ */ E.createElement("path", $a({}, ae(i, !0), {
    fill: u.slice(-1) === "Z" ? i.fill : "none",
    className: s,
    d: u
  }));
};
function by() {
  return by = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, by.apply(this, arguments);
}
var Ho = function(t) {
  var r = t.cx, n = t.cy, a = t.r, o = t.className, i = ue("recharts-dot", o);
  return r === +r && n === +n && a === +a ? /* @__PURE__ */ v.createElement("circle", by({}, ae(t, !1), el(t), {
    className: i,
    cx: r,
    cy: n,
    r: a
  })) : null;
};
function ss(e) {
  "@babel/helpers - typeof";
  return ss = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ss(e);
}
var Ree = ["x", "y", "top", "left", "width", "height", "className"];
function xy() {
  return xy = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xy.apply(this, arguments);
}
function TP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $ee(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? TP(Object(r), !0).forEach(function(n) {
      Iee(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : TP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Iee(e, t, r) {
  return t = Dee(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Dee(e) {
  var t = jee(e, "string");
  return ss(t) == "symbol" ? t : t + "";
}
function jee(e, t) {
  if (ss(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ss(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Lee(e, t) {
  if (e == null) return {};
  var r = Bee(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Bee(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var Fee = function(t, r, n, a, o, i) {
  return "M".concat(t, ",").concat(o, "v").concat(a, "M").concat(i, ",").concat(r, "h").concat(n);
}, zee = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, a = t.y, o = a === void 0 ? 0 : a, i = t.top, s = i === void 0 ? 0 : i, c = t.left, l = c === void 0 ? 0 : c, u = t.width, f = u === void 0 ? 0 : u, d = t.height, p = d === void 0 ? 0 : d, g = t.className, m = Lee(t, Ree), y = $ee({
    x: n,
    y: o,
    top: s,
    left: l,
    width: f,
    height: p
  }, m);
  return !J(n) || !J(o) || !J(f) || !J(p) || !J(s) || !J(l) ? null : /* @__PURE__ */ E.createElement("path", xy({}, ae(y, !0), {
    className: ue("recharts-cross", g),
    d: Fee(n, o, f, p, s, l)
  }));
}, qee = ["cx", "cy", "innerRadius", "outerRadius", "gridType", "radialLines"];
function cs(e) {
  "@babel/helpers - typeof";
  return cs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cs(e);
}
function Wee(e, t) {
  if (e == null) return {};
  var r = Hee(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Hee(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function rn() {
  return rn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, rn.apply(this, arguments);
}
function MP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ls(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? MP(Object(r), !0).forEach(function(n) {
      Vee(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : MP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Vee(e, t, r) {
  return t = Uee(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Uee(e) {
  var t = Kee(e, "string");
  return cs(t) == "symbol" ? t : t + "";
}
function Kee(e, t) {
  if (cs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (cs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Gee = function(t, r, n, a) {
  var o = "";
  return a.forEach(function(i, s) {
    var c = xe(r, n, t, i);
    s ? o += "L ".concat(c.x, ",").concat(c.y) : o += "M ".concat(c.x, ",").concat(c.y);
  }), o += "Z", o;
}, Yee = function(t) {
  var r = t.cx, n = t.cy, a = t.innerRadius, o = t.outerRadius, i = t.polarAngles, s = t.radialLines;
  if (!i || !i.length || !s)
    return null;
  var c = ls({
    stroke: "#ccc"
  }, ae(t, !1));
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-polar-grid-angle"
  }, i.map(function(l) {
    var u = xe(r, n, a, l), f = xe(r, n, o, l);
    return /* @__PURE__ */ E.createElement("line", rn({}, c, {
      key: "line-".concat(l),
      x1: u.x,
      y1: u.y,
      x2: f.x,
      y2: f.y
    }));
  }));
}, Xee = function(t) {
  var r = t.cx, n = t.cy, a = t.radius, o = t.index, i = ls(ls({
    stroke: "#ccc"
  }, ae(t, !1)), {}, {
    fill: "none"
  });
  return /* @__PURE__ */ E.createElement("circle", rn({}, i, {
    className: ue("recharts-polar-grid-concentric-circle", t.className),
    key: "circle-".concat(o),
    cx: r,
    cy: n,
    r: a
  }));
}, Zee = function(t) {
  var r = t.radius, n = t.index, a = ls(ls({
    stroke: "#ccc"
  }, ae(t, !1)), {}, {
    fill: "none"
  });
  return /* @__PURE__ */ E.createElement("path", rn({}, a, {
    className: ue("recharts-polar-grid-concentric-polygon", t.className),
    key: "path-".concat(n),
    d: Gee(r, t.cx, t.cy, t.polarAngles)
  }));
}, Jee = function(t) {
  var r = t.polarRadius, n = t.gridType;
  return !r || !r.length ? null : /* @__PURE__ */ E.createElement("g", {
    className: "recharts-polar-grid-concentric"
  }, r.map(function(a, o) {
    var i = o;
    return n === "circle" ? /* @__PURE__ */ E.createElement(Xee, rn({
      key: i
    }, t, {
      radius: a,
      index: o
    })) : /* @__PURE__ */ E.createElement(Zee, rn({
      key: i
    }, t, {
      radius: a,
      index: o
    }));
  }));
}, VM = function(t) {
  var r = t.cx, n = r === void 0 ? 0 : r, a = t.cy, o = a === void 0 ? 0 : a, i = t.innerRadius, s = i === void 0 ? 0 : i, c = t.outerRadius, l = c === void 0 ? 0 : c, u = t.gridType, f = u === void 0 ? "polygon" : u, d = t.radialLines, p = d === void 0 ? !0 : d, g = Wee(t, qee);
  return l <= 0 ? null : /* @__PURE__ */ E.createElement("g", {
    className: "recharts-polar-grid"
  }, /* @__PURE__ */ E.createElement(Yee, rn({
    cx: n,
    cy: o,
    innerRadius: s,
    outerRadius: l,
    gridType: f,
    radialLines: p
  }, g)), /* @__PURE__ */ E.createElement(Jee, rn({
    cx: n,
    cy: o,
    innerRadius: s,
    outerRadius: l,
    gridType: f,
    radialLines: p
  }, g)));
};
VM.displayName = "PolarGrid";
var Am, RP;
function Qee() {
  if (RP) return Am;
  RP = 1;
  var e = uf(), t = eM(), r = wr();
  function n(a, o) {
    return a && a.length ? e(a, r(o, 2), t) : void 0;
  }
  return Am = n, Am;
}
var ete = Qee();
const UM = /* @__PURE__ */ _e(ete);
var _m, $P;
function tte() {
  if ($P) return _m;
  $P = 1;
  var e = uf(), t = wr(), r = tM();
  function n(a, o) {
    return a && a.length ? e(a, t(o, 2), r) : void 0;
  }
  return _m = n, _m;
}
var rte = tte();
const nte = /* @__PURE__ */ _e(rte);
var ate = ["cx", "cy", "angle", "ticks", "axisLine"], ote = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function io(e) {
  "@babel/helpers - typeof";
  return io = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, io(e);
}
function Si() {
  return Si = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Si.apply(this, arguments);
}
function IP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Wn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? IP(Object(r), !0).forEach(function(n) {
      pf(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : IP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function DP(e, t) {
  if (e == null) return {};
  var r = ite(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function ite(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function ste(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function jP(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, GM(n.key), n);
  }
}
function cte(e, t, r) {
  return t && jP(e.prototype, t), r && jP(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function lte(e, t, r) {
  return t = $l(t), ute(e, KM() ? Reflect.construct(t, r || [], $l(e).constructor) : t.apply(e, r));
}
function ute(e, t) {
  if (t && (io(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fte(e);
}
function fte(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function KM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (KM = function() {
    return !!e;
  })();
}
function $l(e) {
  return $l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, $l(e);
}
function dte(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && wy(e, t);
}
function wy(e, t) {
  return wy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, wy(e, t);
}
function pf(e, t, r) {
  return t = GM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function GM(e) {
  var t = pte(e, "string");
  return io(t) == "symbol" ? t : t + "";
}
function pte(e, t) {
  if (io(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (io(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Vo = /* @__PURE__ */ (function(e) {
  function t() {
    return ste(this, t), lte(this, t, arguments);
  }
  return dte(t, e), cte(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var a = n.coordinate, o = this.props, i = o.angle, s = o.cx, c = o.cy;
        return xe(s, c, a, i);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, a;
      switch (n) {
        case "left":
          a = "end";
          break;
        case "right":
          a = "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, a = n.cx, o = n.cy, i = n.angle, s = n.ticks, c = UM(s, function(u) {
        return u.coordinate || 0;
      }), l = nte(s, function(u) {
        return u.coordinate || 0;
      });
      return {
        cx: a,
        cy: o,
        startAngle: i,
        endAngle: i,
        innerRadius: l.coordinate || 0,
        outerRadius: c.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, o = n.cy, i = n.angle, s = n.ticks, c = n.axisLine, l = DP(n, ate), u = s.reduce(function(g, m) {
        return [Math.min(g[0], m.coordinate), Math.max(g[1], m.coordinate)];
      }, [1 / 0, -1 / 0]), f = xe(a, o, u[0], i), d = xe(a, o, u[1], i), p = Wn(Wn(Wn({}, ae(l, !1)), {}, {
        fill: "none"
      }, ae(c, !1)), {}, {
        x1: f.x,
        y1: f.y,
        x2: d.x,
        y2: d.y
      });
      return /* @__PURE__ */ E.createElement("line", Si({
        className: "recharts-polar-radius-axis-line"
      }, p));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, o = a.ticks, i = a.tick, s = a.angle, c = a.tickFormatter, l = a.stroke, u = DP(a, ote), f = this.getTickTextAnchor(), d = ae(u, !1), p = ae(i, !1), g = o.map(function(m, y) {
        var b = n.getTickValueCoord(m), w = Wn(Wn(Wn(Wn({
          textAnchor: f,
          transform: "rotate(".concat(90 - s, ", ").concat(b.x, ", ").concat(b.y, ")")
        }, d), {}, {
          stroke: "none",
          fill: l
        }, p), {}, {
          index: y
        }, b), {}, {
          payload: m
        });
        return /* @__PURE__ */ E.createElement(de, Si({
          className: ue("recharts-polar-radius-axis-tick", NM(i)),
          key: "tick-".concat(m.coordinate)
        }, Cn(n.props, m, y)), t.renderTickItem(i, w, c ? c(m.value, y) : m.value));
      });
      return /* @__PURE__ */ E.createElement(de, {
        className: "recharts-polar-radius-axis-ticks"
      }, g);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, o = n.axisLine, i = n.tick;
      return !a || !a.length ? null : /* @__PURE__ */ E.createElement(de, {
        className: ue("recharts-polar-radius-axis", this.props.className)
      }, o && this.renderAxisLine(), i && this.renderTicks(), at.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, o) {
      var i;
      return /* @__PURE__ */ E.isValidElement(n) ? i = /* @__PURE__ */ E.cloneElement(n, a) : se(n) ? i = n(a) : i = /* @__PURE__ */ E.createElement(ua, Si({}, a, {
        className: "recharts-polar-radius-axis-tick-value"
      }), o), i;
    }
  }]);
})(St);
pf(Vo, "displayName", "PolarRadiusAxis");
pf(Vo, "axisType", "radiusAxis");
pf(Vo, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function so(e) {
  "@babel/helpers - typeof";
  return so = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, so(e);
}
function Gn() {
  return Gn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Gn.apply(this, arguments);
}
function LP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Hn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? LP(Object(r), !0).forEach(function(n) {
      hf(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : LP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function hte(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function BP(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, XM(n.key), n);
  }
}
function mte(e, t, r) {
  return t && BP(e.prototype, t), r && BP(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vte(e, t, r) {
  return t = Il(t), yte(e, YM() ? Reflect.construct(t, r || [], Il(e).constructor) : t.apply(e, r));
}
function yte(e, t) {
  if (t && (so(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return gte(e);
}
function gte(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function YM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (YM = function() {
    return !!e;
  })();
}
function Il(e) {
  return Il = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Il(e);
}
function bte(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sy(e, t);
}
function Sy(e, t) {
  return Sy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Sy(e, t);
}
function hf(e, t, r) {
  return t = XM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function XM(e) {
  var t = xte(e, "string");
  return so(t) == "symbol" ? t : t + "";
}
function xte(e, t) {
  if (so(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (so(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var wte = Math.PI / 180, FP = 1e-5, Uo = /* @__PURE__ */ (function(e) {
  function t() {
    return hte(this, t), vte(this, t, arguments);
  }
  return bte(t, e), mte(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var a = this.props, o = a.cx, i = a.cy, s = a.radius, c = a.orientation, l = a.tickSize, u = l || 8, f = xe(o, i, s, n.coordinate), d = xe(o, i, s + (c === "inner" ? -1 : 1) * u, n.coordinate);
        return {
          x1: f.x,
          y1: f.y,
          x2: d.x,
          y2: d.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var a = this.props.orientation, o = Math.cos(-n.coordinate * wte), i;
      return o > FP ? i = a === "outer" ? "start" : "end" : o < -FP ? i = a === "outer" ? "end" : "start" : i = "middle", i;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, o = n.cy, i = n.radius, s = n.axisLine, c = n.axisLineType, l = Hn(Hn({}, ae(this.props, !1)), {}, {
        fill: "none"
      }, ae(s, !1));
      if (c === "circle")
        return /* @__PURE__ */ E.createElement(Ho, Gn({
          className: "recharts-polar-angle-axis-line"
        }, l, {
          cx: a,
          cy: o,
          r: i
        }));
      var u = this.props.ticks, f = u.map(function(d) {
        return xe(a, o, i, d.coordinate);
      });
      return /* @__PURE__ */ E.createElement(HM, Gn({
        className: "recharts-polar-angle-axis-line"
      }, l, {
        points: f
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, o = a.ticks, i = a.tick, s = a.tickLine, c = a.tickFormatter, l = a.stroke, u = ae(this.props, !1), f = ae(i, !1), d = Hn(Hn({}, u), {}, {
        fill: "none"
      }, ae(s, !1)), p = o.map(function(g, m) {
        var y = n.getTickLineCoord(g), b = n.getTickTextAnchor(g), w = Hn(Hn(Hn({
          textAnchor: b
        }, u), {}, {
          stroke: "none",
          fill: l
        }, f), {}, {
          index: m,
          payload: g,
          x: y.x2,
          y: y.y2
        });
        return /* @__PURE__ */ E.createElement(de, Gn({
          className: ue("recharts-polar-angle-axis-tick", NM(i)),
          key: "tick-".concat(g.coordinate)
        }, Cn(n.props, g, m)), s && /* @__PURE__ */ E.createElement("line", Gn({
          className: "recharts-polar-angle-axis-tick-line"
        }, d, y)), i && t.renderTickItem(i, w, c ? c(g.value, m) : g.value));
      });
      return /* @__PURE__ */ E.createElement(de, {
        className: "recharts-polar-angle-axis-ticks"
      }, p);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, o = n.radius, i = n.axisLine;
      return o <= 0 || !a || !a.length ? null : /* @__PURE__ */ E.createElement(de, {
        className: ue("recharts-polar-angle-axis", this.props.className)
      }, i && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, o) {
      var i;
      return /* @__PURE__ */ E.isValidElement(n) ? i = /* @__PURE__ */ E.cloneElement(n, a) : se(n) ? i = n(a) : i = /* @__PURE__ */ E.createElement(ua, Gn({}, a, {
        className: "recharts-polar-angle-axis-tick-value"
      }), o), i;
    }
  }]);
})(St);
hf(Uo, "displayName", "PolarAngleAxis");
hf(Uo, "axisType", "angleAxis");
hf(Uo, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var Em, zP;
function Ste() {
  if (zP) return Em;
  zP = 1;
  var e = QN(), t = e(Object.getPrototypeOf, Object);
  return Em = t, Em;
}
var Cm, qP;
function Ote() {
  if (qP) return Cm;
  qP = 1;
  var e = an(), t = Ste(), r = on(), n = "[object Object]", a = Function.prototype, o = Object.prototype, i = a.toString, s = o.hasOwnProperty, c = i.call(Object);
  function l(u) {
    if (!r(u) || e(u) != n)
      return !1;
    var f = t(u);
    if (f === null)
      return !0;
    var d = s.call(f, "constructor") && f.constructor;
    return typeof d == "function" && d instanceof d && i.call(d) == c;
  }
  return Cm = l, Cm;
}
var Pte = Ote();
const Ate = /* @__PURE__ */ _e(Pte);
var km, WP;
function _te() {
  if (WP) return km;
  WP = 1;
  var e = an(), t = on(), r = "[object Boolean]";
  function n(a) {
    return a === !0 || a === !1 || t(a) && e(a) == r;
  }
  return km = n, km;
}
var Ete = _te();
const Cte = /* @__PURE__ */ _e(Ete);
function us(e) {
  "@babel/helpers - typeof";
  return us = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, us(e);
}
function Dl() {
  return Dl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Dl.apply(this, arguments);
}
function kte(e, t) {
  return Rte(e) || Mte(e, t) || Tte(e, t) || Nte();
}
function Nte() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tte(e, t) {
  if (e) {
    if (typeof e == "string") return HP(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return HP(e, t);
  }
}
function HP(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Mte(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function Rte(e) {
  if (Array.isArray(e)) return e;
}
function VP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function UP(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VP(Object(r), !0).forEach(function(n) {
      $te(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : VP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $te(e, t, r) {
  return t = Ite(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ite(e) {
  var t = Dte(e, "string");
  return us(t) == "symbol" ? t : t + "";
}
function Dte(e, t) {
  if (us(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (us(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var KP = function(t, r, n, a, o) {
  var i = n - a, s;
  return s = "M ".concat(t, ",").concat(r), s += "L ".concat(t + n, ",").concat(r), s += "L ".concat(t + n - i / 2, ",").concat(r + o), s += "L ".concat(t + n - i / 2 - a, ",").concat(r + o), s += "L ".concat(t, ",").concat(r, " Z"), s;
}, jte = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Lte = function(t) {
  var r = UP(UP({}, jte), t), n = Ic(), a = pr(-1), o = kte(a, 2), i = o[0], s = o[1];
  ko(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var S = n.current.getTotalLength();
        S && s(S);
      } catch {
      }
  }, []);
  var c = r.x, l = r.y, u = r.upperWidth, f = r.lowerWidth, d = r.height, p = r.className, g = r.animationEasing, m = r.animationDuration, y = r.animationBegin, b = r.isUpdateAnimationActive;
  if (c !== +c || l !== +l || u !== +u || f !== +f || d !== +d || u === 0 && f === 0 || d === 0)
    return null;
  var w = ue("recharts-trapezoid", p);
  return b ? /* @__PURE__ */ E.createElement(Ft, {
    canBegin: i > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: d,
      x: c,
      y: l
    },
    to: {
      upperWidth: u,
      lowerWidth: f,
      height: d,
      x: c,
      y: l
    },
    duration: m,
    animationEasing: g,
    isActive: b
  }, function(S) {
    var P = S.upperWidth, x = S.lowerWidth, O = S.height, A = S.x, _ = S.y;
    return /* @__PURE__ */ E.createElement(Ft, {
      canBegin: i > 0,
      from: "0px ".concat(i === -1 ? 1 : i, "px"),
      to: "".concat(i, "px 0px"),
      attributeName: "strokeDasharray",
      begin: y,
      duration: m,
      easing: g
    }, /* @__PURE__ */ E.createElement("path", Dl({}, ae(r, !0), {
      className: w,
      d: KP(A, _, P, x, O),
      ref: n
    })));
  }) : /* @__PURE__ */ E.createElement("g", null, /* @__PURE__ */ E.createElement("path", Dl({}, ae(r, !0), {
    className: w,
    d: KP(c, l, u, f, d)
  })));
}, Bte = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function fs(e) {
  "@babel/helpers - typeof";
  return fs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fs(e);
}
function Fte(e, t) {
  if (e == null) return {};
  var r = zte(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function zte(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function GP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? GP(Object(r), !0).forEach(function(n) {
      qte(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : GP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qte(e, t, r) {
  return t = Wte(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Wte(e) {
  var t = Hte(e, "string");
  return fs(t) == "symbol" ? t : t + "";
}
function Hte(e, t) {
  if (fs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (fs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Vte(e, t) {
  return jl(jl({}, t), e);
}
function Ute(e, t) {
  return e === "symbols";
}
function YP(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ E.createElement(Gs, r);
    case "trapezoid":
      return /* @__PURE__ */ E.createElement(Lte, r);
    case "sector":
      return /* @__PURE__ */ E.createElement($M, r);
    case "symbols":
      if (Ute(t))
        return /* @__PURE__ */ E.createElement(Qu, r);
      break;
    default:
      return null;
  }
}
function Kte(e) {
  return /* @__PURE__ */ Et(e) ? e.props : e;
}
function Ll(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, a = n === void 0 ? Vte : n, o = e.activeClassName, i = o === void 0 ? "recharts-active-shape" : o, s = e.isActive, c = Fte(e, Bte), l;
  if (/* @__PURE__ */ Et(t))
    l = /* @__PURE__ */ Je(t, jl(jl({}, c), Kte(t)));
  else if (se(t))
    l = t(c);
  else if (Ate(t) && !Cte(t)) {
    var u = a(t, c);
    l = /* @__PURE__ */ E.createElement(YP, {
      shapeType: r,
      elementProps: u
    });
  } else {
    var f = c;
    l = /* @__PURE__ */ E.createElement(YP, {
      shapeType: r,
      elementProps: f
    });
  }
  return s ? /* @__PURE__ */ E.createElement(de, {
    className: i
  }, l) : l;
}
function mf(e, t) {
  return t != null && "trapezoids" in e.props;
}
function vf(e, t) {
  return t != null && "sectors" in e.props;
}
function ds(e, t) {
  return t != null && "points" in e.props;
}
function Gte(e, t) {
  var r, n, a = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, o = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return a && o;
}
function Yte(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function Xte(e, t) {
  var r = e.x === t.x, n = e.y === t.y, a = e.z === t.z;
  return r && n && a;
}
function Zte(e, t) {
  var r;
  return mf(e, t) ? r = Gte : vf(e, t) ? r = Yte : ds(e, t) && (r = Xte), r;
}
function Jte(e, t) {
  var r;
  return mf(e, t) ? r = "trapezoids" : vf(e, t) ? r = "sectors" : ds(e, t) && (r = "points"), r;
}
function Qte(e, t) {
  if (mf(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (vf(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return ds(e, t) ? t.payload : {};
}
function ere(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, a = Jte(r, t), o = Qte(r, t), i = n.filter(function(c, l) {
    var u = tn(o, c), f = r.props[a].filter(function(g) {
      var m = Zte(r, t);
      return m(g, t);
    }), d = r.props[a].indexOf(f[f.length - 1]), p = l === d;
    return u && p;
  }), s = n.indexOf(i[i.length - 1]);
  return s;
}
var Tc;
function co(e) {
  "@babel/helpers - typeof";
  return co = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, co(e);
}
function Ia() {
  return Ia = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ia.apply(this, arguments);
}
function XP(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? XP(Object(r), !0).forEach(function(n) {
      Gt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : XP(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ZP(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, JM(n.key), n);
  }
}
function rre(e, t, r) {
  return t && ZP(e.prototype, t), r && ZP(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function nre(e, t, r) {
  return t = Bl(t), are(e, ZM() ? Reflect.construct(t, r || [], Bl(e).constructor) : t.apply(e, r));
}
function are(e, t) {
  if (t && (co(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ore(e);
}
function ore(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ZM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ZM = function() {
    return !!e;
  })();
}
function Bl(e) {
  return Bl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Bl(e);
}
function ire(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Oy(e, t);
}
function Oy(e, t) {
  return Oy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Oy(e, t);
}
function Gt(e, t, r) {
  return t = JM(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function JM(e) {
  var t = sre(e, "string");
  return co(t) == "symbol" ? t : t + "";
}
function sre(e, t) {
  if (co(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (co(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Sr = /* @__PURE__ */ (function(e) {
  function t(r) {
    var n;
    return tre(this, t), n = nre(this, t, [r]), Gt(n, "pieRef", null), Gt(n, "sectorRefs", []), Gt(n, "id", In("recharts-pie-")), Gt(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), se(a) && a();
    }), Gt(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), se(a) && a();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return ire(t, e), rre(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var a = this.props.activeIndex;
      return Array.isArray(a) ? a.indexOf(n) !== -1 : n === a;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var o = this.props, i = o.label, s = o.labelLine, c = o.dataKey, l = o.valueKey, u = ae(this.props, !1), f = ae(i, !1), d = ae(s, !1), p = i && i.offsetRadius || 20, g = n.map(function(m, y) {
        var b = (m.startAngle + m.endAngle) / 2, w = xe(m.cx, m.cy, m.outerRadius + p, b), S = Re(Re(Re(Re({}, u), m), {}, {
          stroke: "none"
        }, f), {}, {
          index: y,
          textAnchor: t.getTextAnchor(w.x, m.cx)
        }, w), P = Re(Re(Re(Re({}, u), m), {}, {
          fill: "none",
          stroke: m.fill
        }, d), {}, {
          index: y,
          points: [xe(m.cx, m.cy, m.outerRadius, b), w]
        }), x = c;
        return ce(c) && ce(l) ? x = "value" : ce(c) && (x = l), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ E.createElement(de, {
          key: "label-".concat(m.startAngle, "-").concat(m.endAngle, "-").concat(m.midAngle, "-").concat(y)
        }, s && t.renderLabelLineItem(s, P, "line"), t.renderLabelItem(i, S, ge(m, x)));
      });
      return /* @__PURE__ */ E.createElement(de, {
        className: "recharts-pie-labels"
      }, g);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var a = this, o = this.props, i = o.activeShape, s = o.blendStroke, c = o.inactiveShape;
      return n.map(function(l, u) {
        if ((l == null ? void 0 : l.startAngle) === 0 && (l == null ? void 0 : l.endAngle) === 0 && n.length !== 1) return null;
        var f = a.isActiveIndex(u), d = c && a.hasActiveIndex() ? c : null, p = f ? i : d, g = Re(Re({}, l), {}, {
          stroke: s ? l.fill : l.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ E.createElement(de, Ia({
          ref: function(y) {
            y && !a.sectorRefs.includes(y) && a.sectorRefs.push(y);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, Cn(a.props, l, u), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(l == null ? void 0 : l.startAngle, "-").concat(l == null ? void 0 : l.endAngle, "-").concat(l.midAngle, "-").concat(u)
        }), /* @__PURE__ */ E.createElement(Ll, Ia({
          option: p,
          isActive: f,
          shapeType: "sector"
        }, g)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, a = this.props, o = a.sectors, i = a.isAnimationActive, s = a.animationBegin, c = a.animationDuration, l = a.animationEasing, u = a.animationId, f = this.state, d = f.prevSectors, p = f.prevIsAnimationActive;
      return /* @__PURE__ */ E.createElement(Ft, {
        begin: s,
        duration: c,
        isActive: i,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(u, "-").concat(p),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(g) {
        var m = g.t, y = [], b = o && o[0], w = b.startAngle;
        return o.forEach(function(S, P) {
          var x = d && d[P], O = P > 0 ? lt(S, "paddingAngle", 0) : 0;
          if (x) {
            var A = Ne(x.endAngle - x.startAngle, S.endAngle - S.startAngle), _ = Re(Re({}, S), {}, {
              startAngle: w + O,
              endAngle: w + A(m) + O
            });
            y.push(_), w = _.endAngle;
          } else {
            var N = S.endAngle, M = S.startAngle, T = Ne(0, N - M), k = T(m), $ = Re(Re({}, S), {}, {
              startAngle: w + O,
              endAngle: w + k + O
            });
            y.push($), w = $.endAngle;
          }
        }), /* @__PURE__ */ E.createElement(de, null, n.renderSectorsStatically(y));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var a = this;
      n.onkeydown = function(o) {
        if (!o.altKey)
          switch (o.key) {
            case "ArrowLeft": {
              var i = ++a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[i].focus(), a.setState({
                sectorToFocus: i
              });
              break;
            }
            case "ArrowRight": {
              var s = --a.state.sectorToFocus < 0 ? a.sectorRefs.length - 1 : a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[s].focus(), a.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              a.sectorRefs[a.state.sectorToFocus].blur(), a.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, a = n.sectors, o = n.isAnimationActive, i = this.state.prevSectors;
      return o && a && a.length && (!i || !tn(i, a)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(a);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, o = a.hide, i = a.sectors, s = a.className, c = a.label, l = a.cx, u = a.cy, f = a.innerRadius, d = a.outerRadius, p = a.isAnimationActive, g = this.state.isAnimationFinished;
      if (o || !i || !i.length || !J(l) || !J(u) || !J(f) || !J(d))
        return null;
      var m = ue("recharts-pie", s);
      return /* @__PURE__ */ E.createElement(de, {
        tabIndex: this.props.rootTabIndex,
        className: m,
        ref: function(b) {
          n.pieRef = b;
        }
      }, this.renderSectors(), c && this.renderLabels(i), at.renderCallByParent(this.props, null, !1), (!p || g) && Jt.renderCallByParent(this.props, i, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return a.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: a.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== a.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, a) {
      return n > a ? "start" : n < a ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, a, o) {
      if (/* @__PURE__ */ E.isValidElement(n))
        return /* @__PURE__ */ E.cloneElement(n, a);
      if (se(n))
        return n(a);
      var i = ue("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ E.createElement(Pn, Ia({}, a, {
        key: o,
        type: "linear",
        className: i
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, a, o) {
      if (/* @__PURE__ */ E.isValidElement(n))
        return /* @__PURE__ */ E.cloneElement(n, a);
      var i = o;
      if (se(n) && (i = n(a), /* @__PURE__ */ E.isValidElement(i)))
        return i;
      var s = ue("recharts-pie-label-text", typeof n != "boolean" && !se(n) ? n.className : "");
      return /* @__PURE__ */ E.createElement(ua, Ia({}, a, {
        alignmentBaseline: "middle",
        className: s
      }), i);
    }
  }]);
})(St);
Tc = Sr;
Gt(Sr, "displayName", "Pie");
Gt(Sr, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !Lr.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
Gt(Sr, "parseDeltaAngle", function(e, t) {
  var r = yt(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
Gt(Sr, "getRealPieData", function(e) {
  var t = e.data, r = e.children, n = ae(e, !1), a = xt(r, gr);
  return t && t.length ? t.map(function(o, i) {
    return Re(Re(Re({
      payload: o
    }, n), o), a && a[i] && a[i].props);
  }) : a && a.length ? a.map(function(o) {
    return Re(Re({}, n), o.props);
  }) : [];
});
Gt(Sr, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, a = t.width, o = t.height, i = CM(a, o), s = n + gt(e.cx, a, a / 2), c = r + gt(e.cy, o, o / 2), l = gt(e.innerRadius, i, 0), u = gt(e.outerRadius, i, i * 0.8), f = e.maxRadius || Math.sqrt(a * a + o * o) / 2;
  return {
    cx: s,
    cy: c,
    innerRadius: l,
    outerRadius: u,
    maxRadius: f
  };
});
Gt(Sr, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = t.type.defaultProps !== void 0 ? Re(Re({}, t.type.defaultProps), t.props) : t.props, a = Tc.getRealPieData(n);
  if (!a || !a.length)
    return null;
  var o = n.cornerRadius, i = n.startAngle, s = n.endAngle, c = n.paddingAngle, l = n.dataKey, u = n.nameKey, f = n.valueKey, d = n.tooltipType, p = Math.abs(n.minAngle), g = Tc.parseCoordinateOfPie(n, r), m = Tc.parseDeltaAngle(i, s), y = Math.abs(m), b = l;
  ce(l) && ce(f) ? (hr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), b = "value") : ce(l) && (hr(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), b = f);
  var w = a.filter(function(_) {
    return ge(_, b, 0) !== 0;
  }).length, S = (y >= 360 ? w : w - 1) * c, P = y - w * p - S, x = a.reduce(function(_, N) {
    var M = ge(N, b, 0);
    return _ + (J(M) ? M : 0);
  }, 0), O;
  if (x > 0) {
    var A;
    O = a.map(function(_, N) {
      var M = ge(_, b, 0), T = ge(_, u, N), k = (J(M) ? M : 0) / x, $;
      N ? $ = A.endAngle + yt(m) * c * (M !== 0 ? 1 : 0) : $ = i;
      var R = $ + yt(m) * ((M !== 0 ? p : 0) + k * P), L = ($ + R) / 2, j = (g.innerRadius + g.outerRadius) / 2, z = [{
        name: T,
        value: M,
        payload: _,
        dataKey: b,
        type: d
      }], q = xe(g.cx, g.cy, j, L);
      return A = Re(Re(Re({
        percent: k,
        cornerRadius: o,
        name: T,
        tooltipPayload: z,
        midAngle: L,
        middleRadius: j,
        tooltipPosition: q
      }, _), g), {}, {
        value: ge(_, b),
        startAngle: $,
        endAngle: R,
        payload: _,
        paddingAngle: yt(m) * c
      }), A;
    });
  }
  return Re(Re({}, g), {}, {
    sectors: O,
    data: a
  });
});
var Nm, JP;
function cre() {
  if (JP) return Nm;
  JP = 1;
  function e(t) {
    return t && t.length ? t[0] : void 0;
  }
  return Nm = e, Nm;
}
var Tm, QP;
function lre() {
  return QP || (QP = 1, Tm = cre()), Tm;
}
var ure = lre();
const fre = /* @__PURE__ */ _e(ure);
var dre = ["key"];
function lo(e) {
  "@babel/helpers - typeof";
  return lo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lo(e);
}
function pre(e, t) {
  if (e == null) return {};
  var r = hre(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function hre(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Fl() {
  return Fl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Fl.apply(this, arguments);
}
function eA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? eA(Object(r), !0).forEach(function(n) {
      Wr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : eA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function tA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eR(n.key), n);
  }
}
function vre(e, t, r) {
  return t && tA(e.prototype, t), r && tA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function yre(e, t, r) {
  return t = zl(t), gre(e, QM() ? Reflect.construct(t, r || [], zl(e).constructor) : t.apply(e, r));
}
function gre(e, t) {
  if (t && (lo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return bre(e);
}
function bre(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function QM() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (QM = function() {
    return !!e;
  })();
}
function zl(e) {
  return zl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, zl(e);
}
function xre(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Py(e, t);
}
function Py(e, t) {
  return Py = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Py(e, t);
}
function Wr(e, t, r) {
  return t = eR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function eR(e) {
  var t = wre(e, "string");
  return lo(t) == "symbol" ? t : t + "";
}
function wre(e, t) {
  if (lo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (lo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var uo = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    mre(this, t);
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return r = yre(this, t, [].concat(a)), Wr(r, "state", {
      isAnimationFinished: !1
    }), Wr(r, "handleAnimationEnd", function() {
      var i = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), se(i) && i();
    }), Wr(r, "handleAnimationStart", function() {
      var i = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), se(i) && i();
    }), Wr(r, "handleMouseEnter", function(i) {
      var s = r.props.onMouseEnter;
      s && s(r.props, i);
    }), Wr(r, "handleMouseLeave", function(i) {
      var s = r.props.onMouseLeave;
      s && s(r.props, i);
    }), r;
  }
  return xre(t, e), vre(t, [{
    key: "renderDots",
    value: function(n) {
      var a = this.props, o = a.dot, i = a.dataKey, s = ae(this.props, !1), c = ae(o, !0), l = n.map(function(u, f) {
        var d = vt(vt(vt({
          key: "dot-".concat(f),
          r: 3
        }, s), c), {}, {
          dataKey: i,
          cx: u.x,
          cy: u.y,
          index: f,
          payload: u
        });
        return t.renderDotItem(o, d);
      });
      return /* @__PURE__ */ E.createElement(de, {
        className: "recharts-radar-dots"
      }, l);
    }
  }, {
    key: "renderPolygonStatically",
    value: function(n) {
      var a = this.props, o = a.shape, i = a.dot, s = a.isRange, c = a.baseLinePoints, l = a.connectNulls, u;
      return /* @__PURE__ */ E.isValidElement(o) ? u = /* @__PURE__ */ E.cloneElement(o, vt(vt({}, this.props), {}, {
        points: n
      })) : se(o) ? u = o(vt(vt({}, this.props), {}, {
        points: n
      })) : u = /* @__PURE__ */ E.createElement(HM, Fl({}, ae(this.props, !0), {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        points: n,
        baseLinePoints: s ? c : null,
        connectNulls: l
      })), /* @__PURE__ */ E.createElement(de, {
        className: "recharts-radar-polygon"
      }, u, i ? this.renderDots(n) : null);
    }
  }, {
    key: "renderPolygonWithAnimation",
    value: function() {
      var n = this, a = this.props, o = a.points, i = a.isAnimationActive, s = a.animationBegin, c = a.animationDuration, l = a.animationEasing, u = a.animationId, f = this.state.prevPoints;
      return /* @__PURE__ */ E.createElement(Ft, {
        begin: s,
        duration: c,
        isActive: i,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radar-".concat(u),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(d) {
        var p = d.t, g = f && f.length / o.length, m = o.map(function(y, b) {
          var w = f && f[Math.floor(b * g)];
          if (w) {
            var S = Ne(w.x, y.x), P = Ne(w.y, y.y);
            return vt(vt({}, y), {}, {
              x: S(p),
              y: P(p)
            });
          }
          var x = Ne(y.cx, y.x), O = Ne(y.cy, y.y);
          return vt(vt({}, y), {}, {
            x: x(p),
            y: O(p)
          });
        });
        return n.renderPolygonStatically(m);
      });
    }
  }, {
    key: "renderPolygon",
    value: function() {
      var n = this.props, a = n.points, o = n.isAnimationActive, i = n.isRange, s = this.state.prevPoints;
      return o && a && a.length && !i && (!s || !tn(s, a)) ? this.renderPolygonWithAnimation() : this.renderPolygonStatically(a);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, o = n.className, i = n.points, s = n.isAnimationActive;
      if (a || !i || !i.length)
        return null;
      var c = this.state.isAnimationFinished, l = ue("recharts-radar", o);
      return /* @__PURE__ */ E.createElement(de, {
        className: l
      }, this.renderPolygon(), (!s || c) && Jt.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "renderDotItem",
    value: function(n, a) {
      var o;
      if (/* @__PURE__ */ E.isValidElement(n))
        o = /* @__PURE__ */ E.cloneElement(n, a);
      else if (se(n))
        o = n(a);
      else {
        var i = a.key, s = pre(a, dre);
        o = /* @__PURE__ */ E.createElement(Ho, Fl({}, s, {
          key: i,
          className: ue("recharts-radar-dot", typeof n != "boolean" ? n.className : "")
        }));
      }
      return o;
    }
  }]);
})(St);
Wr(uo, "displayName", "Radar");
Wr(uo, "defaultProps", {
  angleAxisId: 0,
  radiusAxisId: 0,
  hide: !1,
  activeDot: !0,
  dot: !1,
  legendType: "rect",
  isAnimationActive: !Lr.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
Wr(uo, "getComposedData", function(e) {
  var t = e.radiusAxis, r = e.angleAxis, n = e.displayedData, a = e.dataKey, o = e.bandSize, i = r.cx, s = r.cy, c = !1, l = [], u = r.type !== "number" ? o ?? 0 : 0;
  n.forEach(function(d, p) {
    var g = ge(d, r.dataKey, p), m = ge(d, a), y = r.scale(g) + u, b = Array.isArray(m) ? MM(m) : m, w = ce(b) ? void 0 : t.scale(b);
    Array.isArray(m) && m.length >= 2 && (c = !0), l.push(vt(vt({}, xe(i, s, w, y)), {}, {
      name: g,
      value: m,
      cx: i,
      cy: s,
      radius: w,
      angle: y,
      payload: d
    }));
  });
  var f = [];
  return c && l.forEach(function(d) {
    if (Array.isArray(d.value)) {
      var p = fre(d.value), g = ce(p) ? void 0 : t.scale(p);
      f.push(vt(vt({}, d), {}, {
        radius: g
      }, xe(i, s, g, d.angle)));
    } else
      f.push(d);
  }), {
    points: l,
    isRange: c,
    baseLinePoints: f
  };
});
var Mm, rA;
function Sre() {
  if (rA) return Mm;
  rA = 1;
  var e = Math.ceil, t = Math.max;
  function r(n, a, o, i) {
    for (var s = -1, c = t(e((a - n) / (o || 1)), 0), l = Array(c); c--; )
      l[i ? c : ++s] = n, n += o;
    return l;
  }
  return Mm = r, Mm;
}
var Rm, nA;
function tR() {
  if (nA) return Rm;
  nA = 1;
  var e = mT(), t = 1 / 0, r = 17976931348623157e292;
  function n(a) {
    if (!a)
      return a === 0 ? a : 0;
    if (a = e(a), a === t || a === -t) {
      var o = a < 0 ? -1 : 1;
      return o * r;
    }
    return a === a ? a : 0;
  }
  return Rm = n, Rm;
}
var $m, aA;
function Ore() {
  if (aA) return $m;
  aA = 1;
  var e = Sre(), t = rf(), r = tR();
  function n(a) {
    return function(o, i, s) {
      return s && typeof s != "number" && t(o, i, s) && (i = s = void 0), o = r(o), i === void 0 ? (i = o, o = 0) : i = r(i), s = s === void 0 ? o < i ? 1 : -1 : r(s), e(o, i, s, a);
    };
  }
  return $m = n, $m;
}
var Im, oA;
function Pre() {
  if (oA) return Im;
  oA = 1;
  var e = Ore(), t = e();
  return Im = t, Im;
}
var Are = Pre();
const ql = /* @__PURE__ */ _e(Are);
function ps(e) {
  "@babel/helpers - typeof";
  return ps = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ps(e);
}
function iA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function sA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? iA(Object(r), !0).forEach(function(n) {
      rR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : iA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function rR(e, t, r) {
  return t = _re(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _re(e) {
  var t = Ere(e, "string");
  return ps(t) == "symbol" ? t : t + "";
}
function Ere(e, t) {
  if (ps(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ps(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Cre = ["Webkit", "Moz", "O", "ms"], kre = function(t, r) {
  var n = t.replace(/(\w)/, function(o) {
    return o.toUpperCase();
  }), a = Cre.reduce(function(o, i) {
    return sA(sA({}, o), {}, rR({}, i + n, r));
  }, {});
  return a[t] = r, a;
};
function fo(e) {
  "@babel/helpers - typeof";
  return fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fo(e);
}
function Wl() {
  return Wl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wl.apply(this, arguments);
}
function cA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Dm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cA(Object(r), !0).forEach(function(n) {
      It(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Nre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aR(n.key), n);
  }
}
function Tre(e, t, r) {
  return t && lA(e.prototype, t), r && lA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Mre(e, t, r) {
  return t = Hl(t), Rre(e, nR() ? Reflect.construct(t, r || [], Hl(e).constructor) : t.apply(e, r));
}
function Rre(e, t) {
  if (t && (fo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $re(e);
}
function $re(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function nR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (nR = function() {
    return !!e;
  })();
}
function Hl(e) {
  return Hl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Hl(e);
}
function Ire(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ay(e, t);
}
function Ay(e, t) {
  return Ay = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Ay(e, t);
}
function It(e, t, r) {
  return t = aR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aR(e) {
  var t = Dre(e, "string");
  return fo(t) == "symbol" ? t : t + "";
}
function Dre(e, t) {
  if (fo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (fo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var jre = function(t) {
  var r = t.data, n = t.startIndex, a = t.endIndex, o = t.x, i = t.width, s = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var c = r.length, l = gi().domain(ql(0, c)).range([o, o + i - s]), u = l.domain().map(function(f) {
    return l(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: l(n),
    endX: l(a),
    scale: l,
    scaleValues: u
  };
}, uA = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, po = /* @__PURE__ */ (function(e) {
  function t(r) {
    var n;
    return Nre(this, t), n = Mre(this, t, [r]), It(n, "handleDrag", function(a) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(a) : n.state.isSlideMoving && n.handleSlideDrag(a);
    }), It(n, "handleTouchMove", function(a) {
      a.changedTouches != null && a.changedTouches.length > 0 && n.handleDrag(a.changedTouches[0]);
    }), It(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var a = n.props, o = a.endIndex, i = a.onDragEnd, s = a.startIndex;
        i == null || i({
          endIndex: o,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), It(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), It(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), It(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), It(n, "handleSlideDragStart", function(a) {
      var o = uA(a) ? a.changedTouches[0] : a;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: o.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return Ire(t, e), Tre(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var a = n.startX, o = n.endX, i = this.state.scaleValues, s = this.props, c = s.gap, l = s.data, u = l.length - 1, f = Math.min(a, o), d = Math.max(a, o), p = t.getIndexInRange(i, f), g = t.getIndexInRange(i, d);
      return {
        startIndex: p - p % c,
        endIndex: g === u ? u : g - g % c
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var a = this.props, o = a.data, i = a.tickFormatter, s = a.dataKey, c = ge(o[n], s, n);
      return se(i) ? i(c, n) : c;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var a = this.state, o = a.slideMoveStartX, i = a.startX, s = a.endX, c = this.props, l = c.x, u = c.width, f = c.travellerWidth, d = c.startIndex, p = c.endIndex, g = c.onChange, m = n.pageX - o;
      m > 0 ? m = Math.min(m, l + u - f - s, l + u - f - i) : m < 0 && (m = Math.max(m, l - i, l - s));
      var y = this.getIndex({
        startX: i + m,
        endX: s + m
      });
      (y.startIndex !== d || y.endIndex !== p) && g && g(y), this.setState({
        startX: i + m,
        endX: s + m,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, a) {
      var o = uA(a) ? a.changedTouches[0] : a;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: o.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var a = this.state, o = a.brushMoveStartX, i = a.movingTravellerId, s = a.endX, c = a.startX, l = this.state[i], u = this.props, f = u.x, d = u.width, p = u.travellerWidth, g = u.onChange, m = u.gap, y = u.data, b = {
        startX: this.state.startX,
        endX: this.state.endX
      }, w = n.pageX - o;
      w > 0 ? w = Math.min(w, f + d - p - l) : w < 0 && (w = Math.max(w, f - l)), b[i] = l + w;
      var S = this.getIndex(b), P = S.startIndex, x = S.endIndex, O = function() {
        var _ = y.length - 1;
        return i === "startX" && (s > c ? P % m === 0 : x % m === 0) || s < c && x === _ || i === "endX" && (s > c ? x % m === 0 : P % m === 0) || s > c && x === _;
      };
      this.setState(It(It({}, i, l + w), "brushMoveStartX", n.pageX), function() {
        g && O() && g(S);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, a) {
      var o = this, i = this.state, s = i.scaleValues, c = i.startX, l = i.endX, u = this.state[a], f = s.indexOf(u);
      if (f !== -1) {
        var d = f + n;
        if (!(d === -1 || d >= s.length)) {
          var p = s[d];
          a === "startX" && p >= l || a === "endX" && p <= c || this.setState(It({}, a, p), function() {
            o.props.onChange(o.getIndex({
              startX: o.state.startX,
              endX: o.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, a = n.x, o = n.y, i = n.width, s = n.height, c = n.fill, l = n.stroke;
      return /* @__PURE__ */ E.createElement("rect", {
        stroke: l,
        fill: c,
        x: a,
        y: o,
        width: i,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, a = n.x, o = n.y, i = n.width, s = n.height, c = n.data, l = n.children, u = n.padding, f = ta.only(l);
      return f ? /* @__PURE__ */ E.cloneElement(f, {
        x: a,
        y: o,
        width: i,
        height: s,
        margin: u,
        compact: !0,
        data: c
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, a) {
      var o, i, s = this, c = this.props, l = c.y, u = c.travellerWidth, f = c.height, d = c.traveller, p = c.ariaLabel, g = c.data, m = c.startIndex, y = c.endIndex, b = Math.max(n, this.props.x), w = Dm(Dm({}, ae(this.props, !1)), {}, {
        x: b,
        y: l,
        width: u,
        height: f
      }), S = p || "Min value: ".concat((o = g[m]) === null || o === void 0 ? void 0 : o.name, ", Max value: ").concat((i = g[y]) === null || i === void 0 ? void 0 : i.name);
      return /* @__PURE__ */ E.createElement(de, {
        tabIndex: 0,
        role: "slider",
        "aria-label": S,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[a],
        onTouchStart: this.travellerDragStartHandlers[a],
        onKeyDown: function(x) {
          ["ArrowLeft", "ArrowRight"].includes(x.key) && (x.preventDefault(), x.stopPropagation(), s.handleTravellerMoveKeyboard(x.key === "ArrowRight" ? 1 : -1, a));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(d, w));
    }
  }, {
    key: "renderSlide",
    value: function(n, a) {
      var o = this.props, i = o.y, s = o.height, c = o.stroke, l = o.travellerWidth, u = Math.min(n, a) + l, f = Math.max(Math.abs(a - n) - l, 0);
      return /* @__PURE__ */ E.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: c,
        fillOpacity: 0.2,
        x: u,
        y: i,
        width: f,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, a = n.startIndex, o = n.endIndex, i = n.y, s = n.height, c = n.travellerWidth, l = n.stroke, u = this.state, f = u.startX, d = u.endX, p = 5, g = {
        pointerEvents: "none",
        fill: l
      };
      return /* @__PURE__ */ E.createElement(de, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ E.createElement(ua, Wl({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, d) - p,
        y: i + s / 2
      }, g), this.getTextOfTick(a)), /* @__PURE__ */ E.createElement(ua, Wl({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, d) + c + p,
        y: i + s / 2
      }, g), this.getTextOfTick(o)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.data, o = n.className, i = n.children, s = n.x, c = n.y, l = n.width, u = n.height, f = n.alwaysShowText, d = this.state, p = d.startX, g = d.endX, m = d.isTextActive, y = d.isSlideMoving, b = d.isTravellerMoving, w = d.isTravellerFocused;
      if (!a || !a.length || !J(s) || !J(c) || !J(l) || !J(u) || l <= 0 || u <= 0)
        return null;
      var S = ue("recharts-brush", o), P = E.Children.count(i) === 1, x = kre("userSelect", "none");
      return /* @__PURE__ */ E.createElement(de, {
        className: S,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: x
      }, this.renderBackground(), P && this.renderPanorama(), this.renderSlide(p, g), this.renderTravellerLayer(p, "startX"), this.renderTravellerLayer(g, "endX"), (m || y || b || w || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var a = n.x, o = n.y, i = n.width, s = n.height, c = n.stroke, l = Math.floor(o + s / 2) - 1;
      return /* @__PURE__ */ E.createElement(E.Fragment, null, /* @__PURE__ */ E.createElement("rect", {
        x: a,
        y: o,
        width: i,
        height: s,
        fill: c,
        stroke: "none"
      }), /* @__PURE__ */ E.createElement("line", {
        x1: a + 1,
        y1: l,
        x2: a + i - 1,
        y2: l,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ E.createElement("line", {
        x1: a + 1,
        y1: l + 2,
        x2: a + i - 1,
        y2: l + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, a) {
      var o;
      return /* @__PURE__ */ E.isValidElement(n) ? o = /* @__PURE__ */ E.cloneElement(n, a) : se(n) ? o = n(a) : o = t.renderDefaultTraveller(a), o;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var o = n.data, i = n.width, s = n.x, c = n.travellerWidth, l = n.updateId, u = n.startIndex, f = n.endIndex;
      if (o !== a.prevData || l !== a.prevUpdateId)
        return Dm({
          prevData: o,
          prevTravellerWidth: c,
          prevUpdateId: l,
          prevX: s,
          prevWidth: i
        }, o && o.length ? jre({
          data: o,
          width: i,
          x: s,
          travellerWidth: c,
          startIndex: u,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (a.scale && (i !== a.prevWidth || s !== a.prevX || c !== a.prevTravellerWidth)) {
        a.scale.range([s, s + i - c]);
        var d = a.scale.domain().map(function(p) {
          return a.scale(p);
        });
        return {
          prevData: o,
          prevTravellerWidth: c,
          prevUpdateId: l,
          prevX: s,
          prevWidth: i,
          startX: a.scale(n.startIndex),
          endX: a.scale(n.endIndex),
          scaleValues: d
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, a) {
      for (var o = n.length, i = 0, s = o - 1; s - i > 1; ) {
        var c = Math.floor((i + s) / 2);
        n[c] > a ? s = c : i = c;
      }
      return a >= n[s] ? s : i;
    }
  }]);
})(St);
It(po, "displayName", "Brush");
It(po, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var jm, fA;
function Lre() {
  if (fA) return jm;
  fA = 1;
  var e = a0();
  function t(r, n) {
    var a;
    return e(r, function(o, i, s) {
      return a = n(o, i, s), !a;
    }), !!a;
  }
  return jm = t, jm;
}
var Lm, dA;
function Bre() {
  if (dA) return Lm;
  dA = 1;
  var e = UN(), t = wr(), r = Lre(), n = Nt(), a = rf();
  function o(i, s, c) {
    var l = n(i) ? e : r;
    return c && a(i, s, c) && (s = void 0), l(i, t(s, 3));
  }
  return Lm = o, Lm;
}
var Fre = Bre();
const zre = /* @__PURE__ */ _e(Fre);
var Tr = function(t, r) {
  var n = t.alwaysShow, a = t.ifOverflow;
  return n && (a = "extendDomain"), a === r;
}, Bm, pA;
function qre() {
  if (pA) return Bm;
  pA = 1;
  var e = uT();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return Bm = t, Bm;
}
var Fm, hA;
function Wre() {
  if (hA) return Fm;
  hA = 1;
  var e = qre(), t = cT(), r = wr();
  function n(a, o) {
    var i = {};
    return o = r(o, 3), t(a, function(s, c, l) {
      e(i, c, o(s, c, l));
    }), i;
  }
  return Fm = n, Fm;
}
var Hre = Wre();
const Vre = /* @__PURE__ */ _e(Hre);
var zm, mA;
function Ure() {
  if (mA) return zm;
  mA = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (!r(t[n], n, t))
        return !1;
    return !0;
  }
  return zm = e, zm;
}
var qm, vA;
function Kre() {
  if (vA) return qm;
  vA = 1;
  var e = a0();
  function t(r, n) {
    var a = !0;
    return e(r, function(o, i, s) {
      return a = !!n(o, i, s), a;
    }), a;
  }
  return qm = t, qm;
}
var Wm, yA;
function Gre() {
  if (yA) return Wm;
  yA = 1;
  var e = Ure(), t = Kre(), r = wr(), n = Nt(), a = rf();
  function o(i, s, c) {
    var l = n(i) ? e : t;
    return c && a(i, s, c) && (s = void 0), l(i, r(s, 3));
  }
  return Wm = o, Wm;
}
var Yre = Gre();
const oR = /* @__PURE__ */ _e(Yre);
var Xre = ["x", "y"];
function ho(e) {
  "@babel/helpers - typeof";
  return ho = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ho(e);
}
function _y() {
  return _y = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _y.apply(this, arguments);
}
function gA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function li(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gA(Object(r), !0).forEach(function(n) {
      Zre(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Zre(e, t, r) {
  return t = Jre(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Jre(e) {
  var t = Qre(e, "string");
  return ho(t) == "symbol" ? t : t + "";
}
function Qre(e, t) {
  if (ho(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ho(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ene(e, t) {
  if (e == null) return {};
  var r = tne(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function tne(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function rne(e, t) {
  var r = e.x, n = e.y, a = ene(e, Xre), o = "".concat(r), i = parseInt(o, 10), s = "".concat(n), c = parseInt(s, 10), l = "".concat(t.height || a.height), u = parseInt(l, 10), f = "".concat(t.width || a.width), d = parseInt(f, 10);
  return li(li(li(li(li({}, t), a), i ? {
    x: i
  } : {}), c ? {
    y: c
  } : {}), {}, {
    height: u,
    width: d,
    name: t.name,
    radius: t.radius
  });
}
function bA(e) {
  return /* @__PURE__ */ E.createElement(Ll, _y({
    shapeType: "rectangle",
    propTransformer: rne,
    activeClassName: "recharts-active-bar"
  }, e));
}
var nne = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, a) {
    if (typeof t == "number") return t;
    var o = J(n) || Xq(n);
    return o ? t(n, a) : (o || (process.env.NODE_ENV !== "production" ? _t(!1, "minPointSize callback function received a value with type of ".concat(ho(n), ". Currently only numbers or null/undefined are supported.")) : _t()), r);
  };
}, ane = ["value", "background"], iR;
function mo(e) {
  "@babel/helpers - typeof";
  return mo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mo(e);
}
function one(e, t) {
  if (e == null) return {};
  var r = ine(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function ine(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Vl() {
  return Vl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Vl.apply(this, arguments);
}
function xA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ue(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xA(Object(r), !0).forEach(function(n) {
      xn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function sne(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function wA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cR(n.key), n);
  }
}
function cne(e, t, r) {
  return t && wA(e.prototype, t), r && wA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function lne(e, t, r) {
  return t = Ul(t), une(e, sR() ? Reflect.construct(t, r || [], Ul(e).constructor) : t.apply(e, r));
}
function une(e, t) {
  if (t && (mo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fne(e);
}
function fne(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (sR = function() {
    return !!e;
  })();
}
function Ul(e) {
  return Ul = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ul(e);
}
function dne(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ey(e, t);
}
function Ey(e, t) {
  return Ey = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Ey(e, t);
}
function xn(e, t, r) {
  return t = cR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function cR(e) {
  var t = pne(e, "string");
  return mo(t) == "symbol" ? t : t + "";
}
function pne(e, t) {
  if (mo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (mo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var dt = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    sne(this, t);
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return r = lne(this, t, [].concat(a)), xn(r, "state", {
      isAnimationFinished: !1
    }), xn(r, "id", In("recharts-bar-")), xn(r, "handleAnimationEnd", function() {
      var i = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), i && i();
    }), xn(r, "handleAnimationStart", function() {
      var i = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), i && i();
    }), r;
  }
  return dne(t, e), cne(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var a = this, o = this.props, i = o.shape, s = o.dataKey, c = o.activeIndex, l = o.activeBar, u = ae(this.props, !1);
      return n && n.map(function(f, d) {
        var p = d === c, g = p ? l : i, m = Ue(Ue(Ue({}, u), f), {}, {
          isActive: p,
          option: g,
          index: d,
          dataKey: s,
          onAnimationStart: a.handleAnimationStart,
          onAnimationEnd: a.handleAnimationEnd
        });
        return /* @__PURE__ */ E.createElement(de, Vl({
          className: "recharts-bar-rectangle"
        }, Cn(a.props, f, d), {
          // https://github.com/recharts/recharts/issues/5415
          // eslint-disable-next-line react/no-array-index-key
          key: "rectangle-".concat(f == null ? void 0 : f.x, "-").concat(f == null ? void 0 : f.y, "-").concat(f == null ? void 0 : f.value, "-").concat(d)
        }), /* @__PURE__ */ E.createElement(bA, m));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, a = this.props, o = a.data, i = a.layout, s = a.isAnimationActive, c = a.animationBegin, l = a.animationDuration, u = a.animationEasing, f = a.animationId, d = this.state.prevData;
      return /* @__PURE__ */ E.createElement(Ft, {
        begin: c,
        duration: l,
        isActive: s,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var g = p.t, m = o.map(function(y, b) {
          var w = d && d[b];
          if (w) {
            var S = Ne(w.x, y.x), P = Ne(w.y, y.y), x = Ne(w.width, y.width), O = Ne(w.height, y.height);
            return Ue(Ue({}, y), {}, {
              x: S(g),
              y: P(g),
              width: x(g),
              height: O(g)
            });
          }
          if (i === "horizontal") {
            var A = Ne(0, y.height), _ = A(g);
            return Ue(Ue({}, y), {}, {
              y: y.y + y.height - _,
              height: _
            });
          }
          var N = Ne(0, y.width), M = N(g);
          return Ue(Ue({}, y), {}, {
            width: M
          });
        });
        return /* @__PURE__ */ E.createElement(de, null, n.renderRectanglesStatically(m));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, a = n.data, o = n.isAnimationActive, i = this.state.prevData;
      return o && a && a.length && (!i || !tn(i, a)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(a);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, a = this.props, o = a.data, i = a.dataKey, s = a.activeIndex, c = ae(this.props.background, !1);
      return o.map(function(l, u) {
        l.value;
        var f = l.background, d = one(l, ane);
        if (!f)
          return null;
        var p = Ue(Ue(Ue(Ue(Ue({}, d), {}, {
          fill: "#eee"
        }, f), c), Cn(n.props, l, u)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: i,
          index: u,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ E.createElement(bA, Vl({
          key: "background-bar-".concat(u),
          option: n.props.background,
          isActive: u === s
        }, p));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var o = this.props, i = o.data, s = o.xAxis, c = o.yAxis, l = o.layout, u = o.children, f = xt(u, Wo);
      if (!f)
        return null;
      var d = l === "vertical" ? i[0].height / 2 : i[0].width / 2, p = function(y, b) {
        var w = Array.isArray(y.value) ? y.value[1] : y.value;
        return {
          x: y.x,
          y: y.y,
          value: w,
          errorVal: ge(y, b)
        };
      }, g = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ E.createElement(de, g, f.map(function(m) {
        return /* @__PURE__ */ E.cloneElement(m, {
          key: "error-bar-".concat(a, "-").concat(m.props.dataKey),
          data: i,
          xAxis: s,
          yAxis: c,
          layout: l,
          offset: d,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, o = n.data, i = n.className, s = n.xAxis, c = n.yAxis, l = n.left, u = n.top, f = n.width, d = n.height, p = n.isAnimationActive, g = n.background, m = n.id;
      if (a || !o || !o.length)
        return null;
      var y = this.state.isAnimationFinished, b = ue("recharts-bar", i), w = s && s.allowDataOverflow, S = c && c.allowDataOverflow, P = w || S, x = ce(m) ? this.id : m;
      return /* @__PURE__ */ E.createElement(de, {
        className: b
      }, w || S ? /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-".concat(x)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: w ? l : l - f / 2,
        y: S ? u : u - d / 2,
        width: w ? f : f * 2,
        height: S ? d : d * 2
      }))) : null, /* @__PURE__ */ E.createElement(de, {
        className: "recharts-bar-rectangles",
        clipPath: P ? "url(#clipPath-".concat(x, ")") : null
      }, g ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(P, x), (!p || y) && Jt.renderCallByParent(this.props, o));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: a.curData
      } : n.data !== a.curData ? {
        curData: n.data
      } : null;
    }
  }]);
})(St);
iR = dt;
xn(dt, "displayName", "Bar");
xn(dt, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Lr.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
xn(dt, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, a = e.bandSize, o = e.xAxis, i = e.yAxis, s = e.xAxisTicks, c = e.yAxisTicks, l = e.stackedData, u = e.dataStartIndex, f = e.displayedData, d = e.offset, p = dZ(n, r);
  if (!p)
    return null;
  var g = t.layout, m = r.type.defaultProps, y = m !== void 0 ? Ue(Ue({}, m), r.props) : r.props, b = y.dataKey, w = y.children, S = y.minPointSize, P = g === "horizontal" ? i : o, x = l ? P.scale.domain() : null, O = bZ({
    numericAxis: P
  }), A = xt(w, gr), _ = f.map(function(N, M) {
    var T, k, $, R, L, j;
    l ? T = pZ(l[u + M], x) : (T = ge(N, b), Array.isArray(T) || (T = [O, T]));
    var z = nne(S, iR.defaultProps.minPointSize)(T[1], M);
    if (g === "horizontal") {
      var q, I = [i.scale(T[0]), i.scale(T[1])], B = I[0], W = I[1];
      k = jO({
        axis: o,
        ticks: s,
        bandSize: a,
        offset: p.offset,
        entry: N,
        index: M
      }), $ = (q = W ?? B) !== null && q !== void 0 ? q : void 0, R = p.size;
      var H = B - W;
      if (L = Number.isNaN(H) ? 0 : H, j = {
        x: k,
        y: i.y,
        width: R,
        height: i.height
      }, Math.abs(z) > 0 && Math.abs(L) < Math.abs(z)) {
        var U = yt(L || z) * (Math.abs(z) - Math.abs(L));
        $ -= U, L += U;
      }
    } else {
      var X = [o.scale(T[0]), o.scale(T[1])], ee = X[0], ne = X[1];
      if (k = ee, $ = jO({
        axis: i,
        ticks: c,
        bandSize: a,
        offset: p.offset,
        entry: N,
        index: M
      }), R = ne - ee, L = p.size, j = {
        x: o.x,
        y: $,
        width: o.width,
        height: L
      }, Math.abs(z) > 0 && Math.abs(R) < Math.abs(z)) {
        var G = yt(R || z) * (Math.abs(z) - Math.abs(R));
        R += G;
      }
    }
    return Ue(Ue(Ue({}, N), {}, {
      x: k,
      y: $,
      width: R,
      height: L,
      value: l ? T : T[1],
      payload: N,
      background: j
    }, A && A[M] && A[M].props), {}, {
      tooltipPayload: [_M(r, N)],
      tooltipPosition: {
        x: k + R / 2,
        y: $ + L / 2
      }
    });
  });
  return Ue({
    data: _,
    layout: g
  }, d);
});
function hs(e) {
  "@babel/helpers - typeof";
  return hs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hs(e);
}
function hne(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function SA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lR(n.key), n);
  }
}
function mne(e, t, r) {
  return t && SA(e.prototype, t), r && SA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function OA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ur(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? OA(Object(r), !0).forEach(function(n) {
      yf(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : OA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yf(e, t, r) {
  return t = lR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function lR(e) {
  var t = vne(e, "string");
  return hs(t) == "symbol" ? t : t + "";
}
function vne(e, t) {
  if (hs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (hs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var gf = function(t, r, n, a, o) {
  var i = t.width, s = t.height, c = t.layout, l = t.children, u = Object.keys(r), f = {
    left: n.left,
    leftMirror: n.left,
    right: i - n.right,
    rightMirror: i - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, d = !!ct(l, dt);
  return u.reduce(function(p, g) {
    var m = r[g], y = m.orientation, b = m.domain, w = m.padding, S = w === void 0 ? {} : w, P = m.mirror, x = m.reversed, O = "".concat(y).concat(P ? "Mirror" : ""), A, _, N, M, T;
    if (m.type === "number" && (m.padding === "gap" || m.padding === "no-gap")) {
      var k = b[1] - b[0], $ = 1 / 0, R = m.categoricalDomain.sort(eW);
      if (R.forEach(function(X, ee) {
        ee > 0 && ($ = Math.min((X || 0) - (R[ee - 1] || 0), $));
      }), Number.isFinite($)) {
        var L = $ / k, j = m.layout === "vertical" ? n.height : n.width;
        if (m.padding === "gap" && (A = L * j / 2), m.padding === "no-gap") {
          var z = gt(t.barCategoryGap, L * j), q = L * j / 2;
          A = q - z - (q - z) / j * z;
        }
      }
    }
    a === "xAxis" ? _ = [n.left + (S.left || 0) + (A || 0), n.left + n.width - (S.right || 0) - (A || 0)] : a === "yAxis" ? _ = c === "horizontal" ? [n.top + n.height - (S.bottom || 0), n.top + (S.top || 0)] : [n.top + (S.top || 0) + (A || 0), n.top + n.height - (S.bottom || 0) - (A || 0)] : _ = m.range, x && (_ = [_[1], _[0]]);
    var I = SM(m, o, d), B = I.scale, W = I.realScaleType;
    B.domain(b).range(_), OM(B);
    var H = PM(B, ur(ur({}, m), {}, {
      realScaleType: W
    }));
    a === "xAxis" ? (T = y === "top" && !P || y === "bottom" && P, N = n.left, M = f[O] - T * m.height) : a === "yAxis" && (T = y === "left" && !P || y === "right" && P, N = f[O] - T * m.width, M = n.top);
    var U = ur(ur(ur({}, m), H), {}, {
      realScaleType: W,
      x: N,
      y: M,
      scale: B,
      width: a === "xAxis" ? n.width : m.width,
      height: a === "yAxis" ? n.height : m.height
    });
    return U.bandSize = Al(U, H), !m.hide && a === "xAxis" ? f[O] += (T ? -1 : 1) * U.height : m.hide || (f[O] += (T ? -1 : 1) * U.width), ur(ur({}, p), {}, yf({}, g, U));
  }, {});
}, uR = function(t, r) {
  var n = t.x, a = t.y, o = r.x, i = r.y;
  return {
    x: Math.min(n, o),
    y: Math.min(a, i),
    width: Math.abs(o - n),
    height: Math.abs(i - a)
  };
}, yne = function(t) {
  var r = t.x1, n = t.y1, a = t.x2, o = t.y2;
  return uR({
    x: r,
    y: n
  }, {
    x: a,
    y: o
  });
}, fR = /* @__PURE__ */ (function() {
  function e(t) {
    hne(this, e), this.scale = t;
  }
  return mne(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.bandAware, o = n.position;
      if (r !== void 0) {
        if (o)
          switch (o) {
            case "start":
              return this.scale(r);
            case "middle": {
              var i = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + i;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (a) {
          var c = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + c;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), a = n[0], o = n[n.length - 1];
      return a <= o ? r >= a && r <= o : r >= o && r <= a;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]);
})();
yf(fR, "EPS", 1e-4);
var R0 = function(t) {
  var r = Object.keys(t).reduce(function(n, a) {
    return ur(ur({}, n), {}, yf({}, a, fR.create(t[a])));
  }, {});
  return ur(ur({}, r), {}, {
    apply: function(a) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = o.bandAware, s = o.position;
      return Vre(a, function(c, l) {
        return r[l].apply(c, {
          bandAware: i,
          position: s
        });
      });
    },
    isInRange: function(a) {
      return oR(a, function(o, i) {
        return r[i].isInRange(o);
      });
    }
  });
};
function gne(e) {
  return (e % 180 + 180) % 180;
}
var bne = function(t) {
  var r = t.width, n = t.height, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = gne(a), i = o * Math.PI / 180, s = Math.atan(n / r), c = i > s && i < Math.PI - s ? n / Math.sin(i) : r / Math.cos(i);
  return Math.abs(c);
}, Hm, PA;
function xne() {
  if (PA) return Hm;
  PA = 1;
  var e = wr(), t = qs(), r = ef();
  function n(a) {
    return function(o, i, s) {
      var c = Object(o);
      if (!t(o)) {
        var l = e(i, 3);
        o = r(o), i = function(f) {
          return l(c[f], f, c);
        };
      }
      var u = a(o, i, s);
      return u > -1 ? c[l ? o[u] : u] : void 0;
    };
  }
  return Hm = n, Hm;
}
var Vm, AA;
function wne() {
  if (AA) return Vm;
  AA = 1;
  var e = tR();
  function t(r) {
    var n = e(r), a = n % 1;
    return n === n ? a ? n - a : n : 0;
  }
  return Vm = t, Vm;
}
var Um, _A;
function Sne() {
  if (_A) return Um;
  _A = 1;
  var e = nT(), t = wr(), r = wne(), n = Math.max;
  function a(o, i, s) {
    var c = o == null ? 0 : o.length;
    if (!c)
      return -1;
    var l = s == null ? 0 : r(s);
    return l < 0 && (l = n(c + l, 0)), e(o, t(i, 3), l);
  }
  return Um = a, Um;
}
var Km, EA;
function One() {
  if (EA) return Km;
  EA = 1;
  var e = xne(), t = Sne(), r = e(t);
  return Km = r, Km;
}
var Pne = One();
const Ane = /* @__PURE__ */ _e(Pne);
var _ne = yN();
const Ene = /* @__PURE__ */ _e(_ne);
var Cne = Ene(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function Kl(e) {
  "@babel/helpers - typeof";
  return Kl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kl(e);
}
var $0 = /* @__PURE__ */ pa(void 0), I0 = /* @__PURE__ */ pa(void 0), dR = /* @__PURE__ */ pa(void 0), pR = /* @__PURE__ */ pa({}), hR = /* @__PURE__ */ pa(void 0), mR = /* @__PURE__ */ pa(0), vR = /* @__PURE__ */ pa(0), CA = function(t) {
  var r = t.state, n = r.xAxisMap, a = r.yAxisMap, o = r.offset, i = t.clipPathId, s = t.children, c = t.width, l = t.height, u = Cne(o);
  return /* @__PURE__ */ E.createElement($0.Provider, {
    value: n
  }, /* @__PURE__ */ E.createElement(I0.Provider, {
    value: a
  }, /* @__PURE__ */ E.createElement(pR.Provider, {
    value: o
  }, /* @__PURE__ */ E.createElement(dR.Provider, {
    value: u
  }, /* @__PURE__ */ E.createElement(hR.Provider, {
    value: i
  }, /* @__PURE__ */ E.createElement(mR.Provider, {
    value: l
  }, /* @__PURE__ */ E.createElement(vR.Provider, {
    value: c
  }, s)))))));
}, kne = function() {
  return nn(hR);
};
function yR(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var gR = function(t) {
  var r = nn($0);
  r == null && (process.env.NODE_ENV !== "production" ? _t(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : _t());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? _t(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(Kl(t), "]. ").concat(yR(r))) : _t()), n;
}, Nne = function() {
  var t = nn($0);
  return gn(t);
}, Tne = function() {
  var t = nn(I0), r = Ane(t, function(n) {
    return oR(n.domain, Number.isFinite);
  });
  return r || gn(t);
}, bR = function(t) {
  var r = nn(I0);
  r == null && (process.env.NODE_ENV !== "production" ? _t(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : _t());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? _t(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(Kl(t), "]. ").concat(yR(r))) : _t()), n;
}, Mne = function() {
  var t = nn(dR);
  return t;
}, Rne = function() {
  return nn(pR);
}, D0 = function() {
  return nn(vR);
}, j0 = function() {
  return nn(mR);
};
function vo(e) {
  "@babel/helpers - typeof";
  return vo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vo(e);
}
function $ne(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ine(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wR(n.key), n);
  }
}
function Dne(e, t, r) {
  return t && Ine(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jne(e, t, r) {
  return t = Gl(t), Lne(e, xR() ? Reflect.construct(t, r || [], Gl(e).constructor) : t.apply(e, r));
}
function Lne(e, t) {
  if (t && (vo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Bne(e);
}
function Bne(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function xR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (xR = function() {
    return !!e;
  })();
}
function Gl(e) {
  return Gl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Gl(e);
}
function Fne(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Cy(e, t);
}
function Cy(e, t) {
  return Cy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Cy(e, t);
}
function kA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function NA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kA(Object(r), !0).forEach(function(n) {
      L0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function L0(e, t, r) {
  return t = wR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function wR(e) {
  var t = zne(e, "string");
  return vo(t) == "symbol" ? t : t + "";
}
function zne(e, t) {
  if (vo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (vo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function qne(e, t) {
  return Une(e) || Vne(e, t) || Hne(e, t) || Wne();
}
function Wne() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hne(e, t) {
  if (e) {
    if (typeof e == "string") return TA(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return TA(e, t);
  }
}
function TA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Vne(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function Une(e) {
  if (Array.isArray(e)) return e;
}
function ky() {
  return ky = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ky.apply(this, arguments);
}
var Kne = function(t, r) {
  var n;
  return /* @__PURE__ */ E.isValidElement(t) ? n = /* @__PURE__ */ E.cloneElement(t, r) : se(t) ? n = t(r) : n = /* @__PURE__ */ E.createElement("line", ky({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, Gne = function(t, r, n, a, o, i, s, c, l) {
  var u = o.x, f = o.y, d = o.width, p = o.height;
  if (n) {
    var g = l.y, m = t.y.apply(g, {
      position: i
    });
    if (Tr(l, "discard") && !t.y.isInRange(m))
      return null;
    var y = [{
      x: u + d,
      y: m
    }, {
      x: u,
      y: m
    }];
    return c === "left" ? y.reverse() : y;
  }
  if (r) {
    var b = l.x, w = t.x.apply(b, {
      position: i
    });
    if (Tr(l, "discard") && !t.x.isInRange(w))
      return null;
    var S = [{
      x: w,
      y: f + p
    }, {
      x: w,
      y: f
    }];
    return s === "top" ? S.reverse() : S;
  }
  if (a) {
    var P = l.segment, x = P.map(function(O) {
      return t.apply(O, {
        position: i
      });
    });
    return Tr(l, "discard") && zre(x, function(O) {
      return !t.isInRange(O);
    }) ? null : x;
  }
  return null;
};
function Yne(e) {
  var t = e.x, r = e.y, n = e.segment, a = e.xAxisId, o = e.yAxisId, i = e.shape, s = e.className, c = e.alwaysShow, l = kne(), u = gR(a), f = bR(o), d = Mne();
  if (!l || !d)
    return null;
  hr(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var p = R0({
    x: u.scale,
    y: f.scale
  }), g = tt(t), m = tt(r), y = n && n.length === 2, b = Gne(p, g, m, y, d, e.position, u.orientation, f.orientation, e);
  if (!b)
    return null;
  var w = qne(b, 2), S = w[0], P = S.x, x = S.y, O = w[1], A = O.x, _ = O.y, N = Tr(e, "hidden") ? "url(#".concat(l, ")") : void 0, M = NA(NA({
    clipPath: N
  }, ae(e, !0)), {}, {
    x1: P,
    y1: x,
    x2: A,
    y2: _
  });
  return /* @__PURE__ */ E.createElement(de, {
    className: ue("recharts-reference-line", s)
  }, Kne(i, M), at.renderCallByParent(e, yne({
    x1: P,
    y1: x,
    x2: A,
    y2: _
  })));
}
var B0 = /* @__PURE__ */ (function(e) {
  function t() {
    return $ne(this, t), jne(this, t, arguments);
  }
  return Fne(t, e), Dne(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ E.createElement(Yne, this.props);
    }
  }]);
})(E.Component);
L0(B0, "displayName", "ReferenceLine");
L0(B0, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function Ny() {
  return Ny = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ny.apply(this, arguments);
}
function yo(e) {
  "@babel/helpers - typeof";
  return yo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yo(e);
}
function MA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function RA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? MA(Object(r), !0).forEach(function(n) {
      bf(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : MA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Xne(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Zne(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, OR(n.key), n);
  }
}
function Jne(e, t, r) {
  return t && Zne(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Qne(e, t, r) {
  return t = Yl(t), eae(e, SR() ? Reflect.construct(t, r || [], Yl(e).constructor) : t.apply(e, r));
}
function eae(e, t) {
  if (t && (yo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return tae(e);
}
function tae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function SR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (SR = function() {
    return !!e;
  })();
}
function Yl(e) {
  return Yl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Yl(e);
}
function rae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ty(e, t);
}
function Ty(e, t) {
  return Ty = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Ty(e, t);
}
function bf(e, t, r) {
  return t = OR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function OR(e) {
  var t = nae(e, "string");
  return yo(t) == "symbol" ? t : t + "";
}
function nae(e, t) {
  if (yo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (yo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var aae = function(t) {
  var r = t.x, n = t.y, a = t.xAxis, o = t.yAxis, i = R0({
    x: a.scale,
    y: o.scale
  }), s = i.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return Tr(t, "discard") && !i.isInRange(s) ? null : s;
}, xf = /* @__PURE__ */ (function(e) {
  function t() {
    return Xne(this, t), Qne(this, t, arguments);
  }
  return rae(t, e), Jne(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x, o = n.y, i = n.r, s = n.alwaysShow, c = n.clipPathId, l = tt(a), u = tt(o);
      if (hr(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !l || !u)
        return null;
      var f = aae(this.props);
      if (!f)
        return null;
      var d = f.x, p = f.y, g = this.props, m = g.shape, y = g.className, b = Tr(this.props, "hidden") ? "url(#".concat(c, ")") : void 0, w = RA(RA({
        clipPath: b
      }, ae(this.props, !0)), {}, {
        cx: d,
        cy: p
      });
      return /* @__PURE__ */ E.createElement(de, {
        className: ue("recharts-reference-dot", y)
      }, t.renderDot(m, w), at.renderCallByParent(this.props, {
        x: d - i,
        y: p - i,
        width: 2 * i,
        height: 2 * i
      }));
    }
  }]);
})(E.Component);
bf(xf, "displayName", "ReferenceDot");
bf(xf, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
bf(xf, "renderDot", function(e, t) {
  var r;
  return /* @__PURE__ */ E.isValidElement(e) ? r = /* @__PURE__ */ E.cloneElement(e, t) : se(e) ? r = e(t) : r = /* @__PURE__ */ E.createElement(Ho, Ny({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function My() {
  return My = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, My.apply(this, arguments);
}
function go(e) {
  "@babel/helpers - typeof";
  return go = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, go(e);
}
function $A(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function IA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $A(Object(r), !0).forEach(function(n) {
      wf(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $A(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function oae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function iae(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, AR(n.key), n);
  }
}
function sae(e, t, r) {
  return t && iae(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cae(e, t, r) {
  return t = Xl(t), lae(e, PR() ? Reflect.construct(t, r || [], Xl(e).constructor) : t.apply(e, r));
}
function lae(e, t) {
  if (t && (go(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return uae(e);
}
function uae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function PR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (PR = function() {
    return !!e;
  })();
}
function Xl(e) {
  return Xl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Xl(e);
}
function fae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ry(e, t);
}
function Ry(e, t) {
  return Ry = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Ry(e, t);
}
function wf(e, t, r) {
  return t = AR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function AR(e) {
  var t = dae(e, "string");
  return go(t) == "symbol" ? t : t + "";
}
function dae(e, t) {
  if (go(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (go(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var pae = function(t, r, n, a, o) {
  var i = o.x1, s = o.x2, c = o.y1, l = o.y2, u = o.xAxis, f = o.yAxis;
  if (!u || !f) return null;
  var d = R0({
    x: u.scale,
    y: f.scale
  }), p = {
    x: t ? d.x.apply(i, {
      position: "start"
    }) : d.x.rangeMin,
    y: n ? d.y.apply(c, {
      position: "start"
    }) : d.y.rangeMin
  }, g = {
    x: r ? d.x.apply(s, {
      position: "end"
    }) : d.x.rangeMax,
    y: a ? d.y.apply(l, {
      position: "end"
    }) : d.y.rangeMax
  };
  return Tr(o, "discard") && (!d.isInRange(p) || !d.isInRange(g)) ? null : uR(p, g);
}, Sf = /* @__PURE__ */ (function(e) {
  function t() {
    return oae(this, t), cae(this, t, arguments);
  }
  return fae(t, e), sae(t, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x1, o = n.x2, i = n.y1, s = n.y2, c = n.className, l = n.alwaysShow, u = n.clipPathId;
      hr(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = tt(a), d = tt(o), p = tt(i), g = tt(s), m = this.props.shape;
      if (!f && !d && !p && !g && !m)
        return null;
      var y = pae(f, d, p, g, this.props);
      if (!y && !m)
        return null;
      var b = Tr(this.props, "hidden") ? "url(#".concat(u, ")") : void 0;
      return /* @__PURE__ */ E.createElement(de, {
        className: ue("recharts-reference-area", c)
      }, t.renderRect(m, IA(IA({
        clipPath: b
      }, ae(this.props, !0)), y)), at.renderCallByParent(this.props, y));
    }
  }]);
})(E.Component);
wf(Sf, "displayName", "ReferenceArea");
wf(Sf, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
wf(Sf, "renderRect", function(e, t) {
  var r;
  return /* @__PURE__ */ E.isValidElement(e) ? r = /* @__PURE__ */ E.cloneElement(e, t) : se(e) ? r = e(t) : r = /* @__PURE__ */ E.createElement(Gs, My({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
});
function _R(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], a = 0; a < e.length; a += t)
    n.push(e[a]);
  return n;
}
function hae(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return bne(n, r);
}
function mae(e, t, r) {
  var n = r === "width", a = e.x, o = e.y, i = e.width, s = e.height;
  return t === 1 ? {
    start: n ? a : o,
    end: n ? a + i : o + s
  } : {
    start: n ? a + i : o + s,
    end: n ? a : o
  };
}
function Zl(e, t, r, n, a) {
  if (e * t < e * n || e * t > e * a)
    return !1;
  var o = r();
  return e * (t - e * o / 2 - n) >= 0 && e * (t + e * o / 2 - a) <= 0;
}
function vae(e, t) {
  return _R(e, t + 1);
}
function yae(e, t, r, n, a) {
  for (var o = (n || []).slice(), i = t.start, s = t.end, c = 0, l = 1, u = i, f = function() {
    var g = n == null ? void 0 : n[c];
    if (g === void 0)
      return {
        v: _R(n, l)
      };
    var m = c, y, b = function() {
      return y === void 0 && (y = r(g, m)), y;
    }, w = g.coordinate, S = c === 0 || Zl(e, w, b, u, s);
    S || (c = 0, u = i, l += 1), S && (u = w + e * (b() / 2 + a), c += l);
  }, d; l <= o.length; )
    if (d = f(), d) return d.v;
  return [];
}
function ms(e) {
  "@babel/helpers - typeof";
  return ms = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ms(e);
}
function DA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ut(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DA(Object(r), !0).forEach(function(n) {
      gae(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : DA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function gae(e, t, r) {
  return t = bae(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bae(e) {
  var t = xae(e, "string");
  return ms(t) == "symbol" ? t : t + "";
}
function xae(e, t) {
  if (ms(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ms(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function wae(e, t, r, n, a) {
  for (var o = (n || []).slice(), i = o.length, s = t.start, c = t.end, l = function(d) {
    var p = o[d], g, m = function() {
      return g === void 0 && (g = r(p, d)), g;
    };
    if (d === i - 1) {
      var y = e * (p.coordinate + e * m() / 2 - c);
      o[d] = p = ut(ut({}, p), {}, {
        tickCoord: y > 0 ? p.coordinate - y * e : p.coordinate
      });
    } else
      o[d] = p = ut(ut({}, p), {}, {
        tickCoord: p.coordinate
      });
    var b = Zl(e, p.tickCoord, m, s, c);
    b && (c = p.tickCoord - e * (m() / 2 + a), o[d] = ut(ut({}, p), {}, {
      isShow: !0
    }));
  }, u = i - 1; u >= 0; u--)
    l(u);
  return o;
}
function Sae(e, t, r, n, a, o) {
  var i = (n || []).slice(), s = i.length, c = t.start, l = t.end;
  if (o) {
    var u = n[s - 1], f = r(u, s - 1), d = e * (u.coordinate + e * f / 2 - l);
    i[s - 1] = u = ut(ut({}, u), {}, {
      tickCoord: d > 0 ? u.coordinate - d * e : u.coordinate
    });
    var p = Zl(e, u.tickCoord, function() {
      return f;
    }, c, l);
    p && (l = u.tickCoord - e * (f / 2 + a), i[s - 1] = ut(ut({}, u), {}, {
      isShow: !0
    }));
  }
  for (var g = o ? s - 1 : s, m = function(w) {
    var S = i[w], P, x = function() {
      return P === void 0 && (P = r(S, w)), P;
    };
    if (w === 0) {
      var O = e * (S.coordinate - e * x() / 2 - c);
      i[w] = S = ut(ut({}, S), {}, {
        tickCoord: O < 0 ? S.coordinate - O * e : S.coordinate
      });
    } else
      i[w] = S = ut(ut({}, S), {}, {
        tickCoord: S.coordinate
      });
    var A = Zl(e, S.tickCoord, x, c, l);
    A && (c = S.tickCoord + e * (x() / 2 + a), i[w] = ut(ut({}, S), {}, {
      isShow: !0
    }));
  }, y = 0; y < g; y++)
    m(y);
  return i;
}
function F0(e, t, r) {
  var n = e.tick, a = e.ticks, o = e.viewBox, i = e.minTickGap, s = e.orientation, c = e.interval, l = e.tickFormatter, u = e.unit, f = e.angle;
  if (!a || !a.length || !n)
    return [];
  if (J(c) || Lr.isSsr)
    return vae(a, typeof c == "number" && J(c) ? c : 0);
  var d = [], p = s === "top" || s === "bottom" ? "width" : "height", g = u && p === "width" ? yi(u, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, m = function(S, P) {
    var x = se(l) ? l(S.value, P) : S.value;
    return p === "width" ? hae(yi(x, {
      fontSize: t,
      letterSpacing: r
    }), g, f) : yi(x, {
      fontSize: t,
      letterSpacing: r
    })[p];
  }, y = a.length >= 2 ? yt(a[1].coordinate - a[0].coordinate) : 1, b = mae(o, y, p);
  return c === "equidistantPreserveStart" ? yae(y, b, m, a, i) : (c === "preserveStart" || c === "preserveStartEnd" ? d = Sae(y, b, m, a, i, c === "preserveStartEnd") : d = wae(y, b, m, a, i), d.filter(function(w) {
    return w.isShow;
  }));
}
var Oae = ["viewBox"], Pae = ["viewBox"], Aae = ["ticks"];
function bo(e) {
  "@babel/helpers - typeof";
  return bo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bo(e);
}
function Da() {
  return Da = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Da.apply(this, arguments);
}
function jA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jA(Object(r), !0).forEach(function(n) {
      z0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Gm(e, t) {
  if (e == null) return {};
  var r = _ae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function _ae(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Eae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function LA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, CR(n.key), n);
  }
}
function Cae(e, t, r) {
  return t && LA(e.prototype, t), r && LA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function kae(e, t, r) {
  return t = Jl(t), Nae(e, ER() ? Reflect.construct(t, r || [], Jl(e).constructor) : t.apply(e, r));
}
function Nae(e, t) {
  if (t && (bo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Tae(e);
}
function Tae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ER() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ER = function() {
    return !!e;
  })();
}
function Jl(e) {
  return Jl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Jl(e);
}
function Mae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $y(e, t);
}
function $y(e, t) {
  return $y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, $y(e, t);
}
function z0(e, t, r) {
  return t = CR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function CR(e) {
  var t = Rae(e, "string");
  return bo(t) == "symbol" ? t : t + "";
}
function Rae(e, t) {
  if (bo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (bo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ko = /* @__PURE__ */ (function(e) {
  function t(r) {
    var n;
    return Eae(this, t), n = kae(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return Mae(t, e), Cae(t, [{
    key: "shouldComponentUpdate",
    value: function(n, a) {
      var o = n.viewBox, i = Gm(n, Oae), s = this.props, c = s.viewBox, l = Gm(s, Pae);
      return !ra(o, c) || !ra(i, l) || !ra(a, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var a = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        a && this.setState({
          fontSize: window.getComputedStyle(a).fontSize,
          letterSpacing: window.getComputedStyle(a).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var a = this.props, o = a.x, i = a.y, s = a.width, c = a.height, l = a.orientation, u = a.tickSize, f = a.mirror, d = a.tickMargin, p, g, m, y, b, w, S = f ? -1 : 1, P = n.tickSize || u, x = J(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (l) {
        case "top":
          p = g = n.coordinate, y = i + +!f * c, m = y - S * P, w = m - S * d, b = x;
          break;
        case "left":
          m = y = n.coordinate, g = o + +!f * s, p = g - S * P, b = p - S * d, w = x;
          break;
        case "right":
          m = y = n.coordinate, g = o + +f * s, p = g + S * P, b = p + S * d, w = x;
          break;
        default:
          p = g = n.coordinate, y = i + +f * c, m = y + S * P, w = m + S * d, b = x;
          break;
      }
      return {
        line: {
          x1: p,
          y1: m,
          x2: g,
          y2: y
        },
        tick: {
          x: b,
          y: w
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, a = n.orientation, o = n.mirror, i;
      switch (a) {
        case "left":
          i = o ? "start" : "end";
          break;
        case "right":
          i = o ? "end" : "start";
          break;
        default:
          i = "middle";
          break;
      }
      return i;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, a = n.orientation, o = n.mirror, i = "end";
      switch (a) {
        case "left":
        case "right":
          i = "middle";
          break;
        case "top":
          i = o ? "start" : "end";
          break;
        default:
          i = o ? "end" : "start";
          break;
      }
      return i;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.x, o = n.y, i = n.width, s = n.height, c = n.orientation, l = n.mirror, u = n.axisLine, f = Xe(Xe(Xe({}, ae(this.props, !1)), ae(u, !1)), {}, {
        fill: "none"
      });
      if (c === "top" || c === "bottom") {
        var d = +(c === "top" && !l || c === "bottom" && l);
        f = Xe(Xe({}, f), {}, {
          x1: a,
          y1: o + d * s,
          x2: a + i,
          y2: o + d * s
        });
      } else {
        var p = +(c === "left" && !l || c === "right" && l);
        f = Xe(Xe({}, f), {}, {
          x1: a + p * i,
          y1: o,
          x2: a + p * i,
          y2: o + s
        });
      }
      return /* @__PURE__ */ E.createElement("line", Da({}, f, {
        className: ue("recharts-cartesian-axis-line", lt(u, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, a, o) {
        var i = this, s = this.props, c = s.tickLine, l = s.stroke, u = s.tick, f = s.tickFormatter, d = s.unit, p = F0(Xe(Xe({}, this.props), {}, {
          ticks: n
        }), a, o), g = this.getTickTextAnchor(), m = this.getTickVerticalAnchor(), y = ae(this.props, !1), b = ae(u, !1), w = Xe(Xe({}, y), {}, {
          fill: "none"
        }, ae(c, !1)), S = p.map(function(P, x) {
          var O = i.getTickLineCoord(P), A = O.line, _ = O.tick, N = Xe(Xe(Xe(Xe({
            textAnchor: g,
            verticalAnchor: m
          }, y), {}, {
            stroke: "none",
            fill: l
          }, b), _), {}, {
            index: x,
            payload: P,
            visibleTicksCount: p.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ E.createElement(de, Da({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(P.value, "-").concat(P.coordinate, "-").concat(P.tickCoord)
          }, Cn(i.props, P, x)), c && /* @__PURE__ */ E.createElement("line", Da({}, w, A, {
            className: ue("recharts-cartesian-axis-tick-line", lt(c, "className"))
          })), u && t.renderTickItem(u, N, "".concat(se(f) ? f(P.value, x) : P.value).concat(d || "")));
        });
        return /* @__PURE__ */ E.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, S);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, o = a.axisLine, i = a.width, s = a.height, c = a.ticksGenerator, l = a.className, u = a.hide;
      if (u)
        return null;
      var f = this.props, d = f.ticks, p = Gm(f, Aae), g = d;
      return se(c) && (g = d && d.length > 0 ? c(this.props) : c(p)), i <= 0 || s <= 0 || !g || !g.length ? null : /* @__PURE__ */ E.createElement(de, {
        className: ue("recharts-cartesian-axis", l),
        ref: function(y) {
          n.layerReference = y;
        }
      }, o && this.renderAxisLine(), this.renderTicks(g, this.state.fontSize, this.state.letterSpacing), at.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, o) {
      var i, s = ue(a.className, "recharts-cartesian-axis-tick-value");
      return /* @__PURE__ */ E.isValidElement(n) ? i = /* @__PURE__ */ E.cloneElement(n, Xe(Xe({}, a), {}, {
        className: s
      })) : se(n) ? i = n(Xe(Xe({}, a), {}, {
        className: s
      })) : i = /* @__PURE__ */ E.createElement(ua, Da({}, a, {
        className: "recharts-cartesian-axis-tick-value"
      }), o), i;
    }
  }]);
})(m_);
z0(Ko, "displayName", "CartesianAxis");
z0(Ko, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var $ae = ["x1", "y1", "x2", "y2", "key"], Iae = ["offset"];
function da(e) {
  "@babel/helpers - typeof";
  return da = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, da(e);
}
function BA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ft(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? BA(Object(r), !0).forEach(function(n) {
      Dae(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : BA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Dae(e, t, r) {
  return t = jae(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jae(e) {
  var t = Lae(e, "string");
  return da(t) == "symbol" ? t : t + "";
}
function Lae(e, t) {
  if (da(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (da(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Qn() {
  return Qn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Qn.apply(this, arguments);
}
function FA(e, t) {
  if (e == null) return {};
  var r = Bae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Bae(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var Fae = function(t) {
  var r = t.fill;
  if (!r || r === "none")
    return null;
  var n = t.fillOpacity, a = t.x, o = t.y, i = t.width, s = t.height, c = t.ry;
  return /* @__PURE__ */ E.createElement("rect", {
    x: a,
    y: o,
    ry: c,
    width: i,
    height: s,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function kR(e, t) {
  var r;
  if (/* @__PURE__ */ E.isValidElement(e))
    r = /* @__PURE__ */ E.cloneElement(e, t);
  else if (se(e))
    r = e(t);
  else {
    var n = t.x1, a = t.y1, o = t.x2, i = t.y2, s = t.key, c = FA(t, $ae), l = ae(c, !1);
    l.offset;
    var u = FA(l, Iae);
    r = /* @__PURE__ */ E.createElement("line", Qn({}, u, {
      x1: n,
      y1: a,
      x2: o,
      y2: i,
      fill: "none",
      key: s
    }));
  }
  return r;
}
function zae(e) {
  var t = e.x, r = e.width, n = e.horizontal, a = n === void 0 ? !0 : n, o = e.horizontalPoints;
  if (!a || !o || !o.length)
    return null;
  var i = o.map(function(s, c) {
    var l = ft(ft({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + r,
      y2: s,
      key: "line-".concat(c),
      index: c
    });
    return kR(a, l);
  });
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, i);
}
function qae(e) {
  var t = e.y, r = e.height, n = e.vertical, a = n === void 0 ? !0 : n, o = e.verticalPoints;
  if (!a || !o || !o.length)
    return null;
  var i = o.map(function(s, c) {
    var l = ft(ft({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + r,
      key: "line-".concat(c),
      index: c
    });
    return kR(a, l);
  });
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, i);
}
function Wae(e) {
  var t = e.horizontalFill, r = e.fillOpacity, n = e.x, a = e.y, o = e.width, i = e.height, s = e.horizontalPoints, c = e.horizontal, l = c === void 0 ? !0 : c;
  if (!l || !t || !t.length)
    return null;
  var u = s.map(function(d) {
    return Math.round(d + a - a);
  }).sort(function(d, p) {
    return d - p;
  });
  a !== u[0] && u.unshift(0);
  var f = u.map(function(d, p) {
    var g = !u[p + 1], m = g ? a + i - d : u[p + 1] - d;
    if (m <= 0)
      return null;
    var y = p % t.length;
    return /* @__PURE__ */ E.createElement("rect", {
      key: "react-".concat(p),
      y: d,
      x: n,
      height: m,
      width: o,
      stroke: "none",
      fill: t[y],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, f);
}
function Hae(e) {
  var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, a = e.fillOpacity, o = e.x, i = e.y, s = e.width, c = e.height, l = e.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var u = l.map(function(d) {
    return Math.round(d + o - o);
  }).sort(function(d, p) {
    return d - p;
  });
  o !== u[0] && u.unshift(0);
  var f = u.map(function(d, p) {
    var g = !u[p + 1], m = g ? o + s - d : u[p + 1] - d;
    if (m <= 0)
      return null;
    var y = p % n.length;
    return /* @__PURE__ */ E.createElement("rect", {
      key: "react-".concat(p),
      x: d,
      y: i,
      width: m,
      height: c,
      stroke: "none",
      fill: n[y],
      fillOpacity: a,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, f);
}
var Vae = function(t, r) {
  var n = t.xAxis, a = t.width, o = t.height, i = t.offset;
  return wM(F0(ft(ft(ft({}, Ko.defaultProps), n), {}, {
    ticks: Ur(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: o
    }
  })), i.left, i.left + i.width, r);
}, Uae = function(t, r) {
  var n = t.yAxis, a = t.width, o = t.height, i = t.offset;
  return wM(F0(ft(ft(ft({}, Ko.defaultProps), n), {}, {
    ticks: Ur(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: o
    }
  })), i.top, i.top + i.height, r);
}, Na = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function Bn(e) {
  var t, r, n, a, o, i, s = D0(), c = j0(), l = Rne(), u = ft(ft({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : Na.stroke,
    fill: (r = e.fill) !== null && r !== void 0 ? r : Na.fill,
    horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : Na.horizontal,
    horizontalFill: (a = e.horizontalFill) !== null && a !== void 0 ? a : Na.horizontalFill,
    vertical: (o = e.vertical) !== null && o !== void 0 ? o : Na.vertical,
    verticalFill: (i = e.verticalFill) !== null && i !== void 0 ? i : Na.verticalFill,
    x: J(e.x) ? e.x : l.left,
    y: J(e.y) ? e.y : l.top,
    width: J(e.width) ? e.width : l.width,
    height: J(e.height) ? e.height : l.height
  }), f = u.x, d = u.y, p = u.width, g = u.height, m = u.syncWithTicks, y = u.horizontalValues, b = u.verticalValues, w = Nne(), S = Tne();
  if (!J(p) || p <= 0 || !J(g) || g <= 0 || !J(f) || f !== +f || !J(d) || d !== +d)
    return null;
  var P = u.verticalCoordinatesGenerator || Vae, x = u.horizontalCoordinatesGenerator || Uae, O = u.horizontalPoints, A = u.verticalPoints;
  if ((!O || !O.length) && se(x)) {
    var _ = y && y.length, N = x({
      yAxis: S ? ft(ft({}, S), {}, {
        ticks: _ ? y : S.ticks
      }) : void 0,
      width: s,
      height: c,
      offset: l
    }, _ ? !0 : m);
    hr(Array.isArray(N), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(da(N), "]")), Array.isArray(N) && (O = N);
  }
  if ((!A || !A.length) && se(P)) {
    var M = b && b.length, T = P({
      xAxis: w ? ft(ft({}, w), {}, {
        ticks: M ? b : w.ticks
      }) : void 0,
      width: s,
      height: c,
      offset: l
    }, M ? !0 : m);
    hr(Array.isArray(T), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(da(T), "]")), Array.isArray(T) && (A = T);
  }
  return /* @__PURE__ */ E.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ E.createElement(Fae, {
    fill: u.fill,
    fillOpacity: u.fillOpacity,
    x: u.x,
    y: u.y,
    width: u.width,
    height: u.height,
    ry: u.ry
  }), /* @__PURE__ */ E.createElement(zae, Qn({}, u, {
    offset: l,
    horizontalPoints: O,
    xAxis: w,
    yAxis: S
  })), /* @__PURE__ */ E.createElement(qae, Qn({}, u, {
    offset: l,
    verticalPoints: A,
    xAxis: w,
    yAxis: S
  })), /* @__PURE__ */ E.createElement(Wae, Qn({}, u, {
    horizontalPoints: O
  })), /* @__PURE__ */ E.createElement(Hae, Qn({}, u, {
    verticalPoints: A
  })));
}
Bn.displayName = "CartesianGrid";
var Kae = ["type", "layout", "connectNulls", "ref"], Gae = ["key"];
function xo(e) {
  "@babel/helpers - typeof";
  return xo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xo(e);
}
function zA(e, t) {
  if (e == null) return {};
  var r = Yae(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Yae(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Oi() {
  return Oi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Oi.apply(this, arguments);
}
function qA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $t(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qA(Object(r), !0).forEach(function(n) {
      fr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ta(e) {
  return Qae(e) || Jae(e) || Zae(e) || Xae();
}
function Xae() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zae(e, t) {
  if (e) {
    if (typeof e == "string") return Iy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Iy(e, t);
  }
}
function Jae(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Qae(e) {
  if (Array.isArray(e)) return Iy(e);
}
function Iy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function eoe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function WA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, TR(n.key), n);
  }
}
function toe(e, t, r) {
  return t && WA(e.prototype, t), r && WA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function roe(e, t, r) {
  return t = Ql(t), noe(e, NR() ? Reflect.construct(t, r || [], Ql(e).constructor) : t.apply(e, r));
}
function noe(e, t) {
  if (t && (xo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return aoe(e);
}
function aoe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function NR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (NR = function() {
    return !!e;
  })();
}
function Ql(e) {
  return Ql = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ql(e);
}
function ooe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Dy(e, t);
}
function Dy(e, t) {
  return Dy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Dy(e, t);
}
function fr(e, t, r) {
  return t = TR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function TR(e) {
  var t = ioe(e, "string");
  return xo(t) == "symbol" ? t : t + "";
}
function ioe(e, t) {
  if (xo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (xo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Ys = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    eoe(this, t);
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return r = roe(this, t, [].concat(a)), fr(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), fr(r, "generateSimpleStrokeDasharray", function(i, s) {
      return "".concat(s, "px ").concat(i - s, "px");
    }), fr(r, "getStrokeDasharray", function(i, s, c) {
      var l = c.reduce(function(b, w) {
        return b + w;
      });
      if (!l)
        return r.generateSimpleStrokeDasharray(s, i);
      for (var u = Math.floor(i / l), f = i % l, d = s - i, p = [], g = 0, m = 0; g < c.length; m += c[g], ++g)
        if (m + c[g] > f) {
          p = [].concat(Ta(c.slice(0, g)), [f - m]);
          break;
        }
      var y = p.length % 2 === 0 ? [0, d] : [d];
      return [].concat(Ta(t.repeat(c, u)), Ta(p), y).map(function(b) {
        return "".concat(b, "px");
      }).join(", ");
    }), fr(r, "id", In("recharts-line-")), fr(r, "pathRef", function(i) {
      r.mainCurve = i;
    }), fr(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), fr(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return ooe(t, e), toe(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var o = this.props, i = o.points, s = o.xAxis, c = o.yAxis, l = o.layout, u = o.children, f = xt(u, Wo);
      if (!f)
        return null;
      var d = function(m, y) {
        return {
          x: m.x,
          y: m.y,
          value: m.value,
          errorVal: ge(m.payload, y)
        };
      }, p = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ E.createElement(de, p, f.map(function(g) {
        return /* @__PURE__ */ E.cloneElement(g, {
          key: "bar-".concat(g.props.dataKey),
          data: i,
          xAxis: s,
          yAxis: c,
          layout: l,
          dataPointFormatter: d
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, a, o) {
      var i = this.props.isAnimationActive;
      if (i && !this.state.isAnimationFinished)
        return null;
      var s = this.props, c = s.dot, l = s.points, u = s.dataKey, f = ae(this.props, !1), d = ae(c, !0), p = l.map(function(m, y) {
        var b = $t($t($t({
          key: "dot-".concat(y),
          r: 3
        }, f), d), {}, {
          index: y,
          cx: m.x,
          cy: m.y,
          value: m.value,
          dataKey: u,
          payload: m.payload,
          points: l
        });
        return t.renderDotItem(c, b);
      }), g = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(o, ")") : null
      };
      return /* @__PURE__ */ E.createElement(de, Oi({
        className: "recharts-line-dots",
        key: "dots"
      }, g), p);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, a, o, i) {
      var s = this.props, c = s.type, l = s.layout, u = s.connectNulls;
      s.ref;
      var f = zA(s, Kae), d = $t($t($t({}, ae(f, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: a ? "url(#clipPath-".concat(o, ")") : null,
        points: n
      }, i), {}, {
        type: c,
        layout: l,
        connectNulls: u
      });
      return /* @__PURE__ */ E.createElement(Pn, Oi({}, d, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, a) {
      var o = this, i = this.props, s = i.points, c = i.strokeDasharray, l = i.isAnimationActive, u = i.animationBegin, f = i.animationDuration, d = i.animationEasing, p = i.animationId, g = i.animateNewValues, m = i.width, y = i.height, b = this.state, w = b.prevPoints, S = b.totalLength;
      return /* @__PURE__ */ E.createElement(Ft, {
        begin: u,
        duration: f,
        isActive: l,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(P) {
        var x = P.t;
        if (w) {
          var O = w.length / s.length, A = s.map(function(k, $) {
            var R = Math.floor($ * O);
            if (w[R]) {
              var L = w[R], j = Ne(L.x, k.x), z = Ne(L.y, k.y);
              return $t($t({}, k), {}, {
                x: j(x),
                y: z(x)
              });
            }
            if (g) {
              var q = Ne(m * 2, k.x), I = Ne(y / 2, k.y);
              return $t($t({}, k), {}, {
                x: q(x),
                y: I(x)
              });
            }
            return $t($t({}, k), {}, {
              x: k.x,
              y: k.y
            });
          });
          return o.renderCurveStatically(A, n, a);
        }
        var _ = Ne(0, S), N = _(x), M;
        if (c) {
          var T = "".concat(c).split(/[,\s]+/gim).map(function(k) {
            return parseFloat(k);
          });
          M = o.getStrokeDasharray(N, S, T);
        } else
          M = o.generateSimpleStrokeDasharray(S, N);
        return o.renderCurveStatically(s, n, a, {
          strokeDasharray: M
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, a) {
      var o = this.props, i = o.points, s = o.isAnimationActive, c = this.state, l = c.prevPoints, u = c.totalLength;
      return s && i && i.length && (!l && u > 0 || !tn(l, i)) ? this.renderCurveWithAnimation(n, a) : this.renderCurveStatically(i, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, o = a.hide, i = a.dot, s = a.points, c = a.className, l = a.xAxis, u = a.yAxis, f = a.top, d = a.left, p = a.width, g = a.height, m = a.isAnimationActive, y = a.id;
      if (o || !s || !s.length)
        return null;
      var b = this.state.isAnimationFinished, w = s.length === 1, S = ue("recharts-line", c), P = l && l.allowDataOverflow, x = u && u.allowDataOverflow, O = P || x, A = ce(y) ? this.id : y, _ = (n = ae(i, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, N = _.r, M = N === void 0 ? 3 : N, T = _.strokeWidth, k = T === void 0 ? 2 : T, $ = ON(i) ? i : {}, R = $.clipDot, L = R === void 0 ? !0 : R, j = M * 2 + k;
      return /* @__PURE__ */ E.createElement(de, {
        className: S
      }, P || x ? /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-".concat(A)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: P ? d : d - p / 2,
        y: x ? f : f - g / 2,
        width: P ? p : p * 2,
        height: x ? g : g * 2
      })), !L && /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-dots-".concat(A)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: d - j / 2,
        y: f - j / 2,
        width: p + j,
        height: g + j
      }))) : null, !w && this.renderCurve(O, A), this.renderErrorBar(O, A), (w || i) && this.renderDots(O, L, A), (!m || b) && Jt.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, a) {
      for (var o = n.length % 2 !== 0 ? [].concat(Ta(n), [0]) : n, i = [], s = 0; s < a; ++s)
        i = [].concat(Ta(i), Ta(o));
      return i;
    }
  }, {
    key: "renderDotItem",
    value: function(n, a) {
      var o;
      if (/* @__PURE__ */ E.isValidElement(n))
        o = /* @__PURE__ */ E.cloneElement(n, a);
      else if (se(n))
        o = n(a);
      else {
        var i = a.key, s = zA(a, Gae), c = ue("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        o = /* @__PURE__ */ E.createElement(Ho, Oi({
          key: i
        }, s, {
          className: c
        }));
      }
      return o;
    }
  }]);
})(St);
fr(Ys, "displayName", "Line");
fr(Ys, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Lr.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
fr(Ys, "getComposedData", function(e) {
  var t = e.props, r = e.xAxis, n = e.yAxis, a = e.xAxisTicks, o = e.yAxisTicks, i = e.dataKey, s = e.bandSize, c = e.displayedData, l = e.offset, u = t.layout, f = c.map(function(d, p) {
    var g = ge(d, i);
    return u === "horizontal" ? {
      x: ao({
        axis: r,
        ticks: a,
        bandSize: s,
        entry: d,
        index: p
      }),
      y: ce(g) ? null : n.scale(g),
      value: g,
      payload: d
    } : {
      x: ce(g) ? null : r.scale(g),
      y: ao({
        axis: n,
        ticks: o,
        bandSize: s,
        entry: d,
        index: p
      }),
      value: g,
      payload: d
    };
  });
  return $t({
    points: f,
    layout: u
  }, l);
});
var soe = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], coe = ["key"], MR;
function wo(e) {
  "@babel/helpers - typeof";
  return wo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wo(e);
}
function RR(e, t) {
  if (e == null) return {};
  var r = loe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function loe(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function ea() {
  return ea = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ea.apply(this, arguments);
}
function HA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? HA(Object(r), !0).forEach(function(n) {
      Cr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : HA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uoe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function VA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, IR(n.key), n);
  }
}
function foe(e, t, r) {
  return t && VA(e.prototype, t), r && VA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function doe(e, t, r) {
  return t = eu(t), poe(e, $R() ? Reflect.construct(t, r || [], eu(e).constructor) : t.apply(e, r));
}
function poe(e, t) {
  if (t && (wo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return hoe(e);
}
function hoe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $R() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return ($R = function() {
    return !!e;
  })();
}
function eu(e) {
  return eu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, eu(e);
}
function moe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jy(e, t);
}
function jy(e, t) {
  return jy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, jy(e, t);
}
function Cr(e, t, r) {
  return t = IR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function IR(e) {
  var t = voe(e, "string");
  return wo(t) == "symbol" ? t : t + "";
}
function voe(e, t) {
  if (wo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (wo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Qe = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    uoe(this, t);
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return r = doe(this, t, [].concat(a)), Cr(r, "state", {
      isAnimationFinished: !0
    }), Cr(r, "id", In("recharts-area-")), Cr(r, "handleAnimationEnd", function() {
      var i = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), se(i) && i();
    }), Cr(r, "handleAnimationStart", function() {
      var i = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), se(i) && i();
    }), r;
  }
  return moe(t, e), foe(t, [{
    key: "renderDots",
    value: function(n, a, o) {
      var i = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (i && !s)
        return null;
      var c = this.props, l = c.dot, u = c.points, f = c.dataKey, d = ae(this.props, !1), p = ae(l, !0), g = u.map(function(y, b) {
        var w = vn(vn(vn({
          key: "dot-".concat(b),
          r: 3
        }, d), p), {}, {
          index: b,
          cx: y.x,
          cy: y.y,
          dataKey: f,
          value: y.value,
          payload: y.payload,
          points: u
        });
        return t.renderDotItem(l, w);
      }), m = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(o, ")") : null
      };
      return /* @__PURE__ */ E.createElement(de, ea({
        className: "recharts-area-dots"
      }, m), g);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var a = this.props, o = a.baseLine, i = a.points, s = a.strokeWidth, c = i[0].x, l = i[i.length - 1].x, u = n * Math.abs(c - l), f = bn(i.map(function(d) {
        return d.y || 0;
      }));
      return J(o) && typeof o == "number" ? f = Math.max(o, f) : o && Array.isArray(o) && o.length && (f = Math.max(bn(o.map(function(d) {
        return d.y || 0;
      })), f)), J(f) ? /* @__PURE__ */ E.createElement("rect", {
        x: c < l ? c : c - u,
        y: 0,
        width: u,
        height: Math.floor(f + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var a = this.props, o = a.baseLine, i = a.points, s = a.strokeWidth, c = i[0].y, l = i[i.length - 1].y, u = n * Math.abs(c - l), f = bn(i.map(function(d) {
        return d.x || 0;
      }));
      return J(o) && typeof o == "number" ? f = Math.max(o, f) : o && Array.isArray(o) && o.length && (f = Math.max(bn(o.map(function(d) {
        return d.x || 0;
      })), f)), J(f) ? /* @__PURE__ */ E.createElement("rect", {
        x: 0,
        y: c < l ? c : c - u,
        width: f + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(u)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var a = this.props.layout;
      return a === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, a, o, i) {
      var s = this.props, c = s.layout, l = s.type, u = s.stroke, f = s.connectNulls, d = s.isRange;
      s.ref;
      var p = RR(s, soe);
      return /* @__PURE__ */ E.createElement(de, {
        clipPath: o ? "url(#clipPath-".concat(i, ")") : null
      }, /* @__PURE__ */ E.createElement(Pn, ea({}, ae(p, !0), {
        points: n,
        connectNulls: f,
        type: l,
        baseLine: a,
        layout: c,
        stroke: "none",
        className: "recharts-area-area"
      })), u !== "none" && /* @__PURE__ */ E.createElement(Pn, ea({}, ae(this.props, !1), {
        className: "recharts-area-curve",
        layout: c,
        type: l,
        connectNulls: f,
        fill: "none",
        points: n
      })), u !== "none" && d && /* @__PURE__ */ E.createElement(Pn, ea({}, ae(this.props, !1), {
        className: "recharts-area-curve",
        layout: c,
        type: l,
        connectNulls: f,
        fill: "none",
        points: a
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, a) {
      var o = this, i = this.props, s = i.points, c = i.baseLine, l = i.isAnimationActive, u = i.animationBegin, f = i.animationDuration, d = i.animationEasing, p = i.animationId, g = this.state, m = g.prevPoints, y = g.prevBaseLine;
      return /* @__PURE__ */ E.createElement(Ft, {
        begin: u,
        duration: f,
        isActive: l,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(b) {
        var w = b.t;
        if (m) {
          var S = m.length / s.length, P = s.map(function(_, N) {
            var M = Math.floor(N * S);
            if (m[M]) {
              var T = m[M], k = Ne(T.x, _.x), $ = Ne(T.y, _.y);
              return vn(vn({}, _), {}, {
                x: k(w),
                y: $(w)
              });
            }
            return _;
          }), x;
          if (J(c) && typeof c == "number") {
            var O = Ne(y, c);
            x = O(w);
          } else if (ce(c) || Lo(c)) {
            var A = Ne(y, 0);
            x = A(w);
          } else
            x = c.map(function(_, N) {
              var M = Math.floor(N * S);
              if (y[M]) {
                var T = y[M], k = Ne(T.x, _.x), $ = Ne(T.y, _.y);
                return vn(vn({}, _), {}, {
                  x: k(w),
                  y: $(w)
                });
              }
              return _;
            });
          return o.renderAreaStatically(P, x, n, a);
        }
        return /* @__PURE__ */ E.createElement(de, null, /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
          id: "animationClipPath-".concat(a)
        }, o.renderClipRect(w))), /* @__PURE__ */ E.createElement(de, {
          clipPath: "url(#animationClipPath-".concat(a, ")")
        }, o.renderAreaStatically(s, c, n, a)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, a) {
      var o = this.props, i = o.points, s = o.baseLine, c = o.isAnimationActive, l = this.state, u = l.prevPoints, f = l.prevBaseLine, d = l.totalLength;
      return c && i && i.length && (!u && d > 0 || !tn(u, i) || !tn(f, s)) ? this.renderAreaWithAnimation(n, a) : this.renderAreaStatically(i, s, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, o = a.hide, i = a.dot, s = a.points, c = a.className, l = a.top, u = a.left, f = a.xAxis, d = a.yAxis, p = a.width, g = a.height, m = a.isAnimationActive, y = a.id;
      if (o || !s || !s.length)
        return null;
      var b = this.state.isAnimationFinished, w = s.length === 1, S = ue("recharts-area", c), P = f && f.allowDataOverflow, x = d && d.allowDataOverflow, O = P || x, A = ce(y) ? this.id : y, _ = (n = ae(i, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, N = _.r, M = N === void 0 ? 3 : N, T = _.strokeWidth, k = T === void 0 ? 2 : T, $ = ON(i) ? i : {}, R = $.clipDot, L = R === void 0 ? !0 : R, j = M * 2 + k;
      return /* @__PURE__ */ E.createElement(de, {
        className: S
      }, P || x ? /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-".concat(A)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: P ? u : u - p / 2,
        y: x ? l : l - g / 2,
        width: P ? p : p * 2,
        height: x ? g : g * 2
      })), !L && /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-dots-".concat(A)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: u - j / 2,
        y: l - j / 2,
        width: p + j,
        height: g + j
      }))) : null, w ? null : this.renderArea(O, A), (i || w) && this.renderDots(O, L, A), (!m || b) && Jt.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: a.curPoints,
        prevBaseLine: a.curBaseLine
      } : n.points !== a.curPoints || n.baseLine !== a.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]);
})(St);
MR = Qe;
Cr(Qe, "displayName", "Area");
Cr(Qe, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Lr.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
Cr(Qe, "getBaseValue", function(e, t, r, n) {
  var a = e.layout, o = e.baseValue, i = t.props.baseValue, s = i ?? o;
  if (J(s) && typeof s == "number")
    return s;
  var c = a === "horizontal" ? n : r, l = c.scale.domain();
  if (c.type === "number") {
    var u = Math.max(l[0], l[1]), f = Math.min(l[0], l[1]);
    return s === "dataMin" ? f : s === "dataMax" || u < 0 ? u : Math.max(Math.min(l[0], l[1]), 0);
  }
  return s === "dataMin" ? l[0] : s === "dataMax" ? l[1] : l[0];
});
Cr(Qe, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.xAxis, a = e.yAxis, o = e.xAxisTicks, i = e.yAxisTicks, s = e.bandSize, c = e.dataKey, l = e.stackedData, u = e.dataStartIndex, f = e.displayedData, d = e.offset, p = t.layout, g = l && l.length, m = MR.getBaseValue(t, r, n, a), y = p === "horizontal", b = !1, w = f.map(function(P, x) {
    var O;
    g ? O = l[u + x] : (O = ge(P, c), Array.isArray(O) ? b = !0 : O = [m, O]);
    var A = O[1] == null || g && ge(P, c) == null;
    return y ? {
      x: ao({
        axis: n,
        ticks: o,
        bandSize: s,
        entry: P,
        index: x
      }),
      y: A ? null : a.scale(O[1]),
      value: O,
      payload: P
    } : {
      x: A ? null : n.scale(O[1]),
      y: ao({
        axis: a,
        ticks: i,
        bandSize: s,
        entry: P,
        index: x
      }),
      value: O,
      payload: P
    };
  }), S;
  return g || b ? S = w.map(function(P) {
    var x = Array.isArray(P.value) ? P.value[0] : null;
    return y ? {
      x: P.x,
      y: x != null && P.y != null ? a.scale(x) : null
    } : {
      x: x != null ? n.scale(x) : null,
      y: P.y
    };
  }) : S = y ? a.scale(m) : n.scale(m), vn({
    points: w,
    baseLine: S,
    layout: p,
    isRange: b
  }, d);
});
Cr(Qe, "renderDotItem", function(e, t) {
  var r;
  if (/* @__PURE__ */ E.isValidElement(e))
    r = /* @__PURE__ */ E.cloneElement(e, t);
  else if (se(e))
    r = e(t);
  else {
    var n = ue("recharts-area-dot", typeof e != "boolean" ? e.className : ""), a = t.key, o = RR(t, coe);
    r = /* @__PURE__ */ E.createElement(Ho, ea({}, o, {
      key: a,
      className: n
    }));
  }
  return r;
});
function So(e) {
  "@babel/helpers - typeof";
  return So = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, So(e);
}
function yoe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function goe(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, LR(n.key), n);
  }
}
function boe(e, t, r) {
  return t && goe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function xoe(e, t, r) {
  return t = tu(t), woe(e, DR() ? Reflect.construct(t, r || [], tu(e).constructor) : t.apply(e, r));
}
function woe(e, t) {
  if (t && (So(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Soe(e);
}
function Soe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function DR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (DR = function() {
    return !!e;
  })();
}
function tu(e) {
  return tu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, tu(e);
}
function Ooe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ly(e, t);
}
function Ly(e, t) {
  return Ly = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Ly(e, t);
}
function jR(e, t, r) {
  return t = LR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function LR(e) {
  var t = Poe(e, "string");
  return So(t) == "symbol" ? t : t + "";
}
function Poe(e, t) {
  if (So(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (So(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Go = /* @__PURE__ */ (function(e) {
  function t() {
    return yoe(this, t), xoe(this, t, arguments);
  }
  return Ooe(t, e), boe(t, [{
    key: "render",
    value: function() {
      return null;
    }
  }]);
})(v.Component);
jR(Go, "displayName", "ZAxis");
jR(Go, "defaultProps", {
  zAxisId: 0,
  range: [64, 64],
  scale: "auto",
  type: "number"
});
var Aoe = ["option", "isActive"];
function Pi() {
  return Pi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pi.apply(this, arguments);
}
function _oe(e, t) {
  if (e == null) return {};
  var r = Eoe(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Eoe(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Coe(e) {
  var t = e.option, r = e.isActive, n = _oe(e, Aoe);
  return typeof t == "string" ? /* @__PURE__ */ v.createElement(Ll, Pi({
    option: /* @__PURE__ */ v.createElement(Qu, Pi({
      type: t
    }, n)),
    isActive: r,
    shapeType: "symbols"
  }, n)) : /* @__PURE__ */ v.createElement(Ll, Pi({
    option: t,
    isActive: r,
    shapeType: "symbols"
  }, n));
}
function Oo(e) {
  "@babel/helpers - typeof";
  return Oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oo(e);
}
function Ai() {
  return Ai = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ai.apply(this, arguments);
}
function UA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? UA(Object(r), !0).forEach(function(n) {
      wn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : UA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function koe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function KA(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, FR(n.key), n);
  }
}
function Noe(e, t, r) {
  return t && KA(e.prototype, t), r && KA(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Toe(e, t, r) {
  return t = ru(t), Moe(e, BR() ? Reflect.construct(t, r || [], ru(e).constructor) : t.apply(e, r));
}
function Moe(e, t) {
  if (t && (Oo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Roe(e);
}
function Roe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function BR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (BR = function() {
    return !!e;
  })();
}
function ru(e) {
  return ru = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ru(e);
}
function $oe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && By(e, t);
}
function By(e, t) {
  return By = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, By(e, t);
}
function wn(e, t, r) {
  return t = FR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function FR(e) {
  var t = Ioe(e, "string");
  return Oo(t) == "symbol" ? t : t + "";
}
function Ioe(e, t) {
  if (Oo(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Oo(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Yo = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    koe(this, t);
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return r = Toe(this, t, [].concat(a)), wn(r, "state", {
      isAnimationFinished: !1
    }), wn(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      });
    }), wn(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      });
    }), wn(r, "id", In("recharts-scatter-")), r;
  }
  return $oe(t, e), Noe(t, [{
    key: "renderSymbolsStatically",
    value: function(n) {
      var a = this, o = this.props, i = o.shape, s = o.activeShape, c = o.activeIndex, l = ae(this.props, !1);
      return n.map(function(u, f) {
        var d = c === f, p = d ? s : i, g = Kt(Kt({}, l), u);
        return /* @__PURE__ */ E.createElement(de, Ai({
          className: "recharts-scatter-symbol",
          key: "symbol-".concat(u == null ? void 0 : u.cx, "-").concat(u == null ? void 0 : u.cy, "-").concat(u == null ? void 0 : u.size, "-").concat(f)
        }, Cn(a.props, u, f), {
          role: "img"
        }), /* @__PURE__ */ E.createElement(Coe, Ai({
          option: p,
          isActive: d,
          key: "symbol-".concat(f)
        }, g)));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function() {
      var n = this, a = this.props, o = a.points, i = a.isAnimationActive, s = a.animationBegin, c = a.animationDuration, l = a.animationEasing, u = a.animationId, f = this.state.prevPoints;
      return /* @__PURE__ */ E.createElement(Ft, {
        begin: s,
        duration: c,
        isActive: i,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(u),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(d) {
        var p = d.t, g = o.map(function(m, y) {
          var b = f && f[y];
          if (b) {
            var w = Ne(b.cx, m.cx), S = Ne(b.cy, m.cy), P = Ne(b.size, m.size);
            return Kt(Kt({}, m), {}, {
              cx: w(p),
              cy: S(p),
              size: P(p)
            });
          }
          var x = Ne(0, m.size);
          return Kt(Kt({}, m), {}, {
            size: x(p)
          });
        });
        return /* @__PURE__ */ E.createElement(de, null, n.renderSymbolsStatically(g));
      });
    }
  }, {
    key: "renderSymbols",
    value: function() {
      var n = this.props, a = n.points, o = n.isAnimationActive, i = this.state.prevPoints;
      return o && a && a.length && (!i || !tn(i, a)) ? this.renderSymbolsWithAnimation() : this.renderSymbolsStatically(a);
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      var n = this.props.isAnimationActive;
      if (n && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.points, i = a.xAxis, s = a.yAxis, c = a.children, l = xt(c, Wo);
      return l ? l.map(function(u, f) {
        var d = u.props, p = d.direction, g = d.dataKey;
        return /* @__PURE__ */ E.cloneElement(u, {
          key: "".concat(p, "-").concat(g, "-").concat(o[f]),
          data: o,
          xAxis: i,
          yAxis: s,
          layout: p === "x" ? "vertical" : "horizontal",
          dataPointFormatter: function(y, b) {
            return {
              x: y.cx,
              y: y.cy,
              value: p === "x" ? +y.node.x : +y.node.y,
              errorVal: ge(y, b)
            };
          }
        });
      }) : null;
    }
  }, {
    key: "renderLine",
    value: function() {
      var n = this.props, a = n.points, o = n.line, i = n.lineType, s = n.lineJointType, c = ae(this.props, !1), l = ae(o, !1), u, f;
      if (i === "joint")
        u = a.map(function(S) {
          return {
            x: S.cx,
            y: S.cy
          };
        });
      else if (i === "fitting") {
        var d = Qq(a), p = d.xmin, g = d.xmax, m = d.a, y = d.b, b = function(P) {
          return m * P + y;
        };
        u = [{
          x: p,
          y: b(p)
        }, {
          x: g,
          y: b(g)
        }];
      }
      var w = Kt(Kt(Kt({}, c), {}, {
        fill: "none",
        stroke: c && c.fill
      }, l), {}, {
        points: u
      });
      return /* @__PURE__ */ E.isValidElement(o) ? f = /* @__PURE__ */ E.cloneElement(o, w) : se(o) ? f = o(w) : f = /* @__PURE__ */ E.createElement(Pn, Ai({}, w, {
        type: s
      })), /* @__PURE__ */ E.createElement(de, {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, f);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, o = n.points, i = n.line, s = n.className, c = n.xAxis, l = n.yAxis, u = n.left, f = n.top, d = n.width, p = n.height, g = n.id, m = n.isAnimationActive;
      if (a || !o || !o.length)
        return null;
      var y = this.state.isAnimationFinished, b = ue("recharts-scatter", s), w = c && c.allowDataOverflow, S = l && l.allowDataOverflow, P = w || S, x = ce(g) ? this.id : g;
      return /* @__PURE__ */ E.createElement(de, {
        className: b,
        clipPath: P ? "url(#clipPath-".concat(x, ")") : null
      }, w || S ? /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
        id: "clipPath-".concat(x)
      }, /* @__PURE__ */ E.createElement("rect", {
        x: w ? u : u - d / 2,
        y: S ? f : f - p / 2,
        width: w ? d : d * 2,
        height: S ? p : p * 2
      }))) : null, i && this.renderLine(), this.renderErrorBar(), /* @__PURE__ */ E.createElement(de, {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!m || y) && Jt.renderCallByParent(this.props, o));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }]);
})(St);
wn(Yo, "displayName", "Scatter");
wn(Yo, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: "circle",
  lineType: "joint",
  lineJointType: "linear",
  data: [],
  shape: "circle",
  hide: !1,
  isAnimationActive: !Lr.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "linear"
});
wn(Yo, "getComposedData", function(e) {
  var t = e.xAxis, r = e.yAxis, n = e.zAxis, a = e.item, o = e.displayedData, i = e.xAxisTicks, s = e.yAxisTicks, c = e.offset, l = a.props.tooltipType, u = xt(a.props.children, gr), f = ce(t.dataKey) ? a.props.dataKey : t.dataKey, d = ce(r.dataKey) ? a.props.dataKey : r.dataKey, p = n && n.dataKey, g = n ? n.range : Go.defaultProps.range, m = g && g[0], y = t.scale.bandwidth ? t.scale.bandwidth() : 0, b = r.scale.bandwidth ? r.scale.bandwidth() : 0, w = o.map(function(S, P) {
    var x = ge(S, f), O = ge(S, d), A = !ce(p) && ge(S, p) || "-", _ = [{
      name: ce(t.dataKey) ? a.props.name : t.name || t.dataKey,
      unit: t.unit || "",
      value: x,
      payload: S,
      dataKey: f,
      type: l
    }, {
      name: ce(r.dataKey) ? a.props.name : r.name || r.dataKey,
      unit: r.unit || "",
      value: O,
      payload: S,
      dataKey: d,
      type: l
    }];
    A !== "-" && _.push({
      name: n.name || n.dataKey,
      unit: n.unit || "",
      value: A,
      payload: S,
      dataKey: p,
      type: l
    });
    var N = ao({
      axis: t,
      ticks: i,
      bandSize: y,
      entry: S,
      index: P,
      dataKey: f
    }), M = ao({
      axis: r,
      ticks: s,
      bandSize: b,
      entry: S,
      index: P,
      dataKey: d
    }), T = A !== "-" ? n.scale(A) : m, k = Math.sqrt(Math.max(T, 0) / Math.PI);
    return Kt(Kt({}, S), {}, {
      cx: N,
      cy: M,
      x: N - k,
      y: M - k,
      xAxis: t,
      yAxis: r,
      zAxis: n,
      width: 2 * k,
      height: 2 * k,
      size: T,
      node: {
        x,
        y: O,
        z: A
      },
      tooltipPayload: _,
      tooltipPosition: {
        x: N,
        y: M
      },
      payload: S
    }, u && u[P] && u[P].props);
  });
  return Kt({
    points: w
  }, c);
});
function Po(e) {
  "@babel/helpers - typeof";
  return Po = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Po(e);
}
function Doe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function joe(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WR(n.key), n);
  }
}
function Loe(e, t, r) {
  return t && joe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Boe(e, t, r) {
  return t = nu(t), Foe(e, zR() ? Reflect.construct(t, r || [], nu(e).constructor) : t.apply(e, r));
}
function Foe(e, t) {
  if (t && (Po(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return zoe(e);
}
function zoe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zR = function() {
    return !!e;
  })();
}
function nu(e) {
  return nu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, nu(e);
}
function qoe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Fy(e, t);
}
function Fy(e, t) {
  return Fy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Fy(e, t);
}
function qR(e, t, r) {
  return t = WR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WR(e) {
  var t = Woe(e, "string");
  return Po(t) == "symbol" ? t : t + "";
}
function Woe(e, t) {
  if (Po(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Po(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function zy() {
  return zy = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zy.apply(this, arguments);
}
function Hoe(e) {
  var t = e.xAxisId, r = D0(), n = j0(), a = gR(t);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ v.createElement(Ko, zy({}, a, {
      className: ue("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(i) {
        return Ur(i, !0);
      }
    }))
  );
}
var wt = /* @__PURE__ */ (function(e) {
  function t() {
    return Doe(this, t), Boe(this, t, arguments);
  }
  return qoe(t, e), Loe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ v.createElement(Hoe, this.props);
    }
  }]);
})(v.Component);
qR(wt, "displayName", "XAxis");
qR(wt, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function Ao(e) {
  "@babel/helpers - typeof";
  return Ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ao(e);
}
function Voe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Uoe(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, UR(n.key), n);
  }
}
function Koe(e, t, r) {
  return t && Uoe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Goe(e, t, r) {
  return t = au(t), Yoe(e, HR() ? Reflect.construct(t, r || [], au(e).constructor) : t.apply(e, r));
}
function Yoe(e, t) {
  if (t && (Ao(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Xoe(e);
}
function Xoe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function HR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (HR = function() {
    return !!e;
  })();
}
function au(e) {
  return au = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, au(e);
}
function Zoe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qy(e, t);
}
function qy(e, t) {
  return qy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, qy(e, t);
}
function VR(e, t, r) {
  return t = UR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function UR(e) {
  var t = Joe(e, "string");
  return Ao(t) == "symbol" ? t : t + "";
}
function Joe(e, t) {
  if (Ao(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ao(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Wy() {
  return Wy = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wy.apply(this, arguments);
}
var Qoe = function(t) {
  var r = t.yAxisId, n = D0(), a = j0(), o = bR(r);
  return o == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ v.createElement(Ko, Wy({}, o, {
      className: ue("recharts-".concat(o.axisType, " ").concat(o.axisType), o.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: a
      },
      ticksGenerator: function(s) {
        return Ur(s, !0);
      }
    }))
  );
}, pt = /* @__PURE__ */ (function(e) {
  function t() {
    return Voe(this, t), Goe(this, t, arguments);
  }
  return Zoe(t, e), Koe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ v.createElement(Qoe, this.props);
    }
  }]);
})(v.Component);
VR(pt, "displayName", "YAxis");
VR(pt, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function GA(e) {
  return nie(e) || rie(e) || tie(e) || eie();
}
function eie() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tie(e, t) {
  if (e) {
    if (typeof e == "string") return Hy(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Hy(e, t);
  }
}
function rie(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function nie(e) {
  if (Array.isArray(e)) return Hy(e);
}
function Hy(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Vy = function(t, r, n, a, o) {
  var i = xt(t, B0), s = xt(t, xf), c = [].concat(GA(i), GA(s)), l = xt(t, Sf), u = "".concat(a, "Id"), f = a[0], d = r;
  if (c.length && (d = c.reduce(function(m, y) {
    if (y.props[u] === n && Tr(y.props, "extendDomain") && J(y.props[f])) {
      var b = y.props[f];
      return [Math.min(m[0], b), Math.max(m[1], b)];
    }
    return m;
  }, d)), l.length) {
    var p = "".concat(f, "1"), g = "".concat(f, "2");
    d = l.reduce(function(m, y) {
      if (y.props[u] === n && Tr(y.props, "extendDomain") && J(y.props[p]) && J(y.props[g])) {
        var b = y.props[p], w = y.props[g];
        return [Math.min(m[0], b, w), Math.max(m[1], b, w)];
      }
      return m;
    }, d);
  }
  return o && o.length && (d = o.reduce(function(m, y) {
    return J(y) ? [Math.min(m[0], y), Math.max(m[1], y)] : m;
  }, d)), d;
}, Ym = { exports: {} }, YA;
function aie() {
  return YA || (YA = 1, (function(e) {
    var t = Object.prototype.hasOwnProperty, r = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
    function a(c, l, u) {
      this.fn = c, this.context = l, this.once = u || !1;
    }
    function o(c, l, u, f, d) {
      if (typeof u != "function")
        throw new TypeError("The listener must be a function");
      var p = new a(u, f || c, d), g = r ? r + l : l;
      return c._events[g] ? c._events[g].fn ? c._events[g] = [c._events[g], p] : c._events[g].push(p) : (c._events[g] = p, c._eventsCount++), c;
    }
    function i(c, l) {
      --c._eventsCount === 0 ? c._events = new n() : delete c._events[l];
    }
    function s() {
      this._events = new n(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var l = [], u, f;
      if (this._eventsCount === 0) return l;
      for (f in u = this._events)
        t.call(u, f) && l.push(r ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(u)) : l;
    }, s.prototype.listeners = function(l) {
      var u = r ? r + l : l, f = this._events[u];
      if (!f) return [];
      if (f.fn) return [f.fn];
      for (var d = 0, p = f.length, g = new Array(p); d < p; d++)
        g[d] = f[d].fn;
      return g;
    }, s.prototype.listenerCount = function(l) {
      var u = r ? r + l : l, f = this._events[u];
      return f ? f.fn ? 1 : f.length : 0;
    }, s.prototype.emit = function(l, u, f, d, p, g) {
      var m = r ? r + l : l;
      if (!this._events[m]) return !1;
      var y = this._events[m], b = arguments.length, w, S;
      if (y.fn) {
        switch (y.once && this.removeListener(l, y.fn, void 0, !0), b) {
          case 1:
            return y.fn.call(y.context), !0;
          case 2:
            return y.fn.call(y.context, u), !0;
          case 3:
            return y.fn.call(y.context, u, f), !0;
          case 4:
            return y.fn.call(y.context, u, f, d), !0;
          case 5:
            return y.fn.call(y.context, u, f, d, p), !0;
          case 6:
            return y.fn.call(y.context, u, f, d, p, g), !0;
        }
        for (S = 1, w = new Array(b - 1); S < b; S++)
          w[S - 1] = arguments[S];
        y.fn.apply(y.context, w);
      } else {
        var P = y.length, x;
        for (S = 0; S < P; S++)
          switch (y[S].once && this.removeListener(l, y[S].fn, void 0, !0), b) {
            case 1:
              y[S].fn.call(y[S].context);
              break;
            case 2:
              y[S].fn.call(y[S].context, u);
              break;
            case 3:
              y[S].fn.call(y[S].context, u, f);
              break;
            case 4:
              y[S].fn.call(y[S].context, u, f, d);
              break;
            default:
              if (!w) for (x = 1, w = new Array(b - 1); x < b; x++)
                w[x - 1] = arguments[x];
              y[S].fn.apply(y[S].context, w);
          }
      }
      return !0;
    }, s.prototype.on = function(l, u, f) {
      return o(this, l, u, f, !1);
    }, s.prototype.once = function(l, u, f) {
      return o(this, l, u, f, !0);
    }, s.prototype.removeListener = function(l, u, f, d) {
      var p = r ? r + l : l;
      if (!this._events[p]) return this;
      if (!u)
        return i(this, p), this;
      var g = this._events[p];
      if (g.fn)
        g.fn === u && (!d || g.once) && (!f || g.context === f) && i(this, p);
      else {
        for (var m = 0, y = [], b = g.length; m < b; m++)
          (g[m].fn !== u || d && !g[m].once || f && g[m].context !== f) && y.push(g[m]);
        y.length ? this._events[p] = y.length === 1 ? y[0] : y : i(this, p);
      }
      return this;
    }, s.prototype.removeAllListeners = function(l) {
      var u;
      return l ? (u = r ? r + l : l, this._events[u] && i(this, u)) : (this._events = new n(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, e.exports = s;
  })(Ym)), Ym.exports;
}
var oie = aie();
const iie = /* @__PURE__ */ _e(oie);
var Xm = new iie(), Zm = "recharts.syncMouseEvents";
function vs(e) {
  "@babel/helpers - typeof";
  return vs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vs(e);
}
function sie(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function cie(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, KR(n.key), n);
  }
}
function lie(e, t, r) {
  return t && cie(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Jm(e, t, r) {
  return t = KR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function KR(e) {
  var t = uie(e, "string");
  return vs(t) == "symbol" ? t : t + "";
}
function uie(e, t) {
  if (vs(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (vs(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var fie = /* @__PURE__ */ (function() {
  function e() {
    sie(this, e), Jm(this, "activeIndex", 0), Jm(this, "coordinateList", []), Jm(this, "layout", "horizontal");
  }
  return lie(e, [{
    key: "setDetails",
    value: function(r) {
      var n, a = r.coordinateList, o = a === void 0 ? null : a, i = r.container, s = i === void 0 ? null : i, c = r.layout, l = c === void 0 ? null : c, u = r.offset, f = u === void 0 ? null : u, d = r.mouseHandlerCallback, p = d === void 0 ? null : d;
      this.coordinateList = (n = o ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = l ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = p ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var a = this.container.getBoundingClientRect(), o = a.x, i = a.y, s = a.height, c = this.coordinateList[this.activeIndex].coordinate, l = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, u = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, f = o + c + l, d = i + this.offset.top + s / 2 + u;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: d
        });
      }
    }
  }]);
})();
function die(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e == null ? void 0 : e[0], a = e == null ? void 0 : e[1];
    if (n && a && J(n) && J(a))
      return !0;
  }
  return !1;
}
function pie(e, t, r, n) {
  var a = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - a : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - a,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function GR(e) {
  var t = e.cx, r = e.cy, n = e.radius, a = e.startAngle, o = e.endAngle, i = xe(t, r, n, a), s = xe(t, r, n, o);
  return {
    points: [i, s],
    cx: t,
    cy: r,
    radius: n,
    startAngle: a,
    endAngle: o
  };
}
function hie(e, t, r) {
  var n, a, o, i;
  if (e === "horizontal")
    n = t.x, o = n, a = r.top, i = r.top + r.height;
  else if (e === "vertical")
    a = t.y, i = a, n = r.left, o = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, c = t.cy, l = t.innerRadius, u = t.outerRadius, f = t.angle, d = xe(s, c, l, f), p = xe(s, c, u, f);
      n = d.x, a = d.y, o = p.x, i = p.y;
    } else
      return GR(t);
  return [{
    x: n,
    y: a
  }, {
    x: o,
    y: i
  }];
}
function ys(e) {
  "@babel/helpers - typeof";
  return ys = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ys(e);
}
function XA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Oc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? XA(Object(r), !0).forEach(function(n) {
      mie(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : XA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mie(e, t, r) {
  return t = vie(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vie(e) {
  var t = yie(e, "string");
  return ys(t) == "symbol" ? t : t + "";
}
function yie(e, t) {
  if (ys(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ys(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function gie(e) {
  var t, r, n = e.element, a = e.tooltipEventType, o = e.isActive, i = e.activeCoordinate, s = e.activePayload, c = e.offset, l = e.activeTooltipIndex, u = e.tooltipAxisBandSize, f = e.layout, d = e.chartName, p = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !p || !o || !i || d !== "ScatterChart" && a !== "axis")
    return null;
  var g, m = Pn;
  if (d === "ScatterChart")
    g = i, m = zee;
  else if (d === "BarChart")
    g = pie(f, i, c, u), m = Gs;
  else if (f === "radial") {
    var y = GR(i), b = y.cx, w = y.cy, S = y.radius, P = y.startAngle, x = y.endAngle;
    g = {
      cx: b,
      cy: w,
      startAngle: P,
      endAngle: x,
      innerRadius: S,
      outerRadius: S
    }, m = $M;
  } else
    g = {
      points: hie(f, i, c)
    }, m = Pn;
  var O = Oc(Oc(Oc(Oc({
    stroke: "#ccc",
    pointerEvents: "none"
  }, c), g), ae(p, !1)), {}, {
    payload: s,
    payloadIndex: l,
    className: ue("recharts-tooltip-cursor", p.className)
  });
  return /* @__PURE__ */ Et(p) ? /* @__PURE__ */ Je(p, O) : /* @__PURE__ */ _i(m, O);
}
var bie = ["item"], xie = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function _o(e) {
  "@babel/helpers - typeof";
  return _o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _o(e);
}
function ja() {
  return ja = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ja.apply(this, arguments);
}
function ZA(e, t) {
  return Oie(e) || Sie(e, t) || XR(e, t) || wie();
}
function wie() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sie(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, a, o, i, s = [], c = !0, l = !1;
    try {
      if (o = (r = r.call(e)).next, t !== 0) for (; !(c = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (i = r.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw a;
      }
    }
    return s;
  }
}
function Oie(e) {
  if (Array.isArray(e)) return e;
}
function JA(e, t) {
  if (e == null) return {};
  var r = Pie(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Pie(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Aie(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _ie(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ZR(n.key), n);
  }
}
function Eie(e, t, r) {
  return t && _ie(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Cie(e, t, r) {
  return t = ou(t), kie(e, YR() ? Reflect.construct(t, r || [], ou(e).constructor) : t.apply(e, r));
}
function kie(e, t) {
  if (t && (_o(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Nie(e);
}
function Nie(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function YR() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (YR = function() {
    return !!e;
  })();
}
function ou(e) {
  return ou = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ou(e);
}
function Tie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Uy(e, t);
}
function Uy(e, t) {
  return Uy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Uy(e, t);
}
function Eo(e) {
  return $ie(e) || Rie(e) || XR(e) || Mie();
}
function Mie() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XR(e, t) {
  if (e) {
    if (typeof e == "string") return Ky(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ky(e, t);
  }
}
function Rie(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function $ie(e) {
  if (Array.isArray(e)) return Ky(e);
}
function Ky(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function QA(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function K(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? QA(Object(r), !0).forEach(function(n) {
      fe(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : QA(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fe(e, t, r) {
  return t = ZR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ZR(e) {
  var t = Iie(e, "string");
  return _o(t) == "symbol" ? t : t + "";
}
function Iie(e, t) {
  if (_o(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (_o(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Die = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, jie = {
  width: "100%",
  height: "100%"
}, JR = {
  x: 0,
  y: 0
};
function Pc(e) {
  return e;
}
var Lie = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, Bie = function(t, r, n, a) {
  var o = r.find(function(u) {
    return u && u.index === n;
  });
  if (o) {
    if (t === "horizontal")
      return {
        x: o.coordinate,
        y: a.y
      };
    if (t === "vertical")
      return {
        x: a.x,
        y: o.coordinate
      };
    if (t === "centric") {
      var i = o.coordinate, s = a.radius;
      return K(K(K({}, a), xe(a.cx, a.cy, s, i)), {}, {
        angle: i,
        radius: s
      });
    }
    var c = o.coordinate, l = a.angle;
    return K(K(K({}, a), xe(a.cx, a.cy, c, l)), {}, {
      angle: l,
      radius: c
    });
  }
  return JR;
}, Of = function(t, r) {
  var n = r.graphicalItems, a = r.dataStartIndex, o = r.dataEndIndex, i = (n ?? []).reduce(function(s, c) {
    var l = c.props.data;
    return l && l.length ? [].concat(Eo(s), Eo(l)) : s;
  }, []);
  return i.length > 0 ? i : t && t.length && J(a) && J(o) ? t.slice(a, o + 1) : [];
};
function QR(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var Gy = function(t, r, n, a) {
  var o = t.graphicalItems, i = t.tooltipAxis, s = Of(r, t);
  return n < 0 || !o || !o.length || n >= s.length ? null : o.reduce(function(c, l) {
    var u, f = (u = l.props.data) !== null && u !== void 0 ? u : r;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= n && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var d;
    if (i.dataKey && !i.allowDuplicatedCategory) {
      var p = f === void 0 ? s : f;
      d = Qc(p, i.dataKey, a);
    } else
      d = f && f[n] || s[n];
    return d ? [].concat(Eo(c), [_M(l, d)]) : c;
  }, []);
}, e_ = function(t, r, n, a) {
  var o = a || {
    x: t.chartX,
    y: t.chartY
  }, i = Lie(o, n), s = t.orderedTooltipTicks, c = t.tooltipAxis, l = t.tooltipTicks, u = iZ(i, s, l, c);
  if (u >= 0 && l) {
    var f = l[u] && l[u].value, d = Gy(t, r, u, f), p = Bie(n, s, u, o);
    return {
      activeTooltipIndex: u,
      activeLabel: f,
      activePayload: d,
      activeCoordinate: p
    };
  }
  return null;
}, Fie = function(t, r) {
  var n = r.axes, a = r.graphicalItems, o = r.axisType, i = r.axisIdKey, s = r.stackGroups, c = r.dataStartIndex, l = r.dataEndIndex, u = t.layout, f = t.children, d = t.stackOffset, p = xM(u, o);
  return n.reduce(function(g, m) {
    var y, b = m.type.defaultProps !== void 0 ? K(K({}, m.type.defaultProps), m.props) : m.props, w = b.type, S = b.dataKey, P = b.allowDataOverflow, x = b.allowDuplicatedCategory, O = b.scale, A = b.ticks, _ = b.includeHidden, N = b[i];
    if (g[N])
      return g;
    var M = Of(t.data, {
      graphicalItems: a.filter(function(H) {
        var U, X = i in H.props ? H.props[i] : (U = H.type.defaultProps) === null || U === void 0 ? void 0 : U[i];
        return X === N;
      }),
      dataStartIndex: c,
      dataEndIndex: l
    }), T = M.length, k, $, R;
    die(b.domain, P, w) && (k = ay(b.domain, null, P), p && (w === "number" || O !== "auto") && (R = bi(M, S, "category")));
    var L = QR(w);
    if (!k || k.length === 0) {
      var j, z = (j = b.domain) !== null && j !== void 0 ? j : L;
      if (S) {
        if (k = bi(M, S, w), w === "category" && p) {
          var q = Jq(k);
          x && q ? ($ = k, k = ql(0, T)) : x || (k = FO(z, k, m).reduce(function(H, U) {
            return H.indexOf(U) >= 0 ? H : [].concat(Eo(H), [U]);
          }, []));
        } else if (w === "category")
          x ? k = k.filter(function(H) {
            return H !== "" && !ce(H);
          }) : k = FO(z, k, m).reduce(function(H, U) {
            return H.indexOf(U) >= 0 || U === "" || ce(U) ? H : [].concat(Eo(H), [U]);
          }, []);
        else if (w === "number") {
          var I = fZ(M, a.filter(function(H) {
            var U, X, ee = i in H.props ? H.props[i] : (U = H.type.defaultProps) === null || U === void 0 ? void 0 : U[i], ne = "hide" in H.props ? H.props.hide : (X = H.type.defaultProps) === null || X === void 0 ? void 0 : X.hide;
            return ee === N && (_ || !ne);
          }), S, o, u);
          I && (k = I);
        }
        p && (w === "number" || O !== "auto") && (R = bi(M, S, "category"));
      } else p ? k = ql(0, T) : s && s[N] && s[N].hasStack && w === "number" ? k = d === "expand" ? [0, 1] : AM(s[N].stackGroups, c, l) : k = bM(M, a.filter(function(H) {
        var U = i in H.props ? H.props[i] : H.type.defaultProps[i], X = "hide" in H.props ? H.props.hide : H.type.defaultProps.hide;
        return U === N && (_ || !X);
      }), w, u, !0);
      if (w === "number")
        k = Vy(f, k, N, o, A), z && (k = ay(z, k, P));
      else if (w === "category" && z) {
        var B = z, W = k.every(function(H) {
          return B.indexOf(H) >= 0;
        });
        W && (k = B);
      }
    }
    return K(K({}, g), {}, fe({}, N, K(K({}, b), {}, {
      axisType: o,
      domain: k,
      categoricalDomain: R,
      duplicateDomain: $,
      originalDomain: (y = b.domain) !== null && y !== void 0 ? y : L,
      isCategorical: p,
      layout: u
    })));
  }, {});
}, zie = function(t, r) {
  var n = r.graphicalItems, a = r.Axis, o = r.axisType, i = r.axisIdKey, s = r.stackGroups, c = r.dataStartIndex, l = r.dataEndIndex, u = t.layout, f = t.children, d = Of(t.data, {
    graphicalItems: n,
    dataStartIndex: c,
    dataEndIndex: l
  }), p = d.length, g = xM(u, o), m = -1;
  return n.reduce(function(y, b) {
    var w = b.type.defaultProps !== void 0 ? K(K({}, b.type.defaultProps), b.props) : b.props, S = w[i], P = QR("number");
    if (!y[S]) {
      m++;
      var x;
      return g ? x = ql(0, p) : s && s[S] && s[S].hasStack ? (x = AM(s[S].stackGroups, c, l), x = Vy(f, x, S, o)) : (x = ay(P, bM(d, n.filter(function(O) {
        var A, _, N = i in O.props ? O.props[i] : (A = O.type.defaultProps) === null || A === void 0 ? void 0 : A[i], M = "hide" in O.props ? O.props.hide : (_ = O.type.defaultProps) === null || _ === void 0 ? void 0 : _.hide;
        return N === S && !M;
      }), "number", u), a.defaultProps.allowDataOverflow), x = Vy(f, x, S, o)), K(K({}, y), {}, fe({}, S, K(K({
        axisType: o
      }, a.defaultProps), {}, {
        hide: !0,
        orientation: lt(Die, "".concat(o, ".").concat(m % 2), null),
        domain: x,
        originalDomain: P,
        isCategorical: g,
        layout: u
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return y;
  }, {});
}, qie = function(t, r) {
  var n = r.axisType, a = n === void 0 ? "xAxis" : n, o = r.AxisComp, i = r.graphicalItems, s = r.stackGroups, c = r.dataStartIndex, l = r.dataEndIndex, u = t.children, f = "".concat(a, "Id"), d = xt(u, o), p = {};
  return d && d.length ? p = Fie(t, {
    axes: d,
    graphicalItems: i,
    axisType: a,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: l
  }) : i && i.length && (p = zie(t, {
    Axis: o,
    graphicalItems: i,
    axisType: a,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: c,
    dataEndIndex: l
  })), p;
}, Wie = function(t) {
  var r = gn(t), n = Ur(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: o0(n, function(a) {
      return a.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Al(r, n)
  };
}, t_ = function(t) {
  var r = t.children, n = t.defaultShowTooltip, a = ct(r, po), o = 0, i = 0;
  return t.data && t.data.length !== 0 && (i = t.data.length - 1), a && a.props && (a.props.startIndex >= 0 && (o = a.props.startIndex), a.props.endIndex >= 0 && (i = a.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: o,
    dataEndIndex: i,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, Hie = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = Kr(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, r_ = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, Vie = function(t, r) {
  var n = t.props, a = t.graphicalItems, o = t.xAxisMap, i = o === void 0 ? {} : o, s = t.yAxisMap, c = s === void 0 ? {} : s, l = n.width, u = n.height, f = n.children, d = n.margin || {}, p = ct(f, po), g = ct(f, Zt), m = Object.keys(c).reduce(function(x, O) {
    var A = c[O], _ = A.orientation;
    return !A.mirror && !A.hide ? K(K({}, x), {}, fe({}, _, x[_] + A.width)) : x;
  }, {
    left: d.left || 0,
    right: d.right || 0
  }), y = Object.keys(i).reduce(function(x, O) {
    var A = i[O], _ = A.orientation;
    return !A.mirror && !A.hide ? K(K({}, x), {}, fe({}, _, lt(x, "".concat(_)) + A.height)) : x;
  }, {
    top: d.top || 0,
    bottom: d.bottom || 0
  }), b = K(K({}, y), m), w = b.bottom;
  p && (b.bottom += p.props.height || po.defaultProps.height), g && r && (b = lZ(b, a, n, r));
  var S = l - b.left - b.right, P = u - b.top - b.bottom;
  return K(K({
    brushBottom: w
  }, b), {}, {
    // never return negative values for height and width
    width: Math.max(S, 0),
    height: Math.max(P, 0)
  });
}, Uie = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, Xo = function(t) {
  var r = t.chartName, n = t.GraphicalChild, a = t.defaultTooltipEventType, o = a === void 0 ? "axis" : a, i = t.validateTooltipEventTypes, s = i === void 0 ? ["axis"] : i, c = t.axisComponents, l = t.legendContent, u = t.formatAxisMap, f = t.defaultProps, d = function(b, w) {
    var S = w.graphicalItems, P = w.stackGroups, x = w.offset, O = w.updateId, A = w.dataStartIndex, _ = w.dataEndIndex, N = b.barSize, M = b.layout, T = b.barGap, k = b.barCategoryGap, $ = b.maxBarSize, R = r_(M), L = R.numericAxisName, j = R.cateAxisName, z = Hie(S), q = [];
    return S.forEach(function(I, B) {
      var W = Of(b.data, {
        graphicalItems: [I],
        dataStartIndex: A,
        dataEndIndex: _
      }), H = I.type.defaultProps !== void 0 ? K(K({}, I.type.defaultProps), I.props) : I.props, U = H.dataKey, X = H.maxBarSize, ee = H["".concat(L, "Id")], ne = H["".concat(j, "Id")], G = {}, te = c.reduce(function(Mt, Wt) {
        var nr, Zo, Jo = w["".concat(Wt.axisType, "Map")], mt = H["".concat(Wt.axisType, "Id")];
        Jo && Jo[mt] || Wt.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? _t(!1, "Specifying a(n) ".concat(Wt.axisType, "Id requires a corresponding ").concat(
          Wt.axisType,
          "Id on the targeted graphical component "
        ).concat((nr = I == null || (Zo = I.type) === null || Zo === void 0 ? void 0 : Zo.displayName) !== null && nr !== void 0 ? nr : "")) : _t());
        var Br = Jo[mt];
        return K(K({}, Mt), {}, fe(fe({}, Wt.axisType, Br), "".concat(Wt.axisType, "Ticks"), Ur(Br)));
      }, G), V = te[j], Y = te["".concat(j, "Ticks")], Q = P && P[ee] && P[ee].hasStack && xZ(I, P[ee].stackGroups), D = Kr(I.type).indexOf("Bar") >= 0, le = Al(V, Y), Z = [], ve = z && sZ({
        barSize: N,
        stackGroups: P,
        totalSize: Uie(te, j)
      });
      if (D) {
        var ye, Ie, Ot = ce(X) ? $ : X, Tt = (ye = (Ie = Al(V, Y, !0)) !== null && Ie !== void 0 ? Ie : Ot) !== null && ye !== void 0 ? ye : 0;
        Z = cZ({
          barGap: T,
          barCategoryGap: k,
          bandSize: Tt !== le ? Tt : le,
          sizeList: ve[ne],
          maxBarSize: Ot
        }), Tt !== le && (Z = Z.map(function(Mt) {
          return K(K({}, Mt), {}, {
            position: K(K({}, Mt.position), {}, {
              offset: Mt.position.offset - Tt / 2
            })
          });
        }));
      }
      var Fn = I && I.type && I.type.getComposedData;
      Fn && q.push({
        props: K(K({}, Fn(K(K({}, te), {}, {
          displayedData: W,
          props: b,
          dataKey: U,
          item: I,
          bandSize: le,
          barPosition: Z,
          offset: x,
          stackedData: Q,
          layout: M,
          dataStartIndex: A,
          dataEndIndex: _
        }))), {}, fe(fe(fe({
          key: I.key || "item-".concat(B)
        }, L, te[L]), j, te[j]), "animationId", O)),
        childIndex: fW(I, b.children),
        item: I
      });
    }), q;
  }, p = function(b, w) {
    var S = b.props, P = b.dataStartIndex, x = b.dataEndIndex, O = b.updateId;
    if (!_v({
      props: S
    }))
      return null;
    var A = S.children, _ = S.layout, N = S.stackOffset, M = S.data, T = S.reverseStackOrder, k = r_(_), $ = k.numericAxisName, R = k.cateAxisName, L = xt(A, n), j = gZ(M, L, "".concat($, "Id"), "".concat(R, "Id"), N, T), z = c.reduce(function(H, U) {
      var X = "".concat(U.axisType, "Map");
      return K(K({}, H), {}, fe({}, X, qie(S, K(K({}, U), {}, {
        graphicalItems: L,
        stackGroups: U.axisType === $ && j,
        dataStartIndex: P,
        dataEndIndex: x
      }))));
    }, {}), q = Vie(K(K({}, z), {}, {
      props: S,
      graphicalItems: L
    }), w == null ? void 0 : w.legendBBox);
    Object.keys(z).forEach(function(H) {
      z[H] = u(S, z[H], q, H.replace("Map", ""), r);
    });
    var I = z["".concat(R, "Map")], B = Wie(I), W = d(S, K(K({}, z), {}, {
      dataStartIndex: P,
      dataEndIndex: x,
      updateId: O,
      graphicalItems: L,
      stackGroups: j,
      offset: q
    }));
    return K(K({
      formattedGraphicalItems: W,
      graphicalItems: L,
      offset: q,
      stackGroups: j
    }, B), z);
  }, g = /* @__PURE__ */ (function(y) {
    function b(w) {
      var S, P, x;
      return Aie(this, b), x = Cie(this, b, [w]), fe(x, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), fe(x, "accessibilityManager", new fie()), fe(x, "handleLegendBBoxUpdate", function(O) {
        if (O) {
          var A = x.state, _ = A.dataStartIndex, N = A.dataEndIndex, M = A.updateId;
          x.setState(K({
            legendBBox: O
          }, p({
            props: x.props,
            dataStartIndex: _,
            dataEndIndex: N,
            updateId: M
          }, K(K({}, x.state), {}, {
            legendBBox: O
          }))));
        }
      }), fe(x, "handleReceiveSyncEvent", function(O, A, _) {
        if (x.props.syncId === O) {
          if (_ === x.eventEmitterSymbol && typeof x.props.syncMethod != "function")
            return;
          x.applySyncEvent(A);
        }
      }), fe(x, "handleBrushChange", function(O) {
        var A = O.startIndex, _ = O.endIndex;
        if (A !== x.state.dataStartIndex || _ !== x.state.dataEndIndex) {
          var N = x.state.updateId;
          x.setState(function() {
            return K({
              dataStartIndex: A,
              dataEndIndex: _
            }, p({
              props: x.props,
              dataStartIndex: A,
              dataEndIndex: _,
              updateId: N
            }, x.state));
          }), x.triggerSyncEvent({
            dataStartIndex: A,
            dataEndIndex: _
          });
        }
      }), fe(x, "handleMouseEnter", function(O) {
        var A = x.getMouseInfo(O);
        if (A) {
          var _ = K(K({}, A), {}, {
            isTooltipActive: !0
          });
          x.setState(_), x.triggerSyncEvent(_);
          var N = x.props.onMouseEnter;
          se(N) && N(_, O);
        }
      }), fe(x, "triggeredAfterMouseMove", function(O) {
        var A = x.getMouseInfo(O), _ = A ? K(K({}, A), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        x.setState(_), x.triggerSyncEvent(_);
        var N = x.props.onMouseMove;
        se(N) && N(_, O);
      }), fe(x, "handleItemMouseEnter", function(O) {
        x.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: O,
            activePayload: O.tooltipPayload,
            activeCoordinate: O.tooltipPosition || {
              x: O.cx,
              y: O.cy
            }
          };
        });
      }), fe(x, "handleItemMouseLeave", function() {
        x.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), fe(x, "handleMouseMove", function(O) {
        O.persist(), x.throttleTriggeredAfterMouseMove(O);
      }), fe(x, "handleMouseLeave", function(O) {
        x.throttleTriggeredAfterMouseMove.cancel();
        var A = {
          isTooltipActive: !1
        };
        x.setState(A), x.triggerSyncEvent(A);
        var _ = x.props.onMouseLeave;
        se(_) && _(A, O);
      }), fe(x, "handleOuterEvent", function(O) {
        var A = uW(O), _ = lt(x.props, "".concat(A));
        if (A && se(_)) {
          var N, M;
          /.*touch.*/i.test(A) ? M = x.getMouseInfo(O.changedTouches[0]) : M = x.getMouseInfo(O), _((N = M) !== null && N !== void 0 ? N : {}, O);
        }
      }), fe(x, "handleClick", function(O) {
        var A = x.getMouseInfo(O);
        if (A) {
          var _ = K(K({}, A), {}, {
            isTooltipActive: !0
          });
          x.setState(_), x.triggerSyncEvent(_);
          var N = x.props.onClick;
          se(N) && N(_, O);
        }
      }), fe(x, "handleMouseDown", function(O) {
        var A = x.props.onMouseDown;
        if (se(A)) {
          var _ = x.getMouseInfo(O);
          A(_, O);
        }
      }), fe(x, "handleMouseUp", function(O) {
        var A = x.props.onMouseUp;
        if (se(A)) {
          var _ = x.getMouseInfo(O);
          A(_, O);
        }
      }), fe(x, "handleTouchMove", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && x.throttleTriggeredAfterMouseMove(O.changedTouches[0]);
      }), fe(x, "handleTouchStart", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && x.handleMouseDown(O.changedTouches[0]);
      }), fe(x, "handleTouchEnd", function(O) {
        O.changedTouches != null && O.changedTouches.length > 0 && x.handleMouseUp(O.changedTouches[0]);
      }), fe(x, "handleDoubleClick", function(O) {
        var A = x.props.onDoubleClick;
        if (se(A)) {
          var _ = x.getMouseInfo(O);
          A(_, O);
        }
      }), fe(x, "handleContextMenu", function(O) {
        var A = x.props.onContextMenu;
        if (se(A)) {
          var _ = x.getMouseInfo(O);
          A(_, O);
        }
      }), fe(x, "triggerSyncEvent", function(O) {
        x.props.syncId !== void 0 && Xm.emit(Zm, x.props.syncId, O, x.eventEmitterSymbol);
      }), fe(x, "applySyncEvent", function(O) {
        var A = x.props, _ = A.layout, N = A.syncMethod, M = x.state.updateId, T = O.dataStartIndex, k = O.dataEndIndex;
        if (O.dataStartIndex !== void 0 || O.dataEndIndex !== void 0)
          x.setState(K({
            dataStartIndex: T,
            dataEndIndex: k
          }, p({
            props: x.props,
            dataStartIndex: T,
            dataEndIndex: k,
            updateId: M
          }, x.state)));
        else if (O.activeTooltipIndex !== void 0) {
          var $ = O.chartX, R = O.chartY, L = O.activeTooltipIndex, j = x.state, z = j.offset, q = j.tooltipTicks;
          if (!z)
            return;
          if (typeof N == "function")
            L = N(q, O);
          else if (N === "value") {
            L = -1;
            for (var I = 0; I < q.length; I++)
              if (q[I].value === O.activeLabel) {
                L = I;
                break;
              }
          }
          var B = K(K({}, z), {}, {
            x: z.left,
            y: z.top
          }), W = Math.min($, B.x + B.width), H = Math.min(R, B.y + B.height), U = q[L] && q[L].value, X = Gy(x.state, x.props.data, L), ee = q[L] ? {
            x: _ === "horizontal" ? q[L].coordinate : W,
            y: _ === "horizontal" ? H : q[L].coordinate
          } : JR;
          x.setState(K(K({}, O), {}, {
            activeLabel: U,
            activeCoordinate: ee,
            activePayload: X,
            activeTooltipIndex: L
          }));
        } else
          x.setState(O);
      }), fe(x, "renderCursor", function(O) {
        var A, _ = x.state, N = _.isTooltipActive, M = _.activeCoordinate, T = _.activePayload, k = _.offset, $ = _.activeTooltipIndex, R = _.tooltipAxisBandSize, L = x.getTooltipEventType(), j = (A = O.props.active) !== null && A !== void 0 ? A : N, z = x.props.layout, q = O.key || "_recharts-cursor";
        return /* @__PURE__ */ E.createElement(gie, {
          key: q,
          activeCoordinate: M,
          activePayload: T,
          activeTooltipIndex: $,
          chartName: r,
          element: O,
          isActive: j,
          layout: z,
          offset: k,
          tooltipAxisBandSize: R,
          tooltipEventType: L
        });
      }), fe(x, "renderPolarAxis", function(O, A, _) {
        var N = lt(O, "type.axisType"), M = lt(x.state, "".concat(N, "Map")), T = O.type.defaultProps, k = T !== void 0 ? K(K({}, T), O.props) : O.props, $ = M && M[k["".concat(N, "Id")]];
        return /* @__PURE__ */ Je(O, K(K({}, $), {}, {
          className: ue(N, $.className),
          key: O.key || "".concat(A, "-").concat(_),
          ticks: Ur($, !0)
        }));
      }), fe(x, "renderPolarGrid", function(O) {
        var A = O.props, _ = A.radialLines, N = A.polarAngles, M = A.polarRadius, T = x.state, k = T.radiusAxisMap, $ = T.angleAxisMap, R = gn(k), L = gn($), j = L.cx, z = L.cy, q = L.innerRadius, I = L.outerRadius;
        return /* @__PURE__ */ Je(O, {
          polarAngles: Array.isArray(N) ? N : Ur(L, !0).map(function(B) {
            return B.coordinate;
          }),
          polarRadius: Array.isArray(M) ? M : Ur(R, !0).map(function(B) {
            return B.coordinate;
          }),
          cx: j,
          cy: z,
          innerRadius: q,
          outerRadius: I,
          key: O.key || "polar-grid",
          radialLines: _
        });
      }), fe(x, "renderLegend", function() {
        var O = x.state.formattedGraphicalItems, A = x.props, _ = A.children, N = A.width, M = A.height, T = x.props.margin || {}, k = N - (T.left || 0) - (T.right || 0), $ = yM({
          children: _,
          formattedGraphicalItems: O,
          legendWidth: k,
          legendContent: l
        });
        if (!$)
          return null;
        var R = $.item, L = JA($, bie);
        return /* @__PURE__ */ Je(R, K(K({}, L), {}, {
          chartWidth: N,
          chartHeight: M,
          margin: T,
          onBBoxUpdate: x.handleLegendBBoxUpdate
        }));
      }), fe(x, "renderTooltip", function() {
        var O, A = x.props, _ = A.children, N = A.accessibilityLayer, M = ct(_, Be);
        if (!M)
          return null;
        var T = x.state, k = T.isTooltipActive, $ = T.activeCoordinate, R = T.activePayload, L = T.activeLabel, j = T.offset, z = (O = M.props.active) !== null && O !== void 0 ? O : k;
        return /* @__PURE__ */ Je(M, {
          viewBox: K(K({}, j), {}, {
            x: j.left,
            y: j.top
          }),
          active: z,
          label: L,
          payload: z ? R : [],
          coordinate: $,
          accessibilityLayer: N
        });
      }), fe(x, "renderBrush", function(O) {
        var A = x.props, _ = A.margin, N = A.data, M = x.state, T = M.offset, k = M.dataStartIndex, $ = M.dataEndIndex, R = M.updateId;
        return /* @__PURE__ */ Je(O, {
          key: O.key || "_recharts-brush",
          onChange: yc(x.handleBrushChange, O.props.onChange),
          data: N,
          x: J(O.props.x) ? O.props.x : T.left,
          y: J(O.props.y) ? O.props.y : T.top + T.height + T.brushBottom - (_.bottom || 0),
          width: J(O.props.width) ? O.props.width : T.width,
          startIndex: k,
          endIndex: $,
          updateId: "brush-".concat(R)
        });
      }), fe(x, "renderReferenceElement", function(O, A, _) {
        if (!O)
          return null;
        var N = x, M = N.clipPathId, T = x.state, k = T.xAxisMap, $ = T.yAxisMap, R = T.offset, L = O.type.defaultProps || {}, j = O.props, z = j.xAxisId, q = z === void 0 ? L.xAxisId : z, I = j.yAxisId, B = I === void 0 ? L.yAxisId : I;
        return /* @__PURE__ */ Je(O, {
          key: O.key || "".concat(A, "-").concat(_),
          xAxis: k[q],
          yAxis: $[B],
          viewBox: {
            x: R.left,
            y: R.top,
            width: R.width,
            height: R.height
          },
          clipPathId: M
        });
      }), fe(x, "renderActivePoints", function(O) {
        var A = O.item, _ = O.activePoint, N = O.basePoint, M = O.childIndex, T = O.isRange, k = [], $ = A.props.key, R = A.item.type.defaultProps !== void 0 ? K(K({}, A.item.type.defaultProps), A.item.props) : A.item.props, L = R.activeDot, j = R.dataKey, z = K(K({
          index: M,
          dataKey: j,
          cx: _.x,
          cy: _.y,
          r: 4,
          fill: T0(A.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: _.payload,
          value: _.value
        }, ae(L, !1)), el(L));
        return k.push(b.renderActiveDot(L, z, "".concat($, "-activePoint-").concat(M))), N ? k.push(b.renderActiveDot(L, K(K({}, z), {}, {
          cx: N.x,
          cy: N.y
        }), "".concat($, "-basePoint-").concat(M))) : T && k.push(null), k;
      }), fe(x, "renderGraphicChild", function(O, A, _) {
        var N = x.filterFormatItem(O, A, _);
        if (!N)
          return null;
        var M = x.getTooltipEventType(), T = x.state, k = T.isTooltipActive, $ = T.tooltipAxis, R = T.activeTooltipIndex, L = T.activeLabel, j = x.props.children, z = ct(j, Be), q = N.props, I = q.points, B = q.isRange, W = q.baseLine, H = N.item.type.defaultProps !== void 0 ? K(K({}, N.item.type.defaultProps), N.item.props) : N.item.props, U = H.activeDot, X = H.hide, ee = H.activeBar, ne = H.activeShape, G = !!(!X && k && z && (U || ee || ne)), te = {};
        M !== "axis" && z && z.props.trigger === "click" ? te = {
          onClick: yc(x.handleItemMouseEnter, O.props.onClick)
        } : M !== "axis" && (te = {
          onMouseLeave: yc(x.handleItemMouseLeave, O.props.onMouseLeave),
          onMouseEnter: yc(x.handleItemMouseEnter, O.props.onMouseEnter)
        });
        var V = /* @__PURE__ */ Je(O, K(K({}, N.props), te));
        function Y(Wt) {
          return typeof $.dataKey == "function" ? $.dataKey(Wt.payload) : null;
        }
        if (G)
          if (R >= 0) {
            var Q, D;
            if ($.dataKey && !$.allowDuplicatedCategory) {
              var le = typeof $.dataKey == "function" ? Y : "payload.".concat($.dataKey.toString());
              Q = Qc(I, le, L), D = B && W && Qc(W, le, L);
            } else
              Q = I == null ? void 0 : I[R], D = B && W && W[R];
            if (ne || ee) {
              var Z = O.props.activeIndex !== void 0 ? O.props.activeIndex : R;
              return [/* @__PURE__ */ Je(O, K(K(K({}, N.props), te), {}, {
                activeIndex: Z
              })), null, null];
            }
            if (!ce(Q))
              return [V].concat(Eo(x.renderActivePoints({
                item: N,
                activePoint: Q,
                basePoint: D,
                childIndex: R,
                isRange: B
              })));
          } else {
            var ve, ye = (ve = x.getItemByXY(x.state.activeCoordinate)) !== null && ve !== void 0 ? ve : {
              graphicalItem: V
            }, Ie = ye.graphicalItem, Ot = Ie.item, Tt = Ot === void 0 ? O : Ot, Fn = Ie.childIndex, Mt = K(K(K({}, N.props), te), {}, {
              activeIndex: Fn
            });
            return [/* @__PURE__ */ Je(Tt, Mt), null, null];
          }
        return B ? [V, null, null] : [V, null];
      }), fe(x, "renderCustomized", function(O, A, _) {
        return /* @__PURE__ */ Je(O, K(K({
          key: "recharts-customized-".concat(_)
        }, x.props), x.state));
      }), fe(x, "renderMap", {
        CartesianGrid: {
          handler: Pc,
          once: !0
        },
        ReferenceArea: {
          handler: x.renderReferenceElement
        },
        ReferenceLine: {
          handler: Pc
        },
        ReferenceDot: {
          handler: x.renderReferenceElement
        },
        XAxis: {
          handler: Pc
        },
        YAxis: {
          handler: Pc
        },
        Brush: {
          handler: x.renderBrush,
          once: !0
        },
        Bar: {
          handler: x.renderGraphicChild
        },
        Line: {
          handler: x.renderGraphicChild
        },
        Area: {
          handler: x.renderGraphicChild
        },
        Radar: {
          handler: x.renderGraphicChild
        },
        RadialBar: {
          handler: x.renderGraphicChild
        },
        Scatter: {
          handler: x.renderGraphicChild
        },
        Pie: {
          handler: x.renderGraphicChild
        },
        Funnel: {
          handler: x.renderGraphicChild
        },
        Tooltip: {
          handler: x.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: x.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: x.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: x.renderPolarAxis
        },
        Customized: {
          handler: x.renderCustomized
        }
      }), x.clipPathId = "".concat((S = w.id) !== null && S !== void 0 ? S : In("recharts"), "-clip"), x.throttleTriggeredAfterMouseMove = vT(x.triggeredAfterMouseMove, (P = w.throttleDelay) !== null && P !== void 0 ? P : 1e3 / 60), x.state = {}, x;
    }
    return Tie(b, y), Eie(b, [{
      key: "componentDidMount",
      value: function() {
        var S, P;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (S = this.props.margin.left) !== null && S !== void 0 ? S : 0,
            top: (P = this.props.margin.top) !== null && P !== void 0 ? P : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var S = this.props, P = S.children, x = S.data, O = S.height, A = S.layout, _ = ct(P, Be);
        if (_) {
          var N = _.props.defaultIndex;
          if (!(typeof N != "number" || N < 0 || N > this.state.tooltipTicks.length - 1)) {
            var M = this.state.tooltipTicks[N] && this.state.tooltipTicks[N].value, T = Gy(this.state, x, N, M), k = this.state.tooltipTicks[N].coordinate, $ = (this.state.offset.top + O) / 2, R = A === "horizontal", L = R ? {
              x: k,
              y: $
            } : {
              y: k,
              x: $
            }, j = this.state.formattedGraphicalItems.find(function(q) {
              var I = q.item;
              return I.type.name === "Scatter";
            });
            j && (L = K(K({}, L), j.props.points[N].tooltipPosition), T = j.props.points[N].tooltipPayload);
            var z = {
              activeTooltipIndex: N,
              isTooltipActive: !0,
              activeLabel: M,
              activePayload: T,
              activeCoordinate: L
            };
            this.setState(z), this.renderCursor(_), this.accessibilityManager.setIndex(N);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(S, P) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== P.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== S.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== S.margin) {
          var x, O;
          this.accessibilityManager.setDetails({
            offset: {
              left: (x = this.props.margin.left) !== null && x !== void 0 ? x : 0,
              top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(S) {
        Ev([ct(S.children, Be)], [ct(this.props.children, Be)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var S = ct(this.props.children, Be);
        if (S && typeof S.props.shared == "boolean") {
          var P = S.props.shared ? "axis" : "item";
          return s.indexOf(P) >= 0 ? P : o;
        }
        return o;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(S) {
        if (!this.container)
          return null;
        var P = this.container, x = P.getBoundingClientRect(), O = JU(x), A = {
          chartX: Math.round(S.pageX - O.left),
          chartY: Math.round(S.pageY - O.top)
        }, _ = x.width / P.offsetWidth || 1, N = this.inRange(A.chartX, A.chartY, _);
        if (!N)
          return null;
        var M = this.state, T = M.xAxisMap, k = M.yAxisMap, $ = this.getTooltipEventType(), R = e_(this.state, this.props.data, this.props.layout, N);
        if ($ !== "axis" && T && k) {
          var L = gn(T).scale, j = gn(k).scale, z = L && L.invert ? L.invert(A.chartX) : null, q = j && j.invert ? j.invert(A.chartY) : null;
          return K(K({}, A), {}, {
            xValue: z,
            yValue: q
          }, R);
        }
        return R ? K(K({}, A), R) : null;
      }
    }, {
      key: "inRange",
      value: function(S, P) {
        var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, O = this.props.layout, A = S / x, _ = P / x;
        if (O === "horizontal" || O === "vertical") {
          var N = this.state.offset, M = A >= N.left && A <= N.left + N.width && _ >= N.top && _ <= N.top + N.height;
          return M ? {
            x: A,
            y: _
          } : null;
        }
        var T = this.state, k = T.angleAxisMap, $ = T.radiusAxisMap;
        if (k && $) {
          var R = gn(k);
          return WO({
            x: A,
            y: _
          }, R);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var S = this.props.children, P = this.getTooltipEventType(), x = ct(S, Be), O = {};
        x && P === "axis" && (x.props.trigger === "click" ? O = {
          onClick: this.handleClick
        } : O = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var A = el(this.props, this.handleOuterEvent);
        return K(K({}, A), O);
      }
    }, {
      key: "addListener",
      value: function() {
        Xm.on(Zm, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        Xm.removeListener(Zm, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(S, P, x) {
        for (var O = this.state.formattedGraphicalItems, A = 0, _ = O.length; A < _; A++) {
          var N = O[A];
          if (N.item === S || N.props.key === S.key || P === Kr(N.item.type) && x === N.childIndex)
            return N;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var S = this.clipPathId, P = this.state.offset, x = P.left, O = P.top, A = P.height, _ = P.width;
        return /* @__PURE__ */ E.createElement("defs", null, /* @__PURE__ */ E.createElement("clipPath", {
          id: S
        }, /* @__PURE__ */ E.createElement("rect", {
          x,
          y: O,
          height: A,
          width: _
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var S = this.state.xAxisMap;
        return S ? Object.entries(S).reduce(function(P, x) {
          var O = ZA(x, 2), A = O[0], _ = O[1];
          return K(K({}, P), {}, fe({}, A, _.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var S = this.state.yAxisMap;
        return S ? Object.entries(S).reduce(function(P, x) {
          var O = ZA(x, 2), A = O[0], _ = O[1];
          return K(K({}, P), {}, fe({}, A, _.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(S) {
        var P;
        return (P = this.state.xAxisMap) === null || P === void 0 || (P = P[S]) === null || P === void 0 ? void 0 : P.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(S) {
        var P;
        return (P = this.state.yAxisMap) === null || P === void 0 || (P = P[S]) === null || P === void 0 ? void 0 : P.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(S) {
        var P = this.state, x = P.formattedGraphicalItems, O = P.activeItem;
        if (x && x.length)
          for (var A = 0, _ = x.length; A < _; A++) {
            var N = x[A], M = N.props, T = N.item, k = T.type.defaultProps !== void 0 ? K(K({}, T.type.defaultProps), T.props) : T.props, $ = Kr(T.type);
            if ($ === "Bar") {
              var R = (M.data || []).find(function(q) {
                return See(S, q);
              });
              if (R)
                return {
                  graphicalItem: N,
                  payload: R
                };
            } else if ($ === "RadialBar") {
              var L = (M.data || []).find(function(q) {
                return WO(S, q);
              });
              if (L)
                return {
                  graphicalItem: N,
                  payload: L
                };
            } else if (mf(N, O) || vf(N, O) || ds(N, O)) {
              var j = ere({
                graphicalItem: N,
                activeTooltipItem: O,
                itemData: k.data
              }), z = k.activeIndex === void 0 ? j : k.activeIndex;
              return {
                graphicalItem: K(K({}, N), {}, {
                  childIndex: z
                }),
                payload: ds(N, O) ? k.data[j] : N.props.data[j]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var S = this;
        if (!_v(this))
          return null;
        var P = this.props, x = P.children, O = P.className, A = P.width, _ = P.height, N = P.style, M = P.compact, T = P.title, k = P.desc, $ = JA(P, xie), R = ae($, !1);
        if (M)
          return /* @__PURE__ */ E.createElement(CA, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ E.createElement(tl, ja({}, R, {
            width: A,
            height: _,
            title: T,
            desc: k
          }), this.renderClipPath(), nw(x, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var L, j;
          R.tabIndex = (L = this.props.tabIndex) !== null && L !== void 0 ? L : 0, R.role = (j = this.props.role) !== null && j !== void 0 ? j : "application", R.onKeyDown = function(q) {
            S.accessibilityManager.keyboardEvent(q);
          }, R.onFocus = function() {
            S.accessibilityManager.focus();
          };
        }
        var z = this.parseEventsOfWrapper();
        return /* @__PURE__ */ E.createElement(CA, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ E.createElement("div", ja({
          className: ue("recharts-wrapper", O),
          style: K({
            position: "relative",
            cursor: "default",
            width: A,
            height: _
          }, N)
        }, z, {
          ref: function(I) {
            S.container = I;
          }
        }), /* @__PURE__ */ E.createElement(tl, ja({}, R, {
          width: A,
          height: _,
          title: T,
          desc: k,
          style: jie
        }), this.renderClipPath(), nw(x, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  })(m_);
  fe(g, "displayName", r), fe(g, "defaultProps", K({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, f)), fe(g, "getDerivedStateFromProps", function(y, b) {
    var w = y.dataKey, S = y.data, P = y.children, x = y.width, O = y.height, A = y.layout, _ = y.stackOffset, N = y.margin, M = b.dataStartIndex, T = b.dataEndIndex;
    if (b.updateId === void 0) {
      var k = t_(y);
      return K(K(K({}, k), {}, {
        updateId: 0
      }, p(K(K({
        props: y
      }, k), {}, {
        updateId: 0
      }), b)), {}, {
        prevDataKey: w,
        prevData: S,
        prevWidth: x,
        prevHeight: O,
        prevLayout: A,
        prevStackOffset: _,
        prevMargin: N,
        prevChildren: P
      });
    }
    if (w !== b.prevDataKey || S !== b.prevData || x !== b.prevWidth || O !== b.prevHeight || A !== b.prevLayout || _ !== b.prevStackOffset || !ra(N, b.prevMargin)) {
      var $ = t_(y), R = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: b.chartX,
        chartY: b.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: b.isTooltipActive
      }, L = K(K({}, e_(b, S, A)), {}, {
        updateId: b.updateId + 1
      }), j = K(K(K({}, $), R), L);
      return K(K(K({}, j), p(K({
        props: y
      }, j), b)), {}, {
        prevDataKey: w,
        prevData: S,
        prevWidth: x,
        prevHeight: O,
        prevLayout: A,
        prevStackOffset: _,
        prevMargin: N,
        prevChildren: P
      });
    }
    if (!Ev(P, b.prevChildren)) {
      var z, q, I, B, W = ct(P, po), H = W && (z = (q = W.props) === null || q === void 0 ? void 0 : q.startIndex) !== null && z !== void 0 ? z : M, U = W && (I = (B = W.props) === null || B === void 0 ? void 0 : B.endIndex) !== null && I !== void 0 ? I : T, X = H !== M || U !== T, ee = !ce(S), ne = ee && !X ? b.updateId : b.updateId + 1;
      return K(K({
        updateId: ne
      }, p(K(K({
        props: y
      }, b), {}, {
        updateId: ne,
        dataStartIndex: H,
        dataEndIndex: U
      }), b)), {}, {
        prevChildren: P,
        dataStartIndex: H,
        dataEndIndex: U
      });
    }
    return null;
  }), fe(g, "renderActiveDot", function(y, b, w) {
    var S;
    return /* @__PURE__ */ Et(y) ? S = /* @__PURE__ */ Je(y, b) : se(y) ? S = y(b) : S = /* @__PURE__ */ E.createElement(Ho, b), /* @__PURE__ */ E.createElement(de, {
      className: "recharts-active-dot",
      key: w
    }, S);
  });
  var m = /* @__PURE__ */ bs(function(b, w) {
    return /* @__PURE__ */ E.createElement(g, ja({}, b, {
      ref: w
    }));
  });
  return m.displayName = g.displayName, m;
}, Pf = Xo({
  chartName: "BarChart",
  GraphicalChild: dt,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: wt
  }, {
    axisType: "yAxis",
    AxisComp: pt
  }],
  formatAxisMap: gf
}), q0 = Xo({
  chartName: "PieChart",
  GraphicalChild: Sr,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Uo
  }, {
    axisType: "radiusAxis",
    AxisComp: Vo
  }],
  formatAxisMap: kM,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), Qm, n_;
function Kie() {
  if (n_) return Qm;
  n_ = 1;
  function e(t, r) {
    for (var n, a = -1, o = t.length; ++a < o; ) {
      var i = r(t[a]);
      i !== void 0 && (n = n === void 0 ? i : n + i);
    }
    return n;
  }
  return Qm = e, Qm;
}
var ev, a_;
function Gie() {
  if (a_) return ev;
  a_ = 1;
  var e = wr(), t = Kie();
  function r(n, a) {
    return n && n.length ? t(n, e(a, 2)) : 0;
  }
  return ev = r, ev;
}
var Yie = Gie();
const Xie = /* @__PURE__ */ _e(Yie);
var Zie = ["width", "height", "className", "style", "children"], Jie = ["sourceX", "sourceY", "sourceControlX", "targetX", "targetY", "targetControlX", "linkWidth"];
function Co(e) {
  "@babel/helpers - typeof";
  return Co = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Co(e);
}
function o_(e, t) {
  if (e == null) return {};
  var r = Qie(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Qie(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Yn() {
  return Yn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Yn.apply(this, arguments);
}
function ese(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function i_(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, t$(n.key), n);
  }
}
function tse(e, t, r) {
  return t && i_(e.prototype, t), r && i_(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function rse(e, t, r) {
  return t = iu(t), nse(e, e$() ? Reflect.construct(t, r || [], iu(e).constructor) : t.apply(e, r));
}
function nse(e, t) {
  if (t && (Co(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ase(e);
}
function ase(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function e$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (e$ = function() {
    return !!e;
  })();
}
function iu(e) {
  return iu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, iu(e);
}
function ose(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Yy(e, t);
}
function Yy(e, t) {
  return Yy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Yy(e, t);
}
function s_(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? s_(Object(r), !0).forEach(function(n) {
      Af(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s_(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Af(e, t, r) {
  return t = t$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function t$(e) {
  var t = ise(e, "string");
  return Co(t) == "symbol" ? t : t + "";
}
function ise(e, t) {
  if (Co(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Co(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var sse = {
  x: 0,
  y: 0
}, cse = function(t, r) {
  var n = +t, a = r - n;
  return function(o) {
    return n + a * o;
  };
}, _f = function(t) {
  return t.y + t.dy / 2;
}, gs = function(t) {
  return t && t.value || 0;
}, su = function(t, r) {
  return r.reduce(function(n, a) {
    return n + gs(t[a]);
  }, 0);
}, lse = function(t, r, n) {
  return n.reduce(function(a, o) {
    var i = r[o], s = t[i.source];
    return a + _f(s) * gs(r[o]);
  }, 0);
}, use = function(t, r, n) {
  return n.reduce(function(a, o) {
    var i = r[o], s = t[i.target];
    return a + _f(s) * gs(r[o]);
  }, 0);
}, fse = function(t, r) {
  return t.y - r.y;
}, dse = function(t, r) {
  for (var n = [], a = [], o = [], i = [], s = 0, c = t.length; s < c; s++) {
    var l = t[s];
    l.source === r && (o.push(l.target), i.push(s)), l.target === r && (n.push(l.source), a.push(s));
  }
  return {
    sourceNodes: n,
    sourceLinks: a,
    targetLinks: i,
    targetNodes: o
  };
}, pse = function e(t, r) {
  for (var n = r.targetNodes, a = 0, o = n.length; a < o; a++) {
    var i = t[n[a]];
    i && (i.depth = Math.max(r.depth + 1, i.depth), e(t, i));
  }
}, hse = function(t, r, n) {
  for (var a = t.nodes, o = t.links, i = a.map(function(m, y) {
    var b = dse(o, y);
    return qe(qe(qe({}, m), b), {}, {
      value: Math.max(su(o, b.sourceLinks), su(o, b.targetLinks)),
      depth: 0
    });
  }), s = 0, c = i.length; s < c; s++) {
    var l = i[s];
    l.sourceNodes.length || pse(i, l);
  }
  var u = UM(i, function(m) {
    return m.depth;
  }).depth;
  if (u >= 1)
    for (var f = (r - n) / u, d = 0, p = i.length; d < p; d++) {
      var g = i[d];
      g.targetNodes.length || (g.depth = u), g.x = g.depth * f, g.dx = n;
    }
  return {
    tree: i,
    maxDepth: u
  };
}, mse = function(t) {
  for (var r = [], n = 0, a = t.length; n < a; n++) {
    var o = t[n];
    r[o.depth] || (r[o.depth] = []), r[o.depth].push(o);
  }
  return r;
}, vse = function(t, r, n, a) {
  for (var o = Ks(t.map(function(f) {
    return (r - (f.length - 1) * n) / Xie(f, gs);
  })), i = 0, s = t.length; i < s; i++)
    for (var c = 0, l = t[i].length; c < l; c++) {
      var u = t[i][c];
      u.y = c, u.dy = u.value * o;
    }
  return a.map(function(f) {
    return qe(qe({}, f), {}, {
      dy: gs(f) * o
    });
  });
}, tv = function(t, r, n) {
  for (var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, o = 0, i = t.length; o < i; o++) {
    var s = t[o], c = s.length;
    a && s.sort(fse);
    for (var l = 0, u = 0; u < c; u++) {
      var f = s[u], d = l - f.y;
      d > 0 && (f.y += d), l = f.y + f.dy + n;
    }
    l = r + n;
    for (var p = c - 1; p >= 0; p--) {
      var g = s[p], m = g.y + g.dy + n - l;
      if (m > 0)
        g.y -= m, l = g.y;
      else
        break;
    }
  }
}, yse = function(t, r, n, a) {
  for (var o = 0, i = r.length; o < i; o++)
    for (var s = r[o], c = 0, l = s.length; c < l; c++) {
      var u = s[c];
      if (u.sourceLinks.length) {
        var f = su(n, u.sourceLinks), d = lse(t, n, u.sourceLinks), p = d / f;
        u.y += (p - _f(u)) * a;
      }
    }
}, gse = function(t, r, n, a) {
  for (var o = r.length - 1; o >= 0; o--)
    for (var i = r[o], s = 0, c = i.length; s < c; s++) {
      var l = i[s];
      if (l.targetLinks.length) {
        var u = su(n, l.targetLinks), f = use(t, n, l.targetLinks), d = f / u;
        l.y += (d - _f(l)) * a;
      }
    }
}, bse = function(t, r) {
  for (var n = 0, a = t.length; n < a; n++) {
    var o = t[n], i = 0, s = 0;
    o.targetLinks.sort(function(g, m) {
      return t[r[g].target].y - t[r[m].target].y;
    }), o.sourceLinks.sort(function(g, m) {
      return t[r[g].source].y - t[r[m].source].y;
    });
    for (var c = 0, l = o.targetLinks.length; c < l; c++) {
      var u = r[o.targetLinks[c]];
      u && (u.sy = i, i += u.dy);
    }
    for (var f = 0, d = o.sourceLinks.length; f < d; f++) {
      var p = r[o.sourceLinks[f]];
      p && (p.ty = s, s += p.dy);
    }
  }
}, xse = function(t) {
  var r = t.data, n = t.width, a = t.height, o = t.iterations, i = t.nodeWidth, s = t.nodePadding, c = t.sort, l = r.links, u = hse(r, n, i), f = u.tree, d = mse(f), p = vse(d, a, s, l);
  tv(d, a, s, c);
  for (var g = 1, m = 1; m <= o; m++)
    gse(f, d, p, g *= 0.99), tv(d, a, s, c), yse(f, d, p, g), tv(d, a, s, c);
  return bse(f, p), {
    nodes: f,
    links: p
  };
}, wse = function(t, r) {
  return r === "node" ? {
    x: t.x + t.width / 2,
    y: t.y + t.height / 2
  } : {
    x: (t.sourceX + t.targetX) / 2,
    y: (t.sourceY + t.targetY) / 2
  };
}, Sse = function(t, r, n) {
  var a = t.payload;
  if (r === "node")
    return [{
      payload: t,
      name: ge(a, n, ""),
      value: ge(a, "value")
    }];
  if (a.source && a.target) {
    var o = ge(a.source, n, ""), i = ge(a.target, n, "");
    return [{
      payload: t,
      name: "".concat(o, " - ").concat(i),
      value: ge(a, "value")
    }];
  }
  return [];
}, W0 = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    ese(this, t);
    for (var n = arguments.length, a = new Array(n), o = 0; o < n; o++)
      a[o] = arguments[o];
    return r = rse(this, t, [].concat(a)), Af(r, "state", {
      activeElement: null,
      activeElementType: null,
      isTooltipActive: !1,
      nodes: [],
      links: []
    }), r;
  }
  return ose(t, e), tse(t, [{
    key: "handleMouseEnter",
    value: function(n, a, o) {
      var i = this.props, s = i.onMouseEnter, c = i.children, l = ct(c, Be);
      l ? this.setState(function(u) {
        return l.props.trigger === "hover" ? qe(qe({}, u), {}, {
          activeElement: n,
          activeElementType: a,
          isTooltipActive: !0
        }) : u;
      }, function() {
        s && s(n, a, o);
      }) : s && s(n, a, o);
    }
  }, {
    key: "handleMouseLeave",
    value: function(n, a, o) {
      var i = this.props, s = i.onMouseLeave, c = i.children, l = ct(c, Be);
      l ? this.setState(function(u) {
        return l.props.trigger === "hover" ? qe(qe({}, u), {}, {
          activeElement: void 0,
          activeElementType: void 0,
          isTooltipActive: !1
        }) : u;
      }, function() {
        s && s(n, a, o);
      }) : s && s(n, a, o);
    }
  }, {
    key: "handleClick",
    value: function(n, a, o) {
      var i = this.props, s = i.onClick, c = i.children, l = ct(c, Be);
      l && l.props.trigger === "click" && (this.state.isTooltipActive ? this.setState(function(u) {
        return qe(qe({}, u), {}, {
          activeElement: void 0,
          activeElementType: void 0,
          isTooltipActive: !1
        });
      }) : this.setState(function(u) {
        return qe(qe({}, u), {}, {
          activeElement: n,
          activeElementType: a,
          isTooltipActive: !0
        });
      })), s && s(n, a, o);
    }
  }, {
    key: "renderLinks",
    value: function(n, a) {
      var o = this, i = this.props, s = i.linkCurvature, c = i.link, l = i.margin, u = lt(l, "top") || 0, f = lt(l, "left") || 0;
      return /* @__PURE__ */ E.createElement(de, {
        className: "recharts-sankey-links",
        key: "recharts-sankey-links"
      }, n.map(function(d, p) {
        var g = d.sy, m = d.ty, y = d.dy, b = a[d.source], w = a[d.target], S = b.x + b.dx + f, P = w.x + f, x = cse(S, P), O = x(s), A = x(1 - s), _ = b.y + g + y / 2 + u, N = w.y + m + y / 2 + u, M = qe({
          sourceX: S,
          targetX: P,
          sourceY: _,
          targetY: N,
          sourceControlX: O,
          targetControlX: A,
          sourceRelativeY: g,
          targetRelativeY: m,
          linkWidth: y,
          index: p,
          payload: qe(qe({}, d), {}, {
            source: b,
            target: w
          })
        }, ae(c, !1)), T = {
          onMouseEnter: o.handleMouseEnter.bind(o, M, "link"),
          onMouseLeave: o.handleMouseLeave.bind(o, M, "link"),
          onClick: o.handleClick.bind(o, M, "link")
        };
        return /* @__PURE__ */ E.createElement(de, Yn({
          key: "link-".concat(d.source, "-").concat(d.target, "-").concat(d.value)
        }, T), o.constructor.renderLinkItem(c, M));
      }));
    }
  }, {
    key: "renderNodes",
    value: function(n) {
      var a = this, o = this.props, i = o.node, s = o.margin, c = lt(s, "top") || 0, l = lt(s, "left") || 0;
      return /* @__PURE__ */ E.createElement(de, {
        className: "recharts-sankey-nodes",
        key: "recharts-sankey-nodes"
      }, n.map(function(u, f) {
        var d = u.x, p = u.y, g = u.dx, m = u.dy, y = qe(qe({}, ae(i, !1)), {}, {
          x: d + l,
          y: p + c,
          width: g,
          height: m,
          index: f,
          payload: u
        }), b = {
          onMouseEnter: a.handleMouseEnter.bind(a, y, "node"),
          onMouseLeave: a.handleMouseLeave.bind(a, y, "node"),
          onClick: a.handleClick.bind(a, y, "node")
        };
        return /* @__PURE__ */ E.createElement(de, Yn({
          key: "node-".concat(u.x, "-").concat(u.y, "-").concat(u.value)
        }, b), a.constructor.renderNodeItem(i, y));
      }));
    }
  }, {
    key: "renderTooltip",
    value: function() {
      var n = this.props, a = n.children, o = n.width, i = n.height, s = n.nameKey, c = ct(a, Be);
      if (!c)
        return null;
      var l = this.state, u = l.isTooltipActive, f = l.activeElement, d = l.activeElementType, p = {
        x: 0,
        y: 0,
        width: o,
        height: i
      }, g = f ? wse(f, d) : sse, m = f ? Sse(f, d, s) : [];
      return /* @__PURE__ */ E.cloneElement(c, {
        viewBox: p,
        active: u,
        coordinate: g,
        label: "",
        payload: m
      });
    }
  }, {
    key: "render",
    value: function() {
      if (!_v(this))
        return null;
      var n = this.props, a = n.width, o = n.height, i = n.className, s = n.style, c = n.children, l = o_(n, Zie), u = this.state, f = u.links, d = u.nodes, p = ae(l, !1);
      return /* @__PURE__ */ E.createElement("div", {
        className: ue("recharts-wrapper", i),
        style: qe(qe({}, s), {}, {
          position: "relative",
          cursor: "default",
          width: a,
          height: o
        }),
        role: "region"
      }, /* @__PURE__ */ E.createElement(tl, Yn({}, p, {
        width: a,
        height: o
      }), lW(c), this.renderLinks(f, d), this.renderNodes(d)), this.renderTooltip());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var o = n.data, i = n.width, s = n.height, c = n.margin, l = n.iterations, u = n.nodeWidth, f = n.nodePadding, d = n.sort;
      if (o !== a.prevData || i !== a.prevWidth || s !== a.prevHeight || !ra(c, a.prevMargin) || l !== a.prevIterations || u !== a.prevNodeWidth || f !== a.prevNodePadding || d !== a.sort) {
        var p = i - (c && c.left || 0) - (c && c.right || 0), g = s - (c && c.top || 0) - (c && c.bottom || 0), m = xse({
          data: o,
          width: p,
          height: g,
          iterations: l,
          nodeWidth: u,
          nodePadding: f,
          sort: d
        }), y = m.links, b = m.nodes;
        return qe(qe({}, a), {}, {
          nodes: b,
          links: y,
          prevData: o,
          prevWidth: l,
          prevHeight: s,
          prevMargin: c,
          prevNodePadding: f,
          prevNodeWidth: u,
          prevIterations: l,
          prevSort: d
        });
      }
      return null;
    }
  }, {
    key: "renderLinkItem",
    value: function(n, a) {
      if (/* @__PURE__ */ E.isValidElement(n))
        return /* @__PURE__ */ E.cloneElement(n, a);
      if (se(n))
        return n(a);
      var o = a.sourceX, i = a.sourceY, s = a.sourceControlX, c = a.targetX, l = a.targetY, u = a.targetControlX, f = a.linkWidth, d = o_(a, Jie);
      return /* @__PURE__ */ E.createElement("path", Yn({
        className: "recharts-sankey-link",
        d: `
          M`.concat(o, ",").concat(i, `
          C`).concat(s, ",").concat(i, " ").concat(u, ",").concat(l, " ").concat(c, ",").concat(l, `
        `),
        fill: "none",
        stroke: "#333",
        strokeWidth: f,
        strokeOpacity: "0.2"
      }, ae(d, !1)));
    }
  }, {
    key: "renderNodeItem",
    value: function(n, a) {
      return /* @__PURE__ */ E.isValidElement(n) ? /* @__PURE__ */ E.cloneElement(n, a) : se(n) ? n(a) : /* @__PURE__ */ E.createElement(Gs, Yn({
        className: "recharts-sankey-node",
        fill: "#0088fe",
        fillOpacity: "0.8"
      }, ae(a, !1), {
        role: "img"
      }));
    }
  }]);
})(St);
Af(W0, "displayName", "Sankey");
Af(W0, "defaultProps", {
  nameKey: "name",
  dataKey: "value",
  nodePadding: 10,
  nodeWidth: 10,
  linkCurvature: 0.5,
  iterations: 32,
  margin: {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
  },
  sort: !0
});
var Ose = Xo({
  chartName: "RadarChart",
  GraphicalChild: uo,
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Uo
  }, {
    axisType: "radiusAxis",
    AxisComp: Vo
  }],
  formatAxisMap: kM,
  defaultProps: {
    layout: "centric",
    startAngle: 90,
    endAngle: -270,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), Pse = Xo({
  chartName: "ScatterChart",
  GraphicalChild: Yo,
  defaultTooltipEventType: "item",
  validateTooltipEventTypes: ["item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: wt
  }, {
    axisType: "yAxis",
    AxisComp: pt
  }, {
    axisType: "zAxis",
    AxisComp: Go
  }],
  formatAxisMap: gf
}), Ase = Xo({
  chartName: "AreaChart",
  GraphicalChild: Qe,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: wt
  }, {
    axisType: "yAxis",
    AxisComp: pt
  }],
  formatAxisMap: gf
}), r$ = Xo({
  chartName: "ComposedChart",
  GraphicalChild: [Ys, Qe, dt, Yo],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: wt
  }, {
    axisType: "yAxis",
    AxisComp: pt
  }, {
    axisType: "zAxis",
    AxisComp: Go
  }],
  formatAxisMap: gf
});
const Rt = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
};
function Ice() {
  const [e, t] = pr(null), [r, n] = pr(!1), [a, o] = pr(!1), [i, s] = pr(!1);
  return ko(() => {
    const c = () => {
      const l = window.innerWidth;
      l >= Rt["2xl"] ? t("2xl") : l >= Rt.xl ? t("xl") : l >= Rt.lg ? t("lg") : l >= Rt.md ? t("md") : l >= Rt.sm ? t("sm") : t(null), n(l < Rt.md), o(l >= Rt.md && l < Rt.lg), s(l >= Rt.lg);
    };
    return c(), window.addEventListener("resize", c), () => window.removeEventListener("resize", c);
  }, []), {
    breakpoint: e,
    isMobile: r,
    isTablet: a,
    isDesktop: i,
    isAbove: (c) => {
      if (!e) return !1;
      const l = Object.keys(Rt).indexOf(e), u = Object.keys(Rt).indexOf(c);
      return l >= u;
    },
    isBelow: (c) => {
      if (!e) return !0;
      const l = Object.keys(Rt).indexOf(e), u = Object.keys(Rt).indexOf(c);
      return l < u;
    }
  };
}
function Dce(e) {
  const [t, r] = pr(!1);
  return ko(() => {
    const n = window.matchMedia(e);
    n.matches !== t && r(n.matches);
    const a = () => r(n.matches);
    return n.addEventListener("change", a), () => n.removeEventListener("change", a);
  }, [t, e]), t;
}
const _se = {
  // Sentiment colors
  sentiment: {
    positive: "#22C55E",
    // green-500
    neutral: "#78716C",
    // stone-500
    negative: "#EF4444"
    // red-500
  },
  // Platform colors - slightly adjusted for better contrast
  platform: {
    twitter: "#1DA1F2",
    instagram: "#E4405F",
    facebook: "#1877F2",
    tiktok: "#1C1917",
    // Dark gray instead of pure black
    google_news: "#4285F4"
  },
  // Emotion colors
  emotion: {
    joy: "#22C55E",
    // green-500
    sadness: "#57AEB3",
    // tertiary-500 (teal medio)
    anger: "#EF4444",
    // red-500
    fear: "#8B5CF6",
    // violet-500
    surprise: "#F59E0B",
    // amber-500
    others: "#78716C"
    // stone-500
  },
  // Crisis level colors
  crisis: {
    low: "#22C55E",
    // green-500
    medium: "#F59E0B",
    // amber-500
    high: "#EF4444",
    // red-500
    critical: "#DC2626"
    // red-600
  },
  // Chart UI elements
  grid: "#E7E5E4",
  // stone-200
  axis: "#78716C",
  // stone-500
  axisSecondary: "#A8A29E",
  // stone-400
  background: "#FFFFFF",
  emptyRing: "#E7E5E4",
  // stone-200
  tooltip: {
    background: "#FFFFFF",
    border: "#E7E5E4",
    text: "#1C1917"
  },
  // Brand palette
  primary: "#2BC4CE",
  // Cyan medio (CTA solido)
  secondary: "#43868A",
  // Teal oscuro
  tertiary: "#57AEB3",
  // Teal medio
  accent: "#6BD6DB",
  // Teal claro
  surface: "#41424C",
  // Slate anchor
  // Score colors (for BrandHealthScore gauge)
  score: {
    excellent: "#22C55E",
    // 80-100
    good: "#57AEB3",
    // 60-79 (teal medio)
    fair: "#F59E0B",
    // 40-59 (amber)
    poor: "#EF4444",
    // 20-39
    critical: "#DC2626"
    // 0-19
  }
}, Ese = {
  // Sentiment colors - brighter for dark backgrounds
  sentiment: {
    positive: "#4ADE80",
    // green-400
    neutral: "#A8A29E",
    // stone-400
    negative: "#F87171"
    // red-400
  },
  // Platform colors - lighter variants for visibility
  platform: {
    twitter: "#38BDF8",
    // sky-400
    instagram: "#F472B6",
    // pink-400
    facebook: "#60A5FA",
    // blue-400
    tiktok: "#E7E5E4",
    // stone-200 (visible on dark)
    google_news: "#60A5FA"
    // blue-400
  },
  // Emotion colors - brighter variants
  emotion: {
    joy: "#4ADE80",
    // green-400
    sadness: "#6FB7BC",
    // tertiary-400 (teal medio claro)
    anger: "#F87171",
    // red-400
    fear: "#A78BFA",
    // violet-400
    surprise: "#FBBF24",
    // amber-400
    others: "#A8A29E"
    // stone-400
  },
  // Crisis level colors - adjusted for dark mode
  crisis: {
    low: "#4ADE80",
    // green-400
    medium: "#FBBF24",
    // amber-400
    high: "#F87171",
    // red-400
    critical: "#EF4444"
    // red-500
  },
  // Chart UI elements - inverted for dark mode
  grid: "#44403C",
  // stone-700
  axis: "#A8A29E",
  // stone-400
  axisSecondary: "#78716C",
  // stone-500
  background: "#1C1917",
  // stone-900
  emptyRing: "#44403C",
  // stone-700
  tooltip: {
    background: "#292524",
    // stone-800
    border: "#44403C",
    // stone-700
    text: "#FAFAF9"
    // stone-50
  },
  // Brand palette - brighter for dark mode
  primary: "#7DF9FF",
  // Cyan IA (punto de luz sobre dark)
  secondary: "#58A8B0",
  // secondary-400
  tertiary: "#6FB7BC",
  // tertiary-400
  accent: "#6BD6DB",
  // accent-300
  surface: "#41424C",
  // anchor
  // Score colors - brighter for dark mode
  score: {
    excellent: "#4ADE80",
    // green-400
    good: "#6FB7BC",
    // teal medio claro
    fair: "#FBBF24",
    // amber-400
    poor: "#F87171",
    // red-400
    critical: "#EF4444"
    // red-500
  }
};
function cn() {
  const [e, t] = pr(!1);
  return ko(() => {
    const r = () => {
      t(document.documentElement.classList.contains("dark"));
    };
    r();
    const n = new MutationObserver((a) => {
      a.forEach((o) => {
        o.attributeName === "class" && r();
      });
    });
    return n.observe(document.documentElement, { attributes: !0 }), () => n.disconnect();
  }, []), e ? Ese : _se;
}
function n$(e, t) {
  return e >= 80 ? t.score.excellent : e >= 60 ? t.score.good : e >= 40 ? t.score.fair : e >= 20 ? t.score.poor : t.score.critical;
}
function Cse(e) {
  return e >= 80 ? "Excellent" : e >= 60 ? "Good" : e >= 40 ? "Fair" : e >= 20 ? "Poor" : "Critical";
}
const kse = {
  sm: { height: 150, innerRadius: 40, outerRadius: 60 },
  md: { height: 200, innerRadius: 55, outerRadius: 80 },
  lg: { height: 280, innerRadius: 70, outerRadius: 100 }
}, Nse = v.forwardRef(
  ({
    className: e,
    data: t,
    showLegend: r = !0,
    showLabels: n = !1,
    size: a = "md",
    onSelectSentiment: o,
    selected: i,
    centerCaption: s = "menciones",
    ...c
  }, l) => {
    const u = cn(), f = t.positive + t.neutral + t.negative, d = kse[a], p = [
      { key: "positive", name: "Positivo", value: t.positive, color: u.sentiment.positive },
      { key: "neutral", name: "Neutral", value: t.neutral, color: u.sentiment.neutral },
      { key: "negative", name: "Negativo", value: t.negative, color: u.sentiment.negative }
    ].filter((b) => b.value > 0), g = (b) => !!(i != null && i.length) && !i.includes(b), m = ({ percent: b }) => !n || b < 0.05 ? null : `${(b * 100).toFixed(0)}%`, y = ({ active: b, payload: w }) => {
      if (!b || !(w != null && w.length)) return null;
      const S = w[0], P = (S.value / f * 100).toFixed(1);
      return /* @__PURE__ */ C("div", { className: "rounded-lg border border-stone-200 bg-white px-3 py-2 shadow-lg dark:border-stone-700 dark:bg-stone-900", children: [
        /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "h-3 w-3 rounded-full",
              style: { backgroundColor: S.payload.color }
            }
          ),
          /* @__PURE__ */ h("span", { className: "font-medium text-stone-900 dark:text-stone-100", children: S.name })
        ] }),
        /* @__PURE__ */ C("div", { className: "mt-1 text-sm text-stone-600 dark:text-stone-400", children: [
          S.value.toLocaleString(),
          " (",
          P,
          "%)"
        ] })
      ] });
    };
    return /* @__PURE__ */ C("div", { ref: l, className: F("relative w-full", e), ...c, children: [
      /* @__PURE__ */ C(
        "div",
        {
          className: "pointer-events-none absolute inset-x-0 flex flex-col items-center justify-center",
          style: { height: d.height },
          "aria-hidden": "true",
          children: [
            /* @__PURE__ */ h("span", { className: "text-2xl font-bold tabular-nums text-stone-900 dark:text-stone-100", children: f.toLocaleString("es-EC") }),
            /* @__PURE__ */ h("span", { className: "text-xs text-stone-500 dark:text-stone-400", children: s })
          ]
        }
      ),
      /* @__PURE__ */ h(qt, { width: "100%", height: d.height, children: /* @__PURE__ */ C(q0, { children: [
        /* @__PURE__ */ h(
          Sr,
          {
            data: p,
            cx: "50%",
            cy: "50%",
            innerRadius: d.innerRadius,
            outerRadius: d.outerRadius,
            paddingAngle: 2,
            dataKey: "value",
            label: n ? m : !1,
            labelLine: !1,
            animationBegin: 0,
            animationDuration: 800,
            children: p.map((b, w) => /* @__PURE__ */ h(
              gr,
              {
                fill: b.color,
                strokeWidth: 0,
                fillOpacity: g(b.key) ? 0.25 : 1,
                cursor: o ? "pointer" : void 0,
                onClick: o ? () => o(b.key) : void 0
              },
              `cell-${w}`
            ))
          }
        ),
        /* @__PURE__ */ h(Be, { content: /* @__PURE__ */ h(y, {}) }),
        r && /* @__PURE__ */ h(
          Zt,
          {
            verticalAlign: "bottom",
            height: 36,
            formatter: (b) => /* @__PURE__ */ h("span", { className: "text-sm text-stone-600 dark:text-stone-400", children: b })
          }
        )
      ] }) })
    ] });
  }
);
Nse.displayName = "SentimentDonut";
const Tse = v.forwardRef(
  ({
    className: e,
    data: t,
    variant: r = "total",
    showGrid: n = !0,
    showLegend: a = !0,
    height: o = 300,
    dateFormat: i = "MMM dd",
    ...s
  }, c) => {
    const l = cn(), u = t.map((p) => ({
      ...p,
      dateLabel: Dt(new Date(p.date), i)
    })), f = ({ active: p, payload: g, label: m }) => !p || !(g != null && g.length) ? null : /* @__PURE__ */ C("div", { className: "rounded-lg border border-stone-200 bg-white px-3 py-2 shadow-lg dark:border-stone-700 dark:bg-stone-900", children: [
      /* @__PURE__ */ h("p", { className: "mb-1 text-sm font-medium text-stone-900 dark:text-stone-100", children: m }),
      g.map((y, b) => /* @__PURE__ */ C("div", { className: "flex items-center justify-between gap-4 text-sm", children: [
        /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "h-2 w-2 rounded-full",
              style: { backgroundColor: y.color }
            }
          ),
          /* @__PURE__ */ h("span", { className: "text-stone-600 dark:text-stone-400", children: y.name })
        ] }),
        /* @__PURE__ */ h("span", { className: "font-medium text-stone-900 dark:text-stone-100", children: Ci(y.value) })
      ] }, b))
    ] }), d = () => r === "total" ? /* @__PURE__ */ h(
      Qe,
      {
        type: "monotone",
        dataKey: "total",
        name: "Mentions",
        stroke: l.secondary,
        fill: l.secondary,
        fillOpacity: 0.3,
        strokeWidth: 2
      }
    ) : r === "sentiment" ? /* @__PURE__ */ C(Ve, { children: [
      /* @__PURE__ */ h(
        Qe,
        {
          type: "monotone",
          dataKey: "positive",
          name: "Positive",
          stackId: "1",
          stroke: l.sentiment.positive,
          fill: l.sentiment.positive,
          fillOpacity: 0.6
        }
      ),
      /* @__PURE__ */ h(
        Qe,
        {
          type: "monotone",
          dataKey: "neutral",
          name: "Neutral",
          stackId: "1",
          stroke: l.sentiment.neutral,
          fill: l.sentiment.neutral,
          fillOpacity: 0.6
        }
      ),
      /* @__PURE__ */ h(
        Qe,
        {
          type: "monotone",
          dataKey: "negative",
          name: "Negative",
          stackId: "1",
          stroke: l.sentiment.negative,
          fill: l.sentiment.negative,
          fillOpacity: 0.6
        }
      )
    ] }) : /* @__PURE__ */ C(Ve, { children: [
      /* @__PURE__ */ h(
        Qe,
        {
          type: "monotone",
          dataKey: "twitter",
          name: "X",
          stackId: "1",
          stroke: l.platform.twitter,
          fill: l.platform.twitter,
          fillOpacity: 0.6
        }
      ),
      /* @__PURE__ */ h(
        Qe,
        {
          type: "monotone",
          dataKey: "instagram",
          name: "Instagram",
          stackId: "1",
          stroke: l.platform.instagram,
          fill: l.platform.instagram,
          fillOpacity: 0.6
        }
      ),
      /* @__PURE__ */ h(
        Qe,
        {
          type: "monotone",
          dataKey: "facebook",
          name: "Facebook",
          stackId: "1",
          stroke: l.platform.facebook,
          fill: l.platform.facebook,
          fillOpacity: 0.6
        }
      ),
      /* @__PURE__ */ h(
        Qe,
        {
          type: "monotone",
          dataKey: "tiktok",
          name: "TikTok",
          stackId: "1",
          stroke: l.platform.tiktok,
          fill: l.platform.tiktok,
          fillOpacity: 0.6
        }
      ),
      /* @__PURE__ */ h(
        Qe,
        {
          type: "monotone",
          dataKey: "google_news",
          name: "Google News",
          stackId: "1",
          stroke: l.platform.google_news,
          fill: l.platform.google_news,
          fillOpacity: 0.6
        }
      )
    ] });
    return /* @__PURE__ */ h("div", { ref: c, className: F("w-full", e), ...s, children: /* @__PURE__ */ h(qt, { width: "100%", height: o, children: /* @__PURE__ */ C(
      Ase,
      {
        data: u,
        margin: { top: 10, right: 10, left: 12, bottom: 18 },
        children: [
          n && /* @__PURE__ */ h(
            Bn,
            {
              strokeDasharray: "3 3",
              stroke: l.grid,
              vertical: !1
            }
          ),
          /* @__PURE__ */ h(
            wt,
            {
              dataKey: "dateLabel",
              axisLine: !1,
              tickLine: !1,
              tick: { fontSize: 12, fill: l.axis },
              dy: 10,
              label: { value: "Fecha", position: "insideBottom", offset: -8, fontSize: 12, fill: l.axis }
            }
          ),
          /* @__PURE__ */ h(
            pt,
            {
              axisLine: !1,
              tickLine: !1,
              tick: { fontSize: 12, fill: l.axis },
              tickFormatter: Ci,
              width: 50,
              label: { value: "Menciones", angle: -90, position: "insideLeft", fontSize: 12, fill: l.axis }
            }
          ),
          /* @__PURE__ */ h(Be, { content: /* @__PURE__ */ h(f, {}) }),
          a && /* @__PURE__ */ h(
            Zt,
            {
              verticalAlign: "top",
              height: 36,
              formatter: (p) => /* @__PURE__ */ h("span", { className: "text-xs text-stone-600 dark:text-stone-400", children: p })
            }
          ),
          d()
        ]
      }
    ) }) });
  }
);
Tse.displayName = "MentionsTimeline";
const Mse = {
  sm: { height: 100, fontSize: "text-xl", labelSize: "text-xs" },
  md: { height: 150, fontSize: "text-3xl", labelSize: "text-sm" },
  lg: { height: 200, fontSize: "text-4xl", labelSize: "text-base" }
}, Rse = v.forwardRef(
  ({
    className: e,
    value: t,
    size: r = "md",
    showValue: n = !0,
    showLabel: a = !0,
    ...o
  }, i) => {
    const s = cn(), c = Math.max(0, Math.min(100, t)), l = R_(c), u = $_(l), f = Mse[r], d = [
      { name: "low", value: 25, color: s.crisis.low },
      { name: "medium", value: 25, color: s.crisis.medium },
      { name: "high", value: 25, color: s.crisis.high },
      { name: "critical", value: 25, color: s.crisis.critical }
    ], p = 180 - c / 100 * 180;
    return /* @__PURE__ */ C(
      "div",
      {
        ref: i,
        className: F("relative flex flex-col items-center", e),
        ...o,
        children: [
          /* @__PURE__ */ C("div", { className: "relative", style: { width: "100%", height: f.height }, children: [
            /* @__PURE__ */ h(qt, { width: "100%", height: "100%", children: /* @__PURE__ */ h(q0, { children: /* @__PURE__ */ h(
              Sr,
              {
                data: d,
                cx: "50%",
                cy: "100%",
                startAngle: 180,
                endAngle: 0,
                innerRadius: "60%",
                outerRadius: "100%",
                paddingAngle: 0,
                dataKey: "value",
                children: d.map((g, m) => /* @__PURE__ */ h(gr, { fill: g.color, stroke: "none" }, `cell-${m}`))
              }
            ) }) }),
            /* @__PURE__ */ h(
              "div",
              {
                className: "absolute left-1/2 bottom-0 origin-bottom",
                style: {
                  height: `${f.height * 0.4}px`,
                  transform: `translateX(-50%) rotate(${p}deg)`,
                  transition: "transform 0.5s ease-out"
                },
                children: /* @__PURE__ */ h(
                  "div",
                  {
                    className: "mx-auto h-full w-1 rounded-full",
                    style: { backgroundColor: s.crisis[l] }
                  }
                )
              }
            ),
            /* @__PURE__ */ h(
              "div",
              {
                className: "absolute left-1/2 bottom-0 h-4 w-4 -translate-x-1/2 translate-y-1/2 rounded-full bg-white shadow-md dark:bg-stone-900",
                style: { borderColor: s.crisis[l], borderWidth: 3 }
              }
            ),
            n && /* @__PURE__ */ h("div", { className: "absolute left-1/2 bottom-4 -translate-x-1/2 text-center", children: /* @__PURE__ */ C(
              "span",
              {
                className: F(
                  "font-bold tabular-nums",
                  f.fontSize
                ),
                style: { color: s.crisis[l] },
                children: [
                  c.toFixed(0),
                  "%"
                ]
              }
            ) })
          ] }),
          a && /* @__PURE__ */ h("div", { className: "mt-2 text-center", children: /* @__PURE__ */ h(
            "span",
            {
              className: F(
                "font-medium",
                f.labelSize
              ),
              style: { color: s.crisis[l] },
              children: u
            }
          ) }),
          /* @__PURE__ */ C("div", { className: "mt-1 flex w-full justify-between px-2", children: [
            /* @__PURE__ */ h("span", { className: "text-xs text-stone-400", children: "0%" }),
            /* @__PURE__ */ h("span", { className: "text-xs text-stone-400", children: "100%" })
          ] })
        ]
      }
    );
  }
);
Rse.displayName = "CrisisGauge";
const $se = {
  sm: { height: 120, scoreSize: "text-2xl", outerRadius: 50, innerRadius: 38 },
  md: { height: 180, scoreSize: "text-4xl", outerRadius: 75, innerRadius: 58 },
  lg: { height: 240, scoreSize: "text-5xl", outerRadius: 100, innerRadius: 78 }
}, Ise = v.forwardRef(
  ({
    className: e,
    score: t,
    breakdown: r,
    size: n = "md",
    showBreakdown: a = !0,
    ...o
  }, i) => {
    const s = cn(), c = Math.max(0, Math.min(100, t)), l = $se[n], u = n$(c, s), f = Cse(c), d = c, p = 100 - c, g = [
      { name: "filled", value: d },
      { name: "empty", value: p }
    ];
    return /* @__PURE__ */ C(
      "div",
      {
        ref: i,
        className: F("flex flex-col items-center", e),
        ...o,
        children: [
          /* @__PURE__ */ C("div", { className: "relative", style: { width: "100%", height: l.height }, children: [
            /* @__PURE__ */ h(qt, { width: "100%", height: "100%", children: /* @__PURE__ */ C(q0, { children: [
              /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ C("linearGradient", { id: "healthGradient", x1: "0%", y1: "0%", x2: "100%", y2: "0%", children: [
                /* @__PURE__ */ h("stop", { offset: "0%", stopColor: "#EF4444" }),
                /* @__PURE__ */ h("stop", { offset: "25%", stopColor: "#F87171" }),
                /* @__PURE__ */ h("stop", { offset: "50%", stopColor: "#F59E0B" }),
                /* @__PURE__ */ h("stop", { offset: "75%", stopColor: "#57AEB3" }),
                /* @__PURE__ */ h("stop", { offset: "100%", stopColor: "#22C55E" })
              ] }) }),
              /* @__PURE__ */ C(
                Sr,
                {
                  data: g,
                  cx: "50%",
                  cy: "50%",
                  startAngle: 90,
                  endAngle: -270,
                  innerRadius: l.innerRadius,
                  outerRadius: l.outerRadius,
                  paddingAngle: 0,
                  dataKey: "value",
                  stroke: "none",
                  children: [
                    /* @__PURE__ */ h(gr, { fill: u }),
                    /* @__PURE__ */ h(gr, { fill: s.emptyRing })
                  ]
                }
              )
            ] }) }),
            /* @__PURE__ */ C("div", { className: "absolute inset-0 flex flex-col items-center justify-center", children: [
              /* @__PURE__ */ h(
                "span",
                {
                  className: F("font-bold tabular-nums", l.scoreSize),
                  style: { color: u },
                  children: c.toFixed(0)
                }
              ),
              /* @__PURE__ */ h("span", { className: "text-xs", style: { color: u }, children: f })
            ] })
          ] }),
          a && r && /* @__PURE__ */ C("div", { className: "mt-4 grid w-full max-w-[200px] grid-cols-3 gap-2 text-center", children: [
            /* @__PURE__ */ h(
              rv,
              {
                label: "Sentiment",
                value: r.sentiment
              }
            ),
            /* @__PURE__ */ h(
              rv,
              {
                label: "Volume",
                value: r.volume
              }
            ),
            /* @__PURE__ */ h(
              rv,
              {
                label: "Engagement",
                value: r.engagement
              }
            )
          ] })
        ]
      }
    );
  }
);
Ise.displayName = "BrandHealthScore";
function rv({ label: e, value: t }) {
  const r = cn(), n = n$(t, r);
  return /* @__PURE__ */ C("div", { className: "space-y-1", children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: "text-lg font-semibold tabular-nums",
        style: { color: n },
        children: t
      }
    ),
    /* @__PURE__ */ h("div", { className: "text-xs text-stone-500 dark:text-stone-400", children: e })
  ] });
}
const c_ = {
  twitter: "Twitter/X",
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  google_news: "Google News"
}, Dse = {
  twitter: /* @__PURE__ */ h("svg", { className: "h-4 w-4", viewBox: "0 0 24 24", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" }) }),
  instagram: /* @__PURE__ */ h("svg", { className: "h-4 w-4", viewBox: "0 0 24 24", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" }) }),
  facebook: /* @__PURE__ */ h("svg", { className: "h-4 w-4", viewBox: "0 0 24 24", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" }) }),
  tiktok: /* @__PURE__ */ h("svg", { className: "h-4 w-4", viewBox: "0 0 24 24", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" }) }),
  google_news: /* @__PURE__ */ h("svg", { className: "h-4 w-4", viewBox: "0 0 24 24", fill: "currentColor", children: /* @__PURE__ */ h("path", { d: "M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zm-.5 3.5h1v3h-1v-3zm-4.5 3h3v1h-3v-1zm9 0h3v1h-3v-1zM7 8.5h10v1H7v-1zm0 2h10v1H7v-1zm0 2h10v1H7v-1zm0 2h10v1H7v-1zm0 2h7v1H7v-1z" }) })
}, jse = {
  sm: { height: 200, barSize: 16, fontSize: 10 },
  md: { height: 280, barSize: 20, fontSize: 12 },
  lg: { height: 360, barSize: 28, fontSize: 14 }
}, Lse = v.forwardRef(
  ({
    className: e,
    data: t,
    showIcons: r = !0,
    showPercentages: n = !0,
    orientation: a = "horizontal",
    size: o = "md",
    ...i
  }, s) => {
    const c = cn(), l = jse[o], u = Object.values(t).reduce((g, m) => g + m, 0), f = Object.entries(t).map(([g, m]) => ({
      platform: g,
      label: c_[g],
      count: m,
      percentage: u > 0 ? (m / u * 100).toFixed(1) : "0",
      color: c.platform[g]
    })).sort((g, m) => m.count - g.count), d = ({ active: g, payload: m }) => {
      if (!g || !(m != null && m.length)) return null;
      const y = m[0].payload;
      return /* @__PURE__ */ C("div", { className: "rounded-lg border border-stone-200 bg-white px-3 py-2 shadow-lg dark:border-stone-700 dark:bg-stone-900", children: [
        /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "h-3 w-3 rounded",
              style: { backgroundColor: y.color }
            }
          ),
          /* @__PURE__ */ h("span", { className: "font-medium text-stone-900 dark:text-stone-100", children: y.label })
        ] }),
        /* @__PURE__ */ C("div", { className: "mt-1 text-sm text-stone-600 dark:text-stone-400", children: [
          y.count.toLocaleString(),
          " mentions (",
          y.percentage,
          "%)"
        ] })
      ] });
    }, p = ({ x: g, y: m, payload: y }) => {
      const b = y.value;
      return /* @__PURE__ */ C("g", { transform: `translate(${g},${m})`, children: [
        /* @__PURE__ */ h(
          "text",
          {
            x: r ? -28 : -5,
            y: 4,
            textAnchor: "end",
            className: "fill-stone-600 text-xs dark:fill-stone-400",
            children: c_[b]
          }
        ),
        r && /* @__PURE__ */ h("foreignObject", { x: -22, y: -8, width: 18, height: 18, children: /* @__PURE__ */ h("div", { className: "flex h-full items-center justify-center text-stone-600 dark:text-stone-400", children: Dse[b] }) })
      ] });
    };
    return /* @__PURE__ */ C("div", { ref: s, className: F("w-full", e), ...i, children: [
      /* @__PURE__ */ h(qt, { width: "100%", height: l.height, children: /* @__PURE__ */ C(
        Pf,
        {
          data: f,
          layout: "vertical",
          margin: { top: 5, right: 30, left: r ? 95 : 85, bottom: 5 },
          children: [
            /* @__PURE__ */ h(wt, { type: "number", hide: !0 }),
            /* @__PURE__ */ h(
              pt,
              {
                type: "category",
                dataKey: "platform",
                tick: p,
                axisLine: !1,
                tickLine: !1,
                width: r ? 95 : 80
              }
            ),
            /* @__PURE__ */ h(Be, { content: /* @__PURE__ */ h(d, {}), cursor: { fill: "rgba(0,0,0,0.05)" } }),
            /* @__PURE__ */ h(
              dt,
              {
                dataKey: "count",
                radius: [0, 4, 4, 0],
                barSize: l.barSize,
                animationBegin: 0,
                animationDuration: 800,
                children: f.map((g, m) => /* @__PURE__ */ h(gr, { fill: g.color }, `cell-${m}`))
              }
            )
          ]
        }
      ) }),
      n && /* @__PURE__ */ h("div", { className: "mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5", children: f.map((g) => /* @__PURE__ */ C(
        "div",
        {
          className: "flex items-center gap-2 rounded-md bg-stone-50 px-2 py-1.5 dark:bg-stone-800",
          children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "h-2.5 w-2.5 rounded",
                style: { backgroundColor: g.color }
              }
            ),
            /* @__PURE__ */ C("span", { className: "text-xs text-stone-600 dark:text-stone-400", children: [
              g.percentage,
              "%"
            ] })
          ]
        },
        g.platform
      )) })
    ] });
  }
);
Lse.displayName = "PlatformDistribution";
const Bse = {
  joy: "Joy",
  sadness: "Sadness",
  anger: "Anger",
  fear: "Fear",
  surprise: "Surprise",
  others: "Others"
}, Fse = {
  sm: { height: 200, outerRadius: 60 },
  md: { height: 300, outerRadius: 90 },
  lg: { height: 400, outerRadius: 120 }
}, zse = v.forwardRef(
  ({
    className: e,
    data: t,
    comparisonData: r,
    showLegend: n = !0,
    size: a = "md",
    primaryLabel: o = "Current",
    comparisonLabel: i = "Previous",
    fillOpacity: s = 0.3,
    ...c
  }, l) => {
    const u = cn(), f = Fse[a], d = Object.values(t).reduce((y, b) => y + b, 0), p = r ? Object.values(r).reduce((y, b) => y + b, 0) : 0, g = Object.keys(t).filter((y) => y !== "others").map((y) => ({
      emotion: y,
      label: Bse[y],
      value: d > 0 ? t[y] / d * 100 : 0,
      count: t[y],
      color: u.emotion[y],
      ...r && {
        comparison: p > 0 ? r[y] / p * 100 : 0,
        comparisonCount: r[y]
      }
    })), m = ({
      active: y,
      payload: b
    }) => {
      var S, P;
      if (!y || !(b != null && b.length)) return null;
      const w = b[0].payload;
      return /* @__PURE__ */ C("div", { className: "rounded-lg border border-stone-200 bg-white px-3 py-2 shadow-lg dark:border-stone-700 dark:bg-stone-900", children: [
        /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ h(
            "div",
            {
              className: "h-3 w-3 rounded-full",
              style: { backgroundColor: w.color }
            }
          ),
          /* @__PURE__ */ h("span", { className: "font-medium text-stone-900 dark:text-stone-100", children: w.label })
        ] }),
        /* @__PURE__ */ C("div", { className: "mt-1 space-y-0.5 text-sm", children: [
          /* @__PURE__ */ C("div", { className: "text-stone-600 dark:text-stone-400", children: [
            o,
            ": ",
            w.count.toLocaleString(),
            " (",
            w.value.toFixed(1),
            "%)"
          ] }),
          r && /* @__PURE__ */ C("div", { className: "text-stone-500 dark:text-stone-400", children: [
            i,
            ": ",
            (S = w.comparisonCount) == null ? void 0 : S.toLocaleString(),
            " (",
            (P = w.comparison) == null ? void 0 : P.toFixed(1),
            "%)"
          ] })
        ] })
      ] });
    };
    return /* @__PURE__ */ C("div", { ref: l, className: F("w-full", e), ...c, children: [
      /* @__PURE__ */ h(qt, { width: "100%", height: f.height, children: /* @__PURE__ */ C(Ose, { data: g, cx: "50%", cy: "50%", outerRadius: f.outerRadius, children: [
        /* @__PURE__ */ h(VM, { stroke: u.grid }),
        /* @__PURE__ */ h(
          Uo,
          {
            dataKey: "label",
            tick: { fill: u.axis, fontSize: 12 }
          }
        ),
        /* @__PURE__ */ h(
          Vo,
          {
            angle: 90,
            domain: [0, 100],
            tick: { fill: u.axisSecondary, fontSize: 10 },
            tickFormatter: (y) => `${y}%`
          }
        ),
        /* @__PURE__ */ h(Be, { content: /* @__PURE__ */ h(m, {}) }),
        r && /* @__PURE__ */ h(
          uo,
          {
            name: i,
            dataKey: "comparison",
            stroke: u.axisSecondary,
            fill: u.axisSecondary,
            fillOpacity: s * 0.5,
            strokeWidth: 1,
            strokeDasharray: "4 4"
          }
        ),
        /* @__PURE__ */ h(
          uo,
          {
            name: o,
            dataKey: "value",
            stroke: u.secondary,
            fill: u.secondary,
            fillOpacity: s,
            strokeWidth: 2,
            animationBegin: 0,
            animationDuration: 800
          }
        ),
        n && /* @__PURE__ */ h(Zt, {})
      ] }) }),
      /* @__PURE__ */ h("div", { className: "mt-4 flex flex-wrap justify-center gap-3", children: g.map((y) => /* @__PURE__ */ C(
        "div",
        {
          className: "flex items-center gap-2 rounded-full bg-stone-50 px-3 py-1 dark:bg-stone-800",
          children: [
            /* @__PURE__ */ h(
              "div",
              {
                className: "h-2.5 w-2.5 rounded-full",
                style: { backgroundColor: y.color }
              }
            ),
            /* @__PURE__ */ h("span", { className: "text-sm font-medium text-stone-700 dark:text-stone-300", children: y.label }),
            /* @__PURE__ */ C("span", { className: "text-sm text-stone-500 dark:text-stone-400", children: [
              y.value.toFixed(0),
              "%"
            ] })
          ]
        },
        y.emotion
      )) })
    ] });
  }
);
zse.displayName = "EmotionRadar";
const qse = {
  sm: { minFont: 10, maxFont: 24, gap: 6, padding: 4 },
  md: { minFont: 12, maxFont: 36, gap: 8, padding: 8 },
  lg: { minFont: 14, maxFont: 48, gap: 12, padding: 12 }
}, Wse = v.forwardRef(
  ({
    className: e,
    words: t,
    maxWords: r = 50,
    colorBySentiment: n = !0,
    defaultColor: a = "#57AEB3",
    onWordClick: o,
    highlightedWords: i = [],
    size: s = "md",
    ...c
  }, l) => {
    const u = cn(), f = qse[s], d = {
      1: u.sentiment.positive,
      0: u.sentiment.neutral,
      "-1": u.sentiment.negative
    }, p = [...t].sort((x, O) => O.count - x.count).slice(0, r);
    if (p.length === 0)
      return /* @__PURE__ */ h(
        "div",
        {
          ref: l,
          className: F(
            "flex h-48 items-center justify-center rounded-lg border border-dashed border-stone-300 dark:border-stone-700",
            e
          ),
          ...c,
          children: /* @__PURE__ */ h("p", { className: "text-sm text-stone-500", children: "No words to display" })
        }
      );
    const g = p[0].count, m = p[p.length - 1].count, y = g - m || 1, b = (x) => {
      const O = (x - m) / y;
      return f.minFont + O * (f.maxFont - f.minFont);
    }, w = (x) => n && x.sentiment !== void 0 ? d[x.sentiment] : a, S = (x) => 0.6 + (x - m) / y * 0.4, P = (x) => i.includes(x.toLowerCase());
    return /* @__PURE__ */ h(
      "div",
      {
        ref: l,
        className: F(
          "flex flex-wrap items-center justify-center rounded-lg bg-stone-50 dark:bg-stone-900",
          e
        ),
        style: { gap: f.gap, padding: f.padding * 2 },
        ...c,
        children: p.map((x, O) => {
          const A = b(x.count), _ = w(x), N = S(x.count), M = P(x.word);
          return /* @__PURE__ */ h(
            "button",
            {
              onClick: () => o == null ? void 0 : o(x),
              className: F(
                "cursor-pointer rounded-md px-2 py-0.5 font-medium transition-all duration-200",
                "hover:scale-110 hover:shadow-md",
                "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
                M && "ring-2 ring-primary-500 ring-offset-2",
                !o && "cursor-default"
              ),
              style: {
                fontSize: `${A}px`,
                color: _,
                opacity: M ? 1 : N,
                backgroundColor: M ? `${_}20` : "transparent"
              },
              title: `${x.word}: ${x.count} mentions`,
              children: x.word
            },
            `${x.word}-${O}`
          );
        })
      }
    );
  }
);
Wse.displayName = "WordCloud";
function a$(e, t) {
  return t.find((r) => e <= r.upTo) ?? t[t.length - 1];
}
const Hse = {
  ok: "bg-primary-200 dark:bg-primary-900",
  warn: "bg-amber-200 dark:bg-amber-900",
  bad: "bg-accent-300 dark:bg-accent-900"
}, l_ = {
  ok: "bg-primary-400",
  warn: "bg-amber-400",
  bad: "bg-accent-500"
};
function jce({
  value: e,
  bands: t,
  label: r,
  formatValue: n = (o) => String(o),
  className: a
}) {
  if (!t.length) return null;
  const o = 0, i = t[t.length - 1].upTo, s = i - o || 1, l = (Math.min(Math.max(e, o), i) - o) / s * 100, u = a$(e, t);
  return /* @__PURE__ */ h(oC, { delayDuration: 150, children: /* @__PURE__ */ C("div", { className: F("mt-2", a), children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: "relative flex h-2 w-full overflow-hidden rounded-full",
        role: "img",
        "aria-label": `${r}: ${n(e)}, zona ${(u == null ? void 0 : u.label) ?? ""}`,
        children: t.map((f, d) => {
          const p = d === 0 ? o : t[d - 1].upTo, g = f === u;
          return /* @__PURE__ */ C(Hc, { children: [
            /* @__PURE__ */ h(Vc, { asChild: !0, children: /* @__PURE__ */ h(
              "button",
              {
                type: "button",
                "aria-label": `Zona ${f.label}, de ${n(p)} a ${n(f.upTo)}`,
                className: F(
                  Hse[f.tone],
                  "h-full cursor-help transition-opacity",
                  !g && "opacity-50 hover:opacity-100"
                ),
                style: { width: `${(f.upTo - p) / s * 100}%` }
              }
            ) }),
            /* @__PURE__ */ C(Mi, { className: "max-w-[240px]", children: [
              /* @__PURE__ */ C("p", { className: "flex items-center gap-1.5 font-medium", children: [
                /* @__PURE__ */ h("span", { className: F("h-2 w-2 rounded-full", l_[f.tone]) }),
                f.label
              ] }),
              /* @__PURE__ */ C("p", { className: "text-xs text-stone-500 dark:text-stone-400", children: [
                "de ",
                n(p),
                " a ",
                n(f.upTo)
              ] }),
              f.description && /* @__PURE__ */ h("p", { className: "mt-1 text-xs leading-snug", children: f.description })
            ] })
          ] }, f.label);
        })
      }
    ),
    /* @__PURE__ */ h("div", { className: "relative h-0", children: /* @__PURE__ */ C(Hc, { children: [
      /* @__PURE__ */ h(Vc, { asChild: !0, children: /* @__PURE__ */ h(
        "button",
        {
          type: "button",
          "aria-label": `Valor actual: ${n(e)}`,
          className: "absolute -top-3 h-4 w-1 -translate-x-1/2 cursor-help rounded bg-stone-800 dark:bg-stone-100",
          style: { left: `${l}%` }
        }
      ) }),
      /* @__PURE__ */ C(Mi, { children: [
        /* @__PURE__ */ h("p", { className: "font-medium", children: n(e) }),
        u && /* @__PURE__ */ h("p", { className: "text-xs text-stone-500 dark:text-stone-400", children: u.label })
      ] })
    ] }) }),
    u && /* @__PURE__ */ C("p", { className: "mt-2 flex items-center gap-1.5 text-xs font-medium text-stone-600 dark:text-stone-300", children: [
      /* @__PURE__ */ h("span", { className: F("h-2 w-2 shrink-0 rounded-full", l_[u.tone]) }),
      u.label
    ] })
  ] }) });
}
const u_ = { positive: "Positivo", neutral: "Neutral", negative: "Negativo" };
function Lce({
  sources: e,
  rows: t,
  total: r,
  sourceLabel: n = (s) => s,
  formatValue: a = (s) => s.toLocaleString("es-EC"),
  onSelectCell: o,
  className: i
}) {
  if (!e.length) return null;
  const s = Math.max(...t.flatMap((c) => e.map((l) => c.values[l] ?? 0)), 0);
  return /* @__PURE__ */ h("div", { className: F("overflow-x-auto", i), children: /* @__PURE__ */ C("table", { className: "w-full min-w-[320px] border-collapse text-sm", children: [
    /* @__PURE__ */ h("thead", { children: /* @__PURE__ */ C("tr", { className: "text-stone-500 dark:text-stone-400", children: [
      /* @__PURE__ */ h("th", { className: "p-2 text-left font-medium", children: "Sentimiento" }),
      e.map((c) => /* @__PURE__ */ h("th", { className: "p-2 text-right font-medium", children: n(c) }, c)),
      /* @__PURE__ */ h("th", { className: "p-2 text-right font-medium", children: "Total" })
    ] }) }),
    /* @__PURE__ */ h("tbody", { children: t.map((c) => /* @__PURE__ */ C("tr", { children: [
      /* @__PURE__ */ h("td", { className: "p-2 text-stone-700 dark:text-stone-200", children: u_[c.sentiment] }),
      e.map((l) => {
        const u = c.values[l] ?? 0, f = s > 0 ? u / s : 0;
        return /* @__PURE__ */ h(
          "td",
          {
            onClick: o ? () => o(l, c.sentiment) : void 0,
            className: F(
              "p-2 text-right tabular-nums text-stone-800 dark:text-stone-100",
              o && "cursor-pointer"
            ),
            style: {
              backgroundColor: `color-mix(in srgb, var(--heatmap-tint, #118DFF) ${Math.round(
                f * 70
              )}%, transparent)`
            },
            title: `${u_[c.sentiment]} · ${n(l)}: ${a(u)}`,
            children: a(u)
          },
          l
        );
      }),
      /* @__PURE__ */ h("td", { className: "p-2 text-right font-semibold tabular-nums text-stone-900 dark:text-stone-50", children: a(c.total) })
    ] }, c.sentiment)) }),
    /* @__PURE__ */ h("tfoot", { children: /* @__PURE__ */ C("tr", { className: "border-t border-stone-200 font-semibold dark:border-stone-700", children: [
      /* @__PURE__ */ h("td", { className: "p-2", children: "Total" }),
      e.map((c) => /* @__PURE__ */ h("td", { className: "p-2 text-right tabular-nums", children: a(t.reduce((l, u) => l + (u.values[c] ?? 0), 0)) }, c)),
      /* @__PURE__ */ h("td", { className: "p-2 text-right tabular-nums", children: a(r) })
    ] }) })
  ] }) });
}
const kt = {
  sentiment: {
    positive: "#118DFF",
    // celeste
    neutral: "#12239E",
    // azul oscuro
    negative: "#E66C37"
    // naranja
  },
  /** Burbujas del scatter y barras del árbol de descomposición. */
  accent: "#118DFF",
  likes: "#118DFF",
  shares: "#12239E",
  replies: "#E66C37",
  /** Riel gris de las barras del árbol. */
  track: "#E6E6E6"
};
function Bce({
  data: e,
  mode: t = "absolute",
  orientation: r = "vertical",
  measureLabel: n,
  sourceLabel: a = (s) => s,
  height: o = 260,
  onSelectSource: i
}) {
  if (!e.length) return null;
  const s = e.map((u) => ({ ...u, source: a(u.source), key: u.source })), c = r === "horizontal", l = t === "share" ? "Porcentaje (%)" : n;
  return /* @__PURE__ */ h(qt, { width: "100%", height: o, children: /* @__PURE__ */ C(
    Pf,
    {
      data: s,
      onClick: (u) => {
        var d, p, g;
        const f = (g = (p = (d = u == null ? void 0 : u.activePayload) == null ? void 0 : d[0]) == null ? void 0 : p.payload) == null ? void 0 : g.key;
        typeof f == "string" && i && i(f);
      },
      style: i ? { cursor: "pointer" } : void 0,
      layout: c ? "vertical" : "horizontal",
      stackOffset: t === "share" ? "expand" : void 0,
      margin: { top: 8, right: 8, bottom: c ? 22 : 8, left: c ? 8 : 22 },
      children: [
        /* @__PURE__ */ h(Bn, { strokeDasharray: "3 3", opacity: 0.25 }),
        c ? /* @__PURE__ */ C(Ve, { children: [
          /* @__PURE__ */ h(
            wt,
            {
              type: "number",
              tickFormatter: t === "share" ? (u) => `${Math.round(u * 100)}%` : void 0,
              fontSize: 12,
              label: { value: l, position: "insideBottom", offset: -8, fontSize: 12 }
            }
          ),
          /* @__PURE__ */ h(pt, { type: "category", dataKey: "source", width: 90, fontSize: 12 })
        ] }) : /* @__PURE__ */ C(Ve, { children: [
          /* @__PURE__ */ h(wt, { dataKey: "source", fontSize: 12 }),
          /* @__PURE__ */ h(
            pt,
            {
              tickFormatter: t === "share" ? (u) => `${Math.round(u * 100)}%` : void 0,
              fontSize: 12,
              label: { value: l, angle: -90, position: "insideLeft", fontSize: 12 }
            }
          )
        ] }),
        /* @__PURE__ */ h(
          Be,
          {
            formatter: (u, f) => [u.toLocaleString("es-EC"), f],
            labelFormatter: (u) => `${u} · ${n}`
          }
        ),
        /* @__PURE__ */ h(Zt, {}),
        /* @__PURE__ */ h(dt, { dataKey: "negative", name: "Negativo", stackId: "s", fill: kt.sentiment.negative }),
        /* @__PURE__ */ h(dt, { dataKey: "neutral", name: "Neutral", stackId: "s", fill: kt.sentiment.neutral }),
        /* @__PURE__ */ h(dt, { dataKey: "positive", name: "Positivo", stackId: "s", fill: kt.sentiment.positive })
      ]
    }
  ) });
}
function Fce({ data: e, height: t = 260 }) {
  if (!e.length) return null;
  const r = e.map((n) => ({ ...n, x: n.likes, y: n.shares }));
  return /* @__PURE__ */ h(qt, { width: "100%", height: t, children: /* @__PURE__ */ C(Pse, { margin: { top: 8, right: 16, bottom: 22, left: 22 }, children: [
    /* @__PURE__ */ h(Bn, { strokeDasharray: "3 3", opacity: 0.25 }),
    /* @__PURE__ */ h(
      wt,
      {
        type: "number",
        dataKey: "x",
        name: "Me gusta",
        domain: [0, "dataMax"],
        fontSize: 12,
        tickFormatter: (n) => n.toLocaleString("es-EC"),
        label: { value: "Me gusta", position: "insideBottom", offset: -8, fontSize: 12 }
      }
    ),
    /* @__PURE__ */ h(
      pt,
      {
        type: "number",
        dataKey: "y",
        name: "Compartidos",
        domain: [0, "dataMax"],
        fontSize: 12,
        tickFormatter: (n) => n.toLocaleString("es-EC"),
        label: { value: "Compartidos", angle: -90, position: "insideLeft", fontSize: 12 }
      }
    ),
    /* @__PURE__ */ h(Go, { type: "number", dataKey: "y", range: [40, 400] }),
    /* @__PURE__ */ h(
      Be,
      {
        cursor: { strokeDasharray: "3 3" },
        formatter: (n, a) => [n.toLocaleString("es-EC"), a]
      }
    ),
    /* @__PURE__ */ h(Yo, { name: "Publicaciones", data: r, fill: kt.accent, fillOpacity: 0.8 })
  ] }) });
}
const f_ = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre"
];
function d_(e) {
  const [t, r, n] = e.split("-");
  return n ? `${Number(n)} ${(f_[Number(r) - 1] ?? r).slice(0, 3)}` : `${f_[Number(r) - 1] ?? r} ${t.slice(2)}`;
}
const Mc = [
  { key: "negative", name: "Negativo", color: kt.sentiment.negative },
  { key: "neutral", name: "Neutral", color: kt.sentiment.neutral },
  { key: "positive", name: "Positivo", color: kt.sentiment.positive }
];
function Vse() {
  return /* @__PURE__ */ C("div", { className: "mb-1 flex items-center gap-3 text-xs", children: [
    /* @__PURE__ */ h("span", { className: "font-semibold text-stone-700 dark:text-stone-200", children: "Sentimiento" }),
    Mc.map((e) => /* @__PURE__ */ C("span", { className: "flex items-center gap-1 text-stone-600 dark:text-stone-300", children: [
      /* @__PURE__ */ h("span", { className: "h-2 w-2 rounded-full", style: { backgroundColor: e.color } }),
      e.name
    ] }, e.key))
  ] });
}
const Use = (e) => Intl.NumberFormat("es-EC", { notation: "compact", maximumFractionDigits: 1 }).format(e);
function zce({
  data: e,
  measureLabel: t,
  height: r = 280,
  variant: n = "area"
}) {
  if (!e.length) return null;
  const a = n === "bars";
  return /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ h(Vse, {}),
    /* @__PURE__ */ h(qt, { width: "100%", height: r, children: /* @__PURE__ */ C(r$, { data: e, margin: { top: 8, right: 8, bottom: 4, left: 22 }, children: [
      /* @__PURE__ */ h(Bn, { strokeDasharray: "3 3", opacity: 0.25 }),
      /* @__PURE__ */ h(
        wt,
        {
          dataKey: "month",
          tickFormatter: d_,
          fontSize: 11,
          angle: -90,
          textAnchor: "end",
          height: a ? 90 : 56,
          interval: 0,
          tickMargin: 4,
          label: { value: "Fecha", position: "insideBottom", offset: -4, fontSize: 11 }
        }
      ),
      /* @__PURE__ */ h(
        pt,
        {
          fontSize: 12,
          tickFormatter: Use,
          label: { value: t, angle: -90, position: "insideLeft", fontSize: 12 }
        }
      ),
      /* @__PURE__ */ h(
        Be,
        {
          labelFormatter: (o) => `${d_(o)} · ${t}`,
          formatter: (o, i) => [o.toLocaleString("es-EC"), i]
        }
      ),
      /* @__PURE__ */ h(Zt, { content: () => null }),
      a ? /* @__PURE__ */ C(Ve, { children: [
        Mc.map((o) => /* @__PURE__ */ h(
          Qe,
          {
            type: "monotone",
            dataKey: o.key,
            stackId: "ribbon",
            stroke: "none",
            fill: o.color,
            fillOpacity: 0.35,
            legendType: "none",
            tooltipType: "none"
          },
          `ribbon-${o.key}`
        )),
        Mc.map((o) => /* @__PURE__ */ h(dt, { dataKey: o.key, name: o.name, stackId: "s", fill: o.color, barSize: 18 }, o.key))
      ] }) : Mc.map((o) => /* @__PURE__ */ h(
        Qe,
        {
          type: "linear",
          dataKey: o.key,
          name: o.name,
          stackId: "s",
          stroke: o.color,
          strokeWidth: 2,
          fill: o.color,
          fillOpacity: 0.4
        },
        o.key
      ))
    ] }) })
  ] });
}
function qce({
  data: e,
  sourceLabel: t = (n) => n,
  height: r = 260
}) {
  if (!e.length) return null;
  const n = e.map((a) => ({ ...a, source: t(a.source) }));
  return /* @__PURE__ */ h(qt, { width: "100%", height: r, children: /* @__PURE__ */ C(r$, { data: n, margin: { top: 8, right: 22, bottom: 8, left: 22 }, children: [
    /* @__PURE__ */ h(Bn, { strokeDasharray: "3 3", opacity: 0.25 }),
    /* @__PURE__ */ h(wt, { dataKey: "source", fontSize: 12 }),
    /* @__PURE__ */ h(
      pt,
      {
        yAxisId: "left",
        fontSize: 12,
        label: { value: "Interacciones", angle: -90, position: "insideLeft", fontSize: 12 }
      }
    ),
    /* @__PURE__ */ h(
      pt,
      {
        yAxisId: "right",
        orientation: "right",
        fontSize: 12,
        label: { value: "Respuestas", angle: 90, position: "insideRight", fontSize: 12 }
      }
    ),
    /* @__PURE__ */ h(Be, { formatter: (a, o) => [a.toLocaleString("es-EC"), o] }),
    /* @__PURE__ */ h(Zt, {}),
    /* @__PURE__ */ h(
      dt,
      {
        yAxisId: "left",
        dataKey: "likes",
        name: "Me gusta",
        stackId: "i",
        fill: kt.likes
      }
    ),
    /* @__PURE__ */ h(
      dt,
      {
        yAxisId: "left",
        dataKey: "shares",
        name: "Compartidos",
        stackId: "i",
        fill: kt.shares
      }
    ),
    /* @__PURE__ */ h(
      Ys,
      {
        yAxisId: "right",
        type: "monotone",
        dataKey: "replies",
        name: "Respuestas",
        stroke: kt.replies,
        strokeWidth: 2,
        dot: !0
      }
    )
  ] }) });
}
function Kse({ x: e, y: t, width: r, height: n, payload: a, containerWidth: o }) {
  const i = e + r + 160 > o;
  return /* @__PURE__ */ C(de, { children: [
    /* @__PURE__ */ h(Gs, { x: e, y: t, width: r, height: n, fill: "#2BC4CE", fillOpacity: 0.9 }),
    /* @__PURE__ */ h(
      "text",
      {
        x: i ? e - 8 : e + r + 8,
        y: t + n / 2,
        textAnchor: i ? "end" : "start",
        dominantBaseline: "middle",
        fontSize: 12,
        className: "fill-stone-700 dark:fill-stone-200",
        children: a.name
      }
    ),
    /* @__PURE__ */ h(
      "text",
      {
        x: i ? e - 8 : e + r + 8,
        y: t + n / 2 + 14,
        textAnchor: i ? "end" : "start",
        dominantBaseline: "middle",
        fontSize: 10,
        className: "fill-stone-400",
        children: a.value.toLocaleString("es-EC")
      }
    )
  ] });
}
function Wce({
  nodes: e,
  links: t,
  measureLabel: r,
  nodeLabel: n = (o) => o,
  height: a = 420
}) {
  if (!e.length || !t.length) return null;
  const o = t.filter((l) => l.value > 0), i = e.filter((l) => o.some((u) => u.source === l || u.target === l)), s = new Map(i.map((l, u) => [l, u])), c = {
    nodes: i.map((l) => ({ name: n(l) })),
    // Recharts espera índices, no nombres. Un enlace con extremo desconocido se
    // descarta antes que romper el gráfico entero.
    links: o.map((l) => ({
      source: s.get(l.source),
      target: s.get(l.target),
      value: l.value
    })).filter(
      (l) => l.source !== void 0 && l.target !== void 0
    )
  };
  return c.links.length ? /* @__PURE__ */ h(qt, { width: "100%", height: a, children: /* @__PURE__ */ h(
    W0,
    {
      data: c,
      nodePadding: 28,
      margin: { top: 12, right: 110, bottom: 12, left: 12 },
      node: /* @__PURE__ */ h(Kse, {}),
      link: { stroke: "var(--sankey-link, #2BC4CE)", strokeOpacity: 0.3 },
      children: /* @__PURE__ */ h(Be, { formatter: (l) => [l.toLocaleString("es-EC"), r] })
    }
  ) }) : null;
}
const Gse = (e) => e > 0 ? "positive" : e < 0 ? "negative" : "neutral";
function Yse(e, t = 42) {
  const r = e.replace(/\s+/g, " ").trim();
  return r.length <= t ? r : `${r.slice(0, r.lastIndexOf(" ", t) || t)}…`;
}
function Hce({
  data: e,
  measureLabel: t,
  sourceLabel: r = (o) => o,
  onSelect: n,
  height: a = 300
}) {
  if (!e.length) return null;
  const o = e.map((i, s) => ({
    ...i,
    label: i.excerpt ? Yse(i.excerpt) : `${r(i.source)} #${s + 1}`
  }));
  return /* @__PURE__ */ h(qt, { width: "100%", height: a, children: /* @__PURE__ */ C(
    Pf,
    {
      data: o,
      layout: "vertical",
      margin: { top: 8, right: 16, bottom: 22, left: 8 },
      style: n ? { cursor: "pointer" } : void 0,
      children: [
        /* @__PURE__ */ h(Bn, { strokeDasharray: "3 3", opacity: 0.25, horizontal: !1 }),
        /* @__PURE__ */ h(
          wt,
          {
            type: "number",
            fontSize: 12,
            label: { value: t, position: "insideBottom", offset: -8, fontSize: 12 }
          }
        ),
        /* @__PURE__ */ h(pt, { type: "category", dataKey: "label", width: 190, fontSize: 11, interval: 0 }),
        /* @__PURE__ */ h(
          Be,
          {
            formatter: (i) => [i.toLocaleString("es-EC"), t],
            labelFormatter: (i) => i
          }
        ),
        /* @__PURE__ */ h(dt, { dataKey: "value", name: t, onClick: n, children: o.map((i) => /* @__PURE__ */ h(gr, { fill: kt.sentiment[Gse(i.feeling)] }, i.id)) })
      ]
    }
  ) });
}
function Vce({
  data: e,
  countLabel: t = "Menciones",
  sourceLabel: r = (i) => i,
  onSelectSource: n,
  selected: a,
  height: o = 256
}) {
  const i = cn();
  if (!e.length) return null;
  const s = i.platform, c = i.sentiment.neutral, l = [...e].sort((f, d) => d.count - f.count).map((f) => ({ ...f, label: r(f.source) })), u = (f) => !!(a != null && a.length) && !a.includes(f);
  return /* @__PURE__ */ h(qt, { width: "100%", height: o, children: /* @__PURE__ */ C(Pf, { data: l, layout: "vertical", margin: { top: 8, right: 16, bottom: 20, left: 8 }, children: [
    /* @__PURE__ */ h(Bn, { strokeDasharray: "3 3", opacity: 0.25, horizontal: !1 }),
    /* @__PURE__ */ h(
      wt,
      {
        type: "number",
        fontSize: 12,
        label: { value: t, position: "insideBottom", offset: -8, fontSize: 12 }
      }
    ),
    /* @__PURE__ */ h(pt, { type: "category", dataKey: "label", width: 100, fontSize: 12, interval: 0 }),
    /* @__PURE__ */ h(
      Be,
      {
        formatter: (f) => [f.toLocaleString("es-EC"), t],
        cursor: { fillOpacity: 0.1 }
      }
    ),
    /* @__PURE__ */ h(
      dt,
      {
        dataKey: "count",
        name: t,
        onClick: n ? (f) => n(f.source) : void 0,
        cursor: n ? "pointer" : void 0,
        children: l.map((f) => /* @__PURE__ */ h(
          gr,
          {
            fill: s[f.source] ?? c,
            fillOpacity: u(f.source) ? 0.3 : 1
          },
          f.source
        ))
      }
    )
  ] }) });
}
const p_ = {
  ok: "#2BC4CE",
  warn: "#F59E0B",
  bad: "#EF4444"
}, Xse = {
  ok: "bg-primary-400",
  warn: "bg-amber-400",
  bad: "bg-accent-500"
}, cu = 52, Rc = 60, $c = 60, Zse = 12;
function Xy(e) {
  const t = Math.PI * (1 - Math.min(Math.max(e, 0), 1));
  return { x: Rc + cu * Math.cos(t), y: $c - cu * Math.sin(t) };
}
function Jse(e, t) {
  const r = Xy(e), n = Xy(t);
  return `M ${r.x} ${r.y} A ${cu} ${cu} 0 0 1 ${n.x} ${n.y}`;
}
function Uce({
  value: e,
  bands: t,
  label: r,
  formatValue: n = (o) => String(o),
  className: a
}) {
  if (!t.length) return null;
  const i = t[t.length - 1].upTo || 1, s = a$(e, t), c = Math.min(Math.max(e / i, 0), 1), l = Xy(c);
  return /* @__PURE__ */ h(oC, { delayDuration: 150, children: /* @__PURE__ */ C("div", { className: F("flex items-center gap-4", a), children: [
    /* @__PURE__ */ C(
      "svg",
      {
        viewBox: "0 0 120 72",
        width: 120,
        height: 72,
        style: { flexShrink: 0 },
        role: "img",
        "aria-label": `${r}: ${n(e)}, zona ${(s == null ? void 0 : s.label) ?? ""}`,
        children: [
          t.map((u, f) => {
            const d = f === 0 ? 0 : t[f - 1].upTo;
            return /* @__PURE__ */ C(Hc, { children: [
              /* @__PURE__ */ h(Vc, { asChild: !0, children: /* @__PURE__ */ h(
                "path",
                {
                  d: Jse(d / i, u.upTo / i),
                  fill: "none",
                  stroke: p_[u.tone],
                  strokeWidth: Zse,
                  strokeOpacity: u === s ? 1 : 0.25,
                  strokeLinecap: "butt",
                  style: { cursor: "help" },
                  "aria-label": `Zona ${u.label}, de ${n(d)} a ${n(u.upTo)}`
                }
              ) }),
              /* @__PURE__ */ C(Mi, { className: "max-w-[240px]", children: [
                /* @__PURE__ */ C("p", { className: "flex items-center gap-1.5 font-medium", children: [
                  /* @__PURE__ */ h("span", { className: F("h-2 w-2 rounded-full", Xse[u.tone]) }),
                  u.label
                ] }),
                /* @__PURE__ */ C("p", { className: "text-xs text-stone-500 dark:text-stone-400", children: [
                  "de ",
                  n(d),
                  " a ",
                  n(u.upTo)
                ] }),
                u.description && /* @__PURE__ */ h("p", { className: "mt-1 text-xs leading-snug", children: u.description })
              ] })
            ] }, u.label);
          }),
          /* @__PURE__ */ C(Hc, { children: [
            /* @__PURE__ */ h(Vc, { asChild: !0, children: /* @__PURE__ */ C("g", { style: { cursor: "help" }, "aria-label": `Valor actual: ${n(e)}`, children: [
              /* @__PURE__ */ h(
                "line",
                {
                  x1: Rc,
                  y1: $c,
                  x2: l.x,
                  y2: l.y,
                  stroke: "transparent",
                  strokeWidth: 14
                }
              ),
              /* @__PURE__ */ h(
                "line",
                {
                  x1: Rc,
                  y1: $c,
                  x2: l.x,
                  y2: l.y,
                  className: "stroke-stone-800 dark:stroke-stone-100",
                  strokeWidth: 2.5,
                  strokeLinecap: "round"
                }
              ),
              /* @__PURE__ */ h("circle", { cx: Rc, cy: $c, r: 4, className: "fill-stone-800 dark:fill-stone-100" })
            ] }) }),
            /* @__PURE__ */ C(Mi, { children: [
              /* @__PURE__ */ h("p", { className: "font-medium", children: n(e) }),
              s && /* @__PURE__ */ h("p", { className: "text-xs text-stone-500 dark:text-stone-400", children: s.label })
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ C("div", { className: "min-w-0", children: [
      /* @__PURE__ */ h("p", { className: "whitespace-nowrap text-2xl font-bold tabular-nums text-stone-900 dark:text-stone-100", children: n(e) }),
      s && /* @__PURE__ */ h(
        "p",
        {
          className: "whitespace-nowrap text-xs font-medium",
          style: { color: p_[s.tone] },
          children: s.label
        }
      )
    ] })
  ] }) });
}
function Kce({
  value: e,
  label: t,
  formatValue: r = (i) => String(i),
  risingIs: n = "neutral",
  caption: a,
  className: o
}) {
  const i = e > 0, s = e === 0, c = s ? "text-stone-500 dark:text-stone-400" : n === "neutral" ? "text-stone-900 dark:text-stone-100" : (i ? n === "good" : n === "bad") ? "text-primary-600 dark:text-primary-400" : "text-accent-600 dark:text-accent-400", l = s ? "—" : i ? "▲" : "▼";
  return /* @__PURE__ */ C("div", { className: F("mt-1", o), children: [
    /* @__PURE__ */ C(
      "p",
      {
        className: F("flex items-baseline gap-1.5 text-2xl font-bold tabular-nums", c),
        role: "img",
        "aria-label": `${t}: ${r(e)}, ${s ? "sin cambio" : i ? "en alza" : "en baja"}`,
        children: [
          /* @__PURE__ */ h("span", { "aria-hidden": "true", className: "text-base", children: l }),
          r(e)
        ]
      }
    ),
    a && /* @__PURE__ */ h("p", { className: "text-xs text-stone-500 dark:text-stone-400", children: a })
  ] });
}
function Gce({ entries: e, limit: t = 4, className: r }) {
  if (!e.length) return null;
  const n = e.slice(0, t), a = e.length - n.length;
  return /* @__PURE__ */ C("div", { className: F("mt-2 space-y-1.5", r), children: [
    n.map((o) => /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ C("div", { className: "flex justify-between gap-2 text-xs text-stone-600 dark:text-stone-300", children: [
        /* @__PURE__ */ h("span", { className: "truncate", children: o.label }),
        /* @__PURE__ */ C("span", { className: "tabular-nums text-stone-500 dark:text-stone-400", children: [
          o.share,
          "%"
        ] })
      ] }),
      /* @__PURE__ */ h("div", { className: "h-1.5 overflow-hidden rounded-full bg-stone-100 dark:bg-stone-800", children: /* @__PURE__ */ h(
        "div",
        {
          className: "h-full rounded-full bg-primary-400",
          style: { width: `${Math.min(Math.max(o.share, 0), 100)}%` }
        }
      ) })
    ] }, o.label)),
    a > 0 && /* @__PURE__ */ C("p", { className: "text-xs text-stone-400 dark:text-stone-500", children: [
      "y ",
      a,
      " ",
      a === 1 ? "tema más" : "temas más"
    ] })
  ] });
}
function Yce({
  records: e,
  levels: t,
  rootLabel: r,
  nodeLabel: n = (i, s) => s,
  formatValue: a = (i) => i.toLocaleString("es-EC"),
  className: o
}) {
  const [i, s] = v.useState({}), [c, l] = v.useState(/* @__PURE__ */ new Set()), [u, f] = v.useState(!1), [d, p] = v.useState([]), g = v.useRef(null), m = t.filter((_) => !c.has(_.key)), y = e.reduce((_, N) => _ + Number(N.value ?? 0), 0), b = (_) => {
    let N = e;
    for (let k = 0; k < _; k++) {
      const $ = m[k], R = w(k);
      if (R == null) return [];
      N = N.filter((L) => String(L[$.key] ?? "") === R);
    }
    const M = m[_].key, T = /* @__PURE__ */ new Map();
    for (const k of N) {
      const $ = String(k[M] ?? "");
      T.set($, (T.get($) ?? 0) + Number(k.value ?? 0));
    }
    return Array.from(T, ([k, $]) => ({ value: k, total: $ })).sort(
      (k, $) => $.total - k.total
    );
  }, w = (_) => {
    const N = m[_], M = i[N.key], T = b(_);
    return T.length ? M != null && T.some((k) => k.value === M) ? M : T[0].value : null;
  }, S = (_, N) => {
    const M = m.findIndex((k) => k.key === _), T = {};
    m.slice(0, M).forEach((k) => {
      i[k.key] != null && (T[k.key] = i[k.key]);
    }), T[_] = N, s(T);
  }, P = (_) => {
    l(/* @__PURE__ */ new Set([...c, _]));
    const N = { ...i };
    delete N[_], s(N);
  }, x = (_) => {
    const N = new Set(c);
    N.delete(_), l(N), f(!1);
  }, O = v.useCallback(() => {
    const _ = g.current;
    if (!_) return;
    const N = _.getBoundingClientRect(), M = [], T = m.length;
    for (let k = 0; k <= T - 1; k++) {
      const $ = _.querySelector(
        k === 0 ? '[data-tree-node="root"]' : `[data-tree-col="${k - 1}"][data-tree-picked="true"]`
      );
      if (!$) continue;
      const R = $.getBoundingClientRect();
      _.querySelectorAll(`[data-tree-col="${k}"]`).forEach((j) => {
        const z = j.getBoundingClientRect();
        M.push({
          x1: R.right - N.left,
          y1: R.top + R.height / 2 - N.top,
          x2: z.left - N.left,
          y2: z.top + z.height / 2 - N.top
        });
      });
    }
    p(
      (k) => k.length === M.length && k.every(($, R) => Math.abs($.y1 - M[R].y1) < 1 && Math.abs($.y2 - M[R].y2) < 1 && $.x1 === M[R].x1 && $.x2 === M[R].x2) ? k : M
    );
  }, [m.length]);
  if (v.useLayoutEffect(() => {
    O();
  }), v.useEffect(() => (window.addEventListener("resize", O), () => window.removeEventListener("resize", O)), [O]), !e.length) return null;
  const A = t.filter((_) => c.has(_.key));
  return /* @__PURE__ */ h("div", { className: F("overflow-x-auto", o), children: /* @__PURE__ */ C(
    "div",
    {
      ref: g,
      className: "relative pb-2",
      style: {
        display: "flex",
        alignItems: "stretch",
        gap: 56,
        minWidth: m.length * 210 + 170
      },
      children: [
        /* @__PURE__ */ h("svg", { className: "pointer-events-none absolute inset-0 h-full w-full", children: d.map((_, N) => {
          const M = (_.x1 + _.x2) / 2;
          return /* @__PURE__ */ h(
            "path",
            {
              d: `M ${_.x1} ${_.y1} C ${M} ${_.y1}, ${M} ${_.y2}, ${_.x2} ${_.y2}`,
              fill: "none",
              stroke: "#B3B0AD",
              strokeWidth: 1.5
            },
            N
          );
        }) }),
        /* @__PURE__ */ C(
          "div",
          {
            className: "flex flex-col justify-center",
            style: { width: 150, flex: "0 0 150px" },
            children: [
              /* @__PURE__ */ h("div", { className: "pb-1 text-sm", children: " " }),
              /* @__PURE__ */ C("div", { "data-tree-node": "root", className: "mt-2", children: [
                /* @__PURE__ */ h("p", { className: "text-sm font-bold text-stone-900 dark:text-stone-100", children: r }),
                /* @__PURE__ */ h("p", { className: "text-xs tabular-nums text-stone-600 dark:text-stone-300", children: a(y) }),
                /* @__PURE__ */ h("div", { className: "mt-1 w-full rounded-sm", style: { height: 8, backgroundColor: kt.accent } })
              ] })
            ]
          }
        ),
        m.map((_, N) => {
          var $;
          const M = b(N), T = w(N), k = (($ = M[0]) == null ? void 0 : $.total) ?? 0;
          return /* @__PURE__ */ C("div", { style: { flex: "1 1 0", minWidth: 160 }, children: [
            /* @__PURE__ */ C("div", { className: "flex items-center justify-between border-b-2 border-[#118DFF] pb-1", children: [
              /* @__PURE__ */ h("span", { className: "text-sm font-semibold text-stone-800 dark:text-stone-100", children: _.title }),
              /* @__PURE__ */ h(
                "button",
                {
                  type: "button",
                  "aria-label": `Quitar ${_.title}`,
                  onClick: () => P(_.key),
                  className: "text-stone-400 hover:text-stone-700 dark:hover:text-stone-200",
                  children: "×"
                }
              )
            ] }),
            /* @__PURE__ */ h("p", { className: "mt-0.5 truncate text-xs text-stone-500 dark:text-stone-400", children: T != null ? n(_.key, T) || "(Blank)" : "" }),
            /* @__PURE__ */ h("div", { className: "mt-2 space-y-2.5", children: M.map((R) => {
              const L = R.value === T, j = k > 0 ? Math.max(R.total / k * 100, 2) : 0;
              return /* @__PURE__ */ C(
                "button",
                {
                  type: "button",
                  "data-tree-col": N,
                  "data-tree-picked": L || void 0,
                  onClick: () => S(_.key, R.value),
                  className: "block w-full text-left",
                  children: [
                    /* @__PURE__ */ h(
                      "p",
                      {
                        className: F(
                          "truncate text-xs",
                          L ? "font-bold text-stone-900 dark:text-stone-100" : "text-stone-600 dark:text-stone-300"
                        ),
                        children: n(_.key, R.value) || "(Blank)"
                      }
                    ),
                    /* @__PURE__ */ h("p", { className: "text-[11px] tabular-nums text-stone-500 dark:text-stone-400", children: a(R.total) }),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        className: "mt-0.5 w-full rounded-sm",
                        style: { height: 6, backgroundColor: kt.track },
                        children: /* @__PURE__ */ h(
                          "div",
                          {
                            className: "rounded-sm",
                            style: {
                              height: 6,
                              width: `${j}%`,
                              backgroundColor: kt.accent,
                              opacity: L ? 1 : 0.45
                            }
                          }
                        )
                      }
                    )
                  ]
                },
                R.value || "(vacío)"
              );
            }) })
          ] }, _.key);
        }),
        A.length > 0 && /* @__PURE__ */ C("div", { className: "relative flex flex-col", style: { flex: "0 0 40px" }, children: [
          /* @__PURE__ */ h("div", { className: "pb-1 text-sm", children: " " }),
          /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              "aria-label": "Agregar dimensión",
              onClick: () => f((_) => !_),
              className: "mt-2 h-7 w-7 rounded-full border border-stone-300 text-stone-500 hover:border-stone-500 hover:text-stone-800 dark:border-stone-600 dark:text-stone-300",
              children: "+"
            }
          ),
          u && /* @__PURE__ */ h("div", { className: "absolute top-12 right-0 z-10 w-40 rounded-md border border-stone-200 bg-white p-1 shadow-md dark:border-stone-700 dark:bg-stone-900", children: A.map((_) => /* @__PURE__ */ h(
            "button",
            {
              type: "button",
              onClick: () => x(_.key),
              className: "block w-full rounded px-2 py-1.5 text-left text-sm text-stone-700 hover:bg-stone-100 dark:text-stone-200 dark:hover:bg-stone-800",
              children: _.title
            },
            _.key
          )) })
        ] })
      ]
    }
  ) });
}
const Qse = v.forwardRef(
  ({
    className: e,
    children: t,
    navItems: r,
    savedQueries: n,
    activeNavItem: a,
    breadcrumbs: o,
    currentQuery: i,
    user: s,
    notifications: c,
    planInfo: l,
    theme: u = "light",
    sidebarCollapsed: f = !1,
    showSearch: d = !0,
    onNavItemClick: p,
    onThemeChange: g,
    onSidebarCollapsedChange: m,
    ...y
  }, b) => {
    const [w, S] = v.useState(!1);
    return /* @__PURE__ */ C(
      "div",
      {
        ref: b,
        className: F("flex h-screen overflow-hidden bg-stone-50 dark:bg-stone-900", e),
        ...y,
        children: [
          w && /* @__PURE__ */ h(
            "div",
            {
              className: "fixed inset-0 z-40 bg-black/50 lg:hidden",
              onClick: () => S(!1)
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: F(
                "fixed inset-y-0 left-0 z-50 lg:relative lg:z-0",
                "transform transition-transform duration-300 lg:transform-none",
                w ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
              ),
              children: /* @__PURE__ */ h(
                pN,
                {
                  navItems: r,
                  savedQueries: n,
                  activeItem: a,
                  collapsed: f,
                  onCollapsedChange: m,
                  theme: u,
                  onThemeChange: g,
                  onNavItemClick: p,
                  planInfo: l
                }
              )
            }
          ),
          /* @__PURE__ */ C("div", { className: "flex flex-1 flex-col overflow-hidden", children: [
            /* @__PURE__ */ h(
              hN,
              {
                breadcrumbs: o,
                currentQuery: i,
                user: s,
                notifications: c,
                showSearch: d,
                onMobileMenuClick: () => S(!0)
              }
            ),
            /* @__PURE__ */ h("main", { className: "flex-1 overflow-y-auto p-4 lg:p-6", children: t })
          ] })
        ]
      }
    );
  }
);
Qse.displayName = "DashboardLayout";
const ece = v.forwardRef(
  ({
    className: e,
    children: t,
    title: r,
    subtitle: n,
    logo: a,
    brandImage: o,
    tagline: i = "Social Listening for LATAM",
    brandDescription: s = "Monitor your brand across social media, analyze sentiment, and get AI-powered insights.",
    footer: c,
    ...l
  }, u) => /* @__PURE__ */ C(
    "div",
    {
      ref: u,
      className: F("flex min-h-screen", e),
      ...l,
      children: [
        /* @__PURE__ */ C("div", { className: "hidden w-1/2 bg-gradient-to-br from-primary-700 via-primary-800 to-primary-900 p-12 lg:flex lg:flex-col lg:justify-between", children: [
          /* @__PURE__ */ h("div", { children: a || /* @__PURE__ */ h("span", { className: "text-3xl font-bold text-white", children: "Uyari" }) }),
          /* @__PURE__ */ C("div", { className: "space-y-6", children: [
            o && /* @__PURE__ */ h(
              "img",
              {
                src: o,
                alt: "Uyari",
                className: "max-w-md rounded-lg shadow-2xl"
              }
            ),
            /* @__PURE__ */ h("h1", { className: "text-4xl font-bold text-white", children: i }),
            /* @__PURE__ */ h("p", { className: "max-w-md text-lg text-primary-100", children: s })
          ] }),
          /* @__PURE__ */ C("div", { className: "grid grid-cols-3 gap-4", children: [
            /* @__PURE__ */ h(
              nv,
              {
                title: "Real-time",
                description: "Monitor mentions as they happen"
              }
            ),
            /* @__PURE__ */ h(
              nv,
              {
                title: "AI-Powered",
                description: "Smart sentiment analysis"
              }
            ),
            /* @__PURE__ */ h(
              nv,
              {
                title: "LATAM Focus",
                description: "Built for Latin America"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ C("div", { className: "flex w-full flex-col justify-between bg-white dark:bg-stone-950 p-6 lg:w-1/2 lg:p-12", children: [
          /* @__PURE__ */ h("div", { className: "mb-8 lg:hidden", children: a || /* @__PURE__ */ h("span", { className: "text-2xl font-bold text-primary-700 dark:text-primary-400", children: "Uyari" }) }),
          /* @__PURE__ */ h("div", { className: "mx-auto w-full max-w-md flex-1", children: /* @__PURE__ */ C("div", { className: "space-y-6", children: [
            /* @__PURE__ */ C("div", { className: "space-y-2", children: [
              /* @__PURE__ */ h("h2", { className: "text-2xl font-bold text-stone-900 dark:text-stone-100", children: r }),
              n && /* @__PURE__ */ h("p", { className: "text-stone-600 dark:text-stone-400", children: n })
            ] }),
            /* @__PURE__ */ h("div", { children: t })
          ] }) }),
          c && /* @__PURE__ */ h("div", { className: "mt-8 text-center text-sm text-stone-500 dark:text-stone-400", children: c })
        ] })
      ]
    }
  )
);
ece.displayName = "AuthLayout";
function nv({ title: e, description: t }) {
  return /* @__PURE__ */ C("div", { className: "space-y-1", children: [
    /* @__PURE__ */ h("h3", { className: "font-semibold text-white", children: e }),
    /* @__PURE__ */ h("p", { className: "text-sm text-primary-200", children: t })
  ] });
}
const tce = [
  { label: "Features", href: "#features" },
  { label: "Pricing", href: "#pricing" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" }
], rce = v.forwardRef(
  ({
    className: e,
    logo: t,
    navLinks: r = tce,
    showHeaderCTA: n = !0,
    headerCTAText: a = "Get Started",
    onHeaderCTAClick: o,
    heroContent: i,
    featuresContent: s,
    pricingContent: c,
    ctaContent: l,
    footerContent: u,
    children: f,
    onNavClick: d,
    ...p
  }, g) => {
    const [m, y] = v.useState(!1), [b, w] = v.useState(!1);
    return v.useEffect(() => {
      const S = () => {
        w(window.scrollY > 10);
      };
      return window.addEventListener("scroll", S), () => window.removeEventListener("scroll", S);
    }, []), /* @__PURE__ */ C(
      "div",
      {
        ref: g,
        className: F("min-h-screen bg-white dark:bg-stone-950", e),
        ...p,
        children: [
          /* @__PURE__ */ C(
            "header",
            {
              className: F(
                "fixed left-0 right-0 top-0 z-50 transition-all duration-300",
                b ? "border-b border-stone-200 bg-white/95 backdrop-blur-sm dark:border-stone-800 dark:bg-stone-950/95" : "bg-transparent"
              ),
              children: [
                /* @__PURE__ */ C("div", { className: "mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8", children: [
                  /* @__PURE__ */ h("div", { className: "flex-shrink-0", children: t || /* @__PURE__ */ h("span", { className: "text-xl font-bold text-primary-700 dark:text-primary-400", children: "Uyari" }) }),
                  /* @__PURE__ */ h("nav", { className: "hidden items-center gap-8 md:flex", children: r.map((S) => /* @__PURE__ */ h(
                    "a",
                    {
                      href: S.href,
                      onClick: (P) => {
                        d && (P.preventDefault(), d(S));
                      },
                      className: F(
                        "text-sm font-medium transition-colors hover:text-primary-600 dark:hover:text-primary-400",
                        S.isActive ? "text-primary-600 dark:text-primary-400" : "text-stone-600 dark:text-stone-400"
                      ),
                      children: S.label
                    },
                    S.href
                  )) }),
                  /* @__PURE__ */ C("div", { className: "hidden items-center gap-4 md:flex", children: [
                    /* @__PURE__ */ h(Te, { variant: "ghost", size: "sm", children: "Sign In" }),
                    n && /* @__PURE__ */ C(Te, { size: "sm", onClick: o, children: [
                      a,
                      /* @__PURE__ */ h(E$, { className: "ml-2 h-4 w-4" })
                    ] })
                  ] }),
                  /* @__PURE__ */ h(
                    "button",
                    {
                      onClick: () => y(!m),
                      className: "rounded-lg p-2 text-stone-600 hover:bg-stone-100 md:hidden dark:text-stone-400 dark:hover:bg-stone-800",
                      children: m ? /* @__PURE__ */ h(An, { className: "h-6 w-6" }) : /* @__PURE__ */ h(P_, { className: "h-6 w-6" })
                    }
                  )
                ] }),
                m && /* @__PURE__ */ h("div", { className: "border-t border-stone-200 bg-white md:hidden dark:border-stone-800 dark:bg-stone-950", children: /* @__PURE__ */ C("div", { className: "space-y-1 px-4 py-3", children: [
                  r.map((S) => /* @__PURE__ */ h(
                    "a",
                    {
                      href: S.href,
                      onClick: (P) => {
                        d && (P.preventDefault(), d(S)), y(!1);
                      },
                      className: "block rounded-lg px-3 py-2 text-sm font-medium text-stone-600 hover:bg-stone-100 dark:text-stone-400 dark:hover:bg-stone-800",
                      children: S.label
                    },
                    S.href
                  )),
                  /* @__PURE__ */ C("div", { className: "mt-4 space-y-2 border-t border-stone-200 pt-4 dark:border-stone-800", children: [
                    /* @__PURE__ */ h(Te, { variant: "outline", className: "w-full", children: "Sign In" }),
                    n && /* @__PURE__ */ h(Te, { className: "w-full", onClick: o, children: a })
                  ] })
                ] }) })
              ]
            }
          ),
          /* @__PURE__ */ h("main", { children: f || /* @__PURE__ */ C(Ve, { children: [
            i && /* @__PURE__ */ C("section", { className: "relative overflow-hidden pt-16", children: [
              /* @__PURE__ */ h("div", { className: "mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-32 lg:px-8", children: i }),
              /* @__PURE__ */ h("div", { className: "absolute inset-0 -z-10 overflow-hidden", children: /* @__PURE__ */ h("div", { className: "absolute -top-1/2 left-1/2 h-[800px] w-[800px] -translate-x-1/2 rounded-full bg-gradient-to-r from-primary-100 to-secondary-100 opacity-30 blur-3xl dark:from-primary-900/20 dark:to-secondary-900/20" }) })
            ] }),
            s && /* @__PURE__ */ h("section", { id: "features", className: "border-t border-stone-100 bg-stone-50 dark:border-stone-900 dark:bg-stone-900/50", children: /* @__PURE__ */ h("div", { className: "mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8", children: s }) }),
            c && /* @__PURE__ */ h("section", { id: "pricing", className: "border-t border-stone-100 dark:border-stone-900", children: /* @__PURE__ */ h("div", { className: "mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8", children: c }) }),
            l && /* @__PURE__ */ h("section", { className: "border-t border-stone-100 bg-gradient-to-r from-primary-600 to-primary-700 dark:border-stone-900", children: /* @__PURE__ */ h("div", { className: "mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8", children: l }) })
          ] }) }),
          /* @__PURE__ */ h("footer", { className: "border-t border-stone-200 bg-stone-50 dark:border-stone-800 dark:bg-stone-900", children: u || /* @__PURE__ */ h("div", { className: "mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8", children: /* @__PURE__ */ C("div", { className: "flex flex-col items-center justify-between gap-4 md:flex-row", children: [
            /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
              t || /* @__PURE__ */ h("span", { className: "text-lg font-bold text-primary-700 dark:text-primary-400", children: "Uyari" }),
              /* @__PURE__ */ C("span", { className: "text-sm text-stone-500", children: [
                "© ",
                (/* @__PURE__ */ new Date()).getFullYear(),
                " All rights reserved."
              ] })
            ] }),
            /* @__PURE__ */ C("div", { className: "flex gap-6", children: [
              /* @__PURE__ */ h("a", { href: "#", className: "text-sm text-stone-500 hover:text-stone-700 dark:hover:text-stone-300", children: "Privacy" }),
              /* @__PURE__ */ h("a", { href: "#", className: "text-sm text-stone-500 hover:text-stone-700 dark:hover:text-stone-300", children: "Terms" }),
              /* @__PURE__ */ h("a", { href: "#", className: "text-sm text-stone-500 hover:text-stone-700 dark:hover:text-stone-300", children: "Contact" })
            ] })
          ] }) }) })
        ]
      }
    );
  }
);
rce.displayName = "LandingPageLayout";
const nce = v.forwardRef(
  ({
    className: e,
    title: t,
    subtitle: r,
    logo: n,
    children: a,
    dateRange: o,
    isFullscreen: i = !1,
    isRefreshing: s = !1,
    lastUpdated: c,
    autoRefreshInterval: l = 0,
    showDatePicker: u = !0,
    showRefresh: f = !0,
    showDownload: d = !0,
    showShare: p = !0,
    showSettings: g = !0,
    onDateRangeChange: m,
    onRefresh: y,
    onDownload: b,
    onShare: w,
    onSettings: S,
    onClose: P,
    onFullscreenToggle: x,
    ...O
  }, A) => {
    const [_, N] = v.useState(l);
    return v.useEffect(() => {
      if (l <= 0) return;
      N(l);
      const M = setInterval(() => {
        N((T) => T <= 1 ? (y == null || y(), l) : T - 1);
      }, 1e3);
      return () => clearInterval(M);
    }, [l, y]), /* @__PURE__ */ C(
      "div",
      {
        ref: A,
        className: F(
          "flex h-screen flex-col bg-stone-50 dark:bg-stone-900",
          i && "fixed inset-0 z-50",
          e
        ),
        ...O,
        children: [
          /* @__PURE__ */ C("header", { className: "flex h-14 flex-shrink-0 items-center justify-between border-b border-stone-200 bg-white px-4 dark:border-stone-800 dark:bg-stone-950", children: [
            /* @__PURE__ */ C("div", { className: "flex items-center gap-4", children: [
              P && /* @__PURE__ */ h(
                "button",
                {
                  onClick: P,
                  className: "rounded-lg p-1.5 text-stone-500 hover:bg-stone-100 dark:hover:bg-stone-800",
                  children: /* @__PURE__ */ h(An, { className: "h-5 w-5" })
                }
              ),
              n || /* @__PURE__ */ h("span", { className: "text-lg font-bold text-primary-700 dark:text-primary-400", children: "Uyari" }),
              /* @__PURE__ */ C("div", { className: "hidden border-l border-stone-200 pl-4 sm:block dark:border-stone-700", children: [
                /* @__PURE__ */ h("h1", { className: "text-sm font-semibold text-stone-900 dark:text-stone-100", children: t }),
                r && /* @__PURE__ */ h("p", { className: "text-xs text-stone-500", children: r })
              ] })
            ] }),
            u && /* @__PURE__ */ h("div", { className: "hidden md:block", children: /* @__PURE__ */ h(
              Jc,
              {
                value: o,
                onChange: m,
                size: "sm"
              }
            ) }),
            /* @__PURE__ */ C("div", { className: "flex items-center gap-1", children: [
              (c || l > 0) && /* @__PURE__ */ C("div", { className: "mr-2 hidden text-right text-xs text-stone-500 lg:block", children: [
                c && /* @__PURE__ */ C("div", { children: [
                  "Updated ",
                  c.toLocaleTimeString()
                ] }),
                l > 0 && /* @__PURE__ */ C("div", { children: [
                  "Refresh in ",
                  _,
                  "s"
                ] })
              ] }),
              f && /* @__PURE__ */ h(
                Te,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: y,
                  disabled: s,
                  children: /* @__PURE__ */ h(Ha, { className: F("h-4 w-4", s && "animate-spin") })
                }
              ),
              d && /* @__PURE__ */ h(Te, { variant: "ghost", size: "sm", onClick: b, children: /* @__PURE__ */ h(I$, { className: "h-4 w-4" }) }),
              p && /* @__PURE__ */ h(Te, { variant: "ghost", size: "sm", onClick: w, children: /* @__PURE__ */ h(tI, { className: "h-4 w-4" }) }),
              g && /* @__PURE__ */ h(Te, { variant: "ghost", size: "sm", onClick: S, children: /* @__PURE__ */ h(E_, { className: "h-4 w-4" }) }),
              /* @__PURE__ */ h("div", { className: "mx-1 h-6 w-px bg-stone-200 dark:bg-stone-700" }),
              /* @__PURE__ */ h(Te, { variant: "ghost", size: "sm", onClick: x, children: i ? /* @__PURE__ */ h(G$, { className: "h-4 w-4" }) : /* @__PURE__ */ h(U$, { className: "h-4 w-4" }) })
            ] })
          ] }),
          u && /* @__PURE__ */ h("div", { className: "border-b border-stone-200 bg-white p-2 md:hidden dark:border-stone-800 dark:bg-stone-950", children: /* @__PURE__ */ h(
            Jc,
            {
              value: o,
              onChange: m,
              size: "sm"
            }
          ) }),
          /* @__PURE__ */ h("main", { className: "flex-1 overflow-auto p-4", children: a }),
          /* @__PURE__ */ h("footer", { className: "flex h-8 flex-shrink-0 items-center justify-center border-t border-stone-200 bg-white text-xs text-stone-500 dark:border-stone-800 dark:bg-stone-950", children: "Powered by Uyari — Social Listening Platform" })
        ]
      }
    );
  }
);
nce.displayName = "FullPageDashboard";
const ace = v.forwardRef(
  ({
    className: e,
    title: t,
    subtitle: r,
    logo: n,
    generatedAt: a = /* @__PURE__ */ new Date(),
    periodStart: o,
    periodEnd: i,
    companyName: s,
    preparedBy: c,
    sections: l = [],
    children: u,
    showPageNumbers: f = !0,
    showTableOfContents: d = !0,
    footerText: p,
    ...g
  }, m) => /* @__PURE__ */ C(
    "div",
    {
      ref: m,
      className: F(
        "min-h-screen bg-white text-stone-900",
        "print:bg-white print:text-black",
        e
      ),
      ...g,
      children: [
        /* @__PURE__ */ C("div", { className: "flex min-h-screen flex-col border-b-4 border-primary-500 p-12 print:break-after-page", children: [
          /* @__PURE__ */ h("div", { className: "mb-auto", children: n || /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ h("div", { className: "h-10 w-10 rounded-lg bg-primary-500" }),
            /* @__PURE__ */ h("span", { className: "text-2xl font-bold text-primary-700", children: "Uyari" })
          ] }) }),
          /* @__PURE__ */ C("div", { className: "mb-auto", children: [
            /* @__PURE__ */ h("h1", { className: "text-4xl font-bold tracking-tight sm:text-5xl", children: t }),
            r && /* @__PURE__ */ h("p", { className: "mt-4 text-xl text-stone-600", children: r }),
            (o || i) && /* @__PURE__ */ C("p", { className: "mt-6 text-lg text-stone-500", children: [
              "Report Period:",
              " ",
              o && Dt(o, "MMMM d, yyyy"),
              o && i && " — ",
              i && Dt(i, "MMMM d, yyyy")
            ] })
          ] }),
          /* @__PURE__ */ C("div", { className: "space-y-2 text-sm text-stone-500", children: [
            s && /* @__PURE__ */ C("p", { children: [
              "Prepared for: ",
              s
            ] }),
            c && /* @__PURE__ */ C("p", { children: [
              "Prepared by: ",
              c
            ] }),
            /* @__PURE__ */ C("p", { children: [
              "Generated: ",
              Dt(a, "MMMM d, yyyy 'at' h:mm a")
            ] })
          ] })
        ] }),
        d && l.length > 0 && /* @__PURE__ */ C("div", { className: "min-h-screen p-12 print:break-after-page", children: [
          /* @__PURE__ */ h("h2", { className: "mb-8 text-2xl font-bold", children: "Table of Contents" }),
          /* @__PURE__ */ h("nav", { className: "space-y-3", children: l.map((y, b) => /* @__PURE__ */ C(
            "div",
            {
              className: "flex items-center gap-4 border-b border-dotted border-stone-200 pb-2",
              children: [
                /* @__PURE__ */ h("span", { className: "text-lg font-semibold text-primary-600", children: String(b + 1).padStart(2, "0") }),
                /* @__PURE__ */ h("span", { className: "flex-1 text-lg", children: y.title }),
                /* @__PURE__ */ h("span", { className: "text-stone-400", children: b + 3 })
              ]
            },
            y.id
          )) })
        ] }),
        u || /* @__PURE__ */ h(Ve, { children: l.map((y, b) => /* @__PURE__ */ C(
          "div",
          {
            id: y.id,
            className: "min-h-screen p-12 print:break-after-page",
            children: [
              /* @__PURE__ */ h("div", { className: "mb-8 border-b-2 border-primary-500 pb-4", children: /* @__PURE__ */ C("div", { className: "flex items-baseline gap-4", children: [
                /* @__PURE__ */ h("span", { className: "text-4xl font-bold text-primary-200", children: String(b + 1).padStart(2, "0") }),
                /* @__PURE__ */ h("h2", { className: "text-2xl font-bold", children: y.title })
              ] }) }),
              /* @__PURE__ */ h("div", { className: "prose prose-stone max-w-none", children: y.content }),
              f && /* @__PURE__ */ h("div", { className: "mt-auto pt-8 text-center text-sm text-stone-400", children: /* @__PURE__ */ h("p", { children: b + 3 }) })
            ]
          },
          y.id
        )) }),
        /* @__PURE__ */ C("div", { className: "flex min-h-screen flex-col items-center justify-center bg-stone-50 p-12 text-center", children: [
          n || /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ h("div", { className: "h-12 w-12 rounded-lg bg-primary-500" }),
            /* @__PURE__ */ h("span", { className: "text-3xl font-bold text-primary-700", children: "Uyari" })
          ] }),
          /* @__PURE__ */ h("p", { className: "mt-6 text-lg text-stone-600", children: p || "Social Listening & Brand Intelligence Platform" }),
          /* @__PURE__ */ h("p", { className: "mt-2 text-stone-500", children: "uyari.io" }),
          /* @__PURE__ */ C("div", { className: "mt-12 text-sm text-stone-400", children: [
            /* @__PURE__ */ C("p", { children: [
              "© ",
              (/* @__PURE__ */ new Date()).getFullYear(),
              " Uyari. All rights reserved."
            ] }),
            /* @__PURE__ */ h("p", { className: "mt-1", children: "This report is confidential and intended solely for the recipient." })
          ] })
        ] })
      ]
    }
  )
);
ace.displayName = "ReportLayout";
const Xce = {
  // Primary - Cyan IA / CTA (base #7DF9FF at stop 300)
  // The bright cyan is the "punto de luz" associated with AI moments and CTAs.
  // Stops 500-700 provide solid CTA surfaces with text contrast.
  primary: {
    50: "#F0FEFF",
    100: "#DEFCFE",
    200: "#BAF8FC",
    300: "#7DF9FF",
    400: "#4FE3EC",
    500: "#2BC4CE",
    600: "#1E9CA5",
    700: "#1A777E",
    800: "#195B61",
    900: "#194B50",
    950: "#0B2C30",
    DEFAULT: "#2BC4CE"
  },
  // Secondary - Teal oscuro (base #43868A) - deeper brand presence
  secondary: {
    50: "#F1F8F9",
    100: "#DBEFF0",
    200: "#B9DFE2",
    300: "#89C7CC",
    400: "#58A8B0",
    500: "#43868A",
    600: "#356C70",
    700: "#2D575B",
    800: "#29494C",
    900: "#253E41",
    950: "#102225",
    DEFAULT: "#43868A"
  },
  // Tertiary - Teal medio (base #57AEB3) - info / data hierarchy
  tertiary: {
    50: "#F2F9F9",
    100: "#DEF0F1",
    200: "#C0E1E3",
    300: "#95CACE",
    400: "#6FB7BC",
    500: "#57AEB3",
    600: "#43898E",
    700: "#386F73",
    800: "#335A5D",
    900: "#2E4B4E",
    950: "#1A2E30",
    DEFAULT: "#57AEB3"
  },
  // Accent - Teal claro (base #6BD6DB at stop 300) - highlights
  accent: {
    50: "#ECFBFC",
    100: "#D2F6F7",
    200: "#ACECEF",
    300: "#6BD6DB",
    400: "#36BBC2",
    500: "#1C9FA7",
    600: "#197F87",
    700: "#1A656C",
    800: "#1B5258",
    900: "#1B454A",
    950: "#0B2C30",
    DEFAULT: "#6BD6DB"
  },
  // Surface - Dark anchor (base #41424C at stop 700) - dashboards / chrome
  surface: {
    50: "#F4F4F5",
    100: "#E4E4E7",
    200: "#C9CACF",
    300: "#ABACB3",
    400: "#7B7C85",
    500: "#5C5D67",
    600: "#4D4E58",
    700: "#41424C",
    800: "#36373F",
    900: "#2A2B32",
    950: "#1B1C21",
    DEFAULT: "#41424C"
  },
  // Neutral - Stone (warm grays for typography and borders)
  stone: {
    50: "#FAFAF9",
    100: "#F5F5F4",
    200: "#E7E5E4",
    300: "#D6D3D1",
    400: "#A8A29E",
    500: "#78716C",
    600: "#57534E",
    700: "#44403C",
    800: "#292524",
    900: "#1C1917",
    950: "#0C0A09"
  },
  // Sentiment (functional, palette-independent)
  sentiment: {
    positive: {
      DEFAULT: "#22C55E",
      light: "#86EFAC",
      dark: "#15803D"
    },
    neutral: {
      DEFAULT: "#78716C",
      light: "#A8A29E",
      dark: "#57534E"
    },
    negative: {
      DEFAULT: "#EF4444",
      light: "#FCA5A5",
      dark: "#B91C1C"
    }
  },
  // Crisis Levels
  crisis: {
    low: "#22C55E",
    medium: "#F59E0B",
    high: "#EF4444",
    critical: "#DC2626"
  },
  // Emotions (functional)
  emotion: {
    joy: "#22C55E",
    sadness: "#57AEB3",
    anger: "#EF4444",
    fear: "#8B5CF6",
    surprise: "#F59E0B",
    others: "#78716C"
  },
  // Platform Colors (external brand colors)
  platform: {
    twitter: "#1DA1F2",
    instagram: "#E4405F",
    facebook: "#1877F2",
    tiktok: "#000000",
    google_news: "#4285F4"
  },
  // Semantic (functional)
  semantic: {
    success: "#22C55E",
    warning: "#F59E0B",
    error: "#EF4444",
    info: "#57AEB3"
  },
  // Chart Colors - Data Hierarchy (teals + cyan highlight + anchor)
  chart: {
    1: "#57AEB3",
    // Tertiary - teal medio - serie principal
    2: "#6BD6DB",
    // Accent - teal claro - serie 2
    3: "#43868A",
    // Secondary - teal oscuro - serie 3
    4: "#7DF9FF",
    // Primary - cyan IA - highlight
    5: "#41424C",
    // Surface - anchor / baseline
    6: "#8B5CF6",
    // Violet (extra differentiation)
    7: "#EC4899"
    // Pink (extra differentiation)
  }
}, Zce = {
  fonts: {
    sans: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, monospace"
  },
  fontSizes: {
    xs: "0.75rem",
    // 12px
    sm: "0.875rem",
    // 14px
    base: "1rem",
    // 16px
    lg: "1.125rem",
    // 18px
    xl: "1.25rem",
    // 20px
    "2xl": "1.5rem",
    // 24px
    "3xl": "1.875rem",
    // 30px
    "4xl": "2.25rem",
    // 36px
    "5xl": "3rem",
    // 48px
    "6xl": "3.75rem",
    // 60px
    "7xl": "4.5rem"
    // 72px
  },
  fontWeights: {
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700"
  },
  lineHeights: {
    none: "1",
    tight: "1.1",
    snug: "1.25",
    normal: "1.5",
    relaxed: "1.625",
    loose: "1.75"
  },
  letterSpacing: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0em",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  // Text Styles
  styles: {
    display: {
      fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
      lineHeight: "1.1",
      fontWeight: "700",
      letterSpacing: "-0.02em"
    },
    h1: {
      fontSize: "clamp(2rem, 4vw, 3rem)",
      lineHeight: "1.2",
      fontWeight: "700",
      letterSpacing: "-0.01em"
    },
    h2: {
      fontSize: "clamp(1.5rem, 3vw, 2.25rem)",
      lineHeight: "1.25",
      fontWeight: "600",
      letterSpacing: "-0.01em"
    },
    h3: {
      fontSize: "clamp(1.25rem, 2.5vw, 1.875rem)",
      lineHeight: "1.3",
      fontWeight: "600",
      letterSpacing: "0"
    },
    h4: {
      fontSize: "clamp(1.125rem, 2vw, 1.5rem)",
      lineHeight: "1.35",
      fontWeight: "600",
      letterSpacing: "0"
    },
    h5: {
      fontSize: "1.25rem",
      lineHeight: "1.4",
      fontWeight: "500",
      letterSpacing: "0"
    },
    h6: {
      fontSize: "1.125rem",
      lineHeight: "1.4",
      fontWeight: "500",
      letterSpacing: "0"
    },
    bodyLarge: {
      fontSize: "1.125rem",
      lineHeight: "1.75",
      fontWeight: "400",
      letterSpacing: "0"
    },
    body: {
      fontSize: "1rem",
      lineHeight: "1.75",
      fontWeight: "400",
      letterSpacing: "0"
    },
    bodySmall: {
      fontSize: "0.875rem",
      lineHeight: "1.5",
      fontWeight: "400",
      letterSpacing: "0"
    },
    caption: {
      fontSize: "0.75rem",
      lineHeight: "1.5",
      fontWeight: "400",
      letterSpacing: "0.01em"
    },
    data: {
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: "2rem",
      lineHeight: "1.2",
      fontWeight: "600",
      letterSpacing: "-0.02em"
    },
    dataSmall: {
      fontFamily: "'JetBrains Mono', monospace",
      fontSize: "1.5rem",
      lineHeight: "1.2",
      fontWeight: "600",
      letterSpacing: "-0.01em"
    }
  }
}, Jce = {
  0: "0px",
  px: "1px",
  0.5: "0.125rem",
  // 2px
  1: "0.25rem",
  // 4px
  1.5: "0.375rem",
  // 6px
  2: "0.5rem",
  // 8px
  2.5: "0.625rem",
  // 10px
  3: "0.75rem",
  // 12px
  3.5: "0.875rem",
  // 14px
  4: "1rem",
  // 16px
  5: "1.25rem",
  // 20px
  6: "1.5rem",
  // 24px
  7: "1.75rem",
  // 28px
  8: "2rem",
  // 32px
  9: "2.25rem",
  // 36px
  10: "2.5rem",
  // 40px
  11: "2.75rem",
  // 44px
  12: "3rem",
  // 48px
  14: "3.5rem",
  // 56px
  16: "4rem",
  // 64px
  20: "5rem",
  // 80px
  24: "6rem",
  // 96px
  28: "7rem",
  // 112px
  32: "8rem",
  // 128px
  36: "9rem",
  // 144px
  40: "10rem",
  // 160px
  44: "11rem",
  // 176px
  48: "12rem",
  // 192px
  52: "13rem",
  // 208px
  56: "14rem",
  // 224px
  60: "15rem",
  // 240px
  64: "16rem",
  // 256px
  72: "18rem",
  // 288px
  80: "20rem",
  // 320px
  96: "24rem"
  // 384px
}, Qce = {
  none: "0px",
  sm: "0.25rem",
  // 4px
  DEFAULT: "0.375rem",
  // 6px
  md: "0.375rem",
  // 6px
  lg: "0.5rem",
  // 8px
  xl: "0.75rem",
  // 12px
  "2xl": "1rem",
  // 16px
  "3xl": "1.5rem",
  // 24px
  full: "9999px"
}, ele = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px"
}, tle = {
  none: "none",
  sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
  DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
  "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
  inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
  // Colored shadows for buttons and cards
  primarySm: "0 2px 4px -1px rgb(180 83 9 / 0.2)",
  primaryMd: "0 4px 6px -1px rgb(180 83 9 / 0.25)",
  primaryLg: "0 8px 15px -3px rgb(180 83 9 / 0.3)",
  secondarySm: "0 2px 4px -1px rgb(132 204 22 / 0.2)",
  secondaryMd: "0 4px 6px -1px rgb(132 204 22 / 0.25)",
  secondaryLg: "0 8px 15px -3px rgb(132 204 22 / 0.3)",
  accentSm: "0 2px 4px -1px rgb(245 158 11 / 0.2)",
  accentMd: "0 4px 6px -1px rgb(245 158 11 / 0.25)",
  accentLg: "0 8px 15px -3px rgb(245 158 11 / 0.3)",
  // Status shadows
  successSm: "0 2px 4px -1px rgb(34 197 94 / 0.2)",
  warningSm: "0 2px 4px -1px rgb(245 158 11 / 0.2)",
  errorSm: "0 2px 4px -1px rgb(239 68 68 / 0.2)",
  infoSm: "0 2px 4px -1px rgb(59 130 246 / 0.2)",
  // Card shadows
  card: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  cardHover: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  cardActive: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)"
};
export {
  oq as AIInsightPanel,
  H9 as Alert,
  cq as AlertConfiguration,
  U9 as AlertDescription,
  V9 as AlertTitle,
  ece as AuthLayout,
  ng as Avatar,
  cD as AvatarGroup,
  Qt as Badge,
  Ise as BrandHealthScore,
  Te as Button,
  P8 as Card,
  C8 as CardContent,
  E8 as CardDescription,
  k8 as CardFooter,
  A8 as CardHeader,
  _8 as CardTitle,
  WD as Checkbox,
  Cce as ConfirmDialog,
  Ov as CrisisAlert,
  Rse as CrisisGauge,
  Qse as DashboardLayout,
  eq as DashboardSummary,
  Mce as DataTable,
  Jc as DateRangePicker,
  $ce as DateRangeSlicer,
  Wce as DecompositionSankey,
  Yce as DecompositionTree,
  Y3 as Dialog,
  vce as DialogClose,
  H2 as DialogContent,
  G2 as DialogDescription,
  U2 as DialogFooter,
  V2 as DialogHeader,
  W2 as DialogOverlay,
  X3 as DialogPortal,
  K2 as DialogTitle,
  mce as DialogTrigger,
  wce as DropdownMenu,
  IF as DropdownMenuCheckboxItem,
  RF as DropdownMenuContent,
  Oce as DropdownMenuGroup,
  $F as DropdownMenuItem,
  jF as DropdownMenuLabel,
  Pce as DropdownMenuPortal,
  _ce as DropdownMenuRadioGroup,
  DF as DropdownMenuRadioItem,
  LF as DropdownMenuSeparator,
  BF as DropdownMenuShortcut,
  Ace as DropdownMenuSub,
  MF as DropdownMenuSubContent,
  TF as DropdownMenuSubTrigger,
  Sce as DropdownMenuTrigger,
  D_ as EmotionBadge,
  zse as EmotionRadar,
  Wk as EmptyState,
  z9 as FormField,
  nce as FullPageDashboard,
  L_ as HateBadge,
  hN as Header,
  pD as InlineLoading,
  jc as Input,
  qce as InteractionsBySourceChart,
  Kce as KpiDelta,
  Uce as KpiGauge,
  Gce as KpiRanking,
  jce as KpiScaleBar,
  X_ as Label,
  rce as LandingPageLayout,
  Fce as LikesVsSharesScatter,
  dD as LoadingOverlay,
  Bce as MeasureBySourceChart,
  dN as MentionCard,
  tq as MentionsList,
  Tse as MentionsTimeline,
  zce as MonthlySentimentChart,
  Dg as Pagination,
  Lse as PlatformDistribution,
  Vz as PlatformFilter,
  yce as Popover,
  bce as PopoverAnchor,
  G6 as PopoverContent,
  gce as PopoverTrigger,
  i9 as ProgressBar,
  ace as ReportLayout,
  j_ as SarcasmBadge,
  F9 as ScrollArea,
  aN as ScrollBar,
  Kz as SearchBar,
  B_ as SearchInput,
  s9 as SegmentedProgress,
  fce as Select,
  E3 as SelectContent,
  dce as SelectGroup,
  k3 as SelectItem,
  C3 as SelectLabel,
  N3 as SelectSeparator,
  _3 as SelectTrigger,
  pce as SelectValue,
  I_ as SentimentBadge,
  Nse as SentimentDonut,
  G9 as SentimentIndicator,
  Lce as SentimentSourceHeatmap,
  $8 as Separator,
  kce as Sheet,
  Tce as SheetClose,
  p9 as SheetContent,
  y9 as SheetDescription,
  m9 as SheetFooter,
  h9 as SheetHeader,
  Hk as SheetOverlay,
  f9 as SheetPortal,
  v9 as SheetTitle,
  Nce as SheetTrigger,
  pN as Sidebar,
  G_ as Skeleton,
  Vce as SourceDistributionChart,
  ag as Spinner,
  oN as StatCard,
  sj as Switch,
  wC as Table,
  OC as TableBody,
  D8 as TableCaption,
  Cc as TableCell,
  I8 as TableFooter,
  PC as TableHead,
  SC as TableHeader,
  fi as TableRow,
  Ece as Tabs,
  n9 as TabsContent,
  t9 as TabsList,
  r9 as TabsTrigger,
  K_ as Tag,
  uD as TagGroup,
  lj as Textarea,
  gD as ThemeSwitcher,
  Rce as TileSelect,
  S8 as Toaster,
  Hc as Tooltip,
  Mi as TooltipContent,
  oC as TooltipProvider,
  Vc as TooltipTrigger,
  Hce as TopPostsChart,
  Wse as WordCloud,
  q9 as alertVariants,
  U_ as avatarVariants,
  zI as badgeVariants,
  a$ as bandFor,
  Qce as borderRadius,
  ele as breakpoints,
  FI as buttonVariants,
  O8 as cardVariants,
  zD as checkboxVariants,
  F as cn,
  Xce as colors,
  Ib as crisisAlertVariants,
  Ci as formatNumber,
  LI as formatPercentage,
  $_ as getCrisisLabel,
  R_ as getCrisisLevel,
  BI as getInitials,
  cce as getSentimentLabel,
  vD as getTheme,
  HI as inputVariants,
  uce as isDarkMode,
  wD as labelVariants,
  A3 as selectTriggerVariants,
  mD as setTheme,
  tle as shadows,
  Jce as spacing,
  fD as spinnerVariants,
  $b as statCardVariants,
  oj as switchVariants,
  lD as tagVariants,
  cj as textareaVariants,
  hD as themes,
  xce as toast,
  lce as toggleDarkMode,
  Zce as typography,
  Ice as useBreakpoint,
  Dce as useMediaQuery
};
